import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _jsonb: { input: any; output: any; }
  _text: { input: any; output: any; }
  _varchar: { input: any; output: any; }
  bigint: { input: any; output: any; }
  cashout_statuses: { input: any; output: any; }
  construction_scope_status: { input: any; output: any; }
  date: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type UserQualificationData = {
  __typename: 'UserQualificationData';
  hasCosigner?: Maybe<Scalars['Boolean']['output']>;
  hasGoodCreditRoommate?: Maybe<Scalars['Boolean']['output']>;
  performedCreditCheck?: Maybe<Scalars['Boolean']['output']>;
  selfReportedCreditScoreHigh?: Maybe<Scalars['Int']['output']>;
  selfReportedCreditScoreLow?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  verifiedCredit?: Maybe<Scalars['Boolean']['output']>;
  voucherType?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "_jsonb". All fields are combined with logical 'AND'. */
export type _Jsonb_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_jsonb']['input']>;
  _gt?: InputMaybe<Scalars['_jsonb']['input']>;
  _gte?: InputMaybe<Scalars['_jsonb']['input']>;
  _in?: InputMaybe<Array<Scalars['_jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_jsonb']['input']>;
  _lte?: InputMaybe<Scalars['_jsonb']['input']>;
  _neq?: InputMaybe<Scalars['_jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['_jsonb']['input']>>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']['input']>;
  _gt?: InputMaybe<Scalars['_text']['input']>;
  _gte?: InputMaybe<Scalars['_text']['input']>;
  _in?: InputMaybe<Array<Scalars['_text']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_text']['input']>;
  _lte?: InputMaybe<Scalars['_text']['input']>;
  _neq?: InputMaybe<Scalars['_text']['input']>;
  _nin?: InputMaybe<Array<Scalars['_text']['input']>>;
};

/** Boolean expression to compare columns of type "_varchar". All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']['input']>;
  _gt?: InputMaybe<Scalars['_varchar']['input']>;
  _gte?: InputMaybe<Scalars['_varchar']['input']>;
  _in?: InputMaybe<Array<Scalars['_varchar']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_varchar']['input']>;
  _lte?: InputMaybe<Scalars['_varchar']['input']>;
  _neq?: InputMaybe<Scalars['_varchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']['input']>>;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename: 'addresses';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  display_line_1?: Maybe<Scalars['String']['output']>;
  display_line_2?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  homes: Array<Homes>;
  id: Scalars['uuid']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  /** An object relationship */
  municipality?: Maybe<Municipalities>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};


/** columns and relationships of "addresses" */
export type AddressesHomesArgs = {
  distinct_on?: InputMaybe<Array<Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Homes_Order_By>>;
  where?: InputMaybe<Homes_Bool_Exp>;
};

/** order by aggregate values of table "addresses" */
export type Addresses_Aggregate_Order_By = {
  avg?: InputMaybe<Addresses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Addresses_Max_Order_By>;
  min?: InputMaybe<Addresses_Min_Order_By>;
  stddev?: InputMaybe<Addresses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Addresses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Addresses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Addresses_Sum_Order_By>;
  var_pop?: InputMaybe<Addresses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Addresses_Var_Samp_Order_By>;
  variance?: InputMaybe<Addresses_Variance_Order_By>;
};

/** order by avg() on columns of table "addresses" */
export type Addresses_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  display_line_1?: InputMaybe<String_Comparison_Exp>;
  display_line_2?: InputMaybe<String_Comparison_Exp>;
  homes?: InputMaybe<Homes_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  long?: InputMaybe<Float_Comparison_Exp>;
  municipality?: InputMaybe<Municipalities_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "addresses" */
export type Addresses_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "addresses" */
export type Addresses_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  homes_aggregate?: InputMaybe<Homes_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Municipalities_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  DisplayLine_1 = 'display_line_1',
  /** column name */
  DisplayLine_2 = 'display_line_2',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Long = 'long',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Number = 'number',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  Zip = 'zip'
}

/** order by stddev() on columns of table "addresses" */
export type Addresses_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "addresses" */
export type Addresses_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "addresses" */
export type Addresses_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "addresses" */
export type Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  display_line_1?: InputMaybe<Scalars['String']['input']>;
  display_line_2?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "addresses" */
export type Addresses_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "addresses" */
export type Addresses_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "addresses" */
export type Addresses_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "addresses" */
export type Addresses_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** columns and relationships of "admin_capabilities" */
export type Admin_Capabilities = {
  __typename: 'admin_capabilities';
  /** An object relationship */
  admin: Admins;
  admin_id: Scalars['uuid']['output'];
  /** An object relationship */
  capability: Capabilities;
  capability_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "admin_capabilities" */
export type Admin_Capabilities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Admin_Capabilities_Max_Order_By>;
  min?: InputMaybe<Admin_Capabilities_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "admin_capabilities". All fields are combined with a logical 'AND'. */
export type Admin_Capabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Capabilities_Bool_Exp>>;
  _not?: InputMaybe<Admin_Capabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Capabilities_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  capability?: InputMaybe<Capabilities_Bool_Exp>;
  capability_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "admin_capabilities" */
export type Admin_Capabilities_Max_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  capability_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "admin_capabilities" */
export type Admin_Capabilities_Min_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  capability_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "admin_capabilities". */
export type Admin_Capabilities_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  admin_id?: InputMaybe<Order_By>;
  capability?: InputMaybe<Capabilities_Order_By>;
  capability_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "admin_capabilities" */
export enum Admin_Capabilities_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  CapabilityId = 'capability_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "admin_capabilities" */
export type Admin_Capabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Capabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Capabilities_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  capability_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "admin_searchable" */
export type Admin_Searchable = {
  __typename: 'admin_searchable';
  contact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "admin_searchable" */
export type Admin_Searchable_Aggregate = {
  __typename: 'admin_searchable_aggregate';
  aggregate?: Maybe<Admin_Searchable_Aggregate_Fields>;
  nodes: Array<Admin_Searchable>;
};

/** aggregate fields of "admin_searchable" */
export type Admin_Searchable_Aggregate_Fields = {
  __typename: 'admin_searchable_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Searchable_Max_Fields>;
  min?: Maybe<Admin_Searchable_Min_Fields>;
};


/** aggregate fields of "admin_searchable" */
export type Admin_Searchable_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Searchable_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin_searchable". All fields are combined with a logical 'AND'. */
export type Admin_Searchable_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Searchable_Bool_Exp>>;
  _not?: InputMaybe<Admin_Searchable_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Searchable_Bool_Exp>>;
  contact?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Admin_Searchable_Max_Fields = {
  __typename: 'admin_searchable_max_fields';
  contact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Admin_Searchable_Min_Fields = {
  __typename: 'admin_searchable_min_fields';
  contact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "admin_searchable". */
export type Admin_Searchable_Order_By = {
  contact?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "admin_searchable" */
export enum Admin_Searchable_Select_Column {
  /** column name */
  Contact = 'contact',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "admin_searchable" */
export type Admin_Searchable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Searchable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Searchable_Stream_Cursor_Value_Input = {
  contact?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "admins" */
export type Admins = {
  __typename: 'admins';
  /** An array relationship */
  admin_capabilities: Array<Admin_Capabilities>;
  /** An object relationship */
  admin_searchable?: Maybe<Admin_Searchable>;
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_name: Scalars['String']['output'];
  /** An array relationship */
  notes: Array<Notes>;
  permissions: Scalars['jsonb']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "admins" */
export type AdminsAdmin_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Capabilities_Order_By>>;
  where?: InputMaybe<Admin_Capabilities_Bool_Exp>;
};


/** columns and relationships of "admins" */
export type AdminsNotesArgs = {
  distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notes_Order_By>>;
  where?: InputMaybe<Notes_Bool_Exp>;
};


/** columns and relationships of "admins" */
export type AdminsPermissionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "admins". All fields are combined with a logical 'AND'. */
export type Admins_Bool_Exp = {
  _and?: InputMaybe<Array<Admins_Bool_Exp>>;
  _not?: InputMaybe<Admins_Bool_Exp>;
  _or?: InputMaybe<Array<Admins_Bool_Exp>>;
  admin_capabilities?: InputMaybe<Admin_Capabilities_Bool_Exp>;
  admin_searchable?: InputMaybe<Admin_Searchable_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<Notes_Bool_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "admins" */
export enum Admins_Constraint {
  /** unique or primary key constraint on columns "email" */
  AdminsEmailUnique = 'admins_email_unique',
  /** unique or primary key constraint on columns "id" */
  AdminsPkey = 'admins_pkey'
}

/** input type for inserting data into table "admins" */
export type Admins_Insert_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Notes_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "admins" */
export type Admins_Mutation_Response = {
  __typename: 'admins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admins>;
};

/** input type for inserting object relation for remote table "admins" */
export type Admins_Obj_Rel_Insert_Input = {
  data: Admins_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Admins_On_Conflict>;
};

/** on_conflict condition type for table "admins" */
export type Admins_On_Conflict = {
  constraint: Admins_Constraint;
  update_columns?: Array<Admins_Update_Column>;
  where?: InputMaybe<Admins_Bool_Exp>;
};

/** Ordering options when selecting data from "admins". */
export type Admins_Order_By = {
  admin_capabilities_aggregate?: InputMaybe<Admin_Capabilities_Aggregate_Order_By>;
  admin_searchable?: InputMaybe<Admin_Searchable_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Notes_Aggregate_Order_By>;
  permissions?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "admins" */
export enum Admins_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "admins" */
export type Admins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admins_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "admins" (current role has no relevant permissions) */
export enum Admins_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners = {
  __typename: 'agent_lead_group_owners';
  /** An object relationship */
  admin: Admins;
  agent_admin_id: Scalars['uuid']['output'];
  agent_type: Agent_Lead_Group_Owners_Agent_Type_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead_group: Lead_Groups;
  lead_group_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "agent_lead_group_owners_agent_type_enum" */
export type Agent_Lead_Group_Owners_Agent_Type_Enum = {
  __typename: 'agent_lead_group_owners_agent_type_enum';
  agent_type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "agent_lead_group_owners_agent_type_enum". All fields are combined with a logical 'AND'. */
export type Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp>>;
  agent_type?: InputMaybe<String_Comparison_Exp>;
};

export enum Agent_Lead_Group_Owners_Agent_Type_Enum_Enum {
  LeasingAgent = 'leasing_agent',
  LeasingCoordinator = 'leasing_coordinator',
  LeasingRepresentative = 'leasing_representative'
}

/** Boolean expression to compare columns of type "agent_lead_group_owners_agent_type_enum_enum". All fields are combined with logical 'AND'. */
export type Agent_Lead_Group_Owners_Agent_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "agent_lead_group_owners_agent_type_enum". */
export type Agent_Lead_Group_Owners_Agent_Type_Enum_Order_By = {
  agent_type?: InputMaybe<Order_By>;
};

/** select columns of table "agent_lead_group_owners_agent_type_enum" */
export enum Agent_Lead_Group_Owners_Agent_Type_Enum_Select_Column {
  /** column name */
  AgentType = 'agent_type'
}

/** Streaming cursor of the table "agent_lead_group_owners_agent_type_enum" */
export type Agent_Lead_Group_Owners_Agent_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Lead_Group_Owners_Agent_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Lead_Group_Owners_Agent_Type_Enum_Stream_Cursor_Value_Input = {
  agent_type?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Lead_Group_Owners_Max_Order_By>;
  min?: InputMaybe<Agent_Lead_Group_Owners_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "agent_lead_group_owners". All fields are combined with a logical 'AND'. */
export type Agent_Lead_Group_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Lead_Group_Owners_Bool_Exp>>;
  _not?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Lead_Group_Owners_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  agent_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  agent_type?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_group?: InputMaybe<Lead_Groups_Bool_Exp>;
  lead_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_lead_group_owners" */
export enum Agent_Lead_Group_Owners_Constraint {
  /** unique or primary key constraint on columns "agent_type", "agent_admin_id", "lead_group_id" */
  ActiveAgentLeadGroupOwner = 'active_agent_lead_group_owner',
  /** unique or primary key constraint on columns "id" */
  AgentLeadGroupOwnersPkey = 'agent_lead_group_owners_pkey'
}

/** input type for inserting data into table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  agent_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_type?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>;
  lead_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Max_Order_By = {
  agent_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Min_Order_By = {
  agent_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Mutation_Response = {
  __typename: 'agent_lead_group_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Lead_Group_Owners>;
};

/** on_conflict condition type for table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_On_Conflict = {
  constraint: Agent_Lead_Group_Owners_Constraint;
  update_columns?: Array<Agent_Lead_Group_Owners_Update_Column>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_lead_group_owners". */
export type Agent_Lead_Group_Owners_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  agent_admin_id?: InputMaybe<Order_By>;
  agent_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group?: InputMaybe<Lead_Groups_Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_lead_group_owners */
export type Agent_Lead_Group_Owners_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agent_lead_group_owners" */
export enum Agent_Lead_Group_Owners_Select_Column {
  /** column name */
  AgentAdminId = 'agent_admin_id',
  /** column name */
  AgentType = 'agent_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadGroupId = 'lead_group_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Set_Input = {
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "agent_lead_group_owners" */
export type Agent_Lead_Group_Owners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Lead_Group_Owners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Lead_Group_Owners_Stream_Cursor_Value_Input = {
  agent_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_type?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_group_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "agent_lead_group_owners" */
export enum Agent_Lead_Group_Owners_Update_Column {
  /** column name */
  DeactivatedAt = 'deactivated_at'
}

export type Agent_Lead_Group_Owners_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Lead_Group_Owners_Set_Input>;
  where: Agent_Lead_Group_Owners_Bool_Exp;
};

/** columns and relationships of "agent_portfolio_home_owners" */
export type Agent_Portfolio_Home_Owners = {
  __typename: 'agent_portfolio_home_owners';
  /** An object relationship */
  admin: Admins;
  agent_admin_id: Scalars['uuid']['output'];
  agent_type: Agent_Lead_Group_Owners_Agent_Type_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "agent_portfolio_home_owners". All fields are combined with a logical 'AND'. */
export type Agent_Portfolio_Home_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Portfolio_Home_Owners_Bool_Exp>>;
  _not?: InputMaybe<Agent_Portfolio_Home_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Portfolio_Home_Owners_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  agent_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  agent_type?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "agent_portfolio_home_owners". */
export type Agent_Portfolio_Home_Owners_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  agent_admin_id?: InputMaybe<Order_By>;
  agent_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "agent_portfolio_home_owners" */
export enum Agent_Portfolio_Home_Owners_Select_Column {
  /** column name */
  AgentAdminId = 'agent_admin_id',
  /** column name */
  AgentType = 'agent_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "agent_portfolio_home_owners" */
export type Agent_Portfolio_Home_Owners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Portfolio_Home_Owners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Portfolio_Home_Owners_Stream_Cursor_Value_Input = {
  agent_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_type?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "agent_user_owners" */
export type Agent_User_Owners = {
  __typename: 'agent_user_owners';
  /** An object relationship */
  admin?: Maybe<Admins>;
  agent_admin_id: Scalars['uuid']['output'];
  agent_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "agent_user_owners". All fields are combined with a logical 'AND'. */
export type Agent_User_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_User_Owners_Bool_Exp>>;
  _not?: InputMaybe<Agent_User_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_User_Owners_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  agent_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  agent_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "agent_user_owners". */
export type Agent_User_Owners_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  agent_admin_id?: InputMaybe<Order_By>;
  agent_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "agent_user_owners" */
export enum Agent_User_Owners_Select_Column {
  /** column name */
  AgentAdminId = 'agent_admin_id',
  /** column name */
  AgentType = 'agent_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "agent_user_owners" */
export type Agent_User_Owners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_User_Owners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_User_Owners_Stream_Cursor_Value_Input = {
  agent_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "agents" */
export type Agents = {
  __typename: 'agents';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  home_address_city?: Maybe<Scalars['String']['output']>;
  home_address_coordinates?: Maybe<Scalars['geography']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street?: Maybe<Scalars['String']['output']>;
  home_address_zip?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
  seller_agent_id?: Maybe<Scalars['uuid']['output']>;
  showingtime_password?: Maybe<Scalars['String']['output']>;
  showingtime_username?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "agents". All fields are combined with a logical 'AND'. */
export type Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Agents_Bool_Exp>>;
  _not?: InputMaybe<Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Agents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  home_address_city?: InputMaybe<String_Comparison_Exp>;
  home_address_coordinates?: InputMaybe<Geography_Comparison_Exp>;
  home_address_state?: InputMaybe<String_Comparison_Exp>;
  home_address_street?: InputMaybe<String_Comparison_Exp>;
  home_address_zip?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Float_Comparison_Exp>;
  seller_agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  showingtime_password?: InputMaybe<String_Comparison_Exp>;
  showingtime_username?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "agents". */
export type Agents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  home_address_city?: InputMaybe<Order_By>;
  home_address_coordinates?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street?: InputMaybe<Order_By>;
  home_address_zip?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  seller_agent_id?: InputMaybe<Order_By>;
  showingtime_password?: InputMaybe<Order_By>;
  showingtime_username?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "agents" */
export enum Agents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HomeAddressCity = 'home_address_city',
  /** column name */
  HomeAddressCoordinates = 'home_address_coordinates',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreet = 'home_address_street',
  /** column name */
  HomeAddressZip = 'home_address_zip',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Priority = 'priority',
  /** column name */
  SellerAgentId = 'seller_agent_id',
  /** column name */
  ShowingtimePassword = 'showingtime_password',
  /** column name */
  ShowingtimeUsername = 'showingtime_username',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "agents" */
export type Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  home_address_city?: InputMaybe<Scalars['String']['input']>;
  home_address_coordinates?: InputMaybe<Scalars['geography']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street?: InputMaybe<Scalars['String']['input']>;
  home_address_zip?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  seller_agent_id?: InputMaybe<Scalars['uuid']['input']>;
  showingtime_password?: InputMaybe<Scalars['String']['input']>;
  showingtime_username?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "agreement_signers" */
export type Agreement_Signers = {
  __typename: 'agreement_signers';
  agreement_id: Scalars['uuid']['output'];
  external_id: Scalars['String']['output'];
  external_source: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  resource_id: Scalars['uuid']['output'];
  resource_type: Scalars['String']['output'];
  role: Scalars['String']['output'];
  signed_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "agreement_signers" */
export type Agreement_Signers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Signers_Max_Order_By>;
  min?: InputMaybe<Agreement_Signers_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_signers". All fields are combined with a logical 'AND'. */
export type Agreement_Signers_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Signers_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Signers_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Signers_Bool_Exp>>;
  agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  signed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "agreement_signers" */
export type Agreement_Signers_Max_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "agreement_signers" */
export type Agreement_Signers_Min_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "agreement_signers". */
export type Agreement_Signers_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "agreement_signers" */
export enum Agreement_Signers_Select_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Role = 'role',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status'
}

/** columns and relationships of "agreement_template_types_enum" */
export type Agreement_Template_Types_Enum = {
  __typename: 'agreement_template_types_enum';
  type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "agreement_template_types_enum". All fields are combined with a logical 'AND'. */
export type Agreement_Template_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Template_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Template_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Template_Types_Enum_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export enum Agreement_Template_Types_Enum_Enum {
  Lease = 'lease',
  PurchaseOptionAgreementAmendment = 'purchase_option_agreement_amendment',
  Renewal = 'renewal',
  WaterServiceTransfer = 'water_service_transfer'
}

/** Boolean expression to compare columns of type "agreement_template_types_enum_enum". All fields are combined with logical 'AND'. */
export type Agreement_Template_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Agreement_Template_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Agreement_Template_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Agreement_Template_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Agreement_Template_Types_Enum_Enum>>;
};

/** Ordering options when selecting data from "agreement_template_types_enum". */
export type Agreement_Template_Types_Enum_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** select columns of table "agreement_template_types_enum" */
export enum Agreement_Template_Types_Enum_Select_Column {
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "agreement_template_types_enum" */
export type Agreement_Template_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Template_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Template_Types_Enum_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "agreement_templates" */
export type Agreement_Templates = {
  __typename: 'agreement_templates';
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  external_source: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  type: Agreement_Template_Types_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "agreement_templates". All fields are combined with a logical 'AND'. */
export type Agreement_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Templates_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Templates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Agreement_Template_Types_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "agreement_templates". */
export type Agreement_Templates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "agreement_templates" */
export enum Agreement_Templates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "agreement_templates" */
export type Agreement_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Templates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Agreement_Template_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "agreements" */
export type Agreements = {
  __typename: 'agreements';
  /** An array relationship */
  agreement_signers: Array<Agreement_Signers>;
  agreement_template_id?: Maybe<Scalars['uuid']['output']>;
  buildium_lease_id?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  documents: Array<Documents>;
  external_id: Scalars['String']['output'];
  external_source: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  /** An object relationship */
  rental?: Maybe<Rentals>;
  /** An object relationship */
  rental_application?: Maybe<Rental_Applications>;
  resource_id: Scalars['uuid']['output'];
  resource_type: Scalars['String']['output'];
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "agreements" */
export type AgreementsAgreement_SignersArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Signers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Signers_Order_By>>;
  where?: InputMaybe<Agreement_Signers_Bool_Exp>;
};


/** columns and relationships of "agreements" */
export type AgreementsDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


/** columns and relationships of "agreements" */
export type AgreementsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "agreements" */
export type Agreements_Aggregate_Order_By = {
  avg?: InputMaybe<Agreements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreements_Max_Order_By>;
  min?: InputMaybe<Agreements_Min_Order_By>;
  stddev?: InputMaybe<Agreements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreements_Sum_Order_By>;
  var_pop?: InputMaybe<Agreements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreements_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreements_Variance_Order_By>;
};

/** order by avg() on columns of table "agreements" */
export type Agreements_Avg_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreements". All fields are combined with a logical 'AND'. */
export type Agreements_Bool_Exp = {
  _and?: InputMaybe<Array<Agreements_Bool_Exp>>;
  _not?: InputMaybe<Agreements_Bool_Exp>;
  _or?: InputMaybe<Array<Agreements_Bool_Exp>>;
  agreement_signers?: InputMaybe<Agreement_Signers_Bool_Exp>;
  agreement_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  buildium_lease_id?: InputMaybe<Int_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  documents?: InputMaybe<Documents_Bool_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "agreements" */
export type Agreements_Max_Order_By = {
  agreement_template_id?: InputMaybe<Order_By>;
  buildium_lease_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "agreements" */
export type Agreements_Min_Order_By = {
  agreement_template_id?: InputMaybe<Order_By>;
  buildium_lease_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreements" */
export type Agreements_Mutation_Response = {
  __typename: 'agreements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreements>;
};

/** Ordering options when selecting data from "agreements". */
export type Agreements_Order_By = {
  agreement_signers_aggregate?: InputMaybe<Agreement_Signers_Aggregate_Order_By>;
  agreement_template_id?: InputMaybe<Order_By>;
  buildium_lease_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreements */
export type Agreements_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreements" */
export enum Agreements_Select_Column {
  /** column name */
  AgreementTemplateId = 'agreement_template_id',
  /** column name */
  BuildiumLeaseId = 'buildium_lease_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agreements" */
export type Agreements_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "agreements" */
export type Agreements_Stddev_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "agreements" */
export type Agreements_Stddev_Pop_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "agreements" */
export type Agreements_Stddev_Samp_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreements" */
export type Agreements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreements_Stream_Cursor_Value_Input = {
  agreement_template_id?: InputMaybe<Scalars['uuid']['input']>;
  buildium_lease_id?: InputMaybe<Scalars['Int']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "agreements" */
export type Agreements_Sum_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

export type Agreements_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreements_Set_Input>;
  where: Agreements_Bool_Exp;
};

/** order by var_pop() on columns of table "agreements" */
export type Agreements_Var_Pop_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "agreements" */
export type Agreements_Var_Samp_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "agreements" */
export type Agreements_Variance_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_employment_verification_statuses_enum" */
export type Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum = {
  __typename: 'applicant_income_underwrites_user_income_employment_verification_statuses_enum';
  employment_verification_status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_employment_verification_statuses_enum". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp>>;
  employment_verification_status?: InputMaybe<String_Comparison_Exp>;
};

export enum Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum {
  Failed = 'failed',
  Pending = 'pending',
  Verified = 'verified'
}

/** Boolean expression to compare columns of type "applicant_income_underwrites_user_income_employment_verification_statuses_enum_enum". All fields are combined with logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum>;
  _in?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum>;
  _nin?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum>>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_employment_verification_statuses_enum". */
export type Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Order_By = {
  employment_verification_status?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_employment_verification_statuses_enum" */
export enum Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Select_Column {
  /** column name */
  EmploymentVerificationStatus = 'employment_verification_status'
}

/** Streaming cursor of the table "applicant_income_underwrites_user_income_employment_verification_statuses_enum" */
export type Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Stream_Cursor_Value_Input = {
  employment_verification_status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents = {
  __typename: 'applicant_income_underwrites_user_income_source_documents';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  document_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_income_source_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Max_Order_By>;
  min?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Min_Order_By>;
  stddev?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Variance_Order_By>;
};

/** order by avg() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_source_documents". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_income_source_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_income_source_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_income_source_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_source_documents". */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_income_source_id?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_source_documents" */
export enum Applicant_Income_Underwrites_User_Income_Source_Documents_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserIncomeSourceId = 'user_income_source_id'
}

/** order by stddev() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "applicant_income_underwrites_user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Source_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_source_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "applicant_income_underwrites.user_income_source_documents" */
export type Applicant_Income_Underwrites_User_Income_Source_Documents_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_source_pay_frequencies_enum" */
export type Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum = {
  __typename: 'applicant_income_underwrites_user_income_source_pay_frequencies_enum';
  frequency: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_source_pay_frequencies_enum". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp>>;
  frequency?: InputMaybe<String_Comparison_Exp>;
};

export enum Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum {
  Annually = 'annually',
  Bimonthly = 'bimonthly',
  Biweekly = 'biweekly',
  Monthly = 'monthly',
  Other = 'other',
  Semimonthly = 'semimonthly',
  Weekly = 'weekly'
}

/** Boolean expression to compare columns of type "applicant_income_underwrites_user_income_source_pay_frequencies_enum_enum". All fields are combined with logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>;
  _in?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>;
  _nin?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_source_pay_frequencies_enum". */
export type Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Order_By = {
  frequency?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_source_pay_frequencies_enum" */
export enum Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Select_Column {
  /** column name */
  Frequency = 'frequency'
}

/** Streaming cursor of the table "applicant_income_underwrites_user_income_source_pay_frequencies_enum" */
export type Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Stream_Cursor_Value_Input = {
  frequency?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_source_statuses_enum" */
export type Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum = {
  __typename: 'applicant_income_underwrites_user_income_source_statuses_enum';
  status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_source_statuses_enum". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_source_statuses_enum". */
export type Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_source_statuses_enum" */
export enum Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "applicant_income_underwrites_user_income_source_statuses_enum" */
export type Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_source_types_enum" */
export type Applicant_Income_Underwrites_User_Income_Source_Types_Enum = {
  __typename: 'applicant_income_underwrites_user_income_source_types_enum';
  income_source_type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_source_types_enum". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp>>;
  income_source_type?: InputMaybe<String_Comparison_Exp>;
};

export enum Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum {
  Benefits = 'benefits',
  Employed = 'employed',
  SelfEmployed = 'self_employed'
}

/** Boolean expression to compare columns of type "applicant_income_underwrites_user_income_source_types_enum_enum". All fields are combined with logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum>>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_source_types_enum". */
export type Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Order_By = {
  income_source_type?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_source_types_enum" */
export enum Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Select_Column {
  /** column name */
  IncomeSourceType = 'income_source_type'
}

/** Streaming cursor of the table "applicant_income_underwrites_user_income_source_types_enum" */
export type Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Stream_Cursor_Value_Input = {
  income_source_type?: InputMaybe<Scalars['String']['input']>;
};

export enum Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum {
  Hourly = 'hourly',
  Salary = 'salary'
}

/** Boolean expression to compare columns of type "applicant_income_underwrites_user_income_source_wage_types_enum_enum". All fields are combined with logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum>>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources = {
  __typename: 'applicant_income_underwrites_user_income_sources';
  /** An object relationship */
  admin?: Maybe<Admins>;
  annual_income_overridden_at?: Maybe<Scalars['timestamptz']['output']>;
  annual_income_overridden_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  benefits?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  deleted_by_user_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  employed?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  id: Scalars['uuid']['output'];
  invalidated_at?: Maybe<Scalars['timestamptz']['output']>;
  invalidated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  self_employed?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed>;
  source_annual_income: Scalars['numeric']['output'];
  status: Scalars['String']['output'];
  type: Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  user_edit_instructions?: Maybe<Scalars['String']['output']>;
  user_edit_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  user_edit_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  user_income_id: Scalars['uuid']['output'];
  /** An array relationship */
  user_income_source_documents: Array<Applicant_Income_Underwrites_User_Income_Source_Documents>;
};


/** columns and relationships of "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_SourcesUser_Income_Source_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>;
};

/** order by aggregate values of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Aggregate_Order_By = {
  avg?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Max_Order_By>;
  min?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Min_Order_By>;
  stddev?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Sum_Order_By>;
  var_pop?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Var_Samp_Order_By>;
  variance?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Variance_Order_By>;
};

/** order by avg() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Avg_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_sources_benefits" */
export type Applicant_Income_Underwrites_User_Income_Sources_Benefits = {
  __typename: 'applicant_income_underwrites_user_income_sources_benefits';
  benefits_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  pay_frequency: Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  user_income_source_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_sources_benefits". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>>;
  benefits_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pay_frequency?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_income_source_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_sources_benefits". */
export type Applicant_Income_Underwrites_User_Income_Sources_Benefits_Order_By = {
  benefits_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pay_frequency?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_income_source_id?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_sources_benefits" */
export enum Applicant_Income_Underwrites_User_Income_Sources_Benefits_Select_Column {
  /** column name */
  BenefitsType = 'benefits_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PayFrequency = 'pay_frequency',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserIncomeSourceId = 'user_income_source_id'
}

/** Streaming cursor of the table "applicant_income_underwrites_user_income_sources_benefits" */
export type Applicant_Income_Underwrites_User_Income_Sources_Benefits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Sources_Benefits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Sources_Benefits_Stream_Cursor_Value_Input = {
  benefits_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pay_frequency?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_source_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_sources". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  annual_income_overridden_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  annual_income_overridden_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  benefits?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_by_user_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employed?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalidated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invalidated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  self_employed?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>;
  source_annual_income?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_edit_instructions?: InputMaybe<String_Comparison_Exp>;
  user_edit_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_edit_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_income_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_income_source_documents?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>;
};

/** columns and relationships of "applicant_income_underwrites.user_income_sources_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed = {
  __typename: 'applicant_income_underwrites_user_income_sources_employed';
  company_name: Scalars['String']['output'];
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  contact_title?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  employment_verification_status: Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum;
  employment_verified_at?: Maybe<Scalars['timestamptz']['output']>;
  employment_verified_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_newly_employed: Scalars['Boolean']['output'];
  offered_rate?: Maybe<Scalars['numeric']['output']>;
  pay_frequency: Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  user_income_source_id: Scalars['uuid']['output'];
  wage_type: Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum;
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_sources_employed". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_title?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employment_verification_status?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum_Comparison_Exp>;
  employment_verified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employment_verified_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_newly_employed?: InputMaybe<Boolean_Comparison_Exp>;
  offered_rate?: InputMaybe<Numeric_Comparison_Exp>;
  pay_frequency?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_income_source_id?: InputMaybe<Uuid_Comparison_Exp>;
  wage_type?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "applicant_income_underwrites.user_income_sources_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Inc_Input = {
  offered_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** response of any mutation on the table "applicant_income_underwrites.user_income_sources_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Mutation_Response = {
  __typename: 'applicant_income_underwrites_user_income_sources_employed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_sources_employed". */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Order_By = {
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employment_verification_status?: InputMaybe<Order_By>;
  employment_verified_at?: InputMaybe<Order_By>;
  employment_verified_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_newly_employed?: InputMaybe<Order_By>;
  offered_rate?: InputMaybe<Order_By>;
  pay_frequency?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_income_source_id?: InputMaybe<Order_By>;
  wage_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: applicant_income_underwrites.user_income_sources_employed */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "applicant_income_underwrites.user_income_sources_employed" */
export enum Applicant_Income_Underwrites_User_Income_Sources_Employed_Select_Column {
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactTitle = 'contact_title',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmploymentVerificationStatus = 'employment_verification_status',
  /** column name */
  EmploymentVerifiedAt = 'employment_verified_at',
  /** column name */
  EmploymentVerifiedByAdminId = 'employment_verified_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsNewlyEmployed = 'is_newly_employed',
  /** column name */
  OfferedRate = 'offered_rate',
  /** column name */
  PayFrequency = 'pay_frequency',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserIncomeSourceId = 'user_income_source_id',
  /** column name */
  WageType = 'wage_type'
}

/** input type for updating data in table "applicant_income_underwrites.user_income_sources_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Set_Input = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  contact_title?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employment_verification_status?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum>;
  employment_verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employment_verified_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_newly_employed?: InputMaybe<Scalars['Boolean']['input']>;
  offered_rate?: InputMaybe<Scalars['numeric']['input']>;
  pay_frequency?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_source_id?: InputMaybe<Scalars['uuid']['input']>;
  wage_type?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum>;
};

/** Streaming cursor of the table "applicant_income_underwrites_user_income_sources_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Sources_Employed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Stream_Cursor_Value_Input = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  contact_title?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employment_verification_status?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum>;
  employment_verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employment_verified_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_newly_employed?: InputMaybe<Scalars['Boolean']['input']>;
  offered_rate?: InputMaybe<Scalars['numeric']['input']>;
  pay_frequency?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_source_id?: InputMaybe<Scalars['uuid']['input']>;
  wage_type?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Wage_Types_Enum_Enum>;
};

export type Applicant_Income_Underwrites_User_Income_Sources_Employed_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Set_Input>;
  where: Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp;
};

/** input type for incrementing numeric columns in table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Inc_Input = {
  source_annual_income?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Max_Order_By = {
  annual_income_overridden_at?: InputMaybe<Order_By>;
  annual_income_overridden_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deleted_by_user_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidated_at?: InputMaybe<Order_By>;
  invalidated_by_admin_id?: InputMaybe<Order_By>;
  source_annual_income?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_edit_instructions?: InputMaybe<Order_By>;
  user_edit_requested_at?: InputMaybe<Order_By>;
  user_edit_submitted_at?: InputMaybe<Order_By>;
  user_income_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Min_Order_By = {
  annual_income_overridden_at?: InputMaybe<Order_By>;
  annual_income_overridden_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deleted_by_user_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidated_at?: InputMaybe<Order_By>;
  invalidated_by_admin_id?: InputMaybe<Order_By>;
  source_annual_income?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_edit_instructions?: InputMaybe<Order_By>;
  user_edit_requested_at?: InputMaybe<Order_By>;
  user_edit_submitted_at?: InputMaybe<Order_By>;
  user_income_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Mutation_Response = {
  __typename: 'applicant_income_underwrites_user_income_sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Applicant_Income_Underwrites_User_Income_Sources>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_sources". */
export type Applicant_Income_Underwrites_User_Income_Sources_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  annual_income_overridden_at?: InputMaybe<Order_By>;
  annual_income_overridden_by_admin_id?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deleted_by_user_at?: InputMaybe<Order_By>;
  employed?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Order_By>;
  id?: InputMaybe<Order_By>;
  invalidated_at?: InputMaybe<Order_By>;
  invalidated_by_admin_id?: InputMaybe<Order_By>;
  self_employed?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Order_By>;
  source_annual_income?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_edit_instructions?: InputMaybe<Order_By>;
  user_edit_requested_at?: InputMaybe<Order_By>;
  user_edit_submitted_at?: InputMaybe<Order_By>;
  user_income_id?: InputMaybe<Order_By>;
  user_income_source_documents_aggregate?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Aggregate_Order_By>;
};

/** primary key columns input for table: applicant_income_underwrites.user_income_sources */
export type Applicant_Income_Underwrites_User_Income_Sources_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "applicant_income_underwrites.user_income_sources" */
export enum Applicant_Income_Underwrites_User_Income_Sources_Select_Column {
  /** column name */
  AnnualIncomeOverriddenAt = 'annual_income_overridden_at',
  /** column name */
  AnnualIncomeOverriddenByAdminId = 'annual_income_overridden_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeletedByUserAt = 'deleted_by_user_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidatedAt = 'invalidated_at',
  /** column name */
  InvalidatedByAdminId = 'invalidated_by_admin_id',
  /** column name */
  SourceAnnualIncome = 'source_annual_income',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEditInstructions = 'user_edit_instructions',
  /** column name */
  UserEditRequestedAt = 'user_edit_requested_at',
  /** column name */
  UserEditSubmittedAt = 'user_edit_submitted_at',
  /** column name */
  UserIncomeId = 'user_income_id'
}

/** columns and relationships of "applicant_income_underwrites.user_income_sources_self_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Self_Employed = {
  __typename: 'applicant_income_underwrites_user_income_sources_self_employed';
  business_name: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_income_source_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_income_sources_self_employed". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>>;
  business_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_income_source_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_income_sources_self_employed". */
export type Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Order_By = {
  business_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_income_source_id?: InputMaybe<Order_By>;
};

/** select columns of table "applicant_income_underwrites.user_income_sources_self_employed" */
export enum Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Select_Column {
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserIncomeSourceId = 'user_income_source_id'
}

/** Streaming cursor of the table "applicant_income_underwrites_user_income_sources_self_employed" */
export type Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Stream_Cursor_Value_Input = {
  business_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_source_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** input type for updating data in table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Set_Input = {
  annual_income_overridden_at?: InputMaybe<Scalars['timestamptz']['input']>;
  annual_income_overridden_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_by_user_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalidated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalidated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  source_annual_income?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_edit_instructions?: InputMaybe<Scalars['String']['input']>;
  user_edit_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_edit_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Stddev_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Stddev_Pop_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Stddev_Samp_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "applicant_income_underwrites_user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Income_Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Income_Sources_Stream_Cursor_Value_Input = {
  annual_income_overridden_at?: InputMaybe<Scalars['timestamptz']['input']>;
  annual_income_overridden_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_by_user_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalidated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalidated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  source_annual_income?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_edit_instructions?: InputMaybe<Scalars['String']['input']>;
  user_edit_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_edit_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_income_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Sum_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

export type Applicant_Income_Underwrites_User_Income_Sources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Set_Input>;
  where: Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp;
};

/** order by var_pop() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Var_Pop_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Var_Samp_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "applicant_income_underwrites.user_income_sources" */
export type Applicant_Income_Underwrites_User_Income_Sources_Variance_Order_By = {
  source_annual_income?: InputMaybe<Order_By>;
};

/** columns and relationships of "applicant_income_underwrites.user_incomes" */
export type Applicant_Income_Underwrites_User_Incomes = {
  __typename: 'applicant_income_underwrites_user_incomes';
  additional_income_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  additional_income_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  admin?: Maybe<Admins>;
  annual_income: Scalars['numeric']['output'];
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  approved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  initially_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  is_non_income_applicant: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An array relationship */
  user_income_sources: Array<Applicant_Income_Underwrites_User_Income_Sources>;
};


/** columns and relationships of "applicant_income_underwrites.user_incomes" */
export type Applicant_Income_Underwrites_User_IncomesUser_Income_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "applicant_income_underwrites.user_incomes". All fields are combined with a logical 'AND'. */
export type Applicant_Income_Underwrites_User_Incomes_Bool_Exp = {
  _and?: InputMaybe<Array<Applicant_Income_Underwrites_User_Incomes_Bool_Exp>>;
  _not?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Bool_Exp>;
  _or?: InputMaybe<Array<Applicant_Income_Underwrites_User_Incomes_Bool_Exp>>;
  additional_income_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  additional_income_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  annual_income?: InputMaybe<Numeric_Comparison_Exp>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approved_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initially_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_non_income_applicant?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_income_sources?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "applicant_income_underwrites.user_incomes" */
export type Applicant_Income_Underwrites_User_Incomes_Inc_Input = {
  annual_income?: InputMaybe<Scalars['numeric']['input']>;
};

/** response of any mutation on the table "applicant_income_underwrites.user_incomes" */
export type Applicant_Income_Underwrites_User_Incomes_Mutation_Response = {
  __typename: 'applicant_income_underwrites_user_incomes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Applicant_Income_Underwrites_User_Incomes>;
};

/** Ordering options when selecting data from "applicant_income_underwrites.user_incomes". */
export type Applicant_Income_Underwrites_User_Incomes_Order_By = {
  additional_income_requested_at?: InputMaybe<Order_By>;
  additional_income_submitted_at?: InputMaybe<Order_By>;
  admin?: InputMaybe<Admins_Order_By>;
  annual_income?: InputMaybe<Order_By>;
  approved_at?: InputMaybe<Order_By>;
  approved_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initially_completed_at?: InputMaybe<Order_By>;
  is_non_income_applicant?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_income_sources_aggregate?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Aggregate_Order_By>;
};

/** primary key columns input for table: applicant_income_underwrites.user_incomes */
export type Applicant_Income_Underwrites_User_Incomes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "applicant_income_underwrites.user_incomes" */
export enum Applicant_Income_Underwrites_User_Incomes_Select_Column {
  /** column name */
  AdditionalIncomeRequestedAt = 'additional_income_requested_at',
  /** column name */
  AdditionalIncomeSubmittedAt = 'additional_income_submitted_at',
  /** column name */
  AnnualIncome = 'annual_income',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedByAdminId = 'approved_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  InitiallyCompletedAt = 'initially_completed_at',
  /** column name */
  IsNonIncomeApplicant = 'is_non_income_applicant',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "applicant_income_underwrites.user_incomes" */
export type Applicant_Income_Underwrites_User_Incomes_Set_Input = {
  additional_income_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  additional_income_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  annual_income?: InputMaybe<Scalars['numeric']['input']>;
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  approved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initially_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_non_income_applicant?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "applicant_income_underwrites_user_incomes" */
export type Applicant_Income_Underwrites_User_Incomes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Applicant_Income_Underwrites_User_Incomes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Applicant_Income_Underwrites_User_Incomes_Stream_Cursor_Value_Input = {
  additional_income_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  additional_income_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  annual_income?: InputMaybe<Scalars['numeric']['input']>;
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  approved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initially_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_non_income_applicant?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Applicant_Income_Underwrites_User_Incomes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Set_Input>;
  where: Applicant_Income_Underwrites_User_Incomes_Bool_Exp;
};

/** columns and relationships of "background_check_requests" */
export type Background_Check_Requests = {
  __typename: 'background_check_requests';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  initiated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  invalidated_at?: Maybe<Scalars['timestamptz']['output']>;
  invalidated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  request_id: Scalars['uuid']['output'];
  resource_id?: Maybe<Scalars['uuid']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "background_check_requests". All fields are combined with a logical 'AND'. */
export type Background_Check_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Background_Check_Requests_Bool_Exp>>;
  _not?: InputMaybe<Background_Check_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Background_Check_Requests_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initiated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  invalidated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invalidated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "background_check_requests". */
export type Background_Check_Requests_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiated_by_admin_id?: InputMaybe<Order_By>;
  invalidated_at?: InputMaybe<Order_By>;
  invalidated_by_admin_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "background_check_requests" */
export enum Background_Check_Requests_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedByAdminId = 'initiated_by_admin_id',
  /** column name */
  InvalidatedAt = 'invalidated_at',
  /** column name */
  InvalidatedByAdminId = 'invalidated_by_admin_id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "background_check_requests" */
export type Background_Check_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Background_Check_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Background_Check_Requests_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initiated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  invalidated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalidated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "bids" */
export type Bids = {
  __typename: 'bids';
  bid_destination_email?: Maybe<Scalars['String']['output']>;
  bid_details_set_at?: Maybe<Scalars['timestamptz']['output']>;
  bid_details_set_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  bid_expiration_date?: Maybe<Scalars['date']['output']>;
  bid_price: Scalars['numeric']['output'];
  bid_price_set_at?: Maybe<Scalars['timestamptz']['output']>;
  bid_price_set_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  closing_date?: Maybe<Scalars['date']['output']>;
  closing_real_estate_attorney_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  contract_id?: Maybe<Scalars['uuid']['output']>;
  counter_offer_bid_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  due_diligence_days?: Maybe<Scalars['Int']['output']>;
  earnest_money_amount?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  legal_description?: Maybe<Scalars['String']['output']>;
  mls_listing_id: Scalars['uuid']['output'];
  possession_at?: Maybe<Scalars['timestamptz']['output']>;
  real_estate_screening_id?: Maybe<Scalars['uuid']['output']>;
  seller_counter_offer_price?: Maybe<Scalars['numeric']['output']>;
  seller_response_at?: Maybe<Scalars['timestamptz']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  sent_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  signed_at?: Maybe<Scalars['timestamptz']['output']>;
  signed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  special_stipulations_note_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  title_company_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "bids" */
export type Bids_Aggregate_Order_By = {
  avg?: InputMaybe<Bids_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bids_Max_Order_By>;
  min?: InputMaybe<Bids_Min_Order_By>;
  stddev?: InputMaybe<Bids_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bids_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bids_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bids_Sum_Order_By>;
  var_pop?: InputMaybe<Bids_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bids_Var_Samp_Order_By>;
  variance?: InputMaybe<Bids_Variance_Order_By>;
};

/** order by avg() on columns of table "bids" */
export type Bids_Avg_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bids". All fields are combined with a logical 'AND'. */
export type Bids_Bool_Exp = {
  _and?: InputMaybe<Array<Bids_Bool_Exp>>;
  _not?: InputMaybe<Bids_Bool_Exp>;
  _or?: InputMaybe<Array<Bids_Bool_Exp>>;
  bid_destination_email?: InputMaybe<String_Comparison_Exp>;
  bid_details_set_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  bid_details_set_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  bid_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  bid_price?: InputMaybe<Numeric_Comparison_Exp>;
  bid_price_set_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  bid_price_set_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  closing_date?: InputMaybe<Date_Comparison_Exp>;
  closing_real_estate_attorney_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  contract_id?: InputMaybe<Uuid_Comparison_Exp>;
  counter_offer_bid_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_diligence_days?: InputMaybe<Int_Comparison_Exp>;
  earnest_money_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legal_description?: InputMaybe<String_Comparison_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  possession_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  real_estate_screening_id?: InputMaybe<Uuid_Comparison_Exp>;
  seller_counter_offer_price?: InputMaybe<Numeric_Comparison_Exp>;
  seller_response_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  signed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  signed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  special_stipulations_note_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "bids" */
export type Bids_Max_Order_By = {
  bid_destination_email?: InputMaybe<Order_By>;
  bid_details_set_at?: InputMaybe<Order_By>;
  bid_details_set_by_admin_id?: InputMaybe<Order_By>;
  bid_expiration_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_price_set_at?: InputMaybe<Order_By>;
  bid_price_set_by_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  closing_real_estate_attorney_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  counter_offer_bid_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_description?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  possession_at?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
  seller_response_at?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by_admin_id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  signed_by_admin_id?: InputMaybe<Order_By>;
  special_stipulations_note_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title_company_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "bids" */
export type Bids_Min_Order_By = {
  bid_destination_email?: InputMaybe<Order_By>;
  bid_details_set_at?: InputMaybe<Order_By>;
  bid_details_set_by_admin_id?: InputMaybe<Order_By>;
  bid_expiration_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_price_set_at?: InputMaybe<Order_By>;
  bid_price_set_by_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  closing_real_estate_attorney_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  counter_offer_bid_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_description?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  possession_at?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
  seller_response_at?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by_admin_id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  signed_by_admin_id?: InputMaybe<Order_By>;
  special_stipulations_note_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title_company_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "bids". */
export type Bids_Order_By = {
  bid_destination_email?: InputMaybe<Order_By>;
  bid_details_set_at?: InputMaybe<Order_By>;
  bid_details_set_by_admin_id?: InputMaybe<Order_By>;
  bid_expiration_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_price_set_at?: InputMaybe<Order_By>;
  bid_price_set_by_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  closing_real_estate_attorney_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  counter_offer_bid_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_description?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  possession_at?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
  seller_response_at?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by_admin_id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  signed_by_admin_id?: InputMaybe<Order_By>;
  special_stipulations_note_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title_company_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "bids" */
export enum Bids_Select_Column {
  /** column name */
  BidDestinationEmail = 'bid_destination_email',
  /** column name */
  BidDetailsSetAt = 'bid_details_set_at',
  /** column name */
  BidDetailsSetByAdminId = 'bid_details_set_by_admin_id',
  /** column name */
  BidExpirationDate = 'bid_expiration_date',
  /** column name */
  BidPrice = 'bid_price',
  /** column name */
  BidPriceSetAt = 'bid_price_set_at',
  /** column name */
  BidPriceSetByAdminId = 'bid_price_set_by_admin_id',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  ClosingDate = 'closing_date',
  /** column name */
  ClosingRealEstateAttorneyId = 'closing_real_estate_attorney_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CounterOfferBidId = 'counter_offer_bid_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DueDiligenceDays = 'due_diligence_days',
  /** column name */
  EarnestMoneyAmount = 'earnest_money_amount',
  /** column name */
  Id = 'id',
  /** column name */
  LegalDescription = 'legal_description',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  PossessionAt = 'possession_at',
  /** column name */
  RealEstateScreeningId = 'real_estate_screening_id',
  /** column name */
  SellerCounterOfferPrice = 'seller_counter_offer_price',
  /** column name */
  SellerResponseAt = 'seller_response_at',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentByAdminId = 'sent_by_admin_id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  SignedByAdminId = 'signed_by_admin_id',
  /** column name */
  SpecialStipulationsNoteId = 'special_stipulations_note_id',
  /** column name */
  Status = 'status',
  /** column name */
  TitleCompanyId = 'title_company_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "bids" */
export type Bids_Stddev_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "bids" */
export type Bids_Stddev_Pop_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "bids" */
export type Bids_Stddev_Samp_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bids" */
export type Bids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bids_Stream_Cursor_Value_Input = {
  bid_destination_email?: InputMaybe<Scalars['String']['input']>;
  bid_details_set_at?: InputMaybe<Scalars['timestamptz']['input']>;
  bid_details_set_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  bid_expiration_date?: InputMaybe<Scalars['date']['input']>;
  bid_price?: InputMaybe<Scalars['numeric']['input']>;
  bid_price_set_at?: InputMaybe<Scalars['timestamptz']['input']>;
  bid_price_set_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closing_date?: InputMaybe<Scalars['date']['input']>;
  closing_real_estate_attorney_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract_id?: InputMaybe<Scalars['uuid']['input']>;
  counter_offer_bid_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_diligence_days?: InputMaybe<Scalars['Int']['input']>;
  earnest_money_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  legal_description?: InputMaybe<Scalars['String']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  possession_at?: InputMaybe<Scalars['timestamptz']['input']>;
  real_estate_screening_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_counter_offer_price?: InputMaybe<Scalars['numeric']['input']>;
  seller_response_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  signed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  signed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  special_stipulations_note_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title_company_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "bids" */
export type Bids_Sum_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "bids" */
export type Bids_Var_Pop_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "bids" */
export type Bids_Var_Samp_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "bids" */
export type Bids_Variance_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  due_diligence_days?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  seller_counter_offer_price?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "buildium_bulk_journal_entry_uploads" */
export type Buildium_Bulk_Journal_Entry_Uploads = {
  __typename: 'buildium_bulk_journal_entry_uploads';
  /** An object relationship */
  admin: Admins;
  admin_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document?: Maybe<Documents>;
  id: Scalars['uuid']['output'];
  reversed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  reversed_by_admin?: Maybe<Admins>;
  reversed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  total_journal_entries: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "buildium_bulk_journal_entry_uploads". All fields are combined with a logical 'AND'. */
export type Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp>>;
  _not?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  reversed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reversed_by_admin?: InputMaybe<Admins_Bool_Exp>;
  reversed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_journal_entries?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** response of any mutation on the table "buildium_bulk_journal_entry_uploads" */
export type Buildium_Bulk_Journal_Entry_Uploads_Mutation_Response = {
  __typename: 'buildium_bulk_journal_entry_uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buildium_Bulk_Journal_Entry_Uploads>;
};

/** Ordering options when selecting data from "buildium_bulk_journal_entry_uploads". */
export type Buildium_Bulk_Journal_Entry_Uploads_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  id?: InputMaybe<Order_By>;
  reversed_at?: InputMaybe<Order_By>;
  reversed_by_admin?: InputMaybe<Admins_Order_By>;
  reversed_by_admin_id?: InputMaybe<Order_By>;
  total_journal_entries?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buildium_bulk_journal_entry_uploads */
export type Buildium_Bulk_Journal_Entry_Uploads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buildium_bulk_journal_entry_uploads" */
export enum Buildium_Bulk_Journal_Entry_Uploads_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReversedAt = 'reversed_at',
  /** column name */
  ReversedByAdminId = 'reversed_by_admin_id',
  /** column name */
  TotalJournalEntries = 'total_journal_entries',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "buildium_bulk_journal_entry_uploads" */
export type Buildium_Bulk_Journal_Entry_Uploads_Set_Input = {
  reversed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reversed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "buildium_bulk_journal_entry_uploads" */
export type Buildium_Bulk_Journal_Entry_Uploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buildium_Bulk_Journal_Entry_Uploads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buildium_Bulk_Journal_Entry_Uploads_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reversed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reversed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  total_journal_entries?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Buildium_Bulk_Journal_Entry_Uploads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Set_Input>;
  where: Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp;
};

/** columns and relationships of "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users = {
  __typename: 'buildium_resident_center_users';
  buildium_lease_href: Scalars['String']['output'];
  buildium_lease_id: Scalars['Int']['output'];
  buildium_lease_type: Scalars['String']['output'];
  buildium_user_first_name: Scalars['String']['output'];
  buildium_user_href: Scalars['String']['output'];
  buildium_user_id: Scalars['Int']['output'];
  buildium_user_last_name: Scalars['String']['output'];
  buildium_user_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_auto_pay_enabled: Scalars['Boolean']['output'];
  resident_center_status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "buildium_resident_center_users". All fields are combined with a logical 'AND'. */
export type Buildium_Resident_Center_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Buildium_Resident_Center_Users_Bool_Exp>>;
  _not?: InputMaybe<Buildium_Resident_Center_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Buildium_Resident_Center_Users_Bool_Exp>>;
  buildium_lease_href?: InputMaybe<String_Comparison_Exp>;
  buildium_lease_id?: InputMaybe<Int_Comparison_Exp>;
  buildium_lease_type?: InputMaybe<String_Comparison_Exp>;
  buildium_user_first_name?: InputMaybe<String_Comparison_Exp>;
  buildium_user_href?: InputMaybe<String_Comparison_Exp>;
  buildium_user_id?: InputMaybe<Int_Comparison_Exp>;
  buildium_user_last_name?: InputMaybe<String_Comparison_Exp>;
  buildium_user_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_auto_pay_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  resident_center_status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "buildium_resident_center_users" */
export enum Buildium_Resident_Center_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  BuildiumResidentCenterUsersPkey = 'buildium_resident_center_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  BuildiumResidentCenterUsersUserIdKey = 'buildium_resident_center_users_user_id_key'
}

/** input type for incrementing numeric columns in table "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users_Inc_Input = {
  buildium_lease_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users_Insert_Input = {
  buildium_lease_href?: InputMaybe<Scalars['String']['input']>;
  buildium_lease_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_lease_type?: InputMaybe<Scalars['String']['input']>;
  buildium_user_first_name?: InputMaybe<Scalars['String']['input']>;
  buildium_user_href?: InputMaybe<Scalars['String']['input']>;
  buildium_user_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_user_last_name?: InputMaybe<Scalars['String']['input']>;
  buildium_user_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_auto_pay_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  resident_center_status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users_Mutation_Response = {
  __typename: 'buildium_resident_center_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buildium_Resident_Center_Users>;
};

/** on_conflict condition type for table "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users_On_Conflict = {
  constraint: Buildium_Resident_Center_Users_Constraint;
  update_columns?: Array<Buildium_Resident_Center_Users_Update_Column>;
  where?: InputMaybe<Buildium_Resident_Center_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "buildium_resident_center_users". */
export type Buildium_Resident_Center_Users_Order_By = {
  buildium_lease_href?: InputMaybe<Order_By>;
  buildium_lease_id?: InputMaybe<Order_By>;
  buildium_lease_type?: InputMaybe<Order_By>;
  buildium_user_first_name?: InputMaybe<Order_By>;
  buildium_user_href?: InputMaybe<Order_By>;
  buildium_user_id?: InputMaybe<Order_By>;
  buildium_user_last_name?: InputMaybe<Order_By>;
  buildium_user_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_auto_pay_enabled?: InputMaybe<Order_By>;
  resident_center_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buildium_resident_center_users */
export type Buildium_Resident_Center_Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buildium_resident_center_users" */
export enum Buildium_Resident_Center_Users_Select_Column {
  /** column name */
  BuildiumLeaseHref = 'buildium_lease_href',
  /** column name */
  BuildiumLeaseId = 'buildium_lease_id',
  /** column name */
  BuildiumLeaseType = 'buildium_lease_type',
  /** column name */
  BuildiumUserFirstName = 'buildium_user_first_name',
  /** column name */
  BuildiumUserHref = 'buildium_user_href',
  /** column name */
  BuildiumUserId = 'buildium_user_id',
  /** column name */
  BuildiumUserLastName = 'buildium_user_last_name',
  /** column name */
  BuildiumUserType = 'buildium_user_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutoPayEnabled = 'is_auto_pay_enabled',
  /** column name */
  ResidentCenterStatus = 'resident_center_status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users_Set_Input = {
  buildium_lease_href?: InputMaybe<Scalars['String']['input']>;
  buildium_lease_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_lease_type?: InputMaybe<Scalars['String']['input']>;
  buildium_user_first_name?: InputMaybe<Scalars['String']['input']>;
  buildium_user_href?: InputMaybe<Scalars['String']['input']>;
  buildium_user_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_user_last_name?: InputMaybe<Scalars['String']['input']>;
  buildium_user_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_auto_pay_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  resident_center_status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "buildium_resident_center_users" */
export type Buildium_Resident_Center_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buildium_Resident_Center_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buildium_Resident_Center_Users_Stream_Cursor_Value_Input = {
  buildium_lease_href?: InputMaybe<Scalars['String']['input']>;
  buildium_lease_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_lease_type?: InputMaybe<Scalars['String']['input']>;
  buildium_user_first_name?: InputMaybe<Scalars['String']['input']>;
  buildium_user_href?: InputMaybe<Scalars['String']['input']>;
  buildium_user_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_user_last_name?: InputMaybe<Scalars['String']['input']>;
  buildium_user_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_auto_pay_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  resident_center_status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "buildium_resident_center_users" */
export enum Buildium_Resident_Center_Users_Update_Column {
  /** column name */
  BuildiumLeaseHref = 'buildium_lease_href',
  /** column name */
  BuildiumLeaseId = 'buildium_lease_id',
  /** column name */
  BuildiumLeaseType = 'buildium_lease_type',
  /** column name */
  BuildiumUserFirstName = 'buildium_user_first_name',
  /** column name */
  BuildiumUserHref = 'buildium_user_href',
  /** column name */
  BuildiumUserId = 'buildium_user_id',
  /** column name */
  BuildiumUserLastName = 'buildium_user_last_name',
  /** column name */
  BuildiumUserType = 'buildium_user_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutoPayEnabled = 'is_auto_pay_enabled',
  /** column name */
  ResidentCenterStatus = 'resident_center_status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Buildium_Resident_Center_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buildium_Resident_Center_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buildium_Resident_Center_Users_Set_Input>;
  where: Buildium_Resident_Center_Users_Bool_Exp;
};

/** columns and relationships of "buildium_transactions" */
export type Buildium_Transactions = {
  __typename: 'buildium_transactions';
  amount: Scalars['numeric']['output'];
  buildium_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  rental_id?: Maybe<Scalars['uuid']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "buildium_transactions" */
export type Buildium_TransactionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "buildium_transactions". All fields are combined with a logical 'AND'. */
export type Buildium_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Buildium_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Buildium_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Buildium_Transactions_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  buildium_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "buildium_transactions" */
export enum Buildium_Transactions_Constraint {
  /** unique or primary key constraint on columns "type", "buildium_id" */
  BuildiumTransactionsBuildiumIdTypeKey = 'buildium_transactions_buildium_id_type_key',
  /** unique or primary key constraint on columns "id" */
  BuildiumTransactionsPkey = 'buildium_transactions_pkey'
}

/** input type for inserting data into table "buildium_transactions" */
export type Buildium_Transactions_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "buildium_transactions" */
export type Buildium_Transactions_Mutation_Response = {
  __typename: 'buildium_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buildium_Transactions>;
};

/** input type for inserting object relation for remote table "buildium_transactions" */
export type Buildium_Transactions_Obj_Rel_Insert_Input = {
  data: Buildium_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buildium_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "buildium_transactions" */
export type Buildium_Transactions_On_Conflict = {
  constraint: Buildium_Transactions_Constraint;
  update_columns?: Array<Buildium_Transactions_Update_Column>;
  where?: InputMaybe<Buildium_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "buildium_transactions". */
export type Buildium_Transactions_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "buildium_transactions" */
export enum Buildium_Transactions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuildiumId = 'buildium_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "buildium_transactions" */
export type Buildium_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buildium_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buildium_Transactions_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "buildium_transactions" (current role has no relevant permissions) */
export enum Buildium_Transactions_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "capabilities" */
export type Capabilities = {
  __typename: 'capabilities';
  /** An array relationship */
  admin_capabilities: Array<Admin_Capabilities>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "capabilities" */
export type CapabilitiesAdmin_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Capabilities_Order_By>>;
  where?: InputMaybe<Admin_Capabilities_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "capabilities". All fields are combined with a logical 'AND'. */
export type Capabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Capabilities_Bool_Exp>>;
  _not?: InputMaybe<Capabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Capabilities_Bool_Exp>>;
  admin_capabilities?: InputMaybe<Admin_Capabilities_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "capabilities" */
export enum Capabilities_Constraint {
  /** unique or primary key constraint on columns "name" */
  CapabilitiesNameUnique = 'capabilities_name_unique',
  /** unique or primary key constraint on columns "id" */
  CapabilitiesPkey = 'capabilities_pkey',
  /** unique or primary key constraint on columns "type" */
  CapabilitiesTypeUnique = 'capabilities_type_unique'
}

/** input type for inserting data into table "capabilities" */
export type Capabilities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "capabilities" */
export type Capabilities_Mutation_Response = {
  __typename: 'capabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Capabilities>;
};

/** on_conflict condition type for table "capabilities" */
export type Capabilities_On_Conflict = {
  constraint: Capabilities_Constraint;
  update_columns?: Array<Capabilities_Update_Column>;
  where?: InputMaybe<Capabilities_Bool_Exp>;
};

/** Ordering options when selecting data from "capabilities". */
export type Capabilities_Order_By = {
  admin_capabilities_aggregate?: InputMaybe<Admin_Capabilities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "capabilities" */
export enum Capabilities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "capabilities" */
export type Capabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Capabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Capabilities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "capabilities" (current role has no relevant permissions) */
export enum Capabilities_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "cashout_adjustments" */
export type Cashout_Adjustments = {
  __typename: 'cashout_adjustments';
  amount: Scalars['numeric']['output'];
  cashout_id: Scalars['uuid']['output'];
  date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
};

/** order by aggregate values of table "cashout_adjustments" */
export type Cashout_Adjustments_Aggregate_Order_By = {
  avg?: InputMaybe<Cashout_Adjustments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cashout_Adjustments_Max_Order_By>;
  min?: InputMaybe<Cashout_Adjustments_Min_Order_By>;
  stddev?: InputMaybe<Cashout_Adjustments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cashout_Adjustments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cashout_Adjustments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cashout_Adjustments_Sum_Order_By>;
  var_pop?: InputMaybe<Cashout_Adjustments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cashout_Adjustments_Var_Samp_Order_By>;
  variance?: InputMaybe<Cashout_Adjustments_Variance_Order_By>;
};

/** order by avg() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cashout_adjustments". All fields are combined with a logical 'AND'. */
export type Cashout_Adjustments_Bool_Exp = {
  _and?: InputMaybe<Array<Cashout_Adjustments_Bool_Exp>>;
  _not?: InputMaybe<Cashout_Adjustments_Bool_Exp>;
  _or?: InputMaybe<Array<Cashout_Adjustments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  cashout_id?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  cashout_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  cashout_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "cashout_adjustments". */
export type Cashout_Adjustments_Order_By = {
  amount?: InputMaybe<Order_By>;
  cashout_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "cashout_adjustments" */
export enum Cashout_Adjustments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CashoutId = 'cashout_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Type = 'type'
}

/** order by stddev() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cashout_adjustments" */
export type Cashout_Adjustments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cashout_Adjustments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cashout_Adjustments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cashout_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cashout_adjustments" */
export type Cashout_Adjustments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "cashout_configs" */
export type Cashout_Configs = {
  __typename: 'cashout_configs';
  cashout_deadline: Scalars['Int']['output'];
  chargeback_deadline?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  market_id: Scalars['uuid']['output'];
  rental_program_type: Rental_Program_Types_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "cashout_configs". All fields are combined with a logical 'AND'. */
export type Cashout_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Cashout_Configs_Bool_Exp>>;
  _not?: InputMaybe<Cashout_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Cashout_Configs_Bool_Exp>>;
  cashout_deadline?: InputMaybe<Int_Comparison_Exp>;
  chargeback_deadline?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "cashout_configs". */
export type Cashout_Configs_Order_By = {
  cashout_deadline?: InputMaybe<Order_By>;
  chargeback_deadline?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  rental_program_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "cashout_configs" */
export enum Cashout_Configs_Select_Column {
  /** column name */
  CashoutDeadline = 'cashout_deadline',
  /** column name */
  ChargebackDeadline = 'chargeback_deadline',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  RentalProgramType = 'rental_program_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "cashout_configs" */
export type Cashout_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cashout_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cashout_Configs_Stream_Cursor_Value_Input = {
  cashout_deadline?: InputMaybe<Scalars['Int']['input']>;
  chargeback_deadline?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Boolean expression to compare columns of type "cashout_statuses". All fields are combined with logical 'AND'. */
export type Cashout_Statuses_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['cashout_statuses']['input']>;
  _gt?: InputMaybe<Scalars['cashout_statuses']['input']>;
  _gte?: InputMaybe<Scalars['cashout_statuses']['input']>;
  _in?: InputMaybe<Array<Scalars['cashout_statuses']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['cashout_statuses']['input']>;
  _lte?: InputMaybe<Scalars['cashout_statuses']['input']>;
  _neq?: InputMaybe<Scalars['cashout_statuses']['input']>;
  _nin?: InputMaybe<Array<Scalars['cashout_statuses']['input']>>;
};

/** columns and relationships of "cashouts" */
export type Cashouts = {
  __typename: 'cashouts';
  adjustments_finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  adjustments_finalized_by_admin?: Maybe<Admins>;
  adjustments_finalized_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  cashed_out_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  cashed_out_by_admin?: Maybe<Admins>;
  cashed_out_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  cashed_out_segment_fired_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  cashout_adjustments: Array<Cashout_Adjustments>;
  /** An array relationship */
  cashouts_pending_liabilities: Array<Cashouts_Pending_Liabilities>;
  clawback_amount?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  final_wallet_amount?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  maintenance_chargebacks_finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  maintenance_chargebacks_finalized_by_admin?: Maybe<Admins>;
  maintenance_chargebacks_finalized_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  paid_out_amount: Scalars['numeric']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  status: Scalars['cashout_statuses']['output'];
  total_investment_amount?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  utilities_finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  utilities_finalized_by_admin?: Maybe<Admins>;
  utilities_finalized_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  wallet_fee_amount?: Maybe<Scalars['numeric']['output']>;
  write_off_amount?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "cashouts" */
export type CashoutsCashout_AdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<Cashout_Adjustments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashout_Adjustments_Order_By>>;
  where?: InputMaybe<Cashout_Adjustments_Bool_Exp>;
};


/** columns and relationships of "cashouts" */
export type CashoutsCashouts_Pending_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Cashouts_Pending_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashouts_Pending_Liabilities_Order_By>>;
  where?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "cashouts". All fields are combined with a logical 'AND'. */
export type Cashouts_Bool_Exp = {
  _and?: InputMaybe<Array<Cashouts_Bool_Exp>>;
  _not?: InputMaybe<Cashouts_Bool_Exp>;
  _or?: InputMaybe<Array<Cashouts_Bool_Exp>>;
  adjustments_finalized_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  adjustments_finalized_by_admin?: InputMaybe<Admins_Bool_Exp>;
  adjustments_finalized_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  cashed_out_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cashed_out_by_admin?: InputMaybe<Admins_Bool_Exp>;
  cashed_out_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  cashed_out_segment_fired_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cashout_adjustments?: InputMaybe<Cashout_Adjustments_Bool_Exp>;
  cashouts_pending_liabilities?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
  clawback_amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  final_wallet_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  maintenance_chargebacks_finalized_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  maintenance_chargebacks_finalized_by_admin?: InputMaybe<Admins_Bool_Exp>;
  maintenance_chargebacks_finalized_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  paid_out_amount?: InputMaybe<Numeric_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Cashout_Statuses_Comparison_Exp>;
  total_investment_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  utilities_finalized_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utilities_finalized_by_admin?: InputMaybe<Admins_Bool_Exp>;
  utilities_finalized_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  wallet_fee_amount?: InputMaybe<Numeric_Comparison_Exp>;
  write_off_amount?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "cashouts". */
export type Cashouts_Order_By = {
  adjustments_finalized_at?: InputMaybe<Order_By>;
  adjustments_finalized_by_admin?: InputMaybe<Admins_Order_By>;
  adjustments_finalized_by_admin_id?: InputMaybe<Order_By>;
  cashed_out_at?: InputMaybe<Order_By>;
  cashed_out_by_admin?: InputMaybe<Admins_Order_By>;
  cashed_out_by_admin_id?: InputMaybe<Order_By>;
  cashed_out_segment_fired_at?: InputMaybe<Order_By>;
  cashout_adjustments_aggregate?: InputMaybe<Cashout_Adjustments_Aggregate_Order_By>;
  cashouts_pending_liabilities_aggregate?: InputMaybe<Cashouts_Pending_Liabilities_Aggregate_Order_By>;
  clawback_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  final_wallet_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  maintenance_chargebacks_finalized_at?: InputMaybe<Order_By>;
  maintenance_chargebacks_finalized_by_admin?: InputMaybe<Admins_Order_By>;
  maintenance_chargebacks_finalized_by_admin_id?: InputMaybe<Order_By>;
  paid_out_amount?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_investment_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  utilities_finalized_at?: InputMaybe<Order_By>;
  utilities_finalized_by_admin?: InputMaybe<Admins_Order_By>;
  utilities_finalized_by_admin_id?: InputMaybe<Order_By>;
  wallet_fee_amount?: InputMaybe<Order_By>;
  write_off_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities = {
  __typename: 'cashouts_pending_liabilities';
  amount: Scalars['numeric']['output'];
  /** An object relationship */
  cashout: Cashouts;
  cashout_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ledger_account?: Maybe<Ledger_Accounts>;
  ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_liability?: Maybe<Rental_Liabilities>;
  rental_liability_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Aggregate_Order_By = {
  avg?: InputMaybe<Cashouts_Pending_Liabilities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cashouts_Pending_Liabilities_Max_Order_By>;
  min?: InputMaybe<Cashouts_Pending_Liabilities_Min_Order_By>;
  stddev?: InputMaybe<Cashouts_Pending_Liabilities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cashouts_Pending_Liabilities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cashouts_Pending_Liabilities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cashouts_Pending_Liabilities_Sum_Order_By>;
  var_pop?: InputMaybe<Cashouts_Pending_Liabilities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cashouts_Pending_Liabilities_Var_Samp_Order_By>;
  variance?: InputMaybe<Cashouts_Pending_Liabilities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Arr_Rel_Insert_Input = {
  data: Array<Cashouts_Pending_Liabilities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cashouts_Pending_Liabilities_On_Conflict>;
};

/** order by avg() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cashouts_pending_liabilities". All fields are combined with a logical 'AND'. */
export type Cashouts_Pending_Liabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Cashouts_Pending_Liabilities_Bool_Exp>>;
  _not?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Cashouts_Pending_Liabilities_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  cashout?: InputMaybe<Cashouts_Bool_Exp>;
  cashout_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ledger_account?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_liability?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  rental_liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cashouts_pending_liabilities" */
export enum Cashouts_Pending_Liabilities_Constraint {
  /** unique or primary key constraint on columns "id" */
  CashoutsPendingLiabilitiesPkey = 'cashouts_pending_liabilities_pkey'
}

/** input type for incrementing numeric columns in table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cashout_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_liability?: InputMaybe<Rental_Liabilities_Obj_Rel_Insert_Input>;
  rental_liability_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  cashout_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account_id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  cashout_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account_id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Mutation_Response = {
  __typename: 'cashouts_pending_liabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cashouts_Pending_Liabilities>;
};

/** on_conflict condition type for table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_On_Conflict = {
  constraint: Cashouts_Pending_Liabilities_Constraint;
  update_columns?: Array<Cashouts_Pending_Liabilities_Update_Column>;
  where?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
};

/** Ordering options when selecting data from "cashouts_pending_liabilities". */
export type Cashouts_Pending_Liabilities_Order_By = {
  amount?: InputMaybe<Order_By>;
  cashout?: InputMaybe<Cashouts_Order_By>;
  cashout_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account?: InputMaybe<Ledger_Accounts_Order_By>;
  ledger_account_id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_liability?: InputMaybe<Rental_Liabilities_Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cashouts_pending_liabilities */
export type Cashouts_Pending_Liabilities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cashouts_pending_liabilities" */
export enum Cashouts_Pending_Liabilities_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CashoutId = 'cashout_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LedgerAccountId = 'ledger_account_id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  RentalLiabilityId = 'rental_liability_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cashout_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cashouts_Pending_Liabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cashouts_Pending_Liabilities_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cashout_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_liability_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "cashouts_pending_liabilities" */
export enum Cashouts_Pending_Liabilities_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CashoutId = 'cashout_id',
  /** column name */
  Description = 'description',
  /** column name */
  LedgerAccountId = 'ledger_account_id',
  /** column name */
  LiabilityTypeId = 'liability_type_id'
}

export type Cashouts_Pending_Liabilities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cashouts_Pending_Liabilities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cashouts_Pending_Liabilities_Set_Input>;
  where: Cashouts_Pending_Liabilities_Bool_Exp;
};

/** order by var_pop() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cashouts_pending_liabilities" */
export type Cashouts_Pending_Liabilities_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** select columns of table "cashouts" */
export enum Cashouts_Select_Column {
  /** column name */
  AdjustmentsFinalizedAt = 'adjustments_finalized_at',
  /** column name */
  AdjustmentsFinalizedByAdminId = 'adjustments_finalized_by_admin_id',
  /** column name */
  CashedOutAt = 'cashed_out_at',
  /** column name */
  CashedOutByAdminId = 'cashed_out_by_admin_id',
  /** column name */
  CashedOutSegmentFiredAt = 'cashed_out_segment_fired_at',
  /** column name */
  ClawbackAmount = 'clawback_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinalWalletAmount = 'final_wallet_amount',
  /** column name */
  Id = 'id',
  /** column name */
  MaintenanceChargebacksFinalizedAt = 'maintenance_chargebacks_finalized_at',
  /** column name */
  MaintenanceChargebacksFinalizedByAdminId = 'maintenance_chargebacks_finalized_by_admin_id',
  /** column name */
  PaidOutAmount = 'paid_out_amount',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Status = 'status',
  /** column name */
  TotalInvestmentAmount = 'total_investment_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UtilitiesFinalizedAt = 'utilities_finalized_at',
  /** column name */
  UtilitiesFinalizedByAdminId = 'utilities_finalized_by_admin_id',
  /** column name */
  WalletFeeAmount = 'wallet_fee_amount',
  /** column name */
  WriteOffAmount = 'write_off_amount'
}

/** Streaming cursor of the table "cashouts" */
export type Cashouts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cashouts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cashouts_Stream_Cursor_Value_Input = {
  adjustments_finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  adjustments_finalized_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  cashed_out_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cashed_out_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  cashed_out_segment_fired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  clawback_amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  final_wallet_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  maintenance_chargebacks_finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  maintenance_chargebacks_finalized_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  paid_out_amount?: InputMaybe<Scalars['numeric']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['cashout_statuses']['input']>;
  total_investment_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  utilities_finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utilities_finalized_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  wallet_fee_amount?: InputMaybe<Scalars['numeric']['input']>;
  write_off_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** columns and relationships of "check_deposit_payments" */
export type Check_Deposit_Payments = {
  __typename: 'check_deposit_payments';
  /** An object relationship */
  check_deposit: Check_Deposits;
  check_deposit_id: Scalars['uuid']['output'];
  /** An object relationship */
  payment: Payments;
  payment_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "check_deposit_payments" */
export type Check_Deposit_Payments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Check_Deposit_Payments_Max_Order_By>;
  min?: InputMaybe<Check_Deposit_Payments_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "check_deposit_payments". All fields are combined with a logical 'AND'. */
export type Check_Deposit_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Check_Deposit_Payments_Bool_Exp>>;
  _not?: InputMaybe<Check_Deposit_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Check_Deposit_Payments_Bool_Exp>>;
  check_deposit?: InputMaybe<Check_Deposits_Bool_Exp>;
  check_deposit_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "check_deposit_payments" */
export type Check_Deposit_Payments_Max_Order_By = {
  check_deposit_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "check_deposit_payments" */
export type Check_Deposit_Payments_Min_Order_By = {
  check_deposit_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "check_deposit_payments". */
export type Check_Deposit_Payments_Order_By = {
  check_deposit?: InputMaybe<Check_Deposits_Order_By>;
  check_deposit_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** select columns of table "check_deposit_payments" */
export enum Check_Deposit_Payments_Select_Column {
  /** column name */
  CheckDepositId = 'check_deposit_id',
  /** column name */
  PaymentId = 'payment_id'
}

/** Streaming cursor of the table "check_deposit_payments" */
export type Check_Deposit_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Check_Deposit_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Check_Deposit_Payments_Stream_Cursor_Value_Input = {
  check_deposit_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "check_deposits" */
export type Check_Deposits = {
  __typename: 'check_deposits';
  /** An object relationship */
  admin: Admins;
  amount: Scalars['numeric']['output'];
  available_on: Scalars['date']['output'];
  /** An array relationship */
  check_deposit_payments: Array<Check_Deposit_Payments>;
  created_at: Scalars['timestamptz']['output'];
  deposited_ledger_account_id: Scalars['uuid']['output'];
  deposited_on: Scalars['date']['output'];
  expected_ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ledger_account: Ledger_Accounts;
  received_by_admin_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  upload_link?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "check_deposits" */
export type Check_DepositsCheck_Deposit_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Check_Deposit_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Check_Deposit_Payments_Order_By>>;
  where?: InputMaybe<Check_Deposit_Payments_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "check_deposits". All fields are combined with a logical 'AND'. */
export type Check_Deposits_Bool_Exp = {
  _and?: InputMaybe<Array<Check_Deposits_Bool_Exp>>;
  _not?: InputMaybe<Check_Deposits_Bool_Exp>;
  _or?: InputMaybe<Array<Check_Deposits_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  available_on?: InputMaybe<Date_Comparison_Exp>;
  check_deposit_payments?: InputMaybe<Check_Deposit_Payments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deposited_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  deposited_on?: InputMaybe<Date_Comparison_Exp>;
  expected_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ledger_account?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  received_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upload_link?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "check_deposits". */
export type Check_Deposits_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  amount?: InputMaybe<Order_By>;
  available_on?: InputMaybe<Order_By>;
  check_deposit_payments_aggregate?: InputMaybe<Check_Deposit_Payments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deposited_ledger_account_id?: InputMaybe<Order_By>;
  deposited_on?: InputMaybe<Order_By>;
  expected_ledger_account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account?: InputMaybe<Ledger_Accounts_Order_By>;
  received_by_admin_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upload_link?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "check_deposits" */
export enum Check_Deposits_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AvailableOn = 'available_on',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DepositedLedgerAccountId = 'deposited_ledger_account_id',
  /** column name */
  DepositedOn = 'deposited_on',
  /** column name */
  ExpectedLedgerAccountId = 'expected_ledger_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  ReceivedByAdminId = 'received_by_admin_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadLink = 'upload_link',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "check_deposits" */
export type Check_Deposits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Check_Deposits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Check_Deposits_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  available_on?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deposited_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  deposited_on?: InputMaybe<Scalars['date']['input']>;
  expected_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  received_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upload_link?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "collection_payment_promises" */
export type Collection_Payment_Promises = {
  __typename: 'collection_payment_promises';
  /** An object relationship */
  admin: Admins;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  collection: Collections;
  collection_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  do_autocharge: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  promise_to_pay_date: Scalars['date']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "collection_payment_promises" */
export type Collection_Payment_Promises_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Collection_Payment_Promises_Max_Order_By>;
  min?: InputMaybe<Collection_Payment_Promises_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "collection_payment_promises". All fields are combined with a logical 'AND'. */
export type Collection_Payment_Promises_Bool_Exp = {
  _and?: InputMaybe<Array<Collection_Payment_Promises_Bool_Exp>>;
  _not?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
  _or?: InputMaybe<Array<Collection_Payment_Promises_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection?: InputMaybe<Collections_Bool_Exp>;
  collection_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  do_autocharge?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  promise_to_pay_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "collection_payment_promises" */
export enum Collection_Payment_Promises_Constraint {
  /** unique or primary key constraint on columns "id" */
  PromiseToPayHistoriesPkey = 'promise_to_pay_histories_pkey'
}

/** input type for inserting data into table "collection_payment_promises" */
export type Collection_Payment_Promises_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  do_autocharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  promise_to_pay_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "collection_payment_promises" */
export type Collection_Payment_Promises_Max_Order_By = {
  canceled_at?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  promise_to_pay_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "collection_payment_promises" */
export type Collection_Payment_Promises_Min_Order_By = {
  canceled_at?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  promise_to_pay_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "collection_payment_promises" */
export type Collection_Payment_Promises_Mutation_Response = {
  __typename: 'collection_payment_promises_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Collection_Payment_Promises>;
};

/** on_conflict condition type for table "collection_payment_promises" */
export type Collection_Payment_Promises_On_Conflict = {
  constraint: Collection_Payment_Promises_Constraint;
  update_columns?: Array<Collection_Payment_Promises_Update_Column>;
  where?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
};

/** Ordering options when selecting data from "collection_payment_promises". */
export type Collection_Payment_Promises_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection?: InputMaybe<Collections_Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  do_autocharge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  promise_to_pay_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: collection_payment_promises */
export type Collection_Payment_Promises_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "collection_payment_promises" */
export enum Collection_Payment_Promises_Select_Column {
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DoAutocharge = 'do_autocharge',
  /** column name */
  Id = 'id',
  /** column name */
  PromiseToPayDate = 'promise_to_pay_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "collection_payment_promises" */
export type Collection_Payment_Promises_Set_Input = {
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  do_autocharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  promise_to_pay_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "collection_payment_promises" */
export type Collection_Payment_Promises_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collection_Payment_Promises_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collection_Payment_Promises_Stream_Cursor_Value_Input = {
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  do_autocharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  promise_to_pay_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "collection_payment_promises" */
export enum Collection_Payment_Promises_Update_Column {
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DoAutocharge = 'do_autocharge',
  /** column name */
  Id = 'id',
  /** column name */
  PromiseToPayDate = 'promise_to_pay_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Collection_Payment_Promises_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collection_Payment_Promises_Set_Input>;
  where: Collection_Payment_Promises_Bool_Exp;
};

/** columns and relationships of "collections" */
export type Collections = {
  __typename: 'collections';
  /** An array relationship */
  collection_payment_promises: Array<Collection_Payment_Promises>;
  /** An array relationship */
  collections_rental_liabilities: Array<Collections_Rental_Liabilities>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_autocharge_enabled_at_creation: Scalars['Boolean']['output'];
  late_payment_reason?: Maybe<Collections_Late_Payment_Reason_Enum_Enum>;
  /** An array relationship */
  liabilities_remaining: Array<Collections_Liabilities_Remaining>;
  month: Scalars['date']['output'];
  /** An object relationship */
  note?: Maybe<Notes>;
  note_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  zendesk_link?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "collections" */
export type CollectionsCollection_Payment_PromisesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Payment_Promises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collection_Payment_Promises_Order_By>>;
  where?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
};


/** columns and relationships of "collections" */
export type CollectionsCollections_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Collections_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
};


/** columns and relationships of "collections" */
export type CollectionsLiabilities_RemainingArgs = {
  distinct_on?: InputMaybe<Array<Collections_Liabilities_Remaining_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Liabilities_Remaining_Order_By>>;
  where?: InputMaybe<Collections_Liabilities_Remaining_Bool_Exp>;
};

/** order by aggregate values of table "collections" */
export type Collections_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Collections_Max_Order_By>;
  min?: InputMaybe<Collections_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "collections". All fields are combined with a logical 'AND'. */
export type Collections_Bool_Exp = {
  _and?: InputMaybe<Array<Collections_Bool_Exp>>;
  _not?: InputMaybe<Collections_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Bool_Exp>>;
  collection_payment_promises?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
  collections_rental_liabilities?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_autocharge_enabled_at_creation?: InputMaybe<Boolean_Comparison_Exp>;
  late_payment_reason?: InputMaybe<Collections_Late_Payment_Reason_Enum_Enum_Comparison_Exp>;
  liabilities_remaining?: InputMaybe<Collections_Liabilities_Remaining_Bool_Exp>;
  month?: InputMaybe<Date_Comparison_Exp>;
  note?: InputMaybe<Notes_Bool_Exp>;
  note_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zendesk_link?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "collections_late_payment_reason_enum" */
export type Collections_Late_Payment_Reason_Enum = {
  __typename: 'collections_late_payment_reason_enum';
  reason: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "collections_late_payment_reason_enum". All fields are combined with a logical 'AND'. */
export type Collections_Late_Payment_Reason_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Bool_Exp>>;
  _not?: InputMaybe<Collections_Late_Payment_Reason_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Bool_Exp>>;
  reason?: InputMaybe<String_Comparison_Exp>;
};

export enum Collections_Late_Payment_Reason_Enum_Enum {
  DeathInFamily = 'death_in_family',
  Divorce = 'divorce',
  FamilyCircumstancesChanged = 'family_circumstances_changed',
  InCourtProceedings = 'in_court_proceedings',
  LostJob = 'lost_job',
  MedicalIssues = 'medical_issues',
  Other = 'other',
  PaidMidMonth = 'paid_mid_month'
}

/** Boolean expression to compare columns of type "collections_late_payment_reason_enum_enum". All fields are combined with logical 'AND'. */
export type Collections_Late_Payment_Reason_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Collections_Late_Payment_Reason_Enum_Enum>;
  _in?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Collections_Late_Payment_Reason_Enum_Enum>;
  _nin?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Enum>>;
};

/** Ordering options when selecting data from "collections_late_payment_reason_enum". */
export type Collections_Late_Payment_Reason_Enum_Order_By = {
  reason?: InputMaybe<Order_By>;
};

/** select columns of table "collections_late_payment_reason_enum" */
export enum Collections_Late_Payment_Reason_Enum_Select_Column {
  /** column name */
  Reason = 'reason'
}

/** Streaming cursor of the table "collections_late_payment_reason_enum" */
export type Collections_Late_Payment_Reason_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_Late_Payment_Reason_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_Late_Payment_Reason_Enum_Stream_Cursor_Value_Input = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining = {
  __typename: 'collections_liabilities_remaining';
  amount_remaining?: Maybe<Scalars['numeric']['output']>;
  collection_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  is_autocharge_enabled_at_creation?: Maybe<Scalars['Boolean']['output']>;
  liability_id?: Maybe<Scalars['uuid']['output']>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  month?: Maybe<Scalars['date']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  original_amount?: Maybe<Scalars['numeric']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Aggregate_Order_By = {
  avg?: InputMaybe<Collections_Liabilities_Remaining_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Collections_Liabilities_Remaining_Max_Order_By>;
  min?: InputMaybe<Collections_Liabilities_Remaining_Min_Order_By>;
  stddev?: InputMaybe<Collections_Liabilities_Remaining_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Collections_Liabilities_Remaining_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Collections_Liabilities_Remaining_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Collections_Liabilities_Remaining_Sum_Order_By>;
  var_pop?: InputMaybe<Collections_Liabilities_Remaining_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Collections_Liabilities_Remaining_Var_Samp_Order_By>;
  variance?: InputMaybe<Collections_Liabilities_Remaining_Variance_Order_By>;
};

/** order by avg() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Avg_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "collections_liabilities_remaining". All fields are combined with a logical 'AND'. */
export type Collections_Liabilities_Remaining_Bool_Exp = {
  _and?: InputMaybe<Array<Collections_Liabilities_Remaining_Bool_Exp>>;
  _not?: InputMaybe<Collections_Liabilities_Remaining_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Liabilities_Remaining_Bool_Exp>>;
  amount_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  collection_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  is_autocharge_enabled_at_creation?: InputMaybe<Boolean_Comparison_Exp>;
  liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<Date_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  original_amount?: InputMaybe<Numeric_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Max_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  liability_id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Min_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  liability_id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "collections_liabilities_remaining". */
export type Collections_Liabilities_Remaining_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  is_autocharge_enabled_at_creation?: InputMaybe<Order_By>;
  liability_id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "collections_liabilities_remaining" */
export enum Collections_Liabilities_Remaining_Select_Column {
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  IsAutochargeEnabledAtCreation = 'is_autocharge_enabled_at_creation',
  /** column name */
  LiabilityId = 'liability_id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Month = 'month',
  /** column name */
  Note = 'note',
  /** column name */
  OriginalAmount = 'original_amount',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Stddev_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Stddev_Pop_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Stddev_Samp_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_Liabilities_Remaining_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_Liabilities_Remaining_Stream_Cursor_Value_Input = {
  amount_remaining?: InputMaybe<Scalars['numeric']['input']>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  is_autocharge_enabled_at_creation?: InputMaybe<Scalars['Boolean']['input']>;
  liability_id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Scalars['date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  original_amount?: InputMaybe<Scalars['numeric']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Sum_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Var_Pop_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Var_Samp_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "collections_liabilities_remaining" */
export type Collections_Liabilities_Remaining_Variance_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "collections" */
export type Collections_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  note_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zendesk_link?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "collections" */
export type Collections_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  note_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zendesk_link?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "collections" */
export type Collections_Mutation_Response = {
  __typename: 'collections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Collections>;
};

/** Ordering options when selecting data from "collections". */
export type Collections_Order_By = {
  collection_payment_promises_aggregate?: InputMaybe<Collection_Payment_Promises_Aggregate_Order_By>;
  collections_rental_liabilities_aggregate?: InputMaybe<Collections_Rental_Liabilities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_autocharge_enabled_at_creation?: InputMaybe<Order_By>;
  late_payment_reason?: InputMaybe<Order_By>;
  liabilities_remaining_aggregate?: InputMaybe<Collections_Liabilities_Remaining_Aggregate_Order_By>;
  month?: InputMaybe<Order_By>;
  note?: InputMaybe<Notes_Order_By>;
  note_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zendesk_link?: InputMaybe<Order_By>;
};

/** primary key columns input for table: collections */
export type Collections_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "collections_rental_liabilities" */
export type Collections_Rental_Liabilities = {
  __typename: 'collections_rental_liabilities';
  /** An object relationship */
  collection: Collections;
  collection_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_liability: Rental_Liabilities;
  rental_liability_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "collections_rental_liabilities" */
export type Collections_Rental_Liabilities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Collections_Rental_Liabilities_Max_Order_By>;
  min?: InputMaybe<Collections_Rental_Liabilities_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "collections_rental_liabilities". All fields are combined with a logical 'AND'. */
export type Collections_Rental_Liabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Collections_Rental_Liabilities_Bool_Exp>>;
  _not?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Rental_Liabilities_Bool_Exp>>;
  collection?: InputMaybe<Collections_Bool_Exp>;
  collection_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_liability?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  rental_liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "collections_rental_liabilities" */
export type Collections_Rental_Liabilities_Max_Order_By = {
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "collections_rental_liabilities" */
export type Collections_Rental_Liabilities_Min_Order_By = {
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "collections_rental_liabilities" */
export type Collections_Rental_Liabilities_Mutation_Response = {
  __typename: 'collections_rental_liabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Collections_Rental_Liabilities>;
};

/** Ordering options when selecting data from "collections_rental_liabilities". */
export type Collections_Rental_Liabilities_Order_By = {
  collection?: InputMaybe<Collections_Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_liability?: InputMaybe<Rental_Liabilities_Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "collections_rental_liabilities" */
export enum Collections_Rental_Liabilities_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RentalLiabilityId = 'rental_liability_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "collections_rental_liabilities" */
export type Collections_Rental_Liabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_Rental_Liabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_Rental_Liabilities_Stream_Cursor_Value_Input = {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_liability_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** select columns of table "collections" */
export enum Collections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutochargeEnabledAtCreation = 'is_autocharge_enabled_at_creation',
  /** column name */
  LatePaymentReason = 'late_payment_reason',
  /** column name */
  Month = 'month',
  /** column name */
  NoteId = 'note_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZendeskLink = 'zendesk_link'
}

/** input type for updating data in table "collections" */
export type Collections_Set_Input = {
  late_payment_reason?: InputMaybe<Collections_Late_Payment_Reason_Enum_Enum>;
  note_id?: InputMaybe<Scalars['uuid']['input']>;
  zendesk_link?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "collections" */
export type Collections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_autocharge_enabled_at_creation?: InputMaybe<Scalars['Boolean']['input']>;
  late_payment_reason?: InputMaybe<Collections_Late_Payment_Reason_Enum_Enum>;
  month?: InputMaybe<Scalars['date']['input']>;
  note_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zendesk_link?: InputMaybe<Scalars['String']['input']>;
};

export type Collections_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collections_Set_Input>;
  where: Collections_Bool_Exp;
};

/** columns and relationships of "communities" */
export type Communities = {
  __typename: 'communities';
  /** An object relationship */
  community_features?: Maybe<Community_Features>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  portfolio_homes: Array<Portfolio_Homes>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "communities" */
export type CommunitiesPortfolio_HomesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Homes_Order_By>>;
  where?: InputMaybe<Portfolio_Homes_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "communities". All fields are combined with a logical 'AND'. */
export type Communities_Bool_Exp = {
  _and?: InputMaybe<Array<Communities_Bool_Exp>>;
  _not?: InputMaybe<Communities_Bool_Exp>;
  _or?: InputMaybe<Array<Communities_Bool_Exp>>;
  community_features?: InputMaybe<Community_Features_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  portfolio_homes?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "communities". */
export type Communities_Order_By = {
  community_features?: InputMaybe<Community_Features_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  portfolio_homes_aggregate?: InputMaybe<Portfolio_Homes_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "communities" */
export enum Communities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "communities" */
export type Communities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Communities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Communities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "community_features" */
export type Community_Features = {
  __typename: 'community_features';
  amenity_details?: Maybe<Scalars['String']['output']>;
  amenity_fee?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  community: Communities;
  community_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  dog_park?: Maybe<Scalars['Boolean']['output']>;
  hoa_contact_email?: Maybe<Scalars['String']['output']>;
  hoa_contact_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  landscaping?: Maybe<Scalars['Boolean']['output']>;
  nature?: Maybe<Scalars['String']['output']>;
  playground?: Maybe<Scalars['Boolean']['output']>;
  pool?: Maybe<Scalars['Boolean']['output']>;
  security?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "community_features". All fields are combined with a logical 'AND'. */
export type Community_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Community_Features_Bool_Exp>>;
  _not?: InputMaybe<Community_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Community_Features_Bool_Exp>>;
  amenity_details?: InputMaybe<String_Comparison_Exp>;
  amenity_fee?: InputMaybe<Numeric_Comparison_Exp>;
  community?: InputMaybe<Communities_Bool_Exp>;
  community_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dog_park?: InputMaybe<Boolean_Comparison_Exp>;
  hoa_contact_email?: InputMaybe<String_Comparison_Exp>;
  hoa_contact_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  landscaping?: InputMaybe<Boolean_Comparison_Exp>;
  nature?: InputMaybe<String_Comparison_Exp>;
  playground?: InputMaybe<Boolean_Comparison_Exp>;
  pool?: InputMaybe<Boolean_Comparison_Exp>;
  security?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "community_features". */
export type Community_Features_Order_By = {
  amenity_details?: InputMaybe<Order_By>;
  amenity_fee?: InputMaybe<Order_By>;
  community?: InputMaybe<Communities_Order_By>;
  community_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dog_park?: InputMaybe<Order_By>;
  hoa_contact_email?: InputMaybe<Order_By>;
  hoa_contact_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  landscaping?: InputMaybe<Order_By>;
  nature?: InputMaybe<Order_By>;
  playground?: InputMaybe<Order_By>;
  pool?: InputMaybe<Order_By>;
  security?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "community_features" */
export enum Community_Features_Select_Column {
  /** column name */
  AmenityDetails = 'amenity_details',
  /** column name */
  AmenityFee = 'amenity_fee',
  /** column name */
  CommunityId = 'community_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DogPark = 'dog_park',
  /** column name */
  HoaContactEmail = 'hoa_contact_email',
  /** column name */
  HoaContactName = 'hoa_contact_name',
  /** column name */
  Id = 'id',
  /** column name */
  Landscaping = 'landscaping',
  /** column name */
  Nature = 'nature',
  /** column name */
  Playground = 'playground',
  /** column name */
  Pool = 'pool',
  /** column name */
  Security = 'security',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "community_features" */
export type Community_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Community_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Community_Features_Stream_Cursor_Value_Input = {
  amenity_details?: InputMaybe<Scalars['String']['input']>;
  amenity_fee?: InputMaybe<Scalars['numeric']['input']>;
  community_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dog_park?: InputMaybe<Scalars['Boolean']['input']>;
  hoa_contact_email?: InputMaybe<Scalars['String']['input']>;
  hoa_contact_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  landscaping?: InputMaybe<Scalars['Boolean']['input']>;
  nature?: InputMaybe<Scalars['String']['input']>;
  playground?: InputMaybe<Scalars['Boolean']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  security?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "construction.construction_common_estimated_costs" */
export type Construction_Construction_Common_Estimated_Costs = {
  __typename: 'construction_construction_common_estimated_costs';
  amount: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "construction.construction_common_estimated_costs". All fields are combined with a logical 'AND'. */
export type Construction_Construction_Common_Estimated_Costs_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Construction_Common_Estimated_Costs_Bool_Exp>>;
  _not?: InputMaybe<Construction_Construction_Common_Estimated_Costs_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Construction_Common_Estimated_Costs_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "construction.construction_common_estimated_costs". */
export type Construction_Construction_Common_Estimated_Costs_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "construction.construction_common_estimated_costs" */
export enum Construction_Construction_Common_Estimated_Costs_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id'
}

/** Streaming cursor of the table "construction_construction_common_estimated_costs" */
export type Construction_Construction_Common_Estimated_Costs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Construction_Common_Estimated_Costs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Construction_Common_Estimated_Costs_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "construction.construction_project_estimated_cost_histories" */
export type Construction_Construction_Project_Estimated_Cost_Histories = {
  __typename: 'construction_construction_project_estimated_cost_histories';
  /** An object relationship */
  admin: Admins;
  construction_project_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  entered_estimated_cost_at: Scalars['timestamptz']['output'];
  estimated_cost_changed_by_admin_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  left_estimated_cost_at?: Maybe<Scalars['timestamptz']['output']>;
  new_estimated_cost: Scalars['numeric']['output'];
  old_estimated_cost?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "construction.construction_project_estimated_cost_histories". All fields are combined with a logical 'AND'. */
export type Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp>>;
  _not?: InputMaybe<Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  construction_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entered_estimated_cost_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  estimated_cost_changed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  left_estimated_cost_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  new_estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  old_estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "construction.construction_project_estimated_cost_histories". */
export type Construction_Construction_Project_Estimated_Cost_Histories_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  construction_project_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entered_estimated_cost_at?: InputMaybe<Order_By>;
  estimated_cost_changed_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_estimated_cost_at?: InputMaybe<Order_By>;
  new_estimated_cost?: InputMaybe<Order_By>;
  old_estimated_cost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction.construction_project_estimated_cost_histories" */
export enum Construction_Construction_Project_Estimated_Cost_Histories_Select_Column {
  /** column name */
  ConstructionProjectId = 'construction_project_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnteredEstimatedCostAt = 'entered_estimated_cost_at',
  /** column name */
  EstimatedCostChangedByAdminId = 'estimated_cost_changed_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeftEstimatedCostAt = 'left_estimated_cost_at',
  /** column name */
  NewEstimatedCost = 'new_estimated_cost',
  /** column name */
  OldEstimatedCost = 'old_estimated_cost',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "construction_construction_project_estimated_cost_histories" */
export type Construction_Construction_Project_Estimated_Cost_Histories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Construction_Project_Estimated_Cost_Histories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Construction_Project_Estimated_Cost_Histories_Stream_Cursor_Value_Input = {
  construction_project_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entered_estimated_cost_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estimated_cost_changed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  left_estimated_cost_at?: InputMaybe<Scalars['timestamptz']['input']>;
  new_estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  old_estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "construction.construction_project_estimated_costs" */
export type Construction_Construction_Project_Estimated_Costs = {
  __typename: 'construction_construction_project_estimated_costs';
  amount: Scalars['numeric']['output'];
  construction_project_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "construction.construction_project_estimated_costs". All fields are combined with a logical 'AND'. */
export type Construction_Construction_Project_Estimated_Costs_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Construction_Project_Estimated_Costs_Bool_Exp>>;
  _not?: InputMaybe<Construction_Construction_Project_Estimated_Costs_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Construction_Project_Estimated_Costs_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  construction_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "construction.construction_project_estimated_costs". */
export type Construction_Construction_Project_Estimated_Costs_Order_By = {
  amount?: InputMaybe<Order_By>;
  construction_project_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "construction.construction_project_estimated_costs" */
export enum Construction_Construction_Project_Estimated_Costs_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ConstructionProjectId = 'construction_project_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id'
}

/** Streaming cursor of the table "construction_construction_project_estimated_costs" */
export type Construction_Construction_Project_Estimated_Costs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Construction_Project_Estimated_Costs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Construction_Project_Estimated_Costs_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  construction_project_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum Construction_Construction_Project_Status_Enum_Enum {
  Canceled = 'canceled',
  Complete = 'complete',
  PendingConstructionCompletion = 'pending_construction_completion',
  PendingConstructionStart = 'pending_construction_start',
  PendingDispatch = 'pending_dispatch',
  PendingMoveOut = 'pending_move_out',
  PendingMoveOutInspection = 'pending_move_out_inspection',
  PendingQualityControl = 'pending_quality_control',
  PendingScope = 'pending_scope',
  PendingScopeApproval = 'pending_scope_approval',
  PostQualityControlTasks = 'post_quality_control_tasks'
}

/** Boolean expression to compare columns of type "construction_construction_project_status_enum_enum". All fields are combined with logical 'AND'. */
export type Construction_Construction_Project_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Construction_Construction_Project_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Construction_Construction_Project_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Construction_Construction_Project_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Construction_Construction_Project_Status_Enum_Enum>>;
};

/** columns and relationships of "construction.construction_scopes" */
export type Construction_Construction_Scopes = {
  __typename: 'construction_construction_scopes';
  construction_project_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  status: Scalars['construction_scope_status']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "construction.construction_scopes". All fields are combined with a logical 'AND'. */
export type Construction_Construction_Scopes_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Construction_Scopes_Bool_Exp>>;
  _not?: InputMaybe<Construction_Construction_Scopes_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Construction_Scopes_Bool_Exp>>;
  construction_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Construction_Scope_Status_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "construction.construction_scopes". */
export type Construction_Construction_Scopes_Order_By = {
  construction_project_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction.construction_scopes" */
export enum Construction_Construction_Scopes_Select_Column {
  /** column name */
  ConstructionProjectId = 'construction_project_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "construction_construction_scopes" */
export type Construction_Construction_Scopes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Construction_Scopes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Construction_Scopes_Stream_Cursor_Value_Input = {
  construction_project_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['construction_scope_status']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "construction_estimates" */
export type Construction_Estimates = {
  __typename: 'construction_estimates';
  /** An object relationship */
  admin: Admins;
  /** An object relationship */
  adminByReviewedByAdminId?: Maybe<Admins>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  estimated_completion_date?: Maybe<Scalars['date']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  estimated_progress_percentage?: Maybe<Scalars['numeric']['output']>;
  estimated_start_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  note?: Maybe<Notes>;
  note_id?: Maybe<Scalars['uuid']['output']>;
  resource_id: Scalars['uuid']['output'];
  resource_type: Scalars['String']['output'];
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "construction_estimates" */
export type Construction_Estimates_Aggregate_Order_By = {
  avg?: InputMaybe<Construction_Estimates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Construction_Estimates_Max_Order_By>;
  min?: InputMaybe<Construction_Estimates_Min_Order_By>;
  stddev?: InputMaybe<Construction_Estimates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Construction_Estimates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Construction_Estimates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Construction_Estimates_Sum_Order_By>;
  var_pop?: InputMaybe<Construction_Estimates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Construction_Estimates_Var_Samp_Order_By>;
  variance?: InputMaybe<Construction_Estimates_Variance_Order_By>;
};

/** order by avg() on columns of table "construction_estimates" */
export type Construction_Estimates_Avg_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_estimates". All fields are combined with a logical 'AND'. */
export type Construction_Estimates_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Estimates_Bool_Exp>>;
  _not?: InputMaybe<Construction_Estimates_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Estimates_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  adminByReviewedByAdminId?: InputMaybe<Admins_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  estimated_completion_date?: InputMaybe<Date_Comparison_Exp>;
  estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_progress_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_start_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<Notes_Bool_Exp>;
  note_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "construction_estimates" */
export type Construction_Estimates_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  estimated_completion_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
  estimated_start_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "construction_estimates" */
export type Construction_Estimates_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  estimated_completion_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
  estimated_start_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "construction_estimates". */
export type Construction_Estimates_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  adminByReviewedByAdminId?: InputMaybe<Admins_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  estimated_completion_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
  estimated_start_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Notes_Order_By>;
  note_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction_estimates" */
export enum Construction_Estimates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  EstimatedCompletionDate = 'estimated_completion_date',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  EstimatedProgressPercentage = 'estimated_progress_percentage',
  /** column name */
  EstimatedStartDate = 'estimated_start_date',
  /** column name */
  Id = 'id',
  /** column name */
  NoteId = 'note_id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "construction_estimates" */
export type Construction_Estimates_Stddev_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "construction_estimates" */
export type Construction_Estimates_Stddev_Pop_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "construction_estimates" */
export type Construction_Estimates_Stddev_Samp_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "construction_estimates" */
export type Construction_Estimates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Estimates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Estimates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  estimated_completion_date?: InputMaybe<Scalars['date']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  estimated_progress_percentage?: InputMaybe<Scalars['numeric']['input']>;
  estimated_start_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "construction_estimates" */
export type Construction_Estimates_Sum_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "construction_estimates" */
export type Construction_Estimates_Var_Pop_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "construction_estimates" */
export type Construction_Estimates_Var_Samp_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "construction_estimates" */
export type Construction_Estimates_Variance_Order_By = {
  estimated_cost?: InputMaybe<Order_By>;
  estimated_progress_percentage?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction.general_contractors" */
export type Construction_General_Contractors = {
  __typename: 'construction_general_contractors';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "construction.general_contractors". All fields are combined with a logical 'AND'. */
export type Construction_General_Contractors_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_General_Contractors_Bool_Exp>>;
  _not?: InputMaybe<Construction_General_Contractors_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_General_Contractors_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "construction.general_contractors". */
export type Construction_General_Contractors_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction.general_contractors" */
export enum Construction_General_Contractors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "construction_general_contractors" */
export type Construction_General_Contractors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_General_Contractors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_General_Contractors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export enum Construction_Occupancy_Inspection_Status_Enum_Enum {
  ApplicationInProgress = 'application_in_progress',
  Complete = 'complete',
  PendingApplication = 'pending_application',
  PendingApproval = 'pending_approval',
  PendingBaseProjectCompletion = 'pending_base_project_completion',
  PendingConstructionCompletion = 'pending_construction_completion',
  PendingConstructionStart = 'pending_construction_start',
  PendingOccupantSignature = 'pending_occupant_signature',
  PendingQualityControl = 'pending_quality_control',
  PendingScheduling = 'pending_scheduling',
  PendingScope = 'pending_scope',
  Scheduled = 'scheduled'
}

/** Boolean expression to compare columns of type "construction_occupancy_inspection_status_enum_enum". All fields are combined with logical 'AND'. */
export type Construction_Occupancy_Inspection_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Construction_Occupancy_Inspection_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Construction_Occupancy_Inspection_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Construction_Occupancy_Inspection_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Construction_Occupancy_Inspection_Status_Enum_Enum>>;
};

/** columns and relationships of "construction.occupancy_inspections" */
export type Construction_Occupancy_Inspections = {
  __typename: 'construction_occupancy_inspections';
  application_submitted_date?: Maybe<Scalars['date']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  certificate_effective_date?: Maybe<Scalars['date']['output']>;
  certificate_expiration_date?: Maybe<Scalars['date']['output']>;
  construction_project_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  in_person_application?: Maybe<Scalars['Boolean']['output']>;
  inspection_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_contacted_date?: Maybe<Scalars['date']['output']>;
  municipality_occupancy_inspection_config_id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  occupant_signature_date?: Maybe<Scalars['date']['output']>;
  occupant_signature_deadline_date?: Maybe<Scalars['date']['output']>;
  payment_confirmed_date?: Maybe<Scalars['date']['output']>;
  payment_submitted_date?: Maybe<Scalars['date']['output']>;
  previous_occupancy_inspection_id?: Maybe<Scalars['uuid']['output']>;
  primary_municipality_contact_id?: Maybe<Scalars['uuid']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  status: Construction_Occupancy_Inspection_Status_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "construction.occupancy_inspections". All fields are combined with a logical 'AND'. */
export type Construction_Occupancy_Inspections_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Occupancy_Inspections_Bool_Exp>>;
  _not?: InputMaybe<Construction_Occupancy_Inspections_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Occupancy_Inspections_Bool_Exp>>;
  application_submitted_date?: InputMaybe<Date_Comparison_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  certificate_effective_date?: InputMaybe<Date_Comparison_Exp>;
  certificate_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  construction_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_person_application?: InputMaybe<Boolean_Comparison_Exp>;
  inspection_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  municipality_contacted_date?: InputMaybe<Date_Comparison_Exp>;
  municipality_occupancy_inspection_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  occupant_signature_date?: InputMaybe<Date_Comparison_Exp>;
  occupant_signature_deadline_date?: InputMaybe<Date_Comparison_Exp>;
  payment_confirmed_date?: InputMaybe<Date_Comparison_Exp>;
  payment_submitted_date?: InputMaybe<Date_Comparison_Exp>;
  previous_occupancy_inspection_id?: InputMaybe<Uuid_Comparison_Exp>;
  primary_municipality_contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  result?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Construction_Occupancy_Inspection_Status_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "construction.occupancy_inspections". */
export type Construction_Occupancy_Inspections_Order_By = {
  application_submitted_date?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  certificate_effective_date?: InputMaybe<Order_By>;
  certificate_expiration_date?: InputMaybe<Order_By>;
  construction_project_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_person_application?: InputMaybe<Order_By>;
  inspection_at?: InputMaybe<Order_By>;
  municipality_contacted_date?: InputMaybe<Order_By>;
  municipality_occupancy_inspection_config_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  occupant_signature_date?: InputMaybe<Order_By>;
  occupant_signature_deadline_date?: InputMaybe<Order_By>;
  payment_confirmed_date?: InputMaybe<Order_By>;
  payment_submitted_date?: InputMaybe<Order_By>;
  previous_occupancy_inspection_id?: InputMaybe<Order_By>;
  primary_municipality_contact_id?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction.occupancy_inspections" */
export enum Construction_Occupancy_Inspections_Select_Column {
  /** column name */
  ApplicationSubmittedDate = 'application_submitted_date',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  CertificateEffectiveDate = 'certificate_effective_date',
  /** column name */
  CertificateExpirationDate = 'certificate_expiration_date',
  /** column name */
  ConstructionProjectId = 'construction_project_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InPersonApplication = 'in_person_application',
  /** column name */
  InspectionAt = 'inspection_at',
  /** column name */
  MunicipalityContactedDate = 'municipality_contacted_date',
  /** column name */
  MunicipalityOccupancyInspectionConfigId = 'municipality_occupancy_inspection_config_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  OccupantSignatureDate = 'occupant_signature_date',
  /** column name */
  OccupantSignatureDeadlineDate = 'occupant_signature_deadline_date',
  /** column name */
  PaymentConfirmedDate = 'payment_confirmed_date',
  /** column name */
  PaymentSubmittedDate = 'payment_submitted_date',
  /** column name */
  PreviousOccupancyInspectionId = 'previous_occupancy_inspection_id',
  /** column name */
  PrimaryMunicipalityContactId = 'primary_municipality_contact_id',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "construction_occupancy_inspections" */
export type Construction_Occupancy_Inspections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Occupancy_Inspections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Occupancy_Inspections_Stream_Cursor_Value_Input = {
  application_submitted_date?: InputMaybe<Scalars['date']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  certificate_effective_date?: InputMaybe<Scalars['date']['input']>;
  certificate_expiration_date?: InputMaybe<Scalars['date']['input']>;
  construction_project_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_person_application?: InputMaybe<Scalars['Boolean']['input']>;
  inspection_at?: InputMaybe<Scalars['timestamptz']['input']>;
  municipality_contacted_date?: InputMaybe<Scalars['date']['input']>;
  municipality_occupancy_inspection_config_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  occupant_signature_date?: InputMaybe<Scalars['date']['input']>;
  occupant_signature_deadline_date?: InputMaybe<Scalars['date']['input']>;
  payment_confirmed_date?: InputMaybe<Scalars['date']['input']>;
  payment_submitted_date?: InputMaybe<Scalars['date']['input']>;
  previous_occupancy_inspection_id?: InputMaybe<Scalars['uuid']['input']>;
  primary_municipality_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Construction_Occupancy_Inspection_Status_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "construction_projects" */
export type Construction_Projects = {
  __typename: 'construction_projects';
  actual_cost?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  admin?: Maybe<Admins>;
  assigned_to_admin_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  construction_scopes: Array<Construction_Scopes>;
  created_at: Scalars['timestamptz']['output'];
  end_date?: Maybe<Scalars['date']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  external_workorder_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  general_contractor?: Maybe<Construction_General_Contractors>;
  id: Scalars['uuid']['output'];
  planned_end_date?: Maybe<Scalars['date']['output']>;
  planned_start_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  portfolio_home?: Maybe<Portfolio_Homes>;
  portfolio_home_id?: Maybe<Scalars['uuid']['output']>;
  resource_id: Scalars['uuid']['output'];
  resource_type: Scalars['String']['output'];
  /** An object relationship */
  source_rental?: Maybe<Rentals>;
  source_rental_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status: Construction_Construction_Project_Status_Enum_Enum;
  substatus?: Maybe<Scalars['String']['output']>;
  tracking_status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "construction_projects" */
export type Construction_ProjectsConstruction_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Scopes_Order_By>>;
  where?: InputMaybe<Construction_Scopes_Bool_Exp>;
};

/** order by aggregate values of table "construction_projects" */
export type Construction_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Construction_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Construction_Projects_Max_Order_By>;
  min?: InputMaybe<Construction_Projects_Min_Order_By>;
  stddev?: InputMaybe<Construction_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Construction_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Construction_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Construction_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Construction_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Construction_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Construction_Projects_Variance_Order_By>;
};

/** order by avg() on columns of table "construction_projects" */
export type Construction_Projects_Avg_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_projects". All fields are combined with a logical 'AND'. */
export type Construction_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Projects_Bool_Exp>>;
  _not?: InputMaybe<Construction_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Projects_Bool_Exp>>;
  actual_cost?: InputMaybe<Numeric_Comparison_Exp>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  assigned_to_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  construction_scopes?: InputMaybe<Construction_Scopes_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  external_workorder_number?: InputMaybe<String_Comparison_Exp>;
  general_contractor?: InputMaybe<Construction_General_Contractors_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  planned_end_date?: InputMaybe<Date_Comparison_Exp>;
  planned_start_date?: InputMaybe<Date_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  source_rental?: InputMaybe<Rentals_Bool_Exp>;
  source_rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Construction_Construction_Project_Status_Enum_Enum_Comparison_Exp>;
  substatus?: InputMaybe<String_Comparison_Exp>;
  tracking_status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "construction_projects" */
export type Construction_Projects_Max_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  assigned_to_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  external_workorder_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  planned_end_date?: InputMaybe<Order_By>;
  planned_start_date?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  source_rental_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  substatus?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "construction_projects" */
export type Construction_Projects_Min_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  assigned_to_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  external_workorder_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  planned_end_date?: InputMaybe<Order_By>;
  planned_start_date?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  source_rental_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  substatus?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "construction_projects". */
export type Construction_Projects_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  admin?: InputMaybe<Admins_Order_By>;
  assigned_to_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  construction_scopes_aggregate?: InputMaybe<Construction_Scopes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  external_workorder_number?: InputMaybe<Order_By>;
  general_contractor?: InputMaybe<Construction_General_Contractors_Order_By>;
  id?: InputMaybe<Order_By>;
  planned_end_date?: InputMaybe<Order_By>;
  planned_start_date?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  source_rental?: InputMaybe<Rentals_Order_By>;
  source_rental_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  substatus?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction_projects" */
export enum Construction_Projects_Select_Column {
  /** column name */
  ActualCost = 'actual_cost',
  /** column name */
  AssignedToAdminId = 'assigned_to_admin_id',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  ExternalWorkorderNumber = 'external_workorder_number',
  /** column name */
  Id = 'id',
  /** column name */
  PlannedEndDate = 'planned_end_date',
  /** column name */
  PlannedStartDate = 'planned_start_date',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  SourceRentalId = 'source_rental_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Substatus = 'substatus',
  /** column name */
  TrackingStatus = 'tracking_status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "construction_projects" */
export type Construction_Projects_Stddev_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "construction_projects" */
export type Construction_Projects_Stddev_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "construction_projects" */
export type Construction_Projects_Stddev_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "construction_projects" */
export type Construction_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Projects_Stream_Cursor_Value_Input = {
  actual_cost?: InputMaybe<Scalars['numeric']['input']>;
  assigned_to_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  external_workorder_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  planned_end_date?: InputMaybe<Scalars['date']['input']>;
  planned_start_date?: InputMaybe<Scalars['date']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  source_rental_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Construction_Construction_Project_Status_Enum_Enum>;
  substatus?: InputMaybe<Scalars['String']['input']>;
  tracking_status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "construction_projects" */
export type Construction_Projects_Sum_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "construction_projects" */
export type Construction_Projects_Var_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "construction_projects" */
export type Construction_Projects_Var_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "construction_projects" */
export type Construction_Projects_Variance_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "construction_scope_status". All fields are combined with logical 'AND'. */
export type Construction_Scope_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['construction_scope_status']['input']>;
  _gt?: InputMaybe<Scalars['construction_scope_status']['input']>;
  _gte?: InputMaybe<Scalars['construction_scope_status']['input']>;
  _in?: InputMaybe<Array<Scalars['construction_scope_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['construction_scope_status']['input']>;
  _lte?: InputMaybe<Scalars['construction_scope_status']['input']>;
  _neq?: InputMaybe<Scalars['construction_scope_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['construction_scope_status']['input']>>;
};

/** columns and relationships of "construction_scopes" */
export type Construction_Scopes = {
  __typename: 'construction_scopes';
  actual_completion_date?: Maybe<Scalars['date']['output']>;
  actual_cost?: Maybe<Scalars['numeric']['output']>;
  actual_start_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  admin: Admins;
  /** An object relationship */
  adminByReviewedByAdminId?: Maybe<Admins>;
  /** An array relationship */
  construction_estimates: Array<Construction_Estimates>;
  /** An object relationship */
  construction_project: Construction_Projects;
  construction_project_id: Scalars['uuid']['output'];
  /** An array relationship */
  construction_scopes_vendors: Array<Construction_Scopes_Vendors>;
  /** An array relationship */
  construction_walkthroughs: Array<Construction_Walkthroughs>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  external_link?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lockbox_code?: Maybe<Scalars['String']['output']>;
  lockbox_instructions?: Maybe<Scalars['String']['output']>;
  renowalk_id?: Maybe<Scalars['Int']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "construction_scopes" */
export type Construction_ScopesConstruction_EstimatesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Estimates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Estimates_Order_By>>;
  where?: InputMaybe<Construction_Estimates_Bool_Exp>;
};


/** columns and relationships of "construction_scopes" */
export type Construction_ScopesConstruction_Scopes_VendorsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Scopes_Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Scopes_Vendors_Order_By>>;
  where?: InputMaybe<Construction_Scopes_Vendors_Bool_Exp>;
};


/** columns and relationships of "construction_scopes" */
export type Construction_ScopesConstruction_WalkthroughsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Walkthroughs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Walkthroughs_Order_By>>;
  where?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
};

/** order by aggregate values of table "construction_scopes" */
export type Construction_Scopes_Aggregate_Order_By = {
  avg?: InputMaybe<Construction_Scopes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Construction_Scopes_Max_Order_By>;
  min?: InputMaybe<Construction_Scopes_Min_Order_By>;
  stddev?: InputMaybe<Construction_Scopes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Construction_Scopes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Construction_Scopes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Construction_Scopes_Sum_Order_By>;
  var_pop?: InputMaybe<Construction_Scopes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Construction_Scopes_Var_Samp_Order_By>;
  variance?: InputMaybe<Construction_Scopes_Variance_Order_By>;
};

/** order by avg() on columns of table "construction_scopes" */
export type Construction_Scopes_Avg_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_scopes". All fields are combined with a logical 'AND'. */
export type Construction_Scopes_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Scopes_Bool_Exp>>;
  _not?: InputMaybe<Construction_Scopes_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Scopes_Bool_Exp>>;
  actual_completion_date?: InputMaybe<Date_Comparison_Exp>;
  actual_cost?: InputMaybe<Numeric_Comparison_Exp>;
  actual_start_date?: InputMaybe<Date_Comparison_Exp>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  adminByReviewedByAdminId?: InputMaybe<Admins_Bool_Exp>;
  construction_estimates?: InputMaybe<Construction_Estimates_Bool_Exp>;
  construction_project?: InputMaybe<Construction_Projects_Bool_Exp>;
  construction_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  construction_scopes_vendors?: InputMaybe<Construction_Scopes_Vendors_Bool_Exp>;
  construction_walkthroughs?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  external_link?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lockbox_code?: InputMaybe<String_Comparison_Exp>;
  lockbox_instructions?: InputMaybe<String_Comparison_Exp>;
  renowalk_id?: InputMaybe<Int_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "construction_scopes" */
export type Construction_Scopes_Max_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  construction_project_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lockbox_code?: InputMaybe<Order_By>;
  lockbox_instructions?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "construction_scopes" */
export type Construction_Scopes_Min_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  construction_project_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lockbox_code?: InputMaybe<Order_By>;
  lockbox_instructions?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "construction_scopes". */
export type Construction_Scopes_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  admin?: InputMaybe<Admins_Order_By>;
  adminByReviewedByAdminId?: InputMaybe<Admins_Order_By>;
  construction_estimates_aggregate?: InputMaybe<Construction_Estimates_Aggregate_Order_By>;
  construction_project?: InputMaybe<Construction_Projects_Order_By>;
  construction_project_id?: InputMaybe<Order_By>;
  construction_scopes_vendors_aggregate?: InputMaybe<Construction_Scopes_Vendors_Aggregate_Order_By>;
  construction_walkthroughs_aggregate?: InputMaybe<Construction_Walkthroughs_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lockbox_code?: InputMaybe<Order_By>;
  lockbox_instructions?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction_scopes" */
export enum Construction_Scopes_Select_Column {
  /** column name */
  ActualCompletionDate = 'actual_completion_date',
  /** column name */
  ActualCost = 'actual_cost',
  /** column name */
  ActualStartDate = 'actual_start_date',
  /** column name */
  ConstructionProjectId = 'construction_project_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  ExternalLink = 'external_link',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  LockboxCode = 'lockbox_code',
  /** column name */
  LockboxInstructions = 'lockbox_instructions',
  /** column name */
  RenowalkId = 'renowalk_id',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "construction_scopes" */
export type Construction_Scopes_Stddev_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "construction_scopes" */
export type Construction_Scopes_Stddev_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "construction_scopes" */
export type Construction_Scopes_Stddev_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "construction_scopes" */
export type Construction_Scopes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Scopes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Scopes_Stream_Cursor_Value_Input = {
  actual_completion_date?: InputMaybe<Scalars['date']['input']>;
  actual_cost?: InputMaybe<Scalars['numeric']['input']>;
  actual_start_date?: InputMaybe<Scalars['date']['input']>;
  construction_project_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  external_link?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lockbox_code?: InputMaybe<Scalars['String']['input']>;
  lockbox_instructions?: InputMaybe<Scalars['String']['input']>;
  renowalk_id?: InputMaybe<Scalars['Int']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "construction_scopes" */
export type Construction_Scopes_Sum_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "construction_scopes" */
export type Construction_Scopes_Var_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "construction_scopes" */
export type Construction_Scopes_Var_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "construction_scopes" */
export type Construction_Scopes_Variance_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  renowalk_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction_scopes_vendors" */
export type Construction_Scopes_Vendors = {
  __typename: 'construction_scopes_vendors';
  actual_completion_date?: Maybe<Scalars['date']['output']>;
  actual_cost?: Maybe<Scalars['numeric']['output']>;
  actual_start_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  admin?: Maybe<Admins>;
  /** An object relationship */
  construction_scope: Construction_Scopes;
  construction_scope_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Aggregate_Order_By = {
  avg?: InputMaybe<Construction_Scopes_Vendors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Construction_Scopes_Vendors_Max_Order_By>;
  min?: InputMaybe<Construction_Scopes_Vendors_Min_Order_By>;
  stddev?: InputMaybe<Construction_Scopes_Vendors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Construction_Scopes_Vendors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Construction_Scopes_Vendors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Construction_Scopes_Vendors_Sum_Order_By>;
  var_pop?: InputMaybe<Construction_Scopes_Vendors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Construction_Scopes_Vendors_Var_Samp_Order_By>;
  variance?: InputMaybe<Construction_Scopes_Vendors_Variance_Order_By>;
};

/** order by avg() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Avg_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_scopes_vendors". All fields are combined with a logical 'AND'. */
export type Construction_Scopes_Vendors_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Scopes_Vendors_Bool_Exp>>;
  _not?: InputMaybe<Construction_Scopes_Vendors_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Scopes_Vendors_Bool_Exp>>;
  actual_completion_date?: InputMaybe<Date_Comparison_Exp>;
  actual_cost?: InputMaybe<Numeric_Comparison_Exp>;
  actual_start_date?: InputMaybe<Date_Comparison_Exp>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  construction_scope?: InputMaybe<Construction_Scopes_Bool_Exp>;
  construction_scope_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Max_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  construction_scope_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Min_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  construction_scope_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "construction_scopes_vendors". */
export type Construction_Scopes_Vendors_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  admin?: InputMaybe<Admins_Order_By>;
  construction_scope?: InputMaybe<Construction_Scopes_Order_By>;
  construction_scope_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "construction_scopes_vendors" */
export enum Construction_Scopes_Vendors_Select_Column {
  /** column name */
  ActualCompletionDate = 'actual_completion_date',
  /** column name */
  ActualCost = 'actual_cost',
  /** column name */
  ActualStartDate = 'actual_start_date',
  /** column name */
  ConstructionScopeId = 'construction_scope_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id'
}

/** order by stddev() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Stddev_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Stddev_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Stddev_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Scopes_Vendors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Scopes_Vendors_Stream_Cursor_Value_Input = {
  actual_completion_date?: InputMaybe<Scalars['date']['input']>;
  actual_cost?: InputMaybe<Scalars['numeric']['input']>;
  actual_start_date?: InputMaybe<Scalars['date']['input']>;
  construction_scope_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Sum_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Var_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Var_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "construction_scopes_vendors" */
export type Construction_Scopes_Vendors_Variance_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction_walkthroughs" */
export type Construction_Walkthroughs = {
  __typename: 'construction_walkthroughs';
  /** An object relationship */
  admin?: Maybe<Admins>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  completed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  external_link?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_red_flag_identified?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  note?: Maybe<Notes>;
  note_id?: Maybe<Scalars['uuid']['output']>;
  resource_id: Scalars['uuid']['output'];
  resource_type: Scalars['String']['output'];
  start_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "construction_walkthroughs" */
export type Construction_Walkthroughs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Construction_Walkthroughs_Max_Order_By>;
  min?: InputMaybe<Construction_Walkthroughs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "construction_walkthroughs". All fields are combined with a logical 'AND'. */
export type Construction_Walkthroughs_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Walkthroughs_Bool_Exp>>;
  _not?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Walkthroughs_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  completed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_link?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_red_flag_identified?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<Notes_Bool_Exp>;
  note_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "construction_walkthroughs" */
export type Construction_Walkthroughs_Max_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "construction_walkthroughs" */
export type Construction_Walkthroughs_Min_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "construction_walkthroughs". */
export type Construction_Walkthroughs_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_red_flag_identified?: InputMaybe<Order_By>;
  note?: InputMaybe<Notes_Order_By>;
  note_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "construction_walkthroughs" */
export enum Construction_Walkthroughs_Select_Column {
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CompletedByAdminId = 'completed_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  ExternalLink = 'external_link',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  IsRedFlagIdentified = 'is_red_flag_identified',
  /** column name */
  NoteId = 'note_id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "construction_walkthroughs" */
export type Construction_Walkthroughs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Walkthroughs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Walkthroughs_Stream_Cursor_Value_Input = {
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  completed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_link?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_red_flag_identified?: InputMaybe<Scalars['Boolean']['input']>;
  note_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Track all conversations with our users. */
export type Conversations = {
  __typename: 'conversations';
  admin_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  direction: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  external_source: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  medium: Scalars['String']['output'];
  payload: Scalars['jsonb']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** Track all conversations with our users. */
export type ConversationsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "conversations" */
export type Conversations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Conversations_Max_Order_By>;
  min?: InputMaybe<Conversations_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "conversations". All fields are combined with a logical 'AND'. */
export type Conversations_Bool_Exp = {
  _and?: InputMaybe<Array<Conversations_Bool_Exp>>;
  _not?: InputMaybe<Conversations_Bool_Exp>;
  _or?: InputMaybe<Array<Conversations_Bool_Exp>>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  direction?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  medium?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "conversations" */
export type Conversations_Max_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "conversations" */
export type Conversations_Min_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "conversations". */
export type Conversations_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "conversations" */
export enum Conversations_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Direction = 'direction',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Medium = 'medium',
  /** column name */
  Payload = 'payload',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "conversations" */
export type Conversations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Conversations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Conversations_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_reports" */
export type Credit_Reports = {
  __typename: 'credit_reports';
  agency?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  document_id?: Maybe<Scalars['uuid']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  provider: Scalars['String']['output'];
  provider_id: Scalars['String']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  score_error_message?: Maybe<Scalars['String']['output']>;
  score_status?: Maybe<Scalars['String']['output']>;
  scoring_model?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "credit_reports" */
export type Credit_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Reports_Max_Order_By>;
  min?: InputMaybe<Credit_Reports_Min_Order_By>;
  stddev?: InputMaybe<Credit_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Reports_Variance_Order_By>;
};

/** order by avg() on columns of table "credit_reports" */
export type Credit_Reports_Avg_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_reports". All fields are combined with a logical 'AND'. */
export type Credit_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Reports_Bool_Exp>>;
  _not?: InputMaybe<Credit_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Reports_Bool_Exp>>;
  agency?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  score_error_message?: InputMaybe<String_Comparison_Exp>;
  score_status?: InputMaybe<String_Comparison_Exp>;
  scoring_model?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "credit_reports" */
export type Credit_Reports_Max_Order_By = {
  agency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  score_error_message?: InputMaybe<Order_By>;
  score_status?: InputMaybe<Order_By>;
  scoring_model?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_reports" */
export type Credit_Reports_Min_Order_By = {
  agency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  score_error_message?: InputMaybe<Order_By>;
  score_status?: InputMaybe<Order_By>;
  scoring_model?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_reports". */
export type Credit_Reports_Order_By = {
  agency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  score_error_message?: InputMaybe<Order_By>;
  score_status?: InputMaybe<Order_By>;
  scoring_model?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "credit_reports" */
export enum Credit_Reports_Select_Column {
  /** column name */
  Agency = 'agency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Score = 'score',
  /** column name */
  ScoreErrorMessage = 'score_error_message',
  /** column name */
  ScoreStatus = 'score_status',
  /** column name */
  ScoringModel = 'scoring_model',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "credit_reports" */
export type Credit_Reports_Stddev_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "credit_reports" */
export type Credit_Reports_Stddev_Pop_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "credit_reports" */
export type Credit_Reports_Stddev_Samp_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_reports" */
export type Credit_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Reports_Stream_Cursor_Value_Input = {
  agency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  score_error_message?: InputMaybe<Scalars['String']['input']>;
  score_status?: InputMaybe<Scalars['String']['input']>;
  scoring_model?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "credit_reports" */
export type Credit_Reports_Sum_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "credit_reports" */
export type Credit_Reports_Var_Pop_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "credit_reports" */
export type Credit_Reports_Var_Samp_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "credit_reports" */
export type Credit_Reports_Variance_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** columns and relationships of "criminal_reports" */
export type Criminal_Reports = {
  __typename: 'criminal_reports';
  created_at: Scalars['timestamptz']['output'];
  document_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  matches?: Maybe<Scalars['jsonb']['output']>;
  provider: Scalars['String']['output'];
  provider_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "criminal_reports" */
export type Criminal_ReportsMatchesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "criminal_reports" */
export type Criminal_Reports_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Criminal_Reports_Max_Order_By>;
  min?: InputMaybe<Criminal_Reports_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "criminal_reports". All fields are combined with a logical 'AND'. */
export type Criminal_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Criminal_Reports_Bool_Exp>>;
  _not?: InputMaybe<Criminal_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Criminal_Reports_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  matches?: InputMaybe<Jsonb_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "criminal_reports" */
export type Criminal_Reports_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "criminal_reports" */
export type Criminal_Reports_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "criminal_reports". */
export type Criminal_Reports_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matches?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "criminal_reports" */
export enum Criminal_Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Matches = 'matches',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "criminal_reports" */
export type Criminal_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Criminal_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Criminal_Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  matches?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "current_balances" */
export type Current_Balances = {
  __typename: 'current_balances';
  aggregate_balance_after?: Maybe<Scalars['numeric']['output']>;
  aggregate_balance_before?: Maybe<Scalars['numeric']['output']>;
  aggregate_successful_balance_after?: Maybe<Scalars['numeric']['output']>;
  aggregate_successful_balance_before?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  liability_type?: Maybe<Scalars['String']['output']>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "current_balances". All fields are combined with a logical 'AND'. */
export type Current_Balances_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Balances_Bool_Exp>>;
  _not?: InputMaybe<Current_Balances_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Balances_Bool_Exp>>;
  aggregate_balance_after?: InputMaybe<Numeric_Comparison_Exp>;
  aggregate_balance_before?: InputMaybe<Numeric_Comparison_Exp>;
  aggregate_successful_balance_after?: InputMaybe<Numeric_Comparison_Exp>;
  aggregate_successful_balance_before?: InputMaybe<Numeric_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<String_Comparison_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "current_balances". */
export type Current_Balances_Order_By = {
  aggregate_balance_after?: InputMaybe<Order_By>;
  aggregate_balance_before?: InputMaybe<Order_By>;
  aggregate_successful_balance_after?: InputMaybe<Order_By>;
  aggregate_successful_balance_before?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "current_balances" */
export enum Current_Balances_Select_Column {
  /** column name */
  AggregateBalanceAfter = 'aggregate_balance_after',
  /** column name */
  AggregateBalanceBefore = 'aggregate_balance_before',
  /** column name */
  AggregateSuccessfulBalanceAfter = 'aggregate_successful_balance_after',
  /** column name */
  AggregateSuccessfulBalanceBefore = 'aggregate_successful_balance_before',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityType = 'liability_type',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "current_balances" */
export type Current_Balances_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Balances_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Balances_Stream_Cursor_Value_Input = {
  aggregate_balance_after?: InputMaybe<Scalars['numeric']['input']>;
  aggregate_balance_before?: InputMaybe<Scalars['numeric']['input']>;
  aggregate_successful_balance_after?: InputMaybe<Scalars['numeric']['input']>;
  aggregate_successful_balance_before?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type?: InputMaybe<Scalars['String']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "current_statements" */
export type Current_Statements = {
  __typename: 'current_statements';
  address?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ending_balance?: Maybe<Scalars['numeric']['output']>;
  ending_premium_factor?: Maybe<Scalars['numeric']['output']>;
  expenses?: Maybe<Scalars['numeric']['output']>;
  hpa?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  income?: Maybe<Scalars['numeric']['output']>;
  investment?: Maybe<Scalars['numeric']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  monthly_return?: Maybe<Scalars['numeric']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  shared_profits?: Maybe<Scalars['numeric']['output']>;
  starting_balance?: Maybe<Scalars['numeric']['output']>;
  starting_premium_factor?: Maybe<Scalars['numeric']['output']>;
  sum_contributions?: Maybe<Scalars['numeric']['output']>;
  sum_shared_hpa?: Maybe<Scalars['numeric']['output']>;
  sum_shared_profits?: Maybe<Scalars['numeric']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "current_statements". All fields are combined with a logical 'AND'. */
export type Current_Statements_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Statements_Bool_Exp>>;
  _not?: InputMaybe<Current_Statements_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Statements_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  ending_balance?: InputMaybe<Numeric_Comparison_Exp>;
  ending_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  expenses?: InputMaybe<Numeric_Comparison_Exp>;
  hpa?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income?: InputMaybe<Numeric_Comparison_Exp>;
  investment?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  monthly_return?: InputMaybe<Numeric_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_profits?: InputMaybe<Numeric_Comparison_Exp>;
  starting_balance?: InputMaybe<Numeric_Comparison_Exp>;
  starting_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  sum_contributions?: InputMaybe<Numeric_Comparison_Exp>;
  sum_shared_hpa?: InputMaybe<Numeric_Comparison_Exp>;
  sum_shared_profits?: InputMaybe<Numeric_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "current_statements". */
export type Current_Statements_Order_By = {
  address?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** select columns of table "current_statements" */
export enum Current_Statements_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Date = 'date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  EndingPremiumFactor = 'ending_premium_factor',
  /** column name */
  Expenses = 'expenses',
  /** column name */
  Hpa = 'hpa',
  /** column name */
  Id = 'id',
  /** column name */
  Income = 'income',
  /** column name */
  Investment = 'investment',
  /** column name */
  Month = 'month',
  /** column name */
  MonthlyReturn = 'monthly_return',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SharedProfits = 'shared_profits',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StartingPremiumFactor = 'starting_premium_factor',
  /** column name */
  SumContributions = 'sum_contributions',
  /** column name */
  SumSharedHpa = 'sum_shared_hpa',
  /** column name */
  SumSharedProfits = 'sum_shared_profits',
  /** column name */
  Tenant = 'tenant'
}

/** Streaming cursor of the table "current_statements" */
export type Current_Statements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Statements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Statements_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  ending_balance?: InputMaybe<Scalars['numeric']['input']>;
  ending_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  expenses?: InputMaybe<Scalars['numeric']['input']>;
  hpa?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income?: InputMaybe<Scalars['numeric']['input']>;
  investment?: InputMaybe<Scalars['numeric']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  monthly_return?: InputMaybe<Scalars['numeric']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  shared_profits?: InputMaybe<Scalars['numeric']['input']>;
  starting_balance?: InputMaybe<Scalars['numeric']['input']>;
  starting_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  sum_contributions?: InputMaybe<Scalars['numeric']['input']>;
  sum_shared_hpa?: InputMaybe<Scalars['numeric']['input']>;
  sum_shared_profits?: InputMaybe<Scalars['numeric']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "current_utility_responsibilities" */
export type Current_Utility_Responsibilities = {
  __typename: 'current_utility_responsibilities';
  /** An object relationship */
  admin?: Maybe<Admins>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  portfolio_home_utility?: Maybe<Portfolio_Home_Utilities>;
  portfolio_home_utility_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  responsible_party?: Maybe<Scalars['String']['output']>;
  rn?: Maybe<Scalars['bigint']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Aggregate_Order_By = {
  avg?: InputMaybe<Current_Utility_Responsibilities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Current_Utility_Responsibilities_Max_Order_By>;
  min?: InputMaybe<Current_Utility_Responsibilities_Min_Order_By>;
  stddev?: InputMaybe<Current_Utility_Responsibilities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Current_Utility_Responsibilities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Current_Utility_Responsibilities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Current_Utility_Responsibilities_Sum_Order_By>;
  var_pop?: InputMaybe<Current_Utility_Responsibilities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Current_Utility_Responsibilities_Var_Samp_Order_By>;
  variance?: InputMaybe<Current_Utility_Responsibilities_Variance_Order_By>;
};

/** order by avg() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Avg_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "current_utility_responsibilities". All fields are combined with a logical 'AND'. */
export type Current_Utility_Responsibilities_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Utility_Responsibilities_Bool_Exp>>;
  _not?: InputMaybe<Current_Utility_Responsibilities_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Utility_Responsibilities_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_utility?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
  portfolio_home_utility_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  responsible_party?: InputMaybe<String_Comparison_Exp>;
  rn?: InputMaybe<Bigint_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_utility_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  responsible_party?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_utility_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  responsible_party?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "current_utility_responsibilities". */
export type Current_Utility_Responsibilities_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_utility?: InputMaybe<Portfolio_Home_Utilities_Order_By>;
  portfolio_home_utility_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  responsible_party?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "current_utility_responsibilities" */
export enum Current_Utility_Responsibilities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeUtilityId = 'portfolio_home_utility_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  ResponsibleParty = 'responsible_party',
  /** column name */
  Rn = 'rn',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Stddev_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Stddev_Pop_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Stddev_Samp_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Utility_Responsibilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Utility_Responsibilities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_utility_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  responsible_party?: InputMaybe<Scalars['String']['input']>;
  rn?: InputMaybe<Scalars['bigint']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Sum_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Var_Pop_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Var_Samp_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "current_utility_responsibilities" */
export type Current_Utility_Responsibilities_Variance_Order_By = {
  rn?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "dashboards" */
export type Dashboards = {
  __typename: 'dashboards';
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "dashboards". All fields are combined with a logical 'AND'. */
export type Dashboards_Bool_Exp = {
  _and?: InputMaybe<Array<Dashboards_Bool_Exp>>;
  _not?: InputMaybe<Dashboards_Bool_Exp>;
  _or?: InputMaybe<Array<Dashboards_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dashboards" */
export enum Dashboards_Constraint {
  /** unique or primary key constraint on columns "id" */
  DashboardsPkey = 'dashboards_pkey'
}

/** input type for inserting data into table "dashboards" */
export type Dashboards_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "dashboards" */
export type Dashboards_Mutation_Response = {
  __typename: 'dashboards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dashboards>;
};

/** on_conflict condition type for table "dashboards" */
export type Dashboards_On_Conflict = {
  constraint: Dashboards_Constraint;
  update_columns?: Array<Dashboards_Update_Column>;
  where?: InputMaybe<Dashboards_Bool_Exp>;
};

/** Ordering options when selecting data from "dashboards". */
export type Dashboards_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dashboards */
export type Dashboards_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dashboards" */
export enum Dashboards_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "dashboards" */
export type Dashboards_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dashboards" */
export type Dashboards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dashboards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dashboards_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dashboards" */
export enum Dashboards_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description',
  /** column name */
  Icon = 'icon',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Url = 'url'
}

export type Dashboards_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dashboards_Set_Input>;
  where: Dashboards_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export enum Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum {
  Accepted = 'accepted',
  Countered = 'countered',
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "dispositions_buyers_inspection_counter_response_type_enum_enum". All fields are combined with logical 'AND'. */
export type Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum>>;
};

export enum Dispositions_Buyers_Inspection_Status_Enum_Enum {
  Canceled = 'canceled',
  CounterResponseReceived = 'counter_response_received',
  CounterSubmitted = 'counter_submitted',
  SubmittedByBuyer = 'submitted_by_buyer',
  VendorBidsSent = 'vendor_bids_sent'
}

/** Boolean expression to compare columns of type "dispositions_buyers_inspection_status_enum_enum". All fields are combined with logical 'AND'. */
export type Dispositions_Buyers_Inspection_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dispositions_Buyers_Inspection_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Dispositions_Buyers_Inspection_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Dispositions_Buyers_Inspection_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Dispositions_Buyers_Inspection_Status_Enum_Enum>>;
};

/** columns and relationships of "dispositions.buyers_inspections" */
export type Dispositions_Buyers_Inspections = {
  __typename: 'dispositions_buyers_inspections';
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  counter_deadline_date?: Maybe<Scalars['date']['output']>;
  counter_response_received_at?: Maybe<Scalars['timestamptz']['output']>;
  counter_response_type?: Maybe<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum>;
  counter_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home_disposition_bid: Dispositions_Portfolio_Home_Disposition_Bids;
  portfolio_home_disposition_bid_id: Scalars['uuid']['output'];
  status: Dispositions_Buyers_Inspection_Status_Enum_Enum;
  submitted_by_buyer_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  vendor_bids_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  vendor_bids_sent_by_admin?: Maybe<Admins>;
  vendor_bids_sent_by_admin_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "dispositions.buyers_inspections" */
export type Dispositions_Buyers_Inspections_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dispositions_Buyers_Inspections_Max_Order_By>;
  min?: InputMaybe<Dispositions_Buyers_Inspections_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "dispositions.buyers_inspections". All fields are combined with a logical 'AND'. */
export type Dispositions_Buyers_Inspections_Bool_Exp = {
  _and?: InputMaybe<Array<Dispositions_Buyers_Inspections_Bool_Exp>>;
  _not?: InputMaybe<Dispositions_Buyers_Inspections_Bool_Exp>;
  _or?: InputMaybe<Array<Dispositions_Buyers_Inspections_Bool_Exp>>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  counter_deadline_date?: InputMaybe<Date_Comparison_Exp>;
  counter_response_received_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  counter_response_type?: InputMaybe<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum_Comparison_Exp>;
  counter_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_disposition_bid?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
  portfolio_home_disposition_bid_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Dispositions_Buyers_Inspection_Status_Enum_Enum_Comparison_Exp>;
  submitted_by_buyer_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_bids_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_bids_sent_by_admin?: InputMaybe<Admins_Bool_Exp>;
  vendor_bids_sent_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "dispositions.buyers_inspections" */
export type Dispositions_Buyers_Inspections_Max_Order_By = {
  canceled_at?: InputMaybe<Order_By>;
  counter_deadline_date?: InputMaybe<Order_By>;
  counter_response_received_at?: InputMaybe<Order_By>;
  counter_submitted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_disposition_bid_id?: InputMaybe<Order_By>;
  submitted_by_buyer_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_bids_sent_at?: InputMaybe<Order_By>;
  vendor_bids_sent_by_admin_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "dispositions.buyers_inspections" */
export type Dispositions_Buyers_Inspections_Min_Order_By = {
  canceled_at?: InputMaybe<Order_By>;
  counter_deadline_date?: InputMaybe<Order_By>;
  counter_response_received_at?: InputMaybe<Order_By>;
  counter_submitted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_disposition_bid_id?: InputMaybe<Order_By>;
  submitted_by_buyer_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_bids_sent_at?: InputMaybe<Order_By>;
  vendor_bids_sent_by_admin_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "dispositions.buyers_inspections". */
export type Dispositions_Buyers_Inspections_Order_By = {
  canceled_at?: InputMaybe<Order_By>;
  counter_deadline_date?: InputMaybe<Order_By>;
  counter_response_received_at?: InputMaybe<Order_By>;
  counter_response_type?: InputMaybe<Order_By>;
  counter_submitted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_disposition_bid?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Order_By>;
  portfolio_home_disposition_bid_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_by_buyer_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_bids_sent_at?: InputMaybe<Order_By>;
  vendor_bids_sent_by_admin?: InputMaybe<Admins_Order_By>;
  vendor_bids_sent_by_admin_id?: InputMaybe<Order_By>;
};

/** select columns of table "dispositions.buyers_inspections" */
export enum Dispositions_Buyers_Inspections_Select_Column {
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CounterDeadlineDate = 'counter_deadline_date',
  /** column name */
  CounterResponseReceivedAt = 'counter_response_received_at',
  /** column name */
  CounterResponseType = 'counter_response_type',
  /** column name */
  CounterSubmittedAt = 'counter_submitted_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeDispositionBidId = 'portfolio_home_disposition_bid_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubmittedByBuyerAt = 'submitted_by_buyer_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorBidsSentAt = 'vendor_bids_sent_at',
  /** column name */
  VendorBidsSentByAdminId = 'vendor_bids_sent_by_admin_id'
}

/** Streaming cursor of the table "dispositions_buyers_inspections" */
export type Dispositions_Buyers_Inspections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispositions_Buyers_Inspections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispositions_Buyers_Inspections_Stream_Cursor_Value_Input = {
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  counter_deadline_date?: InputMaybe<Scalars['date']['input']>;
  counter_response_received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  counter_response_type?: InputMaybe<Dispositions_Buyers_Inspection_Counter_Response_Type_Enum_Enum>;
  counter_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_disposition_bid_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Dispositions_Buyers_Inspection_Status_Enum_Enum>;
  submitted_by_buyer_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_bids_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_bids_sent_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids = {
  __typename: 'dispositions_portfolio_home_disposition_bids';
  agent_id?: Maybe<Scalars['uuid']['output']>;
  bid_expiration_date?: Maybe<Scalars['date']['output']>;
  bid_price: Scalars['numeric']['output'];
  bid_received_date?: Maybe<Scalars['date']['output']>;
  bind_date?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  buyers_inspections: Array<Dispositions_Buyers_Inspections>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  closing_date?: Maybe<Scalars['date']['output']>;
  counterparty_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by_admin?: Maybe<Admins>;
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  due_diligence_end_date?: Maybe<Scalars['date']['output']>;
  due_diligence_start_date?: Maybe<Scalars['date']['output']>;
  earnest_money_amount: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home_disposition: Dispositions_Portfolio_Home_Dispositions;
  /** An object relationship */
  portfolio_home_disposition_counterparty: Dispositions_Portfolio_Home_Disposition_Counterparties;
  portfolio_home_disposition_id: Scalars['uuid']['output'];
  /** An array relationship */
  portfolio_home_dispositions: Array<Dispositions_Portfolio_Home_Dispositions>;
  special_stipulations_note_id?: Maybe<Scalars['uuid']['output']>;
  terminated_date?: Maybe<Scalars['date']['output']>;
  total_sellers_credits: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_BidsBuyers_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Buyers_Inspections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Buyers_Inspections_Order_By>>;
  where?: InputMaybe<Dispositions_Buyers_Inspections_Bool_Exp>;
};


/** columns and relationships of "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_BidsPortfolio_Home_DispositionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
};

/** order by aggregate values of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Aggregate_Order_By = {
  avg?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Max_Order_By>;
  min?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Min_Order_By>;
  stddev?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Sum_Order_By>;
  var_pop?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Var_Samp_Order_By>;
  variance?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Variance_Order_By>;
};

/** order by avg() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Avg_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dispositions.portfolio_home_disposition_bids". All fields are combined with a logical 'AND'. */
export type Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp = {
  _and?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>>;
  _not?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
  _or?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>>;
  agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  bid_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  bid_price?: InputMaybe<Numeric_Comparison_Exp>;
  bid_received_date?: InputMaybe<Date_Comparison_Exp>;
  bind_date?: InputMaybe<Date_Comparison_Exp>;
  buyers_inspections?: InputMaybe<Dispositions_Buyers_Inspections_Bool_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  closing_date?: InputMaybe<Date_Comparison_Exp>;
  counterparty_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin?: InputMaybe<Admins_Bool_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  due_diligence_end_date?: InputMaybe<Date_Comparison_Exp>;
  due_diligence_start_date?: InputMaybe<Date_Comparison_Exp>;
  earnest_money_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_disposition?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
  portfolio_home_disposition_counterparty?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>;
  portfolio_home_disposition_id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_dispositions?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
  special_stipulations_note_id?: InputMaybe<Uuid_Comparison_Exp>;
  terminated_date?: InputMaybe<Date_Comparison_Exp>;
  total_sellers_credits?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  bid_expiration_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_received_date?: InputMaybe<Order_By>;
  bind_date?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  counterparty_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  due_diligence_end_date?: InputMaybe<Order_By>;
  due_diligence_start_date?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_disposition_id?: InputMaybe<Order_By>;
  special_stipulations_note_id?: InputMaybe<Order_By>;
  terminated_date?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  bid_expiration_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_received_date?: InputMaybe<Order_By>;
  bind_date?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  counterparty_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  due_diligence_end_date?: InputMaybe<Order_By>;
  due_diligence_start_date?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_disposition_id?: InputMaybe<Order_By>;
  special_stipulations_note_id?: InputMaybe<Order_By>;
  terminated_date?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "dispositions.portfolio_home_disposition_bids". */
export type Dispositions_Portfolio_Home_Disposition_Bids_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  bid_expiration_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_received_date?: InputMaybe<Order_By>;
  bind_date?: InputMaybe<Order_By>;
  buyers_inspections_aggregate?: InputMaybe<Dispositions_Buyers_Inspections_Aggregate_Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  counterparty_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin?: InputMaybe<Admins_Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  due_diligence_end_date?: InputMaybe<Order_By>;
  due_diligence_start_date?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_disposition?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Order_By>;
  portfolio_home_disposition_counterparty?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Order_By>;
  portfolio_home_disposition_id?: InputMaybe<Order_By>;
  portfolio_home_dispositions_aggregate?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Aggregate_Order_By>;
  special_stipulations_note_id?: InputMaybe<Order_By>;
  terminated_date?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dispositions.portfolio_home_disposition_bids" */
export enum Dispositions_Portfolio_Home_Disposition_Bids_Select_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  BidExpirationDate = 'bid_expiration_date',
  /** column name */
  BidPrice = 'bid_price',
  /** column name */
  BidReceivedDate = 'bid_received_date',
  /** column name */
  BindDate = 'bind_date',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  ClosingDate = 'closing_date',
  /** column name */
  CounterpartyId = 'counterparty_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DueDiligenceEndDate = 'due_diligence_end_date',
  /** column name */
  DueDiligenceStartDate = 'due_diligence_start_date',
  /** column name */
  EarnestMoneyAmount = 'earnest_money_amount',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeDispositionId = 'portfolio_home_disposition_id',
  /** column name */
  SpecialStipulationsNoteId = 'special_stipulations_note_id',
  /** column name */
  TerminatedDate = 'terminated_date',
  /** column name */
  TotalSellersCredits = 'total_sellers_credits',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Stddev_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Stddev_Pop_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Stddev_Samp_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dispositions_portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispositions_Portfolio_Home_Disposition_Bids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispositions_Portfolio_Home_Disposition_Bids_Stream_Cursor_Value_Input = {
  agent_id?: InputMaybe<Scalars['uuid']['input']>;
  bid_expiration_date?: InputMaybe<Scalars['date']['input']>;
  bid_price?: InputMaybe<Scalars['numeric']['input']>;
  bid_received_date?: InputMaybe<Scalars['date']['input']>;
  bind_date?: InputMaybe<Scalars['date']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  closing_date?: InputMaybe<Scalars['date']['input']>;
  counterparty_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  due_diligence_end_date?: InputMaybe<Scalars['date']['input']>;
  due_diligence_start_date?: InputMaybe<Scalars['date']['input']>;
  earnest_money_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_disposition_id?: InputMaybe<Scalars['uuid']['input']>;
  special_stipulations_note_id?: InputMaybe<Scalars['uuid']['input']>;
  terminated_date?: InputMaybe<Scalars['date']['input']>;
  total_sellers_credits?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Sum_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Var_Pop_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Var_Samp_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "dispositions.portfolio_home_disposition_bids" */
export type Dispositions_Portfolio_Home_Disposition_Bids_Variance_Order_By = {
  bid_price?: InputMaybe<Order_By>;
  earnest_money_amount?: InputMaybe<Order_By>;
  total_sellers_credits?: InputMaybe<Order_By>;
};

/** columns and relationships of "dispositions.portfolio_home_disposition_counterparties" */
export type Dispositions_Portfolio_Home_Disposition_Counterparties = {
  __typename: 'dispositions_portfolio_home_disposition_counterparties';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  portfolio_home_disposition_bids: Array<Dispositions_Portfolio_Home_Disposition_Bids>;
  tenant_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "dispositions.portfolio_home_disposition_counterparties" */
export type Dispositions_Portfolio_Home_Disposition_CounterpartiesPortfolio_Home_Disposition_BidsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "dispositions.portfolio_home_disposition_counterparties". All fields are combined with a logical 'AND'. */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp = {
  _and?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>>;
  _not?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>;
  _or?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  portfolio_home_disposition_bids?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
  tenant_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "dispositions.portfolio_home_disposition_counterparties" */
export enum Dispositions_Portfolio_Home_Disposition_Counterparties_Constraint {
  /** unique or primary key constraint on columns "name" */
  PortfolioHomeDispositionCounterpartiesNameKey = 'portfolio_home_disposition_counterparties_name_key',
  /** unique or primary key constraint on columns "id" */
  PortfolioHomeDispositionCounterpartiesPkey = 'portfolio_home_disposition_counterparties_pkey'
}

/** input type for inserting data into table "dispositions.portfolio_home_disposition_counterparties" */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "dispositions.portfolio_home_disposition_counterparties" */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_Mutation_Response = {
  __typename: 'dispositions_portfolio_home_disposition_counterparties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispositions_Portfolio_Home_Disposition_Counterparties>;
};

/** on_conflict condition type for table "dispositions.portfolio_home_disposition_counterparties" */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_On_Conflict = {
  constraint: Dispositions_Portfolio_Home_Disposition_Counterparties_Constraint;
  update_columns?: Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Update_Column>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>;
};

/** Ordering options when selecting data from "dispositions.portfolio_home_disposition_counterparties". */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  portfolio_home_disposition_bids_aggregate?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Aggregate_Order_By>;
  tenant_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "dispositions.portfolio_home_disposition_counterparties" */
export enum Dispositions_Portfolio_Home_Disposition_Counterparties_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantUserId = 'tenant_user_id'
}

/** Streaming cursor of the table "dispositions_portfolio_home_disposition_counterparties" */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispositions_Portfolio_Home_Disposition_Counterparties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispositions_Portfolio_Home_Disposition_Counterparties_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "dispositions.portfolio_home_disposition_counterparties" (current role has no relevant permissions) */
export enum Dispositions_Portfolio_Home_Disposition_Counterparties_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "dispositions.portfolio_home_disposition_statuses" */
export type Dispositions_Portfolio_Home_Disposition_Statuses = {
  __typename: 'dispositions_portfolio_home_disposition_statuses';
  category: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "dispositions.portfolio_home_disposition_statuses". All fields are combined with a logical 'AND'. */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dispositions.portfolio_home_disposition_statuses" */
export enum Dispositions_Portfolio_Home_Disposition_Statuses_Constraint {
  /** unique or primary key constraint on columns "status" */
  PortfolioHomeDispositionStatusesPkey = 'portfolio_home_disposition_statuses_pkey'
}

/** input type for inserting data into table "dispositions.portfolio_home_disposition_statuses" */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "dispositions.portfolio_home_disposition_statuses" */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Mutation_Response = {
  __typename: 'dispositions_portfolio_home_disposition_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispositions_Portfolio_Home_Disposition_Statuses>;
};

/** input type for inserting object relation for remote table "dispositions.portfolio_home_disposition_statuses" */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Obj_Rel_Insert_Input = {
  data: Dispositions_Portfolio_Home_Disposition_Statuses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_On_Conflict>;
};

/** on_conflict condition type for table "dispositions.portfolio_home_disposition_statuses" */
export type Dispositions_Portfolio_Home_Disposition_Statuses_On_Conflict = {
  constraint: Dispositions_Portfolio_Home_Disposition_Statuses_Constraint;
  update_columns?: Array<Dispositions_Portfolio_Home_Disposition_Statuses_Update_Column>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "dispositions.portfolio_home_disposition_statuses". */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Order_By = {
  category?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "dispositions.portfolio_home_disposition_statuses" */
export enum Dispositions_Portfolio_Home_Disposition_Statuses_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "dispositions_portfolio_home_disposition_statuses" */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispositions_Portfolio_Home_Disposition_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispositions_Portfolio_Home_Disposition_Statuses_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "dispositions.portfolio_home_disposition_statuses" (current role has no relevant permissions) */
export enum Dispositions_Portfolio_Home_Disposition_Statuses_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions = {
  __typename: 'dispositions_portfolio_home_dispositions';
  /** An object relationship */
  accepted_bid?: Maybe<Dispositions_Portfolio_Home_Disposition_Bids>;
  accepted_bid_id?: Maybe<Scalars['uuid']['output']>;
  applied_wallet_option_amount?: Maybe<Scalars['numeric']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  canceled_by_admin?: Maybe<Admins>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  completed_by_admin?: Maybe<Admins>;
  completed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  construction_completion_date?: Maybe<Scalars['date']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_admin?: Maybe<Admins>;
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_staged?: Maybe<Scalars['Boolean']['output']>;
  mls_listing_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  /** An array relationship */
  portfolio_home_disposition_bids: Array<Dispositions_Portfolio_Home_Disposition_Bids>;
  /** An object relationship */
  portfolio_home_disposition_status: Dispositions_Portfolio_Home_Disposition_Statuses;
  portfolio_home_id: Scalars['uuid']['output'];
  sale_type?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  target_price?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_DispositionsPortfolio_Home_Disposition_BidsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
};

/** order by aggregate values of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Aggregate_Order_By = {
  avg?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Max_Order_By>;
  min?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Min_Order_By>;
  stddev?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Sum_Order_By>;
  var_pop?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Var_Samp_Order_By>;
  variance?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Variance_Order_By>;
};

/** order by avg() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Avg_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dispositions.portfolio_home_dispositions". All fields are combined with a logical 'AND'. */
export type Dispositions_Portfolio_Home_Dispositions_Bool_Exp = {
  _and?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>>;
  _not?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
  _or?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>>;
  accepted_bid?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
  accepted_bid_id?: InputMaybe<Uuid_Comparison_Exp>;
  applied_wallet_option_amount?: InputMaybe<Numeric_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin?: InputMaybe<Admins_Bool_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_by_admin?: InputMaybe<Admins_Bool_Exp>;
  completed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  construction_completion_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin?: InputMaybe<Admins_Bool_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_staged?: InputMaybe<Boolean_Comparison_Exp>;
  mls_listing_date?: InputMaybe<Date_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_disposition_bids?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
  portfolio_home_disposition_status?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dispositions.portfolio_home_dispositions" */
export enum Dispositions_Portfolio_Home_Dispositions_Constraint {
  /** unique or primary key constraint on columns "portfolio_home_id" */
  PortfolioHomeDispositionsOneNonCanceledPerHome = 'portfolio_home_dispositions_one_non_canceled_per_home',
  /** unique or primary key constraint on columns "id" */
  PortfolioHomeDispositionsPkey = 'portfolio_home_dispositions_pkey'
}

/** input type for incrementing numeric columns in table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Inc_Input = {
  applied_wallet_option_amount?: InputMaybe<Scalars['numeric']['input']>;
  target_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Insert_Input = {
  accepted_bid_id?: InputMaybe<Scalars['uuid']['input']>;
  applied_wallet_option_amount?: InputMaybe<Scalars['numeric']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  completed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  construction_completion_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_staged?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_date?: InputMaybe<Scalars['date']['input']>;
  portfolio_home_disposition_status?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Obj_Rel_Insert_Input>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_price?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Max_Order_By = {
  accepted_bid_id?: InputMaybe<Order_By>;
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  construction_completion_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_date?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  sale_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Min_Order_By = {
  accepted_bid_id?: InputMaybe<Order_By>;
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  construction_completion_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_date?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  sale_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Mutation_Response = {
  __typename: 'dispositions_portfolio_home_dispositions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispositions_Portfolio_Home_Dispositions>;
};

/** on_conflict condition type for table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_On_Conflict = {
  constraint: Dispositions_Portfolio_Home_Dispositions_Constraint;
  update_columns?: Array<Dispositions_Portfolio_Home_Dispositions_Update_Column>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
};

/** Ordering options when selecting data from "dispositions.portfolio_home_dispositions". */
export type Dispositions_Portfolio_Home_Dispositions_Order_By = {
  accepted_bid?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Order_By>;
  accepted_bid_id?: InputMaybe<Order_By>;
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin?: InputMaybe<Admins_Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin?: InputMaybe<Admins_Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  construction_completion_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin?: InputMaybe<Admins_Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_staged?: InputMaybe<Order_By>;
  mls_listing_date?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_disposition_bids_aggregate?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Aggregate_Order_By>;
  portfolio_home_disposition_status?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  sale_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dispositions.portfolio_home_dispositions */
export type Dispositions_Portfolio_Home_Dispositions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dispositions.portfolio_home_dispositions" */
export enum Dispositions_Portfolio_Home_Dispositions_Select_Column {
  /** column name */
  AcceptedBidId = 'accepted_bid_id',
  /** column name */
  AppliedWalletOptionAmount = 'applied_wallet_option_amount',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletedByAdminId = 'completed_by_admin_id',
  /** column name */
  ConstructionCompletionDate = 'construction_completion_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsStaged = 'is_staged',
  /** column name */
  MlsListingDate = 'mls_listing_date',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  SaleType = 'sale_type',
  /** column name */
  Status = 'status',
  /** column name */
  TargetPrice = 'target_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Set_Input = {
  accepted_bid_id?: InputMaybe<Scalars['uuid']['input']>;
  applied_wallet_option_amount?: InputMaybe<Scalars['numeric']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  construction_completion_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_staged?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_date?: InputMaybe<Scalars['date']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_price?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Stddev_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Stddev_Pop_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Stddev_Samp_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dispositions_portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispositions_Portfolio_Home_Dispositions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispositions_Portfolio_Home_Dispositions_Stream_Cursor_Value_Input = {
  accepted_bid_id?: InputMaybe<Scalars['uuid']['input']>;
  applied_wallet_option_amount?: InputMaybe<Scalars['numeric']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  construction_completion_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_staged?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_date?: InputMaybe<Scalars['date']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_price?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Sum_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** update columns of table "dispositions.portfolio_home_dispositions" */
export enum Dispositions_Portfolio_Home_Dispositions_Update_Column {
  /** column name */
  AcceptedBidId = 'accepted_bid_id',
  /** column name */
  AppliedWalletOptionAmount = 'applied_wallet_option_amount',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletedByAdminId = 'completed_by_admin_id',
  /** column name */
  ConstructionCompletionDate = 'construction_completion_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsStaged = 'is_staged',
  /** column name */
  MlsListingDate = 'mls_listing_date',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  SaleType = 'sale_type',
  /** column name */
  Status = 'status',
  /** column name */
  TargetPrice = 'target_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Dispositions_Portfolio_Home_Dispositions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Set_Input>;
  where: Dispositions_Portfolio_Home_Dispositions_Bool_Exp;
};

/** order by var_pop() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Var_Pop_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Var_Samp_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "dispositions.portfolio_home_dispositions" */
export type Dispositions_Portfolio_Home_Dispositions_Variance_Order_By = {
  applied_wallet_option_amount?: InputMaybe<Order_By>;
  target_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "documents" */
export type Documents = {
  __typename: 'documents';
  /** An object relationship */
  admin?: Maybe<Admins>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  credit_reports: Array<Credit_Reports>;
  /** An array relationship */
  criminal_reports: Array<Criminal_Reports>;
  /** An array relationship */
  eviction_reports: Array<Eviction_Reports>;
  external_id: Scalars['String']['output'];
  external_source: Scalars['String']['output'];
  friendly_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_publicly_viewable?: Maybe<Scalars['Boolean']['output']>;
  resource_id: Scalars['uuid']['output'];
  resource_notes?: Maybe<Scalars['String']['output']>;
  resource_type: Scalars['String']['output'];
  review_notes?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploaded_by_admin?: Maybe<Admins>;
  uploaded_by_admin_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "documents" */
export type DocumentsCredit_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Reports_Order_By>>;
  where?: InputMaybe<Credit_Reports_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsCriminal_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Criminal_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criminal_Reports_Order_By>>;
  where?: InputMaybe<Criminal_Reports_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsEviction_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Reports_Order_By>>;
  where?: InputMaybe<Eviction_Reports_Bool_Exp>;
};

/** order by aggregate values of table "documents" */
export type Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Documents_Max_Order_By>;
  min?: InputMaybe<Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "documents" */
export type Documents_Arr_Rel_Insert_Input = {
  data: Array<Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Documents_Bool_Exp>>;
  _not?: InputMaybe<Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Documents_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_reports?: InputMaybe<Credit_Reports_Bool_Exp>;
  criminal_reports?: InputMaybe<Criminal_Reports_Bool_Exp>;
  eviction_reports?: InputMaybe<Eviction_Reports_Bool_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  friendly_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_publicly_viewable?: InputMaybe<Boolean_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_notes?: InputMaybe<String_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  review_notes?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_by_admin?: InputMaybe<Admins_Bool_Exp>;
  uploaded_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey',
  /** unique or primary key constraint on columns "resource_type", "resource_id" */
  UniqueDocumentsResourceIdResourceTypeAgreements = 'unique_documents_resource_id_resource_type_agreements'
}

/** input type for inserting data into table "documents" */
export type Documents_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  friendly_name?: InputMaybe<Scalars['String']['input']>;
  is_publicly_viewable?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_notes?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploaded_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  uploaded_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "documents" */
export type Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by_admin_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "documents" */
export type Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by_admin_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "documents" */
export type Documents_Mutation_Response = {
  __typename: 'documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** on_conflict condition type for table "documents" */
export type Documents_On_Conflict = {
  constraint: Documents_Constraint;
  update_columns?: Array<Documents_Update_Column>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "documents". */
export type Documents_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_reports_aggregate?: InputMaybe<Credit_Reports_Aggregate_Order_By>;
  criminal_reports_aggregate?: InputMaybe<Criminal_Reports_Aggregate_Order_By>;
  eviction_reports_aggregate?: InputMaybe<Eviction_Reports_Aggregate_Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_publicly_viewable?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by_admin?: InputMaybe<Admins_Order_By>;
  uploaded_by_admin_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: documents */
export type Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsPubliclyViewable = 'is_publicly_viewable',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceNotes = 'resource_notes',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ReviewNotes = 'review_notes',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedByAdminId = 'uploaded_by_admin_id'
}

/** input type for updating data in table "documents" */
export type Documents_Set_Input = {
  friendly_name?: InputMaybe<Scalars['String']['input']>;
  resource_notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "documents" */
export type Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  friendly_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_publicly_viewable?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_notes?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  ResourceNotes = 'resource_notes',
  /** column name */
  Status = 'status'
}

export type Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};

/** columns and relationships of "down_status_incidents" */
export type Down_Status_Incidents = {
  __typename: 'down_status_incidents';
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  resolution_reason?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  resolved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  stage: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "down_status_incidents" */
export type Down_Status_Incidents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Down_Status_Incidents_Max_Order_By>;
  min?: InputMaybe<Down_Status_Incidents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "down_status_incidents". All fields are combined with a logical 'AND'. */
export type Down_Status_Incidents_Bool_Exp = {
  _and?: InputMaybe<Array<Down_Status_Incidents_Bool_Exp>>;
  _not?: InputMaybe<Down_Status_Incidents_Bool_Exp>;
  _or?: InputMaybe<Array<Down_Status_Incidents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  resolution_reason?: InputMaybe<String_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resolved_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "down_status_incidents" */
export type Down_Status_Incidents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  resolution_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "down_status_incidents" */
export type Down_Status_Incidents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  resolution_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "down_status_incidents". */
export type Down_Status_Incidents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  resolution_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "down_status_incidents" */
export enum Down_Status_Incidents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  ResolutionReason = 'resolution_reason',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedByAdminId = 'resolved_by_admin_id',
  /** column name */
  Stage = 'stage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "down_status_incidents" */
export type Down_Status_Incidents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Down_Status_Incidents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Down_Status_Incidents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  resolution_reason?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eviction_filing_fees" */
export type Eviction_Filing_Fees = {
  __typename: 'eviction_filing_fees';
  charged_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  charged_by_admin: Admins;
  charged_by_admin_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  eviction: Evictions;
  eviction_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_liability: Rental_Liabilities;
  rental_liability_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "eviction_filing_fees" */
export type Eviction_Filing_Fees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eviction_Filing_Fees_Max_Order_By>;
  min?: InputMaybe<Eviction_Filing_Fees_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "eviction_filing_fees". All fields are combined with a logical 'AND'. */
export type Eviction_Filing_Fees_Bool_Exp = {
  _and?: InputMaybe<Array<Eviction_Filing_Fees_Bool_Exp>>;
  _not?: InputMaybe<Eviction_Filing_Fees_Bool_Exp>;
  _or?: InputMaybe<Array<Eviction_Filing_Fees_Bool_Exp>>;
  charged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  charged_by_admin?: InputMaybe<Admins_Bool_Exp>;
  charged_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eviction?: InputMaybe<Evictions_Bool_Exp>;
  eviction_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_liability?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  rental_liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "eviction_filing_fees" */
export type Eviction_Filing_Fees_Max_Order_By = {
  charged_at?: InputMaybe<Order_By>;
  charged_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eviction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "eviction_filing_fees" */
export type Eviction_Filing_Fees_Min_Order_By = {
  charged_at?: InputMaybe<Order_By>;
  charged_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eviction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "eviction_filing_fees". */
export type Eviction_Filing_Fees_Order_By = {
  charged_at?: InputMaybe<Order_By>;
  charged_by_admin?: InputMaybe<Admins_Order_By>;
  charged_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eviction?: InputMaybe<Evictions_Order_By>;
  eviction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_liability?: InputMaybe<Rental_Liabilities_Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "eviction_filing_fees" */
export enum Eviction_Filing_Fees_Select_Column {
  /** column name */
  ChargedAt = 'charged_at',
  /** column name */
  ChargedByAdminId = 'charged_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvictionId = 'eviction_id',
  /** column name */
  Id = 'id',
  /** column name */
  RentalLiabilityId = 'rental_liability_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "eviction_filing_fees" */
export type Eviction_Filing_Fees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eviction_Filing_Fees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eviction_Filing_Fees_Stream_Cursor_Value_Input = {
  charged_at?: InputMaybe<Scalars['timestamptz']['input']>;
  charged_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eviction_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_liability_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eviction_reports" */
export type Eviction_Reports = {
  __typename: 'eviction_reports';
  created_at: Scalars['timestamptz']['output'];
  document_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  matches?: Maybe<Scalars['jsonb']['output']>;
  provider: Scalars['String']['output'];
  provider_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eviction_reports" */
export type Eviction_ReportsMatchesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "eviction_reports" */
export type Eviction_Reports_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eviction_Reports_Max_Order_By>;
  min?: InputMaybe<Eviction_Reports_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "eviction_reports". All fields are combined with a logical 'AND'. */
export type Eviction_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Eviction_Reports_Bool_Exp>>;
  _not?: InputMaybe<Eviction_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Eviction_Reports_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  matches?: InputMaybe<Jsonb_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "eviction_reports" */
export type Eviction_Reports_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "eviction_reports" */
export type Eviction_Reports_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "eviction_reports". */
export type Eviction_Reports_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matches?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "eviction_reports" */
export enum Eviction_Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Matches = 'matches',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "eviction_reports" */
export type Eviction_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eviction_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eviction_Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  matches?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "evictions" */
export type Evictions = {
  __typename: 'evictions';
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  canceled_by_admin?: Maybe<Admins>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  completed_by_admin?: Maybe<Admins>;
  completed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  consent_judgement?: Maybe<Scalars['Boolean']['output']>;
  court_date?: Maybe<Scalars['date']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  eviction_filing_fees: Array<Eviction_Filing_Fees>;
  file_sent_to_attorney_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  file_sent_to_attorney_by_admin?: Maybe<Admins>;
  file_sent_to_attorney_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  filed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  filed_by_admin?: Maybe<Admins>;
  filed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Notes>;
  projected_possession_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_id: Scalars['uuid']['output'];
  set_out_date?: Maybe<Scalars['date']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  writ_date?: Maybe<Scalars['date']['output']>;
};


/** columns and relationships of "evictions" */
export type EvictionsEviction_Filing_FeesArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Filing_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Filing_Fees_Order_By>>;
  where?: InputMaybe<Eviction_Filing_Fees_Bool_Exp>;
};


/** columns and relationships of "evictions" */
export type EvictionsNotesArgs = {
  distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notes_Order_By>>;
  where?: InputMaybe<Notes_Bool_Exp>;
};

/** order by aggregate values of table "evictions" */
export type Evictions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Evictions_Max_Order_By>;
  min?: InputMaybe<Evictions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "evictions". All fields are combined with a logical 'AND'. */
export type Evictions_Bool_Exp = {
  _and?: InputMaybe<Array<Evictions_Bool_Exp>>;
  _not?: InputMaybe<Evictions_Bool_Exp>;
  _or?: InputMaybe<Array<Evictions_Bool_Exp>>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin?: InputMaybe<Admins_Bool_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_by_admin?: InputMaybe<Admins_Bool_Exp>;
  completed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  consent_judgement?: InputMaybe<Boolean_Comparison_Exp>;
  court_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eviction_filing_fees?: InputMaybe<Eviction_Filing_Fees_Bool_Exp>;
  file_sent_to_attorney_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_sent_to_attorney_by_admin?: InputMaybe<Admins_Bool_Exp>;
  file_sent_to_attorney_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  filed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  filed_by_admin?: InputMaybe<Admins_Bool_Exp>;
  filed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Notes_Bool_Exp>;
  projected_possession_date?: InputMaybe<Date_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  set_out_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  writ_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "evictions" */
export type Evictions_Max_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  court_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_sent_to_attorney_at?: InputMaybe<Order_By>;
  file_sent_to_attorney_by_admin_id?: InputMaybe<Order_By>;
  filed_at?: InputMaybe<Order_By>;
  filed_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projected_possession_date?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  set_out_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  writ_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "evictions" */
export type Evictions_Min_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  court_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_sent_to_attorney_at?: InputMaybe<Order_By>;
  file_sent_to_attorney_by_admin_id?: InputMaybe<Order_By>;
  filed_at?: InputMaybe<Order_By>;
  filed_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projected_possession_date?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  set_out_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  writ_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "evictions" */
export type Evictions_Mutation_Response = {
  __typename: 'evictions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evictions>;
};

/** Ordering options when selecting data from "evictions". */
export type Evictions_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin?: InputMaybe<Admins_Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin?: InputMaybe<Admins_Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  consent_judgement?: InputMaybe<Order_By>;
  court_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eviction_filing_fees_aggregate?: InputMaybe<Eviction_Filing_Fees_Aggregate_Order_By>;
  file_sent_to_attorney_at?: InputMaybe<Order_By>;
  file_sent_to_attorney_by_admin?: InputMaybe<Admins_Order_By>;
  file_sent_to_attorney_by_admin_id?: InputMaybe<Order_By>;
  filed_at?: InputMaybe<Order_By>;
  filed_by_admin?: InputMaybe<Admins_Order_By>;
  filed_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Notes_Aggregate_Order_By>;
  projected_possession_date?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  set_out_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  writ_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evictions */
export type Evictions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "evictions" */
export enum Evictions_Select_Column {
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletedByAdminId = 'completed_by_admin_id',
  /** column name */
  ConsentJudgement = 'consent_judgement',
  /** column name */
  CourtDate = 'court_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileSentToAttorneyAt = 'file_sent_to_attorney_at',
  /** column name */
  FileSentToAttorneyByAdminId = 'file_sent_to_attorney_by_admin_id',
  /** column name */
  FiledAt = 'filed_at',
  /** column name */
  FiledByAdminId = 'filed_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectedPossessionDate = 'projected_possession_date',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SetOutDate = 'set_out_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WritDate = 'writ_date'
}

/** input type for updating data in table "evictions" */
export type Evictions_Set_Input = {
  consent_judgement?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "evictions" */
export type Evictions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Evictions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Evictions_Stream_Cursor_Value_Input = {
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  consent_judgement?: InputMaybe<Scalars['Boolean']['input']>;
  court_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_sent_to_attorney_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_sent_to_attorney_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  filed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projected_possession_date?: InputMaybe<Scalars['date']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  set_out_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  writ_date?: InputMaybe<Scalars['date']['input']>;
};

export type Evictions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evictions_Set_Input>;
  where: Evictions_Bool_Exp;
};

/** columns and relationships of "fund_llcs" */
export type Fund_Llcs = {
  __typename: 'fund_llcs';
  created_at: Scalars['timestamptz']['output'];
  end_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  fund: Funds;
  fund_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  llc: Llcs;
  llc_id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "fund_llcs" */
export type Fund_Llcs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fund_Llcs_Max_Order_By>;
  min?: InputMaybe<Fund_Llcs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "fund_llcs". All fields are combined with a logical 'AND'. */
export type Fund_Llcs_Bool_Exp = {
  _and?: InputMaybe<Array<Fund_Llcs_Bool_Exp>>;
  _not?: InputMaybe<Fund_Llcs_Bool_Exp>;
  _or?: InputMaybe<Array<Fund_Llcs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  fund?: InputMaybe<Funds_Bool_Exp>;
  fund_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llc?: InputMaybe<Llcs_Bool_Exp>;
  llc_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "fund_llcs" */
export type Fund_Llcs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  fund_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llc_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fund_llcs" */
export type Fund_Llcs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  fund_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llc_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fund_llcs". */
export type Fund_Llcs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  fund?: InputMaybe<Funds_Order_By>;
  fund_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llc?: InputMaybe<Llcs_Order_By>;
  llc_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "fund_llcs" */
export enum Fund_Llcs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FundId = 'fund_id',
  /** column name */
  Id = 'id',
  /** column name */
  LlcId = 'llc_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "fund_llcs" */
export type Fund_Llcs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fund_Llcs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fund_Llcs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  fund_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  llc_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "fund_rental_program_configs" */
export type Fund_Rental_Program_Configs = {
  __typename: 'fund_rental_program_configs';
  additional_deposit_rent_multiple: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  fund_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  minimum_credit_score: Scalars['Int']['output'];
  minimum_credit_score_with_additional_deposit: Scalars['Int']['output'];
  rental_program_type: Rental_Program_Types_Enum_Enum;
  standard_deposit_rent_multiple: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "fund_rental_program_configs". All fields are combined with a logical 'AND'. */
export type Fund_Rental_Program_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Fund_Rental_Program_Configs_Bool_Exp>>;
  _not?: InputMaybe<Fund_Rental_Program_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Fund_Rental_Program_Configs_Bool_Exp>>;
  additional_deposit_rent_multiple?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fund_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  minimum_credit_score?: InputMaybe<Int_Comparison_Exp>;
  minimum_credit_score_with_additional_deposit?: InputMaybe<Int_Comparison_Exp>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum_Comparison_Exp>;
  standard_deposit_rent_multiple?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "fund_rental_program_configs". */
export type Fund_Rental_Program_Configs_Order_By = {
  additional_deposit_rent_multiple?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fund_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimum_credit_score?: InputMaybe<Order_By>;
  minimum_credit_score_with_additional_deposit?: InputMaybe<Order_By>;
  rental_program_type?: InputMaybe<Order_By>;
  standard_deposit_rent_multiple?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "fund_rental_program_configs" */
export enum Fund_Rental_Program_Configs_Select_Column {
  /** column name */
  AdditionalDepositRentMultiple = 'additional_deposit_rent_multiple',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FundId = 'fund_id',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumCreditScore = 'minimum_credit_score',
  /** column name */
  MinimumCreditScoreWithAdditionalDeposit = 'minimum_credit_score_with_additional_deposit',
  /** column name */
  RentalProgramType = 'rental_program_type',
  /** column name */
  StandardDepositRentMultiple = 'standard_deposit_rent_multiple',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "fund_rental_program_configs" */
export type Fund_Rental_Program_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fund_Rental_Program_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fund_Rental_Program_Configs_Stream_Cursor_Value_Input = {
  additional_deposit_rent_multiple?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fund_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimum_credit_score?: InputMaybe<Scalars['Int']['input']>;
  minimum_credit_score_with_additional_deposit?: InputMaybe<Scalars['Int']['input']>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  standard_deposit_rent_multiple?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "funds" */
export type Funds = {
  __typename: 'funds';
  abbreviation?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  fund_llcs: Array<Fund_Llcs>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "funds" */
export type FundsFund_LlcsArgs = {
  distinct_on?: InputMaybe<Array<Fund_Llcs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fund_Llcs_Order_By>>;
  where?: InputMaybe<Fund_Llcs_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "funds". All fields are combined with a logical 'AND'. */
export type Funds_Bool_Exp = {
  _and?: InputMaybe<Array<Funds_Bool_Exp>>;
  _not?: InputMaybe<Funds_Bool_Exp>;
  _or?: InputMaybe<Array<Funds_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fund_llcs?: InputMaybe<Fund_Llcs_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "funds". */
export type Funds_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fund_llcs_aggregate?: InputMaybe<Fund_Llcs_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "funds" */
export enum Funds_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "funds" */
export type Funds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funds_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

/** columns and relationships of "home_construction_status_enum" */
export type Home_Construction_Status_Enum = {
  __typename: 'home_construction_status_enum';
  status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "home_construction_status_enum". All fields are combined with a logical 'AND'. */
export type Home_Construction_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Construction_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Home_Construction_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Construction_Status_Enum_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

export enum Home_Construction_Status_Enum_Enum {
  AwaitingStart = 'awaiting_start',
  Canceled = 'canceled',
  InProgress = 'in_progress',
  None = 'none',
  PendingReview = 'pending_review',
  PendingWalkthrough = 'pending_walkthrough',
  QualityCheck = 'quality_check',
  RentReady = 'rent_ready',
  TerminationRequested = 'termination_requested'
}

/** Boolean expression to compare columns of type "home_construction_status_enum_enum". All fields are combined with logical 'AND'. */
export type Home_Construction_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Home_Construction_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Home_Construction_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Home_Construction_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Home_Construction_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "home_construction_status_enum". */
export type Home_Construction_Status_Enum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_construction_status_enum" */
export enum Home_Construction_Status_Enum_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_construction_status_enum" */
export type Home_Construction_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Construction_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Construction_Status_Enum_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "home_construction_statuses" */
export type Home_Construction_Statuses = {
  __typename: 'home_construction_statuses';
  entered_status_at: Scalars['timestamptz']['output'];
  home_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  left_status_at?: Maybe<Scalars['timestamptz']['output']>;
  most_recent_construction_project_id?: Maybe<Scalars['uuid']['output']>;
  most_recent_construction_scope_id?: Maybe<Scalars['uuid']['output']>;
  old_status?: Maybe<Home_Construction_Status_Enum_Enum>;
  status: Home_Construction_Status_Enum_Enum;
};

/** Boolean expression to filter rows from the table "home_construction_statuses". All fields are combined with a logical 'AND'. */
export type Home_Construction_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Construction_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Home_Construction_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Construction_Statuses_Bool_Exp>>;
  entered_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  left_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  most_recent_construction_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  most_recent_construction_scope_id?: InputMaybe<Uuid_Comparison_Exp>;
  old_status?: InputMaybe<Home_Construction_Status_Enum_Enum_Comparison_Exp>;
  status?: InputMaybe<Home_Construction_Status_Enum_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "home_construction_statuses". */
export type Home_Construction_Statuses_Order_By = {
  entered_status_at?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_status_at?: InputMaybe<Order_By>;
  most_recent_construction_project_id?: InputMaybe<Order_By>;
  most_recent_construction_scope_id?: InputMaybe<Order_By>;
  old_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_construction_statuses" */
export enum Home_Construction_Statuses_Select_Column {
  /** column name */
  EnteredStatusAt = 'entered_status_at',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeftStatusAt = 'left_status_at',
  /** column name */
  MostRecentConstructionProjectId = 'most_recent_construction_project_id',
  /** column name */
  MostRecentConstructionScopeId = 'most_recent_construction_scope_id',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_construction_statuses" */
export type Home_Construction_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Construction_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Construction_Statuses_Stream_Cursor_Value_Input = {
  entered_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  left_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  most_recent_construction_project_id?: InputMaybe<Scalars['uuid']['input']>;
  most_recent_construction_scope_id?: InputMaybe<Scalars['uuid']['input']>;
  old_status?: InputMaybe<Home_Construction_Status_Enum_Enum>;
  status?: InputMaybe<Home_Construction_Status_Enum_Enum>;
};

/** columns and relationships of "home_occupancy_status_enum" */
export type Home_Occupancy_Status_Enum = {
  __typename: 'home_occupancy_status_enum';
  status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "home_occupancy_status_enum". All fields are combined with a logical 'AND'. */
export type Home_Occupancy_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Occupancy_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Home_Occupancy_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Occupancy_Status_Enum_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

export enum Home_Occupancy_Status_Enum_Enum {
  Eviction = 'eviction',
  Hold = 'hold',
  Holdover = 'holdover',
  NoticeLeased = 'notice_leased',
  NoticeUnleased = 'notice_unleased',
  Standard = 'standard',
  VacantLeased = 'vacant_leased',
  VacantUnleased = 'vacant_unleased'
}

/** Boolean expression to compare columns of type "home_occupancy_status_enum_enum". All fields are combined with logical 'AND'. */
export type Home_Occupancy_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Home_Occupancy_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Home_Occupancy_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Home_Occupancy_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Home_Occupancy_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "home_occupancy_status_enum". */
export type Home_Occupancy_Status_Enum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_occupancy_status_enum" */
export enum Home_Occupancy_Status_Enum_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_occupancy_status_enum" */
export type Home_Occupancy_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Occupancy_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Occupancy_Status_Enum_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "home_occupancy_statuses" */
export type Home_Occupancy_Statuses = {
  __typename: 'home_occupancy_statuses';
  entered_status_at: Scalars['timestamptz']['output'];
  home_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  left_status_at?: Maybe<Scalars['timestamptz']['output']>;
  most_recent_rental_agreement_id?: Maybe<Scalars['uuid']['output']>;
  most_recent_rental_id?: Maybe<Scalars['uuid']['output']>;
  next_rental_id?: Maybe<Scalars['uuid']['output']>;
  old_status?: Maybe<Home_Occupancy_Status_Enum_Enum>;
  portfolio_home_id?: Maybe<Scalars['uuid']['output']>;
  status: Home_Occupancy_Status_Enum_Enum;
};

/** Boolean expression to filter rows from the table "home_occupancy_statuses". All fields are combined with a logical 'AND'. */
export type Home_Occupancy_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Occupancy_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Home_Occupancy_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Occupancy_Statuses_Bool_Exp>>;
  entered_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  left_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  most_recent_rental_agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  most_recent_rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  next_rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  old_status?: InputMaybe<Home_Occupancy_Status_Enum_Enum_Comparison_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Home_Occupancy_Status_Enum_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "home_occupancy_statuses". */
export type Home_Occupancy_Statuses_Order_By = {
  entered_status_at?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_status_at?: InputMaybe<Order_By>;
  most_recent_rental_agreement_id?: InputMaybe<Order_By>;
  most_recent_rental_id?: InputMaybe<Order_By>;
  next_rental_id?: InputMaybe<Order_By>;
  old_status?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_occupancy_statuses" */
export enum Home_Occupancy_Statuses_Select_Column {
  /** column name */
  EnteredStatusAt = 'entered_status_at',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeftStatusAt = 'left_status_at',
  /** column name */
  MostRecentRentalAgreementId = 'most_recent_rental_agreement_id',
  /** column name */
  MostRecentRentalId = 'most_recent_rental_id',
  /** column name */
  NextRentalId = 'next_rental_id',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_occupancy_statuses" */
export type Home_Occupancy_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Occupancy_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Occupancy_Statuses_Stream_Cursor_Value_Input = {
  entered_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  left_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  most_recent_rental_agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  most_recent_rental_id?: InputMaybe<Scalars['uuid']['input']>;
  next_rental_id?: InputMaybe<Scalars['uuid']['input']>;
  old_status?: InputMaybe<Home_Occupancy_Status_Enum_Enum>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Home_Occupancy_Status_Enum_Enum>;
};

/** columns and relationships of "home_ownership_status_enum" */
export type Home_Ownership_Status_Enum = {
  __typename: 'home_ownership_status_enum';
  status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "home_ownership_status_enum". All fields are combined with a logical 'AND'. */
export type Home_Ownership_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Ownership_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Home_Ownership_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Ownership_Status_Enum_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

export enum Home_Ownership_Status_Enum_Enum {
  Bidding = 'bidding',
  Closing = 'closing',
  Diligence = 'diligence',
  Disposing = 'disposing',
  NotOwned = 'not_owned',
  Owned = 'owned',
  Screening = 'screening',
  Sold = 'sold',
  Terminated = 'terminated'
}

/** Boolean expression to compare columns of type "home_ownership_status_enum_enum". All fields are combined with logical 'AND'. */
export type Home_Ownership_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Home_Ownership_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Home_Ownership_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Home_Ownership_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Home_Ownership_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "home_ownership_status_enum". */
export type Home_Ownership_Status_Enum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_ownership_status_enum" */
export enum Home_Ownership_Status_Enum_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_ownership_status_enum" */
export type Home_Ownership_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Ownership_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Ownership_Status_Enum_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "home_ownership_statuses" */
export type Home_Ownership_Statuses = {
  __typename: 'home_ownership_statuses';
  bid_id?: Maybe<Scalars['uuid']['output']>;
  entered_status_at: Scalars['timestamptz']['output'];
  home_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  left_status_at?: Maybe<Scalars['timestamptz']['output']>;
  old_status?: Maybe<Home_Ownership_Status_Enum_Enum>;
  portfolio_home_disposition_id?: Maybe<Scalars['uuid']['output']>;
  portfolio_home_id?: Maybe<Scalars['uuid']['output']>;
  real_estate_acquisition_id?: Maybe<Scalars['uuid']['output']>;
  real_estate_screening_id?: Maybe<Scalars['uuid']['output']>;
  status: Home_Ownership_Status_Enum_Enum;
};

/** order by aggregate values of table "home_ownership_statuses" */
export type Home_Ownership_Statuses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Home_Ownership_Statuses_Max_Order_By>;
  min?: InputMaybe<Home_Ownership_Statuses_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "home_ownership_statuses". All fields are combined with a logical 'AND'. */
export type Home_Ownership_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Ownership_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Home_Ownership_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Ownership_Statuses_Bool_Exp>>;
  bid_id?: InputMaybe<Uuid_Comparison_Exp>;
  entered_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  left_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  old_status?: InputMaybe<Home_Ownership_Status_Enum_Enum_Comparison_Exp>;
  portfolio_home_disposition_id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  real_estate_acquisition_id?: InputMaybe<Uuid_Comparison_Exp>;
  real_estate_screening_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Home_Ownership_Status_Enum_Enum_Comparison_Exp>;
};

/** order by max() on columns of table "home_ownership_statuses" */
export type Home_Ownership_Statuses_Max_Order_By = {
  bid_id?: InputMaybe<Order_By>;
  entered_status_at?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_status_at?: InputMaybe<Order_By>;
  portfolio_home_disposition_id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "home_ownership_statuses" */
export type Home_Ownership_Statuses_Min_Order_By = {
  bid_id?: InputMaybe<Order_By>;
  entered_status_at?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_status_at?: InputMaybe<Order_By>;
  portfolio_home_disposition_id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "home_ownership_statuses". */
export type Home_Ownership_Statuses_Order_By = {
  bid_id?: InputMaybe<Order_By>;
  entered_status_at?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_status_at?: InputMaybe<Order_By>;
  old_status?: InputMaybe<Order_By>;
  portfolio_home_disposition_id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_ownership_statuses" */
export enum Home_Ownership_Statuses_Select_Column {
  /** column name */
  BidId = 'bid_id',
  /** column name */
  EnteredStatusAt = 'entered_status_at',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeftStatusAt = 'left_status_at',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  PortfolioHomeDispositionId = 'portfolio_home_disposition_id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  RealEstateAcquisitionId = 'real_estate_acquisition_id',
  /** column name */
  RealEstateScreeningId = 'real_estate_screening_id',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_ownership_statuses" */
export type Home_Ownership_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Ownership_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Ownership_Statuses_Stream_Cursor_Value_Input = {
  bid_id?: InputMaybe<Scalars['uuid']['input']>;
  entered_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  left_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  old_status?: InputMaybe<Home_Ownership_Status_Enum_Enum>;
  portfolio_home_disposition_id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  real_estate_acquisition_id?: InputMaybe<Scalars['uuid']['input']>;
  real_estate_screening_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Home_Ownership_Status_Enum_Enum>;
};

/** columns and relationships of "home_summary_status_enum" */
export type Home_Summary_Status_Enum = {
  __typename: 'home_summary_status_enum';
  status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "home_summary_status_enum". All fields are combined with a logical 'AND'. */
export type Home_Summary_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Summary_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Home_Summary_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Summary_Status_Enum_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

export enum Home_Summary_Status_Enum_Enum {
  Acquiring = 'acquiring',
  AcquisitionTerminated = 'acquisition_terminated',
  NotOwned = 'not_owned',
  NotReadyLeased = 'not_ready_leased',
  NotReadyUnleased = 'not_ready_unleased',
  OccupiedEviction = 'occupied_eviction',
  OccupiedHoldover = 'occupied_holdover',
  OccupiedNotice = 'occupied_notice',
  OccupiedStandard = 'occupied_standard',
  RentReadyLeased = 'rent_ready_leased',
  RentReadyUnleased = 'rent_ready_unleased',
  Sold = 'sold',
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "home_summary_status_enum_enum". All fields are combined with logical 'AND'. */
export type Home_Summary_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Home_Summary_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Home_Summary_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Home_Summary_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Home_Summary_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "home_summary_status_enum". */
export type Home_Summary_Status_Enum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_summary_status_enum" */
export enum Home_Summary_Status_Enum_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_summary_status_enum" */
export type Home_Summary_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Summary_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Summary_Status_Enum_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "home_summary_statuses" */
export type Home_Summary_Statuses = {
  __typename: 'home_summary_statuses';
  construction_status_id?: Maybe<Scalars['uuid']['output']>;
  entered_status_at: Scalars['timestamptz']['output'];
  home_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  left_status_at?: Maybe<Scalars['timestamptz']['output']>;
  occupancy_status_id?: Maybe<Scalars['uuid']['output']>;
  old_status?: Maybe<Home_Summary_Status_Enum_Enum>;
  ownership_status_id?: Maybe<Scalars['uuid']['output']>;
  status: Home_Summary_Status_Enum_Enum;
};

/** Boolean expression to filter rows from the table "home_summary_statuses". All fields are combined with a logical 'AND'. */
export type Home_Summary_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Home_Summary_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Home_Summary_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Home_Summary_Statuses_Bool_Exp>>;
  construction_status_id?: InputMaybe<Uuid_Comparison_Exp>;
  entered_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  left_status_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  occupancy_status_id?: InputMaybe<Uuid_Comparison_Exp>;
  old_status?: InputMaybe<Home_Summary_Status_Enum_Enum_Comparison_Exp>;
  ownership_status_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Home_Summary_Status_Enum_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "home_summary_statuses". */
export type Home_Summary_Statuses_Order_By = {
  construction_status_id?: InputMaybe<Order_By>;
  entered_status_at?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  left_status_at?: InputMaybe<Order_By>;
  occupancy_status_id?: InputMaybe<Order_By>;
  old_status?: InputMaybe<Order_By>;
  ownership_status_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "home_summary_statuses" */
export enum Home_Summary_Statuses_Select_Column {
  /** column name */
  ConstructionStatusId = 'construction_status_id',
  /** column name */
  EnteredStatusAt = 'entered_status_at',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeftStatusAt = 'left_status_at',
  /** column name */
  OccupancyStatusId = 'occupancy_status_id',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  OwnershipStatusId = 'ownership_status_id',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "home_summary_statuses" */
export type Home_Summary_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Home_Summary_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Home_Summary_Statuses_Stream_Cursor_Value_Input = {
  construction_status_id?: InputMaybe<Scalars['uuid']['input']>;
  entered_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  left_status_at?: InputMaybe<Scalars['timestamptz']['input']>;
  occupancy_status_id?: InputMaybe<Scalars['uuid']['input']>;
  old_status?: InputMaybe<Home_Summary_Status_Enum_Enum>;
  ownership_status_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Home_Summary_Status_Enum_Enum>;
};

/** columns and relationships of "homes" */
export type Homes = {
  __typename: 'homes';
  /** An object relationship */
  address: Addresses;
  address_id: Scalars['uuid']['output'];
  baths_full: Scalars['Float']['output'];
  baths_half: Scalars['Float']['output'];
  baths_total: Scalars['Float']['output'];
  beds: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  market?: Maybe<Markets>;
  market_id: Scalars['uuid']['output'];
  /** An array relationship */
  opportunities: Array<Opportunities>;
  /** An array relationship */
  portfolio_homes: Array<Portfolio_Homes>;
  sqft?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  year_built?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "homes" */
export type HomesOpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<Opportunities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Opportunities_Order_By>>;
  where?: InputMaybe<Opportunities_Bool_Exp>;
};


/** columns and relationships of "homes" */
export type HomesPortfolio_HomesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Homes_Order_By>>;
  where?: InputMaybe<Portfolio_Homes_Bool_Exp>;
};

/** columns and relationships of "homes360" */
export type Homes360 = {
  __typename: 'homes360';
  address_id?: Maybe<Scalars['uuid']['output']>;
  baths_full?: Maybe<Scalars['Float']['output']>;
  baths_half?: Maybe<Scalars['Float']['output']>;
  baths_total?: Maybe<Scalars['Float']['output']>;
  beds?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Scalars['String']['output']>;
  display_line_1?: Maybe<Scalars['String']['output']>;
  display_line_2?: Maybe<Scalars['String']['output']>;
  disposition_date?: Maybe<Scalars['date']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  fund_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  market?: Maybe<Markets>;
  market_id?: Maybe<Scalars['uuid']['output']>;
  most_recent_rental_id?: Maybe<Scalars['uuid']['output']>;
  most_recent_rental_move_out_date?: Maybe<Scalars['date']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  occupancy_status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  opportunities: Array<Opportunities>;
  ownership_status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  portfolio_home?: Maybe<Portfolio_Homes>;
  portfolio_home_id?: Maybe<Scalars['uuid']['output']>;
  sqft?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  summary_status?: Maybe<Scalars['String']['output']>;
  tenant_first_name?: Maybe<Scalars['String']['output']>;
  tenant_last_name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  year_built?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "homes360" */
export type Homes360OpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<Opportunities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Opportunities_Order_By>>;
  where?: InputMaybe<Opportunities_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "homes360". All fields are combined with a logical 'AND'. */
export type Homes360_Bool_Exp = {
  _and?: InputMaybe<Array<Homes360_Bool_Exp>>;
  _not?: InputMaybe<Homes360_Bool_Exp>;
  _or?: InputMaybe<Array<Homes360_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  baths_full?: InputMaybe<Float_Comparison_Exp>;
  baths_half?: InputMaybe<Float_Comparison_Exp>;
  baths_total?: InputMaybe<Float_Comparison_Exp>;
  beds?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  construction_status?: InputMaybe<String_Comparison_Exp>;
  display_line_1?: InputMaybe<String_Comparison_Exp>;
  display_line_2?: InputMaybe<String_Comparison_Exp>;
  disposition_date?: InputMaybe<Date_Comparison_Exp>;
  entity_name?: InputMaybe<String_Comparison_Exp>;
  fund_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  long?: InputMaybe<Float_Comparison_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  most_recent_rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  most_recent_rental_move_out_date?: InputMaybe<Date_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  occupancy_status?: InputMaybe<String_Comparison_Exp>;
  opportunities?: InputMaybe<Opportunities_Bool_Exp>;
  ownership_status?: InputMaybe<String_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  sqft?: InputMaybe<Float_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  summary_status?: InputMaybe<String_Comparison_Exp>;
  tenant_first_name?: InputMaybe<String_Comparison_Exp>;
  tenant_last_name?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  year_built?: InputMaybe<Int_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "homes360". */
export type Homes360_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  construction_status?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  disposition_date?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  fund_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  most_recent_rental_id?: InputMaybe<Order_By>;
  most_recent_rental_move_out_date?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  occupancy_status?: InputMaybe<Order_By>;
  opportunities_aggregate?: InputMaybe<Opportunities_Aggregate_Order_By>;
  ownership_status?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  summary_status?: InputMaybe<Order_By>;
  tenant_first_name?: InputMaybe<Order_By>;
  tenant_last_name?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** select columns of table "homes360" */
export enum Homes360_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  BathsFull = 'baths_full',
  /** column name */
  BathsHalf = 'baths_half',
  /** column name */
  BathsTotal = 'baths_total',
  /** column name */
  Beds = 'beds',
  /** column name */
  City = 'city',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  DisplayLine_1 = 'display_line_1',
  /** column name */
  DisplayLine_2 = 'display_line_2',
  /** column name */
  DispositionDate = 'disposition_date',
  /** column name */
  EntityName = 'entity_name',
  /** column name */
  FundName = 'fund_name',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Long = 'long',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MostRecentRentalId = 'most_recent_rental_id',
  /** column name */
  MostRecentRentalMoveOutDate = 'most_recent_rental_move_out_date',
  /** column name */
  Number = 'number',
  /** column name */
  OccupancyStatus = 'occupancy_status',
  /** column name */
  OwnershipStatus = 'ownership_status',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  Sqft = 'sqft',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  SummaryStatus = 'summary_status',
  /** column name */
  TenantFirstName = 'tenant_first_name',
  /** column name */
  TenantLastName = 'tenant_last_name',
  /** column name */
  Unit = 'unit',
  /** column name */
  YearBuilt = 'year_built',
  /** column name */
  Zip = 'zip'
}

/** Streaming cursor of the table "homes360" */
export type Homes360_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Homes360_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Homes360_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  baths_full?: InputMaybe<Scalars['Float']['input']>;
  baths_half?: InputMaybe<Scalars['Float']['input']>;
  baths_total?: InputMaybe<Scalars['Float']['input']>;
  beds?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Scalars['String']['input']>;
  display_line_1?: InputMaybe<Scalars['String']['input']>;
  display_line_2?: InputMaybe<Scalars['String']['input']>;
  disposition_date?: InputMaybe<Scalars['date']['input']>;
  entity_name?: InputMaybe<Scalars['String']['input']>;
  fund_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  most_recent_rental_id?: InputMaybe<Scalars['uuid']['input']>;
  most_recent_rental_move_out_date?: InputMaybe<Scalars['date']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  occupancy_status?: InputMaybe<Scalars['String']['input']>;
  ownership_status?: InputMaybe<Scalars['String']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  sqft?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  summary_status?: InputMaybe<Scalars['String']['input']>;
  tenant_first_name?: InputMaybe<Scalars['String']['input']>;
  tenant_last_name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "homes" */
export type Homes_Aggregate_Order_By = {
  avg?: InputMaybe<Homes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Homes_Max_Order_By>;
  min?: InputMaybe<Homes_Min_Order_By>;
  stddev?: InputMaybe<Homes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Homes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Homes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Homes_Sum_Order_By>;
  var_pop?: InputMaybe<Homes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Homes_Var_Samp_Order_By>;
  variance?: InputMaybe<Homes_Variance_Order_By>;
};

/** order by avg() on columns of table "homes" */
export type Homes_Avg_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "homes". All fields are combined with a logical 'AND'. */
export type Homes_Bool_Exp = {
  _and?: InputMaybe<Array<Homes_Bool_Exp>>;
  _not?: InputMaybe<Homes_Bool_Exp>;
  _or?: InputMaybe<Array<Homes_Bool_Exp>>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  baths_full?: InputMaybe<Float_Comparison_Exp>;
  baths_half?: InputMaybe<Float_Comparison_Exp>;
  baths_total?: InputMaybe<Float_Comparison_Exp>;
  beds?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  opportunities?: InputMaybe<Opportunities_Bool_Exp>;
  portfolio_homes?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  sqft?: InputMaybe<Float_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  year_built?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "homes" */
export type Homes_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "homes" */
export type Homes_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "homes". */
export type Homes_Order_By = {
  address?: InputMaybe<Addresses_Order_By>;
  address_id?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  opportunities_aggregate?: InputMaybe<Opportunities_Aggregate_Order_By>;
  portfolio_homes_aggregate?: InputMaybe<Portfolio_Homes_Aggregate_Order_By>;
  sqft?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** select columns of table "homes" */
export enum Homes_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  BathsFull = 'baths_full',
  /** column name */
  BathsHalf = 'baths_half',
  /** column name */
  BathsTotal = 'baths_total',
  /** column name */
  Beds = 'beds',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Sqft = 'sqft',
  /** column name */
  Unit = 'unit',
  /** column name */
  YearBuilt = 'year_built'
}

/** order by stddev() on columns of table "homes" */
export type Homes_Stddev_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "homes" */
export type Homes_Stddev_Pop_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "homes" */
export type Homes_Stddev_Samp_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "homes" */
export type Homes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Homes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Homes_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  baths_full?: InputMaybe<Scalars['Float']['input']>;
  baths_half?: InputMaybe<Scalars['Float']['input']>;
  baths_total?: InputMaybe<Scalars['Float']['input']>;
  beds?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  sqft?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "homes" */
export type Homes_Sum_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "homes" */
export type Homes_Var_Pop_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "homes" */
export type Homes_Var_Samp_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "homes" */
export type Homes_Variance_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items = {
  __typename: 'kafka_connector_prorated_utility_bill_line_items';
  buildium_csv: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  known_liabilities_do_not_cover_full_bill_csv?: Maybe<Scalars['String']['output']>;
  original_upload?: Maybe<Scalars['String']['output']>;
  original_upload_url: Scalars['String']['output'];
  potential_duplicates_csv?: Maybe<Scalars['String']['output']>;
  rental_liabilities: Scalars['json']['output'];
  rental_liabilities_csv: Scalars['String']['output'];
  transformations: Scalars['json']['output'];
  unknown_memos?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_ItemsRental_LiabilitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_ItemsTransformationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "kafka_connector.prorated_utility_bill_line_items". All fields are combined with a logical 'AND'. */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>>;
  buildium_csv?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  known_liabilities_do_not_cover_full_bill_csv?: InputMaybe<String_Comparison_Exp>;
  original_upload?: InputMaybe<String_Comparison_Exp>;
  original_upload_url?: InputMaybe<String_Comparison_Exp>;
  potential_duplicates_csv?: InputMaybe<String_Comparison_Exp>;
  rental_liabilities?: InputMaybe<Json_Comparison_Exp>;
  rental_liabilities_csv?: InputMaybe<String_Comparison_Exp>;
  transformations?: InputMaybe<Json_Comparison_Exp>;
  unknown_memos?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "kafka_connector.prorated_utility_bill_line_items" */
export enum Kafka_Connector_Prorated_Utility_Bill_Line_Items_Constraint {
  /** unique or primary key constraint on columns "original_upload_url" */
  ProratedUtilityBillLineItemsOriginalUploadUrlKey = 'prorated_utility_bill_line_items_original_upload_url_key',
  /** unique or primary key constraint on columns "id" */
  ProratedUtilityBillLineItemsPkey = 'prorated_utility_bill_line_items_pkey'
}

/** input type for inserting data into table "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Insert_Input = {
  buildium_csv?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  known_liabilities_do_not_cover_full_bill_csv?: InputMaybe<Scalars['String']['input']>;
  original_upload?: InputMaybe<Scalars['String']['input']>;
  original_upload_url?: InputMaybe<Scalars['String']['input']>;
  potential_duplicates_csv?: InputMaybe<Scalars['String']['input']>;
  rental_liabilities?: InputMaybe<Scalars['json']['input']>;
  rental_liabilities_csv?: InputMaybe<Scalars['String']['input']>;
  transformations?: InputMaybe<Scalars['json']['input']>;
  unknown_memos?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Mutation_Response = {
  __typename: 'kafka_connector_prorated_utility_bill_line_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
};

/** on_conflict condition type for table "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_On_Conflict = {
  constraint: Kafka_Connector_Prorated_Utility_Bill_Line_Items_Constraint;
  update_columns?: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Update_Column>;
  where?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "kafka_connector.prorated_utility_bill_line_items". */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Order_By = {
  buildium_csv?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  known_liabilities_do_not_cover_full_bill_csv?: InputMaybe<Order_By>;
  original_upload?: InputMaybe<Order_By>;
  original_upload_url?: InputMaybe<Order_By>;
  potential_duplicates_csv?: InputMaybe<Order_By>;
  rental_liabilities?: InputMaybe<Order_By>;
  rental_liabilities_csv?: InputMaybe<Order_By>;
  transformations?: InputMaybe<Order_By>;
  unknown_memos?: InputMaybe<Order_By>;
};

/** primary key columns input for table: kafka_connector.prorated_utility_bill_line_items */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "kafka_connector.prorated_utility_bill_line_items" */
export enum Kafka_Connector_Prorated_Utility_Bill_Line_Items_Select_Column {
  /** column name */
  BuildiumCsv = 'buildium_csv',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  KnownLiabilitiesDoNotCoverFullBillCsv = 'known_liabilities_do_not_cover_full_bill_csv',
  /** column name */
  OriginalUpload = 'original_upload',
  /** column name */
  OriginalUploadUrl = 'original_upload_url',
  /** column name */
  PotentialDuplicatesCsv = 'potential_duplicates_csv',
  /** column name */
  RentalLiabilities = 'rental_liabilities',
  /** column name */
  RentalLiabilitiesCsv = 'rental_liabilities_csv',
  /** column name */
  Transformations = 'transformations',
  /** column name */
  UnknownMemos = 'unknown_memos'
}

/** input type for updating data in table "kafka_connector.prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Set_Input = {
  buildium_csv?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_upload_url?: InputMaybe<Scalars['String']['input']>;
  rental_liabilities?: InputMaybe<Scalars['json']['input']>;
  transformations?: InputMaybe<Scalars['json']['input']>;
};

/** Streaming cursor of the table "kafka_connector_prorated_utility_bill_line_items" */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kafka_Connector_Prorated_Utility_Bill_Line_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Stream_Cursor_Value_Input = {
  buildium_csv?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  known_liabilities_do_not_cover_full_bill_csv?: InputMaybe<Scalars['String']['input']>;
  original_upload?: InputMaybe<Scalars['String']['input']>;
  original_upload_url?: InputMaybe<Scalars['String']['input']>;
  potential_duplicates_csv?: InputMaybe<Scalars['String']['input']>;
  rental_liabilities?: InputMaybe<Scalars['json']['input']>;
  rental_liabilities_csv?: InputMaybe<Scalars['String']['input']>;
  transformations?: InputMaybe<Scalars['json']['input']>;
  unknown_memos?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "kafka_connector.prorated_utility_bill_line_items" */
export enum Kafka_Connector_Prorated_Utility_Bill_Line_Items_Update_Column {
  /** column name */
  BuildiumCsv = 'buildium_csv',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalUploadUrl = 'original_upload_url',
  /** column name */
  RentalLiabilities = 'rental_liabilities',
  /** column name */
  Transformations = 'transformations'
}

export type Kafka_Connector_Prorated_Utility_Bill_Line_Items_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Set_Input>;
  where: Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp;
};

/** columns and relationships of "latchel_categories" */
export type Latchel_Categories = {
  __typename: 'latchel_categories';
  category_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "latchel_categories". All fields are combined with a logical 'AND'. */
export type Latchel_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Latchel_Categories_Bool_Exp>>;
  _not?: InputMaybe<Latchel_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Latchel_Categories_Bool_Exp>>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "latchel_categories". */
export type Latchel_Categories_Order_By = {
  category_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "latchel_categories" */
export enum Latchel_Categories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "latchel_categories" */
export type Latchel_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latchel_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latchel_Categories_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "latchel_dead_letters" */
export type Latchel_Dead_Letters = {
  __typename: 'latchel_dead_letters';
  created_at: Scalars['timestamptz']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  operation_type?: Maybe<Scalars['String']['output']>;
  payload: Scalars['jsonb']['output'];
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "latchel_dead_letters" */
export type Latchel_Dead_LettersPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "latchel_dead_letters". All fields are combined with a logical 'AND'. */
export type Latchel_Dead_Letters_Bool_Exp = {
  _and?: InputMaybe<Array<Latchel_Dead_Letters_Bool_Exp>>;
  _not?: InputMaybe<Latchel_Dead_Letters_Bool_Exp>;
  _or?: InputMaybe<Array<Latchel_Dead_Letters_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operation_type?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "latchel_dead_letters". */
export type Latchel_Dead_Letters_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_type?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "latchel_dead_letters" */
export enum Latchel_Dead_Letters_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  OperationType = 'operation_type',
  /** column name */
  Payload = 'payload',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "latchel_dead_letters" */
export type Latchel_Dead_Letters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latchel_Dead_Letters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latchel_Dead_Letters_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  operation_type?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "latchel_vendor_categories" */
export type Latchel_Vendor_Categories = {
  __typename: 'latchel_vendor_categories';
  /** An object relationship */
  latchel_category: Latchel_Categories;
  latchel_category_id: Scalars['Int']['output'];
  latchel_vendor_company_id: Scalars['Int']['output'];
  /** An object relationship */
  vendor: Vendors;
};

/** order by aggregate values of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Latchel_Vendor_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Latchel_Vendor_Categories_Max_Order_By>;
  min?: InputMaybe<Latchel_Vendor_Categories_Min_Order_By>;
  stddev?: InputMaybe<Latchel_Vendor_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Latchel_Vendor_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Latchel_Vendor_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Latchel_Vendor_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Latchel_Vendor_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Latchel_Vendor_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Latchel_Vendor_Categories_Variance_Order_By>;
};

/** order by avg() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Avg_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "latchel_vendor_categories". All fields are combined with a logical 'AND'. */
export type Latchel_Vendor_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Latchel_Vendor_Categories_Bool_Exp>>;
  _not?: InputMaybe<Latchel_Vendor_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Latchel_Vendor_Categories_Bool_Exp>>;
  latchel_category?: InputMaybe<Latchel_Categories_Bool_Exp>;
  latchel_category_id?: InputMaybe<Int_Comparison_Exp>;
  latchel_vendor_company_id?: InputMaybe<Int_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
};

/** order by max() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Max_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Min_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "latchel_vendor_categories". */
export type Latchel_Vendor_Categories_Order_By = {
  latchel_category?: InputMaybe<Latchel_Categories_Order_By>;
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
};

/** select columns of table "latchel_vendor_categories" */
export enum Latchel_Vendor_Categories_Select_Column {
  /** column name */
  LatchelCategoryId = 'latchel_category_id',
  /** column name */
  LatchelVendorCompanyId = 'latchel_vendor_company_id'
}

/** order by stddev() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Stddev_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Stddev_Pop_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Stddev_Samp_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latchel_Vendor_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latchel_Vendor_Categories_Stream_Cursor_Value_Input = {
  latchel_category_id?: InputMaybe<Scalars['Int']['input']>;
  latchel_vendor_company_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Sum_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Var_Pop_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Var_Samp_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "latchel_vendor_categories" */
export type Latchel_Vendor_Categories_Variance_Order_By = {
  latchel_category_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "latchel_vendor_users" */
export type Latchel_Vendor_Users = {
  __typename: 'latchel_vendor_users';
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  latchel_id: Scalars['Int']['output'];
  latchel_vendor_company_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
};

/** order by aggregate values of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Latchel_Vendor_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Latchel_Vendor_Users_Max_Order_By>;
  min?: InputMaybe<Latchel_Vendor_Users_Min_Order_By>;
  stddev?: InputMaybe<Latchel_Vendor_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Latchel_Vendor_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Latchel_Vendor_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Latchel_Vendor_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Latchel_Vendor_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Latchel_Vendor_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Latchel_Vendor_Users_Variance_Order_By>;
};

/** order by avg() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Avg_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "latchel_vendor_users". All fields are combined with a logical 'AND'. */
export type Latchel_Vendor_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Latchel_Vendor_Users_Bool_Exp>>;
  _not?: InputMaybe<Latchel_Vendor_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Latchel_Vendor_Users_Bool_Exp>>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latchel_id?: InputMaybe<Int_Comparison_Exp>;
  latchel_vendor_company_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
};

/** order by max() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Max_Order_By = {
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Min_Order_By = {
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "latchel_vendor_users". */
export type Latchel_Vendor_Users_Order_By = {
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
};

/** select columns of table "latchel_vendor_users" */
export enum Latchel_Vendor_Users_Select_Column {
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LatchelId = 'latchel_id',
  /** column name */
  LatchelVendorCompanyId = 'latchel_vendor_company_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Stddev_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Stddev_Pop_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Stddev_Samp_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latchel_Vendor_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latchel_Vendor_Users_Stream_Cursor_Value_Input = {
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latchel_id?: InputMaybe<Scalars['Int']['input']>;
  latchel_vendor_company_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Sum_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Var_Pop_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Var_Samp_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "latchel_vendor_users" */
export type Latchel_Vendor_Users_Variance_Order_By = {
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_company_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "lead_group_rental_application_notes" */
export type Lead_Group_Rental_Application_Notes = {
  __typename: 'lead_group_rental_application_notes';
  /** An object relationship */
  admin?: Maybe<Admins>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  lead_group?: Maybe<Lead_Groups>;
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rental_application?: Maybe<Rental_Applications>;
  resource_id?: Maybe<Scalars['uuid']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  subject_id?: Maybe<Scalars['uuid']['output']>;
  subject_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "lead_group_rental_application_notes" */
export type Lead_Group_Rental_Application_Notes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lead_Group_Rental_Application_Notes_Max_Order_By>;
  min?: InputMaybe<Lead_Group_Rental_Application_Notes_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "lead_group_rental_application_notes". All fields are combined with a logical 'AND'. */
export type Lead_Group_Rental_Application_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Bool_Exp>>;
  _not?: InputMaybe<Lead_Group_Rental_Application_Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  lead_group?: InputMaybe<Lead_Groups_Bool_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  subject_id?: InputMaybe<Uuid_Comparison_Exp>;
  subject_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "lead_group_rental_application_notes" */
export type Lead_Group_Rental_Application_Notes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  subject_id?: InputMaybe<Order_By>;
  subject_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "lead_group_rental_application_notes" */
export type Lead_Group_Rental_Application_Notes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  subject_id?: InputMaybe<Order_By>;
  subject_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lead_group_rental_application_notes". */
export type Lead_Group_Rental_Application_Notes_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  lead_group?: InputMaybe<Lead_Groups_Order_By>;
  note?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  subject_id?: InputMaybe<Order_By>;
  subject_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "lead_group_rental_application_notes" */
export enum Lead_Group_Rental_Application_Notes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Note = 'note',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  SubjectId = 'subject_id',
  /** column name */
  SubjectType = 'subject_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "lead_group_rental_application_notes" */
export type Lead_Group_Rental_Application_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Group_Rental_Application_Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Group_Rental_Application_Notes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  subject_id?: InputMaybe<Scalars['uuid']['input']>;
  subject_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "lead_group_users" */
export type Lead_Group_Users = {
  __typename: 'lead_group_users';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  employment_status?: Maybe<Scalars['String']['output']>;
  employment_status_set_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead_group: Lead_Groups;
  lead_group_id: Scalars['uuid']['output'];
  rental_application_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  rental_applications: Array<Rental_Applications>;
  /** An aggregate relationship */
  rental_applications_aggregate: Rental_Applications_Aggregate;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  /** An array relationship */
  user_contact_details: Array<User_Contact_Details>;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user_searchable?: Maybe<User_Searchable>;
};


/** columns and relationships of "lead_group_users" */
export type Lead_Group_UsersRental_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "lead_group_users" */
export type Lead_Group_UsersRental_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "lead_group_users" */
export type Lead_Group_UsersUser_Contact_DetailsArgs = {
  distinct_on?: InputMaybe<Array<User_Contact_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Contact_Details_Order_By>>;
  where?: InputMaybe<User_Contact_Details_Bool_Exp>;
};

/** order by aggregate values of table "lead_group_users" */
export type Lead_Group_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lead_Group_Users_Max_Order_By>;
  min?: InputMaybe<Lead_Group_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "lead_group_users". All fields are combined with a logical 'AND'. */
export type Lead_Group_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Group_Users_Bool_Exp>>;
  _not?: InputMaybe<Lead_Group_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Group_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employment_status?: InputMaybe<String_Comparison_Exp>;
  employment_status_set_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_group?: InputMaybe<Lead_Groups_Bool_Exp>;
  lead_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_application_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  rental_applications?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_contact_details?: InputMaybe<User_Contact_Details_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_searchable?: InputMaybe<User_Searchable_Bool_Exp>;
};

/** order by max() on columns of table "lead_group_users" */
export type Lead_Group_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  employment_status?: InputMaybe<Order_By>;
  employment_status_set_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  rental_application_submitted_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "lead_group_users" */
export type Lead_Group_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  employment_status?: InputMaybe<Order_By>;
  employment_status_set_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  rental_application_submitted_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lead_group_users". */
export type Lead_Group_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  employment_status?: InputMaybe<Order_By>;
  employment_status_set_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group?: InputMaybe<Lead_Groups_Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  rental_application_submitted_at?: InputMaybe<Order_By>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_contact_details_aggregate?: InputMaybe<User_Contact_Details_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_searchable?: InputMaybe<User_Searchable_Order_By>;
};

/** select columns of table "lead_group_users" */
export enum Lead_Group_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  EmploymentStatus = 'employment_status',
  /** column name */
  EmploymentStatusSetAt = 'employment_status_set_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadGroupId = 'lead_group_id',
  /** column name */
  RentalApplicationSubmittedAt = 'rental_application_submitted_at',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "lead_group_users" */
export type Lead_Group_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Group_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Group_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employment_status?: InputMaybe<Scalars['String']['input']>;
  employment_status_set_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_group_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "lead_groups" */
export type Lead_Groups = {
  __typename: 'lead_groups';
  /** An array relationship */
  agent_lead_group_owners: Array<Agent_Lead_Group_Owners>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  lead_group_users: Array<Lead_Group_Users>;
  /** An array relationship */
  rental_application_notes: Array<Lead_Group_Rental_Application_Notes>;
  /** An array relationship */
  rental_applications: Array<Rental_Applications>;
  /** An aggregate relationship */
  rental_applications_aggregate: Rental_Applications_Aggregate;
  status: Scalars['String']['output'];
  /** An array relationship */
  tours: Array<Tours>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "lead_groups" */
export type Lead_GroupsAgent_Lead_Group_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_Lead_Group_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Lead_Group_Owners_Order_By>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
};


/** columns and relationships of "lead_groups" */
export type Lead_GroupsLead_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Users_Order_By>>;
  where?: InputMaybe<Lead_Group_Users_Bool_Exp>;
};


/** columns and relationships of "lead_groups" */
export type Lead_GroupsRental_Application_NotesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Order_By>>;
  where?: InputMaybe<Lead_Group_Rental_Application_Notes_Bool_Exp>;
};


/** columns and relationships of "lead_groups" */
export type Lead_GroupsRental_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "lead_groups" */
export type Lead_GroupsRental_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "lead_groups" */
export type Lead_GroupsToursArgs = {
  distinct_on?: InputMaybe<Array<Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tours_Order_By>>;
  where?: InputMaybe<Tours_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "lead_groups". All fields are combined with a logical 'AND'. */
export type Lead_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Groups_Bool_Exp>>;
  _not?: InputMaybe<Lead_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Groups_Bool_Exp>>;
  agent_lead_group_owners?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_group_users?: InputMaybe<Lead_Group_Users_Bool_Exp>;
  rental_application_notes?: InputMaybe<Lead_Group_Rental_Application_Notes_Bool_Exp>;
  rental_applications?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tours?: InputMaybe<Tours_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "lead_groups". */
export type Lead_Groups_Order_By = {
  agent_lead_group_owners_aggregate?: InputMaybe<Agent_Lead_Group_Owners_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_users_aggregate?: InputMaybe<Lead_Group_Users_Aggregate_Order_By>;
  rental_application_notes_aggregate?: InputMaybe<Lead_Group_Rental_Application_Notes_Aggregate_Order_By>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  tours_aggregate?: InputMaybe<Tours_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "lead_groups" */
export enum Lead_Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "lead_groups" */
export type Lead_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Groups_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export enum Lease_Variants_Enum_Enum {
  Kcpoa = 'kcpoa',
  Standard = 'standard'
}

/** Boolean expression to compare columns of type "lease_variants_enum_enum". All fields are combined with logical 'AND'. */
export type Lease_Variants_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lease_Variants_Enum_Enum>;
  _in?: InputMaybe<Array<Lease_Variants_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lease_Variants_Enum_Enum>;
  _nin?: InputMaybe<Array<Lease_Variants_Enum_Enum>>;
};

/** columns and relationships of "ledger_account_categories" */
export type Ledger_Account_Categories = {
  __typename: 'ledger_account_categories';
  allocation: Scalars['numeric']['output'];
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ledger_account: Ledger_Accounts;
  ledger_account_id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  subcategory: Scalars['String']['output'];
  supercategory: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "ledger_account_categories" */
export type Ledger_Account_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Ledger_Account_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ledger_Account_Categories_Max_Order_By>;
  min?: InputMaybe<Ledger_Account_Categories_Min_Order_By>;
  stddev?: InputMaybe<Ledger_Account_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ledger_Account_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ledger_Account_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ledger_Account_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Ledger_Account_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ledger_Account_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Ledger_Account_Categories_Variance_Order_By>;
};

/** order by avg() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Avg_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ledger_account_categories". All fields are combined with a logical 'AND'. */
export type Ledger_Account_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Ledger_Account_Categories_Bool_Exp>>;
  _not?: InputMaybe<Ledger_Account_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Ledger_Account_Categories_Bool_Exp>>;
  allocation?: InputMaybe<Numeric_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ledger_account?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  subcategory?: InputMaybe<String_Comparison_Exp>;
  supercategory?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Max_Order_By = {
  allocation?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subcategory?: InputMaybe<Order_By>;
  supercategory?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Min_Order_By = {
  allocation?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subcategory?: InputMaybe<Order_By>;
  supercategory?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ledger_account_categories". */
export type Ledger_Account_Categories_Order_By = {
  allocation?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account?: InputMaybe<Ledger_Accounts_Order_By>;
  ledger_account_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subcategory?: InputMaybe<Order_By>;
  supercategory?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ledger_account_categories" */
export enum Ledger_Account_Categories_Select_Column {
  /** column name */
  Allocation = 'allocation',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LedgerAccountId = 'ledger_account_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subcategory = 'subcategory',
  /** column name */
  Supercategory = 'supercategory',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Stddev_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Stddev_Pop_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Stddev_Samp_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ledger_account_categories" */
export type Ledger_Account_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ledger_Account_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ledger_Account_Categories_Stream_Cursor_Value_Input = {
  allocation?: InputMaybe<Scalars['numeric']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  supercategory?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Sum_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Var_Pop_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Var_Samp_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ledger_account_categories" */
export type Ledger_Account_Categories_Variance_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** columns and relationships of "ledger_accounts" */
export type Ledger_Accounts = {
  __typename: 'ledger_accounts';
  cashflow_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exclude_from_cash_balances: Scalars['Boolean']['output'];
  external_id: Scalars['Int']['output'];
  external_source: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_bank_account: Scalars['Boolean']['output'];
  is_contra_account: Scalars['Boolean']['output'];
  /** An array relationship */
  ledger_account_categories: Array<Ledger_Account_Categories>;
  ledger_subtype?: Maybe<Scalars['String']['output']>;
  ledger_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  llc?: Maybe<Llcs>;
  name: Scalars['String']['output'];
  parent_ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  rental_credit_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ledger_accounts" */
export type Ledger_AccountsLedger_Account_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Ledger_Account_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ledger_Account_Categories_Order_By>>;
  where?: InputMaybe<Ledger_Account_Categories_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ledger_accounts". All fields are combined with a logical 'AND'. */
export type Ledger_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Ledger_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Ledger_Accounts_Bool_Exp>>;
  cashflow_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  exclude_from_cash_balances?: InputMaybe<Boolean_Comparison_Exp>;
  external_id?: InputMaybe<Int_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_bank_account?: InputMaybe<Boolean_Comparison_Exp>;
  is_contra_account?: InputMaybe<Boolean_Comparison_Exp>;
  ledger_account_categories?: InputMaybe<Ledger_Account_Categories_Bool_Exp>;
  ledger_subtype?: InputMaybe<String_Comparison_Exp>;
  ledger_type?: InputMaybe<String_Comparison_Exp>;
  llc?: InputMaybe<Llcs_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_credit_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ledger_accounts". */
export type Ledger_Accounts_Order_By = {
  cashflow_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  exclude_from_cash_balances?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_bank_account?: InputMaybe<Order_By>;
  is_contra_account?: InputMaybe<Order_By>;
  ledger_account_categories_aggregate?: InputMaybe<Ledger_Account_Categories_Aggregate_Order_By>;
  ledger_subtype?: InputMaybe<Order_By>;
  ledger_type?: InputMaybe<Order_By>;
  llc?: InputMaybe<Llcs_Order_By>;
  name?: InputMaybe<Order_By>;
  parent_ledger_account_id?: InputMaybe<Order_By>;
  rental_credit_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ledger_accounts" */
export enum Ledger_Accounts_Select_Column {
  /** column name */
  CashflowType = 'cashflow_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExcludeFromCashBalances = 'exclude_from_cash_balances',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBankAccount = 'is_bank_account',
  /** column name */
  IsContraAccount = 'is_contra_account',
  /** column name */
  LedgerSubtype = 'ledger_subtype',
  /** column name */
  LedgerType = 'ledger_type',
  /** column name */
  Name = 'name',
  /** column name */
  ParentLedgerAccountId = 'parent_ledger_account_id',
  /** column name */
  RentalCreditType = 'rental_credit_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ledger_accounts" */
export type Ledger_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ledger_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ledger_Accounts_Stream_Cursor_Value_Input = {
  cashflow_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exclude_from_cash_balances?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_bank_account?: InputMaybe<Scalars['Boolean']['input']>;
  is_contra_account?: InputMaybe<Scalars['Boolean']['input']>;
  ledger_subtype?: InputMaybe<Scalars['String']['input']>;
  ledger_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_credit_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Matching of liabilities to credits or payments */
export type Liabilities_Payments = {
  __typename: 'liabilities_payments';
  amount: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  credit?: Maybe<Rental_Credits>;
  liability_date: Scalars['date']['output'];
  liability_id: Scalars['uuid']['output'];
  /** An object relationship */
  payment?: Maybe<Payments>;
  payment_date: Scalars['date']['output'];
  payment_or_credit_id: Scalars['uuid']['output'];
  remaining_liability_amount: Scalars['numeric']['output'];
  remaining_payment_amount: Scalars['numeric']['output'];
  rental_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_liability: Rental_Liabilities;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "liabilities_payments" */
export type Liabilities_Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Liabilities_Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Liabilities_Payments_Max_Order_By>;
  min?: InputMaybe<Liabilities_Payments_Min_Order_By>;
  stddev?: InputMaybe<Liabilities_Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Liabilities_Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Liabilities_Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Liabilities_Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Liabilities_Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Liabilities_Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Liabilities_Payments_Variance_Order_By>;
};

/** order by avg() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "liabilities_payments". All fields are combined with a logical 'AND'. */
export type Liabilities_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Liabilities_Payments_Bool_Exp>>;
  _not?: InputMaybe<Liabilities_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Liabilities_Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit?: InputMaybe<Rental_Credits_Bool_Exp>;
  liability_date?: InputMaybe<Date_Comparison_Exp>;
  liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_date?: InputMaybe<Date_Comparison_Exp>;
  payment_or_credit_id?: InputMaybe<Uuid_Comparison_Exp>;
  remaining_liability_amount?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_payment_amount?: InputMaybe<Numeric_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_liability?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  liability_date?: InputMaybe<Order_By>;
  liability_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_or_credit_id?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  liability_date?: InputMaybe<Order_By>;
  liability_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_or_credit_id?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "liabilities_payments". */
export type Liabilities_Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Rental_Credits_Order_By>;
  liability_date?: InputMaybe<Order_By>;
  liability_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_or_credit_id?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  rental_liability?: InputMaybe<Rental_Liabilities_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "liabilities_payments" */
export enum Liabilities_Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LiabilityDate = 'liability_date',
  /** column name */
  LiabilityId = 'liability_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentOrCreditId = 'payment_or_credit_id',
  /** column name */
  RemainingLiabilityAmount = 'remaining_liability_amount',
  /** column name */
  RemainingPaymentAmount = 'remaining_payment_amount',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "liabilities_payments" */
export type Liabilities_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Liabilities_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Liabilities_Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  liability_date?: InputMaybe<Scalars['date']['input']>;
  liability_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['date']['input']>;
  payment_or_credit_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_liability_amount?: InputMaybe<Scalars['numeric']['input']>;
  remaining_payment_amount?: InputMaybe<Scalars['numeric']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "liabilities_payments" */
export type Liabilities_Payments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  remaining_liability_amount?: InputMaybe<Order_By>;
  remaining_payment_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "liability_types" */
export type Liability_Types = {
  __typename: 'liability_types';
  allowance_for_bad_debt_ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  bad_debt_ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_variable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  payment_category?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  price?: Maybe<Scalars['numeric']['output']>;
  priority: Scalars['Int']['output'];
  recurring: Scalars['Boolean']['output'];
  /** An array relationship */
  rental_add_ons: Array<Rental_Add_Ons>;
  /** An array relationship */
  rental_liabilities: Array<Rental_Liabilities>;
  /** An array relationship */
  utility_types: Array<Utility_Types>;
};


/** columns and relationships of "liability_types" */
export type Liability_TypesPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "liability_types" */
export type Liability_TypesPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "liability_types" */
export type Liability_TypesRental_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Add_Ons_Order_By>>;
  where?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
};


/** columns and relationships of "liability_types" */
export type Liability_TypesRental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Rental_Liabilities_Bool_Exp>;
};


/** columns and relationships of "liability_types" */
export type Liability_TypesUtility_TypesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Types_Order_By>>;
  where?: InputMaybe<Utility_Types_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "liability_types". All fields are combined with a logical 'AND'. */
export type Liability_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Liability_Types_Bool_Exp>>;
  _not?: InputMaybe<Liability_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Liability_Types_Bool_Exp>>;
  allowance_for_bad_debt_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  bad_debt_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_variable?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payment_category?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  recurring?: InputMaybe<Boolean_Comparison_Exp>;
  rental_add_ons?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
  rental_liabilities?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  utility_types?: InputMaybe<Utility_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "liability_types". */
export type Liability_Types_Order_By = {
  allowance_for_bad_debt_ledger_account_id?: InputMaybe<Order_By>;
  bad_debt_ledger_account_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_variable?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payment_category?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  recurring?: InputMaybe<Order_By>;
  rental_add_ons_aggregate?: InputMaybe<Rental_Add_Ons_Aggregate_Order_By>;
  rental_liabilities_aggregate?: InputMaybe<Rental_Liabilities_Aggregate_Order_By>;
  utility_types_aggregate?: InputMaybe<Utility_Types_Aggregate_Order_By>;
};

/** select columns of table "liability_types" */
export enum Liability_Types_Select_Column {
  /** column name */
  AllowanceForBadDebtLedgerAccountId = 'allowance_for_bad_debt_ledger_account_id',
  /** column name */
  BadDebtLedgerAccountId = 'bad_debt_ledger_account_id',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVariable = 'is_variable',
  /** column name */
  Name = 'name',
  /** column name */
  PaymentCategory = 'payment_category',
  /** column name */
  Price = 'price',
  /** column name */
  Priority = 'priority',
  /** column name */
  Recurring = 'recurring'
}

/** Streaming cursor of the table "liability_types" */
export type Liability_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Liability_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Liability_Types_Stream_Cursor_Value_Input = {
  allowance_for_bad_debt_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  bad_debt_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_variable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payment_category?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "listed_rents" */
export type Listed_Rents = {
  __typename: 'listed_rents';
  base_rent: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  home: Homes;
  home_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  listed_rent: Scalars['numeric']['output'];
  update_reason?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "listed_rents" */
export type Listed_Rents_Aggregate_Order_By = {
  avg?: InputMaybe<Listed_Rents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Listed_Rents_Max_Order_By>;
  min?: InputMaybe<Listed_Rents_Min_Order_By>;
  stddev?: InputMaybe<Listed_Rents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Listed_Rents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Listed_Rents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Listed_Rents_Sum_Order_By>;
  var_pop?: InputMaybe<Listed_Rents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Listed_Rents_Var_Samp_Order_By>;
  variance?: InputMaybe<Listed_Rents_Variance_Order_By>;
};

/** order by avg() on columns of table "listed_rents" */
export type Listed_Rents_Avg_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "listed_rents". All fields are combined with a logical 'AND'. */
export type Listed_Rents_Bool_Exp = {
  _and?: InputMaybe<Array<Listed_Rents_Bool_Exp>>;
  _not?: InputMaybe<Listed_Rents_Bool_Exp>;
  _or?: InputMaybe<Array<Listed_Rents_Bool_Exp>>;
  base_rent?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  home?: InputMaybe<Homes_Bool_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listed_rent?: InputMaybe<Numeric_Comparison_Exp>;
  update_reason?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "listed_rents" */
export type Listed_Rents_Max_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
  update_reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "listed_rents" */
export type Listed_Rents_Min_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
  update_reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "listed_rents". */
export type Listed_Rents_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  home?: InputMaybe<Homes_Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
  update_reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "listed_rents" */
export enum Listed_Rents_Select_Column {
  /** column name */
  BaseRent = 'base_rent',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  ListedRent = 'listed_rent',
  /** column name */
  UpdateReason = 'update_reason',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "listed_rents" */
export type Listed_Rents_Stddev_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "listed_rents" */
export type Listed_Rents_Stddev_Pop_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "listed_rents" */
export type Listed_Rents_Stddev_Samp_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "listed_rents" */
export type Listed_Rents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Listed_Rents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Listed_Rents_Stream_Cursor_Value_Input = {
  base_rent?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  listed_rent?: InputMaybe<Scalars['numeric']['input']>;
  update_reason?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "listed_rents" */
export type Listed_Rents_Sum_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "listed_rents" */
export type Listed_Rents_Var_Pop_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "listed_rents" */
export type Listed_Rents_Var_Samp_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "listed_rents" */
export type Listed_Rents_Variance_Order_By = {
  base_rent?: InputMaybe<Order_By>;
  listed_rent?: InputMaybe<Order_By>;
};

/** columns and relationships of "listing_searchable" */
export type Listing_Searchable = {
  __typename: 'listing_searchable';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "listing_searchable". All fields are combined with a logical 'AND'. */
export type Listing_Searchable_Bool_Exp = {
  _and?: InputMaybe<Array<Listing_Searchable_Bool_Exp>>;
  _not?: InputMaybe<Listing_Searchable_Bool_Exp>;
  _or?: InputMaybe<Array<Listing_Searchable_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "listing_searchable". */
export type Listing_Searchable_Order_By = {
  address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "listing_searchable" */
export enum Listing_Searchable_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "listing_searchable" */
export type Listing_Searchable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Listing_Searchable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Listing_Searchable_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "llc_market_agreement_templates" */
export type Llc_Market_Agreement_Templates = {
  __typename: 'llc_market_agreement_templates';
  agreement_template_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  lease_variant: Lease_Variants_Enum_Enum;
  llc_id: Scalars['uuid']['output'];
  market_id: Scalars['uuid']['output'];
  rental_program_type: Rental_Program_Types_Enum_Enum;
  type: Agreement_Template_Types_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "llc_market_agreement_templates". All fields are combined with a logical 'AND'. */
export type Llc_Market_Agreement_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Llc_Market_Agreement_Templates_Bool_Exp>>;
  _not?: InputMaybe<Llc_Market_Agreement_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Llc_Market_Agreement_Templates_Bool_Exp>>;
  agreement_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum_Comparison_Exp>;
  llc_id?: InputMaybe<Uuid_Comparison_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum_Comparison_Exp>;
  type?: InputMaybe<Agreement_Template_Types_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "llc_market_agreement_templates". */
export type Llc_Market_Agreement_Templates_Order_By = {
  agreement_template_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_variant?: InputMaybe<Order_By>;
  llc_id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  rental_program_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "llc_market_agreement_templates" */
export enum Llc_Market_Agreement_Templates_Select_Column {
  /** column name */
  AgreementTemplateId = 'agreement_template_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeaseVariant = 'lease_variant',
  /** column name */
  LlcId = 'llc_id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  RentalProgramType = 'rental_program_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "llc_market_agreement_templates" */
export type Llc_Market_Agreement_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Llc_Market_Agreement_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Llc_Market_Agreement_Templates_Stream_Cursor_Value_Input = {
  agreement_template_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum>;
  llc_id?: InputMaybe<Scalars['uuid']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  type?: InputMaybe<Agreement_Template_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "llc_properties" */
export type Llc_Properties = {
  __typename: 'llc_properties';
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  llc: Llcs;
  /** An object relationship */
  property: Properties;
  start_date: Scalars['date']['output'];
};

/** order by aggregate values of table "llc_properties" */
export type Llc_Properties_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Llc_Properties_Max_Order_By>;
  min?: InputMaybe<Llc_Properties_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "llc_properties". All fields are combined with a logical 'AND'. */
export type Llc_Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Llc_Properties_Bool_Exp>>;
  _not?: InputMaybe<Llc_Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Llc_Properties_Bool_Exp>>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llc?: InputMaybe<Llcs_Bool_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "llc_properties" */
export type Llc_Properties_Max_Order_By = {
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "llc_properties" */
export type Llc_Properties_Min_Order_By = {
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "llc_properties". */
export type Llc_Properties_Order_By = {
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llc?: InputMaybe<Llcs_Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** select columns of table "llc_properties" */
export enum Llc_Properties_Select_Column {
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'start_date'
}

/** Streaming cursor of the table "llc_properties" */
export type Llc_Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Llc_Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Llc_Properties_Stream_Cursor_Value_Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** columns and relationships of "llc_property_transfers" */
export type Llc_Property_Transfers = {
  __typename: 'llc_property_transfers';
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  diligencer?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  new_llc_id: Scalars['uuid']['output'];
  old_llc_id: Scalars['uuid']['output'];
  property_id: Scalars['uuid']['output'];
  servicer?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transfer_date?: Maybe<Scalars['date']['output']>;
  transfer_number: Scalars['uuid']['output'];
  transfer_type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "llc_property_transfers" */
export type Llc_Property_Transfers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Llc_Property_Transfers_Max_Order_By>;
  min?: InputMaybe<Llc_Property_Transfers_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "llc_property_transfers". All fields are combined with a logical 'AND'. */
export type Llc_Property_Transfers_Bool_Exp = {
  _and?: InputMaybe<Array<Llc_Property_Transfers_Bool_Exp>>;
  _not?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
  _or?: InputMaybe<Array<Llc_Property_Transfers_Bool_Exp>>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  diligencer?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_llc_id?: InputMaybe<Uuid_Comparison_Exp>;
  old_llc_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  servicer?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transfer_date?: InputMaybe<Date_Comparison_Exp>;
  transfer_number?: InputMaybe<Uuid_Comparison_Exp>;
  transfer_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "llc_property_transfers" */
export type Llc_Property_Transfers_Max_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  diligencer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_llc_id?: InputMaybe<Order_By>;
  old_llc_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  servicer?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_date?: InputMaybe<Order_By>;
  transfer_number?: InputMaybe<Order_By>;
  transfer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "llc_property_transfers" */
export type Llc_Property_Transfers_Min_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  diligencer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_llc_id?: InputMaybe<Order_By>;
  old_llc_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  servicer?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_date?: InputMaybe<Order_By>;
  transfer_number?: InputMaybe<Order_By>;
  transfer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "llc_property_transfers". */
export type Llc_Property_Transfers_Order_By = {
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  diligencer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_llc_id?: InputMaybe<Order_By>;
  old_llc_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  servicer?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_date?: InputMaybe<Order_By>;
  transfer_number?: InputMaybe<Order_By>;
  transfer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "llc_property_transfers" */
export enum Llc_Property_Transfers_Select_Column {
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletedByAdminId = 'completed_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Diligencer = 'diligencer',
  /** column name */
  Id = 'id',
  /** column name */
  NewLlcId = 'new_llc_id',
  /** column name */
  OldLlcId = 'old_llc_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Servicer = 'servicer',
  /** column name */
  Status = 'status',
  /** column name */
  TransferDate = 'transfer_date',
  /** column name */
  TransferNumber = 'transfer_number',
  /** column name */
  TransferType = 'transfer_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "llc_property_transfers" */
export type Llc_Property_Transfers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Llc_Property_Transfers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Llc_Property_Transfers_Stream_Cursor_Value_Input = {
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  diligencer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_llc_id?: InputMaybe<Scalars['uuid']['input']>;
  old_llc_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  servicer?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_date?: InputMaybe<Scalars['date']['input']>;
  transfer_number?: InputMaybe<Scalars['uuid']['input']>;
  transfer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "llcs" */
export type Llcs = {
  __typename: 'llcs';
  abbreviation?: Maybe<Scalars['String']['output']>;
  buildium_bank_account_id: Scalars['Int']['output'];
  /** An array relationship */
  fund_llcs: Array<Fund_Llcs>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  ledger_account?: Maybe<Ledger_Accounts>;
  /** An array relationship */
  llcPropertyTransfersByOldLlcId: Array<Llc_Property_Transfers>;
  /** An array relationship */
  llc_properties: Array<Llc_Properties>;
  /** An array relationship */
  llc_property_transfers: Array<Llc_Property_Transfers>;
  name: Scalars['String']['output'];
  /** An array relationship */
  real_estate_acquisitions: Array<Real_Estate_Acquisitions>;
};


/** columns and relationships of "llcs" */
export type LlcsFund_LlcsArgs = {
  distinct_on?: InputMaybe<Array<Fund_Llcs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fund_Llcs_Order_By>>;
  where?: InputMaybe<Fund_Llcs_Bool_Exp>;
};


/** columns and relationships of "llcs" */
export type LlcsLlcPropertyTransfersByOldLlcIdArgs = {
  distinct_on?: InputMaybe<Array<Llc_Property_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Property_Transfers_Order_By>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


/** columns and relationships of "llcs" */
export type LlcsLlc_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Properties_Order_By>>;
  where?: InputMaybe<Llc_Properties_Bool_Exp>;
};


/** columns and relationships of "llcs" */
export type LlcsLlc_Property_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Llc_Property_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Property_Transfers_Order_By>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


/** columns and relationships of "llcs" */
export type LlcsReal_Estate_AcquisitionsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Acquisitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Acquisitions_Order_By>>;
  where?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "llcs". All fields are combined with a logical 'AND'. */
export type Llcs_Bool_Exp = {
  _and?: InputMaybe<Array<Llcs_Bool_Exp>>;
  _not?: InputMaybe<Llcs_Bool_Exp>;
  _or?: InputMaybe<Array<Llcs_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  buildium_bank_account_id?: InputMaybe<Int_Comparison_Exp>;
  fund_llcs?: InputMaybe<Fund_Llcs_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  ledger_account?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  llcPropertyTransfersByOldLlcId?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
  llc_properties?: InputMaybe<Llc_Properties_Bool_Exp>;
  llc_property_transfers?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  real_estate_acquisitions?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};

/** Ordering options when selecting data from "llcs". */
export type Llcs_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  buildium_bank_account_id?: InputMaybe<Order_By>;
  fund_llcs_aggregate?: InputMaybe<Fund_Llcs_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  ledger_account?: InputMaybe<Ledger_Accounts_Order_By>;
  llcPropertyTransfersByOldLlcId_aggregate?: InputMaybe<Llc_Property_Transfers_Aggregate_Order_By>;
  llc_properties_aggregate?: InputMaybe<Llc_Properties_Aggregate_Order_By>;
  llc_property_transfers_aggregate?: InputMaybe<Llc_Property_Transfers_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  real_estate_acquisitions_aggregate?: InputMaybe<Real_Estate_Acquisitions_Aggregate_Order_By>;
};

/** select columns of table "llcs" */
export enum Llcs_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  BuildiumBankAccountId = 'buildium_bank_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "llcs" */
export type Llcs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Llcs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Llcs_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  buildium_bank_account_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** codes for lockboxes for homes */
export type Lockbox_Codes = {
  __typename: 'lockbox_codes';
  /** An object relationship */
  admin: Admins;
  code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  portfolio_home_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "lockbox_codes" */
export type Lockbox_Codes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lockbox_Codes_Max_Order_By>;
  min?: InputMaybe<Lockbox_Codes_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "lockbox_codes". All fields are combined with a logical 'AND'. */
export type Lockbox_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Lockbox_Codes_Bool_Exp>>;
  _not?: InputMaybe<Lockbox_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Lockbox_Codes_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lockbox_codes" */
export enum Lockbox_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  LockboxCodesPkey = 'lockbox_codes_pkey',
  /** unique or primary key constraint on columns "portfolio_home_id" */
  LockboxCodesPortfolioHomeIdIdx = 'lockbox_codes_portfolio_home_id_idx'
}

/** input type for inserting data into table "lockbox_codes" */
export type Lockbox_Codes_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "lockbox_codes" */
export type Lockbox_Codes_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "lockbox_codes" */
export type Lockbox_Codes_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lockbox_codes" */
export type Lockbox_Codes_Mutation_Response = {
  __typename: 'lockbox_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lockbox_Codes>;
};

/** on_conflict condition type for table "lockbox_codes" */
export type Lockbox_Codes_On_Conflict = {
  constraint: Lockbox_Codes_Constraint;
  update_columns?: Array<Lockbox_Codes_Update_Column>;
  where?: InputMaybe<Lockbox_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "lockbox_codes". */
export type Lockbox_Codes_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lockbox_codes */
export type Lockbox_Codes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lockbox_codes" */
export enum Lockbox_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lockbox_codes" */
export type Lockbox_Codes_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "lockbox_codes" */
export type Lockbox_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lockbox_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lockbox_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "lockbox_codes" */
export enum Lockbox_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Lockbox_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lockbox_Codes_Set_Input>;
  where: Lockbox_Codes_Bool_Exp;
};

/** columns and relationships of "markets" */
export type Markets = {
  __typename: 'markets';
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "markets". All fields are combined with a logical 'AND'. */
export type Markets_Bool_Exp = {
  _and?: InputMaybe<Array<Markets_Bool_Exp>>;
  _not?: InputMaybe<Markets_Bool_Exp>;
  _or?: InputMaybe<Array<Markets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "markets". */
export type Markets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "markets" */
export enum Markets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "markets" */
export type Markets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Markets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Markets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes = {
  __typename: 'mls_listing_internal_attributes';
  analyzed_images?: Maybe<Scalars['jsonb']['output']>;
  census_tract_county_code?: Maybe<Scalars['String']['output']>;
  census_tract_income_level?: Maybe<Scalars['String']['output']>;
  census_tract_median_family_income?: Maybe<Scalars['Float']['output']>;
  census_tract_percent_below_poverty_line?: Maybe<Scalars['Float']['output']>;
  census_tract_tract_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  guidance_price?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  internal_status?: Maybe<Scalars['String']['output']>;
  is_census_tract_opportunity_zone?: Maybe<Scalars['Boolean']['output']>;
  is_in_customer_buy_box: Scalars['Boolean']['output'];
  is_in_real_estate_buy_box: Scalars['Boolean']['output'];
  is_persisted_in_algolia: Scalars['Boolean']['output'];
  /** An object relationship */
  mls_listing: Mls_Listings;
  mls_listing_id: Scalars['uuid']['output'];
  neighborhood_levels?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  opportunity: Mls_Listings;
  percent_over_comp?: Maybe<Scalars['Float']['output']>;
  rating_base?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
  short_list_images?: Maybe<Scalars['jsonb']['output']>;
  tags?: Maybe<Scalars['_varchar']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  zillow_deep_search_results?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_AttributesAnalyzed_ImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_AttributesNeighborhood_LevelsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_AttributesShort_List_ImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_AttributesZillow_Deep_Search_ResultsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Aggregate_Order_By = {
  avg?: InputMaybe<Mls_Listing_Internal_Attributes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mls_Listing_Internal_Attributes_Max_Order_By>;
  min?: InputMaybe<Mls_Listing_Internal_Attributes_Min_Order_By>;
  stddev?: InputMaybe<Mls_Listing_Internal_Attributes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mls_Listing_Internal_Attributes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mls_Listing_Internal_Attributes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mls_Listing_Internal_Attributes_Sum_Order_By>;
  var_pop?: InputMaybe<Mls_Listing_Internal_Attributes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mls_Listing_Internal_Attributes_Var_Samp_Order_By>;
  variance?: InputMaybe<Mls_Listing_Internal_Attributes_Variance_Order_By>;
};

/** order by avg() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Avg_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mls_listing_internal_attributes". All fields are combined with a logical 'AND'. */
export type Mls_Listing_Internal_Attributes_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Bool_Exp>>;
  _not?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Bool_Exp>>;
  analyzed_images?: InputMaybe<Jsonb_Comparison_Exp>;
  census_tract_county_code?: InputMaybe<String_Comparison_Exp>;
  census_tract_income_level?: InputMaybe<String_Comparison_Exp>;
  census_tract_median_family_income?: InputMaybe<Float_Comparison_Exp>;
  census_tract_percent_below_poverty_line?: InputMaybe<Float_Comparison_Exp>;
  census_tract_tract_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  guidance_price?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_status?: InputMaybe<String_Comparison_Exp>;
  is_census_tract_opportunity_zone?: InputMaybe<Boolean_Comparison_Exp>;
  is_in_customer_buy_box?: InputMaybe<Boolean_Comparison_Exp>;
  is_in_real_estate_buy_box?: InputMaybe<Boolean_Comparison_Exp>;
  is_persisted_in_algolia?: InputMaybe<Boolean_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighborhood_levels?: InputMaybe<Jsonb_Comparison_Exp>;
  opportunity?: InputMaybe<Mls_Listings_Bool_Exp>;
  percent_over_comp?: InputMaybe<Float_Comparison_Exp>;
  rating_base?: InputMaybe<Float_Comparison_Exp>;
  rent?: InputMaybe<Numeric_Comparison_Exp>;
  short_list_images?: InputMaybe<Jsonb_Comparison_Exp>;
  tags?: InputMaybe<_Varchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  zillow_deep_search_results?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** order by max() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Max_Order_By = {
  census_tract_county_code?: InputMaybe<Order_By>;
  census_tract_income_level?: InputMaybe<Order_By>;
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  census_tract_tract_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_status?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Min_Order_By = {
  census_tract_county_code?: InputMaybe<Order_By>;
  census_tract_income_level?: InputMaybe<Order_By>;
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  census_tract_tract_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_status?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mls_listing_internal_attributes". */
export type Mls_Listing_Internal_Attributes_Order_By = {
  analyzed_images?: InputMaybe<Order_By>;
  census_tract_county_code?: InputMaybe<Order_By>;
  census_tract_income_level?: InputMaybe<Order_By>;
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  census_tract_tract_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_status?: InputMaybe<Order_By>;
  is_census_tract_opportunity_zone?: InputMaybe<Order_By>;
  is_in_customer_buy_box?: InputMaybe<Order_By>;
  is_in_real_estate_buy_box?: InputMaybe<Order_By>;
  is_persisted_in_algolia?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  neighborhood_levels?: InputMaybe<Order_By>;
  opportunity?: InputMaybe<Mls_Listings_Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  short_list_images?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  zillow_deep_search_results?: InputMaybe<Order_By>;
};

/** select columns of table "mls_listing_internal_attributes" */
export enum Mls_Listing_Internal_Attributes_Select_Column {
  /** column name */
  AnalyzedImages = 'analyzed_images',
  /** column name */
  CensusTractCountyCode = 'census_tract_county_code',
  /** column name */
  CensusTractIncomeLevel = 'census_tract_income_level',
  /** column name */
  CensusTractMedianFamilyIncome = 'census_tract_median_family_income',
  /** column name */
  CensusTractPercentBelowPovertyLine = 'census_tract_percent_below_poverty_line',
  /** column name */
  CensusTractTractCode = 'census_tract_tract_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuidancePrice = 'guidance_price',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStatus = 'internal_status',
  /** column name */
  IsCensusTractOpportunityZone = 'is_census_tract_opportunity_zone',
  /** column name */
  IsInCustomerBuyBox = 'is_in_customer_buy_box',
  /** column name */
  IsInRealEstateBuyBox = 'is_in_real_estate_buy_box',
  /** column name */
  IsPersistedInAlgolia = 'is_persisted_in_algolia',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  NeighborhoodLevels = 'neighborhood_levels',
  /** column name */
  PercentOverComp = 'percent_over_comp',
  /** column name */
  RatingBase = 'rating_base',
  /** column name */
  Rent = 'rent',
  /** column name */
  ShortListImages = 'short_list_images',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  ZillowDeepSearchResults = 'zillow_deep_search_results'
}

/** order by stddev() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Stddev_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Stddev_Pop_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Stddev_Samp_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Listing_Internal_Attributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Listing_Internal_Attributes_Stream_Cursor_Value_Input = {
  analyzed_images?: InputMaybe<Scalars['jsonb']['input']>;
  census_tract_county_code?: InputMaybe<Scalars['String']['input']>;
  census_tract_income_level?: InputMaybe<Scalars['String']['input']>;
  census_tract_median_family_income?: InputMaybe<Scalars['Float']['input']>;
  census_tract_percent_below_poverty_line?: InputMaybe<Scalars['Float']['input']>;
  census_tract_tract_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  guidance_price?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_status?: InputMaybe<Scalars['String']['input']>;
  is_census_tract_opportunity_zone?: InputMaybe<Scalars['Boolean']['input']>;
  is_in_customer_buy_box?: InputMaybe<Scalars['Boolean']['input']>;
  is_in_real_estate_buy_box?: InputMaybe<Scalars['Boolean']['input']>;
  is_persisted_in_algolia?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  neighborhood_levels?: InputMaybe<Scalars['jsonb']['input']>;
  percent_over_comp?: InputMaybe<Scalars['Float']['input']>;
  rating_base?: InputMaybe<Scalars['Float']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  short_list_images?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['_varchar']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  zillow_deep_search_results?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by sum() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Sum_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Var_Pop_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Var_Samp_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mls_listing_internal_attributes" */
export type Mls_Listing_Internal_Attributes_Variance_Order_By = {
  census_tract_median_family_income?: InputMaybe<Order_By>;
  census_tract_percent_below_poverty_line?: InputMaybe<Order_By>;
  guidance_price?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rating_base?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Maintains a list of key value overrides for the mls_listings table. */
export type Mls_Listing_Overrides = {
  __typename: 'mls_listing_overrides';
  column_name: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  mls_listing_id: Scalars['uuid']['output'];
  original_value?: Maybe<Scalars['String']['output']>;
  override_value?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mls_listing_overrides" */
export type Mls_Listing_Overrides_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mls_Listing_Overrides_Max_Order_By>;
  min?: InputMaybe<Mls_Listing_Overrides_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "mls_listing_overrides". All fields are combined with a logical 'AND'. */
export type Mls_Listing_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Listing_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Mls_Listing_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Listing_Overrides_Bool_Exp>>;
  column_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_value?: InputMaybe<String_Comparison_Exp>;
  override_value?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "mls_listing_overrides" */
export type Mls_Listing_Overrides_Max_Order_By = {
  column_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  original_value?: InputMaybe<Order_By>;
  override_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mls_listing_overrides" */
export type Mls_Listing_Overrides_Min_Order_By = {
  column_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  original_value?: InputMaybe<Order_By>;
  override_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mls_listing_overrides". */
export type Mls_Listing_Overrides_Order_By = {
  column_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  original_value?: InputMaybe<Order_By>;
  override_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mls_listing_overrides" */
export enum Mls_Listing_Overrides_Select_Column {
  /** column name */
  ColumnName = 'column_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  OriginalValue = 'original_value',
  /** column name */
  OverrideValue = 'override_value',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "mls_listing_overrides" */
export type Mls_Listing_Overrides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Listing_Overrides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Listing_Overrides_Stream_Cursor_Value_Input = {
  column_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  original_value?: InputMaybe<Scalars['String']['input']>;
  override_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "mls_listing_photos" */
export type Mls_Listing_Photos = {
  __typename: 'mls_listing_photos';
  created_at: Scalars['timestamptz']['output'];
  display_order?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  mls_listing: Mls_Listings;
  mls_listing_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** order by aggregate values of table "mls_listing_photos" */
export type Mls_Listing_Photos_Aggregate_Order_By = {
  avg?: InputMaybe<Mls_Listing_Photos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mls_Listing_Photos_Max_Order_By>;
  min?: InputMaybe<Mls_Listing_Photos_Min_Order_By>;
  stddev?: InputMaybe<Mls_Listing_Photos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mls_Listing_Photos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mls_Listing_Photos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mls_Listing_Photos_Sum_Order_By>;
  var_pop?: InputMaybe<Mls_Listing_Photos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mls_Listing_Photos_Var_Samp_Order_By>;
  variance?: InputMaybe<Mls_Listing_Photos_Variance_Order_By>;
};

/** order by avg() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mls_listing_photos". All fields are combined with a logical 'AND'. */
export type Mls_Listing_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Listing_Photos_Bool_Exp>>;
  _not?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Listing_Photos_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mls_listing_photos". */
export type Mls_Listing_Photos_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mls_listing_photos" */
export enum Mls_Listing_Photos_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** order by stddev() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mls_listing_photos" */
export type Mls_Listing_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Listing_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Listing_Photos_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mls_listing_photos" */
export type Mls_Listing_Photos_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "mls_listing_promotions" */
export type Mls_Listing_Promotions = {
  __typename: 'mls_listing_promotions';
  amount: Scalars['numeric']['output'];
  category: Scalars['String']['output'];
  display_message: Scalars['String']['output'];
  end_date: Scalars['date']['output'];
  frequency: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
};

/** order by aggregate values of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Aggregate_Order_By = {
  avg?: InputMaybe<Mls_Listing_Promotions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mls_Listing_Promotions_Max_Order_By>;
  min?: InputMaybe<Mls_Listing_Promotions_Min_Order_By>;
  stddev?: InputMaybe<Mls_Listing_Promotions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mls_Listing_Promotions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mls_Listing_Promotions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mls_Listing_Promotions_Sum_Order_By>;
  var_pop?: InputMaybe<Mls_Listing_Promotions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mls_Listing_Promotions_Var_Samp_Order_By>;
  variance?: InputMaybe<Mls_Listing_Promotions_Variance_Order_By>;
};

/** order by avg() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mls_listing_promotions". All fields are combined with a logical 'AND'. */
export type Mls_Listing_Promotions_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Listing_Promotions_Bool_Exp>>;
  _not?: InputMaybe<Mls_Listing_Promotions_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Listing_Promotions_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  display_message?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  display_message?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  display_message?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mls_listing_promotions". */
export type Mls_Listing_Promotions_Order_By = {
  amount?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  display_message?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** select columns of table "mls_listing_promotions" */
export enum Mls_Listing_Promotions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Category = 'category',
  /** column name */
  DisplayMessage = 'display_message',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'start_date'
}

/** order by stddev() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Listing_Promotions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Listing_Promotions_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  display_message?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by sum() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mls_listing_promotions" */
export type Mls_Listing_Promotions_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "mls_listings" */
export type Mls_Listings = {
  __typename: 'mls_listings';
  area?: Maybe<Scalars['String']['output']>;
  audit_results?: Maybe<Scalars['jsonb']['output']>;
  baths_full?: Maybe<Scalars['Float']['output']>;
  baths_half?: Maybe<Scalars['Float']['output']>;
  baths_total?: Maybe<Scalars['Float']['output']>;
  baths_weighted?: Maybe<Scalars['numeric']['output']>;
  beds?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  co_listing_agent?: Maybe<Seller_Agents>;
  co_listing_agent_id?: Maybe<Scalars['uuid']['output']>;
  co_listing_office_id?: Maybe<Scalars['uuid']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  delivery_line?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_line_1?: Maybe<Scalars['String']['output']>;
  display_line_2?: Maybe<Scalars['String']['output']>;
  features_amenities?: Maybe<Scalars['_varchar']['output']>;
  features_appliances_and_equipment?: Maybe<Scalars['_varchar']['output']>;
  features_bathrooms?: Maybe<Scalars['_varchar']['output']>;
  features_bedrooms?: Maybe<Scalars['_varchar']['output']>;
  features_community?: Maybe<Scalars['_varchar']['output']>;
  features_cooling?: Maybe<Scalars['_varchar']['output']>;
  features_dining_room?: Maybe<Scalars['_varchar']['output']>;
  features_disclosures?: Maybe<Scalars['_varchar']['output']>;
  features_doors?: Maybe<Scalars['_varchar']['output']>;
  features_energy_saving?: Maybe<Scalars['_varchar']['output']>;
  features_exterior_features?: Maybe<Scalars['_varchar']['output']>;
  features_fees?: Maybe<Scalars['_varchar']['output']>;
  features_fence?: Maybe<Scalars['_varchar']['output']>;
  features_fireplaces?: Maybe<Scalars['_varchar']['output']>;
  features_foundation?: Maybe<Scalars['_varchar']['output']>;
  features_garage?: Maybe<Scalars['_varchar']['output']>;
  features_heating?: Maybe<Scalars['_varchar']['output']>;
  features_home_owners_association?: Maybe<Scalars['_varchar']['output']>;
  features_house?: Maybe<Scalars['_varchar']['output']>;
  features_interior?: Maybe<Scalars['_varchar']['output']>;
  features_interior_features?: Maybe<Scalars['_varchar']['output']>;
  features_kitchen?: Maybe<Scalars['_varchar']['output']>;
  features_laundry?: Maybe<Scalars['_varchar']['output']>;
  features_listing?: Maybe<Scalars['_varchar']['output']>;
  features_location?: Maybe<Scalars['_varchar']['output']>;
  features_lot?: Maybe<Scalars['_varchar']['output']>;
  features_miscellaneous?: Maybe<Scalars['_varchar']['output']>;
  features_parking?: Maybe<Scalars['_varchar']['output']>;
  features_pool?: Maybe<Scalars['_varchar']['output']>;
  features_property?: Maybe<Scalars['_varchar']['output']>;
  features_property_access?: Maybe<Scalars['_varchar']['output']>;
  features_roof?: Maybe<Scalars['_varchar']['output']>;
  features_schools?: Maybe<Scalars['_varchar']['output']>;
  features_security_system?: Maybe<Scalars['_varchar']['output']>;
  features_sewer?: Maybe<Scalars['_varchar']['output']>;
  features_spa?: Maybe<Scalars['_varchar']['output']>;
  features_taxes?: Maybe<Scalars['_varchar']['output']>;
  features_utilities?: Maybe<Scalars['_varchar']['output']>;
  features_water?: Maybe<Scalars['_varchar']['output']>;
  features_windows_and_doors?: Maybe<Scalars['_varchar']['output']>;
  firestore_id: Scalars['uuid']['output'];
  geo_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  internal_attributes: Array<Mls_Listing_Internal_Attributes>;
  is_audited?: Maybe<Scalars['Boolean']['output']>;
  is_new_construction?: Maybe<Scalars['Boolean']['output']>;
  last_audited_at?: Maybe<Scalars['timestamptz']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  listing_agent?: Maybe<Seller_Agents>;
  listing_agent_id?: Maybe<Scalars['uuid']['output']>;
  listing_date?: Maybe<Scalars['timestamptz']['output']>;
  listing_office_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  listing_searchable?: Maybe<Listing_Searchable>;
  listing_type?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lotsize_acres?: Maybe<Scalars['Float']['output']>;
  lotsize_sqft?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  market: Markets;
  market_id: Scalars['uuid']['output'];
  mls: Scalars['String']['output'];
  /** An array relationship */
  mls_listing_overrides: Array<Mls_Listing_Overrides>;
  /** An array relationship */
  mls_listing_promotions: Array<Mls_Listing_Promotions>;
  modified_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  opportunity?: Maybe<Opportunities>;
  /** An array relationship */
  opportunity_underwrites: Array<Underwrites_Opportunity_Underwrites>;
  /** An array relationship */
  photos: Array<Mls_Listing_Photos>;
  property_type?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  real_estate_acquisitions: Array<Real_Estate_Acquisitions>;
  region?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rent_prices: Array<Rent_Prices>;
  /** An array relationship */
  rent_ready_dates: Array<Rent_Ready_Dates>;
  /** An array relationship */
  rental_applications: Array<Rental_Applications>;
  /** An aggregate relationship */
  rental_applications_aggregate: Rental_Applications_Aggregate;
  school_district?: Maybe<Scalars['String']['output']>;
  school_elementary?: Maybe<Scalars['String']['output']>;
  school_high?: Maybe<Scalars['String']['output']>;
  school_middle?: Maybe<Scalars['String']['output']>;
  short_id: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  std_address?: Maybe<Scalars['jsonb']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
  system_id?: Maybe<Scalars['String']['output']>;
  tour_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  xf_attributes?: Maybe<Scalars['jsonb']['output']>;
  year_built?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsAudit_ResultsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsInternal_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Order_By>>;
  where?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsMls_Listing_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Overrides_Order_By>>;
  where?: InputMaybe<Mls_Listing_Overrides_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsMls_Listing_PromotionsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Promotions_Order_By>>;
  where?: InputMaybe<Mls_Listing_Promotions_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsOpportunity_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Order_By>>;
  where?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsPhotosArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Photos_Order_By>>;
  where?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsReal_Estate_AcquisitionsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Acquisitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Acquisitions_Order_By>>;
  where?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsRent_PricesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Prices_Order_By>>;
  where?: InputMaybe<Rent_Prices_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsRent_Ready_DatesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Ready_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Ready_Dates_Order_By>>;
  where?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsRental_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsRental_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsStd_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mls_listings" */
export type Mls_ListingsXf_AttributesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "mls_listings" */
export type Mls_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Mls_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mls_Listings_Max_Order_By>;
  min?: InputMaybe<Mls_Listings_Min_Order_By>;
  stddev?: InputMaybe<Mls_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mls_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mls_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mls_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Mls_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mls_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Mls_Listings_Variance_Order_By>;
};

/** order by avg() on columns of table "mls_listings" */
export type Mls_Listings_Avg_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mls_listings". All fields are combined with a logical 'AND'. */
export type Mls_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Listings_Bool_Exp>>;
  _not?: InputMaybe<Mls_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Listings_Bool_Exp>>;
  area?: InputMaybe<String_Comparison_Exp>;
  audit_results?: InputMaybe<Jsonb_Comparison_Exp>;
  baths_full?: InputMaybe<Float_Comparison_Exp>;
  baths_half?: InputMaybe<Float_Comparison_Exp>;
  baths_total?: InputMaybe<Float_Comparison_Exp>;
  baths_weighted?: InputMaybe<Numeric_Comparison_Exp>;
  beds?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  co_listing_agent?: InputMaybe<Seller_Agents_Bool_Exp>;
  co_listing_agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  co_listing_office_id?: InputMaybe<Uuid_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_line?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_line_1?: InputMaybe<String_Comparison_Exp>;
  display_line_2?: InputMaybe<String_Comparison_Exp>;
  features_amenities?: InputMaybe<_Varchar_Comparison_Exp>;
  features_appliances_and_equipment?: InputMaybe<_Varchar_Comparison_Exp>;
  features_bathrooms?: InputMaybe<_Varchar_Comparison_Exp>;
  features_bedrooms?: InputMaybe<_Varchar_Comparison_Exp>;
  features_community?: InputMaybe<_Varchar_Comparison_Exp>;
  features_cooling?: InputMaybe<_Varchar_Comparison_Exp>;
  features_dining_room?: InputMaybe<_Varchar_Comparison_Exp>;
  features_disclosures?: InputMaybe<_Varchar_Comparison_Exp>;
  features_doors?: InputMaybe<_Varchar_Comparison_Exp>;
  features_energy_saving?: InputMaybe<_Varchar_Comparison_Exp>;
  features_exterior_features?: InputMaybe<_Varchar_Comparison_Exp>;
  features_fees?: InputMaybe<_Varchar_Comparison_Exp>;
  features_fence?: InputMaybe<_Varchar_Comparison_Exp>;
  features_fireplaces?: InputMaybe<_Varchar_Comparison_Exp>;
  features_foundation?: InputMaybe<_Varchar_Comparison_Exp>;
  features_garage?: InputMaybe<_Varchar_Comparison_Exp>;
  features_heating?: InputMaybe<_Varchar_Comparison_Exp>;
  features_home_owners_association?: InputMaybe<_Varchar_Comparison_Exp>;
  features_house?: InputMaybe<_Varchar_Comparison_Exp>;
  features_interior?: InputMaybe<_Varchar_Comparison_Exp>;
  features_interior_features?: InputMaybe<_Varchar_Comparison_Exp>;
  features_kitchen?: InputMaybe<_Varchar_Comparison_Exp>;
  features_laundry?: InputMaybe<_Varchar_Comparison_Exp>;
  features_listing?: InputMaybe<_Varchar_Comparison_Exp>;
  features_location?: InputMaybe<_Varchar_Comparison_Exp>;
  features_lot?: InputMaybe<_Varchar_Comparison_Exp>;
  features_miscellaneous?: InputMaybe<_Varchar_Comparison_Exp>;
  features_parking?: InputMaybe<_Varchar_Comparison_Exp>;
  features_pool?: InputMaybe<_Varchar_Comparison_Exp>;
  features_property?: InputMaybe<_Varchar_Comparison_Exp>;
  features_property_access?: InputMaybe<_Varchar_Comparison_Exp>;
  features_roof?: InputMaybe<_Varchar_Comparison_Exp>;
  features_schools?: InputMaybe<_Varchar_Comparison_Exp>;
  features_security_system?: InputMaybe<_Varchar_Comparison_Exp>;
  features_sewer?: InputMaybe<_Varchar_Comparison_Exp>;
  features_spa?: InputMaybe<_Varchar_Comparison_Exp>;
  features_taxes?: InputMaybe<_Varchar_Comparison_Exp>;
  features_utilities?: InputMaybe<_Varchar_Comparison_Exp>;
  features_water?: InputMaybe<_Varchar_Comparison_Exp>;
  features_windows_and_doors?: InputMaybe<_Varchar_Comparison_Exp>;
  firestore_id?: InputMaybe<Uuid_Comparison_Exp>;
  geo_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_attributes?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
  is_audited?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_construction?: InputMaybe<Boolean_Comparison_Exp>;
  last_audited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  list_price?: InputMaybe<Numeric_Comparison_Exp>;
  listing_agent?: InputMaybe<Seller_Agents_Bool_Exp>;
  listing_agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  listing_office_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_searchable?: InputMaybe<Listing_Searchable_Bool_Exp>;
  listing_type?: InputMaybe<String_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  lotsize_acres?: InputMaybe<Float_Comparison_Exp>;
  lotsize_sqft?: InputMaybe<Bigint_Comparison_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls?: InputMaybe<String_Comparison_Exp>;
  mls_listing_overrides?: InputMaybe<Mls_Listing_Overrides_Bool_Exp>;
  mls_listing_promotions?: InputMaybe<Mls_Listing_Promotions_Bool_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  opportunity?: InputMaybe<Opportunities_Bool_Exp>;
  opportunity_underwrites?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
  photos?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  real_estate_acquisitions?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  rent_prices?: InputMaybe<Rent_Prices_Bool_Exp>;
  rent_ready_dates?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
  rental_applications?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp>;
  school_district?: InputMaybe<String_Comparison_Exp>;
  school_elementary?: InputMaybe<String_Comparison_Exp>;
  school_high?: InputMaybe<String_Comparison_Exp>;
  school_middle?: InputMaybe<String_Comparison_Exp>;
  short_id?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  std_address?: InputMaybe<Jsonb_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  style?: InputMaybe<String_Comparison_Exp>;
  subdivision?: InputMaybe<String_Comparison_Exp>;
  system_id?: InputMaybe<String_Comparison_Exp>;
  tour_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xf_attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  year_built?: InputMaybe<Int_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "mls_listings" */
export type Mls_Listings_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  co_listing_agent_id?: InputMaybe<Order_By>;
  co_listing_office_id?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_line?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  firestore_id?: InputMaybe<Order_By>;
  geo_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_audited_at?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  listing_agent_id?: InputMaybe<Order_By>;
  listing_date?: InputMaybe<Order_By>;
  listing_office_id?: InputMaybe<Order_By>;
  listing_type?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  school_district?: InputMaybe<Order_By>;
  school_elementary?: InputMaybe<Order_By>;
  school_high?: InputMaybe<Order_By>;
  school_middle?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  subdivision?: InputMaybe<Order_By>;
  system_id?: InputMaybe<Order_By>;
  tour_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mls_listings" */
export type Mls_Listings_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  co_listing_agent_id?: InputMaybe<Order_By>;
  co_listing_office_id?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_line?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  firestore_id?: InputMaybe<Order_By>;
  geo_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_audited_at?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  listing_agent_id?: InputMaybe<Order_By>;
  listing_date?: InputMaybe<Order_By>;
  listing_office_id?: InputMaybe<Order_By>;
  listing_type?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  school_district?: InputMaybe<Order_By>;
  school_elementary?: InputMaybe<Order_By>;
  school_high?: InputMaybe<Order_By>;
  school_middle?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  subdivision?: InputMaybe<Order_By>;
  system_id?: InputMaybe<Order_By>;
  tour_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mls_listings". */
export type Mls_Listings_Order_By = {
  area?: InputMaybe<Order_By>;
  audit_results?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  co_listing_agent?: InputMaybe<Seller_Agents_Order_By>;
  co_listing_agent_id?: InputMaybe<Order_By>;
  co_listing_office_id?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_line?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  features_amenities?: InputMaybe<Order_By>;
  features_appliances_and_equipment?: InputMaybe<Order_By>;
  features_bathrooms?: InputMaybe<Order_By>;
  features_bedrooms?: InputMaybe<Order_By>;
  features_community?: InputMaybe<Order_By>;
  features_cooling?: InputMaybe<Order_By>;
  features_dining_room?: InputMaybe<Order_By>;
  features_disclosures?: InputMaybe<Order_By>;
  features_doors?: InputMaybe<Order_By>;
  features_energy_saving?: InputMaybe<Order_By>;
  features_exterior_features?: InputMaybe<Order_By>;
  features_fees?: InputMaybe<Order_By>;
  features_fence?: InputMaybe<Order_By>;
  features_fireplaces?: InputMaybe<Order_By>;
  features_foundation?: InputMaybe<Order_By>;
  features_garage?: InputMaybe<Order_By>;
  features_heating?: InputMaybe<Order_By>;
  features_home_owners_association?: InputMaybe<Order_By>;
  features_house?: InputMaybe<Order_By>;
  features_interior?: InputMaybe<Order_By>;
  features_interior_features?: InputMaybe<Order_By>;
  features_kitchen?: InputMaybe<Order_By>;
  features_laundry?: InputMaybe<Order_By>;
  features_listing?: InputMaybe<Order_By>;
  features_location?: InputMaybe<Order_By>;
  features_lot?: InputMaybe<Order_By>;
  features_miscellaneous?: InputMaybe<Order_By>;
  features_parking?: InputMaybe<Order_By>;
  features_pool?: InputMaybe<Order_By>;
  features_property?: InputMaybe<Order_By>;
  features_property_access?: InputMaybe<Order_By>;
  features_roof?: InputMaybe<Order_By>;
  features_schools?: InputMaybe<Order_By>;
  features_security_system?: InputMaybe<Order_By>;
  features_sewer?: InputMaybe<Order_By>;
  features_spa?: InputMaybe<Order_By>;
  features_taxes?: InputMaybe<Order_By>;
  features_utilities?: InputMaybe<Order_By>;
  features_water?: InputMaybe<Order_By>;
  features_windows_and_doors?: InputMaybe<Order_By>;
  firestore_id?: InputMaybe<Order_By>;
  geo_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_attributes_aggregate?: InputMaybe<Mls_Listing_Internal_Attributes_Aggregate_Order_By>;
  is_audited?: InputMaybe<Order_By>;
  is_new_construction?: InputMaybe<Order_By>;
  last_audited_at?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  listing_agent?: InputMaybe<Seller_Agents_Order_By>;
  listing_agent_id?: InputMaybe<Order_By>;
  listing_date?: InputMaybe<Order_By>;
  listing_office_id?: InputMaybe<Order_By>;
  listing_searchable?: InputMaybe<Listing_Searchable_Order_By>;
  listing_type?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  mls_listing_overrides_aggregate?: InputMaybe<Mls_Listing_Overrides_Aggregate_Order_By>;
  mls_listing_promotions_aggregate?: InputMaybe<Mls_Listing_Promotions_Aggregate_Order_By>;
  modified_at?: InputMaybe<Order_By>;
  opportunity?: InputMaybe<Opportunities_Order_By>;
  opportunity_underwrites_aggregate?: InputMaybe<Underwrites_Opportunity_Underwrites_Aggregate_Order_By>;
  photos_aggregate?: InputMaybe<Mls_Listing_Photos_Aggregate_Order_By>;
  property_type?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  real_estate_acquisitions_aggregate?: InputMaybe<Real_Estate_Acquisitions_Aggregate_Order_By>;
  region?: InputMaybe<Order_By>;
  rent_prices_aggregate?: InputMaybe<Rent_Prices_Aggregate_Order_By>;
  rent_ready_dates_aggregate?: InputMaybe<Rent_Ready_Dates_Aggregate_Order_By>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Order_By>;
  school_district?: InputMaybe<Order_By>;
  school_elementary?: InputMaybe<Order_By>;
  school_high?: InputMaybe<Order_By>;
  school_middle?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  std_address?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  subdivision?: InputMaybe<Order_By>;
  system_id?: InputMaybe<Order_By>;
  tour_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xf_attributes?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** select columns of table "mls_listings" */
export enum Mls_Listings_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AuditResults = 'audit_results',
  /** column name */
  BathsFull = 'baths_full',
  /** column name */
  BathsHalf = 'baths_half',
  /** column name */
  BathsTotal = 'baths_total',
  /** column name */
  BathsWeighted = 'baths_weighted',
  /** column name */
  Beds = 'beds',
  /** column name */
  City = 'city',
  /** column name */
  CoListingAgentId = 'co_listing_agent_id',
  /** column name */
  CoListingOfficeId = 'co_listing_office_id',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryLine = 'delivery_line',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayLine_1 = 'display_line_1',
  /** column name */
  DisplayLine_2 = 'display_line_2',
  /** column name */
  FeaturesAmenities = 'features_amenities',
  /** column name */
  FeaturesAppliancesAndEquipment = 'features_appliances_and_equipment',
  /** column name */
  FeaturesBathrooms = 'features_bathrooms',
  /** column name */
  FeaturesBedrooms = 'features_bedrooms',
  /** column name */
  FeaturesCommunity = 'features_community',
  /** column name */
  FeaturesCooling = 'features_cooling',
  /** column name */
  FeaturesDiningRoom = 'features_dining_room',
  /** column name */
  FeaturesDisclosures = 'features_disclosures',
  /** column name */
  FeaturesDoors = 'features_doors',
  /** column name */
  FeaturesEnergySaving = 'features_energy_saving',
  /** column name */
  FeaturesExteriorFeatures = 'features_exterior_features',
  /** column name */
  FeaturesFees = 'features_fees',
  /** column name */
  FeaturesFence = 'features_fence',
  /** column name */
  FeaturesFireplaces = 'features_fireplaces',
  /** column name */
  FeaturesFoundation = 'features_foundation',
  /** column name */
  FeaturesGarage = 'features_garage',
  /** column name */
  FeaturesHeating = 'features_heating',
  /** column name */
  FeaturesHomeOwnersAssociation = 'features_home_owners_association',
  /** column name */
  FeaturesHouse = 'features_house',
  /** column name */
  FeaturesInterior = 'features_interior',
  /** column name */
  FeaturesInteriorFeatures = 'features_interior_features',
  /** column name */
  FeaturesKitchen = 'features_kitchen',
  /** column name */
  FeaturesLaundry = 'features_laundry',
  /** column name */
  FeaturesListing = 'features_listing',
  /** column name */
  FeaturesLocation = 'features_location',
  /** column name */
  FeaturesLot = 'features_lot',
  /** column name */
  FeaturesMiscellaneous = 'features_miscellaneous',
  /** column name */
  FeaturesParking = 'features_parking',
  /** column name */
  FeaturesPool = 'features_pool',
  /** column name */
  FeaturesProperty = 'features_property',
  /** column name */
  FeaturesPropertyAccess = 'features_property_access',
  /** column name */
  FeaturesRoof = 'features_roof',
  /** column name */
  FeaturesSchools = 'features_schools',
  /** column name */
  FeaturesSecuritySystem = 'features_security_system',
  /** column name */
  FeaturesSewer = 'features_sewer',
  /** column name */
  FeaturesSpa = 'features_spa',
  /** column name */
  FeaturesTaxes = 'features_taxes',
  /** column name */
  FeaturesUtilities = 'features_utilities',
  /** column name */
  FeaturesWater = 'features_water',
  /** column name */
  FeaturesWindowsAndDoors = 'features_windows_and_doors',
  /** column name */
  FirestoreId = 'firestore_id',
  /** column name */
  GeoType = 'geo_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsAudited = 'is_audited',
  /** column name */
  IsNewConstruction = 'is_new_construction',
  /** column name */
  LastAuditedAt = 'last_audited_at',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  ListingAgentId = 'listing_agent_id',
  /** column name */
  ListingDate = 'listing_date',
  /** column name */
  ListingOfficeId = 'listing_office_id',
  /** column name */
  ListingType = 'listing_type',
  /** column name */
  Lng = 'lng',
  /** column name */
  LotsizeAcres = 'lotsize_acres',
  /** column name */
  LotsizeSqft = 'lotsize_sqft',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Mls = 'mls',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Region = 'region',
  /** column name */
  SchoolDistrict = 'school_district',
  /** column name */
  SchoolElementary = 'school_elementary',
  /** column name */
  SchoolHigh = 'school_high',
  /** column name */
  SchoolMiddle = 'school_middle',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  Size = 'size',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  StdAddress = 'std_address',
  /** column name */
  Street = 'street',
  /** column name */
  Style = 'style',
  /** column name */
  Subdivision = 'subdivision',
  /** column name */
  SystemId = 'system_id',
  /** column name */
  TourUrl = 'tour_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XfAttributes = 'xf_attributes',
  /** column name */
  YearBuilt = 'year_built',
  /** column name */
  Zip = 'zip'
}

/** order by stddev() on columns of table "mls_listings" */
export type Mls_Listings_Stddev_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mls_listings" */
export type Mls_Listings_Stddev_Pop_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mls_listings" */
export type Mls_Listings_Stddev_Samp_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mls_listings" */
export type Mls_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Listings_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  audit_results?: InputMaybe<Scalars['jsonb']['input']>;
  baths_full?: InputMaybe<Scalars['Float']['input']>;
  baths_half?: InputMaybe<Scalars['Float']['input']>;
  baths_total?: InputMaybe<Scalars['Float']['input']>;
  baths_weighted?: InputMaybe<Scalars['numeric']['input']>;
  beds?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  co_listing_agent_id?: InputMaybe<Scalars['uuid']['input']>;
  co_listing_office_id?: InputMaybe<Scalars['uuid']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_line?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_line_1?: InputMaybe<Scalars['String']['input']>;
  display_line_2?: InputMaybe<Scalars['String']['input']>;
  features_amenities?: InputMaybe<Scalars['_varchar']['input']>;
  features_appliances_and_equipment?: InputMaybe<Scalars['_varchar']['input']>;
  features_bathrooms?: InputMaybe<Scalars['_varchar']['input']>;
  features_bedrooms?: InputMaybe<Scalars['_varchar']['input']>;
  features_community?: InputMaybe<Scalars['_varchar']['input']>;
  features_cooling?: InputMaybe<Scalars['_varchar']['input']>;
  features_dining_room?: InputMaybe<Scalars['_varchar']['input']>;
  features_disclosures?: InputMaybe<Scalars['_varchar']['input']>;
  features_doors?: InputMaybe<Scalars['_varchar']['input']>;
  features_energy_saving?: InputMaybe<Scalars['_varchar']['input']>;
  features_exterior_features?: InputMaybe<Scalars['_varchar']['input']>;
  features_fees?: InputMaybe<Scalars['_varchar']['input']>;
  features_fence?: InputMaybe<Scalars['_varchar']['input']>;
  features_fireplaces?: InputMaybe<Scalars['_varchar']['input']>;
  features_foundation?: InputMaybe<Scalars['_varchar']['input']>;
  features_garage?: InputMaybe<Scalars['_varchar']['input']>;
  features_heating?: InputMaybe<Scalars['_varchar']['input']>;
  features_home_owners_association?: InputMaybe<Scalars['_varchar']['input']>;
  features_house?: InputMaybe<Scalars['_varchar']['input']>;
  features_interior?: InputMaybe<Scalars['_varchar']['input']>;
  features_interior_features?: InputMaybe<Scalars['_varchar']['input']>;
  features_kitchen?: InputMaybe<Scalars['_varchar']['input']>;
  features_laundry?: InputMaybe<Scalars['_varchar']['input']>;
  features_listing?: InputMaybe<Scalars['_varchar']['input']>;
  features_location?: InputMaybe<Scalars['_varchar']['input']>;
  features_lot?: InputMaybe<Scalars['_varchar']['input']>;
  features_miscellaneous?: InputMaybe<Scalars['_varchar']['input']>;
  features_parking?: InputMaybe<Scalars['_varchar']['input']>;
  features_pool?: InputMaybe<Scalars['_varchar']['input']>;
  features_property?: InputMaybe<Scalars['_varchar']['input']>;
  features_property_access?: InputMaybe<Scalars['_varchar']['input']>;
  features_roof?: InputMaybe<Scalars['_varchar']['input']>;
  features_schools?: InputMaybe<Scalars['_varchar']['input']>;
  features_security_system?: InputMaybe<Scalars['_varchar']['input']>;
  features_sewer?: InputMaybe<Scalars['_varchar']['input']>;
  features_spa?: InputMaybe<Scalars['_varchar']['input']>;
  features_taxes?: InputMaybe<Scalars['_varchar']['input']>;
  features_utilities?: InputMaybe<Scalars['_varchar']['input']>;
  features_water?: InputMaybe<Scalars['_varchar']['input']>;
  features_windows_and_doors?: InputMaybe<Scalars['_varchar']['input']>;
  firestore_id?: InputMaybe<Scalars['uuid']['input']>;
  geo_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_audited?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_construction?: InputMaybe<Scalars['Boolean']['input']>;
  last_audited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  list_price?: InputMaybe<Scalars['numeric']['input']>;
  listing_agent_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_office_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_type?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lotsize_acres?: InputMaybe<Scalars['Float']['input']>;
  lotsize_sqft?: InputMaybe<Scalars['bigint']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  mls?: InputMaybe<Scalars['String']['input']>;
  modified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  school_district?: InputMaybe<Scalars['String']['input']>;
  school_elementary?: InputMaybe<Scalars['String']['input']>;
  school_high?: InputMaybe<Scalars['String']['input']>;
  school_middle?: InputMaybe<Scalars['String']['input']>;
  short_id?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  std_address?: InputMaybe<Scalars['jsonb']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  system_id?: InputMaybe<Scalars['String']['input']>;
  tour_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xf_attributes?: InputMaybe<Scalars['jsonb']['input']>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "mls_listings" */
export type Mls_Listings_Sum_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mls_listings" */
export type Mls_Listings_Var_Pop_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mls_listings" */
export type Mls_Listings_Var_Samp_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mls_listings" */
export type Mls_Listings_Variance_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** columns and relationships of "most_recent_llc_property" */
export type Most_Recent_Llc_Property = {
  __typename: 'most_recent_llc_property';
  accounting_entity_id?: Maybe<Scalars['Int']['output']>;
  accounting_unit_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_resource_id?: Maybe<Scalars['uuid']['output']>;
  created_by_resource_type?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  ended_by_resource_id?: Maybe<Scalars['uuid']['output']>;
  ended_by_resource_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  llc?: Maybe<Llcs>;
  llc_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  portfolio_home?: Maybe<Portfolio_Homes>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  rn?: Maybe<Scalars['bigint']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "most_recent_llc_property". All fields are combined with a logical 'AND'. */
export type Most_Recent_Llc_Property_Bool_Exp = {
  _and?: InputMaybe<Array<Most_Recent_Llc_Property_Bool_Exp>>;
  _not?: InputMaybe<Most_Recent_Llc_Property_Bool_Exp>;
  _or?: InputMaybe<Array<Most_Recent_Llc_Property_Bool_Exp>>;
  accounting_entity_id?: InputMaybe<Int_Comparison_Exp>;
  accounting_unit_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_resource_type?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  ended_by_resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  ended_by_resource_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llc?: InputMaybe<Llcs_Bool_Exp>;
  llc_id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  rn?: InputMaybe<Bigint_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "most_recent_llc_property". */
export type Most_Recent_Llc_Property_Order_By = {
  accounting_entity_id?: InputMaybe<Order_By>;
  accounting_unit_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_resource_id?: InputMaybe<Order_By>;
  created_by_resource_type?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  ended_by_resource_id?: InputMaybe<Order_By>;
  ended_by_resource_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llc?: InputMaybe<Llcs_Order_By>;
  llc_id?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  property_id?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "most_recent_llc_property" */
export enum Most_Recent_Llc_Property_Select_Column {
  /** column name */
  AccountingEntityId = 'accounting_entity_id',
  /** column name */
  AccountingUnitId = 'accounting_unit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByResourceId = 'created_by_resource_id',
  /** column name */
  CreatedByResourceType = 'created_by_resource_type',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndedByResourceId = 'ended_by_resource_id',
  /** column name */
  EndedByResourceType = 'ended_by_resource_type',
  /** column name */
  Id = 'id',
  /** column name */
  LlcId = 'llc_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Rn = 'rn',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "most_recent_llc_property" */
export type Most_Recent_Llc_Property_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Most_Recent_Llc_Property_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Most_Recent_Llc_Property_Stream_Cursor_Value_Input = {
  accounting_entity_id?: InputMaybe<Scalars['Int']['input']>;
  accounting_unit_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_resource_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by_resource_type?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  ended_by_resource_id?: InputMaybe<Scalars['uuid']['input']>;
  ended_by_resource_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  llc_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rn?: InputMaybe<Scalars['bigint']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "most_relevant_user_identity_verification_by_user" */
export type Most_Relevant_User_Identity_Verification_By_User = {
  __typename: 'most_relevant_user_identity_verification_by_user';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  failure_code?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalidated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  invalidated_by_admin?: Maybe<Admins>;
  invalidated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  relevance_order?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_session_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verified_as_first_name?: Maybe<Scalars['String']['output']>;
  verified_as_last_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "most_relevant_user_identity_verification_by_user" */
export type Most_Relevant_User_Identity_Verification_By_UserMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "most_relevant_user_identity_verification_by_user". All fields are combined with a logical 'AND'. */
export type Most_Relevant_User_Identity_Verification_By_User_Bool_Exp = {
  _and?: InputMaybe<Array<Most_Relevant_User_Identity_Verification_By_User_Bool_Exp>>;
  _not?: InputMaybe<Most_Relevant_User_Identity_Verification_By_User_Bool_Exp>;
  _or?: InputMaybe<Array<Most_Relevant_User_Identity_Verification_By_User_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  failure_code?: InputMaybe<String_Comparison_Exp>;
  failure_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalidated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invalidated_by_admin?: InputMaybe<Admins_Bool_Exp>;
  invalidated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  relevance_order?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripe_session_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified_as_first_name?: InputMaybe<String_Comparison_Exp>;
  verified_as_last_name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "most_relevant_user_identity_verification_by_user". */
export type Most_Relevant_User_Identity_Verification_By_User_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failure_code?: InputMaybe<Order_By>;
  failure_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidated_at?: InputMaybe<Order_By>;
  invalidated_by_admin?: InputMaybe<Admins_Order_By>;
  invalidated_by_admin_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  relevance_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_as_first_name?: InputMaybe<Order_By>;
  verified_as_last_name?: InputMaybe<Order_By>;
};

/** select columns of table "most_relevant_user_identity_verification_by_user" */
export enum Most_Relevant_User_Identity_Verification_By_User_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailureCode = 'failure_code',
  /** column name */
  FailureMessage = 'failure_message',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidatedAt = 'invalidated_at',
  /** column name */
  InvalidatedByAdminId = 'invalidated_by_admin_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RelevanceOrder = 'relevance_order',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSessionId = 'stripe_session_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerifiedAsFirstName = 'verified_as_first_name',
  /** column name */
  VerifiedAsLastName = 'verified_as_last_name'
}

/** Streaming cursor of the table "most_relevant_user_identity_verification_by_user" */
export type Most_Relevant_User_Identity_Verification_By_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Most_Relevant_User_Identity_Verification_By_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Most_Relevant_User_Identity_Verification_By_User_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  failure_code?: InputMaybe<Scalars['String']['input']>;
  failure_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalidated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalidated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  relevance_order?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_session_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified_as_first_name?: InputMaybe<Scalars['String']['input']>;
  verified_as_last_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "move_ins" */
export type Move_Ins = {
  __typename: 'move_ins';
  created_at: Scalars['timestamptz']['output'];
  follow_up_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  fotonotes_link?: Maybe<Scalars['String']['output']>;
  has_payment_at_move_in?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  move_in_at?: Maybe<Scalars['timestamptz']['output']>;
  owner_admin_id?: Maybe<Scalars['uuid']['output']>;
  rental_application_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  zendesk_link?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "move_ins" */
export type Move_Ins_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Move_Ins_Max_Order_By>;
  min?: InputMaybe<Move_Ins_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "move_ins". All fields are combined with a logical 'AND'. */
export type Move_Ins_Bool_Exp = {
  _and?: InputMaybe<Array<Move_Ins_Bool_Exp>>;
  _not?: InputMaybe<Move_Ins_Bool_Exp>;
  _or?: InputMaybe<Array<Move_Ins_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  follow_up_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fotonotes_link?: InputMaybe<String_Comparison_Exp>;
  has_payment_at_move_in?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  move_in_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  owner_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zendesk_link?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "move_ins" */
export type Move_Ins_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  follow_up_completed_at?: InputMaybe<Order_By>;
  fotonotes_link?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  move_in_at?: InputMaybe<Order_By>;
  owner_admin_id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zendesk_link?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "move_ins" */
export type Move_Ins_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  follow_up_completed_at?: InputMaybe<Order_By>;
  fotonotes_link?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  move_in_at?: InputMaybe<Order_By>;
  owner_admin_id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zendesk_link?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "move_ins". */
export type Move_Ins_Order_By = {
  created_at?: InputMaybe<Order_By>;
  follow_up_completed_at?: InputMaybe<Order_By>;
  fotonotes_link?: InputMaybe<Order_By>;
  has_payment_at_move_in?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  move_in_at?: InputMaybe<Order_By>;
  owner_admin_id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zendesk_link?: InputMaybe<Order_By>;
};

/** select columns of table "move_ins" */
export enum Move_Ins_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FollowUpCompletedAt = 'follow_up_completed_at',
  /** column name */
  FotonotesLink = 'fotonotes_link',
  /** column name */
  HasPaymentAtMoveIn = 'has_payment_at_move_in',
  /** column name */
  Id = 'id',
  /** column name */
  MoveInAt = 'move_in_at',
  /** column name */
  OwnerAdminId = 'owner_admin_id',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZendeskLink = 'zendesk_link'
}

/** Streaming cursor of the table "move_ins" */
export type Move_Ins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Move_Ins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Move_Ins_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  follow_up_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fotonotes_link?: InputMaybe<Scalars['String']['input']>;
  has_payment_at_move_in?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  move_in_at?: InputMaybe<Scalars['timestamptz']['input']>;
  owner_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zendesk_link?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "municipalities" */
export type Municipalities = {
  __typename: 'municipalities';
  /** An array relationship */
  addresses: Array<Addresses>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  market: Markets;
  market_id: Scalars['uuid']['output'];
  /** An array relationship */
  municipality_contacts: Array<Municipality_Contacts>;
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "municipalities" */
export type MunicipalitiesAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


/** columns and relationships of "municipalities" */
export type MunicipalitiesMunicipality_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Municipality_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Municipality_Contacts_Order_By>>;
  where?: InputMaybe<Municipality_Contacts_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "municipalities". All fields are combined with a logical 'AND'. */
export type Municipalities_Bool_Exp = {
  _and?: InputMaybe<Array<Municipalities_Bool_Exp>>;
  _not?: InputMaybe<Municipalities_Bool_Exp>;
  _or?: InputMaybe<Array<Municipalities_Bool_Exp>>;
  addresses?: InputMaybe<Addresses_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_contacts?: InputMaybe<Municipality_Contacts_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "municipalities". */
export type Municipalities_Order_By = {
  addresses_aggregate?: InputMaybe<Addresses_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  municipality_contacts_aggregate?: InputMaybe<Municipality_Contacts_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** select columns of table "municipalities" */
export enum Municipalities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

/** Streaming cursor of the table "municipalities" */
export type Municipalities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Municipalities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Municipalities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "municipality_contacts" */
export type Municipality_Contacts = {
  __typename: 'municipality_contacts';
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  municipality: Municipalities;
  municipality_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "municipality_contacts" */
export type Municipality_Contacts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Municipality_Contacts_Max_Order_By>;
  min?: InputMaybe<Municipality_Contacts_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "municipality_contacts". All fields are combined with a logical 'AND'. */
export type Municipality_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Municipality_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Municipality_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Municipality_Contacts_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Municipalities_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "municipality_contacts" */
export type Municipality_Contacts_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "municipality_contacts" */
export type Municipality_Contacts_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "municipality_contacts". */
export type Municipality_Contacts_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Municipalities_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "municipality_contacts" */
export enum Municipality_Contacts_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "municipality_contacts" */
export type Municipality_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Municipality_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Municipality_Contacts_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename: 'mutation_root';
  /** delete data from the table: "cashouts_pending_liabilities" */
  delete_cashouts_pending_liabilities?: Maybe<Cashouts_Pending_Liabilities_Mutation_Response>;
  /** delete single row from the table: "cashouts_pending_liabilities" */
  delete_cashouts_pending_liabilities_by_pk?: Maybe<Cashouts_Pending_Liabilities>;
  /** delete data from the table: "collections_rental_liabilities" */
  delete_collections_rental_liabilities?: Maybe<Collections_Rental_Liabilities_Mutation_Response>;
  /** delete single row from the table: "collections_rental_liabilities" */
  delete_collections_rental_liabilities_by_pk?: Maybe<Collections_Rental_Liabilities>;
  /** delete data from the table: "documents" */
  delete_documents?: Maybe<Documents_Mutation_Response>;
  /** delete single row from the table: "documents" */
  delete_documents_by_pk?: Maybe<Documents>;
  /** delete data from the table: "recurring_credits" */
  delete_recurring_credits?: Maybe<Recurring_Credits_Mutation_Response>;
  /** delete single row from the table: "recurring_credits" */
  delete_recurring_credits_by_pk?: Maybe<Recurring_Credits>;
  /** delete data from the table: "rental_application_occupants" */
  delete_rental_application_occupants?: Maybe<Rental_Application_Occupants_Mutation_Response>;
  /** delete single row from the table: "rental_application_occupants" */
  delete_rental_application_occupants_by_pk?: Maybe<Rental_Application_Occupants>;
  /** delete data from the table: "rental_application_pets" */
  delete_rental_application_pets?: Maybe<Rental_Application_Pets_Mutation_Response>;
  /** delete single row from the table: "rental_application_pets" */
  delete_rental_application_pets_by_pk?: Maybe<Rental_Application_Pets>;
  /** delete data from the table: "rental_application_vehicles" */
  delete_rental_application_vehicles?: Maybe<Rental_Application_Vehicles_Mutation_Response>;
  /** delete single row from the table: "rental_application_vehicles" */
  delete_rental_application_vehicles_by_pk?: Maybe<Rental_Application_Vehicles>;
  /** delete data from the table: "rental_credits" */
  delete_rental_credits?: Maybe<Rental_Credits_Mutation_Response>;
  /** delete single row from the table: "rental_credits" */
  delete_rental_credits_by_pk?: Maybe<Rental_Credits>;
  /** delete data from the table: "rental_liabilities" */
  delete_rental_liabilities?: Maybe<Rental_Liabilities_Mutation_Response>;
  /** delete single row from the table: "rental_liabilities" */
  delete_rental_liabilities_by_pk?: Maybe<Rental_Liabilities>;
  /** delete data from the table: "vendor_markets" */
  delete_vendor_markets?: Maybe<Vendor_Markets_Mutation_Response>;
  /** delete single row from the table: "vendor_markets" */
  delete_vendor_markets_by_pk?: Maybe<Vendor_Markets>;
  /** insert data into the table: "admins" */
  insert_admins?: Maybe<Admins_Mutation_Response>;
  /** insert a single row into the table: "admins" */
  insert_admins_one?: Maybe<Admins>;
  /** insert data into the table: "agent_lead_group_owners" */
  insert_agent_lead_group_owners?: Maybe<Agent_Lead_Group_Owners_Mutation_Response>;
  /** insert a single row into the table: "agent_lead_group_owners" */
  insert_agent_lead_group_owners_one?: Maybe<Agent_Lead_Group_Owners>;
  /** insert data into the table: "buildium_resident_center_users" */
  insert_buildium_resident_center_users?: Maybe<Buildium_Resident_Center_Users_Mutation_Response>;
  /** insert a single row into the table: "buildium_resident_center_users" */
  insert_buildium_resident_center_users_one?: Maybe<Buildium_Resident_Center_Users>;
  /** insert data into the table: "buildium_transactions" */
  insert_buildium_transactions?: Maybe<Buildium_Transactions_Mutation_Response>;
  /** insert a single row into the table: "buildium_transactions" */
  insert_buildium_transactions_one?: Maybe<Buildium_Transactions>;
  /** insert data into the table: "capabilities" */
  insert_capabilities?: Maybe<Capabilities_Mutation_Response>;
  /** insert a single row into the table: "capabilities" */
  insert_capabilities_one?: Maybe<Capabilities>;
  /** insert data into the table: "cashouts_pending_liabilities" */
  insert_cashouts_pending_liabilities?: Maybe<Cashouts_Pending_Liabilities_Mutation_Response>;
  /** insert a single row into the table: "cashouts_pending_liabilities" */
  insert_cashouts_pending_liabilities_one?: Maybe<Cashouts_Pending_Liabilities>;
  /** insert data into the table: "collection_payment_promises" */
  insert_collection_payment_promises?: Maybe<Collection_Payment_Promises_Mutation_Response>;
  /** insert a single row into the table: "collection_payment_promises" */
  insert_collection_payment_promises_one?: Maybe<Collection_Payment_Promises>;
  /** insert data into the table: "dashboards" */
  insert_dashboards?: Maybe<Dashboards_Mutation_Response>;
  /** insert a single row into the table: "dashboards" */
  insert_dashboards_one?: Maybe<Dashboards>;
  /** insert data into the table: "dispositions.portfolio_home_disposition_counterparties" */
  insert_dispositions_portfolio_home_disposition_counterparties?: Maybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Mutation_Response>;
  /** insert a single row into the table: "dispositions.portfolio_home_disposition_counterparties" */
  insert_dispositions_portfolio_home_disposition_counterparties_one?: Maybe<Dispositions_Portfolio_Home_Disposition_Counterparties>;
  /** insert data into the table: "dispositions.portfolio_home_disposition_statuses" */
  insert_dispositions_portfolio_home_disposition_statuses?: Maybe<Dispositions_Portfolio_Home_Disposition_Statuses_Mutation_Response>;
  /** insert a single row into the table: "dispositions.portfolio_home_disposition_statuses" */
  insert_dispositions_portfolio_home_disposition_statuses_one?: Maybe<Dispositions_Portfolio_Home_Disposition_Statuses>;
  /** insert data into the table: "dispositions.portfolio_home_dispositions" */
  insert_dispositions_portfolio_home_dispositions?: Maybe<Dispositions_Portfolio_Home_Dispositions_Mutation_Response>;
  /** insert a single row into the table: "dispositions.portfolio_home_dispositions" */
  insert_dispositions_portfolio_home_dispositions_one?: Maybe<Dispositions_Portfolio_Home_Dispositions>;
  /** insert data into the table: "documents" */
  insert_documents?: Maybe<Documents_Mutation_Response>;
  /** insert a single row into the table: "documents" */
  insert_documents_one?: Maybe<Documents>;
  /** insert data into the table: "kafka_connector.prorated_utility_bill_line_items" */
  insert_kafka_connector_prorated_utility_bill_line_items?: Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Mutation_Response>;
  /** insert a single row into the table: "kafka_connector.prorated_utility_bill_line_items" */
  insert_kafka_connector_prorated_utility_bill_line_items_one?: Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** insert data into the table: "lockbox_codes" */
  insert_lockbox_codes?: Maybe<Lockbox_Codes_Mutation_Response>;
  /** insert a single row into the table: "lockbox_codes" */
  insert_lockbox_codes_one?: Maybe<Lockbox_Codes>;
  /** insert data into the table: "notes" */
  insert_notes?: Maybe<Notes_Mutation_Response>;
  /** insert a single row into the table: "notes" */
  insert_notes_one?: Maybe<Notes>;
  /** insert data into the table: "payments" */
  insert_payments?: Maybe<Payments_Mutation_Response>;
  /** insert a single row into the table: "payments" */
  insert_payments_one?: Maybe<Payments>;
  /** insert data into the table: "recurring_credits" */
  insert_recurring_credits?: Maybe<Recurring_Credits_Mutation_Response>;
  /** insert a single row into the table: "recurring_credits" */
  insert_recurring_credits_one?: Maybe<Recurring_Credits>;
  /** insert data into the table: "rental_add_ons" */
  insert_rental_add_ons?: Maybe<Rental_Add_Ons_Mutation_Response>;
  /** insert a single row into the table: "rental_add_ons" */
  insert_rental_add_ons_one?: Maybe<Rental_Add_Ons>;
  /** insert data into the table: "rental_agreement_histories" */
  insert_rental_agreement_histories?: Maybe<Rental_Agreement_Histories_Mutation_Response>;
  /** insert a single row into the table: "rental_agreement_histories" */
  insert_rental_agreement_histories_one?: Maybe<Rental_Agreement_Histories>;
  /** insert data into the table: "rental_application_manager.admin_assignments" */
  insert_rental_application_manager_admin_assignments?: Maybe<Rental_Application_Manager_Admin_Assignments_Mutation_Response>;
  /** insert a single row into the table: "rental_application_manager.admin_assignments" */
  insert_rental_application_manager_admin_assignments_one?: Maybe<Rental_Application_Manager_Admin_Assignments>;
  /** insert data into the table: "rental_application_manager.application_escalations" */
  insert_rental_application_manager_application_escalations?: Maybe<Rental_Application_Manager_Application_Escalations_Mutation_Response>;
  /** insert a single row into the table: "rental_application_manager.application_escalations" */
  insert_rental_application_manager_application_escalations_one?: Maybe<Rental_Application_Manager_Application_Escalations>;
  /** insert data into the table: "rental_application_manager.application_snoozes" */
  insert_rental_application_manager_application_snoozes?: Maybe<Rental_Application_Manager_Application_Snoozes_Mutation_Response>;
  /** insert a single row into the table: "rental_application_manager.application_snoozes" */
  insert_rental_application_manager_application_snoozes_one?: Maybe<Rental_Application_Manager_Application_Snoozes>;
  /** insert data into the table: "rental_application_occupants" */
  insert_rental_application_occupants?: Maybe<Rental_Application_Occupants_Mutation_Response>;
  /** insert a single row into the table: "rental_application_occupants" */
  insert_rental_application_occupants_one?: Maybe<Rental_Application_Occupants>;
  /** insert data into the table: "rental_application_pets" */
  insert_rental_application_pets?: Maybe<Rental_Application_Pets_Mutation_Response>;
  /** insert a single row into the table: "rental_application_pets" */
  insert_rental_application_pets_one?: Maybe<Rental_Application_Pets>;
  /** insert data into the table: "rental_application_vehicles" */
  insert_rental_application_vehicles?: Maybe<Rental_Application_Vehicles_Mutation_Response>;
  /** insert a single row into the table: "rental_application_vehicles" */
  insert_rental_application_vehicles_one?: Maybe<Rental_Application_Vehicles>;
  /** insert data into the table: "rental_credits" */
  insert_rental_credits?: Maybe<Rental_Credits_Mutation_Response>;
  /** insert a single row into the table: "rental_credits" */
  insert_rental_credits_one?: Maybe<Rental_Credits>;
  /** insert data into the table: "rental_liabilities" */
  insert_rental_liabilities?: Maybe<Rental_Liabilities_Mutation_Response>;
  /** insert a single row into the table: "rental_liabilities" */
  insert_rental_liabilities_one?: Maybe<Rental_Liabilities>;
  /** insert data into the table: "rental_move_in_fees" */
  insert_rental_move_in_fees?: Maybe<Rental_Move_In_Fees_Mutation_Response>;
  /** insert a single row into the table: "rental_move_in_fees" */
  insert_rental_move_in_fees_one?: Maybe<Rental_Move_In_Fees>;
  /** insert data into the table: "user_document_requests" */
  insert_user_document_requests?: Maybe<User_Document_Requests_Mutation_Response>;
  /** insert a single row into the table: "user_document_requests" */
  insert_user_document_requests_one?: Maybe<User_Document_Requests>;
  /** insert data into the table: "utility_responsibilities" */
  insert_utility_responsibilities?: Maybe<Utility_Responsibilities_Mutation_Response>;
  /** insert a single row into the table: "utility_responsibilities" */
  insert_utility_responsibilities_one?: Maybe<Utility_Responsibilities>;
  /** insert data into the table: "vendor_markets" */
  insert_vendor_markets?: Maybe<Vendor_Markets_Mutation_Response>;
  /** insert a single row into the table: "vendor_markets" */
  insert_vendor_markets_one?: Maybe<Vendor_Markets>;
  /** update data of the table: "agent_lead_group_owners" */
  update_agent_lead_group_owners?: Maybe<Agent_Lead_Group_Owners_Mutation_Response>;
  /** update single row of the table: "agent_lead_group_owners" */
  update_agent_lead_group_owners_by_pk?: Maybe<Agent_Lead_Group_Owners>;
  /** update multiples rows of table: "agent_lead_group_owners" */
  update_agent_lead_group_owners_many?: Maybe<Array<Maybe<Agent_Lead_Group_Owners_Mutation_Response>>>;
  /** update data of the table: "agreements" */
  update_agreements?: Maybe<Agreements_Mutation_Response>;
  /** update single row of the table: "agreements" */
  update_agreements_by_pk?: Maybe<Agreements>;
  /** update multiples rows of table: "agreements" */
  update_agreements_many?: Maybe<Array<Maybe<Agreements_Mutation_Response>>>;
  /** update data of the table: "applicant_income_underwrites.user_income_sources" */
  update_applicant_income_underwrites_user_income_sources?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Mutation_Response>;
  /** update single row of the table: "applicant_income_underwrites.user_income_sources" */
  update_applicant_income_underwrites_user_income_sources_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources>;
  /** update data of the table: "applicant_income_underwrites.user_income_sources_employed" */
  update_applicant_income_underwrites_user_income_sources_employed?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Mutation_Response>;
  /** update single row of the table: "applicant_income_underwrites.user_income_sources_employed" */
  update_applicant_income_underwrites_user_income_sources_employed_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  /** update multiples rows of table: "applicant_income_underwrites.user_income_sources_employed" */
  update_applicant_income_underwrites_user_income_sources_employed_many?: Maybe<Array<Maybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Mutation_Response>>>;
  /** update multiples rows of table: "applicant_income_underwrites.user_income_sources" */
  update_applicant_income_underwrites_user_income_sources_many?: Maybe<Array<Maybe<Applicant_Income_Underwrites_User_Income_Sources_Mutation_Response>>>;
  /** update data of the table: "applicant_income_underwrites.user_incomes" */
  update_applicant_income_underwrites_user_incomes?: Maybe<Applicant_Income_Underwrites_User_Incomes_Mutation_Response>;
  /** update single row of the table: "applicant_income_underwrites.user_incomes" */
  update_applicant_income_underwrites_user_incomes_by_pk?: Maybe<Applicant_Income_Underwrites_User_Incomes>;
  /** update multiples rows of table: "applicant_income_underwrites.user_incomes" */
  update_applicant_income_underwrites_user_incomes_many?: Maybe<Array<Maybe<Applicant_Income_Underwrites_User_Incomes_Mutation_Response>>>;
  /** update data of the table: "buildium_bulk_journal_entry_uploads" */
  update_buildium_bulk_journal_entry_uploads?: Maybe<Buildium_Bulk_Journal_Entry_Uploads_Mutation_Response>;
  /** update single row of the table: "buildium_bulk_journal_entry_uploads" */
  update_buildium_bulk_journal_entry_uploads_by_pk?: Maybe<Buildium_Bulk_Journal_Entry_Uploads>;
  /** update multiples rows of table: "buildium_bulk_journal_entry_uploads" */
  update_buildium_bulk_journal_entry_uploads_many?: Maybe<Array<Maybe<Buildium_Bulk_Journal_Entry_Uploads_Mutation_Response>>>;
  /** update data of the table: "buildium_resident_center_users" */
  update_buildium_resident_center_users?: Maybe<Buildium_Resident_Center_Users_Mutation_Response>;
  /** update single row of the table: "buildium_resident_center_users" */
  update_buildium_resident_center_users_by_pk?: Maybe<Buildium_Resident_Center_Users>;
  /** update multiples rows of table: "buildium_resident_center_users" */
  update_buildium_resident_center_users_many?: Maybe<Array<Maybe<Buildium_Resident_Center_Users_Mutation_Response>>>;
  /** update data of the table: "cashouts_pending_liabilities" */
  update_cashouts_pending_liabilities?: Maybe<Cashouts_Pending_Liabilities_Mutation_Response>;
  /** update single row of the table: "cashouts_pending_liabilities" */
  update_cashouts_pending_liabilities_by_pk?: Maybe<Cashouts_Pending_Liabilities>;
  /** update multiples rows of table: "cashouts_pending_liabilities" */
  update_cashouts_pending_liabilities_many?: Maybe<Array<Maybe<Cashouts_Pending_Liabilities_Mutation_Response>>>;
  /** update data of the table: "collection_payment_promises" */
  update_collection_payment_promises?: Maybe<Collection_Payment_Promises_Mutation_Response>;
  /** update single row of the table: "collection_payment_promises" */
  update_collection_payment_promises_by_pk?: Maybe<Collection_Payment_Promises>;
  /** update multiples rows of table: "collection_payment_promises" */
  update_collection_payment_promises_many?: Maybe<Array<Maybe<Collection_Payment_Promises_Mutation_Response>>>;
  /** update data of the table: "collections" */
  update_collections?: Maybe<Collections_Mutation_Response>;
  /** update single row of the table: "collections" */
  update_collections_by_pk?: Maybe<Collections>;
  /** update multiples rows of table: "collections" */
  update_collections_many?: Maybe<Array<Maybe<Collections_Mutation_Response>>>;
  /** update data of the table: "dashboards" */
  update_dashboards?: Maybe<Dashboards_Mutation_Response>;
  /** update single row of the table: "dashboards" */
  update_dashboards_by_pk?: Maybe<Dashboards>;
  /** update multiples rows of table: "dashboards" */
  update_dashboards_many?: Maybe<Array<Maybe<Dashboards_Mutation_Response>>>;
  /** update data of the table: "dispositions.portfolio_home_dispositions" */
  update_dispositions_portfolio_home_dispositions?: Maybe<Dispositions_Portfolio_Home_Dispositions_Mutation_Response>;
  /** update single row of the table: "dispositions.portfolio_home_dispositions" */
  update_dispositions_portfolio_home_dispositions_by_pk?: Maybe<Dispositions_Portfolio_Home_Dispositions>;
  /** update multiples rows of table: "dispositions.portfolio_home_dispositions" */
  update_dispositions_portfolio_home_dispositions_many?: Maybe<Array<Maybe<Dispositions_Portfolio_Home_Dispositions_Mutation_Response>>>;
  /** update data of the table: "documents" */
  update_documents?: Maybe<Documents_Mutation_Response>;
  /** update single row of the table: "documents" */
  update_documents_by_pk?: Maybe<Documents>;
  /** update multiples rows of table: "documents" */
  update_documents_many?: Maybe<Array<Maybe<Documents_Mutation_Response>>>;
  /** update data of the table: "evictions" */
  update_evictions?: Maybe<Evictions_Mutation_Response>;
  /** update single row of the table: "evictions" */
  update_evictions_by_pk?: Maybe<Evictions>;
  /** update multiples rows of table: "evictions" */
  update_evictions_many?: Maybe<Array<Maybe<Evictions_Mutation_Response>>>;
  /** update data of the table: "kafka_connector.prorated_utility_bill_line_items" */
  update_kafka_connector_prorated_utility_bill_line_items?: Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Mutation_Response>;
  /** update single row of the table: "kafka_connector.prorated_utility_bill_line_items" */
  update_kafka_connector_prorated_utility_bill_line_items_by_pk?: Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** update multiples rows of table: "kafka_connector.prorated_utility_bill_line_items" */
  update_kafka_connector_prorated_utility_bill_line_items_many?: Maybe<Array<Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Mutation_Response>>>;
  /** update data of the table: "lockbox_codes" */
  update_lockbox_codes?: Maybe<Lockbox_Codes_Mutation_Response>;
  /** update single row of the table: "lockbox_codes" */
  update_lockbox_codes_by_pk?: Maybe<Lockbox_Codes>;
  /** update multiples rows of table: "lockbox_codes" */
  update_lockbox_codes_many?: Maybe<Array<Maybe<Lockbox_Codes_Mutation_Response>>>;
  /** update data of the table: "notes" */
  update_notes?: Maybe<Notes_Mutation_Response>;
  /** update single row of the table: "notes" */
  update_notes_by_pk?: Maybe<Notes>;
  /** update multiples rows of table: "notes" */
  update_notes_many?: Maybe<Array<Maybe<Notes_Mutation_Response>>>;
  /** update data of the table: "portfolio_homes" */
  update_portfolio_homes?: Maybe<Portfolio_Homes_Mutation_Response>;
  /** update single row of the table: "portfolio_homes" */
  update_portfolio_homes_by_pk?: Maybe<Portfolio_Homes>;
  /** update multiples rows of table: "portfolio_homes" */
  update_portfolio_homes_many?: Maybe<Array<Maybe<Portfolio_Homes_Mutation_Response>>>;
  /** update data of the table: "rental_add_ons" */
  update_rental_add_ons?: Maybe<Rental_Add_Ons_Mutation_Response>;
  /** update single row of the table: "rental_add_ons" */
  update_rental_add_ons_by_pk?: Maybe<Rental_Add_Ons>;
  /** update multiples rows of table: "rental_add_ons" */
  update_rental_add_ons_many?: Maybe<Array<Maybe<Rental_Add_Ons_Mutation_Response>>>;
  /** update data of the table: "rental_agreement_histories" */
  update_rental_agreement_histories?: Maybe<Rental_Agreement_Histories_Mutation_Response>;
  /** update single row of the table: "rental_agreement_histories" */
  update_rental_agreement_histories_by_pk?: Maybe<Rental_Agreement_Histories>;
  /** update multiples rows of table: "rental_agreement_histories" */
  update_rental_agreement_histories_many?: Maybe<Array<Maybe<Rental_Agreement_Histories_Mutation_Response>>>;
  /** update data of the table: "rental_application_manager.admin_assignments" */
  update_rental_application_manager_admin_assignments?: Maybe<Rental_Application_Manager_Admin_Assignments_Mutation_Response>;
  /** update single row of the table: "rental_application_manager.admin_assignments" */
  update_rental_application_manager_admin_assignments_by_pk?: Maybe<Rental_Application_Manager_Admin_Assignments>;
  /** update multiples rows of table: "rental_application_manager.admin_assignments" */
  update_rental_application_manager_admin_assignments_many?: Maybe<Array<Maybe<Rental_Application_Manager_Admin_Assignments_Mutation_Response>>>;
  /** update data of the table: "rental_application_manager.application_escalations" */
  update_rental_application_manager_application_escalations?: Maybe<Rental_Application_Manager_Application_Escalations_Mutation_Response>;
  /** update single row of the table: "rental_application_manager.application_escalations" */
  update_rental_application_manager_application_escalations_by_pk?: Maybe<Rental_Application_Manager_Application_Escalations>;
  /** update multiples rows of table: "rental_application_manager.application_escalations" */
  update_rental_application_manager_application_escalations_many?: Maybe<Array<Maybe<Rental_Application_Manager_Application_Escalations_Mutation_Response>>>;
  /** update data of the table: "rental_application_manager.application_snoozes" */
  update_rental_application_manager_application_snoozes?: Maybe<Rental_Application_Manager_Application_Snoozes_Mutation_Response>;
  /** update single row of the table: "rental_application_manager.application_snoozes" */
  update_rental_application_manager_application_snoozes_by_pk?: Maybe<Rental_Application_Manager_Application_Snoozes>;
  /** update multiples rows of table: "rental_application_manager.application_snoozes" */
  update_rental_application_manager_application_snoozes_many?: Maybe<Array<Maybe<Rental_Application_Manager_Application_Snoozes_Mutation_Response>>>;
  /** update data of the table: "rental_application_occupants" */
  update_rental_application_occupants?: Maybe<Rental_Application_Occupants_Mutation_Response>;
  /** update single row of the table: "rental_application_occupants" */
  update_rental_application_occupants_by_pk?: Maybe<Rental_Application_Occupants>;
  /** update multiples rows of table: "rental_application_occupants" */
  update_rental_application_occupants_many?: Maybe<Array<Maybe<Rental_Application_Occupants_Mutation_Response>>>;
  /** update data of the table: "rental_application_pets" */
  update_rental_application_pets?: Maybe<Rental_Application_Pets_Mutation_Response>;
  /** update single row of the table: "rental_application_pets" */
  update_rental_application_pets_by_pk?: Maybe<Rental_Application_Pets>;
  /** update multiples rows of table: "rental_application_pets" */
  update_rental_application_pets_many?: Maybe<Array<Maybe<Rental_Application_Pets_Mutation_Response>>>;
  /** update data of the table: "rental_application_vehicles" */
  update_rental_application_vehicles?: Maybe<Rental_Application_Vehicles_Mutation_Response>;
  /** update single row of the table: "rental_application_vehicles" */
  update_rental_application_vehicles_by_pk?: Maybe<Rental_Application_Vehicles>;
  /** update multiples rows of table: "rental_application_vehicles" */
  update_rental_application_vehicles_many?: Maybe<Array<Maybe<Rental_Application_Vehicles_Mutation_Response>>>;
  /** update data of the table: "rental_applications" */
  update_rental_applications?: Maybe<Rental_Applications_Mutation_Response>;
  /** update single row of the table: "rental_applications" */
  update_rental_applications_by_pk?: Maybe<Rental_Applications>;
  /** update multiples rows of table: "rental_applications" */
  update_rental_applications_many?: Maybe<Array<Maybe<Rental_Applications_Mutation_Response>>>;
  /** update data of the table: "rental_liabilities" */
  update_rental_liabilities?: Maybe<Rental_Liabilities_Mutation_Response>;
  /** update single row of the table: "rental_liabilities" */
  update_rental_liabilities_by_pk?: Maybe<Rental_Liabilities>;
  /** update multiples rows of table: "rental_liabilities" */
  update_rental_liabilities_many?: Maybe<Array<Maybe<Rental_Liabilities_Mutation_Response>>>;
  /** update data of the table: "rental_move_in_fees" */
  update_rental_move_in_fees?: Maybe<Rental_Move_In_Fees_Mutation_Response>;
  /** update single row of the table: "rental_move_in_fees" */
  update_rental_move_in_fees_by_pk?: Maybe<Rental_Move_In_Fees>;
  /** update multiples rows of table: "rental_move_in_fees" */
  update_rental_move_in_fees_many?: Maybe<Array<Maybe<Rental_Move_In_Fees_Mutation_Response>>>;
  /** update data of the table: "rental_site_opportunity_checks" */
  update_rental_site_opportunity_checks?: Maybe<Rental_Site_Opportunity_Checks_Mutation_Response>;
  /** update single row of the table: "rental_site_opportunity_checks" */
  update_rental_site_opportunity_checks_by_pk?: Maybe<Rental_Site_Opportunity_Checks>;
  /** update multiples rows of table: "rental_site_opportunity_checks" */
  update_rental_site_opportunity_checks_many?: Maybe<Array<Maybe<Rental_Site_Opportunity_Checks_Mutation_Response>>>;
  /** update data of the table: "rental_users" */
  update_rental_users?: Maybe<Rental_Users_Mutation_Response>;
  /** update single row of the table: "rental_users" */
  update_rental_users_by_pk?: Maybe<Rental_Users>;
  /** update multiples rows of table: "rental_users" */
  update_rental_users_many?: Maybe<Array<Maybe<Rental_Users_Mutation_Response>>>;
  /** update data of the table: "rentals" */
  update_rentals?: Maybe<Rentals_Mutation_Response>;
  /** update single row of the table: "rentals" */
  update_rentals_by_pk?: Maybe<Rentals>;
  /** update multiples rows of table: "rentals" */
  update_rentals_many?: Maybe<Array<Maybe<Rentals_Mutation_Response>>>;
  /** update data of the table: "saferent_requests" */
  update_saferent_requests?: Maybe<Saferent_Requests_Mutation_Response>;
  /** update single row of the table: "saferent_requests" */
  update_saferent_requests_by_pk?: Maybe<Saferent_Requests>;
  /** update multiples rows of table: "saferent_requests" */
  update_saferent_requests_many?: Maybe<Array<Maybe<Saferent_Requests_Mutation_Response>>>;
  /** update data of the table: "user_document_requests" */
  update_user_document_requests?: Maybe<User_Document_Requests_Mutation_Response>;
  /** update single row of the table: "user_document_requests" */
  update_user_document_requests_by_pk?: Maybe<User_Document_Requests>;
  /** update multiples rows of table: "user_document_requests" */
  update_user_document_requests_many?: Maybe<Array<Maybe<User_Document_Requests_Mutation_Response>>>;
  /** update data of the table: "user_funnel_statuses" */
  update_user_funnel_statuses?: Maybe<User_Funnel_Statuses_Mutation_Response>;
  /** update single row of the table: "user_funnel_statuses" */
  update_user_funnel_statuses_by_pk?: Maybe<User_Funnel_Statuses>;
  /** update multiples rows of table: "user_funnel_statuses" */
  update_user_funnel_statuses_many?: Maybe<Array<Maybe<User_Funnel_Statuses_Mutation_Response>>>;
  /** update data of the table: "user_identity_verifications" */
  update_user_identity_verifications?: Maybe<User_Identity_Verifications_Mutation_Response>;
  /** update single row of the table: "user_identity_verifications" */
  update_user_identity_verifications_by_pk?: Maybe<User_Identity_Verifications>;
  /** update multiples rows of table: "user_identity_verifications" */
  update_user_identity_verifications_many?: Maybe<Array<Maybe<User_Identity_Verifications_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "utility_chargebacks" */
  update_utility_chargebacks?: Maybe<Utility_Chargebacks_Mutation_Response>;
  /** update single row of the table: "utility_chargebacks" */
  update_utility_chargebacks_by_pk?: Maybe<Utility_Chargebacks>;
  /** update multiples rows of table: "utility_chargebacks" */
  update_utility_chargebacks_many?: Maybe<Array<Maybe<Utility_Chargebacks_Mutation_Response>>>;
  /** update data of the table: "vendors" */
  update_vendors?: Maybe<Vendors_Mutation_Response>;
  /** update single row of the table: "vendors" */
  update_vendors_by_pk?: Maybe<Vendors>;
  /** update multiples rows of table: "vendors" */
  update_vendors_many?: Maybe<Array<Maybe<Vendors_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Cashouts_Pending_LiabilitiesArgs = {
  where: Cashouts_Pending_Liabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cashouts_Pending_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Collections_Rental_LiabilitiesArgs = {
  where: Collections_Rental_Liabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Collections_Rental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentsArgs = {
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Recurring_CreditsArgs = {
  where: Recurring_Credits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recurring_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_Application_OccupantsArgs = {
  where: Rental_Application_Occupants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Application_Occupants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_Application_PetsArgs = {
  where: Rental_Application_Pets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Application_Pets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_Application_VehiclesArgs = {
  where: Rental_Application_Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Application_Vehicles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_CreditsArgs = {
  where: Rental_Credits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_LiabilitiesArgs = {
  where: Rental_Liabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vendor_MarketsArgs = {
  where: Vendor_Markets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Markets_By_PkArgs = {
  market_id: Scalars['uuid']['input'];
  vendor_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AdminsArgs = {
  objects: Array<Admins_Insert_Input>;
  on_conflict?: InputMaybe<Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admins_OneArgs = {
  object: Admins_Insert_Input;
  on_conflict?: InputMaybe<Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Lead_Group_OwnersArgs = {
  objects: Array<Agent_Lead_Group_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Lead_Group_Owners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Lead_Group_Owners_OneArgs = {
  object: Agent_Lead_Group_Owners_Insert_Input;
  on_conflict?: InputMaybe<Agent_Lead_Group_Owners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buildium_Resident_Center_UsersArgs = {
  objects: Array<Buildium_Resident_Center_Users_Insert_Input>;
  on_conflict?: InputMaybe<Buildium_Resident_Center_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buildium_Resident_Center_Users_OneArgs = {
  object: Buildium_Resident_Center_Users_Insert_Input;
  on_conflict?: InputMaybe<Buildium_Resident_Center_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buildium_TransactionsArgs = {
  objects: Array<Buildium_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Buildium_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buildium_Transactions_OneArgs = {
  object: Buildium_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Buildium_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CapabilitiesArgs = {
  objects: Array<Capabilities_Insert_Input>;
  on_conflict?: InputMaybe<Capabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Capabilities_OneArgs = {
  object: Capabilities_Insert_Input;
  on_conflict?: InputMaybe<Capabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cashouts_Pending_LiabilitiesArgs = {
  objects: Array<Cashouts_Pending_Liabilities_Insert_Input>;
  on_conflict?: InputMaybe<Cashouts_Pending_Liabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cashouts_Pending_Liabilities_OneArgs = {
  object: Cashouts_Pending_Liabilities_Insert_Input;
  on_conflict?: InputMaybe<Cashouts_Pending_Liabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Payment_PromisesArgs = {
  objects: Array<Collection_Payment_Promises_Insert_Input>;
  on_conflict?: InputMaybe<Collection_Payment_Promises_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Payment_Promises_OneArgs = {
  object: Collection_Payment_Promises_Insert_Input;
  on_conflict?: InputMaybe<Collection_Payment_Promises_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DashboardsArgs = {
  objects: Array<Dashboards_Insert_Input>;
  on_conflict?: InputMaybe<Dashboards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dashboards_OneArgs = {
  object: Dashboards_Insert_Input;
  on_conflict?: InputMaybe<Dashboards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispositions_Portfolio_Home_Disposition_CounterpartiesArgs = {
  objects: Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Insert_Input>;
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispositions_Portfolio_Home_Disposition_Counterparties_OneArgs = {
  object: Dispositions_Portfolio_Home_Disposition_Counterparties_Insert_Input;
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispositions_Portfolio_Home_Disposition_StatusesArgs = {
  objects: Array<Dispositions_Portfolio_Home_Disposition_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispositions_Portfolio_Home_Disposition_Statuses_OneArgs = {
  object: Dispositions_Portfolio_Home_Disposition_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispositions_Portfolio_Home_DispositionsArgs = {
  objects: Array<Dispositions_Portfolio_Home_Dispositions_Insert_Input>;
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispositions_Portfolio_Home_Dispositions_OneArgs = {
  object: Dispositions_Portfolio_Home_Dispositions_Insert_Input;
  on_conflict?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentsArgs = {
  objects: Array<Documents_Insert_Input>;
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Documents_OneArgs = {
  object: Documents_Insert_Input;
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Connector_Prorated_Utility_Bill_Line_ItemsArgs = {
  objects: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Insert_Input>;
  on_conflict?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Connector_Prorated_Utility_Bill_Line_Items_OneArgs = {
  object: Kafka_Connector_Prorated_Utility_Bill_Line_Items_Insert_Input;
  on_conflict?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lockbox_CodesArgs = {
  objects: Array<Lockbox_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Lockbox_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lockbox_Codes_OneArgs = {
  object: Lockbox_Codes_Insert_Input;
  on_conflict?: InputMaybe<Lockbox_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotesArgs = {
  objects: Array<Notes_Insert_Input>;
  on_conflict?: InputMaybe<Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notes_OneArgs = {
  object: Notes_Insert_Input;
  on_conflict?: InputMaybe<Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentsArgs = {
  objects: Array<Payments_Insert_Input>;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payments_OneArgs = {
  object: Payments_Insert_Input;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recurring_CreditsArgs = {
  objects: Array<Recurring_Credits_Insert_Input>;
  on_conflict?: InputMaybe<Recurring_Credits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recurring_Credits_OneArgs = {
  object: Recurring_Credits_Insert_Input;
  on_conflict?: InputMaybe<Recurring_Credits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Add_OnsArgs = {
  objects: Array<Rental_Add_Ons_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Add_Ons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Add_Ons_OneArgs = {
  object: Rental_Add_Ons_Insert_Input;
  on_conflict?: InputMaybe<Rental_Add_Ons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Agreement_HistoriesArgs = {
  objects: Array<Rental_Agreement_Histories_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Agreement_Histories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Agreement_Histories_OneArgs = {
  object: Rental_Agreement_Histories_Insert_Input;
  on_conflict?: InputMaybe<Rental_Agreement_Histories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Manager_Admin_AssignmentsArgs = {
  objects: Array<Rental_Application_Manager_Admin_Assignments_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Application_Manager_Admin_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Manager_Admin_Assignments_OneArgs = {
  object: Rental_Application_Manager_Admin_Assignments_Insert_Input;
  on_conflict?: InputMaybe<Rental_Application_Manager_Admin_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Manager_Application_EscalationsArgs = {
  objects: Array<Rental_Application_Manager_Application_Escalations_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Application_Manager_Application_Escalations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Manager_Application_Escalations_OneArgs = {
  object: Rental_Application_Manager_Application_Escalations_Insert_Input;
  on_conflict?: InputMaybe<Rental_Application_Manager_Application_Escalations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Manager_Application_SnoozesArgs = {
  objects: Array<Rental_Application_Manager_Application_Snoozes_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Application_Manager_Application_Snoozes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Manager_Application_Snoozes_OneArgs = {
  object: Rental_Application_Manager_Application_Snoozes_Insert_Input;
  on_conflict?: InputMaybe<Rental_Application_Manager_Application_Snoozes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_OccupantsArgs = {
  objects: Array<Rental_Application_Occupants_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Application_Occupants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Occupants_OneArgs = {
  object: Rental_Application_Occupants_Insert_Input;
  on_conflict?: InputMaybe<Rental_Application_Occupants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_PetsArgs = {
  objects: Array<Rental_Application_Pets_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Application_Pets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Pets_OneArgs = {
  object: Rental_Application_Pets_Insert_Input;
  on_conflict?: InputMaybe<Rental_Application_Pets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_VehiclesArgs = {
  objects: Array<Rental_Application_Vehicles_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Application_Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Application_Vehicles_OneArgs = {
  object: Rental_Application_Vehicles_Insert_Input;
  on_conflict?: InputMaybe<Rental_Application_Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_CreditsArgs = {
  objects: Array<Rental_Credits_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Credits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Credits_OneArgs = {
  object: Rental_Credits_Insert_Input;
  on_conflict?: InputMaybe<Rental_Credits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_LiabilitiesArgs = {
  objects: Array<Rental_Liabilities_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Liabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Liabilities_OneArgs = {
  object: Rental_Liabilities_Insert_Input;
  on_conflict?: InputMaybe<Rental_Liabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Move_In_FeesArgs = {
  objects: Array<Rental_Move_In_Fees_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Move_In_Fees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Move_In_Fees_OneArgs = {
  object: Rental_Move_In_Fees_Insert_Input;
  on_conflict?: InputMaybe<Rental_Move_In_Fees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Document_RequestsArgs = {
  objects: Array<User_Document_Requests_Insert_Input>;
  on_conflict?: InputMaybe<User_Document_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Document_Requests_OneArgs = {
  object: User_Document_Requests_Insert_Input;
  on_conflict?: InputMaybe<User_Document_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utility_ResponsibilitiesArgs = {
  objects: Array<Utility_Responsibilities_Insert_Input>;
  on_conflict?: InputMaybe<Utility_Responsibilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utility_Responsibilities_OneArgs = {
  object: Utility_Responsibilities_Insert_Input;
  on_conflict?: InputMaybe<Utility_Responsibilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_MarketsArgs = {
  objects: Array<Vendor_Markets_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Markets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Markets_OneArgs = {
  object: Vendor_Markets_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Markets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Lead_Group_OwnersArgs = {
  _set?: InputMaybe<Agent_Lead_Group_Owners_Set_Input>;
  where: Agent_Lead_Group_Owners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Lead_Group_Owners_By_PkArgs = {
  _set?: InputMaybe<Agent_Lead_Group_Owners_Set_Input>;
  pk_columns: Agent_Lead_Group_Owners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Lead_Group_Owners_ManyArgs = {
  updates: Array<Agent_Lead_Group_Owners_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgreementsArgs = {
  _set?: InputMaybe<Agreements_Set_Input>;
  where: Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreements_By_PkArgs = {
  _set?: InputMaybe<Agreements_Set_Input>;
  pk_columns: Agreements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreements_ManyArgs = {
  updates: Array<Agreements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Income_SourcesArgs = {
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Inc_Input>;
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Set_Input>;
  where: Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Income_Sources_By_PkArgs = {
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Inc_Input>;
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Set_Input>;
  pk_columns: Applicant_Income_Underwrites_User_Income_Sources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Income_Sources_EmployedArgs = {
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Inc_Input>;
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Set_Input>;
  where: Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Income_Sources_Employed_By_PkArgs = {
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Inc_Input>;
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Set_Input>;
  pk_columns: Applicant_Income_Underwrites_User_Income_Sources_Employed_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Income_Sources_Employed_ManyArgs = {
  updates: Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Income_Sources_ManyArgs = {
  updates: Array<Applicant_Income_Underwrites_User_Income_Sources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_IncomesArgs = {
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Inc_Input>;
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Set_Input>;
  where: Applicant_Income_Underwrites_User_Incomes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Incomes_By_PkArgs = {
  _inc?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Inc_Input>;
  _set?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Set_Input>;
  pk_columns: Applicant_Income_Underwrites_User_Incomes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Applicant_Income_Underwrites_User_Incomes_ManyArgs = {
  updates: Array<Applicant_Income_Underwrites_User_Incomes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buildium_Bulk_Journal_Entry_UploadsArgs = {
  _set?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Set_Input>;
  where: Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buildium_Bulk_Journal_Entry_Uploads_By_PkArgs = {
  _set?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Set_Input>;
  pk_columns: Buildium_Bulk_Journal_Entry_Uploads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buildium_Bulk_Journal_Entry_Uploads_ManyArgs = {
  updates: Array<Buildium_Bulk_Journal_Entry_Uploads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buildium_Resident_Center_UsersArgs = {
  _inc?: InputMaybe<Buildium_Resident_Center_Users_Inc_Input>;
  _set?: InputMaybe<Buildium_Resident_Center_Users_Set_Input>;
  where: Buildium_Resident_Center_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buildium_Resident_Center_Users_By_PkArgs = {
  _inc?: InputMaybe<Buildium_Resident_Center_Users_Inc_Input>;
  _set?: InputMaybe<Buildium_Resident_Center_Users_Set_Input>;
  pk_columns: Buildium_Resident_Center_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buildium_Resident_Center_Users_ManyArgs = {
  updates: Array<Buildium_Resident_Center_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cashouts_Pending_LiabilitiesArgs = {
  _inc?: InputMaybe<Cashouts_Pending_Liabilities_Inc_Input>;
  _set?: InputMaybe<Cashouts_Pending_Liabilities_Set_Input>;
  where: Cashouts_Pending_Liabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cashouts_Pending_Liabilities_By_PkArgs = {
  _inc?: InputMaybe<Cashouts_Pending_Liabilities_Inc_Input>;
  _set?: InputMaybe<Cashouts_Pending_Liabilities_Set_Input>;
  pk_columns: Cashouts_Pending_Liabilities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cashouts_Pending_Liabilities_ManyArgs = {
  updates: Array<Cashouts_Pending_Liabilities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Payment_PromisesArgs = {
  _set?: InputMaybe<Collection_Payment_Promises_Set_Input>;
  where: Collection_Payment_Promises_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Payment_Promises_By_PkArgs = {
  _set?: InputMaybe<Collection_Payment_Promises_Set_Input>;
  pk_columns: Collection_Payment_Promises_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Payment_Promises_ManyArgs = {
  updates: Array<Collection_Payment_Promises_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CollectionsArgs = {
  _set?: InputMaybe<Collections_Set_Input>;
  where: Collections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Collections_By_PkArgs = {
  _set?: InputMaybe<Collections_Set_Input>;
  pk_columns: Collections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Collections_ManyArgs = {
  updates: Array<Collections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DashboardsArgs = {
  _set?: InputMaybe<Dashboards_Set_Input>;
  where: Dashboards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dashboards_By_PkArgs = {
  _set?: InputMaybe<Dashboards_Set_Input>;
  pk_columns: Dashboards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dashboards_ManyArgs = {
  updates: Array<Dashboards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dispositions_Portfolio_Home_DispositionsArgs = {
  _inc?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Inc_Input>;
  _set?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Set_Input>;
  where: Dispositions_Portfolio_Home_Dispositions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dispositions_Portfolio_Home_Dispositions_By_PkArgs = {
  _inc?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Inc_Input>;
  _set?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Set_Input>;
  pk_columns: Dispositions_Portfolio_Home_Dispositions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dispositions_Portfolio_Home_Dispositions_ManyArgs = {
  updates: Array<Dispositions_Portfolio_Home_Dispositions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentsArgs = {
  _set?: InputMaybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_By_PkArgs = {
  _set?: InputMaybe<Documents_Set_Input>;
  pk_columns: Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_ManyArgs = {
  updates: Array<Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EvictionsArgs = {
  _set?: InputMaybe<Evictions_Set_Input>;
  where: Evictions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Evictions_By_PkArgs = {
  _set?: InputMaybe<Evictions_Set_Input>;
  pk_columns: Evictions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Evictions_ManyArgs = {
  updates: Array<Evictions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Connector_Prorated_Utility_Bill_Line_ItemsArgs = {
  _set?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Set_Input>;
  where: Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Connector_Prorated_Utility_Bill_Line_Items_By_PkArgs = {
  _set?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Set_Input>;
  pk_columns: Kafka_Connector_Prorated_Utility_Bill_Line_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Connector_Prorated_Utility_Bill_Line_Items_ManyArgs = {
  updates: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lockbox_CodesArgs = {
  _set?: InputMaybe<Lockbox_Codes_Set_Input>;
  where: Lockbox_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lockbox_Codes_By_PkArgs = {
  _set?: InputMaybe<Lockbox_Codes_Set_Input>;
  pk_columns: Lockbox_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lockbox_Codes_ManyArgs = {
  updates: Array<Lockbox_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotesArgs = {
  _set?: InputMaybe<Notes_Set_Input>;
  where: Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notes_By_PkArgs = {
  _set?: InputMaybe<Notes_Set_Input>;
  pk_columns: Notes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notes_ManyArgs = {
  updates: Array<Notes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Portfolio_HomesArgs = {
  _inc?: InputMaybe<Portfolio_Homes_Inc_Input>;
  _set?: InputMaybe<Portfolio_Homes_Set_Input>;
  where: Portfolio_Homes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Portfolio_Homes_By_PkArgs = {
  _inc?: InputMaybe<Portfolio_Homes_Inc_Input>;
  _set?: InputMaybe<Portfolio_Homes_Set_Input>;
  pk_columns: Portfolio_Homes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Portfolio_Homes_ManyArgs = {
  updates: Array<Portfolio_Homes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Add_OnsArgs = {
  _inc?: InputMaybe<Rental_Add_Ons_Inc_Input>;
  _set?: InputMaybe<Rental_Add_Ons_Set_Input>;
  where: Rental_Add_Ons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Add_Ons_By_PkArgs = {
  _inc?: InputMaybe<Rental_Add_Ons_Inc_Input>;
  _set?: InputMaybe<Rental_Add_Ons_Set_Input>;
  pk_columns: Rental_Add_Ons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Add_Ons_ManyArgs = {
  updates: Array<Rental_Add_Ons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Agreement_HistoriesArgs = {
  _set?: InputMaybe<Rental_Agreement_Histories_Set_Input>;
  where: Rental_Agreement_Histories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Agreement_Histories_By_PkArgs = {
  _set?: InputMaybe<Rental_Agreement_Histories_Set_Input>;
  pk_columns: Rental_Agreement_Histories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Agreement_Histories_ManyArgs = {
  updates: Array<Rental_Agreement_Histories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Admin_AssignmentsArgs = {
  _set?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Set_Input>;
  where: Rental_Application_Manager_Admin_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Admin_Assignments_By_PkArgs = {
  _set?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Set_Input>;
  pk_columns: Rental_Application_Manager_Admin_Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Admin_Assignments_ManyArgs = {
  updates: Array<Rental_Application_Manager_Admin_Assignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Application_EscalationsArgs = {
  _set?: InputMaybe<Rental_Application_Manager_Application_Escalations_Set_Input>;
  where: Rental_Application_Manager_Application_Escalations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Application_Escalations_By_PkArgs = {
  _set?: InputMaybe<Rental_Application_Manager_Application_Escalations_Set_Input>;
  pk_columns: Rental_Application_Manager_Application_Escalations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Application_Escalations_ManyArgs = {
  updates: Array<Rental_Application_Manager_Application_Escalations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Application_SnoozesArgs = {
  _set?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Set_Input>;
  where: Rental_Application_Manager_Application_Snoozes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Application_Snoozes_By_PkArgs = {
  _set?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Set_Input>;
  pk_columns: Rental_Application_Manager_Application_Snoozes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Manager_Application_Snoozes_ManyArgs = {
  updates: Array<Rental_Application_Manager_Application_Snoozes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_OccupantsArgs = {
  _inc?: InputMaybe<Rental_Application_Occupants_Inc_Input>;
  _set?: InputMaybe<Rental_Application_Occupants_Set_Input>;
  where: Rental_Application_Occupants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Occupants_By_PkArgs = {
  _inc?: InputMaybe<Rental_Application_Occupants_Inc_Input>;
  _set?: InputMaybe<Rental_Application_Occupants_Set_Input>;
  pk_columns: Rental_Application_Occupants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Occupants_ManyArgs = {
  updates: Array<Rental_Application_Occupants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_PetsArgs = {
  _inc?: InputMaybe<Rental_Application_Pets_Inc_Input>;
  _set?: InputMaybe<Rental_Application_Pets_Set_Input>;
  where: Rental_Application_Pets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Pets_By_PkArgs = {
  _inc?: InputMaybe<Rental_Application_Pets_Inc_Input>;
  _set?: InputMaybe<Rental_Application_Pets_Set_Input>;
  pk_columns: Rental_Application_Pets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Pets_ManyArgs = {
  updates: Array<Rental_Application_Pets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_VehiclesArgs = {
  _inc?: InputMaybe<Rental_Application_Vehicles_Inc_Input>;
  _set?: InputMaybe<Rental_Application_Vehicles_Set_Input>;
  where: Rental_Application_Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Vehicles_By_PkArgs = {
  _inc?: InputMaybe<Rental_Application_Vehicles_Inc_Input>;
  _set?: InputMaybe<Rental_Application_Vehicles_Set_Input>;
  pk_columns: Rental_Application_Vehicles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Application_Vehicles_ManyArgs = {
  updates: Array<Rental_Application_Vehicles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_ApplicationsArgs = {
  _inc?: InputMaybe<Rental_Applications_Inc_Input>;
  _set?: InputMaybe<Rental_Applications_Set_Input>;
  where: Rental_Applications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Applications_By_PkArgs = {
  _inc?: InputMaybe<Rental_Applications_Inc_Input>;
  _set?: InputMaybe<Rental_Applications_Set_Input>;
  pk_columns: Rental_Applications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Applications_ManyArgs = {
  updates: Array<Rental_Applications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_LiabilitiesArgs = {
  _inc?: InputMaybe<Rental_Liabilities_Inc_Input>;
  _set?: InputMaybe<Rental_Liabilities_Set_Input>;
  where: Rental_Liabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Liabilities_By_PkArgs = {
  _inc?: InputMaybe<Rental_Liabilities_Inc_Input>;
  _set?: InputMaybe<Rental_Liabilities_Set_Input>;
  pk_columns: Rental_Liabilities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Liabilities_ManyArgs = {
  updates: Array<Rental_Liabilities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Move_In_FeesArgs = {
  _inc?: InputMaybe<Rental_Move_In_Fees_Inc_Input>;
  _set?: InputMaybe<Rental_Move_In_Fees_Set_Input>;
  where: Rental_Move_In_Fees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Move_In_Fees_By_PkArgs = {
  _inc?: InputMaybe<Rental_Move_In_Fees_Inc_Input>;
  _set?: InputMaybe<Rental_Move_In_Fees_Set_Input>;
  pk_columns: Rental_Move_In_Fees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Move_In_Fees_ManyArgs = {
  updates: Array<Rental_Move_In_Fees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Site_Opportunity_ChecksArgs = {
  _set?: InputMaybe<Rental_Site_Opportunity_Checks_Set_Input>;
  where: Rental_Site_Opportunity_Checks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Site_Opportunity_Checks_By_PkArgs = {
  _set?: InputMaybe<Rental_Site_Opportunity_Checks_Set_Input>;
  pk_columns: Rental_Site_Opportunity_Checks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Site_Opportunity_Checks_ManyArgs = {
  updates: Array<Rental_Site_Opportunity_Checks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_UsersArgs = {
  _set?: InputMaybe<Rental_Users_Set_Input>;
  where: Rental_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Users_By_PkArgs = {
  _set?: InputMaybe<Rental_Users_Set_Input>;
  pk_columns: Rental_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Users_ManyArgs = {
  updates: Array<Rental_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RentalsArgs = {
  _inc?: InputMaybe<Rentals_Inc_Input>;
  _set?: InputMaybe<Rentals_Set_Input>;
  where: Rentals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rentals_By_PkArgs = {
  _inc?: InputMaybe<Rentals_Inc_Input>;
  _set?: InputMaybe<Rentals_Set_Input>;
  pk_columns: Rentals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rentals_ManyArgs = {
  updates: Array<Rentals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Saferent_RequestsArgs = {
  _set?: InputMaybe<Saferent_Requests_Set_Input>;
  where: Saferent_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Saferent_Requests_By_PkArgs = {
  _set?: InputMaybe<Saferent_Requests_Set_Input>;
  pk_columns: Saferent_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Saferent_Requests_ManyArgs = {
  updates: Array<Saferent_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Document_RequestsArgs = {
  _set?: InputMaybe<User_Document_Requests_Set_Input>;
  where: User_Document_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Document_Requests_By_PkArgs = {
  _set?: InputMaybe<User_Document_Requests_Set_Input>;
  pk_columns: User_Document_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Document_Requests_ManyArgs = {
  updates: Array<User_Document_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Funnel_StatusesArgs = {
  _set?: InputMaybe<User_Funnel_Statuses_Set_Input>;
  where: User_Funnel_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Funnel_Statuses_By_PkArgs = {
  _set?: InputMaybe<User_Funnel_Statuses_Set_Input>;
  pk_columns: User_Funnel_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Funnel_Statuses_ManyArgs = {
  updates: Array<User_Funnel_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Identity_VerificationsArgs = {
  _set?: InputMaybe<User_Identity_Verifications_Set_Input>;
  where: User_Identity_Verifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Identity_Verifications_By_PkArgs = {
  _set?: InputMaybe<User_Identity_Verifications_Set_Input>;
  pk_columns: User_Identity_Verifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Identity_Verifications_ManyArgs = {
  updates: Array<User_Identity_Verifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utility_ChargebacksArgs = {
  _inc?: InputMaybe<Utility_Chargebacks_Inc_Input>;
  _set?: InputMaybe<Utility_Chargebacks_Set_Input>;
  where: Utility_Chargebacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utility_Chargebacks_By_PkArgs = {
  _inc?: InputMaybe<Utility_Chargebacks_Inc_Input>;
  _set?: InputMaybe<Utility_Chargebacks_Set_Input>;
  pk_columns: Utility_Chargebacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utility_Chargebacks_ManyArgs = {
  updates: Array<Utility_Chargebacks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VendorsArgs = {
  _inc?: InputMaybe<Vendors_Inc_Input>;
  _set?: InputMaybe<Vendors_Set_Input>;
  where: Vendors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendors_By_PkArgs = {
  _inc?: InputMaybe<Vendors_Inc_Input>;
  _set?: InputMaybe<Vendors_Set_Input>;
  pk_columns: Vendors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendors_ManyArgs = {
  updates: Array<Vendors_Updates>;
};

/** columns and relationships of "note_priorities" */
export type Note_Priorities = {
  __typename: 'note_priorities';
  note_priority: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "note_priorities". All fields are combined with a logical 'AND'. */
export type Note_Priorities_Bool_Exp = {
  _and?: InputMaybe<Array<Note_Priorities_Bool_Exp>>;
  _not?: InputMaybe<Note_Priorities_Bool_Exp>;
  _or?: InputMaybe<Array<Note_Priorities_Bool_Exp>>;
  note_priority?: InputMaybe<String_Comparison_Exp>;
};

export enum Note_Priorities_Enum {
  Default = 'default',
  Pinned = 'pinned'
}

/** Boolean expression to compare columns of type "note_priorities_enum". All fields are combined with logical 'AND'. */
export type Note_Priorities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Note_Priorities_Enum>;
  _in?: InputMaybe<Array<Note_Priorities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Note_Priorities_Enum>;
  _nin?: InputMaybe<Array<Note_Priorities_Enum>>;
};

/** Ordering options when selecting data from "note_priorities". */
export type Note_Priorities_Order_By = {
  note_priority?: InputMaybe<Order_By>;
};

/** select columns of table "note_priorities" */
export enum Note_Priorities_Select_Column {
  /** column name */
  NotePriority = 'note_priority'
}

/** Streaming cursor of the table "note_priorities" */
export type Note_Priorities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Note_Priorities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Note_Priorities_Stream_Cursor_Value_Input = {
  note_priority?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "notes" */
export type Notes = {
  __typename: 'notes';
  /** An object relationship */
  admin?: Maybe<Admins>;
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  documents: Array<Documents>;
  id: Scalars['uuid']['output'];
  is_deleted: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  priority: Note_Priorities_Enum;
  resource_id: Scalars['uuid']['output'];
  resource_type: Scalars['String']['output'];
  subject_id?: Maybe<Scalars['uuid']['output']>;
  subject_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "notes" */
export type NotesDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** order by aggregate values of table "notes" */
export type Notes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notes_Max_Order_By>;
  min?: InputMaybe<Notes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notes" */
export type Notes_Arr_Rel_Insert_Input = {
  data: Array<Notes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notes". All fields are combined with a logical 'AND'. */
export type Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Notes_Bool_Exp>>;
  _not?: InputMaybe<Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Notes_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Documents_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Note_Priorities_Enum_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  subject_id?: InputMaybe<Uuid_Comparison_Exp>;
  subject_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notes" */
export enum Notes_Constraint {
  /** unique or primary key constraint on columns "close_activity_id" */
  NotesCloseActivityIdKey = 'notes_close_activity_id_key',
  /** unique or primary key constraint on columns "external_id", "external_source" */
  NotesExternalSourceExternalIdUniqueIdx = 'notes_external_source_external_id_unique_idx',
  /** unique or primary key constraint on columns "id" */
  NotesPkey = 'notes_pkey'
}

/** input type for inserting data into table "notes" */
export type Notes_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Documents_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Note_Priorities_Enum>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  subject_id?: InputMaybe<Scalars['uuid']['input']>;
  subject_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "notes" */
export type Notes_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  subject_id?: InputMaybe<Order_By>;
  subject_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "notes" */
export type Notes_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  subject_id?: InputMaybe<Order_By>;
  subject_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notes" */
export type Notes_Mutation_Response = {
  __typename: 'notes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notes>;
};

/** on_conflict condition type for table "notes" */
export type Notes_On_Conflict = {
  constraint: Notes_Constraint;
  update_columns?: Array<Notes_Update_Column>;
  where?: InputMaybe<Notes_Bool_Exp>;
};

/** Ordering options when selecting data from "notes". */
export type Notes_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  subject_id?: InputMaybe<Order_By>;
  subject_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notes */
export type Notes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notes" */
export enum Notes_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Note = 'note',
  /** column name */
  Priority = 'priority',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  SubjectId = 'subject_id',
  /** column name */
  SubjectType = 'subject_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notes" */
export type Notes_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  close_activity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Note_Priorities_Enum>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  subject_id?: InputMaybe<Scalars['uuid']['input']>;
  subject_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "notes" */
export type Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notes_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Note_Priorities_Enum>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  subject_id?: InputMaybe<Scalars['uuid']['input']>;
  subject_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notes" */
export enum Notes_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CloseActivityId = 'close_activity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Note = 'note',
  /** column name */
  Priority = 'priority',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  SubjectId = 'subject_id',
  /** column name */
  SubjectType = 'subject_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Notes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notes_Set_Input>;
  where: Notes_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "opportunities" */
export type Opportunities = {
  __typename: 'opportunities';
  area?: Maybe<Scalars['String']['output']>;
  audit_results?: Maybe<Scalars['jsonb']['output']>;
  baths_full?: Maybe<Scalars['Float']['output']>;
  baths_half?: Maybe<Scalars['Float']['output']>;
  baths_total?: Maybe<Scalars['Float']['output']>;
  baths_weighted?: Maybe<Scalars['numeric']['output']>;
  beds?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  bids: Array<Bids>;
  city?: Maybe<Scalars['String']['output']>;
  co_listing_agent_id?: Maybe<Scalars['uuid']['output']>;
  co_listing_office_id?: Maybe<Scalars['uuid']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  delivery_line?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_line_1?: Maybe<Scalars['String']['output']>;
  display_line_2?: Maybe<Scalars['String']['output']>;
  features_amenities?: Maybe<Scalars['_varchar']['output']>;
  features_appliances_and_equipment?: Maybe<Scalars['_varchar']['output']>;
  features_basement?: Maybe<Scalars['_varchar']['output']>;
  features_bathrooms?: Maybe<Scalars['_varchar']['output']>;
  features_bedrooms?: Maybe<Scalars['_varchar']['output']>;
  features_community?: Maybe<Scalars['_varchar']['output']>;
  features_cooling?: Maybe<Scalars['_varchar']['output']>;
  features_dining_room?: Maybe<Scalars['_varchar']['output']>;
  features_disclosures?: Maybe<Scalars['_varchar']['output']>;
  features_doors?: Maybe<Scalars['_varchar']['output']>;
  features_energy_saving?: Maybe<Scalars['_varchar']['output']>;
  features_exterior_features?: Maybe<Scalars['_varchar']['output']>;
  features_fees?: Maybe<Scalars['_varchar']['output']>;
  features_fence?: Maybe<Scalars['_varchar']['output']>;
  features_fireplaces?: Maybe<Scalars['_varchar']['output']>;
  features_foundation?: Maybe<Scalars['_varchar']['output']>;
  features_garage?: Maybe<Scalars['_varchar']['output']>;
  features_heating?: Maybe<Scalars['_varchar']['output']>;
  features_home_owners_association?: Maybe<Scalars['_varchar']['output']>;
  features_house?: Maybe<Scalars['_varchar']['output']>;
  features_interior?: Maybe<Scalars['_varchar']['output']>;
  features_interior_features?: Maybe<Scalars['_varchar']['output']>;
  features_kitchen?: Maybe<Scalars['_varchar']['output']>;
  features_laundry?: Maybe<Scalars['_varchar']['output']>;
  features_listing?: Maybe<Scalars['_varchar']['output']>;
  features_location?: Maybe<Scalars['_varchar']['output']>;
  features_lot?: Maybe<Scalars['_varchar']['output']>;
  features_miscellaneous?: Maybe<Scalars['_varchar']['output']>;
  features_parking?: Maybe<Scalars['_varchar']['output']>;
  features_pool?: Maybe<Scalars['_varchar']['output']>;
  features_property?: Maybe<Scalars['_varchar']['output']>;
  features_property_access?: Maybe<Scalars['_varchar']['output']>;
  features_roof?: Maybe<Scalars['_varchar']['output']>;
  features_schools?: Maybe<Scalars['_varchar']['output']>;
  features_security_system?: Maybe<Scalars['_varchar']['output']>;
  features_sewer?: Maybe<Scalars['_varchar']['output']>;
  features_spa?: Maybe<Scalars['_varchar']['output']>;
  features_taxes?: Maybe<Scalars['_varchar']['output']>;
  features_utilities?: Maybe<Scalars['_varchar']['output']>;
  features_water?: Maybe<Scalars['_varchar']['output']>;
  features_windows_and_doors?: Maybe<Scalars['_varchar']['output']>;
  firestore_id: Scalars['uuid']['output'];
  geo_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  home?: Maybe<Homes>;
  home_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  internal_attributes: Array<Mls_Listing_Internal_Attributes>;
  is_audited?: Maybe<Scalars['Boolean']['output']>;
  is_new_construction?: Maybe<Scalars['Boolean']['output']>;
  last_audited_at?: Maybe<Scalars['timestamptz']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  listed_rents: Array<Listed_Rents>;
  listing_agent_id?: Maybe<Scalars['uuid']['output']>;
  listing_date?: Maybe<Scalars['timestamptz']['output']>;
  listing_office_id?: Maybe<Scalars['uuid']['output']>;
  listing_type?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lotsize_acres?: Maybe<Scalars['Float']['output']>;
  lotsize_sqft?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  market: Markets;
  market_id: Scalars['uuid']['output'];
  mls: Scalars['String']['output'];
  modified_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  opportunity_underwrites: Array<Underwrites_Opportunity_Underwrites>;
  /** An array relationship */
  photos: Array<Mls_Listing_Photos>;
  property_type?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  real_estate_acquisitions: Array<Real_Estate_Acquisitions>;
  /** An array relationship */
  real_estate_screenings: Array<Real_Estate_Screenings>;
  region?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rent_prices: Array<Rent_Prices>;
  /** An array relationship */
  rent_ready_dates: Array<Rent_Ready_Dates>;
  /** An array relationship */
  rental_applications: Array<Rental_Applications>;
  /** An aggregate relationship */
  rental_applications_aggregate: Rental_Applications_Aggregate;
  school_district?: Maybe<Scalars['String']['output']>;
  school_elementary?: Maybe<Scalars['String']['output']>;
  school_high?: Maybe<Scalars['String']['output']>;
  school_middle?: Maybe<Scalars['String']['output']>;
  short_id: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  standardized_address: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  std_address?: Maybe<Scalars['jsonb']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
  system_id?: Maybe<Scalars['String']['output']>;
  tour_url?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  xf_attributes?: Maybe<Scalars['jsonb']['output']>;
  year_built?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesAudit_ResultsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesInternal_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Order_By>>;
  where?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesListed_RentsArgs = {
  distinct_on?: InputMaybe<Array<Listed_Rents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Listed_Rents_Order_By>>;
  where?: InputMaybe<Listed_Rents_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesOpportunity_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Order_By>>;
  where?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesPhotosArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Photos_Order_By>>;
  where?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesReal_Estate_AcquisitionsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Acquisitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Acquisitions_Order_By>>;
  where?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesReal_Estate_ScreeningsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Screenings_Order_By>>;
  where?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesRent_PricesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Prices_Order_By>>;
  where?: InputMaybe<Rent_Prices_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesRent_Ready_DatesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Ready_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Ready_Dates_Order_By>>;
  where?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesRental_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesRental_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesStd_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "opportunities" */
export type OpportunitiesXf_AttributesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "opportunities" */
export type Opportunities_Aggregate_Order_By = {
  avg?: InputMaybe<Opportunities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Opportunities_Max_Order_By>;
  min?: InputMaybe<Opportunities_Min_Order_By>;
  stddev?: InputMaybe<Opportunities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Opportunities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Opportunities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Opportunities_Sum_Order_By>;
  var_pop?: InputMaybe<Opportunities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Opportunities_Var_Samp_Order_By>;
  variance?: InputMaybe<Opportunities_Variance_Order_By>;
};

/** order by avg() on columns of table "opportunities" */
export type Opportunities_Avg_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "opportunities". All fields are combined with a logical 'AND'. */
export type Opportunities_Bool_Exp = {
  _and?: InputMaybe<Array<Opportunities_Bool_Exp>>;
  _not?: InputMaybe<Opportunities_Bool_Exp>;
  _or?: InputMaybe<Array<Opportunities_Bool_Exp>>;
  area?: InputMaybe<String_Comparison_Exp>;
  audit_results?: InputMaybe<Jsonb_Comparison_Exp>;
  baths_full?: InputMaybe<Float_Comparison_Exp>;
  baths_half?: InputMaybe<Float_Comparison_Exp>;
  baths_total?: InputMaybe<Float_Comparison_Exp>;
  baths_weighted?: InputMaybe<Numeric_Comparison_Exp>;
  beds?: InputMaybe<Int_Comparison_Exp>;
  bids?: InputMaybe<Bids_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  co_listing_agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  co_listing_office_id?: InputMaybe<Uuid_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_line?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_line_1?: InputMaybe<String_Comparison_Exp>;
  display_line_2?: InputMaybe<String_Comparison_Exp>;
  features_amenities?: InputMaybe<_Varchar_Comparison_Exp>;
  features_appliances_and_equipment?: InputMaybe<_Varchar_Comparison_Exp>;
  features_basement?: InputMaybe<_Varchar_Comparison_Exp>;
  features_bathrooms?: InputMaybe<_Varchar_Comparison_Exp>;
  features_bedrooms?: InputMaybe<_Varchar_Comparison_Exp>;
  features_community?: InputMaybe<_Varchar_Comparison_Exp>;
  features_cooling?: InputMaybe<_Varchar_Comparison_Exp>;
  features_dining_room?: InputMaybe<_Varchar_Comparison_Exp>;
  features_disclosures?: InputMaybe<_Varchar_Comparison_Exp>;
  features_doors?: InputMaybe<_Varchar_Comparison_Exp>;
  features_energy_saving?: InputMaybe<_Varchar_Comparison_Exp>;
  features_exterior_features?: InputMaybe<_Varchar_Comparison_Exp>;
  features_fees?: InputMaybe<_Varchar_Comparison_Exp>;
  features_fence?: InputMaybe<_Varchar_Comparison_Exp>;
  features_fireplaces?: InputMaybe<_Varchar_Comparison_Exp>;
  features_foundation?: InputMaybe<_Varchar_Comparison_Exp>;
  features_garage?: InputMaybe<_Varchar_Comparison_Exp>;
  features_heating?: InputMaybe<_Varchar_Comparison_Exp>;
  features_home_owners_association?: InputMaybe<_Varchar_Comparison_Exp>;
  features_house?: InputMaybe<_Varchar_Comparison_Exp>;
  features_interior?: InputMaybe<_Varchar_Comparison_Exp>;
  features_interior_features?: InputMaybe<_Varchar_Comparison_Exp>;
  features_kitchen?: InputMaybe<_Varchar_Comparison_Exp>;
  features_laundry?: InputMaybe<_Varchar_Comparison_Exp>;
  features_listing?: InputMaybe<_Varchar_Comparison_Exp>;
  features_location?: InputMaybe<_Varchar_Comparison_Exp>;
  features_lot?: InputMaybe<_Varchar_Comparison_Exp>;
  features_miscellaneous?: InputMaybe<_Varchar_Comparison_Exp>;
  features_parking?: InputMaybe<_Varchar_Comparison_Exp>;
  features_pool?: InputMaybe<_Varchar_Comparison_Exp>;
  features_property?: InputMaybe<_Varchar_Comparison_Exp>;
  features_property_access?: InputMaybe<_Varchar_Comparison_Exp>;
  features_roof?: InputMaybe<_Varchar_Comparison_Exp>;
  features_schools?: InputMaybe<_Varchar_Comparison_Exp>;
  features_security_system?: InputMaybe<_Varchar_Comparison_Exp>;
  features_sewer?: InputMaybe<_Varchar_Comparison_Exp>;
  features_spa?: InputMaybe<_Varchar_Comparison_Exp>;
  features_taxes?: InputMaybe<_Varchar_Comparison_Exp>;
  features_utilities?: InputMaybe<_Varchar_Comparison_Exp>;
  features_water?: InputMaybe<_Varchar_Comparison_Exp>;
  features_windows_and_doors?: InputMaybe<_Varchar_Comparison_Exp>;
  firestore_id?: InputMaybe<Uuid_Comparison_Exp>;
  geo_type?: InputMaybe<String_Comparison_Exp>;
  home?: InputMaybe<Homes_Bool_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_attributes?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
  is_audited?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_construction?: InputMaybe<Boolean_Comparison_Exp>;
  last_audited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  list_price?: InputMaybe<Numeric_Comparison_Exp>;
  listed_rents?: InputMaybe<Listed_Rents_Bool_Exp>;
  listing_agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  listing_office_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_type?: InputMaybe<String_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  lotsize_acres?: InputMaybe<Float_Comparison_Exp>;
  lotsize_sqft?: InputMaybe<Bigint_Comparison_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls?: InputMaybe<String_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  opportunity_underwrites?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
  photos?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  real_estate_acquisitions?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
  real_estate_screenings?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  rent_prices?: InputMaybe<Rent_Prices_Bool_Exp>;
  rent_ready_dates?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
  rental_applications?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp>;
  school_district?: InputMaybe<String_Comparison_Exp>;
  school_elementary?: InputMaybe<String_Comparison_Exp>;
  school_high?: InputMaybe<String_Comparison_Exp>;
  school_middle?: InputMaybe<String_Comparison_Exp>;
  short_id?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  standardized_address?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  std_address?: InputMaybe<Jsonb_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  style?: InputMaybe<String_Comparison_Exp>;
  subdivision?: InputMaybe<String_Comparison_Exp>;
  system_id?: InputMaybe<String_Comparison_Exp>;
  tour_url?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xf_attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  year_built?: InputMaybe<Int_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "opportunities" */
export type Opportunities_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  co_listing_agent_id?: InputMaybe<Order_By>;
  co_listing_office_id?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_line?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  firestore_id?: InputMaybe<Order_By>;
  geo_type?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_audited_at?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  listing_agent_id?: InputMaybe<Order_By>;
  listing_date?: InputMaybe<Order_By>;
  listing_office_id?: InputMaybe<Order_By>;
  listing_type?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  school_district?: InputMaybe<Order_By>;
  school_elementary?: InputMaybe<Order_By>;
  school_high?: InputMaybe<Order_By>;
  school_middle?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  standardized_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  subdivision?: InputMaybe<Order_By>;
  system_id?: InputMaybe<Order_By>;
  tour_url?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "opportunities" */
export type Opportunities_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  co_listing_agent_id?: InputMaybe<Order_By>;
  co_listing_office_id?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_line?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  firestore_id?: InputMaybe<Order_By>;
  geo_type?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_audited_at?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  listing_agent_id?: InputMaybe<Order_By>;
  listing_date?: InputMaybe<Order_By>;
  listing_office_id?: InputMaybe<Order_By>;
  listing_type?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  school_district?: InputMaybe<Order_By>;
  school_elementary?: InputMaybe<Order_By>;
  school_high?: InputMaybe<Order_By>;
  school_middle?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  standardized_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  subdivision?: InputMaybe<Order_By>;
  system_id?: InputMaybe<Order_By>;
  tour_url?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "opportunities". */
export type Opportunities_Order_By = {
  area?: InputMaybe<Order_By>;
  audit_results?: InputMaybe<Order_By>;
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  bids_aggregate?: InputMaybe<Bids_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  co_listing_agent_id?: InputMaybe<Order_By>;
  co_listing_office_id?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_line?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  features_amenities?: InputMaybe<Order_By>;
  features_appliances_and_equipment?: InputMaybe<Order_By>;
  features_basement?: InputMaybe<Order_By>;
  features_bathrooms?: InputMaybe<Order_By>;
  features_bedrooms?: InputMaybe<Order_By>;
  features_community?: InputMaybe<Order_By>;
  features_cooling?: InputMaybe<Order_By>;
  features_dining_room?: InputMaybe<Order_By>;
  features_disclosures?: InputMaybe<Order_By>;
  features_doors?: InputMaybe<Order_By>;
  features_energy_saving?: InputMaybe<Order_By>;
  features_exterior_features?: InputMaybe<Order_By>;
  features_fees?: InputMaybe<Order_By>;
  features_fence?: InputMaybe<Order_By>;
  features_fireplaces?: InputMaybe<Order_By>;
  features_foundation?: InputMaybe<Order_By>;
  features_garage?: InputMaybe<Order_By>;
  features_heating?: InputMaybe<Order_By>;
  features_home_owners_association?: InputMaybe<Order_By>;
  features_house?: InputMaybe<Order_By>;
  features_interior?: InputMaybe<Order_By>;
  features_interior_features?: InputMaybe<Order_By>;
  features_kitchen?: InputMaybe<Order_By>;
  features_laundry?: InputMaybe<Order_By>;
  features_listing?: InputMaybe<Order_By>;
  features_location?: InputMaybe<Order_By>;
  features_lot?: InputMaybe<Order_By>;
  features_miscellaneous?: InputMaybe<Order_By>;
  features_parking?: InputMaybe<Order_By>;
  features_pool?: InputMaybe<Order_By>;
  features_property?: InputMaybe<Order_By>;
  features_property_access?: InputMaybe<Order_By>;
  features_roof?: InputMaybe<Order_By>;
  features_schools?: InputMaybe<Order_By>;
  features_security_system?: InputMaybe<Order_By>;
  features_sewer?: InputMaybe<Order_By>;
  features_spa?: InputMaybe<Order_By>;
  features_taxes?: InputMaybe<Order_By>;
  features_utilities?: InputMaybe<Order_By>;
  features_water?: InputMaybe<Order_By>;
  features_windows_and_doors?: InputMaybe<Order_By>;
  firestore_id?: InputMaybe<Order_By>;
  geo_type?: InputMaybe<Order_By>;
  home?: InputMaybe<Homes_Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_attributes_aggregate?: InputMaybe<Mls_Listing_Internal_Attributes_Aggregate_Order_By>;
  is_audited?: InputMaybe<Order_By>;
  is_new_construction?: InputMaybe<Order_By>;
  last_audited_at?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  listed_rents_aggregate?: InputMaybe<Listed_Rents_Aggregate_Order_By>;
  listing_agent_id?: InputMaybe<Order_By>;
  listing_date?: InputMaybe<Order_By>;
  listing_office_id?: InputMaybe<Order_By>;
  listing_type?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  opportunity_underwrites_aggregate?: InputMaybe<Underwrites_Opportunity_Underwrites_Aggregate_Order_By>;
  photos_aggregate?: InputMaybe<Mls_Listing_Photos_Aggregate_Order_By>;
  property_type?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  real_estate_acquisitions_aggregate?: InputMaybe<Real_Estate_Acquisitions_Aggregate_Order_By>;
  real_estate_screenings_aggregate?: InputMaybe<Real_Estate_Screenings_Aggregate_Order_By>;
  region?: InputMaybe<Order_By>;
  rent_prices_aggregate?: InputMaybe<Rent_Prices_Aggregate_Order_By>;
  rent_ready_dates_aggregate?: InputMaybe<Rent_Ready_Dates_Aggregate_Order_By>;
  rental_applications_aggregate?: InputMaybe<Rental_Applications_Aggregate_Order_By>;
  school_district?: InputMaybe<Order_By>;
  school_elementary?: InputMaybe<Order_By>;
  school_high?: InputMaybe<Order_By>;
  school_middle?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  standardized_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  std_address?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  subdivision?: InputMaybe<Order_By>;
  system_id?: InputMaybe<Order_By>;
  tour_url?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xf_attributes?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** select columns of table "opportunities" */
export enum Opportunities_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AuditResults = 'audit_results',
  /** column name */
  BathsFull = 'baths_full',
  /** column name */
  BathsHalf = 'baths_half',
  /** column name */
  BathsTotal = 'baths_total',
  /** column name */
  BathsWeighted = 'baths_weighted',
  /** column name */
  Beds = 'beds',
  /** column name */
  City = 'city',
  /** column name */
  CoListingAgentId = 'co_listing_agent_id',
  /** column name */
  CoListingOfficeId = 'co_listing_office_id',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryLine = 'delivery_line',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayLine_1 = 'display_line_1',
  /** column name */
  DisplayLine_2 = 'display_line_2',
  /** column name */
  FeaturesAmenities = 'features_amenities',
  /** column name */
  FeaturesAppliancesAndEquipment = 'features_appliances_and_equipment',
  /** column name */
  FeaturesBasement = 'features_basement',
  /** column name */
  FeaturesBathrooms = 'features_bathrooms',
  /** column name */
  FeaturesBedrooms = 'features_bedrooms',
  /** column name */
  FeaturesCommunity = 'features_community',
  /** column name */
  FeaturesCooling = 'features_cooling',
  /** column name */
  FeaturesDiningRoom = 'features_dining_room',
  /** column name */
  FeaturesDisclosures = 'features_disclosures',
  /** column name */
  FeaturesDoors = 'features_doors',
  /** column name */
  FeaturesEnergySaving = 'features_energy_saving',
  /** column name */
  FeaturesExteriorFeatures = 'features_exterior_features',
  /** column name */
  FeaturesFees = 'features_fees',
  /** column name */
  FeaturesFence = 'features_fence',
  /** column name */
  FeaturesFireplaces = 'features_fireplaces',
  /** column name */
  FeaturesFoundation = 'features_foundation',
  /** column name */
  FeaturesGarage = 'features_garage',
  /** column name */
  FeaturesHeating = 'features_heating',
  /** column name */
  FeaturesHomeOwnersAssociation = 'features_home_owners_association',
  /** column name */
  FeaturesHouse = 'features_house',
  /** column name */
  FeaturesInterior = 'features_interior',
  /** column name */
  FeaturesInteriorFeatures = 'features_interior_features',
  /** column name */
  FeaturesKitchen = 'features_kitchen',
  /** column name */
  FeaturesLaundry = 'features_laundry',
  /** column name */
  FeaturesListing = 'features_listing',
  /** column name */
  FeaturesLocation = 'features_location',
  /** column name */
  FeaturesLot = 'features_lot',
  /** column name */
  FeaturesMiscellaneous = 'features_miscellaneous',
  /** column name */
  FeaturesParking = 'features_parking',
  /** column name */
  FeaturesPool = 'features_pool',
  /** column name */
  FeaturesProperty = 'features_property',
  /** column name */
  FeaturesPropertyAccess = 'features_property_access',
  /** column name */
  FeaturesRoof = 'features_roof',
  /** column name */
  FeaturesSchools = 'features_schools',
  /** column name */
  FeaturesSecuritySystem = 'features_security_system',
  /** column name */
  FeaturesSewer = 'features_sewer',
  /** column name */
  FeaturesSpa = 'features_spa',
  /** column name */
  FeaturesTaxes = 'features_taxes',
  /** column name */
  FeaturesUtilities = 'features_utilities',
  /** column name */
  FeaturesWater = 'features_water',
  /** column name */
  FeaturesWindowsAndDoors = 'features_windows_and_doors',
  /** column name */
  FirestoreId = 'firestore_id',
  /** column name */
  GeoType = 'geo_type',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAudited = 'is_audited',
  /** column name */
  IsNewConstruction = 'is_new_construction',
  /** column name */
  LastAuditedAt = 'last_audited_at',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  ListingAgentId = 'listing_agent_id',
  /** column name */
  ListingDate = 'listing_date',
  /** column name */
  ListingOfficeId = 'listing_office_id',
  /** column name */
  ListingType = 'listing_type',
  /** column name */
  Lng = 'lng',
  /** column name */
  LotsizeAcres = 'lotsize_acres',
  /** column name */
  LotsizeSqft = 'lotsize_sqft',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Mls = 'mls',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Region = 'region',
  /** column name */
  SchoolDistrict = 'school_district',
  /** column name */
  SchoolElementary = 'school_elementary',
  /** column name */
  SchoolHigh = 'school_high',
  /** column name */
  SchoolMiddle = 'school_middle',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  Size = 'size',
  /** column name */
  StandardizedAddress = 'standardized_address',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  StdAddress = 'std_address',
  /** column name */
  Street = 'street',
  /** column name */
  Style = 'style',
  /** column name */
  Subdivision = 'subdivision',
  /** column name */
  SystemId = 'system_id',
  /** column name */
  TourUrl = 'tour_url',
  /** column name */
  Unit = 'unit',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XfAttributes = 'xf_attributes',
  /** column name */
  YearBuilt = 'year_built',
  /** column name */
  Zip = 'zip'
}

/** order by stddev() on columns of table "opportunities" */
export type Opportunities_Stddev_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "opportunities" */
export type Opportunities_Stddev_Pop_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "opportunities" */
export type Opportunities_Stddev_Samp_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "opportunities" */
export type Opportunities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Opportunities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opportunities_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  audit_results?: InputMaybe<Scalars['jsonb']['input']>;
  baths_full?: InputMaybe<Scalars['Float']['input']>;
  baths_half?: InputMaybe<Scalars['Float']['input']>;
  baths_total?: InputMaybe<Scalars['Float']['input']>;
  baths_weighted?: InputMaybe<Scalars['numeric']['input']>;
  beds?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  co_listing_agent_id?: InputMaybe<Scalars['uuid']['input']>;
  co_listing_office_id?: InputMaybe<Scalars['uuid']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_line?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_line_1?: InputMaybe<Scalars['String']['input']>;
  display_line_2?: InputMaybe<Scalars['String']['input']>;
  features_amenities?: InputMaybe<Scalars['_varchar']['input']>;
  features_appliances_and_equipment?: InputMaybe<Scalars['_varchar']['input']>;
  features_basement?: InputMaybe<Scalars['_varchar']['input']>;
  features_bathrooms?: InputMaybe<Scalars['_varchar']['input']>;
  features_bedrooms?: InputMaybe<Scalars['_varchar']['input']>;
  features_community?: InputMaybe<Scalars['_varchar']['input']>;
  features_cooling?: InputMaybe<Scalars['_varchar']['input']>;
  features_dining_room?: InputMaybe<Scalars['_varchar']['input']>;
  features_disclosures?: InputMaybe<Scalars['_varchar']['input']>;
  features_doors?: InputMaybe<Scalars['_varchar']['input']>;
  features_energy_saving?: InputMaybe<Scalars['_varchar']['input']>;
  features_exterior_features?: InputMaybe<Scalars['_varchar']['input']>;
  features_fees?: InputMaybe<Scalars['_varchar']['input']>;
  features_fence?: InputMaybe<Scalars['_varchar']['input']>;
  features_fireplaces?: InputMaybe<Scalars['_varchar']['input']>;
  features_foundation?: InputMaybe<Scalars['_varchar']['input']>;
  features_garage?: InputMaybe<Scalars['_varchar']['input']>;
  features_heating?: InputMaybe<Scalars['_varchar']['input']>;
  features_home_owners_association?: InputMaybe<Scalars['_varchar']['input']>;
  features_house?: InputMaybe<Scalars['_varchar']['input']>;
  features_interior?: InputMaybe<Scalars['_varchar']['input']>;
  features_interior_features?: InputMaybe<Scalars['_varchar']['input']>;
  features_kitchen?: InputMaybe<Scalars['_varchar']['input']>;
  features_laundry?: InputMaybe<Scalars['_varchar']['input']>;
  features_listing?: InputMaybe<Scalars['_varchar']['input']>;
  features_location?: InputMaybe<Scalars['_varchar']['input']>;
  features_lot?: InputMaybe<Scalars['_varchar']['input']>;
  features_miscellaneous?: InputMaybe<Scalars['_varchar']['input']>;
  features_parking?: InputMaybe<Scalars['_varchar']['input']>;
  features_pool?: InputMaybe<Scalars['_varchar']['input']>;
  features_property?: InputMaybe<Scalars['_varchar']['input']>;
  features_property_access?: InputMaybe<Scalars['_varchar']['input']>;
  features_roof?: InputMaybe<Scalars['_varchar']['input']>;
  features_schools?: InputMaybe<Scalars['_varchar']['input']>;
  features_security_system?: InputMaybe<Scalars['_varchar']['input']>;
  features_sewer?: InputMaybe<Scalars['_varchar']['input']>;
  features_spa?: InputMaybe<Scalars['_varchar']['input']>;
  features_taxes?: InputMaybe<Scalars['_varchar']['input']>;
  features_utilities?: InputMaybe<Scalars['_varchar']['input']>;
  features_water?: InputMaybe<Scalars['_varchar']['input']>;
  features_windows_and_doors?: InputMaybe<Scalars['_varchar']['input']>;
  firestore_id?: InputMaybe<Scalars['uuid']['input']>;
  geo_type?: InputMaybe<Scalars['String']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_audited?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_construction?: InputMaybe<Scalars['Boolean']['input']>;
  last_audited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  list_price?: InputMaybe<Scalars['numeric']['input']>;
  listing_agent_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_office_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_type?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lotsize_acres?: InputMaybe<Scalars['Float']['input']>;
  lotsize_sqft?: InputMaybe<Scalars['bigint']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  mls?: InputMaybe<Scalars['String']['input']>;
  modified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  school_district?: InputMaybe<Scalars['String']['input']>;
  school_elementary?: InputMaybe<Scalars['String']['input']>;
  school_high?: InputMaybe<Scalars['String']['input']>;
  school_middle?: InputMaybe<Scalars['String']['input']>;
  short_id?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  standardized_address?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  std_address?: InputMaybe<Scalars['jsonb']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  system_id?: InputMaybe<Scalars['String']['input']>;
  tour_url?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xf_attributes?: InputMaybe<Scalars['jsonb']['input']>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "opportunities" */
export type Opportunities_Sum_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "opportunities" */
export type Opportunities_Var_Pop_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "opportunities" */
export type Opportunities_Var_Samp_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "opportunities" */
export type Opportunities_Variance_Order_By = {
  baths_full?: InputMaybe<Order_By>;
  baths_half?: InputMaybe<Order_By>;
  baths_total?: InputMaybe<Order_By>;
  baths_weighted?: InputMaybe<Order_By>;
  beds?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lotsize_acres?: InputMaybe<Order_By>;
  lotsize_sqft?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** columns and relationships of "option_premium_transfers" */
export type Option_Premium_Transfers = {
  __typename: 'option_premium_transfers';
  amount: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['date']['output'];
  from_rental_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  to_rental_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "option_premium_transfers" */
export type Option_Premium_Transfers_Aggregate_Order_By = {
  avg?: InputMaybe<Option_Premium_Transfers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Option_Premium_Transfers_Max_Order_By>;
  min?: InputMaybe<Option_Premium_Transfers_Min_Order_By>;
  stddev?: InputMaybe<Option_Premium_Transfers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Option_Premium_Transfers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Option_Premium_Transfers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Option_Premium_Transfers_Sum_Order_By>;
  var_pop?: InputMaybe<Option_Premium_Transfers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Option_Premium_Transfers_Var_Samp_Order_By>;
  variance?: InputMaybe<Option_Premium_Transfers_Variance_Order_By>;
};

/** order by avg() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "option_premium_transfers". All fields are combined with a logical 'AND'. */
export type Option_Premium_Transfers_Bool_Exp = {
  _and?: InputMaybe<Array<Option_Premium_Transfers_Bool_Exp>>;
  _not?: InputMaybe<Option_Premium_Transfers_Bool_Exp>;
  _or?: InputMaybe<Array<Option_Premium_Transfers_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  from_rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  to_rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  from_rental_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  from_rental_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "option_premium_transfers". */
export type Option_Premium_Transfers_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  from_rental_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "option_premium_transfers" */
export enum Option_Premium_Transfers_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  FromRentalId = 'from_rental_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToRentalId = 'to_rental_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "option_premium_transfers" */
export type Option_Premium_Transfers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Option_Premium_Transfers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Option_Premium_Transfers_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  from_rental_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  to_rental_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "option_premium_transfers" */
export type Option_Premium_Transfers_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "payment_methods" */
export type Payment_Methods = {
  __typename: 'payment_methods';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  mask: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plaid_access_token?: Maybe<Scalars['String']['output']>;
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_verification_status?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stripe_payment_method_id?: Maybe<Scalars['String']['output']>;
  stripe_source_id?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "payment_methods" */
export type Payment_Methods_Aggregate = {
  __typename: 'payment_methods_aggregate';
  aggregate?: Maybe<Payment_Methods_Aggregate_Fields>;
  nodes: Array<Payment_Methods>;
};

export type Payment_Methods_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp_Count>;
};

export type Payment_Methods_Aggregate_Bool_Exp_Bool_And = {
  arguments: Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Methods_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payment_Methods_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Methods_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payment_Methods_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Methods_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_methods" */
export type Payment_Methods_Aggregate_Fields = {
  __typename: 'payment_methods_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Methods_Max_Fields>;
  min?: Maybe<Payment_Methods_Min_Fields>;
};


/** aggregate fields of "payment_methods" */
export type Payment_Methods_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payment_methods" */
export type Payment_Methods_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Methods_Max_Order_By>;
  min?: InputMaybe<Payment_Methods_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type Payment_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  _not?: InputMaybe<Payment_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  mask?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  plaid_access_token?: InputMaybe<String_Comparison_Exp>;
  plaid_account_id?: InputMaybe<String_Comparison_Exp>;
  plaid_verification_status?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_method_id?: InputMaybe<String_Comparison_Exp>;
  stripe_source_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Payment_Methods_Max_Fields = {
  __typename: 'payment_methods_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plaid_access_token?: Maybe<Scalars['String']['output']>;
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_verification_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_payment_method_id?: Maybe<Scalars['String']['output']>;
  stripe_source_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "payment_methods" */
export type Payment_Methods_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mask?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  plaid_access_token?: InputMaybe<Order_By>;
  plaid_account_id?: InputMaybe<Order_By>;
  plaid_verification_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_payment_method_id?: InputMaybe<Order_By>;
  stripe_source_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Methods_Min_Fields = {
  __typename: 'payment_methods_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plaid_access_token?: Maybe<Scalars['String']['output']>;
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_verification_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_payment_method_id?: Maybe<Scalars['String']['output']>;
  stripe_source_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "payment_methods" */
export type Payment_Methods_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mask?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  plaid_access_token?: InputMaybe<Order_By>;
  plaid_account_id?: InputMaybe<Order_By>;
  plaid_verification_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_payment_method_id?: InputMaybe<Order_By>;
  stripe_source_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "payment_methods". */
export type Payment_Methods_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  mask?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  plaid_access_token?: InputMaybe<Order_By>;
  plaid_account_id?: InputMaybe<Order_By>;
  plaid_verification_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_payment_method_id?: InputMaybe<Order_By>;
  stripe_source_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "payment_methods" */
export enum Payment_Methods_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Mask = 'mask',
  /** column name */
  Name = 'name',
  /** column name */
  PlaidAccessToken = 'plaid_access_token',
  /** column name */
  PlaidAccountId = 'plaid_account_id',
  /** column name */
  PlaidVerificationStatus = 'plaid_verification_status',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentMethodId = 'stripe_payment_method_id',
  /** column name */
  StripeSourceId = 'stripe_source_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "payment_methods_aggregate_bool_exp_bool_and_arguments_columns" columns of table "payment_methods" */
export enum Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDefault = 'is_default'
}

/** select "payment_methods_aggregate_bool_exp_bool_or_arguments_columns" columns of table "payment_methods" */
export enum Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDefault = 'is_default'
}

/** Streaming cursor of the table "payment_methods" */
export type Payment_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Methods_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  mask?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plaid_access_token?: InputMaybe<Scalars['String']['input']>;
  plaid_account_id?: InputMaybe<Scalars['String']['input']>;
  plaid_verification_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_method_id?: InputMaybe<Scalars['String']['input']>;
  stripe_source_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "payment_plan_liabilities" */
export type Payment_Plan_Liabilities = {
  __typename: 'payment_plan_liabilities';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  payment_plan_id: Scalars['uuid']['output'];
  rental_liability_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "payment_plan_liabilities". All fields are combined with a logical 'AND'. */
export type Payment_Plan_Liabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Plan_Liabilities_Bool_Exp>>;
  _not?: InputMaybe<Payment_Plan_Liabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Plan_Liabilities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "payment_plan_liabilities". */
export type Payment_Plan_Liabilities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_plan_id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "payment_plan_liabilities" */
export enum Payment_Plan_Liabilities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentPlanId = 'payment_plan_id',
  /** column name */
  RentalLiabilityId = 'rental_liability_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "payment_plan_liabilities" */
export type Payment_Plan_Liabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Plan_Liabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Plan_Liabilities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_liability_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "payment_plan_offset_credits" */
export type Payment_Plan_Offset_Credits = {
  __typename: 'payment_plan_offset_credits';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  payment_plan_id: Scalars['uuid']['output'];
  rental_credit_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "payment_plan_offset_credits" */
export type Payment_Plan_Offset_Credits_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Plan_Offset_Credits_Max_Order_By>;
  min?: InputMaybe<Payment_Plan_Offset_Credits_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "payment_plan_offset_credits". All fields are combined with a logical 'AND'. */
export type Payment_Plan_Offset_Credits_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Plan_Offset_Credits_Bool_Exp>>;
  _not?: InputMaybe<Payment_Plan_Offset_Credits_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Plan_Offset_Credits_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_credit_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "payment_plan_offset_credits" */
export type Payment_Plan_Offset_Credits_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_plan_id?: InputMaybe<Order_By>;
  rental_credit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "payment_plan_offset_credits" */
export type Payment_Plan_Offset_Credits_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_plan_id?: InputMaybe<Order_By>;
  rental_credit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "payment_plan_offset_credits". */
export type Payment_Plan_Offset_Credits_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_plan_id?: InputMaybe<Order_By>;
  rental_credit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "payment_plan_offset_credits" */
export enum Payment_Plan_Offset_Credits_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentPlanId = 'payment_plan_id',
  /** column name */
  RentalCreditId = 'rental_credit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "payment_plan_offset_credits" */
export type Payment_Plan_Offset_Credits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Plan_Offset_Credits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Plan_Offset_Credits_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_credit_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "payments" */
export type Payments = {
  __typename: 'payments';
  amount: Scalars['numeric']['output'];
  available_on?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  buildium_transaction?: Maybe<Buildium_Transactions>;
  category: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  failed_payment_email_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  initiated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  lifecycle: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['date']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  property?: Maybe<Properties>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  refund_reason?: Maybe<Scalars['String']['output']>;
  refunded_at?: Maybe<Scalars['timestamptz']['output']>;
  refunded_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  stripe_charge_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "payments" */
export type Payments_Aggregate = {
  __typename: 'payments_aggregate';
  aggregate?: Maybe<Payments_Aggregate_Fields>;
  nodes: Array<Payments>;
};

export type Payments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payments_Aggregate_Bool_Exp_Count>;
};

export type Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payments" */
export type Payments_Aggregate_Fields = {
  __typename: 'payments_aggregate_fields';
  avg?: Maybe<Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payments_Max_Fields>;
  min?: Maybe<Payments_Min_Fields>;
  stddev?: Maybe<Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Payments_Sum_Fields>;
  var_pop?: Maybe<Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Payments_Var_Samp_Fields>;
  variance?: Maybe<Payments_Variance_Fields>;
};


/** aggregate fields of "payments" */
export type Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Payments_Avg_Fields = {
  __typename: 'payments_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  available_on?: InputMaybe<Date_Comparison_Exp>;
  buildium_transaction?: InputMaybe<Buildium_Transactions_Bool_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  failed_payment_email_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initiated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  lifecycle?: InputMaybe<String_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  payment_date?: InputMaybe<Date_Comparison_Exp>;
  payment_method?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  refund_reason?: InputMaybe<String_Comparison_Exp>;
  refunded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  refunded_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripe_charge_id?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_intent_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export enum Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey'
}

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_transaction?: InputMaybe<Buildium_Transactions_Obj_Rel_Insert_Input>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  failed_payment_email_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initiated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  lifecycle?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['date']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_charge_id?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Payments_Max_Fields = {
  __typename: 'payments_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  available_on?: Maybe<Scalars['date']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  failed_payment_email_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initiated_at?: Maybe<Scalars['timestamptz']['output']>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  lifecycle?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['date']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  refund_reason?: Maybe<Scalars['String']['output']>;
  refunded_at?: Maybe<Scalars['timestamptz']['output']>;
  refunded_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_charge_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  available_on?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failed_payment_email_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiated_at?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  lifecycle?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  refund_reason?: InputMaybe<Order_By>;
  refunded_at?: InputMaybe<Order_By>;
  refunded_by_admin_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_charge_id?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payments_Min_Fields = {
  __typename: 'payments_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  available_on?: Maybe<Scalars['date']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  failed_payment_email_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initiated_at?: Maybe<Scalars['timestamptz']['output']>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  lifecycle?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['date']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  refund_reason?: Maybe<Scalars['String']['output']>;
  refunded_at?: Maybe<Scalars['timestamptz']['output']>;
  refunded_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_charge_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  available_on?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failed_payment_email_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiated_at?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  lifecycle?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  refund_reason?: InputMaybe<Order_By>;
  refunded_at?: InputMaybe<Order_By>;
  refunded_by_admin_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_charge_id?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payments" */
export type Payments_Mutation_Response = {
  __typename: 'payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payments>;
};

/** on_conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns?: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  available_on?: InputMaybe<Order_By>;
  buildium_transaction?: InputMaybe<Buildium_Transactions_Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failed_payment_email_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiated_at?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  lifecycle?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  refund_reason?: InputMaybe<Order_By>;
  refunded_at?: InputMaybe<Order_By>;
  refunded_by_admin_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_charge_id?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AvailableOn = 'available_on',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailedPaymentEmailSentAt = 'failed_payment_email_sent_at',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedAt = 'initiated_at',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Lifecycle = 'lifecycle',
  /** column name */
  Note = 'note',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RefundReason = 'refund_reason',
  /** column name */
  RefundedAt = 'refunded_at',
  /** column name */
  RefundedByAdminId = 'refunded_by_admin_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeChargeId = 'stripe_charge_id',
  /** column name */
  StripePaymentIntentId = 'stripe_payment_intent_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Payments_Stddev_Fields = {
  __typename: 'payments_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payments_Stddev_Pop_Fields = {
  __typename: 'payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payments_Stddev_Samp_Fields = {
  __typename: 'payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  available_on?: InputMaybe<Scalars['date']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  failed_payment_email_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initiated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  lifecycle?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['date']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  refund_reason?: InputMaybe<Scalars['String']['input']>;
  refunded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  refunded_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_charge_id?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Payments_Sum_Fields = {
  __typename: 'payments_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "payments" (current role has no relevant permissions) */
export enum Payments_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Payments_Var_Pop_Fields = {
  __typename: 'payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payments_Var_Samp_Fields = {
  __typename: 'payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payments_Variance_Fields = {
  __typename: 'payments_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "plaid_income_verification_documents" */
export type Plaid_Income_Verification_Documents = {
  __typename: 'plaid_income_verification_documents';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  friendly_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  plaid_income_verification?: Maybe<Plaid_Income_Verifications>;
  resource_id?: Maybe<Scalars['uuid']['output']>;
  resource_notes?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  review_notes?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "plaid_income_verification_documents" */
export type Plaid_Income_Verification_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plaid_Income_Verification_Documents_Max_Order_By>;
  min?: InputMaybe<Plaid_Income_Verification_Documents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "plaid_income_verification_documents". All fields are combined with a logical 'AND'. */
export type Plaid_Income_Verification_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Plaid_Income_Verification_Documents_Bool_Exp>>;
  _not?: InputMaybe<Plaid_Income_Verification_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Plaid_Income_Verification_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  friendly_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  plaid_income_verification?: InputMaybe<Plaid_Income_Verifications_Bool_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_notes?: InputMaybe<String_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  review_notes?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "plaid_income_verification_documents" */
export type Plaid_Income_Verification_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "plaid_income_verification_documents" */
export type Plaid_Income_Verification_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "plaid_income_verification_documents". */
export type Plaid_Income_Verification_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plaid_income_verification?: InputMaybe<Plaid_Income_Verifications_Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "plaid_income_verification_documents" */
export enum Plaid_Income_Verification_Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceNotes = 'resource_notes',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ReviewNotes = 'review_notes',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "plaid_income_verification_documents" */
export type Plaid_Income_Verification_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plaid_Income_Verification_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plaid_Income_Verification_Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  friendly_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_notes?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "plaid_income_verifications" */
export type Plaid_Income_Verifications = {
  __typename: 'plaid_income_verifications';
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  documents: Array<Plaid_Income_Verification_Documents>;
  id: Scalars['uuid']['output'];
  income_response?: Maybe<Scalars['jsonb']['output']>;
  income_verification_id?: Maybe<Scalars['String']['output']>;
  income_verification_request_id?: Maybe<Scalars['String']['output']>;
  link_token_request_id: Scalars['String']['output'];
  paystub_data?: Maybe<Scalars['jsonb']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  summary_data?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "plaid_income_verifications" */
export type Plaid_Income_VerificationsDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Plaid_Income_Verification_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plaid_Income_Verification_Documents_Order_By>>;
  where?: InputMaybe<Plaid_Income_Verification_Documents_Bool_Exp>;
};


/** columns and relationships of "plaid_income_verifications" */
export type Plaid_Income_VerificationsIncome_ResponseArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "plaid_income_verifications" */
export type Plaid_Income_VerificationsPaystub_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "plaid_income_verifications" */
export type Plaid_Income_VerificationsSummary_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "plaid_income_verifications". All fields are combined with a logical 'AND'. */
export type Plaid_Income_Verifications_Bool_Exp = {
  _and?: InputMaybe<Array<Plaid_Income_Verifications_Bool_Exp>>;
  _not?: InputMaybe<Plaid_Income_Verifications_Bool_Exp>;
  _or?: InputMaybe<Array<Plaid_Income_Verifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  documents?: InputMaybe<Plaid_Income_Verification_Documents_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income_response?: InputMaybe<Jsonb_Comparison_Exp>;
  income_verification_id?: InputMaybe<String_Comparison_Exp>;
  income_verification_request_id?: InputMaybe<String_Comparison_Exp>;
  link_token_request_id?: InputMaybe<String_Comparison_Exp>;
  paystub_data?: InputMaybe<Jsonb_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  summary_data?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "plaid_income_verifications". */
export type Plaid_Income_Verifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Plaid_Income_Verification_Documents_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  income_response?: InputMaybe<Order_By>;
  income_verification_id?: InputMaybe<Order_By>;
  income_verification_request_id?: InputMaybe<Order_By>;
  link_token_request_id?: InputMaybe<Order_By>;
  paystub_data?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  summary_data?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "plaid_income_verifications" */
export enum Plaid_Income_Verifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeResponse = 'income_response',
  /** column name */
  IncomeVerificationId = 'income_verification_id',
  /** column name */
  IncomeVerificationRequestId = 'income_verification_request_id',
  /** column name */
  LinkTokenRequestId = 'link_token_request_id',
  /** column name */
  PaystubData = 'paystub_data',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  SummaryData = 'summary_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "plaid_income_verifications" */
export type Plaid_Income_Verifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plaid_Income_Verifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plaid_Income_Verifications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_response?: InputMaybe<Scalars['jsonb']['input']>;
  income_verification_id?: InputMaybe<Scalars['String']['input']>;
  income_verification_request_id?: InputMaybe<Scalars['String']['input']>;
  link_token_request_id?: InputMaybe<Scalars['String']['input']>;
  paystub_data?: InputMaybe<Scalars['jsonb']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  summary_data?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "portfolio_home_external_features" */
export type Portfolio_Home_External_Features = {
  __typename: 'portfolio_home_external_features';
  created_at: Scalars['timestamptz']['output'];
  fence?: Maybe<Scalars['String']['output']>;
  garage?: Maybe<Scalars['String']['output']>;
  gate?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  mailbox_info?: Maybe<Scalars['String']['output']>;
  parking?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  security: Scalars['String']['output'];
  /** An object relationship */
  security_enum: Security_Enum;
  shed?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "portfolio_home_external_features" */
export type Portfolio_Home_External_Features_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Portfolio_Home_External_Features_Max_Order_By>;
  min?: InputMaybe<Portfolio_Home_External_Features_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "portfolio_home_external_features". All fields are combined with a logical 'AND'. */
export type Portfolio_Home_External_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Home_External_Features_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Home_External_Features_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fence?: InputMaybe<String_Comparison_Exp>;
  garage?: InputMaybe<String_Comparison_Exp>;
  gate?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mailbox_info?: InputMaybe<String_Comparison_Exp>;
  parking?: InputMaybe<String_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  security?: InputMaybe<String_Comparison_Exp>;
  security_enum?: InputMaybe<Security_Enum_Bool_Exp>;
  shed?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "portfolio_home_external_features" */
export type Portfolio_Home_External_Features_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fence?: InputMaybe<Order_By>;
  garage?: InputMaybe<Order_By>;
  gate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailbox_info?: InputMaybe<Order_By>;
  parking?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  security?: InputMaybe<Order_By>;
  shed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "portfolio_home_external_features" */
export type Portfolio_Home_External_Features_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fence?: InputMaybe<Order_By>;
  garage?: InputMaybe<Order_By>;
  gate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailbox_info?: InputMaybe<Order_By>;
  parking?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  security?: InputMaybe<Order_By>;
  shed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "portfolio_home_external_features". */
export type Portfolio_Home_External_Features_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fence?: InputMaybe<Order_By>;
  garage?: InputMaybe<Order_By>;
  gate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailbox_info?: InputMaybe<Order_By>;
  parking?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  security?: InputMaybe<Order_By>;
  security_enum?: InputMaybe<Security_Enum_Order_By>;
  shed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "portfolio_home_external_features" */
export enum Portfolio_Home_External_Features_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Fence = 'fence',
  /** column name */
  Garage = 'garage',
  /** column name */
  Gate = 'gate',
  /** column name */
  Id = 'id',
  /** column name */
  MailboxInfo = 'mailbox_info',
  /** column name */
  Parking = 'parking',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  Security = 'security',
  /** column name */
  Shed = 'shed',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "portfolio_home_external_features" */
export type Portfolio_Home_External_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Home_External_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Home_External_Features_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fence?: InputMaybe<Scalars['String']['input']>;
  garage?: InputMaybe<Scalars['String']['input']>;
  gate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mailbox_info?: InputMaybe<Scalars['String']['input']>;
  parking?: InputMaybe<Scalars['String']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  security?: InputMaybe<Scalars['String']['input']>;
  shed?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "portfolio_home_internal_features" */
export type Portfolio_Home_Internal_Features = {
  __typename: 'portfolio_home_internal_features';
  appliances?: Maybe<Scalars['String']['output']>;
  basement?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  utilities_exception?: Maybe<Scalars['String']['output']>;
  warranties?: Maybe<Scalars['String']['output']>;
  washer_dryer?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to filter rows from the table "portfolio_home_internal_features". All fields are combined with a logical 'AND'. */
export type Portfolio_Home_Internal_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Home_Internal_Features_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Home_Internal_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Home_Internal_Features_Bool_Exp>>;
  appliances?: InputMaybe<String_Comparison_Exp>;
  basement?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utilities_exception?: InputMaybe<String_Comparison_Exp>;
  warranties?: InputMaybe<String_Comparison_Exp>;
  washer_dryer?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "portfolio_home_internal_features". */
export type Portfolio_Home_Internal_Features_Order_By = {
  appliances?: InputMaybe<Order_By>;
  basement?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilities_exception?: InputMaybe<Order_By>;
  warranties?: InputMaybe<Order_By>;
  washer_dryer?: InputMaybe<Order_By>;
};

/** select columns of table "portfolio_home_internal_features" */
export enum Portfolio_Home_Internal_Features_Select_Column {
  /** column name */
  Appliances = 'appliances',
  /** column name */
  Basement = 'basement',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtilitiesException = 'utilities_exception',
  /** column name */
  Warranties = 'warranties',
  /** column name */
  WasherDryer = 'washer_dryer'
}

/** Streaming cursor of the table "portfolio_home_internal_features" */
export type Portfolio_Home_Internal_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Home_Internal_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Home_Internal_Features_Stream_Cursor_Value_Input = {
  appliances?: InputMaybe<Scalars['String']['input']>;
  basement?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utilities_exception?: InputMaybe<Scalars['String']['input']>;
  warranties?: InputMaybe<Scalars['String']['input']>;
  washer_dryer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "portfolio_home_system_work_order_system_enum" */
export type Portfolio_Home_System_Work_Order_System_Enum = {
  __typename: 'portfolio_home_system_work_order_system_enum';
  system: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "portfolio_home_system_work_order_system_enum". All fields are combined with a logical 'AND'. */
export type Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>>;
  system?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "portfolio_home_system_work_order_system_enum". */
export type Portfolio_Home_System_Work_Order_System_Enum_Order_By = {
  system?: InputMaybe<Order_By>;
};

/** select columns of table "portfolio_home_system_work_order_system_enum" */
export enum Portfolio_Home_System_Work_Order_System_Enum_Select_Column {
  /** column name */
  System = 'system'
}

/** Streaming cursor of the table "portfolio_home_system_work_order_system_enum" */
export type Portfolio_Home_System_Work_Order_System_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Home_System_Work_Order_System_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Home_System_Work_Order_System_Enum_Stream_Cursor_Value_Input = {
  system?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "portfolio_home_system_work_order_type_enum" */
export type Portfolio_Home_System_Work_Order_Type_Enum = {
  __typename: 'portfolio_home_system_work_order_type_enum';
  type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "portfolio_home_system_work_order_type_enum". All fields are combined with a logical 'AND'. */
export type Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "portfolio_home_system_work_order_type_enum". */
export type Portfolio_Home_System_Work_Order_Type_Enum_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** select columns of table "portfolio_home_system_work_order_type_enum" */
export enum Portfolio_Home_System_Work_Order_Type_Enum_Select_Column {
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "portfolio_home_system_work_order_type_enum" */
export type Portfolio_Home_System_Work_Order_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Home_System_Work_Order_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Home_System_Work_Order_Type_Enum_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "portfolio_home_system_work_orders" */
export type Portfolio_Home_System_Work_Orders = {
  __typename: 'portfolio_home_system_work_orders';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home_system_work_order_system_enum: Portfolio_Home_System_Work_Order_System_Enum;
  /** An object relationship */
  portfolio_home_system_work_order_type_enum: Portfolio_Home_System_Work_Order_Type_Enum;
  service_date: Scalars['date']['output'];
  system: Scalars['String']['output'];
  type: Scalars['String']['output'];
  under_warranty?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
  warranty_end_date?: Maybe<Scalars['date']['output']>;
};

/** Boolean expression to filter rows from the table "portfolio_home_system_work_orders". All fields are combined with a logical 'AND'. */
export type Portfolio_Home_System_Work_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Home_System_Work_Orders_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Home_System_Work_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Home_System_Work_Orders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_system_work_order_system_enum?: InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>;
  portfolio_home_system_work_order_type_enum?: InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>;
  service_date?: InputMaybe<Date_Comparison_Exp>;
  system?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  under_warranty?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  warranty_end_date?: InputMaybe<Date_Comparison_Exp>;
};

/** Ordering options when selecting data from "portfolio_home_system_work_orders". */
export type Portfolio_Home_System_Work_Orders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  portfolio_home_system_work_order_system_enum?: InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Order_By>;
  portfolio_home_system_work_order_type_enum?: InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Order_By>;
  service_date?: InputMaybe<Order_By>;
  system?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  under_warranty?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  warranty_end_date?: InputMaybe<Order_By>;
};

/** select columns of table "portfolio_home_system_work_orders" */
export enum Portfolio_Home_System_Work_Orders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  ServiceDate = 'service_date',
  /** column name */
  System = 'system',
  /** column name */
  Type = 'type',
  /** column name */
  UnderWarranty = 'under_warranty',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  WarrantyEndDate = 'warranty_end_date'
}

/** Streaming cursor of the table "portfolio_home_system_work_orders" */
export type Portfolio_Home_System_Work_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Home_System_Work_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Home_System_Work_Orders_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  service_date?: InputMaybe<Scalars['date']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  under_warranty?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  warranty_end_date?: InputMaybe<Scalars['date']['input']>;
};

/** columns and relationships of "portfolio_home_utilities" */
export type Portfolio_Home_Utilities = {
  __typename: 'portfolio_home_utilities';
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  default_responsible_party: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  utility_responsibilities: Array<Utility_Responsibilities>;
  /** An object relationship */
  utility_type: Utility_Types;
  utility_type_id: Scalars['uuid']['output'];
};


/** columns and relationships of "portfolio_home_utilities" */
export type Portfolio_Home_UtilitiesUtility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
};

/** order by aggregate values of table "portfolio_home_utilities" */
export type Portfolio_Home_Utilities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Portfolio_Home_Utilities_Max_Order_By>;
  min?: InputMaybe<Portfolio_Home_Utilities_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "portfolio_home_utilities". All fields are combined with a logical 'AND'. */
export type Portfolio_Home_Utilities_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Home_Utilities_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Home_Utilities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_responsible_party?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utility_responsibilities?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
  utility_type?: InputMaybe<Utility_Types_Bool_Exp>;
  utility_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "portfolio_home_utilities" */
export type Portfolio_Home_Utilities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  default_responsible_party?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utility_type_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "portfolio_home_utilities" */
export type Portfolio_Home_Utilities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  default_responsible_party?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utility_type_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "portfolio_home_utilities". */
export type Portfolio_Home_Utilities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  default_responsible_party?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utility_responsibilities_aggregate?: InputMaybe<Utility_Responsibilities_Aggregate_Order_By>;
  utility_type?: InputMaybe<Utility_Types_Order_By>;
  utility_type_id?: InputMaybe<Order_By>;
};

/** select columns of table "portfolio_home_utilities" */
export enum Portfolio_Home_Utilities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DefaultResponsibleParty = 'default_responsible_party',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtilityTypeId = 'utility_type_id'
}

/** Streaming cursor of the table "portfolio_home_utilities" */
export type Portfolio_Home_Utilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Home_Utilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Home_Utilities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_responsible_party?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utility_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "portfolio_homes" */
export type Portfolio_Homes = {
  __typename: 'portfolio_homes';
  /** An object relationship */
  community?: Maybe<Communities>;
  community_id?: Maybe<Scalars['uuid']['output']>;
  conservice_property_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  construction_projects: Array<Construction_Projects>;
  /** An array relationship */
  construction_walkthroughs: Array<Construction_Walkthroughs>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  down_status_incidents: Array<Down_Status_Incidents>;
  exit_date?: Maybe<Scalars['date']['output']>;
  exit_price?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  home: Homes;
  home_id: Scalars['uuid']['output'];
  /** An array relationship */
  home_ownership_statuses: Array<Home_Ownership_Statuses>;
  id: Scalars['uuid']['output'];
  latchel_property_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  listed_rents: Array<Listed_Rents>;
  /** An array relationship */
  llc_properties: Array<Llc_Properties>;
  /** An array relationship */
  llc_property_transfers: Array<Llc_Property_Transfers>;
  /** An array relationship */
  lockbox_codes: Array<Lockbox_Codes>;
  /** An object relationship */
  most_recent_llc_property?: Maybe<Most_Recent_Llc_Property>;
  /** An array relationship */
  portfolio_home_dispositions: Array<Dispositions_Portfolio_Home_Dispositions>;
  /** An object relationship */
  portfolio_home_external_features?: Maybe<Portfolio_Home_External_Features>;
  /** An object relationship */
  portfolio_home_internal_features?: Maybe<Portfolio_Home_Internal_Features>;
  /** An array relationship */
  portfolio_home_utilities: Array<Portfolio_Home_Utilities>;
  /** An object relationship */
  real_estate_acquisition?: Maybe<Real_Estate_Acquisitions>;
  real_estate_acquisition_id?: Maybe<Scalars['uuid']['output']>;
  rental_program_type: Rental_Program_Types_Enum_Enum;
  /** An array relationship */
  rentals: Array<Rentals>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  work_orders: Array<Work_Orders>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesConstruction_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Projects_Order_By>>;
  where?: InputMaybe<Construction_Projects_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesConstruction_WalkthroughsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Walkthroughs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Walkthroughs_Order_By>>;
  where?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesDown_Status_IncidentsArgs = {
  distinct_on?: InputMaybe<Array<Down_Status_Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Down_Status_Incidents_Order_By>>;
  where?: InputMaybe<Down_Status_Incidents_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesHome_Ownership_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Ownership_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Ownership_Statuses_Order_By>>;
  where?: InputMaybe<Home_Ownership_Statuses_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesListed_RentsArgs = {
  distinct_on?: InputMaybe<Array<Listed_Rents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Listed_Rents_Order_By>>;
  where?: InputMaybe<Listed_Rents_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesLlc_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Properties_Order_By>>;
  where?: InputMaybe<Llc_Properties_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesLlc_Property_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Llc_Property_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Property_Transfers_Order_By>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesLockbox_CodesArgs = {
  distinct_on?: InputMaybe<Array<Lockbox_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lockbox_Codes_Order_By>>;
  where?: InputMaybe<Lockbox_Codes_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesPortfolio_Home_DispositionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesPortfolio_Home_UtilitiesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_Utilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_Utilities_Order_By>>;
  where?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesRentalsArgs = {
  distinct_on?: InputMaybe<Array<Rentals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rentals_Order_By>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


/** columns and relationships of "portfolio_homes" */
export type Portfolio_HomesWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** order by aggregate values of table "portfolio_homes" */
export type Portfolio_Homes_Aggregate_Order_By = {
  avg?: InputMaybe<Portfolio_Homes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Portfolio_Homes_Max_Order_By>;
  min?: InputMaybe<Portfolio_Homes_Min_Order_By>;
  stddev?: InputMaybe<Portfolio_Homes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Portfolio_Homes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Portfolio_Homes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Portfolio_Homes_Sum_Order_By>;
  var_pop?: InputMaybe<Portfolio_Homes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Portfolio_Homes_Var_Samp_Order_By>;
  variance?: InputMaybe<Portfolio_Homes_Variance_Order_By>;
};

/** order by avg() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Avg_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "portfolio_homes". All fields are combined with a logical 'AND'. */
export type Portfolio_Homes_Bool_Exp = {
  _and?: InputMaybe<Array<Portfolio_Homes_Bool_Exp>>;
  _not?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  _or?: InputMaybe<Array<Portfolio_Homes_Bool_Exp>>;
  community?: InputMaybe<Communities_Bool_Exp>;
  community_id?: InputMaybe<Uuid_Comparison_Exp>;
  conservice_property_id?: InputMaybe<String_Comparison_Exp>;
  construction_projects?: InputMaybe<Construction_Projects_Bool_Exp>;
  construction_walkthroughs?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  down_status_incidents?: InputMaybe<Down_Status_Incidents_Bool_Exp>;
  exit_date?: InputMaybe<Date_Comparison_Exp>;
  exit_price?: InputMaybe<Numeric_Comparison_Exp>;
  home?: InputMaybe<Homes_Bool_Exp>;
  home_id?: InputMaybe<Uuid_Comparison_Exp>;
  home_ownership_statuses?: InputMaybe<Home_Ownership_Statuses_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latchel_property_id?: InputMaybe<Int_Comparison_Exp>;
  listed_rents?: InputMaybe<Listed_Rents_Bool_Exp>;
  llc_properties?: InputMaybe<Llc_Properties_Bool_Exp>;
  llc_property_transfers?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
  lockbox_codes?: InputMaybe<Lockbox_Codes_Bool_Exp>;
  most_recent_llc_property?: InputMaybe<Most_Recent_Llc_Property_Bool_Exp>;
  portfolio_home_dispositions?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
  portfolio_home_external_features?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
  portfolio_home_internal_features?: InputMaybe<Portfolio_Home_Internal_Features_Bool_Exp>;
  portfolio_home_utilities?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
  real_estate_acquisition?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
  real_estate_acquisition_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum_Comparison_Exp>;
  rentals?: InputMaybe<Rentals_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_orders?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "portfolio_homes" */
export type Portfolio_Homes_Inc_Input = {
  latchel_property_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Max_Order_By = {
  community_id?: InputMaybe<Order_By>;
  conservice_property_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exit_date?: InputMaybe<Order_By>;
  exit_price?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Min_Order_By = {
  community_id?: InputMaybe<Order_By>;
  conservice_property_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exit_date?: InputMaybe<Order_By>;
  exit_price?: InputMaybe<Order_By>;
  home_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "portfolio_homes" */
export type Portfolio_Homes_Mutation_Response = {
  __typename: 'portfolio_homes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Portfolio_Homes>;
};

/** Ordering options when selecting data from "portfolio_homes". */
export type Portfolio_Homes_Order_By = {
  community?: InputMaybe<Communities_Order_By>;
  community_id?: InputMaybe<Order_By>;
  conservice_property_id?: InputMaybe<Order_By>;
  construction_projects_aggregate?: InputMaybe<Construction_Projects_Aggregate_Order_By>;
  construction_walkthroughs_aggregate?: InputMaybe<Construction_Walkthroughs_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  down_status_incidents_aggregate?: InputMaybe<Down_Status_Incidents_Aggregate_Order_By>;
  exit_date?: InputMaybe<Order_By>;
  exit_price?: InputMaybe<Order_By>;
  home?: InputMaybe<Homes_Order_By>;
  home_id?: InputMaybe<Order_By>;
  home_ownership_statuses_aggregate?: InputMaybe<Home_Ownership_Statuses_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
  listed_rents_aggregate?: InputMaybe<Listed_Rents_Aggregate_Order_By>;
  llc_properties_aggregate?: InputMaybe<Llc_Properties_Aggregate_Order_By>;
  llc_property_transfers_aggregate?: InputMaybe<Llc_Property_Transfers_Aggregate_Order_By>;
  lockbox_codes_aggregate?: InputMaybe<Lockbox_Codes_Aggregate_Order_By>;
  most_recent_llc_property?: InputMaybe<Most_Recent_Llc_Property_Order_By>;
  portfolio_home_dispositions_aggregate?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Aggregate_Order_By>;
  portfolio_home_external_features?: InputMaybe<Portfolio_Home_External_Features_Order_By>;
  portfolio_home_internal_features?: InputMaybe<Portfolio_Home_Internal_Features_Order_By>;
  portfolio_home_utilities_aggregate?: InputMaybe<Portfolio_Home_Utilities_Aggregate_Order_By>;
  real_estate_acquisition?: InputMaybe<Real_Estate_Acquisitions_Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  rental_program_type?: InputMaybe<Order_By>;
  rentals_aggregate?: InputMaybe<Rentals_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_orders_aggregate?: InputMaybe<Work_Orders_Aggregate_Order_By>;
};

/** primary key columns input for table: portfolio_homes */
export type Portfolio_Homes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "portfolio_homes" */
export enum Portfolio_Homes_Select_Column {
  /** column name */
  CommunityId = 'community_id',
  /** column name */
  ConservicePropertyId = 'conservice_property_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExitDate = 'exit_date',
  /** column name */
  ExitPrice = 'exit_price',
  /** column name */
  HomeId = 'home_id',
  /** column name */
  Id = 'id',
  /** column name */
  LatchelPropertyId = 'latchel_property_id',
  /** column name */
  RealEstateAcquisitionId = 'real_estate_acquisition_id',
  /** column name */
  RentalProgramType = 'rental_program_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "portfolio_homes" */
export type Portfolio_Homes_Set_Input = {
  conservice_property_id?: InputMaybe<Scalars['String']['input']>;
  latchel_property_id?: InputMaybe<Scalars['Int']['input']>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum>;
};

/** order by stddev() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Stddev_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Stddev_Pop_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Stddev_Samp_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "portfolio_homes" */
export type Portfolio_Homes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Homes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Homes_Stream_Cursor_Value_Input = {
  community_id?: InputMaybe<Scalars['uuid']['input']>;
  conservice_property_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exit_date?: InputMaybe<Scalars['date']['input']>;
  exit_price?: InputMaybe<Scalars['numeric']['input']>;
  home_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latchel_property_id?: InputMaybe<Scalars['Int']['input']>;
  real_estate_acquisition_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Sum_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

export type Portfolio_Homes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Portfolio_Homes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Portfolio_Homes_Set_Input>;
  where: Portfolio_Homes_Bool_Exp;
};

/** order by var_pop() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Var_Pop_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Var_Samp_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "portfolio_homes" */
export type Portfolio_Homes_Variance_Order_By = {
  exit_price?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "properties" */
export type Properties = {
  __typename: 'properties';
  /** An array relationship */
  construction_walkthroughs: Array<Construction_Walkthroughs>;
  exit_date?: Maybe<Scalars['date']['output']>;
  exit_price?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  llc_properties: Array<Llc_Properties>;
  /** An array relationship */
  llc_property_transfers: Array<Llc_Property_Transfers>;
  /** An object relationship */
  most_recent_llc_property?: Maybe<Most_Recent_Llc_Property>;
  /** An object relationship */
  real_estate_acquisition?: Maybe<Real_Estate_Acquisitions>;
  real_estate_acquisition_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  rentals: Array<Rentals>;
  /** An array relationship */
  work_orders: Array<Work_Orders>;
};


/** columns and relationships of "properties" */
export type PropertiesConstruction_WalkthroughsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Walkthroughs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Walkthroughs_Order_By>>;
  where?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLlc_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Properties_Order_By>>;
  where?: InputMaybe<Llc_Properties_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLlc_Property_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Llc_Property_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Property_Transfers_Order_By>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesRentalsArgs = {
  distinct_on?: InputMaybe<Array<Rentals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rentals_Order_By>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "properties". All fields are combined with a logical 'AND'. */
export type Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Properties_Bool_Exp>>;
  _not?: InputMaybe<Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Properties_Bool_Exp>>;
  construction_walkthroughs?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
  exit_date?: InputMaybe<Date_Comparison_Exp>;
  exit_price?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llc_properties?: InputMaybe<Llc_Properties_Bool_Exp>;
  llc_property_transfers?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
  most_recent_llc_property?: InputMaybe<Most_Recent_Llc_Property_Bool_Exp>;
  real_estate_acquisition?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
  real_estate_acquisition_id?: InputMaybe<Uuid_Comparison_Exp>;
  rentals?: InputMaybe<Rentals_Bool_Exp>;
  work_orders?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "properties". */
export type Properties_Order_By = {
  construction_walkthroughs_aggregate?: InputMaybe<Construction_Walkthroughs_Aggregate_Order_By>;
  exit_date?: InputMaybe<Order_By>;
  exit_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llc_properties_aggregate?: InputMaybe<Llc_Properties_Aggregate_Order_By>;
  llc_property_transfers_aggregate?: InputMaybe<Llc_Property_Transfers_Aggregate_Order_By>;
  most_recent_llc_property?: InputMaybe<Most_Recent_Llc_Property_Order_By>;
  real_estate_acquisition?: InputMaybe<Real_Estate_Acquisitions_Order_By>;
  real_estate_acquisition_id?: InputMaybe<Order_By>;
  rentals_aggregate?: InputMaybe<Rentals_Aggregate_Order_By>;
  work_orders_aggregate?: InputMaybe<Work_Orders_Aggregate_Order_By>;
};

/** select columns of table "properties" */
export enum Properties_Select_Column {
  /** column name */
  ExitDate = 'exit_date',
  /** column name */
  ExitPrice = 'exit_price',
  /** column name */
  Id = 'id',
  /** column name */
  RealEstateAcquisitionId = 'real_estate_acquisition_id'
}

/** Streaming cursor of the table "properties" */
export type Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Properties_Stream_Cursor_Value_Input = {
  exit_date?: InputMaybe<Scalars['date']['input']>;
  exit_price?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  real_estate_acquisition_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Query_Root = {
  __typename: 'query_root';
  /** An array relationship */
  addresses: Array<Addresses>;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** An array relationship */
  admin_capabilities: Array<Admin_Capabilities>;
  /** fetch data from the table: "admin_capabilities" using primary key columns */
  admin_capabilities_by_pk?: Maybe<Admin_Capabilities>;
  /** fetch data from the table: "admin_searchable" */
  admin_searchable: Array<Admin_Searchable>;
  /** fetch aggregated fields from the table: "admin_searchable" */
  admin_searchable_aggregate: Admin_Searchable_Aggregate;
  /** fetch data from the table: "admins" */
  admins: Array<Admins>;
  /** fetch data from the table: "admins" using primary key columns */
  admins_by_pk?: Maybe<Admins>;
  /** An array relationship */
  agent_lead_group_owners: Array<Agent_Lead_Group_Owners>;
  /** fetch data from the table: "agent_lead_group_owners_agent_type_enum" */
  agent_lead_group_owners_agent_type_enum: Array<Agent_Lead_Group_Owners_Agent_Type_Enum>;
  /** fetch data from the table: "agent_lead_group_owners_agent_type_enum" using primary key columns */
  agent_lead_group_owners_agent_type_enum_by_pk?: Maybe<Agent_Lead_Group_Owners_Agent_Type_Enum>;
  /** fetch data from the table: "agent_lead_group_owners" using primary key columns */
  agent_lead_group_owners_by_pk?: Maybe<Agent_Lead_Group_Owners>;
  /** fetch data from the table: "agent_portfolio_home_owners" */
  agent_portfolio_home_owners: Array<Agent_Portfolio_Home_Owners>;
  /** fetch data from the table: "agent_portfolio_home_owners" using primary key columns */
  agent_portfolio_home_owners_by_pk?: Maybe<Agent_Portfolio_Home_Owners>;
  /** fetch data from the table: "agent_user_owners" */
  agent_user_owners: Array<Agent_User_Owners>;
  /** fetch data from the table: "agent_user_owners" using primary key columns */
  agent_user_owners_by_pk?: Maybe<Agent_User_Owners>;
  /** fetch data from the table: "agents" */
  agents: Array<Agents>;
  /** fetch data from the table: "agents" using primary key columns */
  agents_by_pk?: Maybe<Agents>;
  /** An array relationship */
  agreement_signers: Array<Agreement_Signers>;
  /** fetch data from the table: "agreement_signers" using primary key columns */
  agreement_signers_by_pk?: Maybe<Agreement_Signers>;
  /** fetch data from the table: "agreement_template_types_enum" */
  agreement_template_types_enum: Array<Agreement_Template_Types_Enum>;
  /** fetch data from the table: "agreement_template_types_enum" using primary key columns */
  agreement_template_types_enum_by_pk?: Maybe<Agreement_Template_Types_Enum>;
  /** fetch data from the table: "agreement_templates" */
  agreement_templates: Array<Agreement_Templates>;
  /** fetch data from the table: "agreement_templates" using primary key columns */
  agreement_templates_by_pk?: Maybe<Agreement_Templates>;
  /** An array relationship */
  agreements: Array<Agreements>;
  /** fetch data from the table: "agreements" using primary key columns */
  agreements_by_pk?: Maybe<Agreements>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_employment_verification_statuses_enum" */
  applicant_income_underwrites_user_income_employment_verification_statuses_enum: Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_employment_verification_statuses_enum" using primary key columns */
  applicant_income_underwrites_user_income_employment_verification_statuses_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_documents" */
  applicant_income_underwrites_user_income_source_documents: Array<Applicant_Income_Underwrites_User_Income_Source_Documents>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_documents" using primary key columns */
  applicant_income_underwrites_user_income_source_documents_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Documents>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_pay_frequencies_enum" */
  applicant_income_underwrites_user_income_source_pay_frequencies_enum: Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_pay_frequencies_enum" using primary key columns */
  applicant_income_underwrites_user_income_source_pay_frequencies_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_statuses_enum" */
  applicant_income_underwrites_user_income_source_statuses_enum: Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_statuses_enum" using primary key columns */
  applicant_income_underwrites_user_income_source_statuses_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_types_enum" */
  applicant_income_underwrites_user_income_source_types_enum: Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_types_enum" using primary key columns */
  applicant_income_underwrites_user_income_source_types_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources" */
  applicant_income_underwrites_user_income_sources: Array<Applicant_Income_Underwrites_User_Income_Sources>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_benefits" */
  applicant_income_underwrites_user_income_sources_benefits: Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_benefits" using primary key columns */
  applicant_income_underwrites_user_income_sources_benefits_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources" using primary key columns */
  applicant_income_underwrites_user_income_sources_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_employed" */
  applicant_income_underwrites_user_income_sources_employed: Array<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_employed" using primary key columns */
  applicant_income_underwrites_user_income_sources_employed_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_self_employed" */
  applicant_income_underwrites_user_income_sources_self_employed: Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_self_employed" using primary key columns */
  applicant_income_underwrites_user_income_sources_self_employed_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_incomes" */
  applicant_income_underwrites_user_incomes: Array<Applicant_Income_Underwrites_User_Incomes>;
  /** fetch data from the table: "applicant_income_underwrites.user_incomes" using primary key columns */
  applicant_income_underwrites_user_incomes_by_pk?: Maybe<Applicant_Income_Underwrites_User_Incomes>;
  /** fetch data from the table: "background_check_requests" */
  background_check_requests: Array<Background_Check_Requests>;
  /** fetch data from the table: "background_check_requests" using primary key columns */
  background_check_requests_by_pk?: Maybe<Background_Check_Requests>;
  /** An array relationship */
  bids: Array<Bids>;
  /** fetch data from the table: "bids" using primary key columns */
  bids_by_pk?: Maybe<Bids>;
  /** fetch data from the table: "buildium_bulk_journal_entry_uploads" */
  buildium_bulk_journal_entry_uploads: Array<Buildium_Bulk_Journal_Entry_Uploads>;
  /** fetch data from the table: "buildium_bulk_journal_entry_uploads" using primary key columns */
  buildium_bulk_journal_entry_uploads_by_pk?: Maybe<Buildium_Bulk_Journal_Entry_Uploads>;
  /** fetch data from the table: "buildium_resident_center_users" */
  buildium_resident_center_users: Array<Buildium_Resident_Center_Users>;
  /** fetch data from the table: "buildium_resident_center_users" using primary key columns */
  buildium_resident_center_users_by_pk?: Maybe<Buildium_Resident_Center_Users>;
  /** fetch data from the table: "buildium_transactions" */
  buildium_transactions: Array<Buildium_Transactions>;
  /** fetch data from the table: "buildium_transactions" using primary key columns */
  buildium_transactions_by_pk?: Maybe<Buildium_Transactions>;
  /** fetch data from the table: "capabilities" */
  capabilities: Array<Capabilities>;
  /** fetch data from the table: "capabilities" using primary key columns */
  capabilities_by_pk?: Maybe<Capabilities>;
  /** An array relationship */
  cashout_adjustments: Array<Cashout_Adjustments>;
  /** fetch data from the table: "cashout_adjustments" using primary key columns */
  cashout_adjustments_by_pk?: Maybe<Cashout_Adjustments>;
  /** fetch data from the table: "cashout_configs" */
  cashout_configs: Array<Cashout_Configs>;
  /** fetch data from the table: "cashout_configs" using primary key columns */
  cashout_configs_by_pk?: Maybe<Cashout_Configs>;
  /** fetch data from the table: "cashouts" */
  cashouts: Array<Cashouts>;
  /** fetch data from the table: "cashouts" using primary key columns */
  cashouts_by_pk?: Maybe<Cashouts>;
  /** An array relationship */
  cashouts_pending_liabilities: Array<Cashouts_Pending_Liabilities>;
  /** fetch data from the table: "cashouts_pending_liabilities" using primary key columns */
  cashouts_pending_liabilities_by_pk?: Maybe<Cashouts_Pending_Liabilities>;
  /** An array relationship */
  check_deposit_payments: Array<Check_Deposit_Payments>;
  /** fetch data from the table: "check_deposit_payments" using primary key columns */
  check_deposit_payments_by_pk?: Maybe<Check_Deposit_Payments>;
  /** fetch data from the table: "check_deposits" */
  check_deposits: Array<Check_Deposits>;
  /** fetch data from the table: "check_deposits" using primary key columns */
  check_deposits_by_pk?: Maybe<Check_Deposits>;
  /** An array relationship */
  collection_payment_promises: Array<Collection_Payment_Promises>;
  /** fetch data from the table: "collection_payment_promises" using primary key columns */
  collection_payment_promises_by_pk?: Maybe<Collection_Payment_Promises>;
  /** An array relationship */
  collections: Array<Collections>;
  /** fetch data from the table: "collections" using primary key columns */
  collections_by_pk?: Maybe<Collections>;
  /** fetch data from the table: "collections_late_payment_reason_enum" */
  collections_late_payment_reason_enum: Array<Collections_Late_Payment_Reason_Enum>;
  /** fetch data from the table: "collections_late_payment_reason_enum" using primary key columns */
  collections_late_payment_reason_enum_by_pk?: Maybe<Collections_Late_Payment_Reason_Enum>;
  /** fetch data from the table: "collections_liabilities_remaining" */
  collections_liabilities_remaining: Array<Collections_Liabilities_Remaining>;
  /** An array relationship */
  collections_rental_liabilities: Array<Collections_Rental_Liabilities>;
  /** fetch data from the table: "collections_rental_liabilities" using primary key columns */
  collections_rental_liabilities_by_pk?: Maybe<Collections_Rental_Liabilities>;
  /** fetch data from the table: "communities" */
  communities: Array<Communities>;
  /** fetch data from the table: "communities" using primary key columns */
  communities_by_pk?: Maybe<Communities>;
  /** fetch data from the table: "community_features" */
  community_features: Array<Community_Features>;
  /** fetch data from the table: "community_features" using primary key columns */
  community_features_by_pk?: Maybe<Community_Features>;
  /** fetch data from the table: "construction.construction_common_estimated_costs" */
  construction_construction_common_estimated_costs: Array<Construction_Construction_Common_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_common_estimated_costs" using primary key columns */
  construction_construction_common_estimated_costs_by_pk?: Maybe<Construction_Construction_Common_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_project_estimated_cost_histories" */
  construction_construction_project_estimated_cost_histories: Array<Construction_Construction_Project_Estimated_Cost_Histories>;
  /** fetch data from the table: "construction.construction_project_estimated_cost_histories" using primary key columns */
  construction_construction_project_estimated_cost_histories_by_pk?: Maybe<Construction_Construction_Project_Estimated_Cost_Histories>;
  /** fetch data from the table: "construction.construction_project_estimated_costs" */
  construction_construction_project_estimated_costs: Array<Construction_Construction_Project_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_project_estimated_costs" using primary key columns */
  construction_construction_project_estimated_costs_by_pk?: Maybe<Construction_Construction_Project_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_scopes" */
  construction_construction_scopes: Array<Construction_Construction_Scopes>;
  /** fetch data from the table: "construction.construction_scopes" using primary key columns */
  construction_construction_scopes_by_pk?: Maybe<Construction_Construction_Scopes>;
  /** An array relationship */
  construction_estimates: Array<Construction_Estimates>;
  /** fetch data from the table: "construction_estimates" using primary key columns */
  construction_estimates_by_pk?: Maybe<Construction_Estimates>;
  /** fetch data from the table: "construction.general_contractors" */
  construction_general_contractors: Array<Construction_General_Contractors>;
  /** fetch data from the table: "construction.general_contractors" using primary key columns */
  construction_general_contractors_by_pk?: Maybe<Construction_General_Contractors>;
  /** fetch data from the table: "construction.occupancy_inspections" */
  construction_occupancy_inspections: Array<Construction_Occupancy_Inspections>;
  /** fetch data from the table: "construction.occupancy_inspections" using primary key columns */
  construction_occupancy_inspections_by_pk?: Maybe<Construction_Occupancy_Inspections>;
  /** An array relationship */
  construction_projects: Array<Construction_Projects>;
  /** fetch data from the table: "construction_projects" using primary key columns */
  construction_projects_by_pk?: Maybe<Construction_Projects>;
  /** An array relationship */
  construction_scopes: Array<Construction_Scopes>;
  /** fetch data from the table: "construction_scopes" using primary key columns */
  construction_scopes_by_pk?: Maybe<Construction_Scopes>;
  /** An array relationship */
  construction_scopes_vendors: Array<Construction_Scopes_Vendors>;
  /** fetch data from the table: "construction_scopes_vendors" using primary key columns */
  construction_scopes_vendors_by_pk?: Maybe<Construction_Scopes_Vendors>;
  /** An array relationship */
  construction_walkthroughs: Array<Construction_Walkthroughs>;
  /** fetch data from the table: "construction_walkthroughs" using primary key columns */
  construction_walkthroughs_by_pk?: Maybe<Construction_Walkthroughs>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** fetch data from the table: "conversations" using primary key columns */
  conversations_by_pk?: Maybe<Conversations>;
  /** An array relationship */
  credit_reports: Array<Credit_Reports>;
  /** fetch data from the table: "credit_reports" using primary key columns */
  credit_reports_by_pk?: Maybe<Credit_Reports>;
  /** An array relationship */
  criminal_reports: Array<Criminal_Reports>;
  /** fetch data from the table: "criminal_reports" using primary key columns */
  criminal_reports_by_pk?: Maybe<Criminal_Reports>;
  /** fetch data from the table: "current_balances" */
  current_balances: Array<Current_Balances>;
  /** fetch data from the table: "current_statements" */
  current_statements: Array<Current_Statements>;
  /** An array relationship */
  current_utility_responsibilities: Array<Current_Utility_Responsibilities>;
  /** fetch data from the table: "dashboards" */
  dashboards: Array<Dashboards>;
  /** fetch data from the table: "dashboards" using primary key columns */
  dashboards_by_pk?: Maybe<Dashboards>;
  /** fetch data from the table: "dispositions.buyers_inspections" */
  dispositions_buyers_inspections: Array<Dispositions_Buyers_Inspections>;
  /** fetch data from the table: "dispositions.buyers_inspections" using primary key columns */
  dispositions_buyers_inspections_by_pk?: Maybe<Dispositions_Buyers_Inspections>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_bids" */
  dispositions_portfolio_home_disposition_bids: Array<Dispositions_Portfolio_Home_Disposition_Bids>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_bids" using primary key columns */
  dispositions_portfolio_home_disposition_bids_by_pk?: Maybe<Dispositions_Portfolio_Home_Disposition_Bids>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_counterparties" */
  dispositions_portfolio_home_disposition_counterparties: Array<Dispositions_Portfolio_Home_Disposition_Counterparties>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_counterparties" using primary key columns */
  dispositions_portfolio_home_disposition_counterparties_by_pk?: Maybe<Dispositions_Portfolio_Home_Disposition_Counterparties>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_statuses" */
  dispositions_portfolio_home_disposition_statuses: Array<Dispositions_Portfolio_Home_Disposition_Statuses>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_statuses" using primary key columns */
  dispositions_portfolio_home_disposition_statuses_by_pk?: Maybe<Dispositions_Portfolio_Home_Disposition_Statuses>;
  /** fetch data from the table: "dispositions.portfolio_home_dispositions" */
  dispositions_portfolio_home_dispositions: Array<Dispositions_Portfolio_Home_Dispositions>;
  /** fetch data from the table: "dispositions.portfolio_home_dispositions" using primary key columns */
  dispositions_portfolio_home_dispositions_by_pk?: Maybe<Dispositions_Portfolio_Home_Dispositions>;
  /** An array relationship */
  documents: Array<Documents>;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** An array relationship */
  down_status_incidents: Array<Down_Status_Incidents>;
  /** fetch data from the table: "down_status_incidents" using primary key columns */
  down_status_incidents_by_pk?: Maybe<Down_Status_Incidents>;
  /** An array relationship */
  eviction_filing_fees: Array<Eviction_Filing_Fees>;
  /** fetch data from the table: "eviction_filing_fees" using primary key columns */
  eviction_filing_fees_by_pk?: Maybe<Eviction_Filing_Fees>;
  /** An array relationship */
  eviction_reports: Array<Eviction_Reports>;
  /** fetch data from the table: "eviction_reports" using primary key columns */
  eviction_reports_by_pk?: Maybe<Eviction_Reports>;
  /** An array relationship */
  evictions: Array<Evictions>;
  /** fetch data from the table: "evictions" using primary key columns */
  evictions_by_pk?: Maybe<Evictions>;
  /** An array relationship */
  fund_llcs: Array<Fund_Llcs>;
  /** fetch data from the table: "fund_llcs" using primary key columns */
  fund_llcs_by_pk?: Maybe<Fund_Llcs>;
  /** fetch data from the table: "fund_rental_program_configs" */
  fund_rental_program_configs: Array<Fund_Rental_Program_Configs>;
  /** fetch data from the table: "fund_rental_program_configs" using primary key columns */
  fund_rental_program_configs_by_pk?: Maybe<Fund_Rental_Program_Configs>;
  /** fetch data from the table: "funds" */
  funds: Array<Funds>;
  /** fetch data from the table: "funds" using primary key columns */
  funds_by_pk?: Maybe<Funds>;
  getUserQualificationData?: Maybe<UserQualificationData>;
  /** fetch data from the table: "home_construction_status_enum" */
  home_construction_status_enum: Array<Home_Construction_Status_Enum>;
  /** fetch data from the table: "home_construction_status_enum" using primary key columns */
  home_construction_status_enum_by_pk?: Maybe<Home_Construction_Status_Enum>;
  /** fetch data from the table: "home_construction_statuses" */
  home_construction_statuses: Array<Home_Construction_Statuses>;
  /** fetch data from the table: "home_construction_statuses" using primary key columns */
  home_construction_statuses_by_pk?: Maybe<Home_Construction_Statuses>;
  /** fetch data from the table: "home_occupancy_status_enum" */
  home_occupancy_status_enum: Array<Home_Occupancy_Status_Enum>;
  /** fetch data from the table: "home_occupancy_status_enum" using primary key columns */
  home_occupancy_status_enum_by_pk?: Maybe<Home_Occupancy_Status_Enum>;
  /** fetch data from the table: "home_occupancy_statuses" */
  home_occupancy_statuses: Array<Home_Occupancy_Statuses>;
  /** fetch data from the table: "home_occupancy_statuses" using primary key columns */
  home_occupancy_statuses_by_pk?: Maybe<Home_Occupancy_Statuses>;
  /** fetch data from the table: "home_ownership_status_enum" */
  home_ownership_status_enum: Array<Home_Ownership_Status_Enum>;
  /** fetch data from the table: "home_ownership_status_enum" using primary key columns */
  home_ownership_status_enum_by_pk?: Maybe<Home_Ownership_Status_Enum>;
  /** An array relationship */
  home_ownership_statuses: Array<Home_Ownership_Statuses>;
  /** fetch data from the table: "home_ownership_statuses" using primary key columns */
  home_ownership_statuses_by_pk?: Maybe<Home_Ownership_Statuses>;
  /** fetch data from the table: "home_summary_status_enum" */
  home_summary_status_enum: Array<Home_Summary_Status_Enum>;
  /** fetch data from the table: "home_summary_status_enum" using primary key columns */
  home_summary_status_enum_by_pk?: Maybe<Home_Summary_Status_Enum>;
  /** fetch data from the table: "home_summary_statuses" */
  home_summary_statuses: Array<Home_Summary_Statuses>;
  /** fetch data from the table: "home_summary_statuses" using primary key columns */
  home_summary_statuses_by_pk?: Maybe<Home_Summary_Statuses>;
  /** An array relationship */
  homes: Array<Homes>;
  /** fetch data from the table: "homes360" */
  homes360: Array<Homes360>;
  /** fetch data from the table: "homes" using primary key columns */
  homes_by_pk?: Maybe<Homes>;
  /** fetch data from the table: "kafka_connector.prorated_utility_bill_line_items" */
  kafka_connector_prorated_utility_bill_line_items: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** fetch data from the table: "kafka_connector.prorated_utility_bill_line_items" using primary key columns */
  kafka_connector_prorated_utility_bill_line_items_by_pk?: Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** fetch data from the table: "latchel_categories" */
  latchel_categories: Array<Latchel_Categories>;
  /** fetch data from the table: "latchel_categories" using primary key columns */
  latchel_categories_by_pk?: Maybe<Latchel_Categories>;
  /** fetch data from the table: "latchel_dead_letters" */
  latchel_dead_letters: Array<Latchel_Dead_Letters>;
  /** fetch data from the table: "latchel_dead_letters" using primary key columns */
  latchel_dead_letters_by_pk?: Maybe<Latchel_Dead_Letters>;
  /** An array relationship */
  latchel_vendor_categories: Array<Latchel_Vendor_Categories>;
  /** fetch data from the table: "latchel_vendor_categories" using primary key columns */
  latchel_vendor_categories_by_pk?: Maybe<Latchel_Vendor_Categories>;
  /** An array relationship */
  latchel_vendor_users: Array<Latchel_Vendor_Users>;
  /** fetch data from the table: "latchel_vendor_users" using primary key columns */
  latchel_vendor_users_by_pk?: Maybe<Latchel_Vendor_Users>;
  /** fetch data from the table: "lead_group_rental_application_notes" */
  lead_group_rental_application_notes: Array<Lead_Group_Rental_Application_Notes>;
  /** An array relationship */
  lead_group_users: Array<Lead_Group_Users>;
  /** fetch data from the table: "lead_group_users" using primary key columns */
  lead_group_users_by_pk?: Maybe<Lead_Group_Users>;
  /** fetch data from the table: "lead_groups" */
  lead_groups: Array<Lead_Groups>;
  /** fetch data from the table: "lead_groups" using primary key columns */
  lead_groups_by_pk?: Maybe<Lead_Groups>;
  /** An array relationship */
  ledger_account_categories: Array<Ledger_Account_Categories>;
  /** fetch data from the table: "ledger_account_categories" using primary key columns */
  ledger_account_categories_by_pk?: Maybe<Ledger_Account_Categories>;
  /** fetch data from the table: "ledger_accounts" */
  ledger_accounts: Array<Ledger_Accounts>;
  /** fetch data from the table: "ledger_accounts" using primary key columns */
  ledger_accounts_by_pk?: Maybe<Ledger_Accounts>;
  /** An array relationship */
  liabilities_payments: Array<Liabilities_Payments>;
  /** fetch data from the table: "liabilities_payments" using primary key columns */
  liabilities_payments_by_pk?: Maybe<Liabilities_Payments>;
  /** fetch data from the table: "liability_types" */
  liability_types: Array<Liability_Types>;
  /** fetch data from the table: "liability_types" using primary key columns */
  liability_types_by_pk?: Maybe<Liability_Types>;
  /** An array relationship */
  listed_rents: Array<Listed_Rents>;
  /** fetch data from the table: "listed_rents" using primary key columns */
  listed_rents_by_pk?: Maybe<Listed_Rents>;
  /** fetch data from the table: "listing_searchable" */
  listing_searchable: Array<Listing_Searchable>;
  /** fetch data from the table: "llc_market_agreement_templates" */
  llc_market_agreement_templates: Array<Llc_Market_Agreement_Templates>;
  /** fetch data from the table: "llc_market_agreement_templates" using primary key columns */
  llc_market_agreement_templates_by_pk?: Maybe<Llc_Market_Agreement_Templates>;
  /** An array relationship */
  llc_properties: Array<Llc_Properties>;
  /** fetch data from the table: "llc_properties" using primary key columns */
  llc_properties_by_pk?: Maybe<Llc_Properties>;
  /** An array relationship */
  llc_property_transfers: Array<Llc_Property_Transfers>;
  /** fetch data from the table: "llc_property_transfers" using primary key columns */
  llc_property_transfers_by_pk?: Maybe<Llc_Property_Transfers>;
  /** fetch data from the table: "llcs" */
  llcs: Array<Llcs>;
  /** fetch data from the table: "llcs" using primary key columns */
  llcs_by_pk?: Maybe<Llcs>;
  /** An array relationship */
  lockbox_codes: Array<Lockbox_Codes>;
  /** fetch data from the table: "lockbox_codes" using primary key columns */
  lockbox_codes_by_pk?: Maybe<Lockbox_Codes>;
  /** fetch data from the table: "markets" */
  markets: Array<Markets>;
  /** fetch data from the table: "markets" using primary key columns */
  markets_by_pk?: Maybe<Markets>;
  /** fetch data from the table: "mls_listing_internal_attributes" */
  mls_listing_internal_attributes: Array<Mls_Listing_Internal_Attributes>;
  /** fetch data from the table: "mls_listing_internal_attributes" using primary key columns */
  mls_listing_internal_attributes_by_pk?: Maybe<Mls_Listing_Internal_Attributes>;
  /** An array relationship */
  mls_listing_overrides: Array<Mls_Listing_Overrides>;
  /** fetch data from the table: "mls_listing_overrides" using primary key columns */
  mls_listing_overrides_by_pk?: Maybe<Mls_Listing_Overrides>;
  /** fetch data from the table: "mls_listing_photos" */
  mls_listing_photos: Array<Mls_Listing_Photos>;
  /** fetch data from the table: "mls_listing_photos" using primary key columns */
  mls_listing_photos_by_pk?: Maybe<Mls_Listing_Photos>;
  /** An array relationship */
  mls_listing_promotions: Array<Mls_Listing_Promotions>;
  /** fetch data from the table: "mls_listing_promotions" using primary key columns */
  mls_listing_promotions_by_pk?: Maybe<Mls_Listing_Promotions>;
  /** An array relationship */
  mls_listings: Array<Mls_Listings>;
  /** fetch data from the table: "mls_listings" using primary key columns */
  mls_listings_by_pk?: Maybe<Mls_Listings>;
  /** fetch data from the table: "most_recent_llc_property" */
  most_recent_llc_property: Array<Most_Recent_Llc_Property>;
  /** fetch data from the table: "most_relevant_user_identity_verification_by_user" */
  most_relevant_user_identity_verification_by_user: Array<Most_Relevant_User_Identity_Verification_By_User>;
  /** An array relationship */
  move_ins: Array<Move_Ins>;
  /** fetch data from the table: "move_ins" using primary key columns */
  move_ins_by_pk?: Maybe<Move_Ins>;
  /** fetch data from the table: "municipalities" */
  municipalities: Array<Municipalities>;
  /** fetch data from the table: "municipalities" using primary key columns */
  municipalities_by_pk?: Maybe<Municipalities>;
  /** An array relationship */
  municipality_contacts: Array<Municipality_Contacts>;
  /** fetch data from the table: "municipality_contacts" using primary key columns */
  municipality_contacts_by_pk?: Maybe<Municipality_Contacts>;
  /** fetch data from the table: "note_priorities" */
  note_priorities: Array<Note_Priorities>;
  /** fetch data from the table: "note_priorities" using primary key columns */
  note_priorities_by_pk?: Maybe<Note_Priorities>;
  /** An array relationship */
  notes: Array<Notes>;
  /** fetch data from the table: "notes" using primary key columns */
  notes_by_pk?: Maybe<Notes>;
  /** An array relationship */
  opportunities: Array<Opportunities>;
  /** fetch data from the table: "opportunities" using primary key columns */
  opportunities_by_pk?: Maybe<Opportunities>;
  /** fetch data from the table: "option_premium_transfers" */
  option_premium_transfers: Array<Option_Premium_Transfers>;
  /** fetch data from the table: "option_premium_transfers" using primary key columns */
  option_premium_transfers_by_pk?: Maybe<Option_Premium_Transfers>;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table: "payment_plan_liabilities" */
  payment_plan_liabilities: Array<Payment_Plan_Liabilities>;
  /** fetch data from the table: "payment_plan_liabilities" using primary key columns */
  payment_plan_liabilities_by_pk?: Maybe<Payment_Plan_Liabilities>;
  /** An array relationship */
  payment_plan_offset_credits: Array<Payment_Plan_Offset_Credits>;
  /** fetch data from the table: "payment_plan_offset_credits" using primary key columns */
  payment_plan_offset_credits_by_pk?: Maybe<Payment_Plan_Offset_Credits>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table: "plaid_income_verification_documents" */
  plaid_income_verification_documents: Array<Plaid_Income_Verification_Documents>;
  /** fetch data from the table: "plaid_income_verifications" */
  plaid_income_verifications: Array<Plaid_Income_Verifications>;
  /** fetch data from the table: "plaid_income_verifications" using primary key columns */
  plaid_income_verifications_by_pk?: Maybe<Plaid_Income_Verifications>;
  /** An array relationship */
  portfolio_home_external_features: Array<Portfolio_Home_External_Features>;
  /** fetch data from the table: "portfolio_home_external_features" using primary key columns */
  portfolio_home_external_features_by_pk?: Maybe<Portfolio_Home_External_Features>;
  /** fetch data from the table: "portfolio_home_internal_features" */
  portfolio_home_internal_features: Array<Portfolio_Home_Internal_Features>;
  /** fetch data from the table: "portfolio_home_internal_features" using primary key columns */
  portfolio_home_internal_features_by_pk?: Maybe<Portfolio_Home_Internal_Features>;
  /** fetch data from the table: "portfolio_home_system_work_order_system_enum" */
  portfolio_home_system_work_order_system_enum: Array<Portfolio_Home_System_Work_Order_System_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_order_system_enum" using primary key columns */
  portfolio_home_system_work_order_system_enum_by_pk?: Maybe<Portfolio_Home_System_Work_Order_System_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_order_type_enum" */
  portfolio_home_system_work_order_type_enum: Array<Portfolio_Home_System_Work_Order_Type_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_order_type_enum" using primary key columns */
  portfolio_home_system_work_order_type_enum_by_pk?: Maybe<Portfolio_Home_System_Work_Order_Type_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_orders" */
  portfolio_home_system_work_orders: Array<Portfolio_Home_System_Work_Orders>;
  /** fetch data from the table: "portfolio_home_system_work_orders" using primary key columns */
  portfolio_home_system_work_orders_by_pk?: Maybe<Portfolio_Home_System_Work_Orders>;
  /** An array relationship */
  portfolio_home_utilities: Array<Portfolio_Home_Utilities>;
  /** fetch data from the table: "portfolio_home_utilities" using primary key columns */
  portfolio_home_utilities_by_pk?: Maybe<Portfolio_Home_Utilities>;
  /** An array relationship */
  portfolio_homes: Array<Portfolio_Homes>;
  /** fetch data from the table: "portfolio_homes" using primary key columns */
  portfolio_homes_by_pk?: Maybe<Portfolio_Homes>;
  /** fetch data from the table: "properties" */
  properties: Array<Properties>;
  /** fetch data from the table: "properties" using primary key columns */
  properties_by_pk?: Maybe<Properties>;
  /** An array relationship */
  real_estate_acquisitions: Array<Real_Estate_Acquisitions>;
  /** fetch data from the table: "real_estate_acquisitions" using primary key columns */
  real_estate_acquisitions_by_pk?: Maybe<Real_Estate_Acquisitions>;
  /** An array relationship */
  real_estate_screenings: Array<Real_Estate_Screenings>;
  /** fetch data from the table: "real_estate_screenings" using primary key columns */
  real_estate_screenings_by_pk?: Maybe<Real_Estate_Screenings>;
  /** An array relationship */
  recurring_credits: Array<Recurring_Credits>;
  /** fetch data from the table: "recurring_credits" using primary key columns */
  recurring_credits_by_pk?: Maybe<Recurring_Credits>;
  /** An array relationship */
  renewal_offers: Array<Renewal_Offers>;
  /** fetch data from the table: "renewal_offers" using primary key columns */
  renewal_offers_by_pk?: Maybe<Renewal_Offers>;
  /** An array relationship */
  renewals: Array<Renewals>;
  /** fetch data from the table: "renewals" using primary key columns */
  renewals_by_pk?: Maybe<Renewals>;
  /** An array relationship */
  rent_prices: Array<Rent_Prices>;
  /** fetch data from the table: "rent_prices" using primary key columns */
  rent_prices_by_pk?: Maybe<Rent_Prices>;
  /** An array relationship */
  rent_ready_dates: Array<Rent_Ready_Dates>;
  /** fetch data from the table: "rent_ready_dates" using primary key columns */
  rent_ready_dates_by_pk?: Maybe<Rent_Ready_Dates>;
  /** fetch data from the table: "rent_roll" */
  rent_roll: Array<Rent_Roll>;
  /** An array relationship */
  rental_add_ons: Array<Rental_Add_Ons>;
  /** fetch data from the table: "rental_add_ons" using primary key columns */
  rental_add_ons_by_pk?: Maybe<Rental_Add_Ons>;
  /** An array relationship */
  rental_agreement_histories: Array<Rental_Agreement_Histories>;
  /** fetch data from the table: "rental_agreement_histories" using primary key columns */
  rental_agreement_histories_by_pk?: Maybe<Rental_Agreement_Histories>;
  /** An array relationship */
  rental_application_decisions: Array<Rental_Application_Decisions>;
  /** fetch data from the table: "rental_application_decisions" using primary key columns */
  rental_application_decisions_by_pk?: Maybe<Rental_Application_Decisions>;
  /** An array relationship */
  rental_application_fees: Array<Rental_Application_Fees>;
  /** fetch data from the table: "rental_application_fees" using primary key columns */
  rental_application_fees_by_pk?: Maybe<Rental_Application_Fees>;
  /** fetch data from the table: "rental_application_fees_config" */
  rental_application_fees_config: Array<Rental_Application_Fees_Config>;
  /** fetch data from the table: "rental_application_fees_config" using primary key columns */
  rental_application_fees_config_by_pk?: Maybe<Rental_Application_Fees_Config>;
  /** fetch data from the table: "rental_application_manager.admin_assignments" */
  rental_application_manager_admin_assignments: Array<Rental_Application_Manager_Admin_Assignments>;
  /** fetch data from the table: "rental_application_manager.admin_assignments" using primary key columns */
  rental_application_manager_admin_assignments_by_pk?: Maybe<Rental_Application_Manager_Admin_Assignments>;
  /** fetch data from the table: "rental_application_manager.admin_roles" */
  rental_application_manager_admin_roles: Array<Rental_Application_Manager_Admin_Roles>;
  /** fetch data from the table: "rental_application_manager.admin_roles" using primary key columns */
  rental_application_manager_admin_roles_by_pk?: Maybe<Rental_Application_Manager_Admin_Roles>;
  /** fetch data from the table: "rental_application_manager.application_escalations" */
  rental_application_manager_application_escalations: Array<Rental_Application_Manager_Application_Escalations>;
  /** fetch data from the table: "rental_application_manager.application_escalations" using primary key columns */
  rental_application_manager_application_escalations_by_pk?: Maybe<Rental_Application_Manager_Application_Escalations>;
  /** fetch data from the table: "rental_application_manager.application_snoozes" */
  rental_application_manager_application_snoozes: Array<Rental_Application_Manager_Application_Snoozes>;
  /** fetch aggregated fields from the table: "rental_application_manager.application_snoozes" */
  rental_application_manager_application_snoozes_aggregate: Rental_Application_Manager_Application_Snoozes_Aggregate;
  /** fetch data from the table: "rental_application_manager.application_snoozes" using primary key columns */
  rental_application_manager_application_snoozes_by_pk?: Maybe<Rental_Application_Manager_Application_Snoozes>;
  /** fetch data from the table: "rental_application_manager.escalation_statuses" */
  rental_application_manager_escalation_statuses: Array<Rental_Application_Manager_Escalation_Statuses>;
  /** fetch data from the table: "rental_application_manager.escalation_statuses" using primary key columns */
  rental_application_manager_escalation_statuses_by_pk?: Maybe<Rental_Application_Manager_Escalation_Statuses>;
  /** fetch data from the table: "rental_application_manager.snooze_reasons" */
  rental_application_manager_snooze_reasons: Array<Rental_Application_Manager_Snooze_Reasons>;
  /** fetch data from the table: "rental_application_manager.snooze_reasons" using primary key columns */
  rental_application_manager_snooze_reasons_by_pk?: Maybe<Rental_Application_Manager_Snooze_Reasons>;
  /** An array relationship */
  rental_application_occupants: Array<Rental_Application_Occupants>;
  /** fetch data from the table: "rental_application_occupants" using primary key columns */
  rental_application_occupants_by_pk?: Maybe<Rental_Application_Occupants>;
  /** fetch data from the table: "rental_application_pets" */
  rental_application_pets: Array<Rental_Application_Pets>;
  /** fetch data from the table: "rental_application_pets" using primary key columns */
  rental_application_pets_by_pk?: Maybe<Rental_Application_Pets>;
  /** fetch data from the table: "rental_application_vehicles" */
  rental_application_vehicles: Array<Rental_Application_Vehicles>;
  /** fetch data from the table: "rental_application_vehicles" using primary key columns */
  rental_application_vehicles_by_pk?: Maybe<Rental_Application_Vehicles>;
  /** An array relationship */
  rental_applications: Array<Rental_Applications>;
  /** An aggregate relationship */
  rental_applications_aggregate: Rental_Applications_Aggregate;
  /** fetch data from the table: "rental_applications" using primary key columns */
  rental_applications_by_pk?: Maybe<Rental_Applications>;
  /** An array relationship */
  rental_credits: Array<Rental_Credits>;
  /** fetch data from the table: "rental_credits" using primary key columns */
  rental_credits_by_pk?: Maybe<Rental_Credits>;
  /** fetch data from the table: "rental_internet_fee_elections" */
  rental_internet_fee_elections: Array<Rental_Internet_Fee_Elections>;
  /** fetch data from the table: "rental_internet_fee_elections" using primary key columns */
  rental_internet_fee_elections_by_pk?: Maybe<Rental_Internet_Fee_Elections>;
  /** An array relationship */
  rental_liabilities: Array<Rental_Liabilities>;
  /** fetch data from the table: "rental_liabilities" using primary key columns */
  rental_liabilities_by_pk?: Maybe<Rental_Liabilities>;
  /** An array relationship */
  rental_move_in_fees: Array<Rental_Move_In_Fees>;
  /** fetch data from the table: "rental_move_in_fees" using primary key columns */
  rental_move_in_fees_by_pk?: Maybe<Rental_Move_In_Fees>;
  /** An array relationship */
  rental_occupants: Array<Rental_Occupants>;
  /** An array relationship */
  rental_reunderwrite_tenant_underwrites: Array<Rental_Reunderwrite_Tenant_Underwrites>;
  /** fetch data from the table: "rental_reunderwrite_tenant_underwrites" using primary key columns */
  rental_reunderwrite_tenant_underwrites_by_pk?: Maybe<Rental_Reunderwrite_Tenant_Underwrites>;
  /** fetch data from the table: "rental_reunderwrites" */
  rental_reunderwrites: Array<Rental_Reunderwrites>;
  /** fetch data from the table: "rental_reunderwrites" using primary key columns */
  rental_reunderwrites_by_pk?: Maybe<Rental_Reunderwrites>;
  /** fetch data from the table: "rental_site_accounts" */
  rental_site_accounts: Array<Rental_Site_Accounts>;
  /** fetch data from the table: "rental_site_accounts" using primary key columns */
  rental_site_accounts_by_pk?: Maybe<Rental_Site_Accounts>;
  /** An array relationship */
  rental_site_leads: Array<Rental_Site_Leads>;
  /** fetch data from the table: "rental_site_leads" using primary key columns */
  rental_site_leads_by_pk?: Maybe<Rental_Site_Leads>;
  /** fetch data from the table: "rental_site_listings" */
  rental_site_listings: Array<Rental_Site_Listings>;
  /** fetch data from the table: "rental_site_listings" using primary key columns */
  rental_site_listings_by_pk?: Maybe<Rental_Site_Listings>;
  /** fetch data from the table: "rental_site_opportunity_checks" */
  rental_site_opportunity_checks: Array<Rental_Site_Opportunity_Checks>;
  /** fetch data from the table: "rental_site_opportunity_checks" using primary key columns */
  rental_site_opportunity_checks_by_pk?: Maybe<Rental_Site_Opportunity_Checks>;
  /** An array relationship */
  rental_users: Array<Rental_Users>;
  /** fetch data from the table: "rental_users" using primary key columns */
  rental_users_by_pk?: Maybe<Rental_Users>;
  /** fetch data from the table: "rental_utility_chargeback_overrides" */
  rental_utility_chargeback_overrides: Array<Rental_Utility_Chargeback_Overrides>;
  /** fetch aggregated fields from the table: "rental_utility_chargeback_overrides" */
  rental_utility_chargeback_overrides_aggregate: Rental_Utility_Chargeback_Overrides_Aggregate;
  /** fetch data from the table: "rental_utility_chargeback_overrides" using primary key columns */
  rental_utility_chargeback_overrides_by_pk?: Maybe<Rental_Utility_Chargeback_Overrides>;
  /** An array relationship */
  rentals: Array<Rentals>;
  /** fetch data from the table: "rentals" using primary key columns */
  rentals_by_pk?: Maybe<Rentals>;
  /** fetch data from the table: "saferent_requests" */
  saferent_requests: Array<Saferent_Requests>;
  /** fetch data from the table: "saferent_requests" using primary key columns */
  saferent_requests_by_pk?: Maybe<Saferent_Requests>;
  /** An array relationship */
  scheduled_rental_liabilities: Array<Scheduled_Rental_Liabilities>;
  /** fetch data from the table: "scheduled_rental_liabilities" using primary key columns */
  scheduled_rental_liabilities_by_pk?: Maybe<Scheduled_Rental_Liabilities>;
  /** fetch data from the table: "security_enum" */
  security_enum: Array<Security_Enum>;
  /** fetch data from the table: "security_enum" using primary key columns */
  security_enum_by_pk?: Maybe<Security_Enum>;
  /** fetch data from the table: "seller_agent_searchable" */
  seller_agent_searchable: Array<Seller_Agent_Searchable>;
  /** fetch data from the table: "seller_agents" */
  seller_agents: Array<Seller_Agents>;
  /** fetch data from the table: "seller_agents" using primary key columns */
  seller_agents_by_pk?: Maybe<Seller_Agents>;
  /** An array relationship */
  statements: Array<Statements>;
  /** An array relationship */
  statements_raw: Array<Statements_Raw>;
  /** fetch data from the table: "statements_raw" using primary key columns */
  statements_raw_by_pk?: Maybe<Statements_Raw>;
  /** An array relationship */
  tenant_underwrite_documents: Array<Tenant_Underwrite_Documents>;
  /** fetch data from the table: "tenant_underwrite_documents" using primary key columns */
  tenant_underwrite_documents_by_pk?: Maybe<Tenant_Underwrite_Documents>;
  /** fetch data from the table: "tenant_underwrites" */
  tenant_underwrites: Array<Tenant_Underwrites>;
  /** fetch data from the table: "tenant_underwrites" using primary key columns */
  tenant_underwrites_by_pk?: Maybe<Tenant_Underwrites>;
  /** An array relationship */
  ticket_vendor_assignments: Array<Ticket_Vendor_Assignments>;
  /** fetch data from the table: "ticket_vendor_assignments" using primary key columns */
  ticket_vendor_assignments_by_pk?: Maybe<Ticket_Vendor_Assignments>;
  /** fetch data from the table: "tickets" */
  tickets: Array<Tickets>;
  /** fetch data from the table: "tickets" using primary key columns */
  tickets_by_pk?: Maybe<Tickets>;
  /** fetch data from the table: "tickets_latchel_data" */
  tickets_latchel_data: Array<Tickets_Latchel_Data>;
  /** fetch data from the table: "tickets_latchel_data" using primary key columns */
  tickets_latchel_data_by_pk?: Maybe<Tickets_Latchel_Data>;
  /** fetch data from the table: "tickets_mason_data" */
  tickets_mason_data: Array<Tickets_Mason_Data>;
  /** fetch data from the table: "tickets_mason_data" using primary key columns */
  tickets_mason_data_by_pk?: Maybe<Tickets_Mason_Data>;
  /** An array relationship */
  tour_properties: Array<Tour_Properties>;
  /** fetch data from the table: "tour_properties" using primary key columns */
  tour_properties_by_pk?: Maybe<Tour_Properties>;
  /** An array relationship */
  tours: Array<Tours>;
  /** fetch data from the table: "tours" using primary key columns */
  tours_by_pk?: Maybe<Tours>;
  /** fetch data from the table: "unallocated_credits" */
  unallocated_credits: Array<Unallocated_Credits>;
  /** fetch data from the table: "unallocated_payments" */
  unallocated_payments: Array<Unallocated_Payments>;
  /** fetch data from the table: "underwrites.opportunity_underwrites" */
  underwrites_opportunity_underwrites: Array<Underwrites_Opportunity_Underwrites>;
  /** fetch data from the table: "underwrites.opportunity_underwrites" using primary key columns */
  underwrites_opportunity_underwrites_by_pk?: Maybe<Underwrites_Opportunity_Underwrites>;
  /** fetch data from the table: "unpaid_liabilities" */
  unpaid_liabilities: Array<Unpaid_Liabilities>;
  /** An array relationship */
  user_contact_details: Array<User_Contact_Details>;
  /** fetch data from the table: "user_contact_details" using primary key columns */
  user_contact_details_by_pk?: Maybe<User_Contact_Details>;
  /** An array relationship */
  user_document_requests: Array<User_Document_Requests>;
  /** fetch data from the table: "user_document_requests" using primary key columns */
  user_document_requests_by_pk?: Maybe<User_Document_Requests>;
  /** fetch data from the table: "user_documents" */
  user_documents: Array<User_Documents>;
  /** fetch data from the table: "user_funnel_statuses" */
  user_funnel_statuses: Array<User_Funnel_Statuses>;
  /** fetch data from the table: "user_funnel_statuses" using primary key columns */
  user_funnel_statuses_by_pk?: Maybe<User_Funnel_Statuses>;
  /** fetch data from the table: "user_identity_verifications" */
  user_identity_verifications: Array<User_Identity_Verifications>;
  /** fetch data from the table: "user_identity_verifications" using primary key columns */
  user_identity_verifications_by_pk?: Maybe<User_Identity_Verifications>;
  /** An array relationship */
  user_incomes: Array<User_Incomes>;
  /** fetch data from the table: "user_incomes" using primary key columns */
  user_incomes_by_pk?: Maybe<User_Incomes>;
  /** fetch data from the table: "user_prequalification_data" */
  user_prequalification_data: Array<User_Prequalification_Data>;
  /** fetch data from the table: "user_prequalification_data" using primary key columns */
  user_prequalification_data_by_pk?: Maybe<User_Prequalification_Data>;
  /** fetch data from the table: "user_searchable" */
  user_searchable: Array<User_Searchable>;
  /** An array relationship */
  user_underwriting_data: Array<User_Underwriting_Data>;
  /** fetch data from the table: "user_underwriting_data" using primary key columns */
  user_underwriting_data_by_pk?: Maybe<User_Underwriting_Data>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "utility_bills" */
  utility_bills: Array<Utility_Bills>;
  /** fetch data from the table: "utility_bills" using primary key columns */
  utility_bills_by_pk?: Maybe<Utility_Bills>;
  /** fetch data from the table: "utility_chargeback_status_enum" */
  utility_chargeback_status_enum: Array<Utility_Chargeback_Status_Enum>;
  /** fetch aggregated fields from the table: "utility_chargeback_status_enum" */
  utility_chargeback_status_enum_aggregate: Utility_Chargeback_Status_Enum_Aggregate;
  /** fetch data from the table: "utility_chargeback_status_enum" using primary key columns */
  utility_chargeback_status_enum_by_pk?: Maybe<Utility_Chargeback_Status_Enum>;
  /** An array relationship */
  utility_chargebacks: Array<Utility_Chargebacks>;
  /** An aggregate relationship */
  utility_chargebacks_aggregate: Utility_Chargebacks_Aggregate;
  /** fetch data from the table: "utility_chargebacks" using primary key columns */
  utility_chargebacks_by_pk?: Maybe<Utility_Chargebacks>;
  /** An array relationship */
  utility_responsibilities: Array<Utility_Responsibilities>;
  /** fetch data from the table: "utility_responsibilities" using primary key columns */
  utility_responsibilities_by_pk?: Maybe<Utility_Responsibilities>;
  /** An array relationship */
  utility_types: Array<Utility_Types>;
  /** fetch data from the table: "utility_types" using primary key columns */
  utility_types_by_pk?: Maybe<Utility_Types>;
  /** An array relationship */
  vendor_markets: Array<Vendor_Markets>;
  /** fetch data from the table: "vendor_markets" using primary key columns */
  vendor_markets_by_pk?: Maybe<Vendor_Markets>;
  /** fetch data from the table: "vendor_tags" */
  vendor_tags: Array<Vendor_Tags>;
  /** fetch data from the table: "vendor_tags" using primary key columns */
  vendor_tags_by_pk?: Maybe<Vendor_Tags>;
  /** fetch data from the table: "vendor_types" */
  vendor_types: Array<Vendor_Types>;
  /** fetch data from the table: "vendor_types" using primary key columns */
  vendor_types_by_pk?: Maybe<Vendor_Types>;
  /** fetch data from the table: "vendors" */
  vendors: Array<Vendors>;
  /** fetch data from the table: "vendors" using primary key columns */
  vendors_by_pk?: Maybe<Vendors>;
  /** An array relationship */
  vendors_vendor_tags: Array<Vendors_Vendor_Tags>;
  /** fetch data from the table: "vendors_vendor_tags" using primary key columns */
  vendors_vendor_tags_by_pk?: Maybe<Vendors_Vendor_Tags>;
  /** An array relationship */
  vendors_vendor_types: Array<Vendors_Vendor_Types>;
  /** fetch data from the table: "vendors_vendor_types" using primary key columns */
  vendors_vendor_types_by_pk?: Maybe<Vendors_Vendor_Types>;
  /** An array relationship */
  work_orders: Array<Work_Orders>;
  /** fetch data from the table: "work_orders" using primary key columns */
  work_orders_by_pk?: Maybe<Work_Orders>;
};


export type Query_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Capabilities_Order_By>>;
  where?: InputMaybe<Admin_Capabilities_Bool_Exp>;
};


export type Query_RootAdmin_Capabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_SearchableArgs = {
  distinct_on?: InputMaybe<Array<Admin_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Searchable_Order_By>>;
  where?: InputMaybe<Admin_Searchable_Bool_Exp>;
};


export type Query_RootAdmin_Searchable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Searchable_Order_By>>;
  where?: InputMaybe<Admin_Searchable_Bool_Exp>;
};


export type Query_RootAdminsArgs = {
  distinct_on?: InputMaybe<Array<Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admins_Order_By>>;
  where?: InputMaybe<Admins_Bool_Exp>;
};


export type Query_RootAdmins_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgent_Lead_Group_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_Lead_Group_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Lead_Group_Owners_Order_By>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
};


export type Query_RootAgent_Lead_Group_Owners_Agent_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Order_By>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp>;
};


export type Query_RootAgent_Lead_Group_Owners_Agent_Type_Enum_By_PkArgs = {
  agent_type: Scalars['String']['input'];
};


export type Query_RootAgent_Lead_Group_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgent_Portfolio_Home_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_Portfolio_Home_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Portfolio_Home_Owners_Order_By>>;
  where?: InputMaybe<Agent_Portfolio_Home_Owners_Bool_Exp>;
};


export type Query_RootAgent_Portfolio_Home_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgent_User_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_User_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_User_Owners_Order_By>>;
  where?: InputMaybe<Agent_User_Owners_Bool_Exp>;
};


export type Query_RootAgent_User_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Order_By>>;
  where?: InputMaybe<Agents_Bool_Exp>;
};


export type Query_RootAgents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgreement_SignersArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Signers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Signers_Order_By>>;
  where?: InputMaybe<Agreement_Signers_Bool_Exp>;
};


export type Query_RootAgreement_Signers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgreement_Template_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Template_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Template_Types_Enum_Order_By>>;
  where?: InputMaybe<Agreement_Template_Types_Enum_Bool_Exp>;
};


export type Query_RootAgreement_Template_Types_Enum_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootAgreement_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Templates_Order_By>>;
  where?: InputMaybe<Agreement_Templates_Bool_Exp>;
};


export type Query_RootAgreement_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Query_RootAgreements_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_By_PkArgs = {
  employment_verification_status: Scalars['String']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_By_PkArgs = {
  frequency: Scalars['String']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Statuses_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Statuses_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Source_Types_Enum_By_PkArgs = {
  income_source_type: Scalars['String']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_BenefitsArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_Benefits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_EmployedArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_Employed_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_Self_EmployedArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Income_Sources_Self_Employed_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicant_Income_Underwrites_User_IncomesArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Incomes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Incomes_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Bool_Exp>;
};


export type Query_RootApplicant_Income_Underwrites_User_Incomes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBackground_Check_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Background_Check_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Background_Check_Requests_Order_By>>;
  where?: InputMaybe<Background_Check_Requests_Bool_Exp>;
};


export type Query_RootBackground_Check_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Query_RootBids_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildium_Bulk_Journal_Entry_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Buildium_Bulk_Journal_Entry_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buildium_Bulk_Journal_Entry_Uploads_Order_By>>;
  where?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp>;
};


export type Query_RootBuildium_Bulk_Journal_Entry_Uploads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildium_Resident_Center_UsersArgs = {
  distinct_on?: InputMaybe<Array<Buildium_Resident_Center_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buildium_Resident_Center_Users_Order_By>>;
  where?: InputMaybe<Buildium_Resident_Center_Users_Bool_Exp>;
};


export type Query_RootBuildium_Resident_Center_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildium_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Buildium_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buildium_Transactions_Order_By>>;
  where?: InputMaybe<Buildium_Transactions_Bool_Exp>;
};


export type Query_RootBuildium_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capabilities_Order_By>>;
  where?: InputMaybe<Capabilities_Bool_Exp>;
};


export type Query_RootCapabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCashout_AdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<Cashout_Adjustments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashout_Adjustments_Order_By>>;
  where?: InputMaybe<Cashout_Adjustments_Bool_Exp>;
};


export type Query_RootCashout_Adjustments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCashout_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Cashout_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashout_Configs_Order_By>>;
  where?: InputMaybe<Cashout_Configs_Bool_Exp>;
};


export type Query_RootCashout_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCashoutsArgs = {
  distinct_on?: InputMaybe<Array<Cashouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashouts_Order_By>>;
  where?: InputMaybe<Cashouts_Bool_Exp>;
};


export type Query_RootCashouts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCashouts_Pending_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Cashouts_Pending_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashouts_Pending_Liabilities_Order_By>>;
  where?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
};


export type Query_RootCashouts_Pending_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCheck_Deposit_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Check_Deposit_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Check_Deposit_Payments_Order_By>>;
  where?: InputMaybe<Check_Deposit_Payments_Bool_Exp>;
};


export type Query_RootCheck_Deposit_Payments_By_PkArgs = {
  check_deposit_id: Scalars['uuid']['input'];
  payment_id: Scalars['uuid']['input'];
};


export type Query_RootCheck_DepositsArgs = {
  distinct_on?: InputMaybe<Array<Check_Deposits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Check_Deposits_Order_By>>;
  where?: InputMaybe<Check_Deposits_Bool_Exp>;
};


export type Query_RootCheck_Deposits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCollection_Payment_PromisesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Payment_Promises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collection_Payment_Promises_Order_By>>;
  where?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
};


export type Query_RootCollection_Payment_Promises_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Query_RootCollections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCollections_Late_Payment_Reason_EnumArgs = {
  distinct_on?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Order_By>>;
  where?: InputMaybe<Collections_Late_Payment_Reason_Enum_Bool_Exp>;
};


export type Query_RootCollections_Late_Payment_Reason_Enum_By_PkArgs = {
  reason: Scalars['String']['input'];
};


export type Query_RootCollections_Liabilities_RemainingArgs = {
  distinct_on?: InputMaybe<Array<Collections_Liabilities_Remaining_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Liabilities_Remaining_Order_By>>;
  where?: InputMaybe<Collections_Liabilities_Remaining_Bool_Exp>;
};


export type Query_RootCollections_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Collections_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
};


export type Query_RootCollections_Rental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCommunitiesArgs = {
  distinct_on?: InputMaybe<Array<Communities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Communities_Order_By>>;
  where?: InputMaybe<Communities_Bool_Exp>;
};


export type Query_RootCommunities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCommunity_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Community_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Community_Features_Order_By>>;
  where?: InputMaybe<Community_Features_Bool_Exp>;
};


export type Query_RootCommunity_Features_By_PkArgs = {
  community_id: Scalars['uuid']['input'];
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_Construction_Common_Estimated_CostsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Common_Estimated_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Common_Estimated_Costs_Order_By>>;
  where?: InputMaybe<Construction_Construction_Common_Estimated_Costs_Bool_Exp>;
};


export type Query_RootConstruction_Construction_Common_Estimated_Costs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_Construction_Project_Estimated_Cost_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Project_Estimated_Cost_Histories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Project_Estimated_Cost_Histories_Order_By>>;
  where?: InputMaybe<Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp>;
};


export type Query_RootConstruction_Construction_Project_Estimated_Cost_Histories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_Construction_Project_Estimated_CostsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Project_Estimated_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Project_Estimated_Costs_Order_By>>;
  where?: InputMaybe<Construction_Construction_Project_Estimated_Costs_Bool_Exp>;
};


export type Query_RootConstruction_Construction_Project_Estimated_Costs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_Construction_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Scopes_Order_By>>;
  where?: InputMaybe<Construction_Construction_Scopes_Bool_Exp>;
};


export type Query_RootConstruction_Construction_Scopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_EstimatesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Estimates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Estimates_Order_By>>;
  where?: InputMaybe<Construction_Estimates_Bool_Exp>;
};


export type Query_RootConstruction_Estimates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_General_ContractorsArgs = {
  distinct_on?: InputMaybe<Array<Construction_General_Contractors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_General_Contractors_Order_By>>;
  where?: InputMaybe<Construction_General_Contractors_Bool_Exp>;
};


export type Query_RootConstruction_General_Contractors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_Occupancy_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Occupancy_Inspections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Occupancy_Inspections_Order_By>>;
  where?: InputMaybe<Construction_Occupancy_Inspections_Bool_Exp>;
};


export type Query_RootConstruction_Occupancy_Inspections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Projects_Order_By>>;
  where?: InputMaybe<Construction_Projects_Bool_Exp>;
};


export type Query_RootConstruction_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Scopes_Order_By>>;
  where?: InputMaybe<Construction_Scopes_Bool_Exp>;
};


export type Query_RootConstruction_Scopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_Scopes_VendorsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Scopes_Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Scopes_Vendors_Order_By>>;
  where?: InputMaybe<Construction_Scopes_Vendors_Bool_Exp>;
};


export type Query_RootConstruction_Scopes_Vendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_WalkthroughsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Walkthroughs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Walkthroughs_Order_By>>;
  where?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
};


export type Query_RootConstruction_Walkthroughs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConversationsArgs = {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
};


export type Query_RootConversations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCredit_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Reports_Order_By>>;
  where?: InputMaybe<Credit_Reports_Bool_Exp>;
};


export type Query_RootCredit_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCriminal_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Criminal_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criminal_Reports_Order_By>>;
  where?: InputMaybe<Criminal_Reports_Bool_Exp>;
};


export type Query_RootCriminal_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCurrent_BalancesArgs = {
  distinct_on?: InputMaybe<Array<Current_Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Balances_Order_By>>;
  where?: InputMaybe<Current_Balances_Bool_Exp>;
};


export type Query_RootCurrent_StatementsArgs = {
  distinct_on?: InputMaybe<Array<Current_Statements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Statements_Order_By>>;
  where?: InputMaybe<Current_Statements_Bool_Exp>;
};


export type Query_RootCurrent_Utility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Current_Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Current_Utility_Responsibilities_Bool_Exp>;
};


export type Query_RootDashboardsArgs = {
  distinct_on?: InputMaybe<Array<Dashboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dashboards_Order_By>>;
  where?: InputMaybe<Dashboards_Bool_Exp>;
};


export type Query_RootDashboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDispositions_Buyers_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Buyers_Inspections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Buyers_Inspections_Order_By>>;
  where?: InputMaybe<Dispositions_Buyers_Inspections_Bool_Exp>;
};


export type Query_RootDispositions_Buyers_Inspections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDispositions_Portfolio_Home_Disposition_BidsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
};


export type Query_RootDispositions_Portfolio_Home_Disposition_Bids_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDispositions_Portfolio_Home_Disposition_CounterpartiesArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>;
};


export type Query_RootDispositions_Portfolio_Home_Disposition_Counterparties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDispositions_Portfolio_Home_Disposition_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Statuses_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>;
};


export type Query_RootDispositions_Portfolio_Home_Disposition_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootDispositions_Portfolio_Home_DispositionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
};


export type Query_RootDispositions_Portfolio_Home_Dispositions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDown_Status_IncidentsArgs = {
  distinct_on?: InputMaybe<Array<Down_Status_Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Down_Status_Incidents_Order_By>>;
  where?: InputMaybe<Down_Status_Incidents_Bool_Exp>;
};


export type Query_RootDown_Status_Incidents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEviction_Filing_FeesArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Filing_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Filing_Fees_Order_By>>;
  where?: InputMaybe<Eviction_Filing_Fees_Bool_Exp>;
};


export type Query_RootEviction_Filing_Fees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEviction_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Reports_Order_By>>;
  where?: InputMaybe<Eviction_Reports_Bool_Exp>;
};


export type Query_RootEviction_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvictionsArgs = {
  distinct_on?: InputMaybe<Array<Evictions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evictions_Order_By>>;
  where?: InputMaybe<Evictions_Bool_Exp>;
};


export type Query_RootEvictions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFund_LlcsArgs = {
  distinct_on?: InputMaybe<Array<Fund_Llcs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fund_Llcs_Order_By>>;
  where?: InputMaybe<Fund_Llcs_Bool_Exp>;
};


export type Query_RootFund_Llcs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFund_Rental_Program_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Fund_Rental_Program_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fund_Rental_Program_Configs_Order_By>>;
  where?: InputMaybe<Fund_Rental_Program_Configs_Bool_Exp>;
};


export type Query_RootFund_Rental_Program_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFundsArgs = {
  distinct_on?: InputMaybe<Array<Funds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funds_Order_By>>;
  where?: InputMaybe<Funds_Bool_Exp>;
};


export type Query_RootFunds_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetUserQualificationDataArgs = {
  id: Scalars['ID']['input'];
};


export type Query_RootHome_Construction_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Construction_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Construction_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Construction_Status_Enum_Bool_Exp>;
};


export type Query_RootHome_Construction_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootHome_Construction_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Construction_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Construction_Statuses_Order_By>>;
  where?: InputMaybe<Home_Construction_Statuses_Bool_Exp>;
};


export type Query_RootHome_Construction_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHome_Occupancy_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Occupancy_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Occupancy_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Occupancy_Status_Enum_Bool_Exp>;
};


export type Query_RootHome_Occupancy_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootHome_Occupancy_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Occupancy_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Occupancy_Statuses_Order_By>>;
  where?: InputMaybe<Home_Occupancy_Statuses_Bool_Exp>;
};


export type Query_RootHome_Occupancy_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHome_Ownership_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Ownership_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Ownership_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Ownership_Status_Enum_Bool_Exp>;
};


export type Query_RootHome_Ownership_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootHome_Ownership_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Ownership_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Ownership_Statuses_Order_By>>;
  where?: InputMaybe<Home_Ownership_Statuses_Bool_Exp>;
};


export type Query_RootHome_Ownership_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHome_Summary_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Summary_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Summary_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Summary_Status_Enum_Bool_Exp>;
};


export type Query_RootHome_Summary_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootHome_Summary_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Summary_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Summary_Statuses_Order_By>>;
  where?: InputMaybe<Home_Summary_Statuses_Bool_Exp>;
};


export type Query_RootHome_Summary_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHomesArgs = {
  distinct_on?: InputMaybe<Array<Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Homes_Order_By>>;
  where?: InputMaybe<Homes_Bool_Exp>;
};


export type Query_RootHomes360Args = {
  distinct_on?: InputMaybe<Array<Homes360_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Homes360_Order_By>>;
  where?: InputMaybe<Homes360_Bool_Exp>;
};


export type Query_RootHomes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootKafka_Connector_Prorated_Utility_Bill_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Order_By>>;
  where?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>;
};


export type Query_RootKafka_Connector_Prorated_Utility_Bill_Line_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLatchel_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Categories_Order_By>>;
  where?: InputMaybe<Latchel_Categories_Bool_Exp>;
};


export type Query_RootLatchel_Categories_By_PkArgs = {
  category_id: Scalars['Int']['input'];
};


export type Query_RootLatchel_Dead_LettersArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Dead_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Dead_Letters_Order_By>>;
  where?: InputMaybe<Latchel_Dead_Letters_Bool_Exp>;
};


export type Query_RootLatchel_Dead_Letters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLatchel_Vendor_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Vendor_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Vendor_Categories_Order_By>>;
  where?: InputMaybe<Latchel_Vendor_Categories_Bool_Exp>;
};


export type Query_RootLatchel_Vendor_Categories_By_PkArgs = {
  latchel_category_id: Scalars['Int']['input'];
  latchel_vendor_company_id: Scalars['Int']['input'];
};


export type Query_RootLatchel_Vendor_UsersArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Vendor_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Vendor_Users_Order_By>>;
  where?: InputMaybe<Latchel_Vendor_Users_Bool_Exp>;
};


export type Query_RootLatchel_Vendor_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLead_Group_Rental_Application_NotesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Order_By>>;
  where?: InputMaybe<Lead_Group_Rental_Application_Notes_Bool_Exp>;
};


export type Query_RootLead_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Users_Order_By>>;
  where?: InputMaybe<Lead_Group_Users_Bool_Exp>;
};


export type Query_RootLead_Group_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLead_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Groups_Order_By>>;
  where?: InputMaybe<Lead_Groups_Bool_Exp>;
};


export type Query_RootLead_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLedger_Account_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Ledger_Account_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ledger_Account_Categories_Order_By>>;
  where?: InputMaybe<Ledger_Account_Categories_Bool_Exp>;
};


export type Query_RootLedger_Account_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLedger_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Ledger_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ledger_Accounts_Order_By>>;
  where?: InputMaybe<Ledger_Accounts_Bool_Exp>;
};


export type Query_RootLedger_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLiabilities_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Liabilities_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Liabilities_Payments_Order_By>>;
  where?: InputMaybe<Liabilities_Payments_Bool_Exp>;
};


export type Query_RootLiabilities_Payments_By_PkArgs = {
  liability_id: Scalars['uuid']['input'];
  payment_or_credit_id: Scalars['uuid']['input'];
};


export type Query_RootLiability_TypesArgs = {
  distinct_on?: InputMaybe<Array<Liability_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Liability_Types_Order_By>>;
  where?: InputMaybe<Liability_Types_Bool_Exp>;
};


export type Query_RootLiability_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootListed_RentsArgs = {
  distinct_on?: InputMaybe<Array<Listed_Rents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Listed_Rents_Order_By>>;
  where?: InputMaybe<Listed_Rents_Bool_Exp>;
};


export type Query_RootListed_Rents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootListing_SearchableArgs = {
  distinct_on?: InputMaybe<Array<Listing_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Listing_Searchable_Order_By>>;
  where?: InputMaybe<Listing_Searchable_Bool_Exp>;
};


export type Query_RootLlc_Market_Agreement_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Market_Agreement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Market_Agreement_Templates_Order_By>>;
  where?: InputMaybe<Llc_Market_Agreement_Templates_Bool_Exp>;
};


export type Query_RootLlc_Market_Agreement_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLlc_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Properties_Order_By>>;
  where?: InputMaybe<Llc_Properties_Bool_Exp>;
};


export type Query_RootLlc_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLlc_Property_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Llc_Property_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Property_Transfers_Order_By>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


export type Query_RootLlc_Property_Transfers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLlcsArgs = {
  distinct_on?: InputMaybe<Array<Llcs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llcs_Order_By>>;
  where?: InputMaybe<Llcs_Bool_Exp>;
};


export type Query_RootLlcs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLockbox_CodesArgs = {
  distinct_on?: InputMaybe<Array<Lockbox_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lockbox_Codes_Order_By>>;
  where?: InputMaybe<Lockbox_Codes_Bool_Exp>;
};


export type Query_RootLockbox_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMarketsArgs = {
  distinct_on?: InputMaybe<Array<Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Markets_Order_By>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


export type Query_RootMarkets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_Listing_Internal_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Order_By>>;
  where?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
};


export type Query_RootMls_Listing_Internal_Attributes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_Listing_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Overrides_Order_By>>;
  where?: InputMaybe<Mls_Listing_Overrides_Bool_Exp>;
};


export type Query_RootMls_Listing_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_Listing_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Photos_Order_By>>;
  where?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
};


export type Query_RootMls_Listing_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_Listing_PromotionsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Promotions_Order_By>>;
  where?: InputMaybe<Mls_Listing_Promotions_Bool_Exp>;
};


export type Query_RootMls_Listing_Promotions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listings_Order_By>>;
  where?: InputMaybe<Mls_Listings_Bool_Exp>;
};


export type Query_RootMls_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMost_Recent_Llc_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Most_Recent_Llc_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Most_Recent_Llc_Property_Order_By>>;
  where?: InputMaybe<Most_Recent_Llc_Property_Bool_Exp>;
};


export type Query_RootMost_Relevant_User_Identity_Verification_By_UserArgs = {
  distinct_on?: InputMaybe<Array<Most_Relevant_User_Identity_Verification_By_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Most_Relevant_User_Identity_Verification_By_User_Order_By>>;
  where?: InputMaybe<Most_Relevant_User_Identity_Verification_By_User_Bool_Exp>;
};


export type Query_RootMove_InsArgs = {
  distinct_on?: InputMaybe<Array<Move_Ins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Move_Ins_Order_By>>;
  where?: InputMaybe<Move_Ins_Bool_Exp>;
};


export type Query_RootMove_Ins_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMunicipalitiesArgs = {
  distinct_on?: InputMaybe<Array<Municipalities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Municipalities_Order_By>>;
  where?: InputMaybe<Municipalities_Bool_Exp>;
};


export type Query_RootMunicipalities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMunicipality_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Municipality_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Municipality_Contacts_Order_By>>;
  where?: InputMaybe<Municipality_Contacts_Bool_Exp>;
};


export type Query_RootMunicipality_Contacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNote_PrioritiesArgs = {
  distinct_on?: InputMaybe<Array<Note_Priorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Priorities_Order_By>>;
  where?: InputMaybe<Note_Priorities_Bool_Exp>;
};


export type Query_RootNote_Priorities_By_PkArgs = {
  note_priority: Scalars['String']['input'];
};


export type Query_RootNotesArgs = {
  distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notes_Order_By>>;
  where?: InputMaybe<Notes_Bool_Exp>;
};


export type Query_RootNotes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<Opportunities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Opportunities_Order_By>>;
  where?: InputMaybe<Opportunities_Bool_Exp>;
};


export type Query_RootOpportunities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOption_Premium_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Option_Premium_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Option_Premium_Transfers_Order_By>>;
  where?: InputMaybe<Option_Premium_Transfers_Bool_Exp>;
};


export type Query_RootOption_Premium_Transfers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPayment_Plan_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Plan_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Plan_Liabilities_Order_By>>;
  where?: InputMaybe<Payment_Plan_Liabilities_Bool_Exp>;
};


export type Query_RootPayment_Plan_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPayment_Plan_Offset_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Plan_Offset_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Plan_Offset_Credits_Order_By>>;
  where?: InputMaybe<Payment_Plan_Offset_Credits_Bool_Exp>;
};


export type Query_RootPayment_Plan_Offset_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlaid_Income_Verification_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Plaid_Income_Verification_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plaid_Income_Verification_Documents_Order_By>>;
  where?: InputMaybe<Plaid_Income_Verification_Documents_Bool_Exp>;
};


export type Query_RootPlaid_Income_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Plaid_Income_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plaid_Income_Verifications_Order_By>>;
  where?: InputMaybe<Plaid_Income_Verifications_Bool_Exp>;
};


export type Query_RootPlaid_Income_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortfolio_Home_External_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_External_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_External_Features_Order_By>>;
  where?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
};


export type Query_RootPortfolio_Home_External_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
  portfolio_home_id: Scalars['uuid']['input'];
};


export type Query_RootPortfolio_Home_Internal_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_Internal_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_Internal_Features_Order_By>>;
  where?: InputMaybe<Portfolio_Home_Internal_Features_Bool_Exp>;
};


export type Query_RootPortfolio_Home_Internal_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
  portfolio_home_id: Scalars['uuid']['input'];
};


export type Query_RootPortfolio_Home_System_Work_Order_System_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_System_Work_Order_System_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_System_Work_Order_System_Enum_Order_By>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>;
};


export type Query_RootPortfolio_Home_System_Work_Order_System_Enum_By_PkArgs = {
  system: Scalars['String']['input'];
};


export type Query_RootPortfolio_Home_System_Work_Order_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_System_Work_Order_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_System_Work_Order_Type_Enum_Order_By>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>;
};


export type Query_RootPortfolio_Home_System_Work_Order_Type_Enum_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootPortfolio_Home_System_Work_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_System_Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_System_Work_Orders_Order_By>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Orders_Bool_Exp>;
};


export type Query_RootPortfolio_Home_System_Work_Orders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortfolio_Home_UtilitiesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_Utilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_Utilities_Order_By>>;
  where?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
};


export type Query_RootPortfolio_Home_Utilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortfolio_HomesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Homes_Order_By>>;
  where?: InputMaybe<Portfolio_Homes_Bool_Exp>;
};


export type Query_RootPortfolio_Homes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Query_RootProperties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReal_Estate_AcquisitionsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Acquisitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Acquisitions_Order_By>>;
  where?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};


export type Query_RootReal_Estate_Acquisitions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReal_Estate_ScreeningsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Screenings_Order_By>>;
  where?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
};


export type Query_RootReal_Estate_Screenings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRecurring_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Recurring_Credits_Order_By>>;
  where?: InputMaybe<Recurring_Credits_Bool_Exp>;
};


export type Query_RootRecurring_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRenewal_OffersArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Renewal_Offers_Order_By>>;
  where?: InputMaybe<Renewal_Offers_Bool_Exp>;
};


export type Query_RootRenewal_Offers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRenewalsArgs = {
  distinct_on?: InputMaybe<Array<Renewals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Renewals_Order_By>>;
  where?: InputMaybe<Renewals_Bool_Exp>;
};


export type Query_RootRenewals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRent_PricesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Prices_Order_By>>;
  where?: InputMaybe<Rent_Prices_Bool_Exp>;
};


export type Query_RootRent_Prices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRent_Ready_DatesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Ready_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Ready_Dates_Order_By>>;
  where?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
};


export type Query_RootRent_Ready_Dates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRent_RollArgs = {
  distinct_on?: InputMaybe<Array<Rent_Roll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Roll_Order_By>>;
  where?: InputMaybe<Rent_Roll_Bool_Exp>;
};


export type Query_RootRental_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Add_Ons_Order_By>>;
  where?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
};


export type Query_RootRental_Add_Ons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Agreement_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Agreement_Histories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Agreement_Histories_Order_By>>;
  where?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
};


export type Query_RootRental_Agreement_Histories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_DecisionsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Decisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Decisions_Order_By>>;
  where?: InputMaybe<Rental_Application_Decisions_Bool_Exp>;
};


export type Query_RootRental_Application_Decisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_FeesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Fees_Order_By>>;
  where?: InputMaybe<Rental_Application_Fees_Bool_Exp>;
};


export type Query_RootRental_Application_Fees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_Fees_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Fees_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Fees_Config_Order_By>>;
  where?: InputMaybe<Rental_Application_Fees_Config_Bool_Exp>;
};


export type Query_RootRental_Application_Fees_Config_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_Manager_Admin_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Admin_Assignments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_Manager_Admin_RolesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Roles_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Admin_Roles_By_PkArgs = {
  admin_role: Scalars['String']['input'];
};


export type Query_RootRental_Application_Manager_Application_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Application_Escalations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_Manager_Application_SnoozesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Application_Snoozes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Application_Snoozes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_Manager_Escalation_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Escalation_Statuses_By_PkArgs = {
  escalation_status: Scalars['String']['input'];
};


export type Query_RootRental_Application_Manager_Snooze_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>;
};


export type Query_RootRental_Application_Manager_Snooze_Reasons_By_PkArgs = {
  snooze_reason: Scalars['String']['input'];
};


export type Query_RootRental_Application_OccupantsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Occupants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Occupants_Order_By>>;
  where?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
};


export type Query_RootRental_Application_Occupants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_PetsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Pets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Pets_Order_By>>;
  where?: InputMaybe<Rental_Application_Pets_Bool_Exp>;
};


export type Query_RootRental_Application_Pets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Application_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Vehicles_Order_By>>;
  where?: InputMaybe<Rental_Application_Vehicles_Bool_Exp>;
};


export type Query_RootRental_Application_Vehicles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


export type Query_RootRental_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


export type Query_RootRental_Applications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Credits_Order_By>>;
  where?: InputMaybe<Rental_Credits_Bool_Exp>;
};


export type Query_RootRental_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Internet_Fee_ElectionsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Internet_Fee_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Internet_Fee_Elections_Order_By>>;
  where?: InputMaybe<Rental_Internet_Fee_Elections_Bool_Exp>;
};


export type Query_RootRental_Internet_Fee_Elections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Rental_Liabilities_Bool_Exp>;
};


export type Query_RootRental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Move_In_FeesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Move_In_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Move_In_Fees_Order_By>>;
  where?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
};


export type Query_RootRental_Move_In_Fees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_OccupantsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Occupants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Occupants_Order_By>>;
  where?: InputMaybe<Rental_Occupants_Bool_Exp>;
};


export type Query_RootRental_Reunderwrite_Tenant_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Order_By>>;
  where?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
};


export type Query_RootRental_Reunderwrite_Tenant_Underwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_ReunderwritesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Reunderwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Reunderwrites_Order_By>>;
  where?: InputMaybe<Rental_Reunderwrites_Bool_Exp>;
};


export type Query_RootRental_Reunderwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Site_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Accounts_Order_By>>;
  where?: InputMaybe<Rental_Site_Accounts_Bool_Exp>;
};


export type Query_RootRental_Site_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Site_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Leads_Order_By>>;
  where?: InputMaybe<Rental_Site_Leads_Bool_Exp>;
};


export type Query_RootRental_Site_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Site_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Listings_Order_By>>;
  where?: InputMaybe<Rental_Site_Listings_Bool_Exp>;
};


export type Query_RootRental_Site_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Site_Opportunity_ChecksArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Opportunity_Checks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Opportunity_Checks_Order_By>>;
  where?: InputMaybe<Rental_Site_Opportunity_Checks_Bool_Exp>;
};


export type Query_RootRental_Site_Opportunity_Checks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_UsersArgs = {
  distinct_on?: InputMaybe<Array<Rental_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Users_Order_By>>;
  where?: InputMaybe<Rental_Users_Bool_Exp>;
};


export type Query_RootRental_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRental_Utility_Chargeback_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Order_By>>;
  where?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
};


export type Query_RootRental_Utility_Chargeback_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Order_By>>;
  where?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
};


export type Query_RootRental_Utility_Chargeback_Overrides_By_PkArgs = {
  rental_id: Scalars['uuid']['input'];
};


export type Query_RootRentalsArgs = {
  distinct_on?: InputMaybe<Array<Rentals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rentals_Order_By>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


export type Query_RootRentals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSaferent_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Saferent_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saferent_Requests_Order_By>>;
  where?: InputMaybe<Saferent_Requests_Bool_Exp>;
};


export type Query_RootSaferent_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootScheduled_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scheduled_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
};


export type Query_RootScheduled_Rental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSecurity_EnumArgs = {
  distinct_on?: InputMaybe<Array<Security_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Security_Enum_Order_By>>;
  where?: InputMaybe<Security_Enum_Bool_Exp>;
};


export type Query_RootSecurity_Enum_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootSeller_Agent_SearchableArgs = {
  distinct_on?: InputMaybe<Array<Seller_Agent_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Agent_Searchable_Order_By>>;
  where?: InputMaybe<Seller_Agent_Searchable_Bool_Exp>;
};


export type Query_RootSeller_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Seller_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Agents_Order_By>>;
  where?: InputMaybe<Seller_Agents_Bool_Exp>;
};


export type Query_RootSeller_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStatementsArgs = {
  distinct_on?: InputMaybe<Array<Statements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statements_Order_By>>;
  where?: InputMaybe<Statements_Bool_Exp>;
};


export type Query_RootStatements_RawArgs = {
  distinct_on?: InputMaybe<Array<Statements_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statements_Raw_Order_By>>;
  where?: InputMaybe<Statements_Raw_Bool_Exp>;
};


export type Query_RootStatements_Raw_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenant_Underwrite_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Underwrite_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Underwrite_Documents_Order_By>>;
  where?: InputMaybe<Tenant_Underwrite_Documents_Bool_Exp>;
};


export type Query_RootTenant_Underwrite_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenant_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Underwrites_Order_By>>;
  where?: InputMaybe<Tenant_Underwrites_Bool_Exp>;
};


export type Query_RootTenant_Underwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTicket_Vendor_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Vendor_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Vendor_Assignments_Order_By>>;
  where?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
};


export type Query_RootTicket_Vendor_Assignments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Query_RootTickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTickets_Latchel_DataArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Latchel_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Latchel_Data_Order_By>>;
  where?: InputMaybe<Tickets_Latchel_Data_Bool_Exp>;
};


export type Query_RootTickets_Latchel_Data_By_PkArgs = {
  ticket_id: Scalars['uuid']['input'];
};


export type Query_RootTickets_Mason_DataArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Mason_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Mason_Data_Order_By>>;
  where?: InputMaybe<Tickets_Mason_Data_Bool_Exp>;
};


export type Query_RootTickets_Mason_Data_By_PkArgs = {
  ticket_id: Scalars['uuid']['input'];
};


export type Query_RootTour_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Tour_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tour_Properties_Order_By>>;
  where?: InputMaybe<Tour_Properties_Bool_Exp>;
};


export type Query_RootTour_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootToursArgs = {
  distinct_on?: InputMaybe<Array<Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tours_Order_By>>;
  where?: InputMaybe<Tours_Bool_Exp>;
};


export type Query_RootTours_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUnallocated_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Unallocated_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unallocated_Credits_Order_By>>;
  where?: InputMaybe<Unallocated_Credits_Bool_Exp>;
};


export type Query_RootUnallocated_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Unallocated_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unallocated_Payments_Order_By>>;
  where?: InputMaybe<Unallocated_Payments_Bool_Exp>;
};


export type Query_RootUnderwrites_Opportunity_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Order_By>>;
  where?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
};


export type Query_RootUnderwrites_Opportunity_Underwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUnpaid_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Unpaid_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unpaid_Liabilities_Order_By>>;
  where?: InputMaybe<Unpaid_Liabilities_Bool_Exp>;
};


export type Query_RootUser_Contact_DetailsArgs = {
  distinct_on?: InputMaybe<Array<User_Contact_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Contact_Details_Order_By>>;
  where?: InputMaybe<User_Contact_Details_Bool_Exp>;
};


export type Query_RootUser_Contact_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Document_RequestsArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Document_Requests_Order_By>>;
  where?: InputMaybe<User_Document_Requests_Bool_Exp>;
};


export type Query_RootUser_Document_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<User_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Documents_Order_By>>;
  where?: InputMaybe<User_Documents_Bool_Exp>;
};


export type Query_RootUser_Funnel_StatusesArgs = {
  distinct_on?: InputMaybe<Array<User_Funnel_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Funnel_Statuses_Order_By>>;
  where?: InputMaybe<User_Funnel_Statuses_Bool_Exp>;
};


export type Query_RootUser_Funnel_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Identity_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Identity_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Identity_Verifications_Order_By>>;
  where?: InputMaybe<User_Identity_Verifications_Bool_Exp>;
};


export type Query_RootUser_Identity_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_IncomesArgs = {
  distinct_on?: InputMaybe<Array<User_Incomes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Incomes_Order_By>>;
  where?: InputMaybe<User_Incomes_Bool_Exp>;
};


export type Query_RootUser_Incomes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Prequalification_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Prequalification_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Prequalification_Data_Order_By>>;
  where?: InputMaybe<User_Prequalification_Data_Bool_Exp>;
};


export type Query_RootUser_Prequalification_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_SearchableArgs = {
  distinct_on?: InputMaybe<Array<User_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Searchable_Order_By>>;
  where?: InputMaybe<User_Searchable_Bool_Exp>;
};


export type Query_RootUser_Underwriting_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Underwriting_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Underwriting_Data_Order_By>>;
  where?: InputMaybe<User_Underwriting_Data_Bool_Exp>;
};


export type Query_RootUser_Underwriting_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUtility_BillsArgs = {
  distinct_on?: InputMaybe<Array<Utility_Bills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Bills_Order_By>>;
  where?: InputMaybe<Utility_Bills_Bool_Exp>;
};


export type Query_RootUtility_Bills_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUtility_Chargeback_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Order_By>>;
  where?: InputMaybe<Utility_Chargeback_Status_Enum_Bool_Exp>;
};


export type Query_RootUtility_Chargeback_Status_Enum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Order_By>>;
  where?: InputMaybe<Utility_Chargeback_Status_Enum_Bool_Exp>;
};


export type Query_RootUtility_Chargeback_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootUtility_ChargebacksArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargebacks_Order_By>>;
  where?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
};


export type Query_RootUtility_Chargebacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargebacks_Order_By>>;
  where?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
};


export type Query_RootUtility_Chargebacks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUtility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
};


export type Query_RootUtility_Responsibilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUtility_TypesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Types_Order_By>>;
  where?: InputMaybe<Utility_Types_Bool_Exp>;
};


export type Query_RootUtility_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVendor_MarketsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Markets_Order_By>>;
  where?: InputMaybe<Vendor_Markets_Bool_Exp>;
};


export type Query_RootVendor_Markets_By_PkArgs = {
  market_id: Scalars['uuid']['input'];
  vendor_id: Scalars['uuid']['input'];
};


export type Query_RootVendor_TagsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Tags_Order_By>>;
  where?: InputMaybe<Vendor_Tags_Bool_Exp>;
};


export type Query_RootVendor_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVendor_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Types_Order_By>>;
  where?: InputMaybe<Vendor_Types_Bool_Exp>;
};


export type Query_RootVendor_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};


export type Query_RootVendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVendors_Vendor_TagsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Tags_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
};


export type Query_RootVendors_Vendor_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVendors_Vendor_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Types_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};


export type Query_RootVendors_Vendor_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


export type Query_RootWork_Orders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "real_estate_acquisitions" */
export type Real_Estate_Acquisitions = {
  __typename: 'real_estate_acquisitions';
  accepted_bid_id?: Maybe<Scalars['uuid']['output']>;
  access_information_note_id?: Maybe<Scalars['uuid']['output']>;
  active_rent_price_id?: Maybe<Scalars['uuid']['output']>;
  actual_made_ready_date?: Maybe<Scalars['date']['output']>;
  brokerage_fee_percentage?: Maybe<Scalars['numeric']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  closing_date?: Maybe<Scalars['date']['output']>;
  closing_real_estate_attorney_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  construction_projects: Array<Construction_Projects>;
  created_at: Scalars['timestamptz']['output'];
  due_diligence_end_at?: Maybe<Scalars['timestamptz']['output']>;
  due_diligence_start_at?: Maybe<Scalars['timestamptz']['output']>;
  due_diligence_status?: Maybe<Scalars['String']['output']>;
  due_diligence_status_approval_at?: Maybe<Scalars['timestamptz']['output']>;
  emd_amount_returned_to_buyer?: Maybe<Scalars['numeric']['output']>;
  emd_returned_at?: Maybe<Scalars['timestamptz']['output']>;
  emd_returned_note_id?: Maybe<Scalars['uuid']['output']>;
  emd_returned_to_type?: Maybe<Scalars['String']['output']>;
  emd_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  estimated_made_ready_date?: Maybe<Scalars['date']['output']>;
  external_link?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  final_ic_opportunity_underwrite?: Maybe<Underwrites_Opportunity_Underwrites>;
  final_ic_opportunity_underwrite_id?: Maybe<Scalars['uuid']['output']>;
  final_ic_underwrite_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  final_ic_underwrite_rent_price?: Maybe<Rent_Prices>;
  final_ic_underwrite_rent_price_id?: Maybe<Scalars['uuid']['output']>;
  final_purchase_price?: Maybe<Scalars['numeric']['output']>;
  final_sellers_credits_amount?: Maybe<Scalars['numeric']['output']>;
  firestore_property_id: Scalars['uuid']['output'];
  fotonotes_project_id?: Maybe<Scalars['String']['output']>;
  housecanary_bpo_valuation?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  inspection_notice_end_date?: Maybe<Scalars['date']['output']>;
  is_closing_confirmed: Scalars['Boolean']['output'];
  is_reinspection_required?: Maybe<Scalars['Boolean']['output']>;
  is_vacant?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  llc?: Maybe<Llcs>;
  llc_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mls_listing: Mls_Listings;
  mls_listing_id: Scalars['uuid']['output'];
  /** An object relationship */
  opportunity?: Maybe<Opportunities>;
  possession_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  real_estate_screening?: Maybe<Real_Estate_Screenings>;
  real_estate_screening_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  submitted_to_review_committee_at?: Maybe<Scalars['timestamptz']['output']>;
  submitted_to_review_committee_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  title_company_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  utilities_activation_date?: Maybe<Scalars['date']['output']>;
};


/** columns and relationships of "real_estate_acquisitions" */
export type Real_Estate_AcquisitionsConstruction_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Projects_Order_By>>;
  where?: InputMaybe<Construction_Projects_Bool_Exp>;
};

/** order by aggregate values of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Aggregate_Order_By = {
  avg?: InputMaybe<Real_Estate_Acquisitions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Real_Estate_Acquisitions_Max_Order_By>;
  min?: InputMaybe<Real_Estate_Acquisitions_Min_Order_By>;
  stddev?: InputMaybe<Real_Estate_Acquisitions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Real_Estate_Acquisitions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Real_Estate_Acquisitions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Real_Estate_Acquisitions_Sum_Order_By>;
  var_pop?: InputMaybe<Real_Estate_Acquisitions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Real_Estate_Acquisitions_Var_Samp_Order_By>;
  variance?: InputMaybe<Real_Estate_Acquisitions_Variance_Order_By>;
};

/** order by avg() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Avg_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "real_estate_acquisitions". All fields are combined with a logical 'AND'. */
export type Real_Estate_Acquisitions_Bool_Exp = {
  _and?: InputMaybe<Array<Real_Estate_Acquisitions_Bool_Exp>>;
  _not?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
  _or?: InputMaybe<Array<Real_Estate_Acquisitions_Bool_Exp>>;
  accepted_bid_id?: InputMaybe<Uuid_Comparison_Exp>;
  access_information_note_id?: InputMaybe<Uuid_Comparison_Exp>;
  active_rent_price_id?: InputMaybe<Uuid_Comparison_Exp>;
  actual_made_ready_date?: InputMaybe<Date_Comparison_Exp>;
  brokerage_fee_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  closing_date?: InputMaybe<Date_Comparison_Exp>;
  closing_real_estate_attorney_id?: InputMaybe<Uuid_Comparison_Exp>;
  construction_projects?: InputMaybe<Construction_Projects_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_diligence_end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_diligence_start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_diligence_status?: InputMaybe<String_Comparison_Exp>;
  due_diligence_status_approval_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emd_amount_returned_to_buyer?: InputMaybe<Numeric_Comparison_Exp>;
  emd_returned_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emd_returned_note_id?: InputMaybe<Uuid_Comparison_Exp>;
  emd_returned_to_type?: InputMaybe<String_Comparison_Exp>;
  emd_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  estimated_made_ready_date?: InputMaybe<Date_Comparison_Exp>;
  external_link?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  final_ic_opportunity_underwrite?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
  final_ic_opportunity_underwrite_id?: InputMaybe<Uuid_Comparison_Exp>;
  final_ic_underwrite_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  final_ic_underwrite_rent_price?: InputMaybe<Rent_Prices_Bool_Exp>;
  final_ic_underwrite_rent_price_id?: InputMaybe<Uuid_Comparison_Exp>;
  final_purchase_price?: InputMaybe<Numeric_Comparison_Exp>;
  final_sellers_credits_amount?: InputMaybe<Numeric_Comparison_Exp>;
  firestore_property_id?: InputMaybe<Uuid_Comparison_Exp>;
  fotonotes_project_id?: InputMaybe<String_Comparison_Exp>;
  housecanary_bpo_valuation?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inspection_notice_end_date?: InputMaybe<Date_Comparison_Exp>;
  is_closing_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  is_reinspection_required?: InputMaybe<Boolean_Comparison_Exp>;
  is_vacant?: InputMaybe<Boolean_Comparison_Exp>;
  llc?: InputMaybe<Llcs_Bool_Exp>;
  llc_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  opportunity?: InputMaybe<Opportunities_Bool_Exp>;
  possession_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  real_estate_screening?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
  real_estate_screening_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  submitted_to_review_committee_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  submitted_to_review_committee_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  title_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utilities_activation_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Max_Order_By = {
  accepted_bid_id?: InputMaybe<Order_By>;
  access_information_note_id?: InputMaybe<Order_By>;
  active_rent_price_id?: InputMaybe<Order_By>;
  actual_made_ready_date?: InputMaybe<Order_By>;
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  closing_real_estate_attorney_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_diligence_end_at?: InputMaybe<Order_By>;
  due_diligence_start_at?: InputMaybe<Order_By>;
  due_diligence_status?: InputMaybe<Order_By>;
  due_diligence_status_approval_at?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  emd_returned_at?: InputMaybe<Order_By>;
  emd_returned_note_id?: InputMaybe<Order_By>;
  emd_returned_to_type?: InputMaybe<Order_By>;
  emd_sent_at?: InputMaybe<Order_By>;
  estimated_made_ready_date?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  final_ic_opportunity_underwrite_id?: InputMaybe<Order_By>;
  final_ic_underwrite_at?: InputMaybe<Order_By>;
  final_ic_underwrite_rent_price_id?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  firestore_property_id?: InputMaybe<Order_By>;
  fotonotes_project_id?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_notice_end_date?: InputMaybe<Order_By>;
  llc_id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  possession_at?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_to_review_committee_at?: InputMaybe<Order_By>;
  submitted_to_review_committee_by_admin_id?: InputMaybe<Order_By>;
  title_company_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilities_activation_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Min_Order_By = {
  accepted_bid_id?: InputMaybe<Order_By>;
  access_information_note_id?: InputMaybe<Order_By>;
  active_rent_price_id?: InputMaybe<Order_By>;
  actual_made_ready_date?: InputMaybe<Order_By>;
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  closing_real_estate_attorney_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_diligence_end_at?: InputMaybe<Order_By>;
  due_diligence_start_at?: InputMaybe<Order_By>;
  due_diligence_status?: InputMaybe<Order_By>;
  due_diligence_status_approval_at?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  emd_returned_at?: InputMaybe<Order_By>;
  emd_returned_note_id?: InputMaybe<Order_By>;
  emd_returned_to_type?: InputMaybe<Order_By>;
  emd_sent_at?: InputMaybe<Order_By>;
  estimated_made_ready_date?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  final_ic_opportunity_underwrite_id?: InputMaybe<Order_By>;
  final_ic_underwrite_at?: InputMaybe<Order_By>;
  final_ic_underwrite_rent_price_id?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  firestore_property_id?: InputMaybe<Order_By>;
  fotonotes_project_id?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_notice_end_date?: InputMaybe<Order_By>;
  llc_id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  possession_at?: InputMaybe<Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_to_review_committee_at?: InputMaybe<Order_By>;
  submitted_to_review_committee_by_admin_id?: InputMaybe<Order_By>;
  title_company_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilities_activation_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "real_estate_acquisitions". */
export type Real_Estate_Acquisitions_Order_By = {
  accepted_bid_id?: InputMaybe<Order_By>;
  access_information_note_id?: InputMaybe<Order_By>;
  active_rent_price_id?: InputMaybe<Order_By>;
  actual_made_ready_date?: InputMaybe<Order_By>;
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  closing_date?: InputMaybe<Order_By>;
  closing_real_estate_attorney_id?: InputMaybe<Order_By>;
  construction_projects_aggregate?: InputMaybe<Construction_Projects_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_diligence_end_at?: InputMaybe<Order_By>;
  due_diligence_start_at?: InputMaybe<Order_By>;
  due_diligence_status?: InputMaybe<Order_By>;
  due_diligence_status_approval_at?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  emd_returned_at?: InputMaybe<Order_By>;
  emd_returned_note_id?: InputMaybe<Order_By>;
  emd_returned_to_type?: InputMaybe<Order_By>;
  emd_sent_at?: InputMaybe<Order_By>;
  estimated_made_ready_date?: InputMaybe<Order_By>;
  external_link?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  final_ic_opportunity_underwrite?: InputMaybe<Underwrites_Opportunity_Underwrites_Order_By>;
  final_ic_opportunity_underwrite_id?: InputMaybe<Order_By>;
  final_ic_underwrite_at?: InputMaybe<Order_By>;
  final_ic_underwrite_rent_price?: InputMaybe<Rent_Prices_Order_By>;
  final_ic_underwrite_rent_price_id?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  firestore_property_id?: InputMaybe<Order_By>;
  fotonotes_project_id?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_notice_end_date?: InputMaybe<Order_By>;
  is_closing_confirmed?: InputMaybe<Order_By>;
  is_reinspection_required?: InputMaybe<Order_By>;
  is_vacant?: InputMaybe<Order_By>;
  llc?: InputMaybe<Llcs_Order_By>;
  llc_id?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  opportunity?: InputMaybe<Opportunities_Order_By>;
  possession_at?: InputMaybe<Order_By>;
  real_estate_screening?: InputMaybe<Real_Estate_Screenings_Order_By>;
  real_estate_screening_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_to_review_committee_at?: InputMaybe<Order_By>;
  submitted_to_review_committee_by_admin_id?: InputMaybe<Order_By>;
  title_company_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilities_activation_date?: InputMaybe<Order_By>;
};

/** select columns of table "real_estate_acquisitions" */
export enum Real_Estate_Acquisitions_Select_Column {
  /** column name */
  AcceptedBidId = 'accepted_bid_id',
  /** column name */
  AccessInformationNoteId = 'access_information_note_id',
  /** column name */
  ActiveRentPriceId = 'active_rent_price_id',
  /** column name */
  ActualMadeReadyDate = 'actual_made_ready_date',
  /** column name */
  BrokerageFeePercentage = 'brokerage_fee_percentage',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  ClosingDate = 'closing_date',
  /** column name */
  ClosingRealEstateAttorneyId = 'closing_real_estate_attorney_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DueDiligenceEndAt = 'due_diligence_end_at',
  /** column name */
  DueDiligenceStartAt = 'due_diligence_start_at',
  /** column name */
  DueDiligenceStatus = 'due_diligence_status',
  /** column name */
  DueDiligenceStatusApprovalAt = 'due_diligence_status_approval_at',
  /** column name */
  EmdAmountReturnedToBuyer = 'emd_amount_returned_to_buyer',
  /** column name */
  EmdReturnedAt = 'emd_returned_at',
  /** column name */
  EmdReturnedNoteId = 'emd_returned_note_id',
  /** column name */
  EmdReturnedToType = 'emd_returned_to_type',
  /** column name */
  EmdSentAt = 'emd_sent_at',
  /** column name */
  EstimatedMadeReadyDate = 'estimated_made_ready_date',
  /** column name */
  ExternalLink = 'external_link',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FinalIcOpportunityUnderwriteId = 'final_ic_opportunity_underwrite_id',
  /** column name */
  FinalIcUnderwriteAt = 'final_ic_underwrite_at',
  /** column name */
  FinalIcUnderwriteRentPriceId = 'final_ic_underwrite_rent_price_id',
  /** column name */
  FinalPurchasePrice = 'final_purchase_price',
  /** column name */
  FinalSellersCreditsAmount = 'final_sellers_credits_amount',
  /** column name */
  FirestorePropertyId = 'firestore_property_id',
  /** column name */
  FotonotesProjectId = 'fotonotes_project_id',
  /** column name */
  HousecanaryBpoValuation = 'housecanary_bpo_valuation',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionNoticeEndDate = 'inspection_notice_end_date',
  /** column name */
  IsClosingConfirmed = 'is_closing_confirmed',
  /** column name */
  IsReinspectionRequired = 'is_reinspection_required',
  /** column name */
  IsVacant = 'is_vacant',
  /** column name */
  LlcId = 'llc_id',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  PossessionAt = 'possession_at',
  /** column name */
  RealEstateScreeningId = 'real_estate_screening_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubmittedToReviewCommitteeAt = 'submitted_to_review_committee_at',
  /** column name */
  SubmittedToReviewCommitteeByAdminId = 'submitted_to_review_committee_by_admin_id',
  /** column name */
  TitleCompanyId = 'title_company_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtilitiesActivationDate = 'utilities_activation_date'
}

/** order by stddev() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Stddev_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Stddev_Pop_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Stddev_Samp_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Real_Estate_Acquisitions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Real_Estate_Acquisitions_Stream_Cursor_Value_Input = {
  accepted_bid_id?: InputMaybe<Scalars['uuid']['input']>;
  access_information_note_id?: InputMaybe<Scalars['uuid']['input']>;
  active_rent_price_id?: InputMaybe<Scalars['uuid']['input']>;
  actual_made_ready_date?: InputMaybe<Scalars['date']['input']>;
  brokerage_fee_percentage?: InputMaybe<Scalars['numeric']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  closing_date?: InputMaybe<Scalars['date']['input']>;
  closing_real_estate_attorney_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_diligence_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_diligence_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_diligence_status?: InputMaybe<Scalars['String']['input']>;
  due_diligence_status_approval_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emd_amount_returned_to_buyer?: InputMaybe<Scalars['numeric']['input']>;
  emd_returned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emd_returned_note_id?: InputMaybe<Scalars['uuid']['input']>;
  emd_returned_to_type?: InputMaybe<Scalars['String']['input']>;
  emd_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estimated_made_ready_date?: InputMaybe<Scalars['date']['input']>;
  external_link?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  final_ic_opportunity_underwrite_id?: InputMaybe<Scalars['uuid']['input']>;
  final_ic_underwrite_at?: InputMaybe<Scalars['timestamptz']['input']>;
  final_ic_underwrite_rent_price_id?: InputMaybe<Scalars['uuid']['input']>;
  final_purchase_price?: InputMaybe<Scalars['numeric']['input']>;
  final_sellers_credits_amount?: InputMaybe<Scalars['numeric']['input']>;
  firestore_property_id?: InputMaybe<Scalars['uuid']['input']>;
  fotonotes_project_id?: InputMaybe<Scalars['String']['input']>;
  housecanary_bpo_valuation?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inspection_notice_end_date?: InputMaybe<Scalars['date']['input']>;
  is_closing_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  is_reinspection_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_vacant?: InputMaybe<Scalars['Boolean']['input']>;
  llc_id?: InputMaybe<Scalars['uuid']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  possession_at?: InputMaybe<Scalars['timestamptz']['input']>;
  real_estate_screening_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submitted_to_review_committee_at?: InputMaybe<Scalars['timestamptz']['input']>;
  submitted_to_review_committee_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  title_company_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utilities_activation_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by sum() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Sum_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Var_Pop_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Var_Samp_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "real_estate_acquisitions" */
export type Real_Estate_Acquisitions_Variance_Order_By = {
  brokerage_fee_percentage?: InputMaybe<Order_By>;
  emd_amount_returned_to_buyer?: InputMaybe<Order_By>;
  final_purchase_price?: InputMaybe<Order_By>;
  final_sellers_credits_amount?: InputMaybe<Order_By>;
  housecanary_bpo_valuation?: InputMaybe<Order_By>;
};

/** columns and relationships of "real_estate_screenings" */
export type Real_Estate_Screenings = {
  __typename: 'real_estate_screenings';
  additional_checks?: Maybe<Scalars['jsonb']['output']>;
  after_capex_quality_rating?: Maybe<Scalars['numeric']['output']>;
  completed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at: Scalars['timestamptz']['output'];
  current_quality_rating?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  is_approved: Scalars['Boolean']['output'];
  manager_review_score?: Maybe<Scalars['numeric']['output']>;
  max_bid_price?: Maybe<Scalars['numeric']['output']>;
  max_underwritten_capex?: Maybe<Scalars['numeric']['output']>;
  mls_listing_id: Scalars['uuid']['output'];
  rejection_reason?: Maybe<Scalars['String']['output']>;
  scored_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  screened_by_admin_id: Scalars['uuid']['output'];
  target_bid_price?: Maybe<Scalars['numeric']['output']>;
  type: Scalars['String']['output'];
  underwritten_rent_price_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "real_estate_screenings" */
export type Real_Estate_ScreeningsAdditional_ChecksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "real_estate_screenings" */
export type Real_Estate_Screenings_Aggregate_Order_By = {
  avg?: InputMaybe<Real_Estate_Screenings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Real_Estate_Screenings_Max_Order_By>;
  min?: InputMaybe<Real_Estate_Screenings_Min_Order_By>;
  stddev?: InputMaybe<Real_Estate_Screenings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Real_Estate_Screenings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Real_Estate_Screenings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Real_Estate_Screenings_Sum_Order_By>;
  var_pop?: InputMaybe<Real_Estate_Screenings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Real_Estate_Screenings_Var_Samp_Order_By>;
  variance?: InputMaybe<Real_Estate_Screenings_Variance_Order_By>;
};

/** order by avg() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Avg_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "real_estate_screenings". All fields are combined with a logical 'AND'. */
export type Real_Estate_Screenings_Bool_Exp = {
  _and?: InputMaybe<Array<Real_Estate_Screenings_Bool_Exp>>;
  _not?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
  _or?: InputMaybe<Array<Real_Estate_Screenings_Bool_Exp>>;
  additional_checks?: InputMaybe<Jsonb_Comparison_Exp>;
  after_capex_quality_rating?: InputMaybe<Numeric_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_quality_rating?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  manager_review_score?: InputMaybe<Numeric_Comparison_Exp>;
  max_bid_price?: InputMaybe<Numeric_Comparison_Exp>;
  max_underwritten_capex?: InputMaybe<Numeric_Comparison_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  scored_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  screened_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_bid_price?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  underwritten_rent_price_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Max_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  scored_by_admin_id?: InputMaybe<Order_By>;
  screened_by_admin_id?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  underwritten_rent_price_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Min_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  scored_by_admin_id?: InputMaybe<Order_By>;
  screened_by_admin_id?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  underwritten_rent_price_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "real_estate_screenings". */
export type Real_Estate_Screenings_Order_By = {
  additional_checks?: InputMaybe<Order_By>;
  after_capex_quality_rating?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  scored_by_admin_id?: InputMaybe<Order_By>;
  screened_by_admin_id?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  underwritten_rent_price_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "real_estate_screenings" */
export enum Real_Estate_Screenings_Select_Column {
  /** column name */
  AdditionalChecks = 'additional_checks',
  /** column name */
  AfterCapexQualityRating = 'after_capex_quality_rating',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQualityRating = 'current_quality_rating',
  /** column name */
  Id = 'id',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  ManagerReviewScore = 'manager_review_score',
  /** column name */
  MaxBidPrice = 'max_bid_price',
  /** column name */
  MaxUnderwrittenCapex = 'max_underwritten_capex',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  ScoredByAdminId = 'scored_by_admin_id',
  /** column name */
  ScreenedByAdminId = 'screened_by_admin_id',
  /** column name */
  TargetBidPrice = 'target_bid_price',
  /** column name */
  Type = 'type',
  /** column name */
  UnderwrittenRentPriceId = 'underwritten_rent_price_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Stddev_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Stddev_Pop_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Stddev_Samp_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "real_estate_screenings" */
export type Real_Estate_Screenings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Real_Estate_Screenings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Real_Estate_Screenings_Stream_Cursor_Value_Input = {
  additional_checks?: InputMaybe<Scalars['jsonb']['input']>;
  after_capex_quality_rating?: InputMaybe<Scalars['numeric']['input']>;
  completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_quality_rating?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  manager_review_score?: InputMaybe<Scalars['numeric']['input']>;
  max_bid_price?: InputMaybe<Scalars['numeric']['input']>;
  max_underwritten_capex?: InputMaybe<Scalars['numeric']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  scored_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  screened_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  target_bid_price?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  underwritten_rent_price_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Sum_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Var_Pop_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Var_Samp_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "real_estate_screenings" */
export type Real_Estate_Screenings_Variance_Order_By = {
  after_capex_quality_rating?: InputMaybe<Order_By>;
  current_quality_rating?: InputMaybe<Order_By>;
  manager_review_score?: InputMaybe<Order_By>;
  max_bid_price?: InputMaybe<Order_By>;
  max_underwritten_capex?: InputMaybe<Order_By>;
  target_bid_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "recurring_credits" */
export type Recurring_Credits = {
  __typename: 'recurring_credits';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  move_in_credit: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  num_months: Scalars['Int']['output'];
  /** An object relationship */
  renewal_agreement?: Maybe<Agreements>;
  renewal_agreement_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  total_amount: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "recurring_credits" */
export type Recurring_Credits_Aggregate_Order_By = {
  avg?: InputMaybe<Recurring_Credits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Recurring_Credits_Max_Order_By>;
  min?: InputMaybe<Recurring_Credits_Min_Order_By>;
  stddev?: InputMaybe<Recurring_Credits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Recurring_Credits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Recurring_Credits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Recurring_Credits_Sum_Order_By>;
  var_pop?: InputMaybe<Recurring_Credits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Recurring_Credits_Var_Samp_Order_By>;
  variance?: InputMaybe<Recurring_Credits_Variance_Order_By>;
};

/** order by avg() on columns of table "recurring_credits" */
export type Recurring_Credits_Avg_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "recurring_credits". All fields are combined with a logical 'AND'. */
export type Recurring_Credits_Bool_Exp = {
  _and?: InputMaybe<Array<Recurring_Credits_Bool_Exp>>;
  _not?: InputMaybe<Recurring_Credits_Bool_Exp>;
  _or?: InputMaybe<Array<Recurring_Credits_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  move_in_credit?: InputMaybe<Boolean_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  num_months?: InputMaybe<Int_Comparison_Exp>;
  renewal_agreement?: InputMaybe<Agreements_Bool_Exp>;
  renewal_agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "recurring_credits" */
export enum Recurring_Credits_Constraint {
  /** unique or primary key constraint on columns "id" */
  MoveInCreditsPkey = 'move_in_credits_pkey',
  /** unique or primary key constraint on columns "start_date", "renewal_agreement_id" */
  RecurringCreditsRenewalAgreementDateKey = 'recurring_credits_renewal_agreement_date_key'
}

/** input type for inserting data into table "recurring_credits" */
export type Recurring_Credits_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  move_in_credit?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  num_months?: InputMaybe<Scalars['Int']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "recurring_credits" */
export type Recurring_Credits_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  num_months?: InputMaybe<Order_By>;
  renewal_agreement_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "recurring_credits" */
export type Recurring_Credits_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  num_months?: InputMaybe<Order_By>;
  renewal_agreement_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "recurring_credits" */
export type Recurring_Credits_Mutation_Response = {
  __typename: 'recurring_credits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Recurring_Credits>;
};

/** on_conflict condition type for table "recurring_credits" */
export type Recurring_Credits_On_Conflict = {
  constraint: Recurring_Credits_Constraint;
  update_columns?: Array<Recurring_Credits_Update_Column>;
  where?: InputMaybe<Recurring_Credits_Bool_Exp>;
};

/** Ordering options when selecting data from "recurring_credits". */
export type Recurring_Credits_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  move_in_credit?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  num_months?: InputMaybe<Order_By>;
  renewal_agreement?: InputMaybe<Agreements_Order_By>;
  renewal_agreement_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "recurring_credits" */
export enum Recurring_Credits_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  MoveInCredit = 'move_in_credit',
  /** column name */
  Notes = 'notes',
  /** column name */
  NumMonths = 'num_months',
  /** column name */
  RenewalAgreementId = 'renewal_agreement_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "recurring_credits" */
export type Recurring_Credits_Stddev_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "recurring_credits" */
export type Recurring_Credits_Stddev_Pop_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "recurring_credits" */
export type Recurring_Credits_Stddev_Samp_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "recurring_credits" */
export type Recurring_Credits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recurring_Credits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Recurring_Credits_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  move_in_credit?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  num_months?: InputMaybe<Scalars['Int']['input']>;
  renewal_agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "recurring_credits" */
export type Recurring_Credits_Sum_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "recurring_credits" (current role has no relevant permissions) */
export enum Recurring_Credits_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "recurring_credits" */
export type Recurring_Credits_Var_Pop_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "recurring_credits" */
export type Recurring_Credits_Var_Samp_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "recurring_credits" */
export type Recurring_Credits_Variance_Order_By = {
  num_months?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "renewal_offers" */
export type Renewal_Offers = {
  __typename: 'renewal_offers';
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_month_to_month: Scalars['Boolean']['output'];
  portfolio_home_underwrite_id?: Maybe<Scalars['uuid']['output']>;
  price: Scalars['numeric']['output'];
  projected_total_contribution?: Maybe<Scalars['numeric']['output']>;
  projected_wallet_value?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  renewal: Renewals;
  renewal_id: Scalars['uuid']['output'];
  term: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "renewal_offers" */
export type Renewal_Offers_Aggregate_Order_By = {
  avg?: InputMaybe<Renewal_Offers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Renewal_Offers_Max_Order_By>;
  min?: InputMaybe<Renewal_Offers_Min_Order_By>;
  stddev?: InputMaybe<Renewal_Offers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Renewal_Offers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Renewal_Offers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Renewal_Offers_Sum_Order_By>;
  var_pop?: InputMaybe<Renewal_Offers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Renewal_Offers_Var_Samp_Order_By>;
  variance?: InputMaybe<Renewal_Offers_Variance_Order_By>;
};

/** order by avg() on columns of table "renewal_offers" */
export type Renewal_Offers_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "renewal_offers". All fields are combined with a logical 'AND'. */
export type Renewal_Offers_Bool_Exp = {
  _and?: InputMaybe<Array<Renewal_Offers_Bool_Exp>>;
  _not?: InputMaybe<Renewal_Offers_Bool_Exp>;
  _or?: InputMaybe<Array<Renewal_Offers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_month_to_month?: InputMaybe<Boolean_Comparison_Exp>;
  portfolio_home_underwrite_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  projected_total_contribution?: InputMaybe<Numeric_Comparison_Exp>;
  projected_wallet_value?: InputMaybe<Numeric_Comparison_Exp>;
  renewal?: InputMaybe<Renewals_Bool_Exp>;
  renewal_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "renewal_offers" */
export type Renewal_Offers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_underwrite_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  renewal_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "renewal_offers" */
export type Renewal_Offers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_underwrite_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  renewal_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "renewal_offers". */
export type Renewal_Offers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_month_to_month?: InputMaybe<Order_By>;
  portfolio_home_underwrite_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Renewals_Order_By>;
  renewal_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "renewal_offers" */
export enum Renewal_Offers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMonthToMonth = 'is_month_to_month',
  /** column name */
  PortfolioHomeUnderwriteId = 'portfolio_home_underwrite_id',
  /** column name */
  Price = 'price',
  /** column name */
  ProjectedTotalContribution = 'projected_total_contribution',
  /** column name */
  ProjectedWalletValue = 'projected_wallet_value',
  /** column name */
  RenewalId = 'renewal_id',
  /** column name */
  Term = 'term',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "renewal_offers" */
export type Renewal_Offers_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "renewal_offers" */
export type Renewal_Offers_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "renewal_offers" */
export type Renewal_Offers_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "renewal_offers" */
export type Renewal_Offers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Renewal_Offers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Renewal_Offers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_month_to_month?: InputMaybe<Scalars['Boolean']['input']>;
  portfolio_home_underwrite_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  projected_total_contribution?: InputMaybe<Scalars['numeric']['input']>;
  projected_wallet_value?: InputMaybe<Scalars['numeric']['input']>;
  renewal_id?: InputMaybe<Scalars['uuid']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "renewal_offers" */
export type Renewal_Offers_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "renewal_offers" */
export type Renewal_Offers_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "renewal_offers" */
export type Renewal_Offers_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "renewal_offers" */
export type Renewal_Offers_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  projected_total_contribution?: InputMaybe<Order_By>;
  projected_wallet_value?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

export enum Renewal_Status_Enum_Enum {
  Canceled = 'canceled',
  Complete = 'complete',
  Offered = 'offered',
  PendingCustomerSignature = 'pending_customer_signature',
  PendingInitialOptionFeePayment = 'pending_initial_option_fee_payment',
  PendingOffer = 'pending_offer',
  PendingUpandupSignature = 'pending_upandup_signature',
  RenewalOptionSelected = 'renewal_option_selected'
}

/** Boolean expression to compare columns of type "renewal_status_enum_enum". All fields are combined with logical 'AND'. */
export type Renewal_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Renewal_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Renewal_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Renewal_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Renewal_Status_Enum_Enum>>;
};

/** columns and relationships of "renewals" */
export type Renewals = {
  __typename: 'renewals';
  /** An object relationship */
  admin: Admins;
  /** An object relationship */
  agreement?: Maybe<Agreements>;
  agreement_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  kcpoa_terms?: Maybe<Scalars['jsonb']['output']>;
  lease_variant: Lease_Variants_Enum_Enum;
  offered_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  renewal_offers: Array<Renewal_Offers>;
  renewal_option_selected_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  renewal_option_selected_by_user?: Maybe<Users>;
  renewal_option_selected_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental: Rentals;
  /** An object relationship */
  rental_agreement_history: Rental_Agreement_Histories;
  rental_agreement_history_id: Scalars['uuid']['output'];
  rental_id: Scalars['uuid']['output'];
  /** An array relationship */
  scheduled_rental_liabilities: Array<Scheduled_Rental_Liabilities>;
  /** An object relationship */
  selected_renewal_offer?: Maybe<Renewal_Offers>;
  selected_renewal_offer_id?: Maybe<Scalars['uuid']['output']>;
  status: Renewal_Status_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "renewals" */
export type RenewalsKcpoa_TermsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "renewals" */
export type RenewalsRenewal_OffersArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Renewal_Offers_Order_By>>;
  where?: InputMaybe<Renewal_Offers_Bool_Exp>;
};


/** columns and relationships of "renewals" */
export type RenewalsScheduled_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scheduled_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
};

/** order by aggregate values of table "renewals" */
export type Renewals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Renewals_Max_Order_By>;
  min?: InputMaybe<Renewals_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "renewals". All fields are combined with a logical 'AND'. */
export type Renewals_Bool_Exp = {
  _and?: InputMaybe<Array<Renewals_Bool_Exp>>;
  _not?: InputMaybe<Renewals_Bool_Exp>;
  _or?: InputMaybe<Array<Renewals_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  agreement?: InputMaybe<Agreements_Bool_Exp>;
  agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kcpoa_terms?: InputMaybe<Jsonb_Comparison_Exp>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum_Comparison_Exp>;
  offered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  renewal_offers?: InputMaybe<Renewal_Offers_Bool_Exp>;
  renewal_option_selected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  renewal_option_selected_by_user?: InputMaybe<Users_Bool_Exp>;
  renewal_option_selected_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_agreement_history?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
  rental_agreement_history_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  scheduled_rental_liabilities?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
  selected_renewal_offer?: InputMaybe<Renewal_Offers_Bool_Exp>;
  selected_renewal_offer_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Renewal_Status_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "renewals" */
export type Renewals_Max_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offered_at?: InputMaybe<Order_By>;
  renewal_option_selected_at?: InputMaybe<Order_By>;
  renewal_option_selected_by_user_id?: InputMaybe<Order_By>;
  rental_agreement_history_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  selected_renewal_offer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "renewals" */
export type Renewals_Min_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offered_at?: InputMaybe<Order_By>;
  renewal_option_selected_at?: InputMaybe<Order_By>;
  renewal_option_selected_by_user_id?: InputMaybe<Order_By>;
  rental_agreement_history_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  selected_renewal_offer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "renewals". */
export type Renewals_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  agreement?: InputMaybe<Agreements_Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcpoa_terms?: InputMaybe<Order_By>;
  lease_variant?: InputMaybe<Order_By>;
  offered_at?: InputMaybe<Order_By>;
  renewal_offers_aggregate?: InputMaybe<Renewal_Offers_Aggregate_Order_By>;
  renewal_option_selected_at?: InputMaybe<Order_By>;
  renewal_option_selected_by_user?: InputMaybe<Users_Order_By>;
  renewal_option_selected_by_user_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_agreement_history?: InputMaybe<Rental_Agreement_Histories_Order_By>;
  rental_agreement_history_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  scheduled_rental_liabilities_aggregate?: InputMaybe<Scheduled_Rental_Liabilities_Aggregate_Order_By>;
  selected_renewal_offer?: InputMaybe<Renewal_Offers_Order_By>;
  selected_renewal_offer_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "renewals" */
export enum Renewals_Select_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  KcpoaTerms = 'kcpoa_terms',
  /** column name */
  LeaseVariant = 'lease_variant',
  /** column name */
  OfferedAt = 'offered_at',
  /** column name */
  RenewalOptionSelectedAt = 'renewal_option_selected_at',
  /** column name */
  RenewalOptionSelectedByUserId = 'renewal_option_selected_by_user_id',
  /** column name */
  RentalAgreementHistoryId = 'rental_agreement_history_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SelectedRenewalOfferId = 'selected_renewal_offer_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "renewals" */
export type Renewals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Renewals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Renewals_Stream_Cursor_Value_Input = {
  agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcpoa_terms?: InputMaybe<Scalars['jsonb']['input']>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum>;
  offered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  renewal_option_selected_at?: InputMaybe<Scalars['timestamptz']['input']>;
  renewal_option_selected_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_agreement_history_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  selected_renewal_offer_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Renewal_Status_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rent_prices" */
export type Rent_Prices = {
  __typename: 'rent_prices';
  annual_bad_debt_expense?: Maybe<Scalars['numeric']['output']>;
  annual_hoa?: Maybe<Scalars['numeric']['output']>;
  annual_insurance_cost?: Maybe<Scalars['numeric']['output']>;
  annual_marketing_and_leasing_fees?: Maybe<Scalars['numeric']['output']>;
  annual_opex?: Maybe<Scalars['numeric']['output']>;
  annual_other_income?: Maybe<Scalars['numeric']['output']>;
  annual_other_opex?: Maybe<Scalars['numeric']['output']>;
  annual_repairs_and_maintenance?: Maybe<Scalars['numeric']['output']>;
  annual_taxes?: Maybe<Scalars['numeric']['output']>;
  annual_turnover_expense?: Maybe<Scalars['numeric']['output']>;
  annual_vacancy_expense?: Maybe<Scalars['numeric']['output']>;
  closing_costs?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deferred_capex_cost?: Maybe<Scalars['numeric']['output']>;
  estimated_cap_rate?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_approved_to_list: Scalars['Boolean']['output'];
  list_price?: Maybe<Scalars['numeric']['output']>;
  mls_listing_id: Scalars['uuid']['output'];
  monthly_property_management_fee?: Maybe<Scalars['numeric']['output']>;
  origination_fee?: Maybe<Scalars['numeric']['output']>;
  percent_over_comp?: Maybe<Scalars['numeric']['output']>;
  rent_price?: Maybe<Scalars['numeric']['output']>;
  rental_comp?: Maybe<Scalars['numeric']['output']>;
  sellers_credits?: Maybe<Scalars['numeric']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  underwritten_vacancy_days?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  upfront_diligence_and_scoping_cost?: Maybe<Scalars['numeric']['output']>;
  upfront_improvements_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by aggregate values of table "rent_prices" */
export type Rent_Prices_Aggregate_Order_By = {
  avg?: InputMaybe<Rent_Prices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rent_Prices_Max_Order_By>;
  min?: InputMaybe<Rent_Prices_Min_Order_By>;
  stddev?: InputMaybe<Rent_Prices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rent_Prices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rent_Prices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rent_Prices_Sum_Order_By>;
  var_pop?: InputMaybe<Rent_Prices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rent_Prices_Var_Samp_Order_By>;
  variance?: InputMaybe<Rent_Prices_Variance_Order_By>;
};

/** order by avg() on columns of table "rent_prices" */
export type Rent_Prices_Avg_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rent_prices". All fields are combined with a logical 'AND'. */
export type Rent_Prices_Bool_Exp = {
  _and?: InputMaybe<Array<Rent_Prices_Bool_Exp>>;
  _not?: InputMaybe<Rent_Prices_Bool_Exp>;
  _or?: InputMaybe<Array<Rent_Prices_Bool_Exp>>;
  annual_bad_debt_expense?: InputMaybe<Numeric_Comparison_Exp>;
  annual_hoa?: InputMaybe<Numeric_Comparison_Exp>;
  annual_insurance_cost?: InputMaybe<Numeric_Comparison_Exp>;
  annual_marketing_and_leasing_fees?: InputMaybe<Numeric_Comparison_Exp>;
  annual_opex?: InputMaybe<Numeric_Comparison_Exp>;
  annual_other_income?: InputMaybe<Numeric_Comparison_Exp>;
  annual_other_opex?: InputMaybe<Numeric_Comparison_Exp>;
  annual_repairs_and_maintenance?: InputMaybe<Numeric_Comparison_Exp>;
  annual_taxes?: InputMaybe<Numeric_Comparison_Exp>;
  annual_turnover_expense?: InputMaybe<Numeric_Comparison_Exp>;
  annual_vacancy_expense?: InputMaybe<Numeric_Comparison_Exp>;
  closing_costs?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deferred_capex_cost?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_cap_rate?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved_to_list?: InputMaybe<Boolean_Comparison_Exp>;
  list_price?: InputMaybe<Numeric_Comparison_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  monthly_property_management_fee?: InputMaybe<Numeric_Comparison_Exp>;
  origination_fee?: InputMaybe<Numeric_Comparison_Exp>;
  percent_over_comp?: InputMaybe<Numeric_Comparison_Exp>;
  rent_price?: InputMaybe<Numeric_Comparison_Exp>;
  rental_comp?: InputMaybe<Numeric_Comparison_Exp>;
  sellers_credits?: InputMaybe<Numeric_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  underwritten_vacancy_days?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Numeric_Comparison_Exp>;
  upfront_improvements_cost?: InputMaybe<Numeric_Comparison_Exp>;
};

/** order by max() on columns of table "rent_prices" */
export type Rent_Prices_Max_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rent_prices" */
export type Rent_Prices_Min_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rent_prices". */
export type Rent_Prices_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_approved_to_list?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** select columns of table "rent_prices" */
export enum Rent_Prices_Select_Column {
  /** column name */
  AnnualBadDebtExpense = 'annual_bad_debt_expense',
  /** column name */
  AnnualHoa = 'annual_hoa',
  /** column name */
  AnnualInsuranceCost = 'annual_insurance_cost',
  /** column name */
  AnnualMarketingAndLeasingFees = 'annual_marketing_and_leasing_fees',
  /** column name */
  AnnualOpex = 'annual_opex',
  /** column name */
  AnnualOtherIncome = 'annual_other_income',
  /** column name */
  AnnualOtherOpex = 'annual_other_opex',
  /** column name */
  AnnualRepairsAndMaintenance = 'annual_repairs_and_maintenance',
  /** column name */
  AnnualTaxes = 'annual_taxes',
  /** column name */
  AnnualTurnoverExpense = 'annual_turnover_expense',
  /** column name */
  AnnualVacancyExpense = 'annual_vacancy_expense',
  /** column name */
  ClosingCosts = 'closing_costs',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeferredCapexCost = 'deferred_capex_cost',
  /** column name */
  EstimatedCapRate = 'estimated_cap_rate',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApprovedToList = 'is_approved_to_list',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  MonthlyPropertyManagementFee = 'monthly_property_management_fee',
  /** column name */
  OriginationFee = 'origination_fee',
  /** column name */
  PercentOverComp = 'percent_over_comp',
  /** column name */
  RentPrice = 'rent_price',
  /** column name */
  RentalComp = 'rental_comp',
  /** column name */
  SellersCredits = 'sellers_credits',
  /** column name */
  Source = 'source',
  /** column name */
  UnderwrittenVacancyDays = 'underwritten_vacancy_days',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpfrontDiligenceAndScopingCost = 'upfront_diligence_and_scoping_cost',
  /** column name */
  UpfrontImprovementsCost = 'upfront_improvements_cost'
}

/** order by stddev() on columns of table "rent_prices" */
export type Rent_Prices_Stddev_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rent_prices" */
export type Rent_Prices_Stddev_Pop_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rent_prices" */
export type Rent_Prices_Stddev_Samp_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rent_prices" */
export type Rent_Prices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rent_Prices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rent_Prices_Stream_Cursor_Value_Input = {
  annual_bad_debt_expense?: InputMaybe<Scalars['numeric']['input']>;
  annual_hoa?: InputMaybe<Scalars['numeric']['input']>;
  annual_insurance_cost?: InputMaybe<Scalars['numeric']['input']>;
  annual_marketing_and_leasing_fees?: InputMaybe<Scalars['numeric']['input']>;
  annual_opex?: InputMaybe<Scalars['numeric']['input']>;
  annual_other_income?: InputMaybe<Scalars['numeric']['input']>;
  annual_other_opex?: InputMaybe<Scalars['numeric']['input']>;
  annual_repairs_and_maintenance?: InputMaybe<Scalars['numeric']['input']>;
  annual_taxes?: InputMaybe<Scalars['numeric']['input']>;
  annual_turnover_expense?: InputMaybe<Scalars['numeric']['input']>;
  annual_vacancy_expense?: InputMaybe<Scalars['numeric']['input']>;
  closing_costs?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deferred_capex_cost?: InputMaybe<Scalars['numeric']['input']>;
  estimated_cap_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved_to_list?: InputMaybe<Scalars['Boolean']['input']>;
  list_price?: InputMaybe<Scalars['numeric']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  monthly_property_management_fee?: InputMaybe<Scalars['numeric']['input']>;
  origination_fee?: InputMaybe<Scalars['numeric']['input']>;
  percent_over_comp?: InputMaybe<Scalars['numeric']['input']>;
  rent_price?: InputMaybe<Scalars['numeric']['input']>;
  rental_comp?: InputMaybe<Scalars['numeric']['input']>;
  sellers_credits?: InputMaybe<Scalars['numeric']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  underwritten_vacancy_days?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Scalars['numeric']['input']>;
  upfront_improvements_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "rent_prices" */
export type Rent_Prices_Sum_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "rent_prices" */
export type Rent_Prices_Var_Pop_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rent_prices" */
export type Rent_Prices_Var_Samp_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rent_prices" */
export type Rent_Prices_Variance_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  estimated_cap_rate?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  percent_over_comp?: InputMaybe<Order_By>;
  rent_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "rent_ready_dates" */
export type Rent_Ready_Dates = {
  __typename: 'rent_ready_dates';
  created_at: Scalars['timestamptz']['output'];
  earliest_move_in_date?: Maybe<Scalars['date']['output']>;
  earliest_tour_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  mls_listing: Mls_Listings;
  mls_listing_id: Scalars['uuid']['output'];
  showing_type?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "rent_ready_dates" */
export type Rent_Ready_Dates_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rent_Ready_Dates_Max_Order_By>;
  min?: InputMaybe<Rent_Ready_Dates_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "rent_ready_dates". All fields are combined with a logical 'AND'. */
export type Rent_Ready_Dates_Bool_Exp = {
  _and?: InputMaybe<Array<Rent_Ready_Dates_Bool_Exp>>;
  _not?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
  _or?: InputMaybe<Array<Rent_Ready_Dates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  earliest_move_in_date?: InputMaybe<Date_Comparison_Exp>;
  earliest_tour_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  showing_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "rent_ready_dates" */
export type Rent_Ready_Dates_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  earliest_move_in_date?: InputMaybe<Order_By>;
  earliest_tour_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  showing_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rent_ready_dates" */
export type Rent_Ready_Dates_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  earliest_move_in_date?: InputMaybe<Order_By>;
  earliest_tour_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  showing_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rent_ready_dates". */
export type Rent_Ready_Dates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  earliest_move_in_date?: InputMaybe<Order_By>;
  earliest_tour_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  showing_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rent_ready_dates" */
export enum Rent_Ready_Dates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EarliestMoveInDate = 'earliest_move_in_date',
  /** column name */
  EarliestTourDate = 'earliest_tour_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  ShowingType = 'showing_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "rent_ready_dates" */
export type Rent_Ready_Dates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rent_Ready_Dates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rent_Ready_Dates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  earliest_move_in_date?: InputMaybe<Scalars['date']['input']>;
  earliest_tour_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  showing_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rent_roll" */
export type Rent_Roll = {
  __typename: 'rent_roll';
  aggregate_balance_after?: Maybe<Scalars['numeric']['output']>;
  aggregate_successful_balance_after?: Maybe<Scalars['numeric']['output']>;
  agreement_id?: Maybe<Scalars['uuid']['output']>;
  auto_charge?: Maybe<Scalars['Boolean']['output']>;
  cashout_deadline?: Maybe<Scalars['Int']['output']>;
  chargeback_deadline?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_rental_application_id?: Maybe<Scalars['uuid']['output']>;
  display_line_1?: Maybe<Scalars['String']['output']>;
  display_line_2?: Maybe<Scalars['String']['output']>;
  ends_at?: Maybe<Scalars['date']['output']>;
  final_liability_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initial_lease_term?: Maybe<Scalars['Int']['output']>;
  initial_option_premium?: Maybe<Scalars['Int']['output']>;
  is_card_payment_allowed?: Maybe<Scalars['Boolean']['output']>;
  is_statements_enabled?: Maybe<Scalars['Boolean']['output']>;
  last_statement_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_end_reason?: Maybe<Scalars['String']['output']>;
  minimum_monthly_option_premium?: Maybe<Scalars['numeric']['output']>;
  move_out_date?: Maybe<Scalars['date']['output']>;
  occupancy_date?: Maybe<Scalars['date']['output']>;
  occupancy_status?: Maybe<Scalars['String']['output']>;
  option_premium?: Maybe<Scalars['numeric']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  renewal_months?: Maybe<Scalars['numeric']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_agreement_history_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  starts_at?: Maybe<Scalars['date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target_monthly_option_premium?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "rent_roll". All fields are combined with a logical 'AND'. */
export type Rent_Roll_Bool_Exp = {
  _and?: InputMaybe<Array<Rent_Roll_Bool_Exp>>;
  _not?: InputMaybe<Rent_Roll_Bool_Exp>;
  _or?: InputMaybe<Array<Rent_Roll_Bool_Exp>>;
  aggregate_balance_after?: InputMaybe<Numeric_Comparison_Exp>;
  aggregate_successful_balance_after?: InputMaybe<Numeric_Comparison_Exp>;
  agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  auto_charge?: InputMaybe<Boolean_Comparison_Exp>;
  cashout_deadline?: InputMaybe<Int_Comparison_Exp>;
  chargeback_deadline?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_line_1?: InputMaybe<String_Comparison_Exp>;
  display_line_2?: InputMaybe<String_Comparison_Exp>;
  ends_at?: InputMaybe<Date_Comparison_Exp>;
  final_liability_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_lease_term?: InputMaybe<Int_Comparison_Exp>;
  initial_option_premium?: InputMaybe<Int_Comparison_Exp>;
  is_card_payment_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  is_statements_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_statement_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lease_end_reason?: InputMaybe<String_Comparison_Exp>;
  minimum_monthly_option_premium?: InputMaybe<Numeric_Comparison_Exp>;
  move_out_date?: InputMaybe<Date_Comparison_Exp>;
  occupancy_date?: InputMaybe<Date_Comparison_Exp>;
  occupancy_status?: InputMaybe<String_Comparison_Exp>;
  option_premium?: InputMaybe<Numeric_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  renewal_months?: InputMaybe<Numeric_Comparison_Exp>;
  rent?: InputMaybe<Numeric_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_agreement_history_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  starts_at?: InputMaybe<Date_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_monthly_option_premium?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "rent_roll". */
export type Rent_Roll_Order_By = {
  aggregate_balance_after?: InputMaybe<Order_By>;
  aggregate_successful_balance_after?: InputMaybe<Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  auto_charge?: InputMaybe<Order_By>;
  cashout_deadline?: InputMaybe<Order_By>;
  chargeback_deadline?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_rental_application_id?: InputMaybe<Order_By>;
  display_line_1?: InputMaybe<Order_By>;
  display_line_2?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  final_liability_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  is_card_payment_allowed?: InputMaybe<Order_By>;
  is_statements_enabled?: InputMaybe<Order_By>;
  last_statement_sent_at?: InputMaybe<Order_By>;
  lease_end_reason?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  move_out_date?: InputMaybe<Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  occupancy_status?: InputMaybe<Order_By>;
  option_premium?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_agreement_history_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** select columns of table "rent_roll" */
export enum Rent_Roll_Select_Column {
  /** column name */
  AggregateBalanceAfter = 'aggregate_balance_after',
  /** column name */
  AggregateSuccessfulBalanceAfter = 'aggregate_successful_balance_after',
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  AutoCharge = 'auto_charge',
  /** column name */
  CashoutDeadline = 'cashout_deadline',
  /** column name */
  ChargebackDeadline = 'chargeback_deadline',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByRentalApplicationId = 'created_by_rental_application_id',
  /** column name */
  DisplayLine_1 = 'display_line_1',
  /** column name */
  DisplayLine_2 = 'display_line_2',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  FinalLiabilityDate = 'final_liability_date',
  /** column name */
  Id = 'id',
  /** column name */
  InitialLeaseTerm = 'initial_lease_term',
  /** column name */
  InitialOptionPremium = 'initial_option_premium',
  /** column name */
  IsCardPaymentAllowed = 'is_card_payment_allowed',
  /** column name */
  IsStatementsEnabled = 'is_statements_enabled',
  /** column name */
  LastStatementSentAt = 'last_statement_sent_at',
  /** column name */
  LeaseEndReason = 'lease_end_reason',
  /** column name */
  MinimumMonthlyOptionPremium = 'minimum_monthly_option_premium',
  /** column name */
  MoveOutDate = 'move_out_date',
  /** column name */
  OccupancyDate = 'occupancy_date',
  /** column name */
  OccupancyStatus = 'occupancy_status',
  /** column name */
  OptionPremium = 'option_premium',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RenewalMonths = 'renewal_months',
  /** column name */
  Rent = 'rent',
  /** column name */
  RentalAgreementHistoryId = 'rental_agreement_history_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  TargetMonthlyOptionPremium = 'target_monthly_option_premium',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Zip = 'zip'
}

/** Streaming cursor of the table "rent_roll" */
export type Rent_Roll_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rent_Roll_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rent_Roll_Stream_Cursor_Value_Input = {
  aggregate_balance_after?: InputMaybe<Scalars['numeric']['input']>;
  aggregate_successful_balance_after?: InputMaybe<Scalars['numeric']['input']>;
  agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  auto_charge?: InputMaybe<Scalars['Boolean']['input']>;
  cashout_deadline?: InputMaybe<Scalars['Int']['input']>;
  chargeback_deadline?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  display_line_1?: InputMaybe<Scalars['String']['input']>;
  display_line_2?: InputMaybe<Scalars['String']['input']>;
  ends_at?: InputMaybe<Scalars['date']['input']>;
  final_liability_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_lease_term?: InputMaybe<Scalars['Int']['input']>;
  initial_option_premium?: InputMaybe<Scalars['Int']['input']>;
  is_card_payment_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  is_statements_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_statement_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_end_reason?: InputMaybe<Scalars['String']['input']>;
  minimum_monthly_option_premium?: InputMaybe<Scalars['numeric']['input']>;
  move_out_date?: InputMaybe<Scalars['date']['input']>;
  occupancy_date?: InputMaybe<Scalars['date']['input']>;
  occupancy_status?: InputMaybe<Scalars['String']['input']>;
  option_premium?: InputMaybe<Scalars['numeric']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  renewal_months?: InputMaybe<Scalars['numeric']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  rental_agreement_history_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  starts_at?: InputMaybe<Scalars['date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_monthly_option_premium?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "rental_add_ons" */
export type Rental_Add_Ons = {
  __typename: 'rental_add_ons';
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  liability_type: Liability_Types;
  price: Scalars['numeric']['output'];
  /** An object relationship */
  rental: Rentals;
  start_date: Scalars['date']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "rental_add_ons" */
export type Rental_Add_Ons_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Add_Ons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Add_Ons_Max_Order_By>;
  min?: InputMaybe<Rental_Add_Ons_Min_Order_By>;
  stddev?: InputMaybe<Rental_Add_Ons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Add_Ons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Add_Ons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Add_Ons_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Add_Ons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Add_Ons_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Add_Ons_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_add_ons". All fields are combined with a logical 'AND'. */
export type Rental_Add_Ons_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Add_Ons_Bool_Exp>>;
  _not?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Add_Ons_Bool_Exp>>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_add_ons" */
export enum Rental_Add_Ons_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalAddOnsPkey = 'rental_add_ons_pkey'
}

/** input type for incrementing numeric columns in table "rental_add_ons" */
export type Rental_Add_Ons_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "rental_add_ons" */
export type Rental_Add_Ons_Insert_Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by max() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Max_Order_By = {
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Min_Order_By = {
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_add_ons" */
export type Rental_Add_Ons_Mutation_Response = {
  __typename: 'rental_add_ons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Add_Ons>;
};

/** on_conflict condition type for table "rental_add_ons" */
export type Rental_Add_Ons_On_Conflict = {
  constraint: Rental_Add_Ons_Constraint;
  update_columns?: Array<Rental_Add_Ons_Update_Column>;
  where?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_add_ons". */
export type Rental_Add_Ons_Order_By = {
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  price?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_add_ons */
export type Rental_Add_Ons_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_add_ons" */
export enum Rental_Add_Ons_Select_Column {
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_add_ons" */
export type Rental_Add_Ons_Set_Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by stddev() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_add_ons" */
export type Rental_Add_Ons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Add_Ons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Add_Ons_Stream_Cursor_Value_Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** update columns of table "rental_add_ons" */
export enum Rental_Add_Ons_Update_Column {
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Price = 'price',
  /** column name */
  StartDate = 'start_date'
}

export type Rental_Add_Ons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Add_Ons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Add_Ons_Set_Input>;
  where: Rental_Add_Ons_Bool_Exp;
};

/** order by var_pop() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_add_ons" */
export type Rental_Add_Ons_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_agreement_histories" */
export type Rental_Agreement_Histories = {
  __typename: 'rental_agreement_histories';
  /** An object relationship */
  agreement?: Maybe<Agreements>;
  agreement_id?: Maybe<Scalars['uuid']['output']>;
  effective_terms_activated_at?: Maybe<Scalars['timestamptz']['output']>;
  effective_terms_activation_attempted_at?: Maybe<Scalars['timestamptz']['output']>;
  effective_terms_activation_error?: Maybe<Scalars['String']['output']>;
  ends_at: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  lease_variant?: Maybe<Lease_Variants_Enum_Enum>;
  option_premium: Scalars['numeric']['output'];
  renewal_months?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  renewals: Array<Renewals>;
  rent: Scalars['numeric']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  starts_at: Scalars['date']['output'];
  type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "rental_agreement_histories" */
export type Rental_Agreement_HistoriesRenewalsArgs = {
  distinct_on?: InputMaybe<Array<Renewals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Renewals_Order_By>>;
  where?: InputMaybe<Renewals_Bool_Exp>;
};

/** order by aggregate values of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Agreement_Histories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Agreement_Histories_Max_Order_By>;
  min?: InputMaybe<Rental_Agreement_Histories_Min_Order_By>;
  stddev?: InputMaybe<Rental_Agreement_Histories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Agreement_Histories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Agreement_Histories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Agreement_Histories_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Agreement_Histories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Agreement_Histories_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Agreement_Histories_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Avg_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_agreement_histories". All fields are combined with a logical 'AND'. */
export type Rental_Agreement_Histories_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Agreement_Histories_Bool_Exp>>;
  _not?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Agreement_Histories_Bool_Exp>>;
  agreement?: InputMaybe<Agreements_Bool_Exp>;
  agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  effective_terms_activated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_terms_activation_attempted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_terms_activation_error?: InputMaybe<String_Comparison_Exp>;
  ends_at?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum_Comparison_Exp>;
  option_premium?: InputMaybe<Numeric_Comparison_Exp>;
  renewal_months?: InputMaybe<Numeric_Comparison_Exp>;
  renewals?: InputMaybe<Renewals_Bool_Exp>;
  rent?: InputMaybe<Numeric_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  starts_at?: InputMaybe<Date_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_agreement_histories" */
export enum Rental_Agreement_Histories_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalPriceHistoriesPkey = 'rental_price_histories_pkey'
}

/** input type for inserting data into table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Insert_Input = {
  ends_at?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum>;
  option_premium?: InputMaybe<Scalars['numeric']['input']>;
  renewal_months?: InputMaybe<Scalars['numeric']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  starts_at?: InputMaybe<Scalars['date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Max_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  effective_terms_activated_at?: InputMaybe<Order_By>;
  effective_terms_activation_attempted_at?: InputMaybe<Order_By>;
  effective_terms_activation_error?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Min_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  effective_terms_activated_at?: InputMaybe<Order_By>;
  effective_terms_activation_attempted_at?: InputMaybe<Order_By>;
  effective_terms_activation_error?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Mutation_Response = {
  __typename: 'rental_agreement_histories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Agreement_Histories>;
};

/** on_conflict condition type for table "rental_agreement_histories" */
export type Rental_Agreement_Histories_On_Conflict = {
  constraint: Rental_Agreement_Histories_Constraint;
  update_columns?: Array<Rental_Agreement_Histories_Update_Column>;
  where?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_agreement_histories". */
export type Rental_Agreement_Histories_Order_By = {
  agreement?: InputMaybe<Agreements_Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  effective_terms_activated_at?: InputMaybe<Order_By>;
  effective_terms_activation_attempted_at?: InputMaybe<Order_By>;
  effective_terms_activation_error?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  lease_variant?: InputMaybe<Order_By>;
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  renewals_aggregate?: InputMaybe<Renewals_Aggregate_Order_By>;
  rent?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_agreement_histories */
export type Rental_Agreement_Histories_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_agreement_histories" */
export enum Rental_Agreement_Histories_Select_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  EffectiveTermsActivatedAt = 'effective_terms_activated_at',
  /** column name */
  EffectiveTermsActivationAttemptedAt = 'effective_terms_activation_attempted_at',
  /** column name */
  EffectiveTermsActivationError = 'effective_terms_activation_error',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LeaseVariant = 'lease_variant',
  /** column name */
  OptionPremium = 'option_premium',
  /** column name */
  RenewalMonths = 'renewal_months',
  /** column name */
  Rent = 'rent',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Set_Input = {
  ends_at?: InputMaybe<Scalars['date']['input']>;
};

/** order by stddev() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Stddev_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Stddev_Pop_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Stddev_Samp_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Agreement_Histories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Agreement_Histories_Stream_Cursor_Value_Input = {
  agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  effective_terms_activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  effective_terms_activation_attempted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  effective_terms_activation_error?: InputMaybe<Scalars['String']['input']>;
  ends_at?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum>;
  option_premium?: InputMaybe<Scalars['numeric']['input']>;
  renewal_months?: InputMaybe<Scalars['numeric']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  starts_at?: InputMaybe<Scalars['date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Sum_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** update columns of table "rental_agreement_histories" */
export enum Rental_Agreement_Histories_Update_Column {
  /** column name */
  EndsAt = 'ends_at'
}

export type Rental_Agreement_Histories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Agreement_Histories_Set_Input>;
  where: Rental_Agreement_Histories_Bool_Exp;
};

/** order by var_pop() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Var_Pop_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Var_Samp_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_agreement_histories" */
export type Rental_Agreement_Histories_Variance_Order_By = {
  option_premium?: InputMaybe<Order_By>;
  renewal_months?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_application_decisions" */
export type Rental_Application_Decisions = {
  __typename: 'rental_application_decisions';
  additional_income_needed_at_decision?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  admin: Admins;
  admin_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  decided_at?: Maybe<Scalars['timestamptz']['output']>;
  deposit_rent_multiple?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  is_approved?: Maybe<Scalars['Boolean']['output']>;
  is_employment_verified_at_decision: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  usable_income_at_decision?: Maybe<Scalars['numeric']['output']>;
  weighted_average_credit_score_at_decision?: Maybe<Scalars['numeric']['output']>;
};

/** order by aggregate values of table "rental_application_decisions" */
export type Rental_Application_Decisions_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Application_Decisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Application_Decisions_Max_Order_By>;
  min?: InputMaybe<Rental_Application_Decisions_Min_Order_By>;
  stddev?: InputMaybe<Rental_Application_Decisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Application_Decisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Application_Decisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Application_Decisions_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Application_Decisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Application_Decisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Application_Decisions_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Avg_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_application_decisions". All fields are combined with a logical 'AND'. */
export type Rental_Application_Decisions_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Decisions_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Decisions_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Decisions_Bool_Exp>>;
  additional_income_needed_at_decision?: InputMaybe<Numeric_Comparison_Exp>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  decided_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deposit_rent_multiple?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_employment_verified_at_decision?: InputMaybe<Boolean_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_income_at_decision?: InputMaybe<Numeric_Comparison_Exp>;
  weighted_average_credit_score_at_decision?: InputMaybe<Numeric_Comparison_Exp>;
};

/** order by max() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Max_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  decided_at?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Min_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  decided_at?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rental_application_decisions". */
export type Rental_Application_Decisions_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  admin?: InputMaybe<Admins_Order_By>;
  admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  decided_at?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  is_employment_verified_at_decision?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** select columns of table "rental_application_decisions" */
export enum Rental_Application_Decisions_Select_Column {
  /** column name */
  AdditionalIncomeNeededAtDecision = 'additional_income_needed_at_decision',
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DecidedAt = 'decided_at',
  /** column name */
  DepositRentMultiple = 'deposit_rent_multiple',
  /** column name */
  Id = 'id',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  IsEmploymentVerifiedAtDecision = 'is_employment_verified_at_decision',
  /** column name */
  Notes = 'notes',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableIncomeAtDecision = 'usable_income_at_decision',
  /** column name */
  WeightedAverageCreditScoreAtDecision = 'weighted_average_credit_score_at_decision'
}

/** order by stddev() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Stddev_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Stddev_Pop_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Stddev_Samp_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_application_decisions" */
export type Rental_Application_Decisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Decisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Decisions_Stream_Cursor_Value_Input = {
  additional_income_needed_at_decision?: InputMaybe<Scalars['numeric']['input']>;
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  decided_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deposit_rent_multiple?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  is_employment_verified_at_decision?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_income_at_decision?: InputMaybe<Scalars['numeric']['input']>;
  weighted_average_credit_score_at_decision?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Sum_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Var_Pop_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Var_Samp_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_application_decisions" */
export type Rental_Application_Decisions_Variance_Order_By = {
  additional_income_needed_at_decision?: InputMaybe<Order_By>;
  deposit_rent_multiple?: InputMaybe<Order_By>;
  usable_income_at_decision?: InputMaybe<Order_By>;
  weighted_average_credit_score_at_decision?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_application_fees" */
export type Rental_Application_Fees = {
  __typename: 'rental_application_fees';
  amount_paid: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  expected_amount: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  payment_date?: Maybe<Scalars['date']['output']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_intent_status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "rental_application_fees" */
export type Rental_Application_Fees_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Application_Fees_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Application_Fees_Max_Order_By>;
  min?: InputMaybe<Rental_Application_Fees_Min_Order_By>;
  stddev?: InputMaybe<Rental_Application_Fees_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Application_Fees_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Application_Fees_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Application_Fees_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Application_Fees_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Application_Fees_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Application_Fees_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Avg_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_application_fees". All fields are combined with a logical 'AND'. */
export type Rental_Application_Fees_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Fees_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Fees_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Fees_Bool_Exp>>;
  amount_paid?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expected_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_date?: InputMaybe<Date_Comparison_Exp>;
  stripe_payment_intent_id?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_intent_status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "rental_application_fees_config" */
export type Rental_Application_Fees_Config = {
  __typename: 'rental_application_fees_config';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  market_id: Scalars['uuid']['output'];
  primary_amount: Scalars['numeric']['output'];
  tenant_amount: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "rental_application_fees_config". All fields are combined with a logical 'AND'. */
export type Rental_Application_Fees_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Fees_Config_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Fees_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Fees_Config_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  primary_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tenant_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "rental_application_fees_config". */
export type Rental_Application_Fees_Config_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  primary_amount?: InputMaybe<Order_By>;
  tenant_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rental_application_fees_config" */
export enum Rental_Application_Fees_Config_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  PrimaryAmount = 'primary_amount',
  /** column name */
  TenantAmount = 'tenant_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "rental_application_fees_config" */
export type Rental_Application_Fees_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Fees_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Fees_Config_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  primary_amount?: InputMaybe<Scalars['numeric']['input']>;
  tenant_amount?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Max_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  stripe_payment_intent_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Min_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  stripe_payment_intent_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rental_application_fees". */
export type Rental_Application_Fees_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  stripe_payment_intent_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_application_fees" */
export enum Rental_Application_Fees_Select_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedAmount = 'expected_amount',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  StripePaymentIntentId = 'stripe_payment_intent_id',
  /** column name */
  StripePaymentIntentStatus = 'stripe_payment_intent_status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Stddev_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Stddev_Pop_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Stddev_Samp_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_application_fees" */
export type Rental_Application_Fees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Fees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Fees_Stream_Cursor_Value_Input = {
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expected_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['date']['input']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Sum_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Var_Pop_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Var_Samp_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_application_fees" */
export type Rental_Application_Fees_Variance_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  expected_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments = {
  __typename: 'rental_application_manager_admin_assignments';
  /** An object relationship */
  admin: Admins;
  admin_id: Scalars['uuid']['output'];
  admin_role: Rental_Application_Manager_Admin_Roles_Enum;
  /** An object relationship */
  admin_role_admin_role: Rental_Application_Manager_Admin_Roles;
  /** An object relationship */
  admin_searchable?: Maybe<Admin_Searchable>;
  /** An object relationship */
  assigned_by_admin?: Maybe<Admins>;
  assigned_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Max_Order_By>;
  min?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "rental_application_manager.admin_assignments". All fields are combined with a logical 'AND'. */
export type Rental_Application_Manager_Admin_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  admin_role?: InputMaybe<Rental_Application_Manager_Admin_Roles_Enum_Comparison_Exp>;
  admin_role_admin_role?: InputMaybe<Rental_Application_Manager_Admin_Roles_Bool_Exp>;
  admin_searchable?: InputMaybe<Admin_Searchable_Bool_Exp>;
  assigned_by_admin?: InputMaybe<Admins_Bool_Exp>;
  assigned_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_application_manager.admin_assignments" */
export enum Rental_Application_Manager_Admin_Assignments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdminAssignmentsPkey = 'admin_assignments_pkey',
  /** unique or primary key constraint on columns "admin_role", "rental_application_id" */
  RentalApplicationIdAdminRoleNotDeactivated = 'rental_application_id_admin_role_not_deactivated'
}

/** input type for inserting data into table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  admin_role?: InputMaybe<Rental_Application_Manager_Admin_Roles_Enum>;
  assigned_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  assigned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Max_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  assigned_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Min_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  assigned_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Mutation_Response = {
  __typename: 'rental_application_manager_admin_assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Application_Manager_Admin_Assignments>;
};

/** on_conflict condition type for table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_On_Conflict = {
  constraint: Rental_Application_Manager_Admin_Assignments_Constraint;
  update_columns?: Array<Rental_Application_Manager_Admin_Assignments_Update_Column>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_application_manager.admin_assignments". */
export type Rental_Application_Manager_Admin_Assignments_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  admin_id?: InputMaybe<Order_By>;
  admin_role?: InputMaybe<Order_By>;
  admin_role_admin_role?: InputMaybe<Rental_Application_Manager_Admin_Roles_Order_By>;
  admin_searchable?: InputMaybe<Admin_Searchable_Order_By>;
  assigned_by_admin?: InputMaybe<Admins_Order_By>;
  assigned_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_application_manager.admin_assignments */
export type Rental_Application_Manager_Admin_Assignments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_application_manager.admin_assignments" */
export enum Rental_Application_Manager_Admin_Assignments_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  AdminRole = 'admin_role',
  /** column name */
  AssignedByAdminId = 'assigned_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  RentalApplicationId = 'rental_application_id'
}

/** input type for updating data in table "rental_application_manager.admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Set_Input = {
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  admin_role?: InputMaybe<Rental_Application_Manager_Admin_Roles_Enum>;
  assigned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "rental_application_manager_admin_assignments" */
export type Rental_Application_Manager_Admin_Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Manager_Admin_Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Manager_Admin_Assignments_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars['uuid']['input']>;
  admin_role?: InputMaybe<Rental_Application_Manager_Admin_Roles_Enum>;
  assigned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "rental_application_manager.admin_assignments" */
export enum Rental_Application_Manager_Admin_Assignments_Update_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  AdminRole = 'admin_role',
  /** column name */
  AssignedByAdminId = 'assigned_by_admin_id',
  /** column name */
  DeactivatedAt = 'deactivated_at'
}

export type Rental_Application_Manager_Admin_Assignments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Set_Input>;
  where: Rental_Application_Manager_Admin_Assignments_Bool_Exp;
};

/** columns and relationships of "rental_application_manager.admin_roles" */
export type Rental_Application_Manager_Admin_Roles = {
  __typename: 'rental_application_manager_admin_roles';
  /** An array relationship */
  admin_assignments: Array<Rental_Application_Manager_Admin_Assignments>;
  admin_role: Scalars['String']['output'];
};


/** columns and relationships of "rental_application_manager.admin_roles" */
export type Rental_Application_Manager_Admin_RolesAdmin_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "rental_application_manager.admin_roles". All fields are combined with a logical 'AND'. */
export type Rental_Application_Manager_Admin_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Manager_Admin_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Bool_Exp>>;
  admin_assignments?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
  admin_role?: InputMaybe<String_Comparison_Exp>;
};

export enum Rental_Application_Manager_Admin_Roles_Enum {
  Agent = 'agent',
  Coordinator = 'coordinator'
}

/** Boolean expression to compare columns of type "rental_application_manager_admin_roles_enum". All fields are combined with logical 'AND'. */
export type Rental_Application_Manager_Admin_Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Rental_Application_Manager_Admin_Roles_Enum>;
  _in?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Rental_Application_Manager_Admin_Roles_Enum>;
  _nin?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Enum>>;
};

/** Ordering options when selecting data from "rental_application_manager.admin_roles". */
export type Rental_Application_Manager_Admin_Roles_Order_By = {
  admin_assignments_aggregate?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Aggregate_Order_By>;
  admin_role?: InputMaybe<Order_By>;
};

/** select columns of table "rental_application_manager.admin_roles" */
export enum Rental_Application_Manager_Admin_Roles_Select_Column {
  /** column name */
  AdminRole = 'admin_role'
}

/** Streaming cursor of the table "rental_application_manager_admin_roles" */
export type Rental_Application_Manager_Admin_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Manager_Admin_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Manager_Admin_Roles_Stream_Cursor_Value_Input = {
  admin_role?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations = {
  __typename: 'rental_application_manager_application_escalations';
  /** An object relationship */
  assigned_by_admin: Admins;
  assigned_by_admin_id: Scalars['uuid']['output'];
  /** An object relationship */
  assigned_to_admin: Admins;
  assigned_to_admin_id: Scalars['uuid']['output'];
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  canceled_by_admin?: Maybe<Admins>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  escalation_status: Rental_Application_Manager_Escalation_Statuses_Enum;
  /** An object relationship */
  escalation_status_escalation_status: Rental_Application_Manager_Escalation_Statuses;
  id: Scalars['uuid']['output'];
  reason: Scalars['String']['output'];
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
  resolution_note?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  resolved_by_admin?: Maybe<Admins>;
  resolved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Application_Manager_Application_Escalations_Max_Order_By>;
  min?: InputMaybe<Rental_Application_Manager_Application_Escalations_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "rental_application_manager.application_escalations". All fields are combined with a logical 'AND'. */
export type Rental_Application_Manager_Application_Escalations_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Bool_Exp>>;
  assigned_by_admin?: InputMaybe<Admins_Bool_Exp>;
  assigned_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_to_admin?: InputMaybe<Admins_Bool_Exp>;
  assigned_to_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin?: InputMaybe<Admins_Bool_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  escalation_status?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Enum_Comparison_Exp>;
  escalation_status_escalation_status?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  resolution_note?: InputMaybe<String_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resolved_by_admin?: InputMaybe<Admins_Bool_Exp>;
  resolved_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_application_manager.application_escalations" */
export enum Rental_Application_Manager_Application_Escalations_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationEscalationsPkey = 'application_escalations_pkey',
  /** unique or primary key constraint on columns "rental_application_id" */
  ApplicationEscalationsRentalApplicationId = 'application_escalations_rental_application_id'
}

/** input type for inserting data into table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Insert_Input = {
  assigned_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  assigned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  assigned_to_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  escalation_status?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  resolution_note?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolved_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  resolved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Max_Order_By = {
  assigned_by_admin_id?: InputMaybe<Order_By>;
  assigned_to_admin_id?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  resolution_note?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Min_Order_By = {
  assigned_by_admin_id?: InputMaybe<Order_By>;
  assigned_to_admin_id?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  resolution_note?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Mutation_Response = {
  __typename: 'rental_application_manager_application_escalations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Application_Manager_Application_Escalations>;
};

/** on_conflict condition type for table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_On_Conflict = {
  constraint: Rental_Application_Manager_Application_Escalations_Constraint;
  update_columns?: Array<Rental_Application_Manager_Application_Escalations_Update_Column>;
  where?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_application_manager.application_escalations". */
export type Rental_Application_Manager_Application_Escalations_Order_By = {
  assigned_by_admin?: InputMaybe<Admins_Order_By>;
  assigned_by_admin_id?: InputMaybe<Order_By>;
  assigned_to_admin?: InputMaybe<Admins_Order_By>;
  assigned_to_admin_id?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin?: InputMaybe<Admins_Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  escalation_status?: InputMaybe<Order_By>;
  escalation_status_escalation_status?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  resolution_note?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin?: InputMaybe<Admins_Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_application_manager.application_escalations */
export type Rental_Application_Manager_Application_Escalations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_application_manager.application_escalations" */
export enum Rental_Application_Manager_Application_Escalations_Select_Column {
  /** column name */
  AssignedByAdminId = 'assigned_by_admin_id',
  /** column name */
  AssignedToAdminId = 'assigned_to_admin_id',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EscalationStatus = 'escalation_status',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  ResolutionNote = 'resolution_note',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedByAdminId = 'resolved_by_admin_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_application_manager.application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Set_Input = {
  assigned_to_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  escalation_status?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Enum>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resolution_note?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "rental_application_manager_application_escalations" */
export type Rental_Application_Manager_Application_Escalations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Manager_Application_Escalations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Manager_Application_Escalations_Stream_Cursor_Value_Input = {
  assigned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  escalation_status?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  resolution_note?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "rental_application_manager.application_escalations" */
export enum Rental_Application_Manager_Application_Escalations_Update_Column {
  /** column name */
  AssignedToAdminId = 'assigned_to_admin_id',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  EscalationStatus = 'escalation_status',
  /** column name */
  Reason = 'reason',
  /** column name */
  ResolutionNote = 'resolution_note',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedByAdminId = 'resolved_by_admin_id'
}

export type Rental_Application_Manager_Application_Escalations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Application_Manager_Application_Escalations_Set_Input>;
  where: Rental_Application_Manager_Application_Escalations_Bool_Exp;
};

/** columns and relationships of "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes = {
  __typename: 'rental_application_manager_application_snoozes';
  created_at: Scalars['timestamp']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
  snooze_reason: Rental_Application_Manager_Snooze_Reasons_Enum;
  /** An object relationship */
  snooze_reason_snooze_reason: Rental_Application_Manager_Snooze_Reasons;
  /** An object relationship */
  snoozed_by_admin: Admins;
  snoozed_by_admin_id: Scalars['uuid']['output'];
  snoozed_until: Scalars['timestamptz']['output'];
};

/** aggregated selection of "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Aggregate = {
  __typename: 'rental_application_manager_application_snoozes_aggregate';
  aggregate?: Maybe<Rental_Application_Manager_Application_Snoozes_Aggregate_Fields>;
  nodes: Array<Rental_Application_Manager_Application_Snoozes>;
};

export type Rental_Application_Manager_Application_Snoozes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Aggregate_Bool_Exp_Count>;
};

export type Rental_Application_Manager_Application_Snoozes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Aggregate_Fields = {
  __typename: 'rental_application_manager_application_snoozes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Rental_Application_Manager_Application_Snoozes_Max_Fields>;
  min?: Maybe<Rental_Application_Manager_Application_Snoozes_Min_Fields>;
};


/** aggregate fields of "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Max_Order_By>;
  min?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "rental_application_manager.application_snoozes". All fields are combined with a logical 'AND'. */
export type Rental_Application_Manager_Application_Snoozes_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  snooze_reason?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Enum_Comparison_Exp>;
  snooze_reason_snooze_reason?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>;
  snoozed_by_admin?: InputMaybe<Admins_Bool_Exp>;
  snoozed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  snoozed_until?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_application_manager.application_snoozes" */
export enum Rental_Application_Manager_Application_Snoozes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationSnoozesPkey = 'application_snoozes_pkey'
}

/** input type for inserting data into table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_reason?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Enum>;
  snoozed_by_admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  snoozed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  snoozed_until?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Rental_Application_Manager_Application_Snoozes_Max_Fields = {
  __typename: 'rental_application_manager_application_snoozes_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rental_application_id?: Maybe<Scalars['uuid']['output']>;
  snoozed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  snoozed_until?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  snoozed_by_admin_id?: InputMaybe<Order_By>;
  snoozed_until?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rental_Application_Manager_Application_Snoozes_Min_Fields = {
  __typename: 'rental_application_manager_application_snoozes_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rental_application_id?: Maybe<Scalars['uuid']['output']>;
  snoozed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  snoozed_until?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  snoozed_by_admin_id?: InputMaybe<Order_By>;
  snoozed_until?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Mutation_Response = {
  __typename: 'rental_application_manager_application_snoozes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Application_Manager_Application_Snoozes>;
};

/** on_conflict condition type for table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_On_Conflict = {
  constraint: Rental_Application_Manager_Application_Snoozes_Constraint;
  update_columns?: Array<Rental_Application_Manager_Application_Snoozes_Update_Column>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_application_manager.application_snoozes". */
export type Rental_Application_Manager_Application_Snoozes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  snooze_reason?: InputMaybe<Order_By>;
  snooze_reason_snooze_reason?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Order_By>;
  snoozed_by_admin?: InputMaybe<Admins_Order_By>;
  snoozed_by_admin_id?: InputMaybe<Order_By>;
  snoozed_until?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_application_manager.application_snoozes */
export type Rental_Application_Manager_Application_Snoozes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_application_manager.application_snoozes" */
export enum Rental_Application_Manager_Application_Snoozes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  SnoozeReason = 'snooze_reason',
  /** column name */
  SnoozedByAdminId = 'snoozed_by_admin_id',
  /** column name */
  SnoozedUntil = 'snoozed_until'
}

/** input type for updating data in table "rental_application_manager.application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  snooze_reason?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Enum>;
  snoozed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  snoozed_until?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "rental_application_manager_application_snoozes" */
export type Rental_Application_Manager_Application_Snoozes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Manager_Application_Snoozes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Manager_Application_Snoozes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_reason?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Enum>;
  snoozed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  snoozed_until?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "rental_application_manager.application_snoozes" */
export enum Rental_Application_Manager_Application_Snoozes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  SnoozeReason = 'snooze_reason',
  /** column name */
  SnoozedByAdminId = 'snoozed_by_admin_id',
  /** column name */
  SnoozedUntil = 'snoozed_until'
}

export type Rental_Application_Manager_Application_Snoozes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Set_Input>;
  where: Rental_Application_Manager_Application_Snoozes_Bool_Exp;
};

/** columns and relationships of "rental_application_manager.escalation_statuses" */
export type Rental_Application_Manager_Escalation_Statuses = {
  __typename: 'rental_application_manager_escalation_statuses';
  /** An array relationship */
  application_escalations: Array<Rental_Application_Manager_Application_Escalations>;
  escalation_status: Scalars['String']['output'];
};


/** columns and relationships of "rental_application_manager.escalation_statuses" */
export type Rental_Application_Manager_Escalation_StatusesApplication_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "rental_application_manager.escalation_statuses". All fields are combined with a logical 'AND'. */
export type Rental_Application_Manager_Escalation_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>>;
  application_escalations?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
  escalation_status?: InputMaybe<String_Comparison_Exp>;
};

export enum Rental_Application_Manager_Escalation_Statuses_Enum {
  Canceled = 'canceled',
  Pending = 'pending',
  Resolved = 'resolved'
}

/** Boolean expression to compare columns of type "rental_application_manager_escalation_statuses_enum". All fields are combined with logical 'AND'. */
export type Rental_Application_Manager_Escalation_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Enum>;
  _in?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Enum>;
  _nin?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Enum>>;
};

/** Ordering options when selecting data from "rental_application_manager.escalation_statuses". */
export type Rental_Application_Manager_Escalation_Statuses_Order_By = {
  application_escalations_aggregate?: InputMaybe<Rental_Application_Manager_Application_Escalations_Aggregate_Order_By>;
  escalation_status?: InputMaybe<Order_By>;
};

/** select columns of table "rental_application_manager.escalation_statuses" */
export enum Rental_Application_Manager_Escalation_Statuses_Select_Column {
  /** column name */
  EscalationStatus = 'escalation_status'
}

/** Streaming cursor of the table "rental_application_manager_escalation_statuses" */
export type Rental_Application_Manager_Escalation_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Manager_Escalation_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Manager_Escalation_Statuses_Stream_Cursor_Value_Input = {
  escalation_status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "rental_application_manager.snooze_reasons" */
export type Rental_Application_Manager_Snooze_Reasons = {
  __typename: 'rental_application_manager_snooze_reasons';
  /** An array relationship */
  application_snoozes: Array<Rental_Application_Manager_Application_Snoozes>;
  /** An aggregate relationship */
  application_snoozes_aggregate: Rental_Application_Manager_Application_Snoozes_Aggregate;
  snooze_reason: Scalars['String']['output'];
};


/** columns and relationships of "rental_application_manager.snooze_reasons" */
export type Rental_Application_Manager_Snooze_ReasonsApplication_SnoozesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


/** columns and relationships of "rental_application_manager.snooze_reasons" */
export type Rental_Application_Manager_Snooze_ReasonsApplication_Snoozes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "rental_application_manager.snooze_reasons". All fields are combined with a logical 'AND'. */
export type Rental_Application_Manager_Snooze_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>>;
  application_snoozes?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
  application_snoozes_aggregate?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Aggregate_Bool_Exp>;
  snooze_reason?: InputMaybe<String_Comparison_Exp>;
};

export enum Rental_Application_Manager_Snooze_Reasons_Enum {
  AccountLinkingIssue = 'account_linking_issue',
  AwaitingCustomerResponse = 'awaiting_customer_response',
  AwaitingDocument = 'awaiting_document',
  DepositPaymentIssue = 'deposit_payment_issue'
}

/** Boolean expression to compare columns of type "rental_application_manager_snooze_reasons_enum". All fields are combined with logical 'AND'. */
export type Rental_Application_Manager_Snooze_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Enum>;
  _in?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Enum>;
  _nin?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Enum>>;
};

/** Ordering options when selecting data from "rental_application_manager.snooze_reasons". */
export type Rental_Application_Manager_Snooze_Reasons_Order_By = {
  application_snoozes_aggregate?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Aggregate_Order_By>;
  snooze_reason?: InputMaybe<Order_By>;
};

/** select columns of table "rental_application_manager.snooze_reasons" */
export enum Rental_Application_Manager_Snooze_Reasons_Select_Column {
  /** column name */
  SnoozeReason = 'snooze_reason'
}

/** Streaming cursor of the table "rental_application_manager_snooze_reasons" */
export type Rental_Application_Manager_Snooze_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Manager_Snooze_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Manager_Snooze_Reasons_Stream_Cursor_Value_Input = {
  snooze_reason?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "rental_application_occupants" */
export type Rental_Application_Occupants = {
  __typename: 'rental_application_occupants';
  age: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  relation: Scalars['String']['output'];
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "rental_application_occupants" */
export type Rental_Application_Occupants_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Application_Occupants_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Application_Occupants_Max_Order_By>;
  min?: InputMaybe<Rental_Application_Occupants_Min_Order_By>;
  stddev?: InputMaybe<Rental_Application_Occupants_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Application_Occupants_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Application_Occupants_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Application_Occupants_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Application_Occupants_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Application_Occupants_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Application_Occupants_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Avg_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_application_occupants". All fields are combined with a logical 'AND'. */
export type Rental_Application_Occupants_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Occupants_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Occupants_Bool_Exp>>;
  age?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  relation?: InputMaybe<String_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_application_occupants" */
export enum Rental_Application_Occupants_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalApplicationOccupantsPkey = 'rental_application_occupants_pkey'
}

/** input type for incrementing numeric columns in table "rental_application_occupants" */
export type Rental_Application_Occupants_Inc_Input = {
  age?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rental_application_occupants" */
export type Rental_Application_Occupants_Insert_Input = {
  age?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Max_Order_By = {
  age?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  relation?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Min_Order_By = {
  age?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  relation?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_application_occupants" */
export type Rental_Application_Occupants_Mutation_Response = {
  __typename: 'rental_application_occupants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Application_Occupants>;
};

/** on_conflict condition type for table "rental_application_occupants" */
export type Rental_Application_Occupants_On_Conflict = {
  constraint: Rental_Application_Occupants_Constraint;
  update_columns?: Array<Rental_Application_Occupants_Update_Column>;
  where?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_application_occupants". */
export type Rental_Application_Occupants_Order_By = {
  age?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  relation?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_application_occupants */
export type Rental_Application_Occupants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_application_occupants" */
export enum Rental_Application_Occupants_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Relation = 'relation',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_application_occupants" */
export type Rental_Application_Occupants_Set_Input = {
  age?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Stddev_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Stddev_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Stddev_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_application_occupants" */
export type Rental_Application_Occupants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Occupants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Occupants_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Sum_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** update columns of table "rental_application_occupants" */
export enum Rental_Application_Occupants_Update_Column {
  /** column name */
  Age = 'age',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Relation = 'relation',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Rental_Application_Occupants_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Application_Occupants_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Application_Occupants_Set_Input>;
  where: Rental_Application_Occupants_Bool_Exp;
};

/** order by var_pop() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Var_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Var_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_application_occupants" */
export type Rental_Application_Occupants_Variance_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_application_pets" */
export type Rental_Application_Pets = {
  __typename: 'rental_application_pets';
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  weight_in_pounds: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "rental_application_pets". All fields are combined with a logical 'AND'. */
export type Rental_Application_Pets_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Pets_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Pets_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Pets_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight_in_pounds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_application_pets" */
export enum Rental_Application_Pets_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalApplicationPetsPkey = 'rental_application_pets_pkey'
}

/** input type for incrementing numeric columns in table "rental_application_pets" */
export type Rental_Application_Pets_Inc_Input = {
  weight_in_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rental_application_pets" */
export type Rental_Application_Pets_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_in_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "rental_application_pets" */
export type Rental_Application_Pets_Mutation_Response = {
  __typename: 'rental_application_pets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Application_Pets>;
};

/** on_conflict condition type for table "rental_application_pets" */
export type Rental_Application_Pets_On_Conflict = {
  constraint: Rental_Application_Pets_Constraint;
  update_columns?: Array<Rental_Application_Pets_Update_Column>;
  where?: InputMaybe<Rental_Application_Pets_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_application_pets". */
export type Rental_Application_Pets_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_in_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_application_pets */
export type Rental_Application_Pets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_application_pets" */
export enum Rental_Application_Pets_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightInPounds = 'weight_in_pounds'
}

/** input type for updating data in table "rental_application_pets" */
export type Rental_Application_Pets_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_in_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** Streaming cursor of the table "rental_application_pets" */
export type Rental_Application_Pets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Pets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Pets_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_in_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "rental_application_pets" */
export enum Rental_Application_Pets_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightInPounds = 'weight_in_pounds'
}

export type Rental_Application_Pets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Application_Pets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Application_Pets_Set_Input>;
  where: Rental_Application_Pets_Bool_Exp;
};

/** columns and relationships of "rental_application_vehicles" */
export type Rental_Application_Vehicles = {
  __typename: 'rental_application_vehicles';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  license_plate: Scalars['String']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  /** An object relationship */
  rental_application: Rental_Applications;
  rental_application_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  year: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "rental_application_vehicles". All fields are combined with a logical 'AND'. */
export type Rental_Application_Vehicles_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Application_Vehicles_Bool_Exp>>;
  _not?: InputMaybe<Rental_Application_Vehicles_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Application_Vehicles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  license_plate?: InputMaybe<String_Comparison_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_application_vehicles" */
export enum Rental_Application_Vehicles_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalApplicationVehiclesPkey = 'rental_application_vehicles_pkey'
}

/** input type for incrementing numeric columns in table "rental_application_vehicles" */
export type Rental_Application_Vehicles_Inc_Input = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rental_application_vehicles" */
export type Rental_Application_Vehicles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "rental_application_vehicles" */
export type Rental_Application_Vehicles_Mutation_Response = {
  __typename: 'rental_application_vehicles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Application_Vehicles>;
};

/** on_conflict condition type for table "rental_application_vehicles" */
export type Rental_Application_Vehicles_On_Conflict = {
  constraint: Rental_Application_Vehicles_Constraint;
  update_columns?: Array<Rental_Application_Vehicles_Update_Column>;
  where?: InputMaybe<Rental_Application_Vehicles_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_application_vehicles". */
export type Rental_Application_Vehicles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_application_vehicles */
export type Rental_Application_Vehicles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_application_vehicles" */
export enum Rental_Application_Vehicles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "rental_application_vehicles" */
export type Rental_Application_Vehicles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Streaming cursor of the table "rental_application_vehicles" */
export type Rental_Application_Vehicles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Application_Vehicles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Application_Vehicles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "rental_application_vehicles" */
export enum Rental_Application_Vehicles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

export type Rental_Application_Vehicles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Application_Vehicles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Application_Vehicles_Set_Input>;
  where: Rental_Application_Vehicles_Bool_Exp;
};

/** columns and relationships of "rental_applications" */
export type Rental_Applications = {
  __typename: 'rental_applications';
  additional_lease_information_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  admin_assignments: Array<Rental_Application_Manager_Admin_Assignments>;
  /** An array relationship */
  agreements: Array<Agreements>;
  /** An array relationship */
  application_escalations: Array<Rental_Application_Manager_Application_Escalations>;
  /** An array relationship */
  application_snoozes: Array<Rental_Application_Manager_Application_Snoozes>;
  /** An aggregate relationship */
  application_snoozes_aggregate: Rental_Application_Manager_Application_Snoozes_Aggregate;
  auto_reminders_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  auto_reminders_disabled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  cancelation_subreason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  credit_card_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  credit_card_enabled_by_admin?: Maybe<Admins>;
  credit_card_enabled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  credit_card_initial_deposit_fee_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_move_in_payment_fee_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  guarantor_bond_id?: Maybe<Scalars['String']['output']>;
  hold_application_at?: Maybe<Scalars['timestamptz']['output']>;
  ic_escalated_admin_id?: Maybe<Scalars['uuid']['output']>;
  ic_escalated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_review_approved?: Maybe<Scalars['Boolean']['output']>;
  is_underwriting_approved?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  lead_group: Lead_Groups;
  lead_group_id: Scalars['uuid']['output'];
  lease_variant: Lease_Variants_Enum_Enum;
  /** An object relationship */
  mls_listing: Mls_Listings;
  mls_listing_id: Scalars['uuid']['output'];
  /** An array relationship */
  move_ins: Array<Move_Ins>;
  occupants_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  pets_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  preapproved_at?: Maybe<Scalars['timestamptz']['output']>;
  preapproved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  priority_score: Scalars['Int']['output'];
  projected_occupancy_date?: Maybe<Scalars['date']['output']>;
  received_initial_product_pitch_at?: Maybe<Scalars['timestamptz']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  rental_application_decisions: Array<Rental_Application_Decisions>;
  /** An array relationship */
  rental_application_occupants: Array<Rental_Application_Occupants>;
  rental_program_type_applied_for: Rental_Program_Types_Enum_Enum;
  /** An array relationship */
  rentals: Array<Rentals>;
  required_coapplicant_at?: Maybe<Scalars['timestamptz']['output']>;
  required_cosigner_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  status_metadata: Scalars['jsonb']['output'];
  underwriter_requested_documents_at?: Maybe<Scalars['timestamptz']['output']>;
  underwriter_requested_income_edits_at?: Maybe<Scalars['timestamptz']['output']>;
  underwriting_methodology: Scalars['String']['output'];
  underwritten_at?: Maybe<Scalars['timestamptz']['output']>;
  underwritten_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  vehicles_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsAdmin_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsAgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsApplication_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsApplication_SnoozesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsApplication_Snoozes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsMove_InsArgs = {
  distinct_on?: InputMaybe<Array<Move_Ins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Move_Ins_Order_By>>;
  where?: InputMaybe<Move_Ins_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsRental_Application_DecisionsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Decisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Decisions_Order_By>>;
  where?: InputMaybe<Rental_Application_Decisions_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsRental_Application_OccupantsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Occupants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Occupants_Order_By>>;
  where?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsRentalsArgs = {
  distinct_on?: InputMaybe<Array<Rentals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rentals_Order_By>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


/** columns and relationships of "rental_applications" */
export type Rental_ApplicationsStatus_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "rental_applications" */
export type Rental_Applications_Aggregate = {
  __typename: 'rental_applications_aggregate';
  aggregate?: Maybe<Rental_Applications_Aggregate_Fields>;
  nodes: Array<Rental_Applications>;
};

export type Rental_Applications_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Rental_Applications_Aggregate_Bool_Exp_Count>;
};

export type Rental_Applications_Aggregate_Bool_Exp_Bool_And = {
  arguments: Rental_Applications_Select_Column_Rental_Applications_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rental_Applications_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rental_Applications_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Rental_Applications_Select_Column_Rental_Applications_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rental_Applications_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rental_Applications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rental_Applications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rental_applications" */
export type Rental_Applications_Aggregate_Fields = {
  __typename: 'rental_applications_aggregate_fields';
  avg?: Maybe<Rental_Applications_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rental_Applications_Max_Fields>;
  min?: Maybe<Rental_Applications_Min_Fields>;
  stddev?: Maybe<Rental_Applications_Stddev_Fields>;
  stddev_pop?: Maybe<Rental_Applications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rental_Applications_Stddev_Samp_Fields>;
  sum?: Maybe<Rental_Applications_Sum_Fields>;
  var_pop?: Maybe<Rental_Applications_Var_Pop_Fields>;
  var_samp?: Maybe<Rental_Applications_Var_Samp_Fields>;
  variance?: Maybe<Rental_Applications_Variance_Fields>;
};


/** aggregate fields of "rental_applications" */
export type Rental_Applications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rental_applications" */
export type Rental_Applications_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Applications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Applications_Max_Order_By>;
  min?: InputMaybe<Rental_Applications_Min_Order_By>;
  stddev?: InputMaybe<Rental_Applications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Applications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Applications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Applications_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Applications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Applications_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Applications_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Rental_Applications_Avg_Fields = {
  __typename: 'rental_applications_avg_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rental_applications" */
export type Rental_Applications_Avg_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_applications". All fields are combined with a logical 'AND'. */
export type Rental_Applications_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Applications_Bool_Exp>>;
  _not?: InputMaybe<Rental_Applications_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Applications_Bool_Exp>>;
  additional_lease_information_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  admin_assignments?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
  agreements?: InputMaybe<Agreements_Bool_Exp>;
  application_escalations?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
  application_snoozes?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
  application_snoozes_aggregate?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Aggregate_Bool_Exp>;
  auto_reminders_disabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  cancelation_subreason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_card_enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_card_enabled_by_admin?: InputMaybe<Admins_Bool_Exp>;
  credit_card_enabled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  credit_card_initial_deposit_fee_disabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_card_move_in_payment_fee_disabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  guarantor_bond_id?: InputMaybe<String_Comparison_Exp>;
  hold_application_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ic_escalated_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  ic_escalated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_review_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_underwriting_approved?: InputMaybe<Boolean_Comparison_Exp>;
  lead_group?: InputMaybe<Lead_Groups_Bool_Exp>;
  lead_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  move_ins?: InputMaybe<Move_Ins_Bool_Exp>;
  occupants_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  pets_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  preapproved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  preapproved_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  priority_score?: InputMaybe<Int_Comparison_Exp>;
  projected_occupancy_date?: InputMaybe<Date_Comparison_Exp>;
  received_initial_product_pitch_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  rent?: InputMaybe<Numeric_Comparison_Exp>;
  rental_application_decisions?: InputMaybe<Rental_Application_Decisions_Bool_Exp>;
  rental_application_occupants?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
  rental_program_type_applied_for?: InputMaybe<Rental_Program_Types_Enum_Enum_Comparison_Exp>;
  rentals?: InputMaybe<Rentals_Bool_Exp>;
  required_coapplicant_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  required_cosigner_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  underwriter_requested_documents_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  underwriter_requested_income_edits_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  underwriting_methodology?: InputMaybe<String_Comparison_Exp>;
  underwritten_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  underwritten_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicles_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "rental_applications" */
export type Rental_Applications_Inc_Input = {
  priority_score?: InputMaybe<Scalars['Int']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Rental_Applications_Max_Fields = {
  __typename: 'rental_applications_max_fields';
  additional_lease_information_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  auto_reminders_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  auto_reminders_disabled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  cancelation_subreason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_enabled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  credit_card_initial_deposit_fee_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_move_in_payment_fee_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  guarantor_bond_id?: Maybe<Scalars['String']['output']>;
  hold_application_at?: Maybe<Scalars['timestamptz']['output']>;
  ic_escalated_admin_id?: Maybe<Scalars['uuid']['output']>;
  ic_escalated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_group_id?: Maybe<Scalars['uuid']['output']>;
  mls_listing_id?: Maybe<Scalars['uuid']['output']>;
  occupants_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  pets_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  preapproved_at?: Maybe<Scalars['timestamptz']['output']>;
  preapproved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  priority_score?: Maybe<Scalars['Int']['output']>;
  projected_occupancy_date?: Maybe<Scalars['date']['output']>;
  received_initial_product_pitch_at?: Maybe<Scalars['timestamptz']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
  required_coapplicant_at?: Maybe<Scalars['timestamptz']['output']>;
  required_cosigner_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  underwriter_requested_documents_at?: Maybe<Scalars['timestamptz']['output']>;
  underwriter_requested_income_edits_at?: Maybe<Scalars['timestamptz']['output']>;
  underwriting_methodology?: Maybe<Scalars['String']['output']>;
  underwritten_at?: Maybe<Scalars['timestamptz']['output']>;
  underwritten_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicles_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "rental_applications" */
export type Rental_Applications_Max_Order_By = {
  additional_lease_information_completed_at?: InputMaybe<Order_By>;
  auto_reminders_disabled_at?: InputMaybe<Order_By>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  cancelation_subreason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_enabled_at?: InputMaybe<Order_By>;
  credit_card_enabled_by_admin_id?: InputMaybe<Order_By>;
  credit_card_initial_deposit_fee_disabled_at?: InputMaybe<Order_By>;
  credit_card_move_in_payment_fee_disabled_at?: InputMaybe<Order_By>;
  guarantor_bond_id?: InputMaybe<Order_By>;
  hold_application_at?: InputMaybe<Order_By>;
  ic_escalated_admin_id?: InputMaybe<Order_By>;
  ic_escalated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  occupants_submitted_at?: InputMaybe<Order_By>;
  pets_submitted_at?: InputMaybe<Order_By>;
  preapproved_at?: InputMaybe<Order_By>;
  preapproved_by_admin_id?: InputMaybe<Order_By>;
  priority_score?: InputMaybe<Order_By>;
  projected_occupancy_date?: InputMaybe<Order_By>;
  received_initial_product_pitch_at?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  required_coapplicant_at?: InputMaybe<Order_By>;
  required_cosigner_at?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  underwriter_requested_documents_at?: InputMaybe<Order_By>;
  underwriter_requested_income_edits_at?: InputMaybe<Order_By>;
  underwriting_methodology?: InputMaybe<Order_By>;
  underwritten_at?: InputMaybe<Order_By>;
  underwritten_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicles_submitted_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rental_Applications_Min_Fields = {
  __typename: 'rental_applications_min_fields';
  additional_lease_information_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  auto_reminders_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  auto_reminders_disabled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  cancelation_subreason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_enabled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  credit_card_initial_deposit_fee_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_card_move_in_payment_fee_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  guarantor_bond_id?: Maybe<Scalars['String']['output']>;
  hold_application_at?: Maybe<Scalars['timestamptz']['output']>;
  ic_escalated_admin_id?: Maybe<Scalars['uuid']['output']>;
  ic_escalated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_group_id?: Maybe<Scalars['uuid']['output']>;
  mls_listing_id?: Maybe<Scalars['uuid']['output']>;
  occupants_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  pets_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  preapproved_at?: Maybe<Scalars['timestamptz']['output']>;
  preapproved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  priority_score?: Maybe<Scalars['Int']['output']>;
  projected_occupancy_date?: Maybe<Scalars['date']['output']>;
  received_initial_product_pitch_at?: Maybe<Scalars['timestamptz']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
  required_coapplicant_at?: Maybe<Scalars['timestamptz']['output']>;
  required_cosigner_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  underwriter_requested_documents_at?: Maybe<Scalars['timestamptz']['output']>;
  underwriter_requested_income_edits_at?: Maybe<Scalars['timestamptz']['output']>;
  underwriting_methodology?: Maybe<Scalars['String']['output']>;
  underwritten_at?: Maybe<Scalars['timestamptz']['output']>;
  underwritten_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicles_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "rental_applications" */
export type Rental_Applications_Min_Order_By = {
  additional_lease_information_completed_at?: InputMaybe<Order_By>;
  auto_reminders_disabled_at?: InputMaybe<Order_By>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  cancelation_subreason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_enabled_at?: InputMaybe<Order_By>;
  credit_card_enabled_by_admin_id?: InputMaybe<Order_By>;
  credit_card_initial_deposit_fee_disabled_at?: InputMaybe<Order_By>;
  credit_card_move_in_payment_fee_disabled_at?: InputMaybe<Order_By>;
  guarantor_bond_id?: InputMaybe<Order_By>;
  hold_application_at?: InputMaybe<Order_By>;
  ic_escalated_admin_id?: InputMaybe<Order_By>;
  ic_escalated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  occupants_submitted_at?: InputMaybe<Order_By>;
  pets_submitted_at?: InputMaybe<Order_By>;
  preapproved_at?: InputMaybe<Order_By>;
  preapproved_by_admin_id?: InputMaybe<Order_By>;
  priority_score?: InputMaybe<Order_By>;
  projected_occupancy_date?: InputMaybe<Order_By>;
  received_initial_product_pitch_at?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  required_coapplicant_at?: InputMaybe<Order_By>;
  required_cosigner_at?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  underwriter_requested_documents_at?: InputMaybe<Order_By>;
  underwriter_requested_income_edits_at?: InputMaybe<Order_By>;
  underwriting_methodology?: InputMaybe<Order_By>;
  underwritten_at?: InputMaybe<Order_By>;
  underwritten_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicles_submitted_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_applications" */
export type Rental_Applications_Mutation_Response = {
  __typename: 'rental_applications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Applications>;
};

/** Ordering options when selecting data from "rental_applications". */
export type Rental_Applications_Order_By = {
  additional_lease_information_completed_at?: InputMaybe<Order_By>;
  admin_assignments_aggregate?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Aggregate_Order_By>;
  agreements_aggregate?: InputMaybe<Agreements_Aggregate_Order_By>;
  application_escalations_aggregate?: InputMaybe<Rental_Application_Manager_Application_Escalations_Aggregate_Order_By>;
  application_snoozes_aggregate?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Aggregate_Order_By>;
  auto_reminders_disabled_at?: InputMaybe<Order_By>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  cancelation_subreason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_enabled_at?: InputMaybe<Order_By>;
  credit_card_enabled_by_admin?: InputMaybe<Admins_Order_By>;
  credit_card_enabled_by_admin_id?: InputMaybe<Order_By>;
  credit_card_initial_deposit_fee_disabled_at?: InputMaybe<Order_By>;
  credit_card_move_in_payment_fee_disabled_at?: InputMaybe<Order_By>;
  guarantor_bond_id?: InputMaybe<Order_By>;
  hold_application_at?: InputMaybe<Order_By>;
  ic_escalated_admin_id?: InputMaybe<Order_By>;
  ic_escalated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_review_approved?: InputMaybe<Order_By>;
  is_underwriting_approved?: InputMaybe<Order_By>;
  lead_group?: InputMaybe<Lead_Groups_Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  lease_variant?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  move_ins_aggregate?: InputMaybe<Move_Ins_Aggregate_Order_By>;
  occupants_submitted_at?: InputMaybe<Order_By>;
  pets_submitted_at?: InputMaybe<Order_By>;
  preapproved_at?: InputMaybe<Order_By>;
  preapproved_by_admin_id?: InputMaybe<Order_By>;
  priority_score?: InputMaybe<Order_By>;
  projected_occupancy_date?: InputMaybe<Order_By>;
  received_initial_product_pitch_at?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental_application_decisions_aggregate?: InputMaybe<Rental_Application_Decisions_Aggregate_Order_By>;
  rental_application_occupants_aggregate?: InputMaybe<Rental_Application_Occupants_Aggregate_Order_By>;
  rental_program_type_applied_for?: InputMaybe<Order_By>;
  rentals_aggregate?: InputMaybe<Rentals_Aggregate_Order_By>;
  required_coapplicant_at?: InputMaybe<Order_By>;
  required_cosigner_at?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_metadata?: InputMaybe<Order_By>;
  underwriter_requested_documents_at?: InputMaybe<Order_By>;
  underwriter_requested_income_edits_at?: InputMaybe<Order_By>;
  underwriting_methodology?: InputMaybe<Order_By>;
  underwritten_at?: InputMaybe<Order_By>;
  underwritten_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicles_submitted_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_applications */
export type Rental_Applications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_applications" */
export enum Rental_Applications_Select_Column {
  /** column name */
  AdditionalLeaseInformationCompletedAt = 'additional_lease_information_completed_at',
  /** column name */
  AutoRemindersDisabledAt = 'auto_reminders_disabled_at',
  /** column name */
  AutoRemindersDisabledByAdminId = 'auto_reminders_disabled_by_admin_id',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CancelationSubreason = 'cancelation_subreason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditCardEnabledAt = 'credit_card_enabled_at',
  /** column name */
  CreditCardEnabledByAdminId = 'credit_card_enabled_by_admin_id',
  /** column name */
  CreditCardInitialDepositFeeDisabledAt = 'credit_card_initial_deposit_fee_disabled_at',
  /** column name */
  CreditCardMoveInPaymentFeeDisabledAt = 'credit_card_move_in_payment_fee_disabled_at',
  /** column name */
  GuarantorBondId = 'guarantor_bond_id',
  /** column name */
  HoldApplicationAt = 'hold_application_at',
  /** column name */
  IcEscalatedAdminId = 'ic_escalated_admin_id',
  /** column name */
  IcEscalatedAt = 'ic_escalated_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsReviewApproved = 'is_review_approved',
  /** column name */
  IsUnderwritingApproved = 'is_underwriting_approved',
  /** column name */
  LeadGroupId = 'lead_group_id',
  /** column name */
  LeaseVariant = 'lease_variant',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  OccupantsSubmittedAt = 'occupants_submitted_at',
  /** column name */
  PetsSubmittedAt = 'pets_submitted_at',
  /** column name */
  PreapprovedAt = 'preapproved_at',
  /** column name */
  PreapprovedByAdminId = 'preapproved_by_admin_id',
  /** column name */
  PriorityScore = 'priority_score',
  /** column name */
  ProjectedOccupancyDate = 'projected_occupancy_date',
  /** column name */
  ReceivedInitialProductPitchAt = 'received_initial_product_pitch_at',
  /** column name */
  Rent = 'rent',
  /** column name */
  RentalProgramTypeAppliedFor = 'rental_program_type_applied_for',
  /** column name */
  RequiredCoapplicantAt = 'required_coapplicant_at',
  /** column name */
  RequiredCosignerAt = 'required_cosigner_at',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusMetadata = 'status_metadata',
  /** column name */
  UnderwriterRequestedDocumentsAt = 'underwriter_requested_documents_at',
  /** column name */
  UnderwriterRequestedIncomeEditsAt = 'underwriter_requested_income_edits_at',
  /** column name */
  UnderwritingMethodology = 'underwriting_methodology',
  /** column name */
  UnderwrittenAt = 'underwritten_at',
  /** column name */
  UnderwrittenByAdminId = 'underwritten_by_admin_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehiclesSubmittedAt = 'vehicles_submitted_at'
}

/** select "rental_applications_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rental_applications" */
export enum Rental_Applications_Select_Column_Rental_Applications_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsReviewApproved = 'is_review_approved',
  /** column name */
  IsUnderwritingApproved = 'is_underwriting_approved'
}

/** select "rental_applications_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rental_applications" */
export enum Rental_Applications_Select_Column_Rental_Applications_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsReviewApproved = 'is_review_approved',
  /** column name */
  IsUnderwritingApproved = 'is_underwriting_approved'
}

/** input type for updating data in table "rental_applications" */
export type Rental_Applications_Set_Input = {
  auto_reminders_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  credit_card_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_card_enabled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  credit_card_initial_deposit_fee_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_card_move_in_payment_fee_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  priority_score?: InputMaybe<Scalars['Int']['input']>;
  received_initial_product_pitch_at?: InputMaybe<Scalars['timestamptz']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Rental_Applications_Stddev_Fields = {
  __typename: 'rental_applications_stddev_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rental_applications" */
export type Rental_Applications_Stddev_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rental_Applications_Stddev_Pop_Fields = {
  __typename: 'rental_applications_stddev_pop_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rental_applications" */
export type Rental_Applications_Stddev_Pop_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rental_Applications_Stddev_Samp_Fields = {
  __typename: 'rental_applications_stddev_samp_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rental_applications" */
export type Rental_Applications_Stddev_Samp_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_applications" */
export type Rental_Applications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Applications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Applications_Stream_Cursor_Value_Input = {
  additional_lease_information_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auto_reminders_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  cancelation_subreason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_card_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_card_enabled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  credit_card_initial_deposit_fee_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_card_move_in_payment_fee_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  guarantor_bond_id?: InputMaybe<Scalars['String']['input']>;
  hold_application_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ic_escalated_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  ic_escalated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_review_approved?: InputMaybe<Scalars['Boolean']['input']>;
  is_underwriting_approved?: InputMaybe<Scalars['Boolean']['input']>;
  lead_group_id?: InputMaybe<Scalars['uuid']['input']>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  occupants_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  pets_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  preapproved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  preapproved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  priority_score?: InputMaybe<Scalars['Int']['input']>;
  projected_occupancy_date?: InputMaybe<Scalars['date']['input']>;
  received_initial_product_pitch_at?: InputMaybe<Scalars['timestamptz']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  rental_program_type_applied_for?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  required_coapplicant_at?: InputMaybe<Scalars['timestamptz']['input']>;
  required_cosigner_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  underwriter_requested_documents_at?: InputMaybe<Scalars['timestamptz']['input']>;
  underwriter_requested_income_edits_at?: InputMaybe<Scalars['timestamptz']['input']>;
  underwriting_methodology?: InputMaybe<Scalars['String']['input']>;
  underwritten_at?: InputMaybe<Scalars['timestamptz']['input']>;
  underwritten_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicles_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Rental_Applications_Sum_Fields = {
  __typename: 'rental_applications_sum_fields';
  priority_score?: Maybe<Scalars['Int']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "rental_applications" */
export type Rental_Applications_Sum_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

export type Rental_Applications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Applications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Applications_Set_Input>;
  where: Rental_Applications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rental_Applications_Var_Pop_Fields = {
  __typename: 'rental_applications_var_pop_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rental_applications" */
export type Rental_Applications_Var_Pop_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rental_Applications_Var_Samp_Fields = {
  __typename: 'rental_applications_var_samp_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rental_applications" */
export type Rental_Applications_Var_Samp_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rental_Applications_Variance_Fields = {
  __typename: 'rental_applications_variance_fields';
  priority_score?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rental_applications" */
export type Rental_Applications_Variance_Order_By = {
  priority_score?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_credits" */
export type Rental_Credits = {
  __typename: 'rental_credits';
  amount: Scalars['numeric']['output'];
  buildium_id?: Maybe<Scalars['Int']['output']>;
  buildium_reversal_date?: Maybe<Scalars['date']['output']>;
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ledger_account?: Maybe<Ledger_Accounts>;
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  move_in_credit?: Maybe<Scalars['Boolean']['output']>;
  note: Scalars['String']['output'];
  offsetting_ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  payment_plan_offset_credits: Array<Payment_Plan_Offset_Credits>;
  rental_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rental_credits" */
export type Rental_CreditsPayment_Plan_Offset_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Plan_Offset_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Plan_Offset_Credits_Order_By>>;
  where?: InputMaybe<Payment_Plan_Offset_Credits_Bool_Exp>;
};

/** order by aggregate values of table "rental_credits" */
export type Rental_Credits_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Credits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Credits_Max_Order_By>;
  min?: InputMaybe<Rental_Credits_Min_Order_By>;
  stddev?: InputMaybe<Rental_Credits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Credits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Credits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Credits_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Credits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Credits_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Credits_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_credits" */
export type Rental_Credits_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_credits". All fields are combined with a logical 'AND'. */
export type Rental_Credits_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Credits_Bool_Exp>>;
  _not?: InputMaybe<Rental_Credits_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Credits_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  buildium_id?: InputMaybe<Int_Comparison_Exp>;
  buildium_reversal_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ledger_account?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  move_in_credit?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  offsetting_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_plan_offset_credits?: InputMaybe<Payment_Plan_Offset_Credits_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_credits" */
export enum Rental_Credits_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalCreditsPkey = 'rental_credits_pkey'
}

/** input type for inserting data into table "rental_credits" */
export type Rental_Credits_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  move_in_credit?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offsetting_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "rental_credits" */
export type Rental_Credits_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  buildium_reversal_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offsetting_ledger_account_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_credits" */
export type Rental_Credits_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  buildium_reversal_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offsetting_ledger_account_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_credits" */
export type Rental_Credits_Mutation_Response = {
  __typename: 'rental_credits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Credits>;
};

/** on_conflict condition type for table "rental_credits" */
export type Rental_Credits_On_Conflict = {
  constraint: Rental_Credits_Constraint;
  update_columns?: Array<Rental_Credits_Update_Column>;
  where?: InputMaybe<Rental_Credits_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_credits". */
export type Rental_Credits_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  buildium_reversal_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ledger_account?: InputMaybe<Ledger_Accounts_Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  move_in_credit?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offsetting_ledger_account_id?: InputMaybe<Order_By>;
  payment_plan_offset_credits_aggregate?: InputMaybe<Payment_Plan_Offset_Credits_Aggregate_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rental_credits" */
export enum Rental_Credits_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuildiumId = 'buildium_id',
  /** column name */
  BuildiumReversalDate = 'buildium_reversal_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  MoveInCredit = 'move_in_credit',
  /** column name */
  Note = 'note',
  /** column name */
  OffsettingLedgerAccountId = 'offsetting_ledger_account_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "rental_credits" */
export type Rental_Credits_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_credits" */
export type Rental_Credits_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_credits" */
export type Rental_Credits_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_credits" */
export type Rental_Credits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Credits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Credits_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['Int']['input']>;
  buildium_reversal_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  move_in_credit?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offsetting_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "rental_credits" */
export type Rental_Credits_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "rental_credits" (current role has no relevant permissions) */
export enum Rental_Credits_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "rental_credits" */
export type Rental_Credits_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_credits" */
export type Rental_Credits_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_credits" */
export type Rental_Credits_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_internet_fee_elections" */
export type Rental_Internet_Fee_Elections = {
  __typename: 'rental_internet_fee_elections';
  /** An object relationship */
  agreement: Agreements;
  agreement_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  effective_date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  mode: Scalars['String']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "rental_internet_fee_elections". All fields are combined with a logical 'AND'. */
export type Rental_Internet_Fee_Elections_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Internet_Fee_Elections_Bool_Exp>>;
  _not?: InputMaybe<Rental_Internet_Fee_Elections_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Internet_Fee_Elections_Bool_Exp>>;
  agreement?: InputMaybe<Agreements_Bool_Exp>;
  agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "rental_internet_fee_elections". */
export type Rental_Internet_Fee_Elections_Order_By = {
  agreement?: InputMaybe<Agreements_Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effective_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_internet_fee_elections" */
export enum Rental_Internet_Fee_Elections_Select_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EffectiveDate = 'effective_date',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  RentalId = 'rental_id'
}

/** Streaming cursor of the table "rental_internet_fee_elections" */
export type Rental_Internet_Fee_Elections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Internet_Fee_Elections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Internet_Fee_Elections_Stream_Cursor_Value_Input = {
  agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  effective_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "rental_liabilities" */
export type Rental_Liabilities = {
  __typename: 'rental_liabilities';
  amount: Scalars['numeric']['output'];
  buildium_id?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  cashouts_pending_liabilities: Array<Cashouts_Pending_Liabilities>;
  /** An array relationship */
  collections_rental_liabilities: Array<Collections_Rental_Liabilities>;
  created_at: Scalars['timestamp']['output'];
  date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  liabilities_payments: Array<Liabilities_Payments>;
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  payment_plan_liability?: Maybe<Payment_Plan_Liabilities>;
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  /** Primary key of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_id?: Maybe<Scalars['uuid']['output']>;
  /** Table name of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_type?: Maybe<Scalars['String']['output']>;
  sync_to_buildium: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rental_liabilities" */
export type Rental_LiabilitiesCashouts_Pending_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Cashouts_Pending_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashouts_Pending_Liabilities_Order_By>>;
  where?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
};


/** columns and relationships of "rental_liabilities" */
export type Rental_LiabilitiesCollections_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Collections_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
};


/** columns and relationships of "rental_liabilities" */
export type Rental_LiabilitiesLiabilities_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Liabilities_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Liabilities_Payments_Order_By>>;
  where?: InputMaybe<Liabilities_Payments_Bool_Exp>;
};

/** order by aggregate values of table "rental_liabilities" */
export type Rental_Liabilities_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Liabilities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Liabilities_Max_Order_By>;
  min?: InputMaybe<Rental_Liabilities_Min_Order_By>;
  stddev?: InputMaybe<Rental_Liabilities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Liabilities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Liabilities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Liabilities_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Liabilities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Liabilities_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Liabilities_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_liabilities". All fields are combined with a logical 'AND'. */
export type Rental_Liabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Liabilities_Bool_Exp>>;
  _not?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Liabilities_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  buildium_id?: InputMaybe<Numeric_Comparison_Exp>;
  cashouts_pending_liabilities?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
  collections_rental_liabilities?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liabilities_payments?: InputMaybe<Liabilities_Payments_Bool_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  payment_plan_liability?: InputMaybe<Payment_Plan_Liabilities_Bool_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  sync_to_buildium?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_liabilities" */
export enum Rental_Liabilities_Constraint {
  /** unique or primary key constraint on columns "date", "resource_type", "resource_id", "liability_type_id" */
  RentalLiabilitiesResourcePeriodTypeUnique = 'rental_liabilities_resource_period_type_unique',
  /** unique or primary key constraint on columns "id" */
  RentalLiabiltiesPkey = 'rental_liabilties_pkey'
}

/** input type for incrementing numeric columns in table "rental_liabilities" */
export type Rental_Liabilities_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "rental_liabilities" */
export type Rental_Liabilities_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['numeric']['input']>;
  buildium_reversal_date?: InputMaybe<Scalars['date']['input']>;
  cashouts_pending_liabilities?: InputMaybe<Cashouts_Pending_Liabilities_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  sync_to_buildium?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  /** Primary key of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_id?: InputMaybe<Order_By>;
  /** Table name of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  /** Primary key of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_id?: InputMaybe<Order_By>;
  /** Table name of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_liabilities" */
export type Rental_Liabilities_Mutation_Response = {
  __typename: 'rental_liabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Liabilities>;
};

/** input type for inserting object relation for remote table "rental_liabilities" */
export type Rental_Liabilities_Obj_Rel_Insert_Input = {
  data: Rental_Liabilities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rental_Liabilities_On_Conflict>;
};

/** on_conflict condition type for table "rental_liabilities" */
export type Rental_Liabilities_On_Conflict = {
  constraint: Rental_Liabilities_Constraint;
  update_columns?: Array<Rental_Liabilities_Update_Column>;
  where?: InputMaybe<Rental_Liabilities_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_liabilities". */
export type Rental_Liabilities_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  cashouts_pending_liabilities_aggregate?: InputMaybe<Cashouts_Pending_Liabilities_Aggregate_Order_By>;
  collections_rental_liabilities_aggregate?: InputMaybe<Collections_Rental_Liabilities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liabilities_payments_aggregate?: InputMaybe<Liabilities_Payments_Aggregate_Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_plan_liability?: InputMaybe<Payment_Plan_Liabilities_Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  sync_to_buildium?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_liabilities */
export type Rental_Liabilities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_liabilities" */
export enum Rental_Liabilities_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuildiumId = 'buildium_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Note = 'note',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  SyncToBuildium = 'sync_to_buildium',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_liabilities" */
export type Rental_Liabilities_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  sync_to_buildium?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_liabilities" */
export type Rental_Liabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Liabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Liabilities_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildium_id?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Primary key of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Table name of the source that automatically generated this liability; null for legacy and manually created rows. */
  resource_type?: InputMaybe<Scalars['String']['input']>;
  sync_to_buildium?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** update columns of table "rental_liabilities" */
export enum Rental_Liabilities_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuildiumId = 'buildium_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Note = 'note',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SyncToBuildium = 'sync_to_buildium',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Rental_Liabilities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Liabilities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Liabilities_Set_Input>;
  where: Rental_Liabilities_Bool_Exp;
};

/** order by var_pop() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_liabilities" */
export type Rental_Liabilities_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_move_in_fees" */
export type Rental_Move_In_Fees = {
  __typename: 'rental_move_in_fees';
  amount: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Move_In_Fees_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Move_In_Fees_Max_Order_By>;
  min?: InputMaybe<Rental_Move_In_Fees_Min_Order_By>;
  stddev?: InputMaybe<Rental_Move_In_Fees_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Move_In_Fees_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Move_In_Fees_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Move_In_Fees_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Move_In_Fees_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Move_In_Fees_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Move_In_Fees_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_move_in_fees". All fields are combined with a logical 'AND'. */
export type Rental_Move_In_Fees_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Move_In_Fees_Bool_Exp>>;
  _not?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Move_In_Fees_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_move_in_fees" */
export enum Rental_Move_In_Fees_Constraint {
  /** unique or primary key constraint on columns "id" */
  RentalMoveInFeesPkey = 'rental_move_in_fees_pkey'
}

/** input type for incrementing numeric columns in table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Mutation_Response = {
  __typename: 'rental_move_in_fees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Move_In_Fees>;
};

/** on_conflict condition type for table "rental_move_in_fees" */
export type Rental_Move_In_Fees_On_Conflict = {
  constraint: Rental_Move_In_Fees_Constraint;
  update_columns?: Array<Rental_Move_In_Fees_Update_Column>;
  where?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_move_in_fees". */
export type Rental_Move_In_Fees_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_move_in_fees */
export type Rental_Move_In_Fees_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_move_in_fees" */
export enum Rental_Move_In_Fees_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Move_In_Fees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Move_In_Fees_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "rental_move_in_fees" */
export enum Rental_Move_In_Fees_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  LiabilityTypeId = 'liability_type_id'
}

export type Rental_Move_In_Fees_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Move_In_Fees_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Move_In_Fees_Set_Input>;
  where: Rental_Move_In_Fees_Bool_Exp;
};

/** order by var_pop() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_move_in_fees" */
export type Rental_Move_In_Fees_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_occupants" */
export type Rental_Occupants = {
  __typename: 'rental_occupants';
  agreement_id?: Maybe<Scalars['uuid']['output']>;
  occupant_age?: Maybe<Scalars['String']['output']>;
  occupant_name?: Maybe<Scalars['String']['output']>;
  occupant_number?: Maybe<Scalars['Int']['output']>;
  occupant_relation?: Maybe<Scalars['String']['output']>;
  rental_application_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rentals?: Maybe<Rentals>;
};

/** order by aggregate values of table "rental_occupants" */
export type Rental_Occupants_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Occupants_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Occupants_Max_Order_By>;
  min?: InputMaybe<Rental_Occupants_Min_Order_By>;
  stddev?: InputMaybe<Rental_Occupants_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Occupants_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Occupants_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Occupants_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Occupants_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Occupants_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Occupants_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_occupants" */
export type Rental_Occupants_Avg_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_occupants". All fields are combined with a logical 'AND'. */
export type Rental_Occupants_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Occupants_Bool_Exp>>;
  _not?: InputMaybe<Rental_Occupants_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Occupants_Bool_Exp>>;
  agreement_id?: InputMaybe<Uuid_Comparison_Exp>;
  occupant_age?: InputMaybe<String_Comparison_Exp>;
  occupant_name?: InputMaybe<String_Comparison_Exp>;
  occupant_number?: InputMaybe<Int_Comparison_Exp>;
  occupant_relation?: InputMaybe<String_Comparison_Exp>;
  rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  rentals?: InputMaybe<Rentals_Bool_Exp>;
};

/** order by max() on columns of table "rental_occupants" */
export type Rental_Occupants_Max_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  occupant_age?: InputMaybe<Order_By>;
  occupant_name?: InputMaybe<Order_By>;
  occupant_number?: InputMaybe<Order_By>;
  occupant_relation?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_occupants" */
export type Rental_Occupants_Min_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  occupant_age?: InputMaybe<Order_By>;
  occupant_name?: InputMaybe<Order_By>;
  occupant_number?: InputMaybe<Order_By>;
  occupant_relation?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rental_occupants". */
export type Rental_Occupants_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  occupant_age?: InputMaybe<Order_By>;
  occupant_name?: InputMaybe<Order_By>;
  occupant_number?: InputMaybe<Order_By>;
  occupant_relation?: InputMaybe<Order_By>;
  rental_application_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  rentals?: InputMaybe<Rentals_Order_By>;
};

/** select columns of table "rental_occupants" */
export enum Rental_Occupants_Select_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  OccupantAge = 'occupant_age',
  /** column name */
  OccupantName = 'occupant_name',
  /** column name */
  OccupantNumber = 'occupant_number',
  /** column name */
  OccupantRelation = 'occupant_relation',
  /** column name */
  RentalApplicationId = 'rental_application_id',
  /** column name */
  RentalId = 'rental_id'
}

/** order by stddev() on columns of table "rental_occupants" */
export type Rental_Occupants_Stddev_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_occupants" */
export type Rental_Occupants_Stddev_Pop_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_occupants" */
export type Rental_Occupants_Stddev_Samp_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_occupants" */
export type Rental_Occupants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Occupants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Occupants_Stream_Cursor_Value_Input = {
  agreement_id?: InputMaybe<Scalars['uuid']['input']>;
  occupant_age?: InputMaybe<Scalars['String']['input']>;
  occupant_name?: InputMaybe<Scalars['String']['input']>;
  occupant_number?: InputMaybe<Scalars['Int']['input']>;
  occupant_relation?: InputMaybe<Scalars['String']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "rental_occupants" */
export type Rental_Occupants_Sum_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "rental_occupants" */
export type Rental_Occupants_Var_Pop_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_occupants" */
export type Rental_Occupants_Var_Samp_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_occupants" */
export type Rental_Occupants_Variance_Order_By = {
  occupant_number?: InputMaybe<Order_By>;
};

export enum Rental_Program_Types_Enum_Enum {
  Upandup = 'upandup',
  Vanilla = 'vanilla'
}

/** Boolean expression to compare columns of type "rental_program_types_enum_enum". All fields are combined with logical 'AND'. */
export type Rental_Program_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Rental_Program_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Rental_Program_Types_Enum_Enum>>;
};

/** columns and relationships of "rental_reunderwrite_tenant_underwrites" */
export type Rental_Reunderwrite_Tenant_Underwrites = {
  __typename: 'rental_reunderwrite_tenant_underwrites';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_reunderwrite: Rental_Reunderwrites;
  rental_reunderwrite_id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant_underwrite: Tenant_Underwrites;
  tenant_underwrite_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "rental_reunderwrite_tenant_underwrites" */
export type Rental_Reunderwrite_Tenant_Underwrites_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Max_Order_By>;
  min?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "rental_reunderwrite_tenant_underwrites". All fields are combined with a logical 'AND'. */
export type Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>>;
  _not?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_reunderwrite?: InputMaybe<Rental_Reunderwrites_Bool_Exp>;
  rental_reunderwrite_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_underwrite?: InputMaybe<Tenant_Underwrites_Bool_Exp>;
  tenant_underwrite_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "rental_reunderwrite_tenant_underwrites" */
export type Rental_Reunderwrite_Tenant_Underwrites_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_reunderwrite_id?: InputMaybe<Order_By>;
  tenant_underwrite_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_reunderwrite_tenant_underwrites" */
export type Rental_Reunderwrite_Tenant_Underwrites_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_reunderwrite_id?: InputMaybe<Order_By>;
  tenant_underwrite_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rental_reunderwrite_tenant_underwrites". */
export type Rental_Reunderwrite_Tenant_Underwrites_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_reunderwrite?: InputMaybe<Rental_Reunderwrites_Order_By>;
  rental_reunderwrite_id?: InputMaybe<Order_By>;
  tenant_underwrite?: InputMaybe<Tenant_Underwrites_Order_By>;
  tenant_underwrite_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_reunderwrite_tenant_underwrites" */
export enum Rental_Reunderwrite_Tenant_Underwrites_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RentalReunderwriteId = 'rental_reunderwrite_id',
  /** column name */
  TenantUnderwriteId = 'tenant_underwrite_id'
}

/** Streaming cursor of the table "rental_reunderwrite_tenant_underwrites" */
export type Rental_Reunderwrite_Tenant_Underwrites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Reunderwrite_Tenant_Underwrites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Reunderwrite_Tenant_Underwrites_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_reunderwrite_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_underwrite_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "rental_reunderwrites" */
export type Rental_Reunderwrites = {
  __typename: 'rental_reunderwrites';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  /** An array relationship */
  rental_reunderwrite_tenant_underwrites: Array<Rental_Reunderwrite_Tenant_Underwrites>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rental_reunderwrites" */
export type Rental_ReunderwritesRental_Reunderwrite_Tenant_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Order_By>>;
  where?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "rental_reunderwrites". All fields are combined with a logical 'AND'. */
export type Rental_Reunderwrites_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Reunderwrites_Bool_Exp>>;
  _not?: InputMaybe<Rental_Reunderwrites_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Reunderwrites_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_reunderwrite_tenant_underwrites?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "rental_reunderwrites". */
export type Rental_Reunderwrites_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  rental_reunderwrite_tenant_underwrites_aggregate?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rental_reunderwrites" */
export enum Rental_Reunderwrites_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "rental_reunderwrites" */
export type Rental_Reunderwrites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Reunderwrites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Reunderwrites_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rental_site_accounts" */
export type Rental_Site_Accounts = {
  __typename: 'rental_site_accounts';
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  feed_format: Scalars['String']['output'];
  feed_specification?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  max_listings?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "rental_site_accounts". All fields are combined with a logical 'AND'. */
export type Rental_Site_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Site_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Rental_Site_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Site_Accounts_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  feed_format?: InputMaybe<String_Comparison_Exp>;
  feed_specification?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max_listings?: InputMaybe<Int_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "rental_site_accounts". */
export type Rental_Site_Accounts_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  feed_format?: InputMaybe<Order_By>;
  feed_specification?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_listings?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rental_site_accounts" */
export enum Rental_Site_Accounts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Email = 'email',
  /** column name */
  FeedFormat = 'feed_format',
  /** column name */
  FeedSpecification = 'feed_specification',
  /** column name */
  Id = 'id',
  /** column name */
  MaxListings = 'max_listings',
  /** column name */
  Password = 'password',
  /** column name */
  Source = 'source',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "rental_site_accounts" */
export type Rental_Site_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Site_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Site_Accounts_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feed_format?: InputMaybe<Scalars['String']['input']>;
  feed_specification?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_listings?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rental_site_leads" */
export type Rental_Site_Leads = {
  __typename: 'rental_site_leads';
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_smoker?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lead_comments?: Maybe<Scalars['String']['output']>;
  lease_length_in_months?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  number_of_bathrooms?: Maybe<Scalars['numeric']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_occupants?: Maybe<Scalars['Int']['output']>;
  occupancy_date?: Maybe<Scalars['date']['output']>;
  parking_type?: Maybe<Scalars['String']['output']>;
  pet_details?: Maybe<Scalars['_jsonb']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reason_for_moving?: Maybe<Scalars['String']['output']>;
  rent?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  rental_site_listing: Rental_Site_Listings;
  rental_site_listing_id: Scalars['uuid']['output'];
  self_reported_annual_income?: Maybe<Scalars['numeric']['output']>;
  self_reported_credit?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "rental_site_leads" */
export type Rental_Site_LeadsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "rental_site_leads" */
export type Rental_Site_LeadsSelf_Reported_CreditArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "rental_site_leads" */
export type Rental_Site_Leads_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Site_Leads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Site_Leads_Max_Order_By>;
  min?: InputMaybe<Rental_Site_Leads_Min_Order_By>;
  stddev?: InputMaybe<Rental_Site_Leads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Site_Leads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Site_Leads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Site_Leads_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Site_Leads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Site_Leads_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Site_Leads_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Avg_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_site_leads". All fields are combined with a logical 'AND'. */
export type Rental_Site_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Site_Leads_Bool_Exp>>;
  _not?: InputMaybe<Rental_Site_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Site_Leads_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  employer?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_smoker?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead_comments?: InputMaybe<String_Comparison_Exp>;
  lease_length_in_months?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Numeric_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_occupants?: InputMaybe<Int_Comparison_Exp>;
  occupancy_date?: InputMaybe<Date_Comparison_Exp>;
  parking_type?: InputMaybe<String_Comparison_Exp>;
  pet_details?: InputMaybe<_Jsonb_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  reason_for_moving?: InputMaybe<String_Comparison_Exp>;
  rent?: InputMaybe<Numeric_Comparison_Exp>;
  rental_site_listing?: InputMaybe<Rental_Site_Listings_Bool_Exp>;
  rental_site_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  self_reported_annual_income?: InputMaybe<Numeric_Comparison_Exp>;
  self_reported_credit?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_comments?: InputMaybe<Order_By>;
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  parking_type?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  reason_for_moving?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental_site_listing_id?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_comments?: InputMaybe<Order_By>;
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  parking_type?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  reason_for_moving?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental_site_listing_id?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rental_site_leads". */
export type Rental_Site_Leads_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_smoker?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_comments?: InputMaybe<Order_By>;
  lease_length_in_months?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  parking_type?: InputMaybe<Order_By>;
  pet_details?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  reason_for_moving?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  rental_site_listing?: InputMaybe<Rental_Site_Listings_Order_By>;
  rental_site_listing_id?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
  self_reported_credit?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_site_leads" */
export enum Rental_Site_Leads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Employer = 'employer',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsSmoker = 'is_smoker',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LeadComments = 'lead_comments',
  /** column name */
  LeaseLengthInMonths = 'lease_length_in_months',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfOccupants = 'number_of_occupants',
  /** column name */
  OccupancyDate = 'occupancy_date',
  /** column name */
  ParkingType = 'parking_type',
  /** column name */
  PetDetails = 'pet_details',
  /** column name */
  Phone = 'phone',
  /** column name */
  ReasonForMoving = 'reason_for_moving',
  /** column name */
  Rent = 'rent',
  /** column name */
  RentalSiteListingId = 'rental_site_listing_id',
  /** column name */
  SelfReportedAnnualIncome = 'self_reported_annual_income',
  /** column name */
  SelfReportedCredit = 'self_reported_credit',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Stddev_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Stddev_Pop_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Stddev_Samp_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_site_leads" */
export type Rental_Site_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Site_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Site_Leads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_smoker?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_comments?: InputMaybe<Scalars['String']['input']>;
  lease_length_in_months?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['numeric']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_occupants?: InputMaybe<Scalars['Int']['input']>;
  occupancy_date?: InputMaybe<Scalars['date']['input']>;
  parking_type?: InputMaybe<Scalars['String']['input']>;
  pet_details?: InputMaybe<Scalars['_jsonb']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reason_for_moving?: InputMaybe<Scalars['String']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  rental_site_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  self_reported_annual_income?: InputMaybe<Scalars['numeric']['input']>;
  self_reported_credit?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Sum_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Var_Pop_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Var_Samp_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_site_leads" */
export type Rental_Site_Leads_Variance_Order_By = {
  lease_length_in_months?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_occupants?: InputMaybe<Order_By>;
  rent?: InputMaybe<Order_By>;
  self_reported_annual_income?: InputMaybe<Order_By>;
};

/** columns and relationships of "rental_site_listings" */
export type Rental_Site_Listings = {
  __typename: 'rental_site_listings';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  mls_listing: Mls_Listings;
  mls_listing_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_site_account: Rental_Site_Accounts;
  rental_site_account_id: Scalars['uuid']['output'];
  source_listing_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "rental_site_listings". All fields are combined with a logical 'AND'. */
export type Rental_Site_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Site_Listings_Bool_Exp>>;
  _not?: InputMaybe<Rental_Site_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Site_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_site_account?: InputMaybe<Rental_Site_Accounts_Bool_Exp>;
  rental_site_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_listing_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "rental_site_listings". */
export type Rental_Site_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  mls_listing_id?: InputMaybe<Order_By>;
  rental_site_account?: InputMaybe<Rental_Site_Accounts_Order_By>;
  rental_site_account_id?: InputMaybe<Order_By>;
  source_listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rental_site_listings" */
export enum Rental_Site_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MlsListingId = 'mls_listing_id',
  /** column name */
  RentalSiteAccountId = 'rental_site_account_id',
  /** column name */
  SourceListingId = 'source_listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "rental_site_listings" */
export type Rental_Site_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Site_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Site_Listings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  mls_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_site_account_id?: InputMaybe<Scalars['uuid']['input']>;
  source_listing_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rental_site_opportunity_checks" */
export type Rental_Site_Opportunity_Checks = {
  __typename: 'rental_site_opportunity_checks';
  created_at: Scalars['timestamptz']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  images?: Maybe<Scalars['_text']['output']>;
  last_run_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  muted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  muted_by_admin?: Maybe<Admins>;
  muted_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  opportunity: Opportunities;
  opportunity_id: Scalars['uuid']['output'];
  status: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rental_site_opportunity_checks" */
export type Rental_Site_Opportunity_ChecksMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "rental_site_opportunity_checks". All fields are combined with a logical 'AND'. */
export type Rental_Site_Opportunity_Checks_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Site_Opportunity_Checks_Bool_Exp>>;
  _not?: InputMaybe<Rental_Site_Opportunity_Checks_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Site_Opportunity_Checks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  images?: InputMaybe<_Text_Comparison_Exp>;
  last_run_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  muted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  muted_by_admin?: InputMaybe<Admins_Bool_Exp>;
  muted_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  opportunity?: InputMaybe<Opportunities_Bool_Exp>;
  opportunity_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** response of any mutation on the table "rental_site_opportunity_checks" */
export type Rental_Site_Opportunity_Checks_Mutation_Response = {
  __typename: 'rental_site_opportunity_checks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Site_Opportunity_Checks>;
};

/** Ordering options when selecting data from "rental_site_opportunity_checks". */
export type Rental_Site_Opportunity_Checks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  last_run_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  muted_at?: InputMaybe<Order_By>;
  muted_by_admin?: InputMaybe<Admins_Order_By>;
  muted_by_admin_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  opportunity?: InputMaybe<Opportunities_Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_site_opportunity_checks */
export type Rental_Site_Opportunity_Checks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_site_opportunity_checks" */
export enum Rental_Site_Opportunity_Checks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LastRunAt = 'last_run_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MutedAt = 'muted_at',
  /** column name */
  MutedByAdminId = 'muted_by_admin_id',
  /** column name */
  Name = 'name',
  /** column name */
  OpportunityId = 'opportunity_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_site_opportunity_checks" */
export type Rental_Site_Opportunity_Checks_Set_Input = {
  muted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  muted_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "rental_site_opportunity_checks" */
export type Rental_Site_Opportunity_Checks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Site_Opportunity_Checks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Site_Opportunity_Checks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  images?: InputMaybe<Scalars['_text']['input']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  muted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  muted_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Rental_Site_Opportunity_Checks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Site_Opportunity_Checks_Set_Input>;
  where: Rental_Site_Opportunity_Checks_Bool_Exp;
};

/** columns and relationships of "rental_users" */
export type Rental_Users = {
  __typename: 'rental_users';
  auto_charge_disabled_at?: Maybe<Scalars['timestamptz']['output']>;
  buildium_tenant_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  credit_card_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "rental_users" */
export type Rental_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Rental_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rental_Users_Max_Order_By>;
  min?: InputMaybe<Rental_Users_Min_Order_By>;
  stddev?: InputMaybe<Rental_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rental_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rental_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rental_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Rental_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rental_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Rental_Users_Variance_Order_By>;
};

/** order by avg() on columns of table "rental_users" */
export type Rental_Users_Avg_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rental_users". All fields are combined with a logical 'AND'. */
export type Rental_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Users_Bool_Exp>>;
  _not?: InputMaybe<Rental_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Users_Bool_Exp>>;
  auto_charge_disabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  buildium_tenant_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_card_enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "rental_users" */
export type Rental_Users_Max_Order_By = {
  auto_charge_disabled_at?: InputMaybe<Order_By>;
  buildium_tenant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_enabled_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rental_users" */
export type Rental_Users_Min_Order_By = {
  auto_charge_disabled_at?: InputMaybe<Order_By>;
  buildium_tenant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_enabled_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rental_users" */
export type Rental_Users_Mutation_Response = {
  __typename: 'rental_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Users>;
};

/** Ordering options when selecting data from "rental_users". */
export type Rental_Users_Order_By = {
  auto_charge_disabled_at?: InputMaybe<Order_By>;
  buildium_tenant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_enabled_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_users */
export type Rental_Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rental_users" */
export enum Rental_Users_Select_Column {
  /** column name */
  AutoChargeDisabledAt = 'auto_charge_disabled_at',
  /** column name */
  BuildiumTenantId = 'buildium_tenant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditCardEnabledAt = 'credit_card_enabled_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "rental_users" */
export type Rental_Users_Set_Input = {
  credit_card_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "rental_users" */
export type Rental_Users_Stddev_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rental_users" */
export type Rental_Users_Stddev_Pop_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rental_users" */
export type Rental_Users_Stddev_Samp_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rental_users" */
export type Rental_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Users_Stream_Cursor_Value_Input = {
  auto_charge_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  buildium_tenant_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_card_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "rental_users" */
export type Rental_Users_Sum_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

export type Rental_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Users_Set_Input>;
  where: Rental_Users_Bool_Exp;
};

/** order by var_pop() on columns of table "rental_users" */
export type Rental_Users_Var_Pop_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rental_users" */
export type Rental_Users_Var_Samp_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rental_users" */
export type Rental_Users_Variance_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
};

/** Engineering-managed utility chargeback policy. Missing rows and default rows use normal rules. Block stops chargebacks immediately; allow bypasses rental policy restrictions for payments from the following UTC day while retaining accounting safeguards. */
export type Rental_Utility_Chargeback_Overrides = {
  __typename: 'rental_utility_chargeback_overrides';
  mode: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  /** Set to the current database timestamp when switching to allow. Do not backdate or reuse a previous activation timestamp. */
  set_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "rental_utility_chargeback_overrides" */
export type Rental_Utility_Chargeback_Overrides_Aggregate = {
  __typename: 'rental_utility_chargeback_overrides_aggregate';
  aggregate?: Maybe<Rental_Utility_Chargeback_Overrides_Aggregate_Fields>;
  nodes: Array<Rental_Utility_Chargeback_Overrides>;
};

/** aggregate fields of "rental_utility_chargeback_overrides" */
export type Rental_Utility_Chargeback_Overrides_Aggregate_Fields = {
  __typename: 'rental_utility_chargeback_overrides_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Rental_Utility_Chargeback_Overrides_Max_Fields>;
  min?: Maybe<Rental_Utility_Chargeback_Overrides_Min_Fields>;
};


/** aggregate fields of "rental_utility_chargeback_overrides" */
export type Rental_Utility_Chargeback_Overrides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "rental_utility_chargeback_overrides". All fields are combined with a logical 'AND'. */
export type Rental_Utility_Chargeback_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Bool_Exp>>;
  mode?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  set_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Rental_Utility_Chargeback_Overrides_Max_Fields = {
  __typename: 'rental_utility_chargeback_overrides_max_fields';
  mode?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  /** Set to the current database timestamp when switching to allow. Do not backdate or reuse a previous activation timestamp. */
  set_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Rental_Utility_Chargeback_Overrides_Min_Fields = {
  __typename: 'rental_utility_chargeback_overrides_min_fields';
  mode?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  /** Set to the current database timestamp when switching to allow. Do not backdate or reuse a previous activation timestamp. */
  set_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "rental_utility_chargeback_overrides". */
export type Rental_Utility_Chargeback_Overrides_Order_By = {
  mode?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  set_at?: InputMaybe<Order_By>;
};

/** select columns of table "rental_utility_chargeback_overrides" */
export enum Rental_Utility_Chargeback_Overrides_Select_Column {
  /** column name */
  Mode = 'mode',
  /** column name */
  Reason = 'reason',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SetAt = 'set_at'
}

/** Streaming cursor of the table "rental_utility_chargeback_overrides" */
export type Rental_Utility_Chargeback_Overrides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Utility_Chargeback_Overrides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Utility_Chargeback_Overrides_Stream_Cursor_Value_Input = {
  mode?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Set to the current database timestamp when switching to allow. Do not backdate or reuse a previous activation timestamp. */
  set_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rentals" */
export type Rentals = {
  __typename: 'rentals';
  /** An array relationship */
  agreements: Array<Agreements>;
  auto_charge: Scalars['Boolean']['output'];
  buildium_lease_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  cashout?: Maybe<Cashouts>;
  /** An array relationship */
  collections: Array<Collections>;
  /** An array relationship */
  construction_projects: Array<Construction_Projects>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_rental_application_id: Scalars['uuid']['output'];
  /** An object relationship */
  current_balance?: Maybe<Current_Balances>;
  /** An object relationship */
  current_statement?: Maybe<Current_Statements>;
  /** An array relationship */
  current_utility_responsibilities: Array<Current_Utility_Responsibilities>;
  daily_late_fee_amount?: Maybe<Scalars['numeric']['output']>;
  do_not_renew_notice_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  do_not_renew_reason?: Maybe<Scalars['String']['output']>;
  do_not_renew_selected_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  do_not_renew_selected_by_admin?: Maybe<Admins>;
  do_not_renew_selected_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An array relationship */
  evictions: Array<Evictions>;
  final_liability_date?: Maybe<Scalars['date']['output']>;
  has_signed_utility_addendum?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  initial_lease_term: Scalars['Int']['output'];
  initial_option_premium: Scalars['Int']['output'];
  is_card_payment_allowed: Scalars['Boolean']['output'];
  is_statements_enabled: Scalars['Boolean']['output'];
  last_statement_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_end_reason?: Maybe<Scalars['String']['output']>;
  lease_variant: Lease_Variants_Enum_Enum;
  minimum_monthly_option_premium: Scalars['numeric']['output'];
  move_out_date?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  notes: Array<Notes>;
  occupancy_date: Scalars['date']['output'];
  /** An array relationship */
  option_premium_transfers_received: Array<Option_Premium_Transfers>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  poa_effective_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  portfolio_home?: Maybe<Portfolio_Homes>;
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  /** An array relationship */
  recurring_credits: Array<Recurring_Credits>;
  /** An object relationship */
  rent_roll?: Maybe<Rent_Roll>;
  /** An array relationship */
  rental_add_ons: Array<Rental_Add_Ons>;
  /** An array relationship */
  rental_agreement_histories: Array<Rental_Agreement_Histories>;
  /** An object relationship */
  rental_application: Rental_Applications;
  /** An array relationship */
  rental_credits: Array<Rental_Credits>;
  /** An array relationship */
  rental_liabilities: Array<Rental_Liabilities>;
  /** An array relationship */
  rental_move_in_fees: Array<Rental_Move_In_Fees>;
  /** An array relationship */
  rental_occupants: Array<Rental_Occupants>;
  rental_program_type: Rental_Program_Types_Enum_Enum;
  /** An array relationship */
  rental_users: Array<Rental_Users>;
  /** An array relationship */
  scheduled_rental_liabilities: Array<Scheduled_Rental_Liabilities>;
  security_deposit: Scalars['Int']['output'];
  /** An array relationship */
  statements: Array<Statements>;
  /** An array relationship */
  statements_raw: Array<Statements_Raw>;
  status: Scalars['String']['output'];
  target_monthly_option_premium: Scalars['Int']['output'];
  tenant_notice_given_on_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  utility_chargeback_override?: Maybe<Rental_Utility_Chargeback_Overrides>;
  /** An array relationship */
  utility_responsibilities: Array<Utility_Responsibilities>;
  zendesk_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "rentals" */
export type RentalsAgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsConstruction_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Projects_Order_By>>;
  where?: InputMaybe<Construction_Projects_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsCurrent_Utility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Current_Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Current_Utility_Responsibilities_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsEvictionsArgs = {
  distinct_on?: InputMaybe<Array<Evictions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evictions_Order_By>>;
  where?: InputMaybe<Evictions_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsNotesArgs = {
  distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notes_Order_By>>;
  where?: InputMaybe<Notes_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsOption_Premium_Transfers_ReceivedArgs = {
  distinct_on?: InputMaybe<Array<Option_Premium_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Option_Premium_Transfers_Order_By>>;
  where?: InputMaybe<Option_Premium_Transfers_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRecurring_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Recurring_Credits_Order_By>>;
  where?: InputMaybe<Recurring_Credits_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Add_Ons_Order_By>>;
  where?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_Agreement_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Agreement_Histories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Agreement_Histories_Order_By>>;
  where?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Credits_Order_By>>;
  where?: InputMaybe<Rental_Credits_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Rental_Liabilities_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_Move_In_FeesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Move_In_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Move_In_Fees_Order_By>>;
  where?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_OccupantsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Occupants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Occupants_Order_By>>;
  where?: InputMaybe<Rental_Occupants_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsRental_UsersArgs = {
  distinct_on?: InputMaybe<Array<Rental_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Users_Order_By>>;
  where?: InputMaybe<Rental_Users_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsScheduled_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scheduled_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsStatementsArgs = {
  distinct_on?: InputMaybe<Array<Statements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statements_Order_By>>;
  where?: InputMaybe<Statements_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsStatements_RawArgs = {
  distinct_on?: InputMaybe<Array<Statements_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statements_Raw_Order_By>>;
  where?: InputMaybe<Statements_Raw_Bool_Exp>;
};


/** columns and relationships of "rentals" */
export type RentalsUtility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
};

/** order by aggregate values of table "rentals" */
export type Rentals_Aggregate_Order_By = {
  avg?: InputMaybe<Rentals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rentals_Max_Order_By>;
  min?: InputMaybe<Rentals_Min_Order_By>;
  stddev?: InputMaybe<Rentals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rentals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rentals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rentals_Sum_Order_By>;
  var_pop?: InputMaybe<Rentals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rentals_Var_Samp_Order_By>;
  variance?: InputMaybe<Rentals_Variance_Order_By>;
};

/** order by avg() on columns of table "rentals" */
export type Rentals_Avg_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rentals". All fields are combined with a logical 'AND'. */
export type Rentals_Bool_Exp = {
  _and?: InputMaybe<Array<Rentals_Bool_Exp>>;
  _not?: InputMaybe<Rentals_Bool_Exp>;
  _or?: InputMaybe<Array<Rentals_Bool_Exp>>;
  agreements?: InputMaybe<Agreements_Bool_Exp>;
  auto_charge?: InputMaybe<Boolean_Comparison_Exp>;
  buildium_lease_id?: InputMaybe<Int_Comparison_Exp>;
  cashout?: InputMaybe<Cashouts_Bool_Exp>;
  collections?: InputMaybe<Collections_Bool_Exp>;
  construction_projects?: InputMaybe<Construction_Projects_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_rental_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  current_balance?: InputMaybe<Current_Balances_Bool_Exp>;
  current_statement?: InputMaybe<Current_Statements_Bool_Exp>;
  current_utility_responsibilities?: InputMaybe<Current_Utility_Responsibilities_Bool_Exp>;
  daily_late_fee_amount?: InputMaybe<Numeric_Comparison_Exp>;
  do_not_renew_notice_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  do_not_renew_reason?: InputMaybe<String_Comparison_Exp>;
  do_not_renew_selected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  do_not_renew_selected_by_admin?: InputMaybe<Admins_Bool_Exp>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Documents_Bool_Exp>;
  evictions?: InputMaybe<Evictions_Bool_Exp>;
  final_liability_date?: InputMaybe<Date_Comparison_Exp>;
  has_signed_utility_addendum?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_lease_term?: InputMaybe<Int_Comparison_Exp>;
  initial_option_premium?: InputMaybe<Int_Comparison_Exp>;
  is_card_payment_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  is_statements_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_statement_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lease_end_reason?: InputMaybe<String_Comparison_Exp>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum_Comparison_Exp>;
  minimum_monthly_option_premium?: InputMaybe<Numeric_Comparison_Exp>;
  move_out_date?: InputMaybe<Date_Comparison_Exp>;
  notes?: InputMaybe<Notes_Bool_Exp>;
  occupancy_date?: InputMaybe<Date_Comparison_Exp>;
  option_premium_transfers_received?: InputMaybe<Option_Premium_Transfers_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  poa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  recurring_credits?: InputMaybe<Recurring_Credits_Bool_Exp>;
  rent_roll?: InputMaybe<Rent_Roll_Bool_Exp>;
  rental_add_ons?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
  rental_agreement_histories?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
  rental_application?: InputMaybe<Rental_Applications_Bool_Exp>;
  rental_credits?: InputMaybe<Rental_Credits_Bool_Exp>;
  rental_liabilities?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  rental_move_in_fees?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
  rental_occupants?: InputMaybe<Rental_Occupants_Bool_Exp>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum_Comparison_Exp>;
  rental_users?: InputMaybe<Rental_Users_Bool_Exp>;
  scheduled_rental_liabilities?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
  security_deposit?: InputMaybe<Int_Comparison_Exp>;
  statements?: InputMaybe<Statements_Bool_Exp>;
  statements_raw?: InputMaybe<Statements_Raw_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_monthly_option_premium?: InputMaybe<Int_Comparison_Exp>;
  tenant_notice_given_on_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  utility_chargeback_override?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
  utility_responsibilities?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
  zendesk_id?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "rentals" */
export type Rentals_Inc_Input = {
  target_monthly_option_premium?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "rentals" */
export type Rentals_Max_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_rental_application_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  do_not_renew_notice_sent_at?: InputMaybe<Order_By>;
  do_not_renew_reason?: InputMaybe<Order_By>;
  do_not_renew_selected_at?: InputMaybe<Order_By>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Order_By>;
  final_liability_date?: InputMaybe<Order_By>;
  has_signed_utility_addendum?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  last_statement_sent_at?: InputMaybe<Order_By>;
  lease_end_reason?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  move_out_date?: InputMaybe<Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  poa_effective_date?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
  tenant_notice_given_on_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  zendesk_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rentals" */
export type Rentals_Min_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_rental_application_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  do_not_renew_notice_sent_at?: InputMaybe<Order_By>;
  do_not_renew_reason?: InputMaybe<Order_By>;
  do_not_renew_selected_at?: InputMaybe<Order_By>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Order_By>;
  final_liability_date?: InputMaybe<Order_By>;
  has_signed_utility_addendum?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  last_statement_sent_at?: InputMaybe<Order_By>;
  lease_end_reason?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  move_out_date?: InputMaybe<Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  poa_effective_date?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
  tenant_notice_given_on_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  zendesk_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rentals" */
export type Rentals_Mutation_Response = {
  __typename: 'rentals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rentals>;
};

/** Ordering options when selecting data from "rentals". */
export type Rentals_Order_By = {
  agreements_aggregate?: InputMaybe<Agreements_Aggregate_Order_By>;
  auto_charge?: InputMaybe<Order_By>;
  buildium_lease_id?: InputMaybe<Order_By>;
  cashout?: InputMaybe<Cashouts_Order_By>;
  collections_aggregate?: InputMaybe<Collections_Aggregate_Order_By>;
  construction_projects_aggregate?: InputMaybe<Construction_Projects_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_rental_application_id?: InputMaybe<Order_By>;
  current_balance?: InputMaybe<Current_Balances_Order_By>;
  current_statement?: InputMaybe<Current_Statements_Order_By>;
  current_utility_responsibilities_aggregate?: InputMaybe<Current_Utility_Responsibilities_Aggregate_Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  do_not_renew_notice_sent_at?: InputMaybe<Order_By>;
  do_not_renew_reason?: InputMaybe<Order_By>;
  do_not_renew_selected_at?: InputMaybe<Order_By>;
  do_not_renew_selected_by_admin?: InputMaybe<Admins_Order_By>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  evictions_aggregate?: InputMaybe<Evictions_Aggregate_Order_By>;
  final_liability_date?: InputMaybe<Order_By>;
  has_signed_utility_addendum?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  is_card_payment_allowed?: InputMaybe<Order_By>;
  is_statements_enabled?: InputMaybe<Order_By>;
  last_statement_sent_at?: InputMaybe<Order_By>;
  lease_end_reason?: InputMaybe<Order_By>;
  lease_variant?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  move_out_date?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Notes_Aggregate_Order_By>;
  occupancy_date?: InputMaybe<Order_By>;
  option_premium_transfers_received_aggregate?: InputMaybe<Option_Premium_Transfers_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  poa_effective_date?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  recurring_credits_aggregate?: InputMaybe<Recurring_Credits_Aggregate_Order_By>;
  rent_roll?: InputMaybe<Rent_Roll_Order_By>;
  rental_add_ons_aggregate?: InputMaybe<Rental_Add_Ons_Aggregate_Order_By>;
  rental_agreement_histories_aggregate?: InputMaybe<Rental_Agreement_Histories_Aggregate_Order_By>;
  rental_application?: InputMaybe<Rental_Applications_Order_By>;
  rental_credits_aggregate?: InputMaybe<Rental_Credits_Aggregate_Order_By>;
  rental_liabilities_aggregate?: InputMaybe<Rental_Liabilities_Aggregate_Order_By>;
  rental_move_in_fees_aggregate?: InputMaybe<Rental_Move_In_Fees_Aggregate_Order_By>;
  rental_occupants_aggregate?: InputMaybe<Rental_Occupants_Aggregate_Order_By>;
  rental_program_type?: InputMaybe<Order_By>;
  rental_users_aggregate?: InputMaybe<Rental_Users_Aggregate_Order_By>;
  scheduled_rental_liabilities_aggregate?: InputMaybe<Scheduled_Rental_Liabilities_Aggregate_Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  statements_aggregate?: InputMaybe<Statements_Aggregate_Order_By>;
  statements_raw_aggregate?: InputMaybe<Statements_Raw_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
  tenant_notice_given_on_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  utility_chargeback_override?: InputMaybe<Rental_Utility_Chargeback_Overrides_Order_By>;
  utility_responsibilities_aggregate?: InputMaybe<Utility_Responsibilities_Aggregate_Order_By>;
  zendesk_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rentals */
export type Rentals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rentals" */
export enum Rentals_Select_Column {
  /** column name */
  AutoCharge = 'auto_charge',
  /** column name */
  BuildiumLeaseId = 'buildium_lease_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByRentalApplicationId = 'created_by_rental_application_id',
  /** column name */
  DailyLateFeeAmount = 'daily_late_fee_amount',
  /** column name */
  DoNotRenewNoticeSentAt = 'do_not_renew_notice_sent_at',
  /** column name */
  DoNotRenewReason = 'do_not_renew_reason',
  /** column name */
  DoNotRenewSelectedAt = 'do_not_renew_selected_at',
  /** column name */
  DoNotRenewSelectedByAdminId = 'do_not_renew_selected_by_admin_id',
  /** column name */
  FinalLiabilityDate = 'final_liability_date',
  /** column name */
  HasSignedUtilityAddendum = 'has_signed_utility_addendum',
  /** column name */
  Id = 'id',
  /** column name */
  InitialLeaseTerm = 'initial_lease_term',
  /** column name */
  InitialOptionPremium = 'initial_option_premium',
  /** column name */
  IsCardPaymentAllowed = 'is_card_payment_allowed',
  /** column name */
  IsStatementsEnabled = 'is_statements_enabled',
  /** column name */
  LastStatementSentAt = 'last_statement_sent_at',
  /** column name */
  LeaseEndReason = 'lease_end_reason',
  /** column name */
  LeaseVariant = 'lease_variant',
  /** column name */
  MinimumMonthlyOptionPremium = 'minimum_monthly_option_premium',
  /** column name */
  MoveOutDate = 'move_out_date',
  /** column name */
  OccupancyDate = 'occupancy_date',
  /** column name */
  PoaEffectiveDate = 'poa_effective_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RentalProgramType = 'rental_program_type',
  /** column name */
  SecurityDeposit = 'security_deposit',
  /** column name */
  Status = 'status',
  /** column name */
  TargetMonthlyOptionPremium = 'target_monthly_option_premium',
  /** column name */
  TenantNoticeGivenOnDate = 'tenant_notice_given_on_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ZendeskId = 'zendesk_id'
}

/** input type for updating data in table "rentals" */
export type Rentals_Set_Input = {
  auto_charge?: InputMaybe<Scalars['Boolean']['input']>;
  do_not_renew_reason?: InputMaybe<Scalars['String']['input']>;
  do_not_renew_selected_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  final_liability_date?: InputMaybe<Scalars['date']['input']>;
  is_card_payment_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  lease_end_reason?: InputMaybe<Scalars['String']['input']>;
  move_out_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_monthly_option_premium?: InputMaybe<Scalars['Int']['input']>;
  tenant_notice_given_on_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by stddev() on columns of table "rentals" */
export type Rentals_Stddev_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rentals" */
export type Rentals_Stddev_Pop_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rentals" */
export type Rentals_Stddev_Samp_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rentals" */
export type Rentals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rentals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rentals_Stream_Cursor_Value_Input = {
  auto_charge?: InputMaybe<Scalars['Boolean']['input']>;
  buildium_lease_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
  daily_late_fee_amount?: InputMaybe<Scalars['numeric']['input']>;
  do_not_renew_notice_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_renew_reason?: InputMaybe<Scalars['String']['input']>;
  do_not_renew_selected_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  final_liability_date?: InputMaybe<Scalars['date']['input']>;
  has_signed_utility_addendum?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_lease_term?: InputMaybe<Scalars['Int']['input']>;
  initial_option_premium?: InputMaybe<Scalars['Int']['input']>;
  is_card_payment_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  is_statements_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_statement_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_end_reason?: InputMaybe<Scalars['String']['input']>;
  lease_variant?: InputMaybe<Lease_Variants_Enum_Enum>;
  minimum_monthly_option_premium?: InputMaybe<Scalars['numeric']['input']>;
  move_out_date?: InputMaybe<Scalars['date']['input']>;
  occupancy_date?: InputMaybe<Scalars['date']['input']>;
  poa_effective_date?: InputMaybe<Scalars['date']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_program_type?: InputMaybe<Rental_Program_Types_Enum_Enum>;
  security_deposit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_monthly_option_premium?: InputMaybe<Scalars['Int']['input']>;
  tenant_notice_given_on_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  zendesk_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "rentals" */
export type Rentals_Sum_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

export type Rentals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rentals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rentals_Set_Input>;
  where: Rentals_Bool_Exp;
};

/** order by var_pop() on columns of table "rentals" */
export type Rentals_Var_Pop_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rentals" */
export type Rentals_Var_Samp_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rentals" */
export type Rentals_Variance_Order_By = {
  buildium_lease_id?: InputMaybe<Order_By>;
  daily_late_fee_amount?: InputMaybe<Order_By>;
  initial_lease_term?: InputMaybe<Order_By>;
  initial_option_premium?: InputMaybe<Order_By>;
  minimum_monthly_option_premium?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  target_monthly_option_premium?: InputMaybe<Order_By>;
};

/** columns and relationships of "saferent_requests" */
export type Saferent_Requests = {
  __typename: 'saferent_requests';
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  saferent_xml_response?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  triggered_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "saferent_requests". All fields are combined with a logical 'AND'. */
export type Saferent_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Saferent_Requests_Bool_Exp>>;
  _not?: InputMaybe<Saferent_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Saferent_Requests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  saferent_xml_response?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  triggered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** response of any mutation on the table "saferent_requests" */
export type Saferent_Requests_Mutation_Response = {
  __typename: 'saferent_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Saferent_Requests>;
};

/** Ordering options when selecting data from "saferent_requests". */
export type Saferent_Requests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  saferent_xml_response?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  triggered_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: saferent_requests */
export type Saferent_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "saferent_requests" */
export enum Saferent_Requests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SaferentXmlResponse = 'saferent_xml_response',
  /** column name */
  Status = 'status',
  /** column name */
  TriggeredAt = 'triggered_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "saferent_requests" */
export type Saferent_Requests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  saferent_xml_response?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "saferent_requests" */
export type Saferent_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Saferent_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Saferent_Requests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  saferent_xml_response?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Saferent_Requests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Saferent_Requests_Set_Input>;
  where: Saferent_Requests_Bool_Exp;
};

/** columns and relationships of "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities = {
  __typename: 'scheduled_rental_liabilities';
  amount: Scalars['numeric']['output'];
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  canceled_by_admin?: Maybe<Admins>;
  canceled_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_admin: Admins;
  created_by_admin_id: Scalars['uuid']['output'];
  /** Contractual due date. KCPOA initial option fee dates are immutable after issuance. */
  due_date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  last_attempted_at?: Maybe<Scalars['timestamptz']['output']>;
  last_error?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  note: Scalars['String']['output'];
  posted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  renewal?: Maybe<Renewals>;
  renewal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  resolved_by_admin?: Maybe<Admins>;
  resolved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Aggregate_Order_By = {
  avg?: InputMaybe<Scheduled_Rental_Liabilities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scheduled_Rental_Liabilities_Max_Order_By>;
  min?: InputMaybe<Scheduled_Rental_Liabilities_Min_Order_By>;
  stddev?: InputMaybe<Scheduled_Rental_Liabilities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scheduled_Rental_Liabilities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scheduled_Rental_Liabilities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scheduled_Rental_Liabilities_Sum_Order_By>;
  var_pop?: InputMaybe<Scheduled_Rental_Liabilities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scheduled_Rental_Liabilities_Var_Samp_Order_By>;
  variance?: InputMaybe<Scheduled_Rental_Liabilities_Variance_Order_By>;
};

/** order by avg() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scheduled_rental_liabilities". All fields are combined with a logical 'AND'. */
export type Scheduled_Rental_Liabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Scheduled_Rental_Liabilities_Bool_Exp>>;
  _not?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Scheduled_Rental_Liabilities_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceled_by_admin?: InputMaybe<Admins_Bool_Exp>;
  canceled_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin?: InputMaybe<Admins_Bool_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_attempted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_error?: InputMaybe<String_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  posted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  renewal?: InputMaybe<Renewals_Bool_Exp>;
  renewal_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resolved_by_admin?: InputMaybe<Admins_Bool_Exp>;
  resolved_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  /** Contractual due date. KCPOA initial option fee dates are immutable after issuance. */
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_attempted_at?: InputMaybe<Order_By>;
  last_error?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  renewal_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  /** Contractual due date. KCPOA initial option fee dates are immutable after issuance. */
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_attempted_at?: InputMaybe<Order_By>;
  last_error?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  renewal_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "scheduled_rental_liabilities". */
export type Scheduled_Rental_Liabilities_Order_By = {
  amount?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  canceled_by_admin?: InputMaybe<Admins_Order_By>;
  canceled_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin?: InputMaybe<Admins_Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_attempted_at?: InputMaybe<Order_By>;
  last_error?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Renewals_Order_By>;
  renewal_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_admin?: InputMaybe<Admins_Order_By>;
  resolved_by_admin_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scheduled_rental_liabilities" */
export enum Scheduled_Rental_Liabilities_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledByAdminId = 'canceled_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastAttemptedAt = 'last_attempted_at',
  /** column name */
  LastError = 'last_error',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Note = 'note',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  RenewalId = 'renewal_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedByAdminId = 'resolved_by_admin_id',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scheduled_Rental_Liabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scheduled_Rental_Liabilities_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  canceled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Contractual due date. KCPOA initial option fee dates are immutable after issuance. */
  due_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_attempted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_error?: InputMaybe<Scalars['String']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  renewal_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "scheduled_rental_liabilities" */
export type Scheduled_Rental_Liabilities_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "security_enum" */
export type Security_Enum = {
  __typename: 'security_enum';
  name: Scalars['String']['output'];
  /** An array relationship */
  portfolio_home_external_features: Array<Portfolio_Home_External_Features>;
};


/** columns and relationships of "security_enum" */
export type Security_EnumPortfolio_Home_External_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_External_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_External_Features_Order_By>>;
  where?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "security_enum". All fields are combined with a logical 'AND'. */
export type Security_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Security_Enum_Bool_Exp>>;
  _not?: InputMaybe<Security_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Security_Enum_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  portfolio_home_external_features?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "security_enum". */
export type Security_Enum_Order_By = {
  name?: InputMaybe<Order_By>;
  portfolio_home_external_features_aggregate?: InputMaybe<Portfolio_Home_External_Features_Aggregate_Order_By>;
};

/** select columns of table "security_enum" */
export enum Security_Enum_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "security_enum" */
export type Security_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Security_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Security_Enum_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "seller_agent_searchable" */
export type Seller_Agent_Searchable = {
  __typename: 'seller_agent_searchable';
  contact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  seller_agent?: Maybe<Seller_Agents>;
};

/** Boolean expression to filter rows from the table "seller_agent_searchable". All fields are combined with a logical 'AND'. */
export type Seller_Agent_Searchable_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Agent_Searchable_Bool_Exp>>;
  _not?: InputMaybe<Seller_Agent_Searchable_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Agent_Searchable_Bool_Exp>>;
  contact?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  seller_agent?: InputMaybe<Seller_Agents_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_agent_searchable". */
export type Seller_Agent_Searchable_Order_By = {
  contact?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  seller_agent?: InputMaybe<Seller_Agents_Order_By>;
};

/** select columns of table "seller_agent_searchable" */
export enum Seller_Agent_Searchable_Select_Column {
  /** column name */
  Contact = 'contact',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "seller_agent_searchable" */
export type Seller_Agent_Searchable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Agent_Searchable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Agent_Searchable_Stream_Cursor_Value_Input = {
  contact?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "seller_agents" */
export type Seller_Agents = {
  __typename: 'seller_agents';
  close_lead_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  do_not_contact?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_contacted_at?: Maybe<Scalars['timestamptz']['output']>;
  last_name: Scalars['String']['output'];
  mls: Scalars['String']['output'];
  /** An array relationship */
  mlsListingsByCoListingAgentId: Array<Mls_Listings>;
  mls_id: Scalars['String']['output'];
  /** An array relationship */
  mls_listings: Array<Mls_Listings>;
  permission_for_all_postings?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  seller_agent_searchable?: Maybe<Seller_Agent_Searchable>;
  seller_office_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "seller_agents" */
export type Seller_AgentsMlsListingsByCoListingAgentIdArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listings_Order_By>>;
  where?: InputMaybe<Mls_Listings_Bool_Exp>;
};


/** columns and relationships of "seller_agents" */
export type Seller_AgentsMls_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listings_Order_By>>;
  where?: InputMaybe<Mls_Listings_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "seller_agents". All fields are combined with a logical 'AND'. */
export type Seller_Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Agents_Bool_Exp>>;
  _not?: InputMaybe<Seller_Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Agents_Bool_Exp>>;
  close_lead_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  do_not_contact?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_contacted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  mls?: InputMaybe<String_Comparison_Exp>;
  mlsListingsByCoListingAgentId?: InputMaybe<Mls_Listings_Bool_Exp>;
  mls_id?: InputMaybe<String_Comparison_Exp>;
  mls_listings?: InputMaybe<Mls_Listings_Bool_Exp>;
  permission_for_all_postings?: InputMaybe<Boolean_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  seller_agent_searchable?: InputMaybe<Seller_Agent_Searchable_Bool_Exp>;
  seller_office_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "seller_agents". */
export type Seller_Agents_Order_By = {
  close_lead_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  do_not_contact?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_contacted_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  mls?: InputMaybe<Order_By>;
  mlsListingsByCoListingAgentId_aggregate?: InputMaybe<Mls_Listings_Aggregate_Order_By>;
  mls_id?: InputMaybe<Order_By>;
  mls_listings_aggregate?: InputMaybe<Mls_Listings_Aggregate_Order_By>;
  permission_for_all_postings?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  seller_agent_searchable?: InputMaybe<Seller_Agent_Searchable_Order_By>;
  seller_office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "seller_agents" */
export enum Seller_Agents_Select_Column {
  /** column name */
  CloseLeadId = 'close_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotContact = 'do_not_contact',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastContactedAt = 'last_contacted_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Mls = 'mls',
  /** column name */
  MlsId = 'mls_id',
  /** column name */
  PermissionForAllPostings = 'permission_for_all_postings',
  /** column name */
  Phone = 'phone',
  /** column name */
  SellerOfficeId = 'seller_office_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "seller_agents" */
export type Seller_Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Agents_Stream_Cursor_Value_Input = {
  close_lead_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_contact?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_contacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  mls?: InputMaybe<Scalars['String']['input']>;
  mls_id?: InputMaybe<Scalars['String']['input']>;
  permission_for_all_postings?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  seller_office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

/** columns and relationships of "statements" */
export type Statements = {
  __typename: 'statements';
  address?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ending_balance?: Maybe<Scalars['numeric']['output']>;
  ending_premium_factor?: Maybe<Scalars['numeric']['output']>;
  expenses?: Maybe<Scalars['numeric']['output']>;
  hpa?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  income?: Maybe<Scalars['numeric']['output']>;
  investment?: Maybe<Scalars['numeric']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  monthly_return?: Maybe<Scalars['numeric']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  shared_profits?: Maybe<Scalars['numeric']['output']>;
  starting_balance?: Maybe<Scalars['numeric']['output']>;
  starting_premium_factor?: Maybe<Scalars['numeric']['output']>;
  sum_contributions?: Maybe<Scalars['numeric']['output']>;
  sum_shared_hpa?: Maybe<Scalars['numeric']['output']>;
  sum_shared_profits?: Maybe<Scalars['numeric']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "statements" */
export type Statements_Aggregate_Order_By = {
  avg?: InputMaybe<Statements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Statements_Max_Order_By>;
  min?: InputMaybe<Statements_Min_Order_By>;
  stddev?: InputMaybe<Statements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Statements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Statements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Statements_Sum_Order_By>;
  var_pop?: InputMaybe<Statements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Statements_Var_Samp_Order_By>;
  variance?: InputMaybe<Statements_Variance_Order_By>;
};

/** order by avg() on columns of table "statements" */
export type Statements_Avg_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "statements". All fields are combined with a logical 'AND'. */
export type Statements_Bool_Exp = {
  _and?: InputMaybe<Array<Statements_Bool_Exp>>;
  _not?: InputMaybe<Statements_Bool_Exp>;
  _or?: InputMaybe<Array<Statements_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  ending_balance?: InputMaybe<Numeric_Comparison_Exp>;
  ending_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  expenses?: InputMaybe<Numeric_Comparison_Exp>;
  hpa?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income?: InputMaybe<Numeric_Comparison_Exp>;
  investment?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  monthly_return?: InputMaybe<Numeric_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_profits?: InputMaybe<Numeric_Comparison_Exp>;
  starting_balance?: InputMaybe<Numeric_Comparison_Exp>;
  starting_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  sum_contributions?: InputMaybe<Numeric_Comparison_Exp>;
  sum_shared_hpa?: InputMaybe<Numeric_Comparison_Exp>;
  sum_shared_profits?: InputMaybe<Numeric_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "statements" */
export type Statements_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "statements" */
export type Statements_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "statements". */
export type Statements_Order_By = {
  address?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** columns and relationships of "statements_raw" */
export type Statements_Raw = {
  __typename: 'statements_raw';
  address: Scalars['String']['output'];
  adjustments?: Maybe<Scalars['numeric']['output']>;
  date: Scalars['date']['output'];
  ending_balance: Scalars['numeric']['output'];
  ending_premium_factor: Scalars['numeric']['output'];
  expenses: Scalars['numeric']['output'];
  hpa: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  income: Scalars['numeric']['output'];
  investment: Scalars['numeric']['output'];
  month: Scalars['String']['output'];
  monthly_return?: Maybe<Scalars['numeric']['output']>;
  property_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  shared_profits: Scalars['numeric']['output'];
  snapshot_balance?: Maybe<Scalars['numeric']['output']>;
  snapshot_premium_factor?: Maybe<Scalars['numeric']['output']>;
  starting_balance: Scalars['numeric']['output'];
  starting_premium_factor: Scalars['numeric']['output'];
  sum_contributions: Scalars['numeric']['output'];
  sum_shared_hpa: Scalars['numeric']['output'];
  sum_shared_profits: Scalars['numeric']['output'];
  tenant: Scalars['String']['output'];
};

/** order by aggregate values of table "statements_raw" */
export type Statements_Raw_Aggregate_Order_By = {
  avg?: InputMaybe<Statements_Raw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Statements_Raw_Max_Order_By>;
  min?: InputMaybe<Statements_Raw_Min_Order_By>;
  stddev?: InputMaybe<Statements_Raw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Statements_Raw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Statements_Raw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Statements_Raw_Sum_Order_By>;
  var_pop?: InputMaybe<Statements_Raw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Statements_Raw_Var_Samp_Order_By>;
  variance?: InputMaybe<Statements_Raw_Variance_Order_By>;
};

/** order by avg() on columns of table "statements_raw" */
export type Statements_Raw_Avg_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "statements_raw". All fields are combined with a logical 'AND'. */
export type Statements_Raw_Bool_Exp = {
  _and?: InputMaybe<Array<Statements_Raw_Bool_Exp>>;
  _not?: InputMaybe<Statements_Raw_Bool_Exp>;
  _or?: InputMaybe<Array<Statements_Raw_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  adjustments?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  ending_balance?: InputMaybe<Numeric_Comparison_Exp>;
  ending_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  expenses?: InputMaybe<Numeric_Comparison_Exp>;
  hpa?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income?: InputMaybe<Numeric_Comparison_Exp>;
  investment?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  monthly_return?: InputMaybe<Numeric_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_profits?: InputMaybe<Numeric_Comparison_Exp>;
  snapshot_balance?: InputMaybe<Numeric_Comparison_Exp>;
  snapshot_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  starting_balance?: InputMaybe<Numeric_Comparison_Exp>;
  starting_premium_factor?: InputMaybe<Numeric_Comparison_Exp>;
  sum_contributions?: InputMaybe<Numeric_Comparison_Exp>;
  sum_shared_hpa?: InputMaybe<Numeric_Comparison_Exp>;
  sum_shared_profits?: InputMaybe<Numeric_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "statements_raw" */
export type Statements_Raw_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  adjustments?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "statements_raw" */
export type Statements_Raw_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  adjustments?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "statements_raw". */
export type Statements_Raw_Order_By = {
  address?: InputMaybe<Order_By>;
  adjustments?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** select columns of table "statements_raw" */
export enum Statements_Raw_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Adjustments = 'adjustments',
  /** column name */
  Date = 'date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  EndingPremiumFactor = 'ending_premium_factor',
  /** column name */
  Expenses = 'expenses',
  /** column name */
  Hpa = 'hpa',
  /** column name */
  Id = 'id',
  /** column name */
  Income = 'income',
  /** column name */
  Investment = 'investment',
  /** column name */
  Month = 'month',
  /** column name */
  MonthlyReturn = 'monthly_return',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SharedProfits = 'shared_profits',
  /** column name */
  SnapshotBalance = 'snapshot_balance',
  /** column name */
  SnapshotPremiumFactor = 'snapshot_premium_factor',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StartingPremiumFactor = 'starting_premium_factor',
  /** column name */
  SumContributions = 'sum_contributions',
  /** column name */
  SumSharedHpa = 'sum_shared_hpa',
  /** column name */
  SumSharedProfits = 'sum_shared_profits',
  /** column name */
  Tenant = 'tenant'
}

/** order by stddev() on columns of table "statements_raw" */
export type Statements_Raw_Stddev_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "statements_raw" */
export type Statements_Raw_Stddev_Pop_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "statements_raw" */
export type Statements_Raw_Stddev_Samp_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "statements_raw" */
export type Statements_Raw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Statements_Raw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Statements_Raw_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  adjustments?: InputMaybe<Scalars['numeric']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  ending_balance?: InputMaybe<Scalars['numeric']['input']>;
  ending_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  expenses?: InputMaybe<Scalars['numeric']['input']>;
  hpa?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income?: InputMaybe<Scalars['numeric']['input']>;
  investment?: InputMaybe<Scalars['numeric']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  monthly_return?: InputMaybe<Scalars['numeric']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  shared_profits?: InputMaybe<Scalars['numeric']['input']>;
  snapshot_balance?: InputMaybe<Scalars['numeric']['input']>;
  snapshot_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  starting_balance?: InputMaybe<Scalars['numeric']['input']>;
  starting_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  sum_contributions?: InputMaybe<Scalars['numeric']['input']>;
  sum_shared_hpa?: InputMaybe<Scalars['numeric']['input']>;
  sum_shared_profits?: InputMaybe<Scalars['numeric']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "statements_raw" */
export type Statements_Raw_Sum_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "statements_raw" */
export type Statements_Raw_Var_Pop_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "statements_raw" */
export type Statements_Raw_Var_Samp_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "statements_raw" */
export type Statements_Raw_Variance_Order_By = {
  adjustments?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  snapshot_balance?: InputMaybe<Order_By>;
  snapshot_premium_factor?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** select columns of table "statements" */
export enum Statements_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Date = 'date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  EndingPremiumFactor = 'ending_premium_factor',
  /** column name */
  Expenses = 'expenses',
  /** column name */
  Hpa = 'hpa',
  /** column name */
  Id = 'id',
  /** column name */
  Income = 'income',
  /** column name */
  Investment = 'investment',
  /** column name */
  Month = 'month',
  /** column name */
  MonthlyReturn = 'monthly_return',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  SharedProfits = 'shared_profits',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StartingPremiumFactor = 'starting_premium_factor',
  /** column name */
  SumContributions = 'sum_contributions',
  /** column name */
  SumSharedHpa = 'sum_shared_hpa',
  /** column name */
  SumSharedProfits = 'sum_shared_profits',
  /** column name */
  Tenant = 'tenant'
}

/** order by stddev() on columns of table "statements" */
export type Statements_Stddev_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "statements" */
export type Statements_Stddev_Pop_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "statements" */
export type Statements_Stddev_Samp_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "statements" */
export type Statements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Statements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Statements_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  ending_balance?: InputMaybe<Scalars['numeric']['input']>;
  ending_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  expenses?: InputMaybe<Scalars['numeric']['input']>;
  hpa?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income?: InputMaybe<Scalars['numeric']['input']>;
  investment?: InputMaybe<Scalars['numeric']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  monthly_return?: InputMaybe<Scalars['numeric']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  shared_profits?: InputMaybe<Scalars['numeric']['input']>;
  starting_balance?: InputMaybe<Scalars['numeric']['input']>;
  starting_premium_factor?: InputMaybe<Scalars['numeric']['input']>;
  sum_contributions?: InputMaybe<Scalars['numeric']['input']>;
  sum_shared_hpa?: InputMaybe<Scalars['numeric']['input']>;
  sum_shared_profits?: InputMaybe<Scalars['numeric']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "statements" */
export type Statements_Sum_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "statements" */
export type Statements_Var_Pop_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "statements" */
export type Statements_Var_Samp_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "statements" */
export type Statements_Variance_Order_By = {
  ending_balance?: InputMaybe<Order_By>;
  ending_premium_factor?: InputMaybe<Order_By>;
  expenses?: InputMaybe<Order_By>;
  hpa?: InputMaybe<Order_By>;
  income?: InputMaybe<Order_By>;
  investment?: InputMaybe<Order_By>;
  monthly_return?: InputMaybe<Order_By>;
  shared_profits?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  starting_premium_factor?: InputMaybe<Order_By>;
  sum_contributions?: InputMaybe<Order_By>;
  sum_shared_hpa?: InputMaybe<Order_By>;
  sum_shared_profits?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename: 'subscription_root';
  /** An array relationship */
  addresses: Array<Addresses>;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** An array relationship */
  admin_capabilities: Array<Admin_Capabilities>;
  /** fetch data from the table: "admin_capabilities" using primary key columns */
  admin_capabilities_by_pk?: Maybe<Admin_Capabilities>;
  /** fetch data from the table in a streaming manner: "admin_capabilities" */
  admin_capabilities_stream: Array<Admin_Capabilities>;
  /** fetch data from the table: "admin_searchable" */
  admin_searchable: Array<Admin_Searchable>;
  /** fetch aggregated fields from the table: "admin_searchable" */
  admin_searchable_aggregate: Admin_Searchable_Aggregate;
  /** fetch data from the table in a streaming manner: "admin_searchable" */
  admin_searchable_stream: Array<Admin_Searchable>;
  /** fetch data from the table: "admins" */
  admins: Array<Admins>;
  /** fetch data from the table: "admins" using primary key columns */
  admins_by_pk?: Maybe<Admins>;
  /** fetch data from the table in a streaming manner: "admins" */
  admins_stream: Array<Admins>;
  /** An array relationship */
  agent_lead_group_owners: Array<Agent_Lead_Group_Owners>;
  /** fetch data from the table: "agent_lead_group_owners_agent_type_enum" */
  agent_lead_group_owners_agent_type_enum: Array<Agent_Lead_Group_Owners_Agent_Type_Enum>;
  /** fetch data from the table: "agent_lead_group_owners_agent_type_enum" using primary key columns */
  agent_lead_group_owners_agent_type_enum_by_pk?: Maybe<Agent_Lead_Group_Owners_Agent_Type_Enum>;
  /** fetch data from the table in a streaming manner: "agent_lead_group_owners_agent_type_enum" */
  agent_lead_group_owners_agent_type_enum_stream: Array<Agent_Lead_Group_Owners_Agent_Type_Enum>;
  /** fetch data from the table: "agent_lead_group_owners" using primary key columns */
  agent_lead_group_owners_by_pk?: Maybe<Agent_Lead_Group_Owners>;
  /** fetch data from the table in a streaming manner: "agent_lead_group_owners" */
  agent_lead_group_owners_stream: Array<Agent_Lead_Group_Owners>;
  /** fetch data from the table: "agent_portfolio_home_owners" */
  agent_portfolio_home_owners: Array<Agent_Portfolio_Home_Owners>;
  /** fetch data from the table: "agent_portfolio_home_owners" using primary key columns */
  agent_portfolio_home_owners_by_pk?: Maybe<Agent_Portfolio_Home_Owners>;
  /** fetch data from the table in a streaming manner: "agent_portfolio_home_owners" */
  agent_portfolio_home_owners_stream: Array<Agent_Portfolio_Home_Owners>;
  /** fetch data from the table: "agent_user_owners" */
  agent_user_owners: Array<Agent_User_Owners>;
  /** fetch data from the table: "agent_user_owners" using primary key columns */
  agent_user_owners_by_pk?: Maybe<Agent_User_Owners>;
  /** fetch data from the table in a streaming manner: "agent_user_owners" */
  agent_user_owners_stream: Array<Agent_User_Owners>;
  /** fetch data from the table: "agents" */
  agents: Array<Agents>;
  /** fetch data from the table: "agents" using primary key columns */
  agents_by_pk?: Maybe<Agents>;
  /** fetch data from the table in a streaming manner: "agents" */
  agents_stream: Array<Agents>;
  /** An array relationship */
  agreement_signers: Array<Agreement_Signers>;
  /** fetch data from the table: "agreement_signers" using primary key columns */
  agreement_signers_by_pk?: Maybe<Agreement_Signers>;
  /** fetch data from the table: "agreement_template_types_enum" */
  agreement_template_types_enum: Array<Agreement_Template_Types_Enum>;
  /** fetch data from the table: "agreement_template_types_enum" using primary key columns */
  agreement_template_types_enum_by_pk?: Maybe<Agreement_Template_Types_Enum>;
  /** fetch data from the table in a streaming manner: "agreement_template_types_enum" */
  agreement_template_types_enum_stream: Array<Agreement_Template_Types_Enum>;
  /** fetch data from the table: "agreement_templates" */
  agreement_templates: Array<Agreement_Templates>;
  /** fetch data from the table: "agreement_templates" using primary key columns */
  agreement_templates_by_pk?: Maybe<Agreement_Templates>;
  /** fetch data from the table in a streaming manner: "agreement_templates" */
  agreement_templates_stream: Array<Agreement_Templates>;
  /** An array relationship */
  agreements: Array<Agreements>;
  /** fetch data from the table: "agreements" using primary key columns */
  agreements_by_pk?: Maybe<Agreements>;
  /** fetch data from the table in a streaming manner: "agreements" */
  agreements_stream: Array<Agreements>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_employment_verification_statuses_enum" */
  applicant_income_underwrites_user_income_employment_verification_statuses_enum: Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_employment_verification_statuses_enum" using primary key columns */
  applicant_income_underwrites_user_income_employment_verification_statuses_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_employment_verification_statuses_enum" */
  applicant_income_underwrites_user_income_employment_verification_statuses_enum_stream: Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_documents" */
  applicant_income_underwrites_user_income_source_documents: Array<Applicant_Income_Underwrites_User_Income_Source_Documents>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_documents" using primary key columns */
  applicant_income_underwrites_user_income_source_documents_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Documents>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_source_documents" */
  applicant_income_underwrites_user_income_source_documents_stream: Array<Applicant_Income_Underwrites_User_Income_Source_Documents>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_pay_frequencies_enum" */
  applicant_income_underwrites_user_income_source_pay_frequencies_enum: Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_pay_frequencies_enum" using primary key columns */
  applicant_income_underwrites_user_income_source_pay_frequencies_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_source_pay_frequencies_enum" */
  applicant_income_underwrites_user_income_source_pay_frequencies_enum_stream: Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_statuses_enum" */
  applicant_income_underwrites_user_income_source_statuses_enum: Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_statuses_enum" using primary key columns */
  applicant_income_underwrites_user_income_source_statuses_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_source_statuses_enum" */
  applicant_income_underwrites_user_income_source_statuses_enum_stream: Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_types_enum" */
  applicant_income_underwrites_user_income_source_types_enum: Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_source_types_enum" using primary key columns */
  applicant_income_underwrites_user_income_source_types_enum_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_source_types_enum" */
  applicant_income_underwrites_user_income_source_types_enum_stream: Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources" */
  applicant_income_underwrites_user_income_sources: Array<Applicant_Income_Underwrites_User_Income_Sources>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_benefits" */
  applicant_income_underwrites_user_income_sources_benefits: Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_benefits" using primary key columns */
  applicant_income_underwrites_user_income_sources_benefits_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_sources_benefits" */
  applicant_income_underwrites_user_income_sources_benefits_stream: Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources" using primary key columns */
  applicant_income_underwrites_user_income_sources_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_employed" */
  applicant_income_underwrites_user_income_sources_employed: Array<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_employed" using primary key columns */
  applicant_income_underwrites_user_income_sources_employed_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_sources_employed" */
  applicant_income_underwrites_user_income_sources_employed_stream: Array<Applicant_Income_Underwrites_User_Income_Sources_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_self_employed" */
  applicant_income_underwrites_user_income_sources_self_employed: Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed>;
  /** fetch data from the table: "applicant_income_underwrites.user_income_sources_self_employed" using primary key columns */
  applicant_income_underwrites_user_income_sources_self_employed_by_pk?: Maybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_sources_self_employed" */
  applicant_income_underwrites_user_income_sources_self_employed_stream: Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_income_sources" */
  applicant_income_underwrites_user_income_sources_stream: Array<Applicant_Income_Underwrites_User_Income_Sources>;
  /** fetch data from the table: "applicant_income_underwrites.user_incomes" */
  applicant_income_underwrites_user_incomes: Array<Applicant_Income_Underwrites_User_Incomes>;
  /** fetch data from the table: "applicant_income_underwrites.user_incomes" using primary key columns */
  applicant_income_underwrites_user_incomes_by_pk?: Maybe<Applicant_Income_Underwrites_User_Incomes>;
  /** fetch data from the table in a streaming manner: "applicant_income_underwrites.user_incomes" */
  applicant_income_underwrites_user_incomes_stream: Array<Applicant_Income_Underwrites_User_Incomes>;
  /** fetch data from the table: "background_check_requests" */
  background_check_requests: Array<Background_Check_Requests>;
  /** fetch data from the table: "background_check_requests" using primary key columns */
  background_check_requests_by_pk?: Maybe<Background_Check_Requests>;
  /** fetch data from the table in a streaming manner: "background_check_requests" */
  background_check_requests_stream: Array<Background_Check_Requests>;
  /** An array relationship */
  bids: Array<Bids>;
  /** fetch data from the table: "bids" using primary key columns */
  bids_by_pk?: Maybe<Bids>;
  /** fetch data from the table in a streaming manner: "bids" */
  bids_stream: Array<Bids>;
  /** fetch data from the table: "buildium_bulk_journal_entry_uploads" */
  buildium_bulk_journal_entry_uploads: Array<Buildium_Bulk_Journal_Entry_Uploads>;
  /** fetch data from the table: "buildium_bulk_journal_entry_uploads" using primary key columns */
  buildium_bulk_journal_entry_uploads_by_pk?: Maybe<Buildium_Bulk_Journal_Entry_Uploads>;
  /** fetch data from the table in a streaming manner: "buildium_bulk_journal_entry_uploads" */
  buildium_bulk_journal_entry_uploads_stream: Array<Buildium_Bulk_Journal_Entry_Uploads>;
  /** fetch data from the table: "buildium_resident_center_users" */
  buildium_resident_center_users: Array<Buildium_Resident_Center_Users>;
  /** fetch data from the table: "buildium_resident_center_users" using primary key columns */
  buildium_resident_center_users_by_pk?: Maybe<Buildium_Resident_Center_Users>;
  /** fetch data from the table in a streaming manner: "buildium_resident_center_users" */
  buildium_resident_center_users_stream: Array<Buildium_Resident_Center_Users>;
  /** fetch data from the table: "buildium_transactions" */
  buildium_transactions: Array<Buildium_Transactions>;
  /** fetch data from the table: "buildium_transactions" using primary key columns */
  buildium_transactions_by_pk?: Maybe<Buildium_Transactions>;
  /** fetch data from the table in a streaming manner: "buildium_transactions" */
  buildium_transactions_stream: Array<Buildium_Transactions>;
  /** fetch data from the table: "capabilities" */
  capabilities: Array<Capabilities>;
  /** fetch data from the table: "capabilities" using primary key columns */
  capabilities_by_pk?: Maybe<Capabilities>;
  /** fetch data from the table in a streaming manner: "capabilities" */
  capabilities_stream: Array<Capabilities>;
  /** An array relationship */
  cashout_adjustments: Array<Cashout_Adjustments>;
  /** fetch data from the table: "cashout_adjustments" using primary key columns */
  cashout_adjustments_by_pk?: Maybe<Cashout_Adjustments>;
  /** fetch data from the table in a streaming manner: "cashout_adjustments" */
  cashout_adjustments_stream: Array<Cashout_Adjustments>;
  /** fetch data from the table: "cashout_configs" */
  cashout_configs: Array<Cashout_Configs>;
  /** fetch data from the table: "cashout_configs" using primary key columns */
  cashout_configs_by_pk?: Maybe<Cashout_Configs>;
  /** fetch data from the table in a streaming manner: "cashout_configs" */
  cashout_configs_stream: Array<Cashout_Configs>;
  /** fetch data from the table: "cashouts" */
  cashouts: Array<Cashouts>;
  /** fetch data from the table: "cashouts" using primary key columns */
  cashouts_by_pk?: Maybe<Cashouts>;
  /** An array relationship */
  cashouts_pending_liabilities: Array<Cashouts_Pending_Liabilities>;
  /** fetch data from the table: "cashouts_pending_liabilities" using primary key columns */
  cashouts_pending_liabilities_by_pk?: Maybe<Cashouts_Pending_Liabilities>;
  /** fetch data from the table in a streaming manner: "cashouts_pending_liabilities" */
  cashouts_pending_liabilities_stream: Array<Cashouts_Pending_Liabilities>;
  /** fetch data from the table in a streaming manner: "cashouts" */
  cashouts_stream: Array<Cashouts>;
  /** An array relationship */
  check_deposit_payments: Array<Check_Deposit_Payments>;
  /** fetch data from the table: "check_deposit_payments" using primary key columns */
  check_deposit_payments_by_pk?: Maybe<Check_Deposit_Payments>;
  /** fetch data from the table in a streaming manner: "check_deposit_payments" */
  check_deposit_payments_stream: Array<Check_Deposit_Payments>;
  /** fetch data from the table: "check_deposits" */
  check_deposits: Array<Check_Deposits>;
  /** fetch data from the table: "check_deposits" using primary key columns */
  check_deposits_by_pk?: Maybe<Check_Deposits>;
  /** fetch data from the table in a streaming manner: "check_deposits" */
  check_deposits_stream: Array<Check_Deposits>;
  /** An array relationship */
  collection_payment_promises: Array<Collection_Payment_Promises>;
  /** fetch data from the table: "collection_payment_promises" using primary key columns */
  collection_payment_promises_by_pk?: Maybe<Collection_Payment_Promises>;
  /** fetch data from the table in a streaming manner: "collection_payment_promises" */
  collection_payment_promises_stream: Array<Collection_Payment_Promises>;
  /** An array relationship */
  collections: Array<Collections>;
  /** fetch data from the table: "collections" using primary key columns */
  collections_by_pk?: Maybe<Collections>;
  /** fetch data from the table: "collections_late_payment_reason_enum" */
  collections_late_payment_reason_enum: Array<Collections_Late_Payment_Reason_Enum>;
  /** fetch data from the table: "collections_late_payment_reason_enum" using primary key columns */
  collections_late_payment_reason_enum_by_pk?: Maybe<Collections_Late_Payment_Reason_Enum>;
  /** fetch data from the table in a streaming manner: "collections_late_payment_reason_enum" */
  collections_late_payment_reason_enum_stream: Array<Collections_Late_Payment_Reason_Enum>;
  /** fetch data from the table: "collections_liabilities_remaining" */
  collections_liabilities_remaining: Array<Collections_Liabilities_Remaining>;
  /** fetch data from the table in a streaming manner: "collections_liabilities_remaining" */
  collections_liabilities_remaining_stream: Array<Collections_Liabilities_Remaining>;
  /** An array relationship */
  collections_rental_liabilities: Array<Collections_Rental_Liabilities>;
  /** fetch data from the table: "collections_rental_liabilities" using primary key columns */
  collections_rental_liabilities_by_pk?: Maybe<Collections_Rental_Liabilities>;
  /** fetch data from the table in a streaming manner: "collections_rental_liabilities" */
  collections_rental_liabilities_stream: Array<Collections_Rental_Liabilities>;
  /** fetch data from the table in a streaming manner: "collections" */
  collections_stream: Array<Collections>;
  /** fetch data from the table: "communities" */
  communities: Array<Communities>;
  /** fetch data from the table: "communities" using primary key columns */
  communities_by_pk?: Maybe<Communities>;
  /** fetch data from the table in a streaming manner: "communities" */
  communities_stream: Array<Communities>;
  /** fetch data from the table: "community_features" */
  community_features: Array<Community_Features>;
  /** fetch data from the table: "community_features" using primary key columns */
  community_features_by_pk?: Maybe<Community_Features>;
  /** fetch data from the table in a streaming manner: "community_features" */
  community_features_stream: Array<Community_Features>;
  /** fetch data from the table: "construction.construction_common_estimated_costs" */
  construction_construction_common_estimated_costs: Array<Construction_Construction_Common_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_common_estimated_costs" using primary key columns */
  construction_construction_common_estimated_costs_by_pk?: Maybe<Construction_Construction_Common_Estimated_Costs>;
  /** fetch data from the table in a streaming manner: "construction.construction_common_estimated_costs" */
  construction_construction_common_estimated_costs_stream: Array<Construction_Construction_Common_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_project_estimated_cost_histories" */
  construction_construction_project_estimated_cost_histories: Array<Construction_Construction_Project_Estimated_Cost_Histories>;
  /** fetch data from the table: "construction.construction_project_estimated_cost_histories" using primary key columns */
  construction_construction_project_estimated_cost_histories_by_pk?: Maybe<Construction_Construction_Project_Estimated_Cost_Histories>;
  /** fetch data from the table in a streaming manner: "construction.construction_project_estimated_cost_histories" */
  construction_construction_project_estimated_cost_histories_stream: Array<Construction_Construction_Project_Estimated_Cost_Histories>;
  /** fetch data from the table: "construction.construction_project_estimated_costs" */
  construction_construction_project_estimated_costs: Array<Construction_Construction_Project_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_project_estimated_costs" using primary key columns */
  construction_construction_project_estimated_costs_by_pk?: Maybe<Construction_Construction_Project_Estimated_Costs>;
  /** fetch data from the table in a streaming manner: "construction.construction_project_estimated_costs" */
  construction_construction_project_estimated_costs_stream: Array<Construction_Construction_Project_Estimated_Costs>;
  /** fetch data from the table: "construction.construction_scopes" */
  construction_construction_scopes: Array<Construction_Construction_Scopes>;
  /** fetch data from the table: "construction.construction_scopes" using primary key columns */
  construction_construction_scopes_by_pk?: Maybe<Construction_Construction_Scopes>;
  /** fetch data from the table in a streaming manner: "construction.construction_scopes" */
  construction_construction_scopes_stream: Array<Construction_Construction_Scopes>;
  /** An array relationship */
  construction_estimates: Array<Construction_Estimates>;
  /** fetch data from the table: "construction_estimates" using primary key columns */
  construction_estimates_by_pk?: Maybe<Construction_Estimates>;
  /** fetch data from the table in a streaming manner: "construction_estimates" */
  construction_estimates_stream: Array<Construction_Estimates>;
  /** fetch data from the table: "construction.general_contractors" */
  construction_general_contractors: Array<Construction_General_Contractors>;
  /** fetch data from the table: "construction.general_contractors" using primary key columns */
  construction_general_contractors_by_pk?: Maybe<Construction_General_Contractors>;
  /** fetch data from the table in a streaming manner: "construction.general_contractors" */
  construction_general_contractors_stream: Array<Construction_General_Contractors>;
  /** fetch data from the table: "construction.occupancy_inspections" */
  construction_occupancy_inspections: Array<Construction_Occupancy_Inspections>;
  /** fetch data from the table: "construction.occupancy_inspections" using primary key columns */
  construction_occupancy_inspections_by_pk?: Maybe<Construction_Occupancy_Inspections>;
  /** fetch data from the table in a streaming manner: "construction.occupancy_inspections" */
  construction_occupancy_inspections_stream: Array<Construction_Occupancy_Inspections>;
  /** An array relationship */
  construction_projects: Array<Construction_Projects>;
  /** fetch data from the table: "construction_projects" using primary key columns */
  construction_projects_by_pk?: Maybe<Construction_Projects>;
  /** fetch data from the table in a streaming manner: "construction_projects" */
  construction_projects_stream: Array<Construction_Projects>;
  /** An array relationship */
  construction_scopes: Array<Construction_Scopes>;
  /** fetch data from the table: "construction_scopes" using primary key columns */
  construction_scopes_by_pk?: Maybe<Construction_Scopes>;
  /** fetch data from the table in a streaming manner: "construction_scopes" */
  construction_scopes_stream: Array<Construction_Scopes>;
  /** An array relationship */
  construction_scopes_vendors: Array<Construction_Scopes_Vendors>;
  /** fetch data from the table: "construction_scopes_vendors" using primary key columns */
  construction_scopes_vendors_by_pk?: Maybe<Construction_Scopes_Vendors>;
  /** fetch data from the table in a streaming manner: "construction_scopes_vendors" */
  construction_scopes_vendors_stream: Array<Construction_Scopes_Vendors>;
  /** An array relationship */
  construction_walkthroughs: Array<Construction_Walkthroughs>;
  /** fetch data from the table: "construction_walkthroughs" using primary key columns */
  construction_walkthroughs_by_pk?: Maybe<Construction_Walkthroughs>;
  /** fetch data from the table in a streaming manner: "construction_walkthroughs" */
  construction_walkthroughs_stream: Array<Construction_Walkthroughs>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** fetch data from the table: "conversations" using primary key columns */
  conversations_by_pk?: Maybe<Conversations>;
  /** fetch data from the table in a streaming manner: "conversations" */
  conversations_stream: Array<Conversations>;
  /** An array relationship */
  credit_reports: Array<Credit_Reports>;
  /** fetch data from the table: "credit_reports" using primary key columns */
  credit_reports_by_pk?: Maybe<Credit_Reports>;
  /** fetch data from the table in a streaming manner: "credit_reports" */
  credit_reports_stream: Array<Credit_Reports>;
  /** An array relationship */
  criminal_reports: Array<Criminal_Reports>;
  /** fetch data from the table: "criminal_reports" using primary key columns */
  criminal_reports_by_pk?: Maybe<Criminal_Reports>;
  /** fetch data from the table in a streaming manner: "criminal_reports" */
  criminal_reports_stream: Array<Criminal_Reports>;
  /** fetch data from the table: "current_balances" */
  current_balances: Array<Current_Balances>;
  /** fetch data from the table in a streaming manner: "current_balances" */
  current_balances_stream: Array<Current_Balances>;
  /** fetch data from the table: "current_statements" */
  current_statements: Array<Current_Statements>;
  /** fetch data from the table in a streaming manner: "current_statements" */
  current_statements_stream: Array<Current_Statements>;
  /** An array relationship */
  current_utility_responsibilities: Array<Current_Utility_Responsibilities>;
  /** fetch data from the table in a streaming manner: "current_utility_responsibilities" */
  current_utility_responsibilities_stream: Array<Current_Utility_Responsibilities>;
  /** fetch data from the table: "dashboards" */
  dashboards: Array<Dashboards>;
  /** fetch data from the table: "dashboards" using primary key columns */
  dashboards_by_pk?: Maybe<Dashboards>;
  /** fetch data from the table in a streaming manner: "dashboards" */
  dashboards_stream: Array<Dashboards>;
  /** fetch data from the table: "dispositions.buyers_inspections" */
  dispositions_buyers_inspections: Array<Dispositions_Buyers_Inspections>;
  /** fetch data from the table: "dispositions.buyers_inspections" using primary key columns */
  dispositions_buyers_inspections_by_pk?: Maybe<Dispositions_Buyers_Inspections>;
  /** fetch data from the table in a streaming manner: "dispositions.buyers_inspections" */
  dispositions_buyers_inspections_stream: Array<Dispositions_Buyers_Inspections>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_bids" */
  dispositions_portfolio_home_disposition_bids: Array<Dispositions_Portfolio_Home_Disposition_Bids>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_bids" using primary key columns */
  dispositions_portfolio_home_disposition_bids_by_pk?: Maybe<Dispositions_Portfolio_Home_Disposition_Bids>;
  /** fetch data from the table in a streaming manner: "dispositions.portfolio_home_disposition_bids" */
  dispositions_portfolio_home_disposition_bids_stream: Array<Dispositions_Portfolio_Home_Disposition_Bids>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_counterparties" */
  dispositions_portfolio_home_disposition_counterparties: Array<Dispositions_Portfolio_Home_Disposition_Counterparties>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_counterparties" using primary key columns */
  dispositions_portfolio_home_disposition_counterparties_by_pk?: Maybe<Dispositions_Portfolio_Home_Disposition_Counterparties>;
  /** fetch data from the table in a streaming manner: "dispositions.portfolio_home_disposition_counterparties" */
  dispositions_portfolio_home_disposition_counterparties_stream: Array<Dispositions_Portfolio_Home_Disposition_Counterparties>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_statuses" */
  dispositions_portfolio_home_disposition_statuses: Array<Dispositions_Portfolio_Home_Disposition_Statuses>;
  /** fetch data from the table: "dispositions.portfolio_home_disposition_statuses" using primary key columns */
  dispositions_portfolio_home_disposition_statuses_by_pk?: Maybe<Dispositions_Portfolio_Home_Disposition_Statuses>;
  /** fetch data from the table in a streaming manner: "dispositions.portfolio_home_disposition_statuses" */
  dispositions_portfolio_home_disposition_statuses_stream: Array<Dispositions_Portfolio_Home_Disposition_Statuses>;
  /** fetch data from the table: "dispositions.portfolio_home_dispositions" */
  dispositions_portfolio_home_dispositions: Array<Dispositions_Portfolio_Home_Dispositions>;
  /** fetch data from the table: "dispositions.portfolio_home_dispositions" using primary key columns */
  dispositions_portfolio_home_dispositions_by_pk?: Maybe<Dispositions_Portfolio_Home_Dispositions>;
  /** fetch data from the table in a streaming manner: "dispositions.portfolio_home_dispositions" */
  dispositions_portfolio_home_dispositions_stream: Array<Dispositions_Portfolio_Home_Dispositions>;
  /** An array relationship */
  documents: Array<Documents>;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table in a streaming manner: "documents" */
  documents_stream: Array<Documents>;
  /** An array relationship */
  down_status_incidents: Array<Down_Status_Incidents>;
  /** fetch data from the table: "down_status_incidents" using primary key columns */
  down_status_incidents_by_pk?: Maybe<Down_Status_Incidents>;
  /** fetch data from the table in a streaming manner: "down_status_incidents" */
  down_status_incidents_stream: Array<Down_Status_Incidents>;
  /** An array relationship */
  eviction_filing_fees: Array<Eviction_Filing_Fees>;
  /** fetch data from the table: "eviction_filing_fees" using primary key columns */
  eviction_filing_fees_by_pk?: Maybe<Eviction_Filing_Fees>;
  /** fetch data from the table in a streaming manner: "eviction_filing_fees" */
  eviction_filing_fees_stream: Array<Eviction_Filing_Fees>;
  /** An array relationship */
  eviction_reports: Array<Eviction_Reports>;
  /** fetch data from the table: "eviction_reports" using primary key columns */
  eviction_reports_by_pk?: Maybe<Eviction_Reports>;
  /** fetch data from the table in a streaming manner: "eviction_reports" */
  eviction_reports_stream: Array<Eviction_Reports>;
  /** An array relationship */
  evictions: Array<Evictions>;
  /** fetch data from the table: "evictions" using primary key columns */
  evictions_by_pk?: Maybe<Evictions>;
  /** fetch data from the table in a streaming manner: "evictions" */
  evictions_stream: Array<Evictions>;
  /** An array relationship */
  fund_llcs: Array<Fund_Llcs>;
  /** fetch data from the table: "fund_llcs" using primary key columns */
  fund_llcs_by_pk?: Maybe<Fund_Llcs>;
  /** fetch data from the table in a streaming manner: "fund_llcs" */
  fund_llcs_stream: Array<Fund_Llcs>;
  /** fetch data from the table: "fund_rental_program_configs" */
  fund_rental_program_configs: Array<Fund_Rental_Program_Configs>;
  /** fetch data from the table: "fund_rental_program_configs" using primary key columns */
  fund_rental_program_configs_by_pk?: Maybe<Fund_Rental_Program_Configs>;
  /** fetch data from the table in a streaming manner: "fund_rental_program_configs" */
  fund_rental_program_configs_stream: Array<Fund_Rental_Program_Configs>;
  /** fetch data from the table: "funds" */
  funds: Array<Funds>;
  /** fetch data from the table: "funds" using primary key columns */
  funds_by_pk?: Maybe<Funds>;
  /** fetch data from the table in a streaming manner: "funds" */
  funds_stream: Array<Funds>;
  /** fetch data from the table: "home_construction_status_enum" */
  home_construction_status_enum: Array<Home_Construction_Status_Enum>;
  /** fetch data from the table: "home_construction_status_enum" using primary key columns */
  home_construction_status_enum_by_pk?: Maybe<Home_Construction_Status_Enum>;
  /** fetch data from the table in a streaming manner: "home_construction_status_enum" */
  home_construction_status_enum_stream: Array<Home_Construction_Status_Enum>;
  /** fetch data from the table: "home_construction_statuses" */
  home_construction_statuses: Array<Home_Construction_Statuses>;
  /** fetch data from the table: "home_construction_statuses" using primary key columns */
  home_construction_statuses_by_pk?: Maybe<Home_Construction_Statuses>;
  /** fetch data from the table in a streaming manner: "home_construction_statuses" */
  home_construction_statuses_stream: Array<Home_Construction_Statuses>;
  /** fetch data from the table: "home_occupancy_status_enum" */
  home_occupancy_status_enum: Array<Home_Occupancy_Status_Enum>;
  /** fetch data from the table: "home_occupancy_status_enum" using primary key columns */
  home_occupancy_status_enum_by_pk?: Maybe<Home_Occupancy_Status_Enum>;
  /** fetch data from the table in a streaming manner: "home_occupancy_status_enum" */
  home_occupancy_status_enum_stream: Array<Home_Occupancy_Status_Enum>;
  /** fetch data from the table: "home_occupancy_statuses" */
  home_occupancy_statuses: Array<Home_Occupancy_Statuses>;
  /** fetch data from the table: "home_occupancy_statuses" using primary key columns */
  home_occupancy_statuses_by_pk?: Maybe<Home_Occupancy_Statuses>;
  /** fetch data from the table in a streaming manner: "home_occupancy_statuses" */
  home_occupancy_statuses_stream: Array<Home_Occupancy_Statuses>;
  /** fetch data from the table: "home_ownership_status_enum" */
  home_ownership_status_enum: Array<Home_Ownership_Status_Enum>;
  /** fetch data from the table: "home_ownership_status_enum" using primary key columns */
  home_ownership_status_enum_by_pk?: Maybe<Home_Ownership_Status_Enum>;
  /** fetch data from the table in a streaming manner: "home_ownership_status_enum" */
  home_ownership_status_enum_stream: Array<Home_Ownership_Status_Enum>;
  /** An array relationship */
  home_ownership_statuses: Array<Home_Ownership_Statuses>;
  /** fetch data from the table: "home_ownership_statuses" using primary key columns */
  home_ownership_statuses_by_pk?: Maybe<Home_Ownership_Statuses>;
  /** fetch data from the table in a streaming manner: "home_ownership_statuses" */
  home_ownership_statuses_stream: Array<Home_Ownership_Statuses>;
  /** fetch data from the table: "home_summary_status_enum" */
  home_summary_status_enum: Array<Home_Summary_Status_Enum>;
  /** fetch data from the table: "home_summary_status_enum" using primary key columns */
  home_summary_status_enum_by_pk?: Maybe<Home_Summary_Status_Enum>;
  /** fetch data from the table in a streaming manner: "home_summary_status_enum" */
  home_summary_status_enum_stream: Array<Home_Summary_Status_Enum>;
  /** fetch data from the table: "home_summary_statuses" */
  home_summary_statuses: Array<Home_Summary_Statuses>;
  /** fetch data from the table: "home_summary_statuses" using primary key columns */
  home_summary_statuses_by_pk?: Maybe<Home_Summary_Statuses>;
  /** fetch data from the table in a streaming manner: "home_summary_statuses" */
  home_summary_statuses_stream: Array<Home_Summary_Statuses>;
  /** An array relationship */
  homes: Array<Homes>;
  /** fetch data from the table: "homes360" */
  homes360: Array<Homes360>;
  /** fetch data from the table in a streaming manner: "homes360" */
  homes360_stream: Array<Homes360>;
  /** fetch data from the table: "homes" using primary key columns */
  homes_by_pk?: Maybe<Homes>;
  /** fetch data from the table in a streaming manner: "homes" */
  homes_stream: Array<Homes>;
  /** fetch data from the table: "kafka_connector.prorated_utility_bill_line_items" */
  kafka_connector_prorated_utility_bill_line_items: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** fetch data from the table: "kafka_connector.prorated_utility_bill_line_items" using primary key columns */
  kafka_connector_prorated_utility_bill_line_items_by_pk?: Maybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** fetch data from the table in a streaming manner: "kafka_connector.prorated_utility_bill_line_items" */
  kafka_connector_prorated_utility_bill_line_items_stream: Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items>;
  /** fetch data from the table: "latchel_categories" */
  latchel_categories: Array<Latchel_Categories>;
  /** fetch data from the table: "latchel_categories" using primary key columns */
  latchel_categories_by_pk?: Maybe<Latchel_Categories>;
  /** fetch data from the table in a streaming manner: "latchel_categories" */
  latchel_categories_stream: Array<Latchel_Categories>;
  /** fetch data from the table: "latchel_dead_letters" */
  latchel_dead_letters: Array<Latchel_Dead_Letters>;
  /** fetch data from the table: "latchel_dead_letters" using primary key columns */
  latchel_dead_letters_by_pk?: Maybe<Latchel_Dead_Letters>;
  /** fetch data from the table in a streaming manner: "latchel_dead_letters" */
  latchel_dead_letters_stream: Array<Latchel_Dead_Letters>;
  /** An array relationship */
  latchel_vendor_categories: Array<Latchel_Vendor_Categories>;
  /** fetch data from the table: "latchel_vendor_categories" using primary key columns */
  latchel_vendor_categories_by_pk?: Maybe<Latchel_Vendor_Categories>;
  /** fetch data from the table in a streaming manner: "latchel_vendor_categories" */
  latchel_vendor_categories_stream: Array<Latchel_Vendor_Categories>;
  /** An array relationship */
  latchel_vendor_users: Array<Latchel_Vendor_Users>;
  /** fetch data from the table: "latchel_vendor_users" using primary key columns */
  latchel_vendor_users_by_pk?: Maybe<Latchel_Vendor_Users>;
  /** fetch data from the table in a streaming manner: "latchel_vendor_users" */
  latchel_vendor_users_stream: Array<Latchel_Vendor_Users>;
  /** fetch data from the table: "lead_group_rental_application_notes" */
  lead_group_rental_application_notes: Array<Lead_Group_Rental_Application_Notes>;
  /** fetch data from the table in a streaming manner: "lead_group_rental_application_notes" */
  lead_group_rental_application_notes_stream: Array<Lead_Group_Rental_Application_Notes>;
  /** An array relationship */
  lead_group_users: Array<Lead_Group_Users>;
  /** fetch data from the table: "lead_group_users" using primary key columns */
  lead_group_users_by_pk?: Maybe<Lead_Group_Users>;
  /** fetch data from the table in a streaming manner: "lead_group_users" */
  lead_group_users_stream: Array<Lead_Group_Users>;
  /** fetch data from the table: "lead_groups" */
  lead_groups: Array<Lead_Groups>;
  /** fetch data from the table: "lead_groups" using primary key columns */
  lead_groups_by_pk?: Maybe<Lead_Groups>;
  /** fetch data from the table in a streaming manner: "lead_groups" */
  lead_groups_stream: Array<Lead_Groups>;
  /** An array relationship */
  ledger_account_categories: Array<Ledger_Account_Categories>;
  /** fetch data from the table: "ledger_account_categories" using primary key columns */
  ledger_account_categories_by_pk?: Maybe<Ledger_Account_Categories>;
  /** fetch data from the table in a streaming manner: "ledger_account_categories" */
  ledger_account_categories_stream: Array<Ledger_Account_Categories>;
  /** fetch data from the table: "ledger_accounts" */
  ledger_accounts: Array<Ledger_Accounts>;
  /** fetch data from the table: "ledger_accounts" using primary key columns */
  ledger_accounts_by_pk?: Maybe<Ledger_Accounts>;
  /** fetch data from the table in a streaming manner: "ledger_accounts" */
  ledger_accounts_stream: Array<Ledger_Accounts>;
  /** An array relationship */
  liabilities_payments: Array<Liabilities_Payments>;
  /** fetch data from the table: "liabilities_payments" using primary key columns */
  liabilities_payments_by_pk?: Maybe<Liabilities_Payments>;
  /** fetch data from the table in a streaming manner: "liabilities_payments" */
  liabilities_payments_stream: Array<Liabilities_Payments>;
  /** fetch data from the table: "liability_types" */
  liability_types: Array<Liability_Types>;
  /** fetch data from the table: "liability_types" using primary key columns */
  liability_types_by_pk?: Maybe<Liability_Types>;
  /** fetch data from the table in a streaming manner: "liability_types" */
  liability_types_stream: Array<Liability_Types>;
  /** An array relationship */
  listed_rents: Array<Listed_Rents>;
  /** fetch data from the table: "listed_rents" using primary key columns */
  listed_rents_by_pk?: Maybe<Listed_Rents>;
  /** fetch data from the table in a streaming manner: "listed_rents" */
  listed_rents_stream: Array<Listed_Rents>;
  /** fetch data from the table: "listing_searchable" */
  listing_searchable: Array<Listing_Searchable>;
  /** fetch data from the table in a streaming manner: "listing_searchable" */
  listing_searchable_stream: Array<Listing_Searchable>;
  /** fetch data from the table: "llc_market_agreement_templates" */
  llc_market_agreement_templates: Array<Llc_Market_Agreement_Templates>;
  /** fetch data from the table: "llc_market_agreement_templates" using primary key columns */
  llc_market_agreement_templates_by_pk?: Maybe<Llc_Market_Agreement_Templates>;
  /** fetch data from the table in a streaming manner: "llc_market_agreement_templates" */
  llc_market_agreement_templates_stream: Array<Llc_Market_Agreement_Templates>;
  /** An array relationship */
  llc_properties: Array<Llc_Properties>;
  /** fetch data from the table: "llc_properties" using primary key columns */
  llc_properties_by_pk?: Maybe<Llc_Properties>;
  /** fetch data from the table in a streaming manner: "llc_properties" */
  llc_properties_stream: Array<Llc_Properties>;
  /** An array relationship */
  llc_property_transfers: Array<Llc_Property_Transfers>;
  /** fetch data from the table: "llc_property_transfers" using primary key columns */
  llc_property_transfers_by_pk?: Maybe<Llc_Property_Transfers>;
  /** fetch data from the table in a streaming manner: "llc_property_transfers" */
  llc_property_transfers_stream: Array<Llc_Property_Transfers>;
  /** fetch data from the table: "llcs" */
  llcs: Array<Llcs>;
  /** fetch data from the table: "llcs" using primary key columns */
  llcs_by_pk?: Maybe<Llcs>;
  /** fetch data from the table in a streaming manner: "llcs" */
  llcs_stream: Array<Llcs>;
  /** An array relationship */
  lockbox_codes: Array<Lockbox_Codes>;
  /** fetch data from the table: "lockbox_codes" using primary key columns */
  lockbox_codes_by_pk?: Maybe<Lockbox_Codes>;
  /** fetch data from the table in a streaming manner: "lockbox_codes" */
  lockbox_codes_stream: Array<Lockbox_Codes>;
  /** fetch data from the table: "markets" */
  markets: Array<Markets>;
  /** fetch data from the table: "markets" using primary key columns */
  markets_by_pk?: Maybe<Markets>;
  /** fetch data from the table in a streaming manner: "markets" */
  markets_stream: Array<Markets>;
  /** fetch data from the table: "mls_listing_internal_attributes" */
  mls_listing_internal_attributes: Array<Mls_Listing_Internal_Attributes>;
  /** fetch data from the table: "mls_listing_internal_attributes" using primary key columns */
  mls_listing_internal_attributes_by_pk?: Maybe<Mls_Listing_Internal_Attributes>;
  /** fetch data from the table in a streaming manner: "mls_listing_internal_attributes" */
  mls_listing_internal_attributes_stream: Array<Mls_Listing_Internal_Attributes>;
  /** An array relationship */
  mls_listing_overrides: Array<Mls_Listing_Overrides>;
  /** fetch data from the table: "mls_listing_overrides" using primary key columns */
  mls_listing_overrides_by_pk?: Maybe<Mls_Listing_Overrides>;
  /** fetch data from the table in a streaming manner: "mls_listing_overrides" */
  mls_listing_overrides_stream: Array<Mls_Listing_Overrides>;
  /** fetch data from the table: "mls_listing_photos" */
  mls_listing_photos: Array<Mls_Listing_Photos>;
  /** fetch data from the table: "mls_listing_photos" using primary key columns */
  mls_listing_photos_by_pk?: Maybe<Mls_Listing_Photos>;
  /** fetch data from the table in a streaming manner: "mls_listing_photos" */
  mls_listing_photos_stream: Array<Mls_Listing_Photos>;
  /** An array relationship */
  mls_listing_promotions: Array<Mls_Listing_Promotions>;
  /** fetch data from the table: "mls_listing_promotions" using primary key columns */
  mls_listing_promotions_by_pk?: Maybe<Mls_Listing_Promotions>;
  /** fetch data from the table in a streaming manner: "mls_listing_promotions" */
  mls_listing_promotions_stream: Array<Mls_Listing_Promotions>;
  /** An array relationship */
  mls_listings: Array<Mls_Listings>;
  /** fetch data from the table: "mls_listings" using primary key columns */
  mls_listings_by_pk?: Maybe<Mls_Listings>;
  /** fetch data from the table in a streaming manner: "mls_listings" */
  mls_listings_stream: Array<Mls_Listings>;
  /** fetch data from the table: "most_recent_llc_property" */
  most_recent_llc_property: Array<Most_Recent_Llc_Property>;
  /** fetch data from the table in a streaming manner: "most_recent_llc_property" */
  most_recent_llc_property_stream: Array<Most_Recent_Llc_Property>;
  /** fetch data from the table: "most_relevant_user_identity_verification_by_user" */
  most_relevant_user_identity_verification_by_user: Array<Most_Relevant_User_Identity_Verification_By_User>;
  /** fetch data from the table in a streaming manner: "most_relevant_user_identity_verification_by_user" */
  most_relevant_user_identity_verification_by_user_stream: Array<Most_Relevant_User_Identity_Verification_By_User>;
  /** An array relationship */
  move_ins: Array<Move_Ins>;
  /** fetch data from the table: "move_ins" using primary key columns */
  move_ins_by_pk?: Maybe<Move_Ins>;
  /** fetch data from the table in a streaming manner: "move_ins" */
  move_ins_stream: Array<Move_Ins>;
  /** fetch data from the table: "municipalities" */
  municipalities: Array<Municipalities>;
  /** fetch data from the table: "municipalities" using primary key columns */
  municipalities_by_pk?: Maybe<Municipalities>;
  /** fetch data from the table in a streaming manner: "municipalities" */
  municipalities_stream: Array<Municipalities>;
  /** An array relationship */
  municipality_contacts: Array<Municipality_Contacts>;
  /** fetch data from the table: "municipality_contacts" using primary key columns */
  municipality_contacts_by_pk?: Maybe<Municipality_Contacts>;
  /** fetch data from the table in a streaming manner: "municipality_contacts" */
  municipality_contacts_stream: Array<Municipality_Contacts>;
  /** fetch data from the table: "note_priorities" */
  note_priorities: Array<Note_Priorities>;
  /** fetch data from the table: "note_priorities" using primary key columns */
  note_priorities_by_pk?: Maybe<Note_Priorities>;
  /** fetch data from the table in a streaming manner: "note_priorities" */
  note_priorities_stream: Array<Note_Priorities>;
  /** An array relationship */
  notes: Array<Notes>;
  /** fetch data from the table: "notes" using primary key columns */
  notes_by_pk?: Maybe<Notes>;
  /** fetch data from the table in a streaming manner: "notes" */
  notes_stream: Array<Notes>;
  /** An array relationship */
  opportunities: Array<Opportunities>;
  /** fetch data from the table: "opportunities" using primary key columns */
  opportunities_by_pk?: Maybe<Opportunities>;
  /** fetch data from the table in a streaming manner: "opportunities" */
  opportunities_stream: Array<Opportunities>;
  /** fetch data from the table: "option_premium_transfers" */
  option_premium_transfers: Array<Option_Premium_Transfers>;
  /** fetch data from the table: "option_premium_transfers" using primary key columns */
  option_premium_transfers_by_pk?: Maybe<Option_Premium_Transfers>;
  /** fetch data from the table in a streaming manner: "option_premium_transfers" */
  option_premium_transfers_stream: Array<Option_Premium_Transfers>;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table in a streaming manner: "payment_methods" */
  payment_methods_stream: Array<Payment_Methods>;
  /** fetch data from the table: "payment_plan_liabilities" */
  payment_plan_liabilities: Array<Payment_Plan_Liabilities>;
  /** fetch data from the table: "payment_plan_liabilities" using primary key columns */
  payment_plan_liabilities_by_pk?: Maybe<Payment_Plan_Liabilities>;
  /** fetch data from the table in a streaming manner: "payment_plan_liabilities" */
  payment_plan_liabilities_stream: Array<Payment_Plan_Liabilities>;
  /** An array relationship */
  payment_plan_offset_credits: Array<Payment_Plan_Offset_Credits>;
  /** fetch data from the table: "payment_plan_offset_credits" using primary key columns */
  payment_plan_offset_credits_by_pk?: Maybe<Payment_Plan_Offset_Credits>;
  /** fetch data from the table in a streaming manner: "payment_plan_offset_credits" */
  payment_plan_offset_credits_stream: Array<Payment_Plan_Offset_Credits>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table in a streaming manner: "payments" */
  payments_stream: Array<Payments>;
  /** fetch data from the table: "plaid_income_verification_documents" */
  plaid_income_verification_documents: Array<Plaid_Income_Verification_Documents>;
  /** fetch data from the table in a streaming manner: "plaid_income_verification_documents" */
  plaid_income_verification_documents_stream: Array<Plaid_Income_Verification_Documents>;
  /** fetch data from the table: "plaid_income_verifications" */
  plaid_income_verifications: Array<Plaid_Income_Verifications>;
  /** fetch data from the table: "plaid_income_verifications" using primary key columns */
  plaid_income_verifications_by_pk?: Maybe<Plaid_Income_Verifications>;
  /** fetch data from the table in a streaming manner: "plaid_income_verifications" */
  plaid_income_verifications_stream: Array<Plaid_Income_Verifications>;
  /** An array relationship */
  portfolio_home_external_features: Array<Portfolio_Home_External_Features>;
  /** fetch data from the table: "portfolio_home_external_features" using primary key columns */
  portfolio_home_external_features_by_pk?: Maybe<Portfolio_Home_External_Features>;
  /** fetch data from the table in a streaming manner: "portfolio_home_external_features" */
  portfolio_home_external_features_stream: Array<Portfolio_Home_External_Features>;
  /** fetch data from the table: "portfolio_home_internal_features" */
  portfolio_home_internal_features: Array<Portfolio_Home_Internal_Features>;
  /** fetch data from the table: "portfolio_home_internal_features" using primary key columns */
  portfolio_home_internal_features_by_pk?: Maybe<Portfolio_Home_Internal_Features>;
  /** fetch data from the table in a streaming manner: "portfolio_home_internal_features" */
  portfolio_home_internal_features_stream: Array<Portfolio_Home_Internal_Features>;
  /** fetch data from the table: "portfolio_home_system_work_order_system_enum" */
  portfolio_home_system_work_order_system_enum: Array<Portfolio_Home_System_Work_Order_System_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_order_system_enum" using primary key columns */
  portfolio_home_system_work_order_system_enum_by_pk?: Maybe<Portfolio_Home_System_Work_Order_System_Enum>;
  /** fetch data from the table in a streaming manner: "portfolio_home_system_work_order_system_enum" */
  portfolio_home_system_work_order_system_enum_stream: Array<Portfolio_Home_System_Work_Order_System_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_order_type_enum" */
  portfolio_home_system_work_order_type_enum: Array<Portfolio_Home_System_Work_Order_Type_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_order_type_enum" using primary key columns */
  portfolio_home_system_work_order_type_enum_by_pk?: Maybe<Portfolio_Home_System_Work_Order_Type_Enum>;
  /** fetch data from the table in a streaming manner: "portfolio_home_system_work_order_type_enum" */
  portfolio_home_system_work_order_type_enum_stream: Array<Portfolio_Home_System_Work_Order_Type_Enum>;
  /** fetch data from the table: "portfolio_home_system_work_orders" */
  portfolio_home_system_work_orders: Array<Portfolio_Home_System_Work_Orders>;
  /** fetch data from the table: "portfolio_home_system_work_orders" using primary key columns */
  portfolio_home_system_work_orders_by_pk?: Maybe<Portfolio_Home_System_Work_Orders>;
  /** fetch data from the table in a streaming manner: "portfolio_home_system_work_orders" */
  portfolio_home_system_work_orders_stream: Array<Portfolio_Home_System_Work_Orders>;
  /** An array relationship */
  portfolio_home_utilities: Array<Portfolio_Home_Utilities>;
  /** fetch data from the table: "portfolio_home_utilities" using primary key columns */
  portfolio_home_utilities_by_pk?: Maybe<Portfolio_Home_Utilities>;
  /** fetch data from the table in a streaming manner: "portfolio_home_utilities" */
  portfolio_home_utilities_stream: Array<Portfolio_Home_Utilities>;
  /** An array relationship */
  portfolio_homes: Array<Portfolio_Homes>;
  /** fetch data from the table: "portfolio_homes" using primary key columns */
  portfolio_homes_by_pk?: Maybe<Portfolio_Homes>;
  /** fetch data from the table in a streaming manner: "portfolio_homes" */
  portfolio_homes_stream: Array<Portfolio_Homes>;
  /** fetch data from the table: "properties" */
  properties: Array<Properties>;
  /** fetch data from the table: "properties" using primary key columns */
  properties_by_pk?: Maybe<Properties>;
  /** fetch data from the table in a streaming manner: "properties" */
  properties_stream: Array<Properties>;
  /** An array relationship */
  real_estate_acquisitions: Array<Real_Estate_Acquisitions>;
  /** fetch data from the table: "real_estate_acquisitions" using primary key columns */
  real_estate_acquisitions_by_pk?: Maybe<Real_Estate_Acquisitions>;
  /** fetch data from the table in a streaming manner: "real_estate_acquisitions" */
  real_estate_acquisitions_stream: Array<Real_Estate_Acquisitions>;
  /** An array relationship */
  real_estate_screenings: Array<Real_Estate_Screenings>;
  /** fetch data from the table: "real_estate_screenings" using primary key columns */
  real_estate_screenings_by_pk?: Maybe<Real_Estate_Screenings>;
  /** fetch data from the table in a streaming manner: "real_estate_screenings" */
  real_estate_screenings_stream: Array<Real_Estate_Screenings>;
  /** An array relationship */
  recurring_credits: Array<Recurring_Credits>;
  /** fetch data from the table: "recurring_credits" using primary key columns */
  recurring_credits_by_pk?: Maybe<Recurring_Credits>;
  /** fetch data from the table in a streaming manner: "recurring_credits" */
  recurring_credits_stream: Array<Recurring_Credits>;
  /** An array relationship */
  renewal_offers: Array<Renewal_Offers>;
  /** fetch data from the table: "renewal_offers" using primary key columns */
  renewal_offers_by_pk?: Maybe<Renewal_Offers>;
  /** fetch data from the table in a streaming manner: "renewal_offers" */
  renewal_offers_stream: Array<Renewal_Offers>;
  /** An array relationship */
  renewals: Array<Renewals>;
  /** fetch data from the table: "renewals" using primary key columns */
  renewals_by_pk?: Maybe<Renewals>;
  /** fetch data from the table in a streaming manner: "renewals" */
  renewals_stream: Array<Renewals>;
  /** An array relationship */
  rent_prices: Array<Rent_Prices>;
  /** fetch data from the table: "rent_prices" using primary key columns */
  rent_prices_by_pk?: Maybe<Rent_Prices>;
  /** fetch data from the table in a streaming manner: "rent_prices" */
  rent_prices_stream: Array<Rent_Prices>;
  /** An array relationship */
  rent_ready_dates: Array<Rent_Ready_Dates>;
  /** fetch data from the table: "rent_ready_dates" using primary key columns */
  rent_ready_dates_by_pk?: Maybe<Rent_Ready_Dates>;
  /** fetch data from the table in a streaming manner: "rent_ready_dates" */
  rent_ready_dates_stream: Array<Rent_Ready_Dates>;
  /** fetch data from the table: "rent_roll" */
  rent_roll: Array<Rent_Roll>;
  /** fetch data from the table in a streaming manner: "rent_roll" */
  rent_roll_stream: Array<Rent_Roll>;
  /** An array relationship */
  rental_add_ons: Array<Rental_Add_Ons>;
  /** fetch data from the table: "rental_add_ons" using primary key columns */
  rental_add_ons_by_pk?: Maybe<Rental_Add_Ons>;
  /** fetch data from the table in a streaming manner: "rental_add_ons" */
  rental_add_ons_stream: Array<Rental_Add_Ons>;
  /** An array relationship */
  rental_agreement_histories: Array<Rental_Agreement_Histories>;
  /** fetch data from the table: "rental_agreement_histories" using primary key columns */
  rental_agreement_histories_by_pk?: Maybe<Rental_Agreement_Histories>;
  /** fetch data from the table in a streaming manner: "rental_agreement_histories" */
  rental_agreement_histories_stream: Array<Rental_Agreement_Histories>;
  /** An array relationship */
  rental_application_decisions: Array<Rental_Application_Decisions>;
  /** fetch data from the table: "rental_application_decisions" using primary key columns */
  rental_application_decisions_by_pk?: Maybe<Rental_Application_Decisions>;
  /** fetch data from the table in a streaming manner: "rental_application_decisions" */
  rental_application_decisions_stream: Array<Rental_Application_Decisions>;
  /** An array relationship */
  rental_application_fees: Array<Rental_Application_Fees>;
  /** fetch data from the table: "rental_application_fees" using primary key columns */
  rental_application_fees_by_pk?: Maybe<Rental_Application_Fees>;
  /** fetch data from the table: "rental_application_fees_config" */
  rental_application_fees_config: Array<Rental_Application_Fees_Config>;
  /** fetch data from the table: "rental_application_fees_config" using primary key columns */
  rental_application_fees_config_by_pk?: Maybe<Rental_Application_Fees_Config>;
  /** fetch data from the table in a streaming manner: "rental_application_fees_config" */
  rental_application_fees_config_stream: Array<Rental_Application_Fees_Config>;
  /** fetch data from the table in a streaming manner: "rental_application_fees" */
  rental_application_fees_stream: Array<Rental_Application_Fees>;
  /** fetch data from the table: "rental_application_manager.admin_assignments" */
  rental_application_manager_admin_assignments: Array<Rental_Application_Manager_Admin_Assignments>;
  /** fetch data from the table: "rental_application_manager.admin_assignments" using primary key columns */
  rental_application_manager_admin_assignments_by_pk?: Maybe<Rental_Application_Manager_Admin_Assignments>;
  /** fetch data from the table in a streaming manner: "rental_application_manager.admin_assignments" */
  rental_application_manager_admin_assignments_stream: Array<Rental_Application_Manager_Admin_Assignments>;
  /** fetch data from the table: "rental_application_manager.admin_roles" */
  rental_application_manager_admin_roles: Array<Rental_Application_Manager_Admin_Roles>;
  /** fetch data from the table: "rental_application_manager.admin_roles" using primary key columns */
  rental_application_manager_admin_roles_by_pk?: Maybe<Rental_Application_Manager_Admin_Roles>;
  /** fetch data from the table in a streaming manner: "rental_application_manager.admin_roles" */
  rental_application_manager_admin_roles_stream: Array<Rental_Application_Manager_Admin_Roles>;
  /** fetch data from the table: "rental_application_manager.application_escalations" */
  rental_application_manager_application_escalations: Array<Rental_Application_Manager_Application_Escalations>;
  /** fetch data from the table: "rental_application_manager.application_escalations" using primary key columns */
  rental_application_manager_application_escalations_by_pk?: Maybe<Rental_Application_Manager_Application_Escalations>;
  /** fetch data from the table in a streaming manner: "rental_application_manager.application_escalations" */
  rental_application_manager_application_escalations_stream: Array<Rental_Application_Manager_Application_Escalations>;
  /** fetch data from the table: "rental_application_manager.application_snoozes" */
  rental_application_manager_application_snoozes: Array<Rental_Application_Manager_Application_Snoozes>;
  /** fetch aggregated fields from the table: "rental_application_manager.application_snoozes" */
  rental_application_manager_application_snoozes_aggregate: Rental_Application_Manager_Application_Snoozes_Aggregate;
  /** fetch data from the table: "rental_application_manager.application_snoozes" using primary key columns */
  rental_application_manager_application_snoozes_by_pk?: Maybe<Rental_Application_Manager_Application_Snoozes>;
  /** fetch data from the table in a streaming manner: "rental_application_manager.application_snoozes" */
  rental_application_manager_application_snoozes_stream: Array<Rental_Application_Manager_Application_Snoozes>;
  /** fetch data from the table: "rental_application_manager.escalation_statuses" */
  rental_application_manager_escalation_statuses: Array<Rental_Application_Manager_Escalation_Statuses>;
  /** fetch data from the table: "rental_application_manager.escalation_statuses" using primary key columns */
  rental_application_manager_escalation_statuses_by_pk?: Maybe<Rental_Application_Manager_Escalation_Statuses>;
  /** fetch data from the table in a streaming manner: "rental_application_manager.escalation_statuses" */
  rental_application_manager_escalation_statuses_stream: Array<Rental_Application_Manager_Escalation_Statuses>;
  /** fetch data from the table: "rental_application_manager.snooze_reasons" */
  rental_application_manager_snooze_reasons: Array<Rental_Application_Manager_Snooze_Reasons>;
  /** fetch data from the table: "rental_application_manager.snooze_reasons" using primary key columns */
  rental_application_manager_snooze_reasons_by_pk?: Maybe<Rental_Application_Manager_Snooze_Reasons>;
  /** fetch data from the table in a streaming manner: "rental_application_manager.snooze_reasons" */
  rental_application_manager_snooze_reasons_stream: Array<Rental_Application_Manager_Snooze_Reasons>;
  /** An array relationship */
  rental_application_occupants: Array<Rental_Application_Occupants>;
  /** fetch data from the table: "rental_application_occupants" using primary key columns */
  rental_application_occupants_by_pk?: Maybe<Rental_Application_Occupants>;
  /** fetch data from the table in a streaming manner: "rental_application_occupants" */
  rental_application_occupants_stream: Array<Rental_Application_Occupants>;
  /** fetch data from the table: "rental_application_pets" */
  rental_application_pets: Array<Rental_Application_Pets>;
  /** fetch data from the table: "rental_application_pets" using primary key columns */
  rental_application_pets_by_pk?: Maybe<Rental_Application_Pets>;
  /** fetch data from the table in a streaming manner: "rental_application_pets" */
  rental_application_pets_stream: Array<Rental_Application_Pets>;
  /** fetch data from the table: "rental_application_vehicles" */
  rental_application_vehicles: Array<Rental_Application_Vehicles>;
  /** fetch data from the table: "rental_application_vehicles" using primary key columns */
  rental_application_vehicles_by_pk?: Maybe<Rental_Application_Vehicles>;
  /** fetch data from the table in a streaming manner: "rental_application_vehicles" */
  rental_application_vehicles_stream: Array<Rental_Application_Vehicles>;
  /** An array relationship */
  rental_applications: Array<Rental_Applications>;
  /** An aggregate relationship */
  rental_applications_aggregate: Rental_Applications_Aggregate;
  /** fetch data from the table: "rental_applications" using primary key columns */
  rental_applications_by_pk?: Maybe<Rental_Applications>;
  /** fetch data from the table in a streaming manner: "rental_applications" */
  rental_applications_stream: Array<Rental_Applications>;
  /** An array relationship */
  rental_credits: Array<Rental_Credits>;
  /** fetch data from the table: "rental_credits" using primary key columns */
  rental_credits_by_pk?: Maybe<Rental_Credits>;
  /** fetch data from the table in a streaming manner: "rental_credits" */
  rental_credits_stream: Array<Rental_Credits>;
  /** fetch data from the table: "rental_internet_fee_elections" */
  rental_internet_fee_elections: Array<Rental_Internet_Fee_Elections>;
  /** fetch data from the table: "rental_internet_fee_elections" using primary key columns */
  rental_internet_fee_elections_by_pk?: Maybe<Rental_Internet_Fee_Elections>;
  /** fetch data from the table in a streaming manner: "rental_internet_fee_elections" */
  rental_internet_fee_elections_stream: Array<Rental_Internet_Fee_Elections>;
  /** An array relationship */
  rental_liabilities: Array<Rental_Liabilities>;
  /** fetch data from the table: "rental_liabilities" using primary key columns */
  rental_liabilities_by_pk?: Maybe<Rental_Liabilities>;
  /** fetch data from the table in a streaming manner: "rental_liabilities" */
  rental_liabilities_stream: Array<Rental_Liabilities>;
  /** An array relationship */
  rental_move_in_fees: Array<Rental_Move_In_Fees>;
  /** fetch data from the table: "rental_move_in_fees" using primary key columns */
  rental_move_in_fees_by_pk?: Maybe<Rental_Move_In_Fees>;
  /** fetch data from the table in a streaming manner: "rental_move_in_fees" */
  rental_move_in_fees_stream: Array<Rental_Move_In_Fees>;
  /** An array relationship */
  rental_occupants: Array<Rental_Occupants>;
  /** fetch data from the table in a streaming manner: "rental_occupants" */
  rental_occupants_stream: Array<Rental_Occupants>;
  /** An array relationship */
  rental_reunderwrite_tenant_underwrites: Array<Rental_Reunderwrite_Tenant_Underwrites>;
  /** fetch data from the table: "rental_reunderwrite_tenant_underwrites" using primary key columns */
  rental_reunderwrite_tenant_underwrites_by_pk?: Maybe<Rental_Reunderwrite_Tenant_Underwrites>;
  /** fetch data from the table in a streaming manner: "rental_reunderwrite_tenant_underwrites" */
  rental_reunderwrite_tenant_underwrites_stream: Array<Rental_Reunderwrite_Tenant_Underwrites>;
  /** fetch data from the table: "rental_reunderwrites" */
  rental_reunderwrites: Array<Rental_Reunderwrites>;
  /** fetch data from the table: "rental_reunderwrites" using primary key columns */
  rental_reunderwrites_by_pk?: Maybe<Rental_Reunderwrites>;
  /** fetch data from the table in a streaming manner: "rental_reunderwrites" */
  rental_reunderwrites_stream: Array<Rental_Reunderwrites>;
  /** fetch data from the table: "rental_site_accounts" */
  rental_site_accounts: Array<Rental_Site_Accounts>;
  /** fetch data from the table: "rental_site_accounts" using primary key columns */
  rental_site_accounts_by_pk?: Maybe<Rental_Site_Accounts>;
  /** fetch data from the table in a streaming manner: "rental_site_accounts" */
  rental_site_accounts_stream: Array<Rental_Site_Accounts>;
  /** An array relationship */
  rental_site_leads: Array<Rental_Site_Leads>;
  /** fetch data from the table: "rental_site_leads" using primary key columns */
  rental_site_leads_by_pk?: Maybe<Rental_Site_Leads>;
  /** fetch data from the table in a streaming manner: "rental_site_leads" */
  rental_site_leads_stream: Array<Rental_Site_Leads>;
  /** fetch data from the table: "rental_site_listings" */
  rental_site_listings: Array<Rental_Site_Listings>;
  /** fetch data from the table: "rental_site_listings" using primary key columns */
  rental_site_listings_by_pk?: Maybe<Rental_Site_Listings>;
  /** fetch data from the table in a streaming manner: "rental_site_listings" */
  rental_site_listings_stream: Array<Rental_Site_Listings>;
  /** fetch data from the table: "rental_site_opportunity_checks" */
  rental_site_opportunity_checks: Array<Rental_Site_Opportunity_Checks>;
  /** fetch data from the table: "rental_site_opportunity_checks" using primary key columns */
  rental_site_opportunity_checks_by_pk?: Maybe<Rental_Site_Opportunity_Checks>;
  /** fetch data from the table in a streaming manner: "rental_site_opportunity_checks" */
  rental_site_opportunity_checks_stream: Array<Rental_Site_Opportunity_Checks>;
  /** An array relationship */
  rental_users: Array<Rental_Users>;
  /** fetch data from the table: "rental_users" using primary key columns */
  rental_users_by_pk?: Maybe<Rental_Users>;
  /** fetch data from the table in a streaming manner: "rental_users" */
  rental_users_stream: Array<Rental_Users>;
  /** fetch data from the table: "rental_utility_chargeback_overrides" */
  rental_utility_chargeback_overrides: Array<Rental_Utility_Chargeback_Overrides>;
  /** fetch aggregated fields from the table: "rental_utility_chargeback_overrides" */
  rental_utility_chargeback_overrides_aggregate: Rental_Utility_Chargeback_Overrides_Aggregate;
  /** fetch data from the table: "rental_utility_chargeback_overrides" using primary key columns */
  rental_utility_chargeback_overrides_by_pk?: Maybe<Rental_Utility_Chargeback_Overrides>;
  /** fetch data from the table in a streaming manner: "rental_utility_chargeback_overrides" */
  rental_utility_chargeback_overrides_stream: Array<Rental_Utility_Chargeback_Overrides>;
  /** An array relationship */
  rentals: Array<Rentals>;
  /** fetch data from the table: "rentals" using primary key columns */
  rentals_by_pk?: Maybe<Rentals>;
  /** fetch data from the table in a streaming manner: "rentals" */
  rentals_stream: Array<Rentals>;
  /** fetch data from the table: "saferent_requests" */
  saferent_requests: Array<Saferent_Requests>;
  /** fetch data from the table: "saferent_requests" using primary key columns */
  saferent_requests_by_pk?: Maybe<Saferent_Requests>;
  /** fetch data from the table in a streaming manner: "saferent_requests" */
  saferent_requests_stream: Array<Saferent_Requests>;
  /** An array relationship */
  scheduled_rental_liabilities: Array<Scheduled_Rental_Liabilities>;
  /** fetch data from the table: "scheduled_rental_liabilities" using primary key columns */
  scheduled_rental_liabilities_by_pk?: Maybe<Scheduled_Rental_Liabilities>;
  /** fetch data from the table in a streaming manner: "scheduled_rental_liabilities" */
  scheduled_rental_liabilities_stream: Array<Scheduled_Rental_Liabilities>;
  /** fetch data from the table: "security_enum" */
  security_enum: Array<Security_Enum>;
  /** fetch data from the table: "security_enum" using primary key columns */
  security_enum_by_pk?: Maybe<Security_Enum>;
  /** fetch data from the table in a streaming manner: "security_enum" */
  security_enum_stream: Array<Security_Enum>;
  /** fetch data from the table: "seller_agent_searchable" */
  seller_agent_searchable: Array<Seller_Agent_Searchable>;
  /** fetch data from the table in a streaming manner: "seller_agent_searchable" */
  seller_agent_searchable_stream: Array<Seller_Agent_Searchable>;
  /** fetch data from the table: "seller_agents" */
  seller_agents: Array<Seller_Agents>;
  /** fetch data from the table: "seller_agents" using primary key columns */
  seller_agents_by_pk?: Maybe<Seller_Agents>;
  /** fetch data from the table in a streaming manner: "seller_agents" */
  seller_agents_stream: Array<Seller_Agents>;
  /** An array relationship */
  statements: Array<Statements>;
  /** An array relationship */
  statements_raw: Array<Statements_Raw>;
  /** fetch data from the table: "statements_raw" using primary key columns */
  statements_raw_by_pk?: Maybe<Statements_Raw>;
  /** fetch data from the table in a streaming manner: "statements_raw" */
  statements_raw_stream: Array<Statements_Raw>;
  /** fetch data from the table in a streaming manner: "statements" */
  statements_stream: Array<Statements>;
  /** An array relationship */
  tenant_underwrite_documents: Array<Tenant_Underwrite_Documents>;
  /** fetch data from the table: "tenant_underwrite_documents" using primary key columns */
  tenant_underwrite_documents_by_pk?: Maybe<Tenant_Underwrite_Documents>;
  /** fetch data from the table in a streaming manner: "tenant_underwrite_documents" */
  tenant_underwrite_documents_stream: Array<Tenant_Underwrite_Documents>;
  /** fetch data from the table: "tenant_underwrites" */
  tenant_underwrites: Array<Tenant_Underwrites>;
  /** fetch data from the table: "tenant_underwrites" using primary key columns */
  tenant_underwrites_by_pk?: Maybe<Tenant_Underwrites>;
  /** fetch data from the table in a streaming manner: "tenant_underwrites" */
  tenant_underwrites_stream: Array<Tenant_Underwrites>;
  /** An array relationship */
  ticket_vendor_assignments: Array<Ticket_Vendor_Assignments>;
  /** fetch data from the table: "ticket_vendor_assignments" using primary key columns */
  ticket_vendor_assignments_by_pk?: Maybe<Ticket_Vendor_Assignments>;
  /** fetch data from the table in a streaming manner: "ticket_vendor_assignments" */
  ticket_vendor_assignments_stream: Array<Ticket_Vendor_Assignments>;
  /** fetch data from the table: "tickets" */
  tickets: Array<Tickets>;
  /** fetch data from the table: "tickets" using primary key columns */
  tickets_by_pk?: Maybe<Tickets>;
  /** fetch data from the table: "tickets_latchel_data" */
  tickets_latchel_data: Array<Tickets_Latchel_Data>;
  /** fetch data from the table: "tickets_latchel_data" using primary key columns */
  tickets_latchel_data_by_pk?: Maybe<Tickets_Latchel_Data>;
  /** fetch data from the table in a streaming manner: "tickets_latchel_data" */
  tickets_latchel_data_stream: Array<Tickets_Latchel_Data>;
  /** fetch data from the table: "tickets_mason_data" */
  tickets_mason_data: Array<Tickets_Mason_Data>;
  /** fetch data from the table: "tickets_mason_data" using primary key columns */
  tickets_mason_data_by_pk?: Maybe<Tickets_Mason_Data>;
  /** fetch data from the table in a streaming manner: "tickets_mason_data" */
  tickets_mason_data_stream: Array<Tickets_Mason_Data>;
  /** fetch data from the table in a streaming manner: "tickets" */
  tickets_stream: Array<Tickets>;
  /** An array relationship */
  tour_properties: Array<Tour_Properties>;
  /** fetch data from the table: "tour_properties" using primary key columns */
  tour_properties_by_pk?: Maybe<Tour_Properties>;
  /** fetch data from the table in a streaming manner: "tour_properties" */
  tour_properties_stream: Array<Tour_Properties>;
  /** An array relationship */
  tours: Array<Tours>;
  /** fetch data from the table: "tours" using primary key columns */
  tours_by_pk?: Maybe<Tours>;
  /** fetch data from the table in a streaming manner: "tours" */
  tours_stream: Array<Tours>;
  /** fetch data from the table: "unallocated_credits" */
  unallocated_credits: Array<Unallocated_Credits>;
  /** fetch data from the table in a streaming manner: "unallocated_credits" */
  unallocated_credits_stream: Array<Unallocated_Credits>;
  /** fetch data from the table: "unallocated_payments" */
  unallocated_payments: Array<Unallocated_Payments>;
  /** fetch data from the table in a streaming manner: "unallocated_payments" */
  unallocated_payments_stream: Array<Unallocated_Payments>;
  /** fetch data from the table: "underwrites.opportunity_underwrites" */
  underwrites_opportunity_underwrites: Array<Underwrites_Opportunity_Underwrites>;
  /** fetch data from the table: "underwrites.opportunity_underwrites" using primary key columns */
  underwrites_opportunity_underwrites_by_pk?: Maybe<Underwrites_Opportunity_Underwrites>;
  /** fetch data from the table in a streaming manner: "underwrites.opportunity_underwrites" */
  underwrites_opportunity_underwrites_stream: Array<Underwrites_Opportunity_Underwrites>;
  /** fetch data from the table: "unpaid_liabilities" */
  unpaid_liabilities: Array<Unpaid_Liabilities>;
  /** fetch data from the table in a streaming manner: "unpaid_liabilities" */
  unpaid_liabilities_stream: Array<Unpaid_Liabilities>;
  /** An array relationship */
  user_contact_details: Array<User_Contact_Details>;
  /** fetch data from the table: "user_contact_details" using primary key columns */
  user_contact_details_by_pk?: Maybe<User_Contact_Details>;
  /** fetch data from the table in a streaming manner: "user_contact_details" */
  user_contact_details_stream: Array<User_Contact_Details>;
  /** An array relationship */
  user_document_requests: Array<User_Document_Requests>;
  /** fetch data from the table: "user_document_requests" using primary key columns */
  user_document_requests_by_pk?: Maybe<User_Document_Requests>;
  /** fetch data from the table in a streaming manner: "user_document_requests" */
  user_document_requests_stream: Array<User_Document_Requests>;
  /** fetch data from the table: "user_documents" */
  user_documents: Array<User_Documents>;
  /** fetch data from the table in a streaming manner: "user_documents" */
  user_documents_stream: Array<User_Documents>;
  /** fetch data from the table: "user_funnel_statuses" */
  user_funnel_statuses: Array<User_Funnel_Statuses>;
  /** fetch data from the table: "user_funnel_statuses" using primary key columns */
  user_funnel_statuses_by_pk?: Maybe<User_Funnel_Statuses>;
  /** fetch data from the table in a streaming manner: "user_funnel_statuses" */
  user_funnel_statuses_stream: Array<User_Funnel_Statuses>;
  /** fetch data from the table: "user_identity_verifications" */
  user_identity_verifications: Array<User_Identity_Verifications>;
  /** fetch data from the table: "user_identity_verifications" using primary key columns */
  user_identity_verifications_by_pk?: Maybe<User_Identity_Verifications>;
  /** An array relationship */
  user_incomes: Array<User_Incomes>;
  /** fetch data from the table: "user_incomes" using primary key columns */
  user_incomes_by_pk?: Maybe<User_Incomes>;
  /** fetch data from the table in a streaming manner: "user_incomes" */
  user_incomes_stream: Array<User_Incomes>;
  /** fetch data from the table: "user_prequalification_data" */
  user_prequalification_data: Array<User_Prequalification_Data>;
  /** fetch data from the table: "user_prequalification_data" using primary key columns */
  user_prequalification_data_by_pk?: Maybe<User_Prequalification_Data>;
  /** fetch data from the table in a streaming manner: "user_prequalification_data" */
  user_prequalification_data_stream: Array<User_Prequalification_Data>;
  /** fetch data from the table: "user_searchable" */
  user_searchable: Array<User_Searchable>;
  /** fetch data from the table in a streaming manner: "user_searchable" */
  user_searchable_stream: Array<User_Searchable>;
  /** An array relationship */
  user_underwriting_data: Array<User_Underwriting_Data>;
  /** fetch data from the table: "user_underwriting_data" using primary key columns */
  user_underwriting_data_by_pk?: Maybe<User_Underwriting_Data>;
  /** fetch data from the table in a streaming manner: "user_underwriting_data" */
  user_underwriting_data_stream: Array<User_Underwriting_Data>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "utility_bills" */
  utility_bills: Array<Utility_Bills>;
  /** fetch data from the table: "utility_bills" using primary key columns */
  utility_bills_by_pk?: Maybe<Utility_Bills>;
  /** fetch data from the table: "utility_chargeback_status_enum" */
  utility_chargeback_status_enum: Array<Utility_Chargeback_Status_Enum>;
  /** fetch aggregated fields from the table: "utility_chargeback_status_enum" */
  utility_chargeback_status_enum_aggregate: Utility_Chargeback_Status_Enum_Aggregate;
  /** fetch data from the table: "utility_chargeback_status_enum" using primary key columns */
  utility_chargeback_status_enum_by_pk?: Maybe<Utility_Chargeback_Status_Enum>;
  /** An array relationship */
  utility_chargebacks: Array<Utility_Chargebacks>;
  /** An aggregate relationship */
  utility_chargebacks_aggregate: Utility_Chargebacks_Aggregate;
  /** fetch data from the table: "utility_chargebacks" using primary key columns */
  utility_chargebacks_by_pk?: Maybe<Utility_Chargebacks>;
  /** An array relationship */
  utility_responsibilities: Array<Utility_Responsibilities>;
  /** fetch data from the table: "utility_responsibilities" using primary key columns */
  utility_responsibilities_by_pk?: Maybe<Utility_Responsibilities>;
  /** fetch data from the table in a streaming manner: "utility_responsibilities" */
  utility_responsibilities_stream: Array<Utility_Responsibilities>;
  /** An array relationship */
  utility_types: Array<Utility_Types>;
  /** fetch data from the table: "utility_types" using primary key columns */
  utility_types_by_pk?: Maybe<Utility_Types>;
  /** fetch data from the table in a streaming manner: "utility_types" */
  utility_types_stream: Array<Utility_Types>;
  /** An array relationship */
  vendor_markets: Array<Vendor_Markets>;
  /** fetch data from the table: "vendor_markets" using primary key columns */
  vendor_markets_by_pk?: Maybe<Vendor_Markets>;
  /** fetch data from the table in a streaming manner: "vendor_markets" */
  vendor_markets_stream: Array<Vendor_Markets>;
  /** fetch data from the table: "vendor_tags" */
  vendor_tags: Array<Vendor_Tags>;
  /** fetch data from the table: "vendor_tags" using primary key columns */
  vendor_tags_by_pk?: Maybe<Vendor_Tags>;
  /** fetch data from the table in a streaming manner: "vendor_tags" */
  vendor_tags_stream: Array<Vendor_Tags>;
  /** fetch data from the table: "vendor_types" */
  vendor_types: Array<Vendor_Types>;
  /** fetch data from the table: "vendor_types" using primary key columns */
  vendor_types_by_pk?: Maybe<Vendor_Types>;
  /** fetch data from the table in a streaming manner: "vendor_types" */
  vendor_types_stream: Array<Vendor_Types>;
  /** fetch data from the table: "vendors" */
  vendors: Array<Vendors>;
  /** fetch data from the table: "vendors" using primary key columns */
  vendors_by_pk?: Maybe<Vendors>;
  /** fetch data from the table in a streaming manner: "vendors" */
  vendors_stream: Array<Vendors>;
  /** An array relationship */
  vendors_vendor_tags: Array<Vendors_Vendor_Tags>;
  /** fetch data from the table: "vendors_vendor_tags" using primary key columns */
  vendors_vendor_tags_by_pk?: Maybe<Vendors_Vendor_Tags>;
  /** fetch data from the table in a streaming manner: "vendors_vendor_tags" */
  vendors_vendor_tags_stream: Array<Vendors_Vendor_Tags>;
  /** An array relationship */
  vendors_vendor_types: Array<Vendors_Vendor_Types>;
  /** fetch data from the table: "vendors_vendor_types" using primary key columns */
  vendors_vendor_types_by_pk?: Maybe<Vendors_Vendor_Types>;
  /** fetch data from the table in a streaming manner: "vendors_vendor_types" */
  vendors_vendor_types_stream: Array<Vendors_Vendor_Types>;
  /** An array relationship */
  work_orders: Array<Work_Orders>;
  /** fetch data from the table: "work_orders" using primary key columns */
  work_orders_by_pk?: Maybe<Work_Orders>;
  /** fetch data from the table in a streaming manner: "work_orders" */
  work_orders_stream: Array<Work_Orders>;
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAddresses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAdmin_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Capabilities_Order_By>>;
  where?: InputMaybe<Admin_Capabilities_Bool_Exp>;
};


export type Subscription_RootAdmin_Capabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_Capabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Capabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Capabilities_Bool_Exp>;
};


export type Subscription_RootAdmin_SearchableArgs = {
  distinct_on?: InputMaybe<Array<Admin_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Searchable_Order_By>>;
  where?: InputMaybe<Admin_Searchable_Bool_Exp>;
};


export type Subscription_RootAdmin_Searchable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Searchable_Order_By>>;
  where?: InputMaybe<Admin_Searchable_Bool_Exp>;
};


export type Subscription_RootAdmin_Searchable_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Searchable_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Searchable_Bool_Exp>;
};


export type Subscription_RootAdminsArgs = {
  distinct_on?: InputMaybe<Array<Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admins_Order_By>>;
  where?: InputMaybe<Admins_Bool_Exp>;
};


export type Subscription_RootAdmins_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admins_Stream_Cursor_Input>>;
  where?: InputMaybe<Admins_Bool_Exp>;
};


export type Subscription_RootAgent_Lead_Group_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_Lead_Group_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Lead_Group_Owners_Order_By>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
};


export type Subscription_RootAgent_Lead_Group_Owners_Agent_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Lead_Group_Owners_Agent_Type_Enum_Order_By>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp>;
};


export type Subscription_RootAgent_Lead_Group_Owners_Agent_Type_Enum_By_PkArgs = {
  agent_type: Scalars['String']['input'];
};


export type Subscription_RootAgent_Lead_Group_Owners_Agent_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Agent_Type_Enum_Bool_Exp>;
};


export type Subscription_RootAgent_Lead_Group_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_Lead_Group_Owners_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Lead_Group_Owners_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Lead_Group_Owners_Bool_Exp>;
};


export type Subscription_RootAgent_Portfolio_Home_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_Portfolio_Home_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Portfolio_Home_Owners_Order_By>>;
  where?: InputMaybe<Agent_Portfolio_Home_Owners_Bool_Exp>;
};


export type Subscription_RootAgent_Portfolio_Home_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_Portfolio_Home_Owners_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Portfolio_Home_Owners_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Portfolio_Home_Owners_Bool_Exp>;
};


export type Subscription_RootAgent_User_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Agent_User_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_User_Owners_Order_By>>;
  where?: InputMaybe<Agent_User_Owners_Bool_Exp>;
};


export type Subscription_RootAgent_User_Owners_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_User_Owners_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_User_Owners_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_User_Owners_Bool_Exp>;
};


export type Subscription_RootAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Order_By>>;
  where?: InputMaybe<Agents_Bool_Exp>;
};


export type Subscription_RootAgents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Agents_Bool_Exp>;
};


export type Subscription_RootAgreement_SignersArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Signers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Signers_Order_By>>;
  where?: InputMaybe<Agreement_Signers_Bool_Exp>;
};


export type Subscription_RootAgreement_Signers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgreement_Template_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Template_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Template_Types_Enum_Order_By>>;
  where?: InputMaybe<Agreement_Template_Types_Enum_Bool_Exp>;
};


export type Subscription_RootAgreement_Template_Types_Enum_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootAgreement_Template_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agreement_Template_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Template_Types_Enum_Bool_Exp>;
};


export type Subscription_RootAgreement_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreement_Templates_Order_By>>;
  where?: InputMaybe<Agreement_Templates_Bool_Exp>;
};


export type Subscription_RootAgreement_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgreement_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agreement_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Templates_Bool_Exp>;
};


export type Subscription_RootAgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Subscription_RootAgreements_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgreements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agreements_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_By_PkArgs = {
  employment_verification_status: Scalars['String']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Documents_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Documents_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_By_PkArgs = {
  frequency: Scalars['String']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Statuses_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Statuses_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Statuses_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Statuses_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Types_Enum_By_PkArgs = {
  income_source_type: Scalars['String']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Source_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Source_Types_Enum_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_BenefitsArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Benefits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Benefits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Benefits_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_EmployedArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Employed_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Employed_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Employed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Employed_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Self_EmployedArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Self_Employed_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_Self_Employed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Self_Employed_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Income_Sources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Income_Sources_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_IncomesArgs = {
  distinct_on?: InputMaybe<Array<Applicant_Income_Underwrites_User_Incomes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Applicant_Income_Underwrites_User_Incomes_Order_By>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Bool_Exp>;
};


export type Subscription_RootApplicant_Income_Underwrites_User_Incomes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicant_Income_Underwrites_User_Incomes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Applicant_Income_Underwrites_User_Incomes_Stream_Cursor_Input>>;
  where?: InputMaybe<Applicant_Income_Underwrites_User_Incomes_Bool_Exp>;
};


export type Subscription_RootBackground_Check_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Background_Check_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Background_Check_Requests_Order_By>>;
  where?: InputMaybe<Background_Check_Requests_Bool_Exp>;
};


export type Subscription_RootBackground_Check_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBackground_Check_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Background_Check_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Background_Check_Requests_Bool_Exp>;
};


export type Subscription_RootBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Subscription_RootBids_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBids_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bids_Stream_Cursor_Input>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Subscription_RootBuildium_Bulk_Journal_Entry_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Buildium_Bulk_Journal_Entry_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buildium_Bulk_Journal_Entry_Uploads_Order_By>>;
  where?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp>;
};


export type Subscription_RootBuildium_Bulk_Journal_Entry_Uploads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildium_Bulk_Journal_Entry_Uploads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Stream_Cursor_Input>>;
  where?: InputMaybe<Buildium_Bulk_Journal_Entry_Uploads_Bool_Exp>;
};


export type Subscription_RootBuildium_Resident_Center_UsersArgs = {
  distinct_on?: InputMaybe<Array<Buildium_Resident_Center_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buildium_Resident_Center_Users_Order_By>>;
  where?: InputMaybe<Buildium_Resident_Center_Users_Bool_Exp>;
};


export type Subscription_RootBuildium_Resident_Center_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildium_Resident_Center_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buildium_Resident_Center_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Buildium_Resident_Center_Users_Bool_Exp>;
};


export type Subscription_RootBuildium_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Buildium_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buildium_Transactions_Order_By>>;
  where?: InputMaybe<Buildium_Transactions_Bool_Exp>;
};


export type Subscription_RootBuildium_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildium_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buildium_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Buildium_Transactions_Bool_Exp>;
};


export type Subscription_RootCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capabilities_Order_By>>;
  where?: InputMaybe<Capabilities_Bool_Exp>;
};


export type Subscription_RootCapabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCapabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Capabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Capabilities_Bool_Exp>;
};


export type Subscription_RootCashout_AdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<Cashout_Adjustments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashout_Adjustments_Order_By>>;
  where?: InputMaybe<Cashout_Adjustments_Bool_Exp>;
};


export type Subscription_RootCashout_Adjustments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCashout_Adjustments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cashout_Adjustments_Stream_Cursor_Input>>;
  where?: InputMaybe<Cashout_Adjustments_Bool_Exp>;
};


export type Subscription_RootCashout_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Cashout_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashout_Configs_Order_By>>;
  where?: InputMaybe<Cashout_Configs_Bool_Exp>;
};


export type Subscription_RootCashout_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCashout_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cashout_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Cashout_Configs_Bool_Exp>;
};


export type Subscription_RootCashoutsArgs = {
  distinct_on?: InputMaybe<Array<Cashouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashouts_Order_By>>;
  where?: InputMaybe<Cashouts_Bool_Exp>;
};


export type Subscription_RootCashouts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCashouts_Pending_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Cashouts_Pending_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cashouts_Pending_Liabilities_Order_By>>;
  where?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
};


export type Subscription_RootCashouts_Pending_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCashouts_Pending_Liabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cashouts_Pending_Liabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Cashouts_Pending_Liabilities_Bool_Exp>;
};


export type Subscription_RootCashouts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cashouts_Stream_Cursor_Input>>;
  where?: InputMaybe<Cashouts_Bool_Exp>;
};


export type Subscription_RootCheck_Deposit_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Check_Deposit_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Check_Deposit_Payments_Order_By>>;
  where?: InputMaybe<Check_Deposit_Payments_Bool_Exp>;
};


export type Subscription_RootCheck_Deposit_Payments_By_PkArgs = {
  check_deposit_id: Scalars['uuid']['input'];
  payment_id: Scalars['uuid']['input'];
};


export type Subscription_RootCheck_Deposit_Payments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Check_Deposit_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Check_Deposit_Payments_Bool_Exp>;
};


export type Subscription_RootCheck_DepositsArgs = {
  distinct_on?: InputMaybe<Array<Check_Deposits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Check_Deposits_Order_By>>;
  where?: InputMaybe<Check_Deposits_Bool_Exp>;
};


export type Subscription_RootCheck_Deposits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCheck_Deposits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Check_Deposits_Stream_Cursor_Input>>;
  where?: InputMaybe<Check_Deposits_Bool_Exp>;
};


export type Subscription_RootCollection_Payment_PromisesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Payment_Promises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collection_Payment_Promises_Order_By>>;
  where?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
};


export type Subscription_RootCollection_Payment_Promises_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCollection_Payment_Promises_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collection_Payment_Promises_Stream_Cursor_Input>>;
  where?: InputMaybe<Collection_Payment_Promises_Bool_Exp>;
};


export type Subscription_RootCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootCollections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCollections_Late_Payment_Reason_EnumArgs = {
  distinct_on?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Late_Payment_Reason_Enum_Order_By>>;
  where?: InputMaybe<Collections_Late_Payment_Reason_Enum_Bool_Exp>;
};


export type Subscription_RootCollections_Late_Payment_Reason_Enum_By_PkArgs = {
  reason: Scalars['String']['input'];
};


export type Subscription_RootCollections_Late_Payment_Reason_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collections_Late_Payment_Reason_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_Late_Payment_Reason_Enum_Bool_Exp>;
};


export type Subscription_RootCollections_Liabilities_RemainingArgs = {
  distinct_on?: InputMaybe<Array<Collections_Liabilities_Remaining_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Liabilities_Remaining_Order_By>>;
  where?: InputMaybe<Collections_Liabilities_Remaining_Bool_Exp>;
};


export type Subscription_RootCollections_Liabilities_Remaining_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collections_Liabilities_Remaining_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_Liabilities_Remaining_Bool_Exp>;
};


export type Subscription_RootCollections_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Collections_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
};


export type Subscription_RootCollections_Rental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCollections_Rental_Liabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collections_Rental_Liabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_Rental_Liabilities_Bool_Exp>;
};


export type Subscription_RootCollections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collections_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootCommunitiesArgs = {
  distinct_on?: InputMaybe<Array<Communities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Communities_Order_By>>;
  where?: InputMaybe<Communities_Bool_Exp>;
};


export type Subscription_RootCommunities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCommunities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Communities_Stream_Cursor_Input>>;
  where?: InputMaybe<Communities_Bool_Exp>;
};


export type Subscription_RootCommunity_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Community_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Community_Features_Order_By>>;
  where?: InputMaybe<Community_Features_Bool_Exp>;
};


export type Subscription_RootCommunity_Features_By_PkArgs = {
  community_id: Scalars['uuid']['input'];
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCommunity_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Community_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Community_Features_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Common_Estimated_CostsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Common_Estimated_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Common_Estimated_Costs_Order_By>>;
  where?: InputMaybe<Construction_Construction_Common_Estimated_Costs_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Common_Estimated_Costs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Construction_Common_Estimated_Costs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Construction_Common_Estimated_Costs_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Construction_Common_Estimated_Costs_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Project_Estimated_Cost_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Project_Estimated_Cost_Histories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Project_Estimated_Cost_Histories_Order_By>>;
  where?: InputMaybe<Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Project_Estimated_Cost_Histories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Construction_Project_Estimated_Cost_Histories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Construction_Project_Estimated_Cost_Histories_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Construction_Project_Estimated_Cost_Histories_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Project_Estimated_CostsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Project_Estimated_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Project_Estimated_Costs_Order_By>>;
  where?: InputMaybe<Construction_Construction_Project_Estimated_Costs_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Project_Estimated_Costs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Construction_Project_Estimated_Costs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Construction_Project_Estimated_Costs_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Construction_Project_Estimated_Costs_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Construction_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Construction_Scopes_Order_By>>;
  where?: InputMaybe<Construction_Construction_Scopes_Bool_Exp>;
};


export type Subscription_RootConstruction_Construction_Scopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Construction_Scopes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Construction_Scopes_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Construction_Scopes_Bool_Exp>;
};


export type Subscription_RootConstruction_EstimatesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Estimates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Estimates_Order_By>>;
  where?: InputMaybe<Construction_Estimates_Bool_Exp>;
};


export type Subscription_RootConstruction_Estimates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Estimates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Estimates_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Estimates_Bool_Exp>;
};


export type Subscription_RootConstruction_General_ContractorsArgs = {
  distinct_on?: InputMaybe<Array<Construction_General_Contractors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_General_Contractors_Order_By>>;
  where?: InputMaybe<Construction_General_Contractors_Bool_Exp>;
};


export type Subscription_RootConstruction_General_Contractors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_General_Contractors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_General_Contractors_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_General_Contractors_Bool_Exp>;
};


export type Subscription_RootConstruction_Occupancy_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Occupancy_Inspections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Occupancy_Inspections_Order_By>>;
  where?: InputMaybe<Construction_Occupancy_Inspections_Bool_Exp>;
};


export type Subscription_RootConstruction_Occupancy_Inspections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Occupancy_Inspections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Occupancy_Inspections_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Occupancy_Inspections_Bool_Exp>;
};


export type Subscription_RootConstruction_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Projects_Order_By>>;
  where?: InputMaybe<Construction_Projects_Bool_Exp>;
};


export type Subscription_RootConstruction_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Projects_Bool_Exp>;
};


export type Subscription_RootConstruction_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Construction_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Scopes_Order_By>>;
  where?: InputMaybe<Construction_Scopes_Bool_Exp>;
};


export type Subscription_RootConstruction_Scopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Scopes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Scopes_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Scopes_Bool_Exp>;
};


export type Subscription_RootConstruction_Scopes_VendorsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Scopes_Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Scopes_Vendors_Order_By>>;
  where?: InputMaybe<Construction_Scopes_Vendors_Bool_Exp>;
};


export type Subscription_RootConstruction_Scopes_Vendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Scopes_Vendors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Scopes_Vendors_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Scopes_Vendors_Bool_Exp>;
};


export type Subscription_RootConstruction_WalkthroughsArgs = {
  distinct_on?: InputMaybe<Array<Construction_Walkthroughs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Walkthroughs_Order_By>>;
  where?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
};


export type Subscription_RootConstruction_Walkthroughs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_Walkthroughs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Walkthroughs_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Walkthroughs_Bool_Exp>;
};


export type Subscription_RootConversationsArgs = {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
};


export type Subscription_RootConversations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConversations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Conversations_Stream_Cursor_Input>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
};


export type Subscription_RootCredit_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Reports_Order_By>>;
  where?: InputMaybe<Credit_Reports_Bool_Exp>;
};


export type Subscription_RootCredit_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Reports_Bool_Exp>;
};


export type Subscription_RootCriminal_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Criminal_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criminal_Reports_Order_By>>;
  where?: InputMaybe<Criminal_Reports_Bool_Exp>;
};


export type Subscription_RootCriminal_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCriminal_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Criminal_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Criminal_Reports_Bool_Exp>;
};


export type Subscription_RootCurrent_BalancesArgs = {
  distinct_on?: InputMaybe<Array<Current_Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Balances_Order_By>>;
  where?: InputMaybe<Current_Balances_Bool_Exp>;
};


export type Subscription_RootCurrent_Balances_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Current_Balances_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Balances_Bool_Exp>;
};


export type Subscription_RootCurrent_StatementsArgs = {
  distinct_on?: InputMaybe<Array<Current_Statements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Statements_Order_By>>;
  where?: InputMaybe<Current_Statements_Bool_Exp>;
};


export type Subscription_RootCurrent_Statements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Current_Statements_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Statements_Bool_Exp>;
};


export type Subscription_RootCurrent_Utility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Current_Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Current_Utility_Responsibilities_Bool_Exp>;
};


export type Subscription_RootCurrent_Utility_Responsibilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Current_Utility_Responsibilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Utility_Responsibilities_Bool_Exp>;
};


export type Subscription_RootDashboardsArgs = {
  distinct_on?: InputMaybe<Array<Dashboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dashboards_Order_By>>;
  where?: InputMaybe<Dashboards_Bool_Exp>;
};


export type Subscription_RootDashboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDashboards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dashboards_Stream_Cursor_Input>>;
  where?: InputMaybe<Dashboards_Bool_Exp>;
};


export type Subscription_RootDispositions_Buyers_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Buyers_Inspections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Buyers_Inspections_Order_By>>;
  where?: InputMaybe<Dispositions_Buyers_Inspections_Bool_Exp>;
};


export type Subscription_RootDispositions_Buyers_Inspections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispositions_Buyers_Inspections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispositions_Buyers_Inspections_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispositions_Buyers_Inspections_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_BidsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Bids_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_Bids_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_Bids_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Bids_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_CounterpartiesArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Counterparties_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_Counterparties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_Counterparties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Counterparties_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Disposition_Statuses_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootDispositions_Portfolio_Home_Disposition_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Disposition_Statuses_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_DispositionsArgs = {
  distinct_on?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispositions_Portfolio_Home_Dispositions_Order_By>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
};


export type Subscription_RootDispositions_Portfolio_Home_Dispositions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispositions_Portfolio_Home_Dispositions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispositions_Portfolio_Home_Dispositions_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispositions_Portfolio_Home_Dispositions_Bool_Exp>;
};


export type Subscription_RootDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocuments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDown_Status_IncidentsArgs = {
  distinct_on?: InputMaybe<Array<Down_Status_Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Down_Status_Incidents_Order_By>>;
  where?: InputMaybe<Down_Status_Incidents_Bool_Exp>;
};


export type Subscription_RootDown_Status_Incidents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDown_Status_Incidents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Down_Status_Incidents_Stream_Cursor_Input>>;
  where?: InputMaybe<Down_Status_Incidents_Bool_Exp>;
};


export type Subscription_RootEviction_Filing_FeesArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Filing_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Filing_Fees_Order_By>>;
  where?: InputMaybe<Eviction_Filing_Fees_Bool_Exp>;
};


export type Subscription_RootEviction_Filing_Fees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEviction_Filing_Fees_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eviction_Filing_Fees_Stream_Cursor_Input>>;
  where?: InputMaybe<Eviction_Filing_Fees_Bool_Exp>;
};


export type Subscription_RootEviction_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Reports_Order_By>>;
  where?: InputMaybe<Eviction_Reports_Bool_Exp>;
};


export type Subscription_RootEviction_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEviction_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eviction_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Eviction_Reports_Bool_Exp>;
};


export type Subscription_RootEvictionsArgs = {
  distinct_on?: InputMaybe<Array<Evictions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Evictions_Order_By>>;
  where?: InputMaybe<Evictions_Bool_Exp>;
};


export type Subscription_RootEvictions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvictions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Evictions_Stream_Cursor_Input>>;
  where?: InputMaybe<Evictions_Bool_Exp>;
};


export type Subscription_RootFund_LlcsArgs = {
  distinct_on?: InputMaybe<Array<Fund_Llcs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fund_Llcs_Order_By>>;
  where?: InputMaybe<Fund_Llcs_Bool_Exp>;
};


export type Subscription_RootFund_Llcs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFund_Llcs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fund_Llcs_Stream_Cursor_Input>>;
  where?: InputMaybe<Fund_Llcs_Bool_Exp>;
};


export type Subscription_RootFund_Rental_Program_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Fund_Rental_Program_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fund_Rental_Program_Configs_Order_By>>;
  where?: InputMaybe<Fund_Rental_Program_Configs_Bool_Exp>;
};


export type Subscription_RootFund_Rental_Program_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFund_Rental_Program_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fund_Rental_Program_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Fund_Rental_Program_Configs_Bool_Exp>;
};


export type Subscription_RootFundsArgs = {
  distinct_on?: InputMaybe<Array<Funds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funds_Order_By>>;
  where?: InputMaybe<Funds_Bool_Exp>;
};


export type Subscription_RootFunds_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFunds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funds_Stream_Cursor_Input>>;
  where?: InputMaybe<Funds_Bool_Exp>;
};


export type Subscription_RootHome_Construction_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Construction_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Construction_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Construction_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Construction_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootHome_Construction_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Construction_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Construction_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Construction_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Construction_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Construction_Statuses_Order_By>>;
  where?: InputMaybe<Home_Construction_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Construction_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHome_Construction_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Construction_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Construction_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Occupancy_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Occupancy_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Occupancy_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Occupancy_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Occupancy_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootHome_Occupancy_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Occupancy_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Occupancy_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Occupancy_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Occupancy_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Occupancy_Statuses_Order_By>>;
  where?: InputMaybe<Home_Occupancy_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Occupancy_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHome_Occupancy_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Occupancy_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Occupancy_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Ownership_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Ownership_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Ownership_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Ownership_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Ownership_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootHome_Ownership_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Ownership_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Ownership_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Ownership_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Ownership_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Ownership_Statuses_Order_By>>;
  where?: InputMaybe<Home_Ownership_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Ownership_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHome_Ownership_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Ownership_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Ownership_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Summary_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Home_Summary_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Summary_Status_Enum_Order_By>>;
  where?: InputMaybe<Home_Summary_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Summary_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootHome_Summary_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Summary_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Summary_Status_Enum_Bool_Exp>;
};


export type Subscription_RootHome_Summary_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Home_Summary_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Home_Summary_Statuses_Order_By>>;
  where?: InputMaybe<Home_Summary_Statuses_Bool_Exp>;
};


export type Subscription_RootHome_Summary_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHome_Summary_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Home_Summary_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Home_Summary_Statuses_Bool_Exp>;
};


export type Subscription_RootHomesArgs = {
  distinct_on?: InputMaybe<Array<Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Homes_Order_By>>;
  where?: InputMaybe<Homes_Bool_Exp>;
};


export type Subscription_RootHomes360Args = {
  distinct_on?: InputMaybe<Array<Homes360_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Homes360_Order_By>>;
  where?: InputMaybe<Homes360_Bool_Exp>;
};


export type Subscription_RootHomes360_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Homes360_Stream_Cursor_Input>>;
  where?: InputMaybe<Homes360_Bool_Exp>;
};


export type Subscription_RootHomes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHomes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Homes_Stream_Cursor_Input>>;
  where?: InputMaybe<Homes_Bool_Exp>;
};


export type Subscription_RootKafka_Connector_Prorated_Utility_Bill_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Order_By>>;
  where?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>;
};


export type Subscription_RootKafka_Connector_Prorated_Utility_Bill_Line_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootKafka_Connector_Prorated_Utility_Bill_Line_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Kafka_Connector_Prorated_Utility_Bill_Line_Items_Bool_Exp>;
};


export type Subscription_RootLatchel_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Categories_Order_By>>;
  where?: InputMaybe<Latchel_Categories_Bool_Exp>;
};


export type Subscription_RootLatchel_Categories_By_PkArgs = {
  category_id: Scalars['Int']['input'];
};


export type Subscription_RootLatchel_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Latchel_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Latchel_Categories_Bool_Exp>;
};


export type Subscription_RootLatchel_Dead_LettersArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Dead_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Dead_Letters_Order_By>>;
  where?: InputMaybe<Latchel_Dead_Letters_Bool_Exp>;
};


export type Subscription_RootLatchel_Dead_Letters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLatchel_Dead_Letters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Latchel_Dead_Letters_Stream_Cursor_Input>>;
  where?: InputMaybe<Latchel_Dead_Letters_Bool_Exp>;
};


export type Subscription_RootLatchel_Vendor_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Vendor_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Vendor_Categories_Order_By>>;
  where?: InputMaybe<Latchel_Vendor_Categories_Bool_Exp>;
};


export type Subscription_RootLatchel_Vendor_Categories_By_PkArgs = {
  latchel_category_id: Scalars['Int']['input'];
  latchel_vendor_company_id: Scalars['Int']['input'];
};


export type Subscription_RootLatchel_Vendor_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Latchel_Vendor_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Latchel_Vendor_Categories_Bool_Exp>;
};


export type Subscription_RootLatchel_Vendor_UsersArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Vendor_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Vendor_Users_Order_By>>;
  where?: InputMaybe<Latchel_Vendor_Users_Bool_Exp>;
};


export type Subscription_RootLatchel_Vendor_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLatchel_Vendor_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Latchel_Vendor_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Latchel_Vendor_Users_Bool_Exp>;
};


export type Subscription_RootLead_Group_Rental_Application_NotesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Rental_Application_Notes_Order_By>>;
  where?: InputMaybe<Lead_Group_Rental_Application_Notes_Bool_Exp>;
};


export type Subscription_RootLead_Group_Rental_Application_Notes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Group_Rental_Application_Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Group_Rental_Application_Notes_Bool_Exp>;
};


export type Subscription_RootLead_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Users_Order_By>>;
  where?: InputMaybe<Lead_Group_Users_Bool_Exp>;
};


export type Subscription_RootLead_Group_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLead_Group_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Group_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Group_Users_Bool_Exp>;
};


export type Subscription_RootLead_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Groups_Order_By>>;
  where?: InputMaybe<Lead_Groups_Bool_Exp>;
};


export type Subscription_RootLead_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLead_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Groups_Bool_Exp>;
};


export type Subscription_RootLedger_Account_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Ledger_Account_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ledger_Account_Categories_Order_By>>;
  where?: InputMaybe<Ledger_Account_Categories_Bool_Exp>;
};


export type Subscription_RootLedger_Account_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLedger_Account_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ledger_Account_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Ledger_Account_Categories_Bool_Exp>;
};


export type Subscription_RootLedger_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Ledger_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ledger_Accounts_Order_By>>;
  where?: InputMaybe<Ledger_Accounts_Bool_Exp>;
};


export type Subscription_RootLedger_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLedger_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ledger_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Ledger_Accounts_Bool_Exp>;
};


export type Subscription_RootLiabilities_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Liabilities_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Liabilities_Payments_Order_By>>;
  where?: InputMaybe<Liabilities_Payments_Bool_Exp>;
};


export type Subscription_RootLiabilities_Payments_By_PkArgs = {
  liability_id: Scalars['uuid']['input'];
  payment_or_credit_id: Scalars['uuid']['input'];
};


export type Subscription_RootLiabilities_Payments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Liabilities_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Liabilities_Payments_Bool_Exp>;
};


export type Subscription_RootLiability_TypesArgs = {
  distinct_on?: InputMaybe<Array<Liability_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Liability_Types_Order_By>>;
  where?: InputMaybe<Liability_Types_Bool_Exp>;
};


export type Subscription_RootLiability_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLiability_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Liability_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Liability_Types_Bool_Exp>;
};


export type Subscription_RootListed_RentsArgs = {
  distinct_on?: InputMaybe<Array<Listed_Rents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Listed_Rents_Order_By>>;
  where?: InputMaybe<Listed_Rents_Bool_Exp>;
};


export type Subscription_RootListed_Rents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootListed_Rents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Listed_Rents_Stream_Cursor_Input>>;
  where?: InputMaybe<Listed_Rents_Bool_Exp>;
};


export type Subscription_RootListing_SearchableArgs = {
  distinct_on?: InputMaybe<Array<Listing_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Listing_Searchable_Order_By>>;
  where?: InputMaybe<Listing_Searchable_Bool_Exp>;
};


export type Subscription_RootListing_Searchable_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Listing_Searchable_Stream_Cursor_Input>>;
  where?: InputMaybe<Listing_Searchable_Bool_Exp>;
};


export type Subscription_RootLlc_Market_Agreement_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Market_Agreement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Market_Agreement_Templates_Order_By>>;
  where?: InputMaybe<Llc_Market_Agreement_Templates_Bool_Exp>;
};


export type Subscription_RootLlc_Market_Agreement_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLlc_Market_Agreement_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Llc_Market_Agreement_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Llc_Market_Agreement_Templates_Bool_Exp>;
};


export type Subscription_RootLlc_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Llc_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Properties_Order_By>>;
  where?: InputMaybe<Llc_Properties_Bool_Exp>;
};


export type Subscription_RootLlc_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLlc_Properties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Llc_Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Llc_Properties_Bool_Exp>;
};


export type Subscription_RootLlc_Property_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Llc_Property_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llc_Property_Transfers_Order_By>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


export type Subscription_RootLlc_Property_Transfers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLlc_Property_Transfers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Llc_Property_Transfers_Stream_Cursor_Input>>;
  where?: InputMaybe<Llc_Property_Transfers_Bool_Exp>;
};


export type Subscription_RootLlcsArgs = {
  distinct_on?: InputMaybe<Array<Llcs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Llcs_Order_By>>;
  where?: InputMaybe<Llcs_Bool_Exp>;
};


export type Subscription_RootLlcs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLlcs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Llcs_Stream_Cursor_Input>>;
  where?: InputMaybe<Llcs_Bool_Exp>;
};


export type Subscription_RootLockbox_CodesArgs = {
  distinct_on?: InputMaybe<Array<Lockbox_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lockbox_Codes_Order_By>>;
  where?: InputMaybe<Lockbox_Codes_Bool_Exp>;
};


export type Subscription_RootLockbox_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLockbox_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lockbox_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Lockbox_Codes_Bool_Exp>;
};


export type Subscription_RootMarketsArgs = {
  distinct_on?: InputMaybe<Array<Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Markets_Order_By>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


export type Subscription_RootMarkets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMarkets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Markets_Stream_Cursor_Input>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Internal_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Internal_Attributes_Order_By>>;
  where?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Internal_Attributes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Listing_Internal_Attributes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Listing_Internal_Attributes_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Listing_Internal_Attributes_Bool_Exp>;
};


export type Subscription_RootMls_Listing_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Overrides_Order_By>>;
  where?: InputMaybe<Mls_Listing_Overrides_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Listing_Overrides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Listing_Overrides_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Listing_Overrides_Bool_Exp>;
};


export type Subscription_RootMls_Listing_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Photos_Order_By>>;
  where?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Listing_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Listing_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Listing_Photos_Bool_Exp>;
};


export type Subscription_RootMls_Listing_PromotionsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Promotions_Order_By>>;
  where?: InputMaybe<Mls_Listing_Promotions_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Promotions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Listing_Promotions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Listing_Promotions_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Listing_Promotions_Bool_Exp>;
};


export type Subscription_RootMls_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listings_Order_By>>;
  where?: InputMaybe<Mls_Listings_Bool_Exp>;
};


export type Subscription_RootMls_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Listings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Listings_Bool_Exp>;
};


export type Subscription_RootMost_Recent_Llc_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Most_Recent_Llc_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Most_Recent_Llc_Property_Order_By>>;
  where?: InputMaybe<Most_Recent_Llc_Property_Bool_Exp>;
};


export type Subscription_RootMost_Recent_Llc_Property_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Most_Recent_Llc_Property_Stream_Cursor_Input>>;
  where?: InputMaybe<Most_Recent_Llc_Property_Bool_Exp>;
};


export type Subscription_RootMost_Relevant_User_Identity_Verification_By_UserArgs = {
  distinct_on?: InputMaybe<Array<Most_Relevant_User_Identity_Verification_By_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Most_Relevant_User_Identity_Verification_By_User_Order_By>>;
  where?: InputMaybe<Most_Relevant_User_Identity_Verification_By_User_Bool_Exp>;
};


export type Subscription_RootMost_Relevant_User_Identity_Verification_By_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Most_Relevant_User_Identity_Verification_By_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Most_Relevant_User_Identity_Verification_By_User_Bool_Exp>;
};


export type Subscription_RootMove_InsArgs = {
  distinct_on?: InputMaybe<Array<Move_Ins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Move_Ins_Order_By>>;
  where?: InputMaybe<Move_Ins_Bool_Exp>;
};


export type Subscription_RootMove_Ins_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMove_Ins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Move_Ins_Stream_Cursor_Input>>;
  where?: InputMaybe<Move_Ins_Bool_Exp>;
};


export type Subscription_RootMunicipalitiesArgs = {
  distinct_on?: InputMaybe<Array<Municipalities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Municipalities_Order_By>>;
  where?: InputMaybe<Municipalities_Bool_Exp>;
};


export type Subscription_RootMunicipalities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMunicipalities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Municipalities_Stream_Cursor_Input>>;
  where?: InputMaybe<Municipalities_Bool_Exp>;
};


export type Subscription_RootMunicipality_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Municipality_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Municipality_Contacts_Order_By>>;
  where?: InputMaybe<Municipality_Contacts_Bool_Exp>;
};


export type Subscription_RootMunicipality_Contacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMunicipality_Contacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Municipality_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Municipality_Contacts_Bool_Exp>;
};


export type Subscription_RootNote_PrioritiesArgs = {
  distinct_on?: InputMaybe<Array<Note_Priorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Priorities_Order_By>>;
  where?: InputMaybe<Note_Priorities_Bool_Exp>;
};


export type Subscription_RootNote_Priorities_By_PkArgs = {
  note_priority: Scalars['String']['input'];
};


export type Subscription_RootNote_Priorities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Note_Priorities_Stream_Cursor_Input>>;
  where?: InputMaybe<Note_Priorities_Bool_Exp>;
};


export type Subscription_RootNotesArgs = {
  distinct_on?: InputMaybe<Array<Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notes_Order_By>>;
  where?: InputMaybe<Notes_Bool_Exp>;
};


export type Subscription_RootNotes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Notes_Bool_Exp>;
};


export type Subscription_RootOpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<Opportunities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Opportunities_Order_By>>;
  where?: InputMaybe<Opportunities_Bool_Exp>;
};


export type Subscription_RootOpportunities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOpportunities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Opportunities_Stream_Cursor_Input>>;
  where?: InputMaybe<Opportunities_Bool_Exp>;
};


export type Subscription_RootOption_Premium_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Option_Premium_Transfers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Option_Premium_Transfers_Order_By>>;
  where?: InputMaybe<Option_Premium_Transfers_Bool_Exp>;
};


export type Subscription_RootOption_Premium_Transfers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOption_Premium_Transfers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Option_Premium_Transfers_Stream_Cursor_Input>>;
  where?: InputMaybe<Option_Premium_Transfers_Bool_Exp>;
};


export type Subscription_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayment_Methods_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Plan_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Plan_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Plan_Liabilities_Order_By>>;
  where?: InputMaybe<Payment_Plan_Liabilities_Bool_Exp>;
};


export type Subscription_RootPayment_Plan_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayment_Plan_Liabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Plan_Liabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Plan_Liabilities_Bool_Exp>;
};


export type Subscription_RootPayment_Plan_Offset_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Plan_Offset_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Plan_Offset_Credits_Order_By>>;
  where?: InputMaybe<Payment_Plan_Offset_Credits_Bool_Exp>;
};


export type Subscription_RootPayment_Plan_Offset_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayment_Plan_Offset_Credits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Plan_Offset_Credits_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Plan_Offset_Credits_Bool_Exp>;
};


export type Subscription_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPlaid_Income_Verification_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Plaid_Income_Verification_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plaid_Income_Verification_Documents_Order_By>>;
  where?: InputMaybe<Plaid_Income_Verification_Documents_Bool_Exp>;
};


export type Subscription_RootPlaid_Income_Verification_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Plaid_Income_Verification_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Plaid_Income_Verification_Documents_Bool_Exp>;
};


export type Subscription_RootPlaid_Income_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Plaid_Income_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plaid_Income_Verifications_Order_By>>;
  where?: InputMaybe<Plaid_Income_Verifications_Bool_Exp>;
};


export type Subscription_RootPlaid_Income_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlaid_Income_Verifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Plaid_Income_Verifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Plaid_Income_Verifications_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_External_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_External_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_External_Features_Order_By>>;
  where?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_External_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
  portfolio_home_id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolio_Home_External_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Home_External_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Home_External_Features_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_Internal_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_Internal_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_Internal_Features_Order_By>>;
  where?: InputMaybe<Portfolio_Home_Internal_Features_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_Internal_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
  portfolio_home_id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolio_Home_Internal_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Home_Internal_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Home_Internal_Features_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_System_Work_Order_System_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_System_Work_Order_System_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_System_Work_Order_System_Enum_Order_By>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_System_Work_Order_System_Enum_By_PkArgs = {
  system: Scalars['String']['input'];
};


export type Subscription_RootPortfolio_Home_System_Work_Order_System_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Order_System_Enum_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_System_Work_Order_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_System_Work_Order_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_System_Work_Order_Type_Enum_Order_By>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_System_Work_Order_Type_Enum_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootPortfolio_Home_System_Work_Order_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Order_Type_Enum_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_System_Work_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_System_Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_System_Work_Orders_Order_By>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Orders_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_System_Work_Orders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolio_Home_System_Work_Orders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Home_System_Work_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Home_System_Work_Orders_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_UtilitiesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_Utilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_Utilities_Order_By>>;
  where?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
};


export type Subscription_RootPortfolio_Home_Utilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolio_Home_Utilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Home_Utilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
};


export type Subscription_RootPortfolio_HomesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Homes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Homes_Order_By>>;
  where?: InputMaybe<Portfolio_Homes_Bool_Exp>;
};


export type Subscription_RootPortfolio_Homes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolio_Homes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Homes_Stream_Cursor_Input>>;
  where?: InputMaybe<Portfolio_Homes_Bool_Exp>;
};


export type Subscription_RootPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Subscription_RootProperties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Subscription_RootReal_Estate_AcquisitionsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Acquisitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Acquisitions_Order_By>>;
  where?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};


export type Subscription_RootReal_Estate_Acquisitions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReal_Estate_Acquisitions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Real_Estate_Acquisitions_Stream_Cursor_Input>>;
  where?: InputMaybe<Real_Estate_Acquisitions_Bool_Exp>;
};


export type Subscription_RootReal_Estate_ScreeningsArgs = {
  distinct_on?: InputMaybe<Array<Real_Estate_Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Real_Estate_Screenings_Order_By>>;
  where?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
};


export type Subscription_RootReal_Estate_Screenings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReal_Estate_Screenings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Real_Estate_Screenings_Stream_Cursor_Input>>;
  where?: InputMaybe<Real_Estate_Screenings_Bool_Exp>;
};


export type Subscription_RootRecurring_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Recurring_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Recurring_Credits_Order_By>>;
  where?: InputMaybe<Recurring_Credits_Bool_Exp>;
};


export type Subscription_RootRecurring_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRecurring_Credits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Recurring_Credits_Stream_Cursor_Input>>;
  where?: InputMaybe<Recurring_Credits_Bool_Exp>;
};


export type Subscription_RootRenewal_OffersArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Renewal_Offers_Order_By>>;
  where?: InputMaybe<Renewal_Offers_Bool_Exp>;
};


export type Subscription_RootRenewal_Offers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRenewal_Offers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Renewal_Offers_Stream_Cursor_Input>>;
  where?: InputMaybe<Renewal_Offers_Bool_Exp>;
};


export type Subscription_RootRenewalsArgs = {
  distinct_on?: InputMaybe<Array<Renewals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Renewals_Order_By>>;
  where?: InputMaybe<Renewals_Bool_Exp>;
};


export type Subscription_RootRenewals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRenewals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Renewals_Stream_Cursor_Input>>;
  where?: InputMaybe<Renewals_Bool_Exp>;
};


export type Subscription_RootRent_PricesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Prices_Order_By>>;
  where?: InputMaybe<Rent_Prices_Bool_Exp>;
};


export type Subscription_RootRent_Prices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRent_Prices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rent_Prices_Stream_Cursor_Input>>;
  where?: InputMaybe<Rent_Prices_Bool_Exp>;
};


export type Subscription_RootRent_Ready_DatesArgs = {
  distinct_on?: InputMaybe<Array<Rent_Ready_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Ready_Dates_Order_By>>;
  where?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
};


export type Subscription_RootRent_Ready_Dates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRent_Ready_Dates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rent_Ready_Dates_Stream_Cursor_Input>>;
  where?: InputMaybe<Rent_Ready_Dates_Bool_Exp>;
};


export type Subscription_RootRent_RollArgs = {
  distinct_on?: InputMaybe<Array<Rent_Roll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rent_Roll_Order_By>>;
  where?: InputMaybe<Rent_Roll_Bool_Exp>;
};


export type Subscription_RootRent_Roll_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rent_Roll_Stream_Cursor_Input>>;
  where?: InputMaybe<Rent_Roll_Bool_Exp>;
};


export type Subscription_RootRental_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Add_Ons_Order_By>>;
  where?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
};


export type Subscription_RootRental_Add_Ons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Add_Ons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Add_Ons_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Add_Ons_Bool_Exp>;
};


export type Subscription_RootRental_Agreement_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Agreement_Histories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Agreement_Histories_Order_By>>;
  where?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
};


export type Subscription_RootRental_Agreement_Histories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Agreement_Histories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Agreement_Histories_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Agreement_Histories_Bool_Exp>;
};


export type Subscription_RootRental_Application_DecisionsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Decisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Decisions_Order_By>>;
  where?: InputMaybe<Rental_Application_Decisions_Bool_Exp>;
};


export type Subscription_RootRental_Application_Decisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Decisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Decisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Decisions_Bool_Exp>;
};


export type Subscription_RootRental_Application_FeesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Fees_Order_By>>;
  where?: InputMaybe<Rental_Application_Fees_Bool_Exp>;
};


export type Subscription_RootRental_Application_Fees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Fees_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Fees_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Fees_Config_Order_By>>;
  where?: InputMaybe<Rental_Application_Fees_Config_Bool_Exp>;
};


export type Subscription_RootRental_Application_Fees_Config_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Fees_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Fees_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Fees_Config_Bool_Exp>;
};


export type Subscription_RootRental_Application_Fees_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Fees_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Fees_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Admin_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Admin_Assignments_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Admin_Assignments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Manager_Admin_Assignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Manager_Admin_Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Assignments_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Admin_RolesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Admin_Roles_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Roles_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Admin_Roles_By_PkArgs = {
  admin_role: Scalars['String']['input'];
};


export type Subscription_RootRental_Application_Manager_Admin_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Manager_Admin_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Manager_Admin_Roles_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Application_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Escalations_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Application_Escalations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Manager_Application_Escalations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Manager_Application_Escalations_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Escalations_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Application_SnoozesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Application_Snoozes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Application_Snoozes_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Application_Snoozes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Manager_Application_Snoozes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Manager_Application_Snoozes_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Manager_Application_Snoozes_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Escalation_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Escalation_Statuses_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Escalation_Statuses_By_PkArgs = {
  escalation_status: Scalars['String']['input'];
};


export type Subscription_RootRental_Application_Manager_Escalation_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Manager_Escalation_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Manager_Escalation_Statuses_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Snooze_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Manager_Snooze_Reasons_Order_By>>;
  where?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>;
};


export type Subscription_RootRental_Application_Manager_Snooze_Reasons_By_PkArgs = {
  snooze_reason: Scalars['String']['input'];
};


export type Subscription_RootRental_Application_Manager_Snooze_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Manager_Snooze_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Manager_Snooze_Reasons_Bool_Exp>;
};


export type Subscription_RootRental_Application_OccupantsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Occupants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Occupants_Order_By>>;
  where?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
};


export type Subscription_RootRental_Application_Occupants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Occupants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Occupants_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Occupants_Bool_Exp>;
};


export type Subscription_RootRental_Application_PetsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Pets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Pets_Order_By>>;
  where?: InputMaybe<Rental_Application_Pets_Bool_Exp>;
};


export type Subscription_RootRental_Application_Pets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Pets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Pets_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Pets_Bool_Exp>;
};


export type Subscription_RootRental_Application_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Vehicles_Order_By>>;
  where?: InputMaybe<Rental_Application_Vehicles_Bool_Exp>;
};


export type Subscription_RootRental_Application_Vehicles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Application_Vehicles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Application_Vehicles_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Application_Vehicles_Bool_Exp>;
};


export type Subscription_RootRental_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


export type Subscription_RootRental_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


export type Subscription_RootRental_Applications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Applications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Applications_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
};


export type Subscription_RootRental_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Credits_Order_By>>;
  where?: InputMaybe<Rental_Credits_Bool_Exp>;
};


export type Subscription_RootRental_Credits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Credits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Credits_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Credits_Bool_Exp>;
};


export type Subscription_RootRental_Internet_Fee_ElectionsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Internet_Fee_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Internet_Fee_Elections_Order_By>>;
  where?: InputMaybe<Rental_Internet_Fee_Elections_Bool_Exp>;
};


export type Subscription_RootRental_Internet_Fee_Elections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Internet_Fee_Elections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Internet_Fee_Elections_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Internet_Fee_Elections_Bool_Exp>;
};


export type Subscription_RootRental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Rental_Liabilities_Bool_Exp>;
};


export type Subscription_RootRental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Liabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Liabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Liabilities_Bool_Exp>;
};


export type Subscription_RootRental_Move_In_FeesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Move_In_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Move_In_Fees_Order_By>>;
  where?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
};


export type Subscription_RootRental_Move_In_Fees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Move_In_Fees_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Move_In_Fees_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Move_In_Fees_Bool_Exp>;
};


export type Subscription_RootRental_OccupantsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Occupants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Occupants_Order_By>>;
  where?: InputMaybe<Rental_Occupants_Bool_Exp>;
};


export type Subscription_RootRental_Occupants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Occupants_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Occupants_Bool_Exp>;
};


export type Subscription_RootRental_Reunderwrite_Tenant_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Order_By>>;
  where?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
};


export type Subscription_RootRental_Reunderwrite_Tenant_Underwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Reunderwrite_Tenant_Underwrites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
};


export type Subscription_RootRental_ReunderwritesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Reunderwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Reunderwrites_Order_By>>;
  where?: InputMaybe<Rental_Reunderwrites_Bool_Exp>;
};


export type Subscription_RootRental_Reunderwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Reunderwrites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Reunderwrites_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Reunderwrites_Bool_Exp>;
};


export type Subscription_RootRental_Site_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Accounts_Order_By>>;
  where?: InputMaybe<Rental_Site_Accounts_Bool_Exp>;
};


export type Subscription_RootRental_Site_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Site_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Site_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Site_Accounts_Bool_Exp>;
};


export type Subscription_RootRental_Site_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Leads_Order_By>>;
  where?: InputMaybe<Rental_Site_Leads_Bool_Exp>;
};


export type Subscription_RootRental_Site_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Site_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Site_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Site_Leads_Bool_Exp>;
};


export type Subscription_RootRental_Site_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Listings_Order_By>>;
  where?: InputMaybe<Rental_Site_Listings_Bool_Exp>;
};


export type Subscription_RootRental_Site_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Site_Listings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Site_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Site_Listings_Bool_Exp>;
};


export type Subscription_RootRental_Site_Opportunity_ChecksArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Opportunity_Checks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Opportunity_Checks_Order_By>>;
  where?: InputMaybe<Rental_Site_Opportunity_Checks_Bool_Exp>;
};


export type Subscription_RootRental_Site_Opportunity_Checks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Site_Opportunity_Checks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Site_Opportunity_Checks_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Site_Opportunity_Checks_Bool_Exp>;
};


export type Subscription_RootRental_UsersArgs = {
  distinct_on?: InputMaybe<Array<Rental_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Users_Order_By>>;
  where?: InputMaybe<Rental_Users_Bool_Exp>;
};


export type Subscription_RootRental_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Users_Bool_Exp>;
};


export type Subscription_RootRental_Utility_Chargeback_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Order_By>>;
  where?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
};


export type Subscription_RootRental_Utility_Chargeback_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Utility_Chargeback_Overrides_Order_By>>;
  where?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
};


export type Subscription_RootRental_Utility_Chargeback_Overrides_By_PkArgs = {
  rental_id: Scalars['uuid']['input'];
};


export type Subscription_RootRental_Utility_Chargeback_Overrides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rental_Utility_Chargeback_Overrides_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Utility_Chargeback_Overrides_Bool_Exp>;
};


export type Subscription_RootRentalsArgs = {
  distinct_on?: InputMaybe<Array<Rentals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rentals_Order_By>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


export type Subscription_RootRentals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRentals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rentals_Stream_Cursor_Input>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


export type Subscription_RootSaferent_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Saferent_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saferent_Requests_Order_By>>;
  where?: InputMaybe<Saferent_Requests_Bool_Exp>;
};


export type Subscription_RootSaferent_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSaferent_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Saferent_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Saferent_Requests_Bool_Exp>;
};


export type Subscription_RootScheduled_Rental_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Rental_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scheduled_Rental_Liabilities_Order_By>>;
  where?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
};


export type Subscription_RootScheduled_Rental_Liabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootScheduled_Rental_Liabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scheduled_Rental_Liabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Scheduled_Rental_Liabilities_Bool_Exp>;
};


export type Subscription_RootSecurity_EnumArgs = {
  distinct_on?: InputMaybe<Array<Security_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Security_Enum_Order_By>>;
  where?: InputMaybe<Security_Enum_Bool_Exp>;
};


export type Subscription_RootSecurity_Enum_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootSecurity_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Security_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Security_Enum_Bool_Exp>;
};


export type Subscription_RootSeller_Agent_SearchableArgs = {
  distinct_on?: InputMaybe<Array<Seller_Agent_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Agent_Searchable_Order_By>>;
  where?: InputMaybe<Seller_Agent_Searchable_Bool_Exp>;
};


export type Subscription_RootSeller_Agent_Searchable_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Agent_Searchable_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Agent_Searchable_Bool_Exp>;
};


export type Subscription_RootSeller_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Seller_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Agents_Order_By>>;
  where?: InputMaybe<Seller_Agents_Bool_Exp>;
};


export type Subscription_RootSeller_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeller_Agents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Agents_Bool_Exp>;
};


export type Subscription_RootStatementsArgs = {
  distinct_on?: InputMaybe<Array<Statements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statements_Order_By>>;
  where?: InputMaybe<Statements_Bool_Exp>;
};


export type Subscription_RootStatements_RawArgs = {
  distinct_on?: InputMaybe<Array<Statements_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statements_Raw_Order_By>>;
  where?: InputMaybe<Statements_Raw_Bool_Exp>;
};


export type Subscription_RootStatements_Raw_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStatements_Raw_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Statements_Raw_Stream_Cursor_Input>>;
  where?: InputMaybe<Statements_Raw_Bool_Exp>;
};


export type Subscription_RootStatements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Statements_Stream_Cursor_Input>>;
  where?: InputMaybe<Statements_Bool_Exp>;
};


export type Subscription_RootTenant_Underwrite_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Underwrite_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Underwrite_Documents_Order_By>>;
  where?: InputMaybe<Tenant_Underwrite_Documents_Bool_Exp>;
};


export type Subscription_RootTenant_Underwrite_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenant_Underwrite_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenant_Underwrite_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenant_Underwrite_Documents_Bool_Exp>;
};


export type Subscription_RootTenant_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Underwrites_Order_By>>;
  where?: InputMaybe<Tenant_Underwrites_Bool_Exp>;
};


export type Subscription_RootTenant_Underwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenant_Underwrites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenant_Underwrites_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenant_Underwrites_Bool_Exp>;
};


export type Subscription_RootTicket_Vendor_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Vendor_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Vendor_Assignments_Order_By>>;
  where?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
};


export type Subscription_RootTicket_Vendor_Assignments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTicket_Vendor_Assignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ticket_Vendor_Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
};


export type Subscription_RootTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Subscription_RootTickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTickets_Latchel_DataArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Latchel_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Latchel_Data_Order_By>>;
  where?: InputMaybe<Tickets_Latchel_Data_Bool_Exp>;
};


export type Subscription_RootTickets_Latchel_Data_By_PkArgs = {
  ticket_id: Scalars['uuid']['input'];
};


export type Subscription_RootTickets_Latchel_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tickets_Latchel_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Tickets_Latchel_Data_Bool_Exp>;
};


export type Subscription_RootTickets_Mason_DataArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Mason_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Mason_Data_Order_By>>;
  where?: InputMaybe<Tickets_Mason_Data_Bool_Exp>;
};


export type Subscription_RootTickets_Mason_Data_By_PkArgs = {
  ticket_id: Scalars['uuid']['input'];
};


export type Subscription_RootTickets_Mason_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tickets_Mason_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Tickets_Mason_Data_Bool_Exp>;
};


export type Subscription_RootTickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Subscription_RootTour_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Tour_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tour_Properties_Order_By>>;
  where?: InputMaybe<Tour_Properties_Bool_Exp>;
};


export type Subscription_RootTour_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTour_Properties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tour_Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Tour_Properties_Bool_Exp>;
};


export type Subscription_RootToursArgs = {
  distinct_on?: InputMaybe<Array<Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tours_Order_By>>;
  where?: InputMaybe<Tours_Bool_Exp>;
};


export type Subscription_RootTours_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTours_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tours_Stream_Cursor_Input>>;
  where?: InputMaybe<Tours_Bool_Exp>;
};


export type Subscription_RootUnallocated_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Unallocated_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unallocated_Credits_Order_By>>;
  where?: InputMaybe<Unallocated_Credits_Bool_Exp>;
};


export type Subscription_RootUnallocated_Credits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unallocated_Credits_Stream_Cursor_Input>>;
  where?: InputMaybe<Unallocated_Credits_Bool_Exp>;
};


export type Subscription_RootUnallocated_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Unallocated_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unallocated_Payments_Order_By>>;
  where?: InputMaybe<Unallocated_Payments_Bool_Exp>;
};


export type Subscription_RootUnallocated_Payments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unallocated_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Unallocated_Payments_Bool_Exp>;
};


export type Subscription_RootUnderwrites_Opportunity_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Order_By>>;
  where?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
};


export type Subscription_RootUnderwrites_Opportunity_Underwrites_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUnderwrites_Opportunity_Underwrites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Underwrites_Opportunity_Underwrites_Stream_Cursor_Input>>;
  where?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
};


export type Subscription_RootUnpaid_LiabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Unpaid_Liabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unpaid_Liabilities_Order_By>>;
  where?: InputMaybe<Unpaid_Liabilities_Bool_Exp>;
};


export type Subscription_RootUnpaid_Liabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unpaid_Liabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Unpaid_Liabilities_Bool_Exp>;
};


export type Subscription_RootUser_Contact_DetailsArgs = {
  distinct_on?: InputMaybe<Array<User_Contact_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Contact_Details_Order_By>>;
  where?: InputMaybe<User_Contact_Details_Bool_Exp>;
};


export type Subscription_RootUser_Contact_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Contact_Details_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Contact_Details_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Contact_Details_Bool_Exp>;
};


export type Subscription_RootUser_Document_RequestsArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Document_Requests_Order_By>>;
  where?: InputMaybe<User_Document_Requests_Bool_Exp>;
};


export type Subscription_RootUser_Document_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Document_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Document_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Document_Requests_Bool_Exp>;
};


export type Subscription_RootUser_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<User_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Documents_Order_By>>;
  where?: InputMaybe<User_Documents_Bool_Exp>;
};


export type Subscription_RootUser_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Documents_Bool_Exp>;
};


export type Subscription_RootUser_Funnel_StatusesArgs = {
  distinct_on?: InputMaybe<Array<User_Funnel_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Funnel_Statuses_Order_By>>;
  where?: InputMaybe<User_Funnel_Statuses_Bool_Exp>;
};


export type Subscription_RootUser_Funnel_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Funnel_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Funnel_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Funnel_Statuses_Bool_Exp>;
};


export type Subscription_RootUser_Identity_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Identity_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Identity_Verifications_Order_By>>;
  where?: InputMaybe<User_Identity_Verifications_Bool_Exp>;
};


export type Subscription_RootUser_Identity_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_IncomesArgs = {
  distinct_on?: InputMaybe<Array<User_Incomes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Incomes_Order_By>>;
  where?: InputMaybe<User_Incomes_Bool_Exp>;
};


export type Subscription_RootUser_Incomes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Incomes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Incomes_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Incomes_Bool_Exp>;
};


export type Subscription_RootUser_Prequalification_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Prequalification_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Prequalification_Data_Order_By>>;
  where?: InputMaybe<User_Prequalification_Data_Bool_Exp>;
};


export type Subscription_RootUser_Prequalification_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Prequalification_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Prequalification_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Prequalification_Data_Bool_Exp>;
};


export type Subscription_RootUser_SearchableArgs = {
  distinct_on?: InputMaybe<Array<User_Searchable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Searchable_Order_By>>;
  where?: InputMaybe<User_Searchable_Bool_Exp>;
};


export type Subscription_RootUser_Searchable_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Searchable_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Searchable_Bool_Exp>;
};


export type Subscription_RootUser_Underwriting_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Underwriting_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Underwriting_Data_Order_By>>;
  where?: InputMaybe<User_Underwriting_Data_Bool_Exp>;
};


export type Subscription_RootUser_Underwriting_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Underwriting_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Underwriting_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Underwriting_Data_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUtility_BillsArgs = {
  distinct_on?: InputMaybe<Array<Utility_Bills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Bills_Order_By>>;
  where?: InputMaybe<Utility_Bills_Bool_Exp>;
};


export type Subscription_RootUtility_Bills_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUtility_Chargeback_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Order_By>>;
  where?: InputMaybe<Utility_Chargeback_Status_Enum_Bool_Exp>;
};


export type Subscription_RootUtility_Chargeback_Status_Enum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Order_By>>;
  where?: InputMaybe<Utility_Chargeback_Status_Enum_Bool_Exp>;
};


export type Subscription_RootUtility_Chargeback_Status_Enum_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootUtility_ChargebacksArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargebacks_Order_By>>;
  where?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
};


export type Subscription_RootUtility_Chargebacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargebacks_Order_By>>;
  where?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
};


export type Subscription_RootUtility_Chargebacks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUtility_ResponsibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Responsibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Responsibilities_Order_By>>;
  where?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
};


export type Subscription_RootUtility_Responsibilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUtility_Responsibilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utility_Responsibilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
};


export type Subscription_RootUtility_TypesArgs = {
  distinct_on?: InputMaybe<Array<Utility_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Types_Order_By>>;
  where?: InputMaybe<Utility_Types_Bool_Exp>;
};


export type Subscription_RootUtility_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUtility_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utility_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Utility_Types_Bool_Exp>;
};


export type Subscription_RootVendor_MarketsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Markets_Order_By>>;
  where?: InputMaybe<Vendor_Markets_Bool_Exp>;
};


export type Subscription_RootVendor_Markets_By_PkArgs = {
  market_id: Scalars['uuid']['input'];
  vendor_id: Scalars['uuid']['input'];
};


export type Subscription_RootVendor_Markets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Markets_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Markets_Bool_Exp>;
};


export type Subscription_RootVendor_TagsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Tags_Order_By>>;
  where?: InputMaybe<Vendor_Tags_Bool_Exp>;
};


export type Subscription_RootVendor_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVendor_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Tags_Bool_Exp>;
};


export type Subscription_RootVendor_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Types_Order_By>>;
  where?: InputMaybe<Vendor_Types_Bool_Exp>;
};


export type Subscription_RootVendor_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVendor_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Types_Bool_Exp>;
};


export type Subscription_RootVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Order_By>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};


export type Subscription_RootVendors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVendors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendors_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendors_Bool_Exp>;
};


export type Subscription_RootVendors_Vendor_TagsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Tags_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
};


export type Subscription_RootVendors_Vendor_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVendors_Vendor_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendors_Vendor_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
};


export type Subscription_RootVendors_Vendor_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Types_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};


export type Subscription_RootVendors_Vendor_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVendors_Vendor_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendors_Vendor_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};


export type Subscription_RootWork_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Work_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Work_Orders_Order_By>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};


export type Subscription_RootWork_Orders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWork_Orders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Work_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Work_Orders_Bool_Exp>;
};

/** columns and relationships of "tenant_underwrite_documents" */
export type Tenant_Underwrite_Documents = {
  __typename: 'tenant_underwrite_documents';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  approved_by_admin?: Maybe<Admins>;
  approved_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document: Documents;
  document_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant_underwrite: Tenant_Underwrites;
  tenant_underwrite_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "tenant_underwrite_documents" */
export type Tenant_Underwrite_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tenant_Underwrite_Documents_Max_Order_By>;
  min?: InputMaybe<Tenant_Underwrite_Documents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "tenant_underwrite_documents". All fields are combined with a logical 'AND'. */
export type Tenant_Underwrite_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Tenant_Underwrite_Documents_Bool_Exp>>;
  _not?: InputMaybe<Tenant_Underwrite_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Tenant_Underwrite_Documents_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approved_by_admin?: InputMaybe<Admins_Bool_Exp>;
  approved_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_underwrite?: InputMaybe<Tenant_Underwrites_Bool_Exp>;
  tenant_underwrite_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "tenant_underwrite_documents" */
export type Tenant_Underwrite_Documents_Max_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_underwrite_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tenant_underwrite_documents" */
export type Tenant_Underwrite_Documents_Min_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_underwrite_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tenant_underwrite_documents". */
export type Tenant_Underwrite_Documents_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by_admin?: InputMaybe<Admins_Order_By>;
  approved_by_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_underwrite?: InputMaybe<Tenant_Underwrites_Order_By>;
  tenant_underwrite_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tenant_underwrite_documents" */
export enum Tenant_Underwrite_Documents_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedByAdminId = 'approved_by_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  TenantUnderwriteId = 'tenant_underwrite_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "tenant_underwrite_documents" */
export type Tenant_Underwrite_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Underwrite_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Underwrite_Documents_Stream_Cursor_Value_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  approved_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_underwrite_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "tenant_underwrites" */
export type Tenant_Underwrites = {
  __typename: 'tenant_underwrites';
  contact_email?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_admin?: Maybe<Admins>;
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  rental_reunderwrite_tenant_underwrites: Array<Rental_Reunderwrite_Tenant_Underwrites>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  tenant_underwrite_documents: Array<Tenant_Underwrite_Documents>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "tenant_underwrites" */
export type Tenant_UnderwritesRental_Reunderwrite_Tenant_UnderwritesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Reunderwrite_Tenant_Underwrites_Order_By>>;
  where?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
};


/** columns and relationships of "tenant_underwrites" */
export type Tenant_UnderwritesTenant_Underwrite_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Underwrite_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Underwrite_Documents_Order_By>>;
  where?: InputMaybe<Tenant_Underwrite_Documents_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tenant_underwrites". All fields are combined with a logical 'AND'. */
export type Tenant_Underwrites_Bool_Exp = {
  _and?: InputMaybe<Array<Tenant_Underwrites_Bool_Exp>>;
  _not?: InputMaybe<Tenant_Underwrites_Bool_Exp>;
  _or?: InputMaybe<Array<Tenant_Underwrites_Bool_Exp>>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin?: InputMaybe<Admins_Bool_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_reunderwrite_tenant_underwrites?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Bool_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenant_underwrite_documents?: InputMaybe<Tenant_Underwrite_Documents_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "tenant_underwrites". */
export type Tenant_Underwrites_Order_By = {
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin?: InputMaybe<Admins_Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_reunderwrite_tenant_underwrites_aggregate?: InputMaybe<Rental_Reunderwrite_Tenant_Underwrites_Aggregate_Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  tenant_underwrite_documents_aggregate?: InputMaybe<Tenant_Underwrite_Documents_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "tenant_underwrites" */
export enum Tenant_Underwrites_Select_Column {
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "tenant_underwrites" */
export type Tenant_Underwrites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Underwrites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Underwrites_Stream_Cursor_Value_Input = {
  contact_email?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments = {
  __typename: 'ticket_vendor_assignments';
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  internal_vendor_rating?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  ticket: Tickets;
  ticket_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Ticket_Vendor_Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ticket_Vendor_Assignments_Max_Order_By>;
  min?: InputMaybe<Ticket_Vendor_Assignments_Min_Order_By>;
  stddev?: InputMaybe<Ticket_Vendor_Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ticket_Vendor_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ticket_Vendor_Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ticket_Vendor_Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Ticket_Vendor_Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ticket_Vendor_Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Ticket_Vendor_Assignments_Variance_Order_By>;
};

/** order by avg() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Avg_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ticket_vendor_assignments". All fields are combined with a logical 'AND'. */
export type Ticket_Vendor_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Ticket_Vendor_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Ticket_Vendor_Assignments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_vendor_rating?: InputMaybe<Int_Comparison_Exp>;
  ticket?: InputMaybe<Tickets_Bool_Exp>;
  ticket_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_vendor_rating?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_vendor_rating?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ticket_vendor_assignments". */
export type Ticket_Vendor_Assignments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_vendor_rating?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Tickets_Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "ticket_vendor_assignments" */
export enum Ticket_Vendor_Assignments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  InternalVendorRating = 'internal_vendor_rating',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id'
}

/** order by stddev() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Stddev_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Stddev_Pop_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Stddev_Samp_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticket_Vendor_Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticket_Vendor_Assignments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_vendor_rating?: InputMaybe<Scalars['Int']['input']>;
  ticket_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Sum_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Var_Pop_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Var_Samp_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ticket_vendor_assignments" */
export type Ticket_Vendor_Assignments_Variance_Order_By = {
  internal_vendor_rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "tickets" */
export type Tickets = {
  __typename: 'tickets';
  actual_cost?: Maybe<Scalars['numeric']['output']>;
  actual_end_date?: Maybe<Scalars['date']['output']>;
  actual_hours?: Maybe<Scalars['Int']['output']>;
  actual_start_date?: Maybe<Scalars['date']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  current_start_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  estimated_end_date?: Maybe<Scalars['date']['output']>;
  estimated_hours?: Maybe<Scalars['numeric']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  max_cost?: Maybe<Scalars['numeric']['output']>;
  planned_start_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  portfolio_home: Portfolio_Homes;
  portfolio_home_id: Scalars['uuid']['output'];
  project_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An array relationship */
  ticket_vendor_assignments: Array<Ticket_Vendor_Assignments>;
  /** An object relationship */
  tickets_latchel_data?: Maybe<Tickets_Latchel_Data>;
  /** An object relationship */
  tickets_mason_data?: Maybe<Tickets_Mason_Data>;
  title?: Maybe<Scalars['String']['output']>;
  tracking_status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "tickets" */
export type TicketsTicket_Vendor_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Vendor_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Vendor_Assignments_Order_By>>;
  where?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tickets". All fields are combined with a logical 'AND'. */
export type Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Bool_Exp>>;
  _not?: InputMaybe<Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Tickets_Bool_Exp>>;
  actual_cost?: InputMaybe<Numeric_Comparison_Exp>;
  actual_end_date?: InputMaybe<Date_Comparison_Exp>;
  actual_hours?: InputMaybe<Int_Comparison_Exp>;
  actual_start_date?: InputMaybe<Date_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  current_start_date?: InputMaybe<Date_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_end_date?: InputMaybe<Date_Comparison_Exp>;
  estimated_hours?: InputMaybe<Numeric_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max_cost?: InputMaybe<Numeric_Comparison_Exp>;
  planned_start_date?: InputMaybe<Date_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  ticket_vendor_assignments?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
  tickets_latchel_data?: InputMaybe<Tickets_Latchel_Data_Bool_Exp>;
  tickets_mason_data?: InputMaybe<Tickets_Mason_Data_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  tracking_status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "tickets_latchel_data" */
export type Tickets_Latchel_Data = {
  __typename: 'tickets_latchel_data';
  access_instructions?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimate?: Maybe<Scalars['numeric']['output']>;
  estimate_note?: Maybe<Scalars['String']['output']>;
  is_emergency: Scalars['Boolean']['output'];
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
  is_urgent: Scalars['Boolean']['output'];
  is_vacant?: Maybe<Scalars['Boolean']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['Int']['output']>;
  job_rating?: Maybe<Scalars['Int']['output']>;
  latchel_created_at?: Maybe<Scalars['timestamptz']['output']>;
  latchel_issue_id?: Maybe<Scalars['Int']['output']>;
  latchel_problem_id?: Maybe<Scalars['Int']['output']>;
  latchel_property_id?: Maybe<Scalars['Int']['output']>;
  latchel_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  latchel_vendor_user_id?: Maybe<Scalars['Int']['output']>;
  manually_assign_vendor: Scalars['Boolean']['output'];
  max_cost?: Maybe<Scalars['numeric']['output']>;
  rating_comments?: Maybe<Scalars['String']['output']>;
  scheduled_end?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_start?: Maybe<Scalars['timestamptz']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  ticket_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  vendor_description?: Maybe<Scalars['String']['output']>;
  vendor_rating?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "tickets_latchel_data". All fields are combined with a logical 'AND'. */
export type Tickets_Latchel_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Latchel_Data_Bool_Exp>>;
  _not?: InputMaybe<Tickets_Latchel_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Tickets_Latchel_Data_Bool_Exp>>;
  access_instructions?: InputMaybe<String_Comparison_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estimate?: InputMaybe<Numeric_Comparison_Exp>;
  estimate_note?: InputMaybe<String_Comparison_Exp>;
  is_emergency?: InputMaybe<Boolean_Comparison_Exp>;
  is_mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  is_urgent?: InputMaybe<Boolean_Comparison_Exp>;
  is_vacant?: InputMaybe<Boolean_Comparison_Exp>;
  issue?: InputMaybe<String_Comparison_Exp>;
  job_id?: InputMaybe<Int_Comparison_Exp>;
  job_rating?: InputMaybe<Int_Comparison_Exp>;
  latchel_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latchel_issue_id?: InputMaybe<Int_Comparison_Exp>;
  latchel_problem_id?: InputMaybe<Int_Comparison_Exp>;
  latchel_property_id?: InputMaybe<Int_Comparison_Exp>;
  latchel_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latchel_vendor_user_id?: InputMaybe<Int_Comparison_Exp>;
  manually_assign_vendor?: InputMaybe<Boolean_Comparison_Exp>;
  max_cost?: InputMaybe<Numeric_Comparison_Exp>;
  rating_comments?: InputMaybe<String_Comparison_Exp>;
  scheduled_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  scheduled_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  ticket_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_description?: InputMaybe<String_Comparison_Exp>;
  vendor_rating?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "tickets_latchel_data". */
export type Tickets_Latchel_Data_Order_By = {
  access_instructions?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estimate?: InputMaybe<Order_By>;
  estimate_note?: InputMaybe<Order_By>;
  is_emergency?: InputMaybe<Order_By>;
  is_mandatory?: InputMaybe<Order_By>;
  is_urgent?: InputMaybe<Order_By>;
  is_vacant?: InputMaybe<Order_By>;
  issue?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  job_rating?: InputMaybe<Order_By>;
  latchel_created_at?: InputMaybe<Order_By>;
  latchel_issue_id?: InputMaybe<Order_By>;
  latchel_problem_id?: InputMaybe<Order_By>;
  latchel_property_id?: InputMaybe<Order_By>;
  latchel_updated_at?: InputMaybe<Order_By>;
  latchel_vendor_user_id?: InputMaybe<Order_By>;
  manually_assign_vendor?: InputMaybe<Order_By>;
  max_cost?: InputMaybe<Order_By>;
  rating_comments?: InputMaybe<Order_By>;
  scheduled_end?: InputMaybe<Order_By>;
  scheduled_start?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_description?: InputMaybe<Order_By>;
  vendor_rating?: InputMaybe<Order_By>;
};

/** select columns of table "tickets_latchel_data" */
export enum Tickets_Latchel_Data_Select_Column {
  /** column name */
  AccessInstructions = 'access_instructions',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Estimate = 'estimate',
  /** column name */
  EstimateNote = 'estimate_note',
  /** column name */
  IsEmergency = 'is_emergency',
  /** column name */
  IsMandatory = 'is_mandatory',
  /** column name */
  IsUrgent = 'is_urgent',
  /** column name */
  IsVacant = 'is_vacant',
  /** column name */
  Issue = 'issue',
  /** column name */
  JobId = 'job_id',
  /** column name */
  JobRating = 'job_rating',
  /** column name */
  LatchelCreatedAt = 'latchel_created_at',
  /** column name */
  LatchelIssueId = 'latchel_issue_id',
  /** column name */
  LatchelProblemId = 'latchel_problem_id',
  /** column name */
  LatchelPropertyId = 'latchel_property_id',
  /** column name */
  LatchelUpdatedAt = 'latchel_updated_at',
  /** column name */
  LatchelVendorUserId = 'latchel_vendor_user_id',
  /** column name */
  ManuallyAssignVendor = 'manually_assign_vendor',
  /** column name */
  MaxCost = 'max_cost',
  /** column name */
  RatingComments = 'rating_comments',
  /** column name */
  ScheduledEnd = 'scheduled_end',
  /** column name */
  ScheduledStart = 'scheduled_start',
  /** column name */
  Severity = 'severity',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  State = 'state',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorDescription = 'vendor_description',
  /** column name */
  VendorRating = 'vendor_rating'
}

/** Streaming cursor of the table "tickets_latchel_data" */
export type Tickets_Latchel_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Latchel_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tickets_Latchel_Data_Stream_Cursor_Value_Input = {
  access_instructions?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimate?: InputMaybe<Scalars['numeric']['input']>;
  estimate_note?: InputMaybe<Scalars['String']['input']>;
  is_emergency?: InputMaybe<Scalars['Boolean']['input']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  is_urgent?: InputMaybe<Scalars['Boolean']['input']>;
  is_vacant?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_rating?: InputMaybe<Scalars['Int']['input']>;
  latchel_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latchel_issue_id?: InputMaybe<Scalars['Int']['input']>;
  latchel_problem_id?: InputMaybe<Scalars['Int']['input']>;
  latchel_property_id?: InputMaybe<Scalars['Int']['input']>;
  latchel_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latchel_vendor_user_id?: InputMaybe<Scalars['Int']['input']>;
  manually_assign_vendor?: InputMaybe<Scalars['Boolean']['input']>;
  max_cost?: InputMaybe<Scalars['numeric']['input']>;
  rating_comments?: InputMaybe<Scalars['String']['input']>;
  scheduled_end?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_start?: InputMaybe<Scalars['timestamptz']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  ticket_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_description?: InputMaybe<Scalars['String']['input']>;
  vendor_rating?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "tickets_mason_data" */
export type Tickets_Mason_Data = {
  __typename: 'tickets_mason_data';
  created_at: Scalars['timestamptz']['output'];
  last_check_result?: Maybe<Scalars['jsonb']['output']>;
  last_checked_at?: Maybe<Scalars['timestamptz']['output']>;
  linked_at: Scalars['timestamptz']['output'];
  linked_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  mason_friendly_id?: Maybe<Scalars['String']['output']>;
  mason_work_order_id: Scalars['String']['output'];
  ticket_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "tickets_mason_data" */
export type Tickets_Mason_DataLast_Check_ResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "tickets_mason_data". All fields are combined with a logical 'AND'. */
export type Tickets_Mason_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Mason_Data_Bool_Exp>>;
  _not?: InputMaybe<Tickets_Mason_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Tickets_Mason_Data_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_check_result?: InputMaybe<Jsonb_Comparison_Exp>;
  last_checked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  linked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  linked_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  mason_friendly_id?: InputMaybe<String_Comparison_Exp>;
  mason_work_order_id?: InputMaybe<String_Comparison_Exp>;
  ticket_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "tickets_mason_data". */
export type Tickets_Mason_Data_Order_By = {
  created_at?: InputMaybe<Order_By>;
  last_check_result?: InputMaybe<Order_By>;
  last_checked_at?: InputMaybe<Order_By>;
  linked_at?: InputMaybe<Order_By>;
  linked_by_admin_id?: InputMaybe<Order_By>;
  mason_friendly_id?: InputMaybe<Order_By>;
  mason_work_order_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tickets_mason_data" */
export enum Tickets_Mason_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LastCheckResult = 'last_check_result',
  /** column name */
  LastCheckedAt = 'last_checked_at',
  /** column name */
  LinkedAt = 'linked_at',
  /** column name */
  LinkedByAdminId = 'linked_by_admin_id',
  /** column name */
  MasonFriendlyId = 'mason_friendly_id',
  /** column name */
  MasonWorkOrderId = 'mason_work_order_id',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "tickets_mason_data" */
export type Tickets_Mason_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Mason_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tickets_Mason_Data_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_check_result?: InputMaybe<Scalars['jsonb']['input']>;
  last_checked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  linked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  linked_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  mason_friendly_id?: InputMaybe<Scalars['String']['input']>;
  mason_work_order_id?: InputMaybe<Scalars['String']['input']>;
  ticket_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Ordering options when selecting data from "tickets". */
export type Tickets_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  actual_end_date?: InputMaybe<Order_By>;
  actual_hours?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  current_start_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  estimated_end_date?: InputMaybe<Order_By>;
  estimated_hours?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_cost?: InputMaybe<Order_By>;
  planned_start_date?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_vendor_assignments_aggregate?: InputMaybe<Ticket_Vendor_Assignments_Aggregate_Order_By>;
  tickets_latchel_data?: InputMaybe<Tickets_Latchel_Data_Order_By>;
  tickets_mason_data?: InputMaybe<Tickets_Mason_Data_Order_By>;
  title?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tickets" */
export enum Tickets_Select_Column {
  /** column name */
  ActualCost = 'actual_cost',
  /** column name */
  ActualEndDate = 'actual_end_date',
  /** column name */
  ActualHours = 'actual_hours',
  /** column name */
  ActualStartDate = 'actual_start_date',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  CurrentStartDate = 'current_start_date',
  /** column name */
  Description = 'description',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  EstimatedEndDate = 'estimated_end_date',
  /** column name */
  EstimatedHours = 'estimated_hours',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  MaxCost = 'max_cost',
  /** column name */
  PlannedStartDate = 'planned_start_date',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  TrackingStatus = 'tracking_status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "tickets" */
export type Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tickets_Stream_Cursor_Value_Input = {
  actual_cost?: InputMaybe<Scalars['numeric']['input']>;
  actual_end_date?: InputMaybe<Scalars['date']['input']>;
  actual_hours?: InputMaybe<Scalars['Int']['input']>;
  actual_start_date?: InputMaybe<Scalars['date']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  current_start_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  estimated_end_date?: InputMaybe<Scalars['date']['input']>;
  estimated_hours?: InputMaybe<Scalars['numeric']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_cost?: InputMaybe<Scalars['numeric']['input']>;
  planned_start_date?: InputMaybe<Scalars['date']['input']>;
  portfolio_home_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tracking_status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "tour_properties" */
export type Tour_Properties = {
  __typename: 'tour_properties';
  agent_confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mls_listing: Mls_Listings;
  property_id: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  tour_id: Scalars['uuid']['output'];
  tour_order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "tour_properties" */
export type Tour_Properties_Aggregate_Order_By = {
  avg?: InputMaybe<Tour_Properties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tour_Properties_Max_Order_By>;
  min?: InputMaybe<Tour_Properties_Min_Order_By>;
  stddev?: InputMaybe<Tour_Properties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tour_Properties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tour_Properties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tour_Properties_Sum_Order_By>;
  var_pop?: InputMaybe<Tour_Properties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tour_Properties_Var_Samp_Order_By>;
  variance?: InputMaybe<Tour_Properties_Variance_Order_By>;
};

/** order by avg() on columns of table "tour_properties" */
export type Tour_Properties_Avg_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tour_properties". All fields are combined with a logical 'AND'. */
export type Tour_Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Tour_Properties_Bool_Exp>>;
  _not?: InputMaybe<Tour_Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Tour_Properties_Bool_Exp>>;
  agent_confirmed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_listing?: InputMaybe<Mls_Listings_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tour_id?: InputMaybe<Uuid_Comparison_Exp>;
  tour_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "tour_properties" */
export type Tour_Properties_Max_Order_By = {
  agent_confirmed_at?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tour_id?: InputMaybe<Order_By>;
  tour_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tour_properties" */
export type Tour_Properties_Min_Order_By = {
  agent_confirmed_at?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tour_id?: InputMaybe<Order_By>;
  tour_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tour_properties". */
export type Tour_Properties_Order_By = {
  agent_confirmed_at?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mls_listing?: InputMaybe<Mls_Listings_Order_By>;
  property_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tour_id?: InputMaybe<Order_By>;
  tour_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tour_properties" */
export enum Tour_Properties_Select_Column {
  /** column name */
  AgentConfirmedAt = 'agent_confirmed_at',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Status = 'status',
  /** column name */
  TourId = 'tour_id',
  /** column name */
  TourOrder = 'tour_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "tour_properties" */
export type Tour_Properties_Stddev_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tour_properties" */
export type Tour_Properties_Stddev_Pop_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tour_properties" */
export type Tour_Properties_Stddev_Samp_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tour_properties" */
export type Tour_Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tour_Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tour_Properties_Stream_Cursor_Value_Input = {
  agent_confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tour_id?: InputMaybe<Scalars['uuid']['input']>;
  tour_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "tour_properties" */
export type Tour_Properties_Sum_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tour_properties" */
export type Tour_Properties_Var_Pop_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tour_properties" */
export type Tour_Properties_Var_Samp_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tour_properties" */
export type Tour_Properties_Variance_Order_By = {
  tour_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "tours" */
export type Tours = {
  __typename: 'tours';
  /** An object relationship */
  agent?: Maybe<Agents>;
  agent_id?: Maybe<Scalars['uuid']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  first_lead_group_confirmation_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  lead_group_confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  lead_group_id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  second_lead_group_confirmation_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  start_at: Scalars['timestamptz']['output'];
  status: Scalars['String']['output'];
  /** An array relationship */
  tour_properties: Array<Tour_Properties>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "tours" */
export type ToursTour_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Tour_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tour_Properties_Order_By>>;
  where?: InputMaybe<Tour_Properties_Bool_Exp>;
};

/** order by aggregate values of table "tours" */
export type Tours_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tours_Max_Order_By>;
  min?: InputMaybe<Tours_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "tours". All fields are combined with a logical 'AND'. */
export type Tours_Bool_Exp = {
  _and?: InputMaybe<Array<Tours_Bool_Exp>>;
  _not?: InputMaybe<Tours_Bool_Exp>;
  _or?: InputMaybe<Array<Tours_Bool_Exp>>;
  agent?: InputMaybe<Agents_Bool_Exp>;
  agent_id?: InputMaybe<Uuid_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_lead_group_confirmation_sms_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_group_confirmed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lead_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  second_lead_group_confirmation_sms_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tour_properties?: InputMaybe<Tour_Properties_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "tours" */
export type Tours_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_lead_group_confirmation_sms_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_confirmed_at?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  second_lead_group_confirmation_sms_sent_at?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tours" */
export type Tours_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_lead_group_confirmation_sms_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_confirmed_at?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  second_lead_group_confirmation_sms_sent_at?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tours". */
export type Tours_Order_By = {
  agent?: InputMaybe<Agents_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_lead_group_confirmation_sms_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_group_confirmed_at?: InputMaybe<Order_By>;
  lead_group_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  second_lead_group_confirmation_sms_sent_at?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tour_properties_aggregate?: InputMaybe<Tour_Properties_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tours" */
export enum Tours_Select_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstLeadGroupConfirmationSmsSentAt = 'first_lead_group_confirmation_sms_sent_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadGroupConfirmedAt = 'lead_group_confirmed_at',
  /** column name */
  LeadGroupId = 'lead_group_id',
  /** column name */
  Note = 'note',
  /** column name */
  SecondLeadGroupConfirmationSmsSentAt = 'second_lead_group_confirmation_sms_sent_at',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "tours" */
export type Tours_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tours_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tours_Stream_Cursor_Value_Input = {
  agent_id?: InputMaybe<Scalars['uuid']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_lead_group_confirmation_sms_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_group_confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_group_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  second_lead_group_confirmation_sms_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "unallocated_credits" */
export type Unallocated_Credits = {
  __typename: 'unallocated_credits';
  amount_remaining?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  credit?: Maybe<Rental_Credits>;
  credit_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  liability_type?: Maybe<Liability_Types>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "unallocated_credits". All fields are combined with a logical 'AND'. */
export type Unallocated_Credits_Bool_Exp = {
  _and?: InputMaybe<Array<Unallocated_Credits_Bool_Exp>>;
  _not?: InputMaybe<Unallocated_Credits_Bool_Exp>;
  _or?: InputMaybe<Array<Unallocated_Credits_Bool_Exp>>;
  amount_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  credit?: InputMaybe<Rental_Credits_Bool_Exp>;
  credit_id?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "unallocated_credits". */
export type Unallocated_Credits_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  credit?: InputMaybe<Rental_Credits_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
};

/** select columns of table "unallocated_credits" */
export enum Unallocated_Credits_Select_Column {
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  Date = 'date',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  RentalId = 'rental_id'
}

/** Streaming cursor of the table "unallocated_credits" */
export type Unallocated_Credits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unallocated_Credits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unallocated_Credits_Stream_Cursor_Value_Input = {
  amount_remaining?: InputMaybe<Scalars['numeric']['input']>;
  credit_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "unallocated_payments" */
export type Unallocated_Payments = {
  __typename: 'unallocated_payments';
  amount_remaining?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  liability_type?: Maybe<Liability_Types>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  payment?: Maybe<Payments>;
  payment_date?: Maybe<Scalars['date']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "unallocated_payments". All fields are combined with a logical 'AND'. */
export type Unallocated_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Unallocated_Payments_Bool_Exp>>;
  _not?: InputMaybe<Unallocated_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Unallocated_Payments_Bool_Exp>>;
  amount_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_date?: InputMaybe<Date_Comparison_Exp>;
  payment_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "unallocated_payments". */
export type Unallocated_Payments_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "unallocated_payments" */
export enum Unallocated_Payments_Select_Column {
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "unallocated_payments" */
export type Unallocated_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unallocated_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unallocated_Payments_Stream_Cursor_Value_Input = {
  amount_remaining?: InputMaybe<Scalars['numeric']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['date']['input']>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites = {
  __typename: 'underwrites_opportunity_underwrites';
  annual_bad_debt_expense?: Maybe<Scalars['numeric']['output']>;
  annual_hoa?: Maybe<Scalars['numeric']['output']>;
  annual_insurance_cost?: Maybe<Scalars['numeric']['output']>;
  annual_marketing_and_leasing_fees?: Maybe<Scalars['numeric']['output']>;
  annual_opex?: Maybe<Scalars['numeric']['output']>;
  annual_other_income?: Maybe<Scalars['numeric']['output']>;
  annual_other_opex?: Maybe<Scalars['numeric']['output']>;
  annual_repairs_and_maintenance?: Maybe<Scalars['numeric']['output']>;
  annual_taxes?: Maybe<Scalars['numeric']['output']>;
  annual_turnover_expense?: Maybe<Scalars['numeric']['output']>;
  annual_vacancy_expense?: Maybe<Scalars['numeric']['output']>;
  closing_costs?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deferred_capex_cost?: Maybe<Scalars['numeric']['output']>;
  floor_cap_rate?: Maybe<Scalars['numeric']['output']>;
  floor_rent?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  is_for_sale_and_in_buy_box: Scalars['Boolean']['output'];
  monthly_property_management_fee?: Maybe<Scalars['numeric']['output']>;
  opportunity_id: Scalars['uuid']['output'];
  origination_fee?: Maybe<Scalars['numeric']['output']>;
  purchase_price?: Maybe<Scalars['numeric']['output']>;
  rental_comp?: Maybe<Scalars['numeric']['output']>;
  sellers_credits?: Maybe<Scalars['numeric']['output']>;
  stretch_cap_rate?: Maybe<Scalars['numeric']['output']>;
  stretch_rent?: Maybe<Scalars['numeric']['output']>;
  target_cap_rate?: Maybe<Scalars['numeric']['output']>;
  target_rent?: Maybe<Scalars['numeric']['output']>;
  type: Scalars['String']['output'];
  underwritten_vacancy_days?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  upfront_diligence_and_scoping_cost?: Maybe<Scalars['numeric']['output']>;
  upfront_improvements_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by aggregate values of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Aggregate_Order_By = {
  avg?: InputMaybe<Underwrites_Opportunity_Underwrites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Underwrites_Opportunity_Underwrites_Max_Order_By>;
  min?: InputMaybe<Underwrites_Opportunity_Underwrites_Min_Order_By>;
  stddev?: InputMaybe<Underwrites_Opportunity_Underwrites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Underwrites_Opportunity_Underwrites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Underwrites_Opportunity_Underwrites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Underwrites_Opportunity_Underwrites_Sum_Order_By>;
  var_pop?: InputMaybe<Underwrites_Opportunity_Underwrites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Underwrites_Opportunity_Underwrites_Var_Samp_Order_By>;
  variance?: InputMaybe<Underwrites_Opportunity_Underwrites_Variance_Order_By>;
};

/** order by avg() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Avg_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "underwrites.opportunity_underwrites". All fields are combined with a logical 'AND'. */
export type Underwrites_Opportunity_Underwrites_Bool_Exp = {
  _and?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Bool_Exp>>;
  _not?: InputMaybe<Underwrites_Opportunity_Underwrites_Bool_Exp>;
  _or?: InputMaybe<Array<Underwrites_Opportunity_Underwrites_Bool_Exp>>;
  annual_bad_debt_expense?: InputMaybe<Numeric_Comparison_Exp>;
  annual_hoa?: InputMaybe<Numeric_Comparison_Exp>;
  annual_insurance_cost?: InputMaybe<Numeric_Comparison_Exp>;
  annual_marketing_and_leasing_fees?: InputMaybe<Numeric_Comparison_Exp>;
  annual_opex?: InputMaybe<Numeric_Comparison_Exp>;
  annual_other_income?: InputMaybe<Numeric_Comparison_Exp>;
  annual_other_opex?: InputMaybe<Numeric_Comparison_Exp>;
  annual_repairs_and_maintenance?: InputMaybe<Numeric_Comparison_Exp>;
  annual_taxes?: InputMaybe<Numeric_Comparison_Exp>;
  annual_turnover_expense?: InputMaybe<Numeric_Comparison_Exp>;
  annual_vacancy_expense?: InputMaybe<Numeric_Comparison_Exp>;
  closing_costs?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deferred_capex_cost?: InputMaybe<Numeric_Comparison_Exp>;
  floor_cap_rate?: InputMaybe<Numeric_Comparison_Exp>;
  floor_rent?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_for_sale_and_in_buy_box?: InputMaybe<Boolean_Comparison_Exp>;
  monthly_property_management_fee?: InputMaybe<Numeric_Comparison_Exp>;
  opportunity_id?: InputMaybe<Uuid_Comparison_Exp>;
  origination_fee?: InputMaybe<Numeric_Comparison_Exp>;
  purchase_price?: InputMaybe<Numeric_Comparison_Exp>;
  rental_comp?: InputMaybe<Numeric_Comparison_Exp>;
  sellers_credits?: InputMaybe<Numeric_Comparison_Exp>;
  stretch_cap_rate?: InputMaybe<Numeric_Comparison_Exp>;
  stretch_rent?: InputMaybe<Numeric_Comparison_Exp>;
  target_cap_rate?: InputMaybe<Numeric_Comparison_Exp>;
  target_rent?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  underwritten_vacancy_days?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Numeric_Comparison_Exp>;
  upfront_improvements_cost?: InputMaybe<Numeric_Comparison_Exp>;
};

/** order by max() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Max_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Min_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "underwrites.opportunity_underwrites". */
export type Underwrites_Opportunity_Underwrites_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_for_sale_and_in_buy_box?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** select columns of table "underwrites.opportunity_underwrites" */
export enum Underwrites_Opportunity_Underwrites_Select_Column {
  /** column name */
  AnnualBadDebtExpense = 'annual_bad_debt_expense',
  /** column name */
  AnnualHoa = 'annual_hoa',
  /** column name */
  AnnualInsuranceCost = 'annual_insurance_cost',
  /** column name */
  AnnualMarketingAndLeasingFees = 'annual_marketing_and_leasing_fees',
  /** column name */
  AnnualOpex = 'annual_opex',
  /** column name */
  AnnualOtherIncome = 'annual_other_income',
  /** column name */
  AnnualOtherOpex = 'annual_other_opex',
  /** column name */
  AnnualRepairsAndMaintenance = 'annual_repairs_and_maintenance',
  /** column name */
  AnnualTaxes = 'annual_taxes',
  /** column name */
  AnnualTurnoverExpense = 'annual_turnover_expense',
  /** column name */
  AnnualVacancyExpense = 'annual_vacancy_expense',
  /** column name */
  ClosingCosts = 'closing_costs',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeferredCapexCost = 'deferred_capex_cost',
  /** column name */
  FloorCapRate = 'floor_cap_rate',
  /** column name */
  FloorRent = 'floor_rent',
  /** column name */
  Id = 'id',
  /** column name */
  IsForSaleAndInBuyBox = 'is_for_sale_and_in_buy_box',
  /** column name */
  MonthlyPropertyManagementFee = 'monthly_property_management_fee',
  /** column name */
  OpportunityId = 'opportunity_id',
  /** column name */
  OriginationFee = 'origination_fee',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  RentalComp = 'rental_comp',
  /** column name */
  SellersCredits = 'sellers_credits',
  /** column name */
  StretchCapRate = 'stretch_cap_rate',
  /** column name */
  StretchRent = 'stretch_rent',
  /** column name */
  TargetCapRate = 'target_cap_rate',
  /** column name */
  TargetRent = 'target_rent',
  /** column name */
  Type = 'type',
  /** column name */
  UnderwrittenVacancyDays = 'underwritten_vacancy_days',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpfrontDiligenceAndScopingCost = 'upfront_diligence_and_scoping_cost',
  /** column name */
  UpfrontImprovementsCost = 'upfront_improvements_cost'
}

/** order by stddev() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Stddev_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Stddev_Pop_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Stddev_Samp_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "underwrites_opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Underwrites_Opportunity_Underwrites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Underwrites_Opportunity_Underwrites_Stream_Cursor_Value_Input = {
  annual_bad_debt_expense?: InputMaybe<Scalars['numeric']['input']>;
  annual_hoa?: InputMaybe<Scalars['numeric']['input']>;
  annual_insurance_cost?: InputMaybe<Scalars['numeric']['input']>;
  annual_marketing_and_leasing_fees?: InputMaybe<Scalars['numeric']['input']>;
  annual_opex?: InputMaybe<Scalars['numeric']['input']>;
  annual_other_income?: InputMaybe<Scalars['numeric']['input']>;
  annual_other_opex?: InputMaybe<Scalars['numeric']['input']>;
  annual_repairs_and_maintenance?: InputMaybe<Scalars['numeric']['input']>;
  annual_taxes?: InputMaybe<Scalars['numeric']['input']>;
  annual_turnover_expense?: InputMaybe<Scalars['numeric']['input']>;
  annual_vacancy_expense?: InputMaybe<Scalars['numeric']['input']>;
  closing_costs?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deferred_capex_cost?: InputMaybe<Scalars['numeric']['input']>;
  floor_cap_rate?: InputMaybe<Scalars['numeric']['input']>;
  floor_rent?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_for_sale_and_in_buy_box?: InputMaybe<Scalars['Boolean']['input']>;
  monthly_property_management_fee?: InputMaybe<Scalars['numeric']['input']>;
  opportunity_id?: InputMaybe<Scalars['uuid']['input']>;
  origination_fee?: InputMaybe<Scalars['numeric']['input']>;
  purchase_price?: InputMaybe<Scalars['numeric']['input']>;
  rental_comp?: InputMaybe<Scalars['numeric']['input']>;
  sellers_credits?: InputMaybe<Scalars['numeric']['input']>;
  stretch_cap_rate?: InputMaybe<Scalars['numeric']['input']>;
  stretch_rent?: InputMaybe<Scalars['numeric']['input']>;
  target_cap_rate?: InputMaybe<Scalars['numeric']['input']>;
  target_rent?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  underwritten_vacancy_days?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Scalars['numeric']['input']>;
  upfront_improvements_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Sum_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Var_Pop_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Var_Samp_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "underwrites.opportunity_underwrites" */
export type Underwrites_Opportunity_Underwrites_Variance_Order_By = {
  annual_bad_debt_expense?: InputMaybe<Order_By>;
  annual_hoa?: InputMaybe<Order_By>;
  annual_insurance_cost?: InputMaybe<Order_By>;
  annual_marketing_and_leasing_fees?: InputMaybe<Order_By>;
  annual_opex?: InputMaybe<Order_By>;
  annual_other_income?: InputMaybe<Order_By>;
  annual_other_opex?: InputMaybe<Order_By>;
  annual_repairs_and_maintenance?: InputMaybe<Order_By>;
  annual_taxes?: InputMaybe<Order_By>;
  annual_turnover_expense?: InputMaybe<Order_By>;
  annual_vacancy_expense?: InputMaybe<Order_By>;
  closing_costs?: InputMaybe<Order_By>;
  deferred_capex_cost?: InputMaybe<Order_By>;
  floor_cap_rate?: InputMaybe<Order_By>;
  floor_rent?: InputMaybe<Order_By>;
  monthly_property_management_fee?: InputMaybe<Order_By>;
  origination_fee?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rental_comp?: InputMaybe<Order_By>;
  sellers_credits?: InputMaybe<Order_By>;
  stretch_cap_rate?: InputMaybe<Order_By>;
  stretch_rent?: InputMaybe<Order_By>;
  target_cap_rate?: InputMaybe<Order_By>;
  target_rent?: InputMaybe<Order_By>;
  underwritten_vacancy_days?: InputMaybe<Order_By>;
  upfront_diligence_and_scoping_cost?: InputMaybe<Order_By>;
  upfront_improvements_cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "unpaid_liabilities" */
export type Unpaid_Liabilities = {
  __typename: 'unpaid_liabilities';
  amount_remaining?: Maybe<Scalars['numeric']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  liability?: Maybe<Rental_Liabilities>;
  liability_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  liability_type?: Maybe<Liability_Types>;
  liability_type_id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "unpaid_liabilities". All fields are combined with a logical 'AND'. */
export type Unpaid_Liabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Unpaid_Liabilities_Bool_Exp>>;
  _not?: InputMaybe<Unpaid_Liabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Unpaid_Liabilities_Bool_Exp>>;
  amount_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  liability?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "unpaid_liabilities". */
export type Unpaid_Liabilities_Order_By = {
  amount_remaining?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  liability?: InputMaybe<Rental_Liabilities_Order_By>;
  liability_id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
};

/** select columns of table "unpaid_liabilities" */
export enum Unpaid_Liabilities_Select_Column {
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  Date = 'date',
  /** column name */
  LiabilityId = 'liability_id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  RentalId = 'rental_id'
}

/** Streaming cursor of the table "unpaid_liabilities" */
export type Unpaid_Liabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unpaid_Liabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unpaid_Liabilities_Stream_Cursor_Value_Input = {
  amount_remaining?: InputMaybe<Scalars['numeric']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  liability_id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "user_contact_details" */
export type User_Contact_Details = {
  __typename: 'user_contact_details';
  contact_info: Scalars['String']['output'];
  contact_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_primary_for_contact_type: Scalars['Boolean']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_contact_details" */
export type User_Contact_Details_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Contact_Details_Max_Order_By>;
  min?: InputMaybe<User_Contact_Details_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_contact_details". All fields are combined with a logical 'AND'. */
export type User_Contact_Details_Bool_Exp = {
  _and?: InputMaybe<Array<User_Contact_Details_Bool_Exp>>;
  _not?: InputMaybe<User_Contact_Details_Bool_Exp>;
  _or?: InputMaybe<Array<User_Contact_Details_Bool_Exp>>;
  contact_info?: InputMaybe<String_Comparison_Exp>;
  contact_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_primary_for_contact_type?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "user_contact_details" */
export type User_Contact_Details_Max_Order_By = {
  contact_info?: InputMaybe<Order_By>;
  contact_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_contact_details" */
export type User_Contact_Details_Min_Order_By = {
  contact_info?: InputMaybe<Order_By>;
  contact_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_contact_details". */
export type User_Contact_Details_Order_By = {
  contact_info?: InputMaybe<Order_By>;
  contact_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_primary_for_contact_type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_contact_details" */
export enum User_Contact_Details_Select_Column {
  /** column name */
  ContactInfo = 'contact_info',
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimaryForContactType = 'is_primary_for_contact_type',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "user_contact_details" */
export type User_Contact_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Contact_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Contact_Details_Stream_Cursor_Value_Input = {
  contact_info?: InputMaybe<Scalars['String']['input']>;
  contact_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary_for_contact_type?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "user_document_requests" */
export type User_Document_Requests = {
  __typename: 'user_document_requests';
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  document_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_document_requests" */
export type User_Document_Requests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Document_Requests_Max_Order_By>;
  min?: InputMaybe<User_Document_Requests_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_document_requests". All fields are combined with a logical 'AND'. */
export type User_Document_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<User_Document_Requests_Bool_Exp>>;
  _not?: InputMaybe<User_Document_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<User_Document_Requests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instructions?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_document_requests" */
export enum User_Document_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserDocumentRequestsPkey = 'user_document_requests_pkey'
}

/** input type for inserting data into table "user_document_requests" */
export type User_Document_Requests_Insert_Input = {
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "user_document_requests" */
export type User_Document_Requests_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_document_requests" */
export type User_Document_Requests_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_document_requests" */
export type User_Document_Requests_Mutation_Response = {
  __typename: 'user_document_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Document_Requests>;
};

/** on_conflict condition type for table "user_document_requests" */
export type User_Document_Requests_On_Conflict = {
  constraint: User_Document_Requests_Constraint;
  update_columns?: Array<User_Document_Requests_Update_Column>;
  where?: InputMaybe<User_Document_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "user_document_requests". */
export type User_Document_Requests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_document_requests */
export type User_Document_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_document_requests" */
export enum User_Document_Requests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_document_requests" */
export type User_Document_Requests_Set_Input = {
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_document_requests" */
export type User_Document_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Document_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Document_Requests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_document_requests" */
export enum User_Document_Requests_Update_Column {
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  UserId = 'user_id'
}

export type User_Document_Requests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Document_Requests_Set_Input>;
  where: User_Document_Requests_Bool_Exp;
};

/** columns and relationships of "user_documents" */
export type User_Documents = {
  __typename: 'user_documents';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<Scalars['String']['output']>;
  friendly_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  resource_id?: Maybe<Scalars['uuid']['output']>;
  resource_notes?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  review_notes?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "user_documents" */
export type User_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Documents_Max_Order_By>;
  min?: InputMaybe<User_Documents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_documents". All fields are combined with a logical 'AND'. */
export type User_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<User_Documents_Bool_Exp>>;
  _not?: InputMaybe<User_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<User_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  friendly_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_notes?: InputMaybe<String_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  review_notes?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "user_documents" */
export type User_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_documents" */
export type User_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_documents". */
export type User_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_notes?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "user_documents" */
export enum User_Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceNotes = 'resource_notes',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ReviewNotes = 'review_notes',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "user_documents" */
export type User_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  friendly_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_notes?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "user_funnel_statuses" */
export type User_Funnel_Statuses = {
  __typename: 'user_funnel_statuses';
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  archived_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  conversion_propensity_score?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  escalated_at?: Maybe<Scalars['timestamptz']['output']>;
  escalated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  escalated_to_admin_id?: Maybe<Scalars['uuid']['output']>;
  escalation_note_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  lead_status?: Maybe<Scalars['String']['output']>;
  priority_note_id?: Maybe<Scalars['uuid']['output']>;
  priority_score?: Maybe<Scalars['numeric']['output']>;
  prospective_move_in_date?: Maybe<Scalars['date']['output']>;
  snoozed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  snoozed_until?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "user_funnel_statuses". All fields are combined with a logical 'AND'. */
export type User_Funnel_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<User_Funnel_Statuses_Bool_Exp>>;
  _not?: InputMaybe<User_Funnel_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<User_Funnel_Statuses_Bool_Exp>>;
  archived_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  archived_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  conversion_propensity_score?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  escalated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  escalated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  escalated_to_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  escalation_note_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_status?: InputMaybe<String_Comparison_Exp>;
  priority_note_id?: InputMaybe<Uuid_Comparison_Exp>;
  priority_score?: InputMaybe<Numeric_Comparison_Exp>;
  prospective_move_in_date?: InputMaybe<Date_Comparison_Exp>;
  snoozed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  snoozed_until?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** response of any mutation on the table "user_funnel_statuses" */
export type User_Funnel_Statuses_Mutation_Response = {
  __typename: 'user_funnel_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Funnel_Statuses>;
};

/** Ordering options when selecting data from "user_funnel_statuses". */
export type User_Funnel_Statuses_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  archived_by_admin_id?: InputMaybe<Order_By>;
  conversion_propensity_score?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  deactivated_by_admin_id?: InputMaybe<Order_By>;
  escalated_at?: InputMaybe<Order_By>;
  escalated_by_admin_id?: InputMaybe<Order_By>;
  escalated_to_admin_id?: InputMaybe<Order_By>;
  escalation_note_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_status?: InputMaybe<Order_By>;
  priority_note_id?: InputMaybe<Order_By>;
  priority_score?: InputMaybe<Order_By>;
  prospective_move_in_date?: InputMaybe<Order_By>;
  snoozed_by_admin_id?: InputMaybe<Order_By>;
  snoozed_until?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_funnel_statuses */
export type User_Funnel_Statuses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_funnel_statuses" */
export enum User_Funnel_Statuses_Select_Column {
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  ArchivedByAdminId = 'archived_by_admin_id',
  /** column name */
  ConversionPropensityScore = 'conversion_propensity_score',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedByAdminId = 'deactivated_by_admin_id',
  /** column name */
  EscalatedAt = 'escalated_at',
  /** column name */
  EscalatedByAdminId = 'escalated_by_admin_id',
  /** column name */
  EscalatedToAdminId = 'escalated_to_admin_id',
  /** column name */
  EscalationNoteId = 'escalation_note_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadStatus = 'lead_status',
  /** column name */
  PriorityNoteId = 'priority_note_id',
  /** column name */
  PriorityScore = 'priority_score',
  /** column name */
  ProspectiveMoveInDate = 'prospective_move_in_date',
  /** column name */
  SnoozedByAdminId = 'snoozed_by_admin_id',
  /** column name */
  SnoozedUntil = 'snoozed_until',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_funnel_statuses" */
export type User_Funnel_Statuses_Set_Input = {
  archive_reason?: InputMaybe<Scalars['String']['input']>;
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  archived_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_reason?: InputMaybe<Scalars['String']['input']>;
  snoozed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  snoozed_until?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user_funnel_statuses" */
export type User_Funnel_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Funnel_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Funnel_Statuses_Stream_Cursor_Value_Input = {
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  archived_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  conversion_propensity_score?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  escalated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  escalated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  escalated_to_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  escalation_note_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_status?: InputMaybe<Scalars['String']['input']>;
  priority_note_id?: InputMaybe<Scalars['uuid']['input']>;
  priority_score?: InputMaybe<Scalars['numeric']['input']>;
  prospective_move_in_date?: InputMaybe<Scalars['date']['input']>;
  snoozed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  snoozed_until?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type User_Funnel_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Funnel_Statuses_Set_Input>;
  where: User_Funnel_Statuses_Bool_Exp;
};

export enum User_Identity_Verification_Status_Enum_Enum {
  Failed = 'failed',
  Processing = 'processing',
  SessionCreated = 'session_created',
  Verified = 'verified'
}

/** Boolean expression to compare columns of type "user_identity_verification_status_enum_enum". All fields are combined with logical 'AND'. */
export type User_Identity_Verification_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Identity_Verification_Status_Enum_Enum>;
  _in?: InputMaybe<Array<User_Identity_Verification_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Identity_Verification_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<User_Identity_Verification_Status_Enum_Enum>>;
};

/** columns and relationships of "user_identity_verifications" */
export type User_Identity_Verifications = {
  __typename: 'user_identity_verifications';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  failure_code?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  invalidated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  invalidated_by_admin?: Maybe<Admins>;
  invalidated_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  status: User_Identity_Verification_Status_Enum_Enum;
  stripe_session_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
  verified_as_first_name?: Maybe<Scalars['String']['output']>;
  verified_as_last_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "user_identity_verifications" */
export type User_Identity_VerificationsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "user_identity_verifications". All fields are combined with a logical 'AND'. */
export type User_Identity_Verifications_Bool_Exp = {
  _and?: InputMaybe<Array<User_Identity_Verifications_Bool_Exp>>;
  _not?: InputMaybe<User_Identity_Verifications_Bool_Exp>;
  _or?: InputMaybe<Array<User_Identity_Verifications_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  failure_code?: InputMaybe<String_Comparison_Exp>;
  failure_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalidated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invalidated_by_admin?: InputMaybe<Admins_Bool_Exp>;
  invalidated_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<User_Identity_Verification_Status_Enum_Enum_Comparison_Exp>;
  stripe_session_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified_as_first_name?: InputMaybe<String_Comparison_Exp>;
  verified_as_last_name?: InputMaybe<String_Comparison_Exp>;
};

/** response of any mutation on the table "user_identity_verifications" */
export type User_Identity_Verifications_Mutation_Response = {
  __typename: 'user_identity_verifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Identity_Verifications>;
};

/** Ordering options when selecting data from "user_identity_verifications". */
export type User_Identity_Verifications_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failure_code?: InputMaybe<Order_By>;
  failure_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidated_at?: InputMaybe<Order_By>;
  invalidated_by_admin?: InputMaybe<Admins_Order_By>;
  invalidated_by_admin_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_as_first_name?: InputMaybe<Order_By>;
  verified_as_last_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_identity_verifications */
export type User_Identity_Verifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_identity_verifications" */
export enum User_Identity_Verifications_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailureCode = 'failure_code',
  /** column name */
  FailureMessage = 'failure_message',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidatedAt = 'invalidated_at',
  /** column name */
  InvalidatedByAdminId = 'invalidated_by_admin_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSessionId = 'stripe_session_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerifiedAsFirstName = 'verified_as_first_name',
  /** column name */
  VerifiedAsLastName = 'verified_as_last_name'
}

/** input type for updating data in table "user_identity_verifications" */
export type User_Identity_Verifications_Set_Input = {
  invalidated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalidated_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type User_Identity_Verifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Identity_Verifications_Set_Input>;
  where: User_Identity_Verifications_Bool_Exp;
};

/** columns and relationships of "user_incomes" */
export type User_Incomes = {
  __typename: 'user_incomes';
  created_at: Scalars['timestamptz']['output'];
  employee_name?: Maybe<Scalars['String']['output']>;
  employee_title?: Maybe<Scalars['String']['output']>;
  employer_industry?: Maybe<Scalars['String']['output']>;
  employer_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pay_frequency?: Maybe<Scalars['String']['output']>;
  projected_annual_income?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submitted_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  unverified_at?: Maybe<Scalars['timestamptz']['output']>;
  unverified_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid']['output'];
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  ytd_gross_income?: Maybe<Scalars['numeric']['output']>;
  ytd_net_income?: Maybe<Scalars['numeric']['output']>;
};

/** order by aggregate values of table "user_incomes" */
export type User_Incomes_Aggregate_Order_By = {
  avg?: InputMaybe<User_Incomes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Incomes_Max_Order_By>;
  min?: InputMaybe<User_Incomes_Min_Order_By>;
  stddev?: InputMaybe<User_Incomes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Incomes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Incomes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Incomes_Sum_Order_By>;
  var_pop?: InputMaybe<User_Incomes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Incomes_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Incomes_Variance_Order_By>;
};

/** order by avg() on columns of table "user_incomes" */
export type User_Incomes_Avg_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_incomes". All fields are combined with a logical 'AND'. */
export type User_Incomes_Bool_Exp = {
  _and?: InputMaybe<Array<User_Incomes_Bool_Exp>>;
  _not?: InputMaybe<User_Incomes_Bool_Exp>;
  _or?: InputMaybe<Array<User_Incomes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employee_name?: InputMaybe<String_Comparison_Exp>;
  employee_title?: InputMaybe<String_Comparison_Exp>;
  employer_industry?: InputMaybe<String_Comparison_Exp>;
  employer_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pay_frequency?: InputMaybe<String_Comparison_Exp>;
  projected_annual_income?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  submitted_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  unverified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  unverified_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  ytd_gross_income?: InputMaybe<Numeric_Comparison_Exp>;
  ytd_net_income?: InputMaybe<Numeric_Comparison_Exp>;
};

/** order by max() on columns of table "user_incomes" */
export type User_Incomes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  employee_name?: InputMaybe<Order_By>;
  employee_title?: InputMaybe<Order_By>;
  employer_industry?: InputMaybe<Order_By>;
  employer_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pay_frequency?: InputMaybe<Order_By>;
  projected_annual_income?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_by_admin_id?: InputMaybe<Order_By>;
  unverified_at?: InputMaybe<Order_By>;
  unverified_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  verified_by_admin_id?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_incomes" */
export type User_Incomes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  employee_name?: InputMaybe<Order_By>;
  employee_title?: InputMaybe<Order_By>;
  employer_industry?: InputMaybe<Order_By>;
  employer_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pay_frequency?: InputMaybe<Order_By>;
  projected_annual_income?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_by_admin_id?: InputMaybe<Order_By>;
  unverified_at?: InputMaybe<Order_By>;
  unverified_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  verified_by_admin_id?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_incomes". */
export type User_Incomes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  employee_name?: InputMaybe<Order_By>;
  employee_title?: InputMaybe<Order_By>;
  employer_industry?: InputMaybe<Order_By>;
  employer_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pay_frequency?: InputMaybe<Order_By>;
  projected_annual_income?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_by_admin_id?: InputMaybe<Order_By>;
  unverified_at?: InputMaybe<Order_By>;
  unverified_by_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  verified_by_admin_id?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** select columns of table "user_incomes" */
export enum User_Incomes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmployeeName = 'employee_name',
  /** column name */
  EmployeeTitle = 'employee_title',
  /** column name */
  EmployerIndustry = 'employer_industry',
  /** column name */
  EmployerName = 'employer_name',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PayFrequency = 'pay_frequency',
  /** column name */
  ProjectedAnnualIncome = 'projected_annual_income',
  /** column name */
  Status = 'status',
  /** column name */
  SubmittedByAdminId = 'submitted_by_admin_id',
  /** column name */
  UnverifiedAt = 'unverified_at',
  /** column name */
  UnverifiedByAdminId = 'unverified_by_admin_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerifiedAt = 'verified_at',
  /** column name */
  VerifiedByAdminId = 'verified_by_admin_id',
  /** column name */
  YtdGrossIncome = 'ytd_gross_income',
  /** column name */
  YtdNetIncome = 'ytd_net_income'
}

/** order by stddev() on columns of table "user_incomes" */
export type User_Incomes_Stddev_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_incomes" */
export type User_Incomes_Stddev_Pop_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_incomes" */
export type User_Incomes_Stddev_Samp_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_incomes" */
export type User_Incomes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Incomes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Incomes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employee_name?: InputMaybe<Scalars['String']['input']>;
  employee_title?: InputMaybe<Scalars['String']['input']>;
  employer_industry?: InputMaybe<Scalars['String']['input']>;
  employer_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pay_frequency?: InputMaybe<Scalars['String']['input']>;
  projected_annual_income?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submitted_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  unverified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  unverified_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  ytd_gross_income?: InputMaybe<Scalars['numeric']['input']>;
  ytd_net_income?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "user_incomes" */
export type User_Incomes_Sum_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "user_incomes" */
export type User_Incomes_Var_Pop_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_incomes" */
export type User_Incomes_Var_Samp_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_incomes" */
export type User_Incomes_Variance_Order_By = {
  projected_annual_income?: InputMaybe<Order_By>;
  ytd_gross_income?: InputMaybe<Order_By>;
  ytd_net_income?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_prequalification_data" */
export type User_Prequalification_Data = {
  __typename: 'user_prequalification_data';
  campaign?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  credit_reports: Array<Credit_Reports>;
  has_coapplicant?: Maybe<Scalars['Boolean']['output']>;
  has_cosigner?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  is_credit_qualified?: Maybe<Scalars['Boolean']['output']>;
  is_income_qualified?: Maybe<Scalars['Boolean']['output']>;
  is_ok_with_two_year_lease?: Maybe<Scalars['Boolean']['output']>;
  is_section_eight?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  move_in_timeline_at_submission?: Maybe<Scalars['String']['output']>;
  prequalification_status: Scalars['String']['output'];
  prequalified_at?: Maybe<Scalars['timestamptz']['output']>;
  prequalified_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "user_prequalification_data" */
export type User_Prequalification_DataCredit_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Reports_Order_By>>;
  where?: InputMaybe<Credit_Reports_Bool_Exp>;
};


/** columns and relationships of "user_prequalification_data" */
export type User_Prequalification_DataMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "user_prequalification_data". All fields are combined with a logical 'AND'. */
export type User_Prequalification_Data_Bool_Exp = {
  _and?: InputMaybe<Array<User_Prequalification_Data_Bool_Exp>>;
  _not?: InputMaybe<User_Prequalification_Data_Bool_Exp>;
  _or?: InputMaybe<Array<User_Prequalification_Data_Bool_Exp>>;
  campaign?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_reports?: InputMaybe<Credit_Reports_Bool_Exp>;
  has_coapplicant?: InputMaybe<Boolean_Comparison_Exp>;
  has_cosigner?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_credit_qualified?: InputMaybe<Boolean_Comparison_Exp>;
  is_income_qualified?: InputMaybe<Boolean_Comparison_Exp>;
  is_ok_with_two_year_lease?: InputMaybe<Boolean_Comparison_Exp>;
  is_section_eight?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  move_in_timeline_at_submission?: InputMaybe<String_Comparison_Exp>;
  prequalification_status?: InputMaybe<String_Comparison_Exp>;
  prequalified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  prequalified_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "user_prequalification_data". */
export type User_Prequalification_Data_Order_By = {
  campaign?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_reports_aggregate?: InputMaybe<Credit_Reports_Aggregate_Order_By>;
  has_coapplicant?: InputMaybe<Order_By>;
  has_cosigner?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_credit_qualified?: InputMaybe<Order_By>;
  is_income_qualified?: InputMaybe<Order_By>;
  is_ok_with_two_year_lease?: InputMaybe<Order_By>;
  is_section_eight?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  move_in_timeline_at_submission?: InputMaybe<Order_By>;
  prequalification_status?: InputMaybe<Order_By>;
  prequalified_at?: InputMaybe<Order_By>;
  prequalified_by_admin_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_prequalification_data" */
export enum User_Prequalification_Data_Select_Column {
  /** column name */
  Campaign = 'campaign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasCoapplicant = 'has_coapplicant',
  /** column name */
  HasCosigner = 'has_cosigner',
  /** column name */
  Id = 'id',
  /** column name */
  IsCreditQualified = 'is_credit_qualified',
  /** column name */
  IsIncomeQualified = 'is_income_qualified',
  /** column name */
  IsOkWithTwoYearLease = 'is_ok_with_two_year_lease',
  /** column name */
  IsSectionEight = 'is_section_eight',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MoveInTimelineAtSubmission = 'move_in_timeline_at_submission',
  /** column name */
  PrequalificationStatus = 'prequalification_status',
  /** column name */
  PrequalifiedAt = 'prequalified_at',
  /** column name */
  PrequalifiedByAdminId = 'prequalified_by_admin_id',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "user_prequalification_data" */
export type User_Prequalification_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Prequalification_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Prequalification_Data_Stream_Cursor_Value_Input = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_coapplicant?: InputMaybe<Scalars['Boolean']['input']>;
  has_cosigner?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_credit_qualified?: InputMaybe<Scalars['Boolean']['input']>;
  is_income_qualified?: InputMaybe<Scalars['Boolean']['input']>;
  is_ok_with_two_year_lease?: InputMaybe<Scalars['Boolean']['input']>;
  is_section_eight?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  move_in_timeline_at_submission?: InputMaybe<Scalars['String']['input']>;
  prequalification_status?: InputMaybe<Scalars['String']['input']>;
  prequalified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  prequalified_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "user_searchable" */
export type User_Searchable = {
  __typename: 'user_searchable';
  contact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lead_group_user?: Maybe<Lead_Group_Users>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** Boolean expression to filter rows from the table "user_searchable". All fields are combined with a logical 'AND'. */
export type User_Searchable_Bool_Exp = {
  _and?: InputMaybe<Array<User_Searchable_Bool_Exp>>;
  _not?: InputMaybe<User_Searchable_Bool_Exp>;
  _or?: InputMaybe<Array<User_Searchable_Bool_Exp>>;
  contact?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<String_Comparison_Exp>;
  lead_group_user?: InputMaybe<Lead_Group_Users_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "user_searchable". */
export type User_Searchable_Order_By = {
  contact?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  lead_group_user?: InputMaybe<Lead_Group_Users_Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "user_searchable" */
export enum User_Searchable_Select_Column {
  /** column name */
  Contact = 'contact',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "user_searchable" */
export type User_Searchable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Searchable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Searchable_Stream_Cursor_Value_Input = {
  contact?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "user_underwriting_data" */
export type User_Underwriting_Data = {
  __typename: 'user_underwriting_data';
  alerts?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  credit_score?: Maybe<Scalars['Int']['output']>;
  criminal_match?: Maybe<Scalars['jsonb']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
  verified_income?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "user_underwriting_data" */
export type User_Underwriting_DataAlertsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_underwriting_data" */
export type User_Underwriting_DataCriminal_MatchArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "user_underwriting_data" */
export type User_Underwriting_Data_Aggregate_Order_By = {
  avg?: InputMaybe<User_Underwriting_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Underwriting_Data_Max_Order_By>;
  min?: InputMaybe<User_Underwriting_Data_Min_Order_By>;
  stddev?: InputMaybe<User_Underwriting_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Underwriting_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Underwriting_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Underwriting_Data_Sum_Order_By>;
  var_pop?: InputMaybe<User_Underwriting_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Underwriting_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Underwriting_Data_Variance_Order_By>;
};

/** order by avg() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Avg_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_underwriting_data". All fields are combined with a logical 'AND'. */
export type User_Underwriting_Data_Bool_Exp = {
  _and?: InputMaybe<Array<User_Underwriting_Data_Bool_Exp>>;
  _not?: InputMaybe<User_Underwriting_Data_Bool_Exp>;
  _or?: InputMaybe<Array<User_Underwriting_Data_Bool_Exp>>;
  alerts?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_score?: InputMaybe<Int_Comparison_Exp>;
  criminal_match?: InputMaybe<Jsonb_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified_income?: InputMaybe<Numeric_Comparison_Exp>;
};

/** order by max() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_underwriting_data". */
export type User_Underwriting_Data_Order_By = {
  alerts?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  criminal_match?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** select columns of table "user_underwriting_data" */
export enum User_Underwriting_Data_Select_Column {
  /** column name */
  Alerts = 'alerts',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditScore = 'credit_score',
  /** column name */
  CriminalMatch = 'criminal_match',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerifiedIncome = 'verified_income'
}

/** order by stddev() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Stddev_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Stddev_Pop_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Stddev_Samp_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_underwriting_data" */
export type User_Underwriting_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Underwriting_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Underwriting_Data_Stream_Cursor_Value_Input = {
  alerts?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_score?: InputMaybe<Scalars['Int']['input']>;
  criminal_match?: InputMaybe<Scalars['jsonb']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified_income?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Sum_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Var_Pop_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Var_Samp_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_underwriting_data" */
export type User_Underwriting_Data_Variance_Order_By = {
  credit_score?: InputMaybe<Order_By>;
  verified_income?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename: 'users';
  buildium_tenant_id?: Maybe<Scalars['Int']['output']>;
  close_contact_ids?: Maybe<Scalars['_text']['output']>;
  close_lead_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  conversations: Array<Conversations>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  credit_reports: Array<Credit_Reports>;
  /** An array relationship */
  criminal_reports: Array<Criminal_Reports>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  disable_self_initiated_payments?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  documents: Array<User_Documents>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  eviction_reports: Array<Eviction_Reports>;
  firebase_auth_uid?: Maybe<Scalars['String']['output']>;
  firestore_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  invalid_at?: Maybe<Scalars['timestamptz']['output']>;
  is_fake_email?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lead_group_users: Array<Lead_Group_Users>;
  merged_at?: Maybe<Scalars['timestamptz']['output']>;
  merged_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  phone?: Maybe<Scalars['String']['output']>;
  plaid_access_token?: Maybe<Scalars['String']['output']>;
  plaid_access_token_invalid_at?: Maybe<Scalars['timestamp']['output']>;
  plaid_access_token_pending_automatic_verification_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_access_token_pending_manual_verification_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_product_not_ready_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_stripe_connected_at?: Maybe<Scalars['timestamptz']['output']>;
  primary_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  rental_application_fees: Array<Rental_Application_Fees>;
  /** An array relationship */
  rental_site_leads: Array<Rental_Site_Leads>;
  /** An array relationship */
  rental_users: Array<Rental_Users>;
  /** An array relationship */
  rentals: Array<Rentals>;
  reset_password: Scalars['Boolean']['output'];
  settings?: Maybe<Scalars['jsonb']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  test_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_contact_details: Array<User_Contact_Details>;
  /** An array relationship */
  user_document_requests: Array<User_Document_Requests>;
  /** An object relationship */
  user_funnel_status?: Maybe<User_Funnel_Statuses>;
  /** An array relationship */
  user_incomes: Array<User_Incomes>;
  /** An object relationship */
  user_prequalification_data?: Maybe<User_Prequalification_Data>;
  /** An object relationship */
  user_searchable?: Maybe<User_Searchable>;
  /** An array relationship */
  user_underwriting_data: Array<User_Underwriting_Data>;
};


/** columns and relationships of "users" */
export type UsersConversationsArgs = {
  distinct_on?: InputMaybe<Array<Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversations_Order_By>>;
  where?: InputMaybe<Conversations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Reports_Order_By>>;
  where?: InputMaybe<Credit_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCriminal_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Criminal_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Criminal_Reports_Order_By>>;
  where?: InputMaybe<Criminal_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocumentsArgs = {
  distinct_on?: InputMaybe<Array<User_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Documents_Order_By>>;
  where?: InputMaybe<User_Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEviction_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Eviction_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eviction_Reports_Order_By>>;
  where?: InputMaybe<Eviction_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLead_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Lead_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Group_Users_Order_By>>;
  where?: InputMaybe<Lead_Group_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRental_Application_FeesArgs = {
  distinct_on?: InputMaybe<Array<Rental_Application_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Application_Fees_Order_By>>;
  where?: InputMaybe<Rental_Application_Fees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRental_Site_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Rental_Site_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Site_Leads_Order_By>>;
  where?: InputMaybe<Rental_Site_Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRental_UsersArgs = {
  distinct_on?: InputMaybe<Array<Rental_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Users_Order_By>>;
  where?: InputMaybe<Rental_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRentalsArgs = {
  distinct_on?: InputMaybe<Array<Rentals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rentals_Order_By>>;
  where?: InputMaybe<Rentals_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersUser_Contact_DetailsArgs = {
  distinct_on?: InputMaybe<Array<User_Contact_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Contact_Details_Order_By>>;
  where?: InputMaybe<User_Contact_Details_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Document_RequestsArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Document_Requests_Order_By>>;
  where?: InputMaybe<User_Document_Requests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_IncomesArgs = {
  distinct_on?: InputMaybe<Array<User_Incomes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Incomes_Order_By>>;
  where?: InputMaybe<User_Incomes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Underwriting_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Underwriting_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Underwriting_Data_Order_By>>;
  where?: InputMaybe<User_Underwriting_Data_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename: 'users_avg_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  buildium_tenant_id?: InputMaybe<Int_Comparison_Exp>;
  close_contact_ids?: InputMaybe<_Text_Comparison_Exp>;
  close_lead_id?: InputMaybe<String_Comparison_Exp>;
  conversations?: InputMaybe<Conversations_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_reports?: InputMaybe<Credit_Reports_Bool_Exp>;
  criminal_reports?: InputMaybe<Criminal_Reports_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  disable_self_initiated_payments?: InputMaybe<Boolean_Comparison_Exp>;
  documents?: InputMaybe<User_Documents_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  eviction_reports?: InputMaybe<Eviction_Reports_Bool_Exp>;
  firebase_auth_uid?: InputMaybe<String_Comparison_Exp>;
  firestore_synced_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_fake_email?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead_group_users?: InputMaybe<Lead_Group_Users_Bool_Exp>;
  merged_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  merged_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  payment_methods?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  plaid_access_token?: InputMaybe<String_Comparison_Exp>;
  plaid_access_token_invalid_at?: InputMaybe<Timestamp_Comparison_Exp>;
  plaid_access_token_pending_automatic_verification_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  plaid_access_token_pending_manual_verification_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  plaid_account_id?: InputMaybe<String_Comparison_Exp>;
  plaid_product_not_ready_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  plaid_stripe_connected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  primary_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_application_fees?: InputMaybe<Rental_Application_Fees_Bool_Exp>;
  rental_site_leads?: InputMaybe<Rental_Site_Leads_Bool_Exp>;
  rental_users?: InputMaybe<Rental_Users_Bool_Exp>;
  rentals?: InputMaybe<Rentals_Bool_Exp>;
  reset_password?: InputMaybe<Boolean_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  test_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_contact_details?: InputMaybe<User_Contact_Details_Bool_Exp>;
  user_document_requests?: InputMaybe<User_Document_Requests_Bool_Exp>;
  user_funnel_status?: InputMaybe<User_Funnel_Statuses_Bool_Exp>;
  user_incomes?: InputMaybe<User_Incomes_Bool_Exp>;
  user_prequalification_data?: InputMaybe<User_Prequalification_Data_Bool_Exp>;
  user_searchable?: InputMaybe<User_Searchable_Bool_Exp>;
  user_underwriting_data?: InputMaybe<User_Underwriting_Data_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename: 'users_max_fields';
  buildium_tenant_id?: Maybe<Scalars['Int']['output']>;
  close_lead_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebase_auth_uid?: Maybe<Scalars['String']['output']>;
  firestore_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_at?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_at?: Maybe<Scalars['timestamptz']['output']>;
  merged_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plaid_access_token?: Maybe<Scalars['String']['output']>;
  plaid_access_token_invalid_at?: Maybe<Scalars['timestamp']['output']>;
  plaid_access_token_pending_automatic_verification_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_access_token_pending_manual_verification_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_product_not_ready_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_stripe_connected_at?: Maybe<Scalars['timestamptz']['output']>;
  primary_user_id?: Maybe<Scalars['uuid']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  test_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename: 'users_min_fields';
  buildium_tenant_id?: Maybe<Scalars['Int']['output']>;
  close_lead_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebase_auth_uid?: Maybe<Scalars['String']['output']>;
  firestore_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_at?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_at?: Maybe<Scalars['timestamptz']['output']>;
  merged_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plaid_access_token?: Maybe<Scalars['String']['output']>;
  plaid_access_token_invalid_at?: Maybe<Scalars['timestamp']['output']>;
  plaid_access_token_pending_automatic_verification_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_access_token_pending_manual_verification_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_product_not_ready_at?: Maybe<Scalars['timestamptz']['output']>;
  plaid_stripe_connected_at?: Maybe<Scalars['timestamptz']['output']>;
  primary_user_id?: Maybe<Scalars['uuid']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  test_admin_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  buildium_tenant_id?: InputMaybe<Order_By>;
  close_contact_ids?: InputMaybe<Order_By>;
  close_lead_id?: InputMaybe<Order_By>;
  conversations_aggregate?: InputMaybe<Conversations_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_reports_aggregate?: InputMaybe<Credit_Reports_Aggregate_Order_By>;
  criminal_reports_aggregate?: InputMaybe<Criminal_Reports_Aggregate_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_admin_id?: InputMaybe<Order_By>;
  disable_self_initiated_payments?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<User_Documents_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  eviction_reports_aggregate?: InputMaybe<Eviction_Reports_Aggregate_Order_By>;
  firebase_auth_uid?: InputMaybe<Order_By>;
  firestore_synced_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalid_at?: InputMaybe<Order_By>;
  is_fake_email?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_group_users_aggregate?: InputMaybe<Lead_Group_Users_Aggregate_Order_By>;
  merged_at?: InputMaybe<Order_By>;
  merged_by_admin_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  plaid_access_token?: InputMaybe<Order_By>;
  plaid_access_token_invalid_at?: InputMaybe<Order_By>;
  plaid_access_token_pending_automatic_verification_at?: InputMaybe<Order_By>;
  plaid_access_token_pending_manual_verification_at?: InputMaybe<Order_By>;
  plaid_account_id?: InputMaybe<Order_By>;
  plaid_product_not_ready_at?: InputMaybe<Order_By>;
  plaid_stripe_connected_at?: InputMaybe<Order_By>;
  primary_user_id?: InputMaybe<Order_By>;
  rental_application_fees_aggregate?: InputMaybe<Rental_Application_Fees_Aggregate_Order_By>;
  rental_site_leads_aggregate?: InputMaybe<Rental_Site_Leads_Aggregate_Order_By>;
  rental_users_aggregate?: InputMaybe<Rental_Users_Aggregate_Order_By>;
  rentals_aggregate?: InputMaybe<Rentals_Aggregate_Order_By>;
  reset_password?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  test_admin_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_contact_details_aggregate?: InputMaybe<User_Contact_Details_Aggregate_Order_By>;
  user_document_requests_aggregate?: InputMaybe<User_Document_Requests_Aggregate_Order_By>;
  user_funnel_status?: InputMaybe<User_Funnel_Statuses_Order_By>;
  user_incomes_aggregate?: InputMaybe<User_Incomes_Aggregate_Order_By>;
  user_prequalification_data?: InputMaybe<User_Prequalification_Data_Order_By>;
  user_searchable?: InputMaybe<User_Searchable_Order_By>;
  user_underwriting_data_aggregate?: InputMaybe<User_Underwriting_Data_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  BuildiumTenantId = 'buildium_tenant_id',
  /** column name */
  CloseContactIds = 'close_contact_ids',
  /** column name */
  CloseLeadId = 'close_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByAdminId = 'deleted_by_admin_id',
  /** column name */
  DisableSelfInitiatedPayments = 'disable_self_initiated_payments',
  /** column name */
  Email = 'email',
  /** column name */
  FirebaseAuthUid = 'firebase_auth_uid',
  /** column name */
  FirestoreSyncedAt = 'firestore_synced_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidAt = 'invalid_at',
  /** column name */
  IsFakeEmail = 'is_fake_email',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MergedAt = 'merged_at',
  /** column name */
  MergedByAdminId = 'merged_by_admin_id',
  /** column name */
  Password = 'password',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlaidAccessToken = 'plaid_access_token',
  /** column name */
  PlaidAccessTokenInvalidAt = 'plaid_access_token_invalid_at',
  /** column name */
  PlaidAccessTokenPendingAutomaticVerificationAt = 'plaid_access_token_pending_automatic_verification_at',
  /** column name */
  PlaidAccessTokenPendingManualVerificationAt = 'plaid_access_token_pending_manual_verification_at',
  /** column name */
  PlaidAccountId = 'plaid_account_id',
  /** column name */
  PlaidProductNotReadyAt = 'plaid_product_not_ready_at',
  /** column name */
  PlaidStripeConnectedAt = 'plaid_stripe_connected_at',
  /** column name */
  PrimaryUserId = 'primary_user_id',
  /** column name */
  ResetPassword = 'reset_password',
  /** column name */
  Settings = 'settings',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  TestAdminId = 'test_admin_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  disable_self_initiated_payments?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename: 'users_stddev_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename: 'users_stddev_pop_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename: 'users_stddev_samp_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  buildium_tenant_id?: InputMaybe<Scalars['Int']['input']>;
  close_contact_ids?: InputMaybe<Scalars['_text']['input']>;
  close_lead_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  disable_self_initiated_payments?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebase_auth_uid?: InputMaybe<Scalars['String']['input']>;
  firestore_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_fake_email?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  merged_at?: InputMaybe<Scalars['timestamptz']['input']>;
  merged_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plaid_access_token?: InputMaybe<Scalars['String']['input']>;
  plaid_access_token_invalid_at?: InputMaybe<Scalars['timestamp']['input']>;
  plaid_access_token_pending_automatic_verification_at?: InputMaybe<Scalars['timestamptz']['input']>;
  plaid_access_token_pending_manual_verification_at?: InputMaybe<Scalars['timestamptz']['input']>;
  plaid_account_id?: InputMaybe<Scalars['String']['input']>;
  plaid_product_not_ready_at?: InputMaybe<Scalars['timestamptz']['input']>;
  plaid_stripe_connected_at?: InputMaybe<Scalars['timestamptz']['input']>;
  primary_user_id?: InputMaybe<Scalars['uuid']['input']>;
  reset_password?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  test_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename: 'users_sum_fields';
  buildium_tenant_id?: Maybe<Scalars['Int']['output']>;
};

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename: 'users_var_pop_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename: 'users_var_samp_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename: 'users_variance_fields';
  buildium_tenant_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "utility_bills" */
export type Utility_Bills = {
  __typename: 'utility_bills';
  amount: Scalars['numeric']['output'];
  bill_date: Scalars['date']['output'];
  bill_due_date: Scalars['date']['output'];
  buildium_bank_account_id?: Maybe<Scalars['Int']['output']>;
  buildium_id?: Maybe<Scalars['Int']['output']>;
  charge_type: Utility_Bills_Charge_Type_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document?: Maybe<Documents>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_source: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  original_bill_metadata: Scalars['jsonb']['output'];
  /** An object relationship */
  portfolio_home?: Maybe<Portfolio_Homes>;
  portfolio_home_id?: Maybe<Scalars['uuid']['output']>;
  service_end_date: Scalars['date']['output'];
  service_start_date: Scalars['date']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
  /** An array relationship */
  utility_chargebacks: Array<Utility_Chargebacks>;
  /** An aggregate relationship */
  utility_chargebacks_aggregate: Utility_Chargebacks_Aggregate;
  /** An object relationship */
  utility_type: Utility_Types;
  utility_type_id: Scalars['uuid']['output'];
  vendor: Scalars['String']['output'];
};


/** columns and relationships of "utility_bills" */
export type Utility_BillsOriginal_Bill_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "utility_bills" */
export type Utility_BillsUtility_ChargebacksArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargebacks_Order_By>>;
  where?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
};


/** columns and relationships of "utility_bills" */
export type Utility_BillsUtility_Chargebacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utility_Chargebacks_Order_By>>;
  where?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "utility_bills". All fields are combined with a logical 'AND'. */
export type Utility_Bills_Bool_Exp = {
  _and?: InputMaybe<Array<Utility_Bills_Bool_Exp>>;
  _not?: InputMaybe<Utility_Bills_Bool_Exp>;
  _or?: InputMaybe<Array<Utility_Bills_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  bill_date?: InputMaybe<Date_Comparison_Exp>;
  bill_due_date?: InputMaybe<Date_Comparison_Exp>;
  buildium_bank_account_id?: InputMaybe<Int_Comparison_Exp>;
  buildium_id?: InputMaybe<Int_Comparison_Exp>;
  charge_type?: InputMaybe<Utility_Bills_Charge_Type_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  original_bill_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Bool_Exp>;
  portfolio_home_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_end_date?: InputMaybe<Date_Comparison_Exp>;
  service_start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  utility_chargebacks?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
  utility_chargebacks_aggregate?: InputMaybe<Utility_Chargebacks_Aggregate_Bool_Exp>;
  utility_type?: InputMaybe<Utility_Types_Bool_Exp>;
  utility_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor?: InputMaybe<String_Comparison_Exp>;
};

export enum Utility_Bills_Charge_Type_Enum_Enum {
  Deposit = 'deposit',
  LateFee = 'late_fee',
  ServiceCharge = 'service_charge'
}

/** Boolean expression to compare columns of type "utility_bills_charge_type_enum_enum". All fields are combined with logical 'AND'. */
export type Utility_Bills_Charge_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Utility_Bills_Charge_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Utility_Bills_Charge_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Utility_Bills_Charge_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Utility_Bills_Charge_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "utility_bills". */
export type Utility_Bills_Order_By = {
  amount?: InputMaybe<Order_By>;
  bill_date?: InputMaybe<Order_By>;
  bill_due_date?: InputMaybe<Order_By>;
  buildium_bank_account_id?: InputMaybe<Order_By>;
  buildium_id?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_bill_metadata?: InputMaybe<Order_By>;
  portfolio_home?: InputMaybe<Portfolio_Homes_Order_By>;
  portfolio_home_id?: InputMaybe<Order_By>;
  service_end_date?: InputMaybe<Order_By>;
  service_start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  utility_chargebacks_aggregate?: InputMaybe<Utility_Chargebacks_Aggregate_Order_By>;
  utility_type?: InputMaybe<Utility_Types_Order_By>;
  utility_type_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Order_By>;
};

/** select columns of table "utility_bills" */
export enum Utility_Bills_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BillDate = 'bill_date',
  /** column name */
  BillDueDate = 'bill_due_date',
  /** column name */
  BuildiumBankAccountId = 'buildium_bank_account_id',
  /** column name */
  BuildiumId = 'buildium_id',
  /** column name */
  ChargeType = 'charge_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalBillMetadata = 'original_bill_metadata',
  /** column name */
  PortfolioHomeId = 'portfolio_home_id',
  /** column name */
  ServiceEndDate = 'service_end_date',
  /** column name */
  ServiceStartDate = 'service_start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UtilityTypeId = 'utility_type_id',
  /** column name */
  Vendor = 'vendor'
}

/** columns and relationships of "utility_chargeback_status_enum" */
export type Utility_Chargeback_Status_Enum = {
  __typename: 'utility_chargeback_status_enum';
  status: Scalars['String']['output'];
};

/** aggregated selection of "utility_chargeback_status_enum" */
export type Utility_Chargeback_Status_Enum_Aggregate = {
  __typename: 'utility_chargeback_status_enum_aggregate';
  aggregate?: Maybe<Utility_Chargeback_Status_Enum_Aggregate_Fields>;
  nodes: Array<Utility_Chargeback_Status_Enum>;
};

/** aggregate fields of "utility_chargeback_status_enum" */
export type Utility_Chargeback_Status_Enum_Aggregate_Fields = {
  __typename: 'utility_chargeback_status_enum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Utility_Chargeback_Status_Enum_Max_Fields>;
  min?: Maybe<Utility_Chargeback_Status_Enum_Min_Fields>;
};


/** aggregate fields of "utility_chargeback_status_enum" */
export type Utility_Chargeback_Status_Enum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "utility_chargeback_status_enum". All fields are combined with a logical 'AND'. */
export type Utility_Chargeback_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Utility_Chargeback_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

export enum Utility_Chargeback_Status_Enum_Enum {
  Approved = 'approved',
  Deferred = 'deferred',
  PendingTriage = 'pending_triage',
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "utility_chargeback_status_enum_enum". All fields are combined with logical 'AND'. */
export type Utility_Chargeback_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Utility_Chargeback_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Utility_Chargeback_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Utility_Chargeback_Status_Enum_Enum>>;
};

/** aggregate max on columns */
export type Utility_Chargeback_Status_Enum_Max_Fields = {
  __typename: 'utility_chargeback_status_enum_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Utility_Chargeback_Status_Enum_Min_Fields = {
  __typename: 'utility_chargeback_status_enum_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "utility_chargeback_status_enum". */
export type Utility_Chargeback_Status_Enum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "utility_chargeback_status_enum" */
export enum Utility_Chargeback_Status_Enum_Select_Column {
  /** column name */
  Status = 'status'
}

/** columns and relationships of "utility_chargebacks" */
export type Utility_Chargebacks = {
  __typename: 'utility_chargebacks';
  /** An object relationship */
  admin?: Maybe<Admins>;
  created_at: Scalars['timestamptz']['output'];
  finalized_amount?: Maybe<Scalars['numeric']['output']>;
  finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  finalized_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental_liability?: Maybe<Rental_Liabilities>;
  rental_liability_id?: Maybe<Scalars['uuid']['output']>;
  status: Utility_Chargeback_Status_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  utility_bill?: Maybe<Utility_Bills>;
  utility_bill_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "utility_chargebacks" */
export type Utility_Chargebacks_Aggregate = {
  __typename: 'utility_chargebacks_aggregate';
  aggregate?: Maybe<Utility_Chargebacks_Aggregate_Fields>;
  nodes: Array<Utility_Chargebacks>;
};

export type Utility_Chargebacks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utility_Chargebacks_Aggregate_Bool_Exp_Count>;
};

export type Utility_Chargebacks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utility_chargebacks" */
export type Utility_Chargebacks_Aggregate_Fields = {
  __typename: 'utility_chargebacks_aggregate_fields';
  avg?: Maybe<Utility_Chargebacks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utility_Chargebacks_Max_Fields>;
  min?: Maybe<Utility_Chargebacks_Min_Fields>;
  stddev?: Maybe<Utility_Chargebacks_Stddev_Fields>;
  stddev_pop?: Maybe<Utility_Chargebacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utility_Chargebacks_Stddev_Samp_Fields>;
  sum?: Maybe<Utility_Chargebacks_Sum_Fields>;
  var_pop?: Maybe<Utility_Chargebacks_Var_Pop_Fields>;
  var_samp?: Maybe<Utility_Chargebacks_Var_Samp_Fields>;
  variance?: Maybe<Utility_Chargebacks_Variance_Fields>;
};


/** aggregate fields of "utility_chargebacks" */
export type Utility_Chargebacks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utility_Chargebacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utility_chargebacks" */
export type Utility_Chargebacks_Aggregate_Order_By = {
  avg?: InputMaybe<Utility_Chargebacks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utility_Chargebacks_Max_Order_By>;
  min?: InputMaybe<Utility_Chargebacks_Min_Order_By>;
  stddev?: InputMaybe<Utility_Chargebacks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utility_Chargebacks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utility_Chargebacks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utility_Chargebacks_Sum_Order_By>;
  var_pop?: InputMaybe<Utility_Chargebacks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utility_Chargebacks_Var_Samp_Order_By>;
  variance?: InputMaybe<Utility_Chargebacks_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Utility_Chargebacks_Avg_Fields = {
  __typename: 'utility_chargebacks_avg_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Avg_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utility_chargebacks". All fields are combined with a logical 'AND'. */
export type Utility_Chargebacks_Bool_Exp = {
  _and?: InputMaybe<Array<Utility_Chargebacks_Bool_Exp>>;
  _not?: InputMaybe<Utility_Chargebacks_Bool_Exp>;
  _or?: InputMaybe<Array<Utility_Chargebacks_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finalized_amount?: InputMaybe<Numeric_Comparison_Exp>;
  finalized_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finalized_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_liability?: InputMaybe<Rental_Liabilities_Bool_Exp>;
  rental_liability_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Utility_Chargeback_Status_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utility_bill?: InputMaybe<Utility_Bills_Bool_Exp>;
  utility_bill_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "utility_chargebacks" */
export type Utility_Chargebacks_Inc_Input = {
  finalized_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Utility_Chargebacks_Max_Fields = {
  __typename: 'utility_chargebacks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  finalized_amount?: Maybe<Scalars['numeric']['output']>;
  finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  finalized_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  rental_liability_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utility_bill_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finalized_amount?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  finalized_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utility_bill_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utility_Chargebacks_Min_Fields = {
  __typename: 'utility_chargebacks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  finalized_amount?: Maybe<Scalars['numeric']['output']>;
  finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  finalized_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  rental_liability_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utility_bill_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finalized_amount?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  finalized_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utility_bill_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utility_chargebacks" */
export type Utility_Chargebacks_Mutation_Response = {
  __typename: 'utility_chargebacks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utility_Chargebacks>;
};

/** Ordering options when selecting data from "utility_chargebacks". */
export type Utility_Chargebacks_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  created_at?: InputMaybe<Order_By>;
  finalized_amount?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  finalized_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  rental_liability?: InputMaybe<Rental_Liabilities_Order_By>;
  rental_liability_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utility_bill?: InputMaybe<Utility_Bills_Order_By>;
  utility_bill_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utility_chargebacks */
export type Utility_Chargebacks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "utility_chargebacks" */
export enum Utility_Chargebacks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinalizedAmount = 'finalized_amount',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  FinalizedByAdminId = 'finalized_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  RentalLiabilityId = 'rental_liability_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtilityBillId = 'utility_bill_id'
}

/** input type for updating data in table "utility_chargebacks" */
export type Utility_Chargebacks_Set_Input = {
  finalized_amount?: InputMaybe<Scalars['numeric']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  finalized_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_liability_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Utility_Chargeback_Status_Enum_Enum>;
};

/** aggregate stddev on columns */
export type Utility_Chargebacks_Stddev_Fields = {
  __typename: 'utility_chargebacks_stddev_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Stddev_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utility_Chargebacks_Stddev_Pop_Fields = {
  __typename: 'utility_chargebacks_stddev_pop_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Stddev_Pop_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utility_Chargebacks_Stddev_Samp_Fields = {
  __typename: 'utility_chargebacks_stddev_samp_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Stddev_Samp_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Utility_Chargebacks_Sum_Fields = {
  __typename: 'utility_chargebacks_sum_fields';
  finalized_amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Sum_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

export type Utility_Chargebacks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utility_Chargebacks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utility_Chargebacks_Set_Input>;
  where: Utility_Chargebacks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utility_Chargebacks_Var_Pop_Fields = {
  __typename: 'utility_chargebacks_var_pop_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Var_Pop_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utility_Chargebacks_Var_Samp_Fields = {
  __typename: 'utility_chargebacks_var_samp_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Var_Samp_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utility_Chargebacks_Variance_Fields = {
  __typename: 'utility_chargebacks_variance_fields';
  finalized_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utility_chargebacks" */
export type Utility_Chargebacks_Variance_Order_By = {
  finalized_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "utility_responsibilities" */
export type Utility_Responsibilities = {
  __typename: 'utility_responsibilities';
  /** An object relationship */
  admin?: Maybe<Admins>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio_home_utility: Portfolio_Home_Utilities;
  portfolio_home_utility_id: Scalars['uuid']['output'];
  /** An object relationship */
  rental: Rentals;
  rental_id: Scalars['uuid']['output'];
  responsible_party: Scalars['String']['output'];
  start_date: Scalars['date']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "utility_responsibilities" */
export type Utility_Responsibilities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utility_Responsibilities_Max_Order_By>;
  min?: InputMaybe<Utility_Responsibilities_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "utility_responsibilities". All fields are combined with a logical 'AND'. */
export type Utility_Responsibilities_Bool_Exp = {
  _and?: InputMaybe<Array<Utility_Responsibilities_Bool_Exp>>;
  _not?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
  _or?: InputMaybe<Array<Utility_Responsibilities_Bool_Exp>>;
  admin?: InputMaybe<Admins_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portfolio_home_utility?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
  portfolio_home_utility_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  responsible_party?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "utility_responsibilities" */
export enum Utility_Responsibilities_Constraint {
  /** unique or primary key constraint on columns "id" */
  UtilityResponsibilitiesPkey = 'utility_responsibilities_pkey'
}

/** input type for inserting data into table "utility_responsibilities" */
export type Utility_Responsibilities_Insert_Input = {
  admin?: InputMaybe<Admins_Obj_Rel_Insert_Input>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_utility_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  responsible_party?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by max() on columns of table "utility_responsibilities" */
export type Utility_Responsibilities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_utility_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  responsible_party?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "utility_responsibilities" */
export type Utility_Responsibilities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_utility_id?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  responsible_party?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utility_responsibilities" */
export type Utility_Responsibilities_Mutation_Response = {
  __typename: 'utility_responsibilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utility_Responsibilities>;
};

/** on_conflict condition type for table "utility_responsibilities" */
export type Utility_Responsibilities_On_Conflict = {
  constraint: Utility_Responsibilities_Constraint;
  update_columns?: Array<Utility_Responsibilities_Update_Column>;
  where?: InputMaybe<Utility_Responsibilities_Bool_Exp>;
};

/** Ordering options when selecting data from "utility_responsibilities". */
export type Utility_Responsibilities_Order_By = {
  admin?: InputMaybe<Admins_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portfolio_home_utility?: InputMaybe<Portfolio_Home_Utilities_Order_By>;
  portfolio_home_utility_id?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  responsible_party?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "utility_responsibilities" */
export enum Utility_Responsibilities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  Id = 'id',
  /** column name */
  PortfolioHomeUtilityId = 'portfolio_home_utility_id',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  ResponsibleParty = 'responsible_party',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "utility_responsibilities" */
export type Utility_Responsibilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utility_Responsibilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utility_Responsibilities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio_home_utility_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  responsible_party?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "utility_responsibilities" (current role has no relevant permissions) */
export enum Utility_Responsibilities_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "utility_types" */
export type Utility_Types = {
  __typename: 'utility_types';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  deposit_ledger_account?: Maybe<Ledger_Accounts>;
  deposit_ledger_account_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  liability_type: Liability_Types;
  liability_type_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  portfolio_home_utilities: Array<Portfolio_Home_Utilities>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "utility_types" */
export type Utility_TypesPortfolio_Home_UtilitiesArgs = {
  distinct_on?: InputMaybe<Array<Portfolio_Home_Utilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Home_Utilities_Order_By>>;
  where?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
};

/** order by aggregate values of table "utility_types" */
export type Utility_Types_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utility_Types_Max_Order_By>;
  min?: InputMaybe<Utility_Types_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "utility_types". All fields are combined with a logical 'AND'. */
export type Utility_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Utility_Types_Bool_Exp>>;
  _not?: InputMaybe<Utility_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Utility_Types_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deposit_ledger_account?: InputMaybe<Ledger_Accounts_Bool_Exp>;
  deposit_ledger_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  liability_type?: InputMaybe<Liability_Types_Bool_Exp>;
  liability_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  portfolio_home_utilities?: InputMaybe<Portfolio_Home_Utilities_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "utility_types" */
export type Utility_Types_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deposit_ledger_account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "utility_types" */
export type Utility_Types_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deposit_ledger_account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "utility_types". */
export type Utility_Types_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deposit_ledger_account?: InputMaybe<Ledger_Accounts_Order_By>;
  deposit_ledger_account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liability_type?: InputMaybe<Liability_Types_Order_By>;
  liability_type_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  portfolio_home_utilities_aggregate?: InputMaybe<Portfolio_Home_Utilities_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "utility_types" */
export enum Utility_Types_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DepositLedgerAccountId = 'deposit_ledger_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  LiabilityTypeId = 'liability_type_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "utility_types" */
export type Utility_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utility_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utility_Types_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deposit_ledger_account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Join table to relate vendors to the markets they operate in */
export type Vendor_Markets = {
  __typename: 'vendor_markets';
  /** An object relationship */
  market: Markets;
  market_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendor_markets" */
export type Vendor_Markets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Markets_Max_Order_By>;
  min?: InputMaybe<Vendor_Markets_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_markets". All fields are combined with a logical 'AND'. */
export type Vendor_Markets_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Markets_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Markets_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Markets_Bool_Exp>>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_markets" */
export enum Vendor_Markets_Constraint {
  /** unique or primary key constraint on columns "market_id", "vendor_id" */
  VendorMarketsPkey = 'vendor_markets_pkey'
}

/** input type for inserting data into table "vendor_markets" */
export type Vendor_Markets_Insert_Input = {
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "vendor_markets" */
export type Vendor_Markets_Max_Order_By = {
  market_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendor_markets" */
export type Vendor_Markets_Min_Order_By = {
  market_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_markets" */
export type Vendor_Markets_Mutation_Response = {
  __typename: 'vendor_markets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Markets>;
};

/** on_conflict condition type for table "vendor_markets" */
export type Vendor_Markets_On_Conflict = {
  constraint: Vendor_Markets_Constraint;
  update_columns?: Array<Vendor_Markets_Update_Column>;
  where?: InputMaybe<Vendor_Markets_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_markets". */
export type Vendor_Markets_Order_By = {
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendor_markets" */
export enum Vendor_Markets_Select_Column {
  /** column name */
  MarketId = 'market_id',
  /** column name */
  VendorId = 'vendor_id'
}

/** Streaming cursor of the table "vendor_markets" */
export type Vendor_Markets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Markets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Markets_Stream_Cursor_Value_Input = {
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "vendor_markets" (current role has no relevant permissions) */
export enum Vendor_Markets_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "vendor_tags" */
export type Vendor_Tags = {
  __typename: 'vendor_tags';
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendors_vendor_tags: Array<Vendors_Vendor_Tags>;
};


/** columns and relationships of "vendor_tags" */
export type Vendor_TagsVendors_Vendor_TagsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Tags_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "vendor_tags". All fields are combined with a logical 'AND'. */
export type Vendor_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Tags_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendors_vendor_tags?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_tags". */
export type Vendor_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendors_vendor_tags_aggregate?: InputMaybe<Vendors_Vendor_Tags_Aggregate_Order_By>;
};

/** select columns of table "vendor_tags" */
export enum Vendor_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "vendor_tags" */
export type Vendor_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "vendor_types" */
export type Vendor_Types = {
  __typename: 'vendor_types';
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendors_vendor_types: Array<Vendors_Vendor_Types>;
};


/** columns and relationships of "vendor_types" */
export type Vendor_TypesVendors_Vendor_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Types_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "vendor_types". All fields are combined with a logical 'AND'. */
export type Vendor_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Types_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Types_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendors_vendor_types?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_types". */
export type Vendor_Types_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendors_vendor_types_aggregate?: InputMaybe<Vendors_Vendor_Types_Aggregate_Order_By>;
};

/** select columns of table "vendor_types" */
export enum Vendor_Types_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "vendor_types" */
export type Vendor_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Types_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "vendors" */
export type Vendors = {
  __typename: 'vendors';
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  insurance_expiration_date?: Maybe<Scalars['date']['output']>;
  insurance_policy_number?: Maybe<Scalars['String']['output']>;
  insurance_provider?: Maybe<Scalars['String']['output']>;
  internal_rating?: Maybe<Scalars['Int']['output']>;
  is_active: Scalars['Boolean']['output'];
  latchel_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  latchel_vendor_categories: Array<Latchel_Vendor_Categories>;
  /** An array relationship */
  latchel_vendor_users: Array<Latchel_Vendor_Users>;
  /** An object relationship */
  market?: Maybe<Markets>;
  market_id?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  scope_of_work_description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  ticket_vendor_assignments: Array<Ticket_Vendor_Assignments>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  vendor_markets: Array<Vendor_Markets>;
  /** An array relationship */
  vendors_vendor_tags: Array<Vendors_Vendor_Tags>;
  /** An array relationship */
  vendors_vendor_types: Array<Vendors_Vendor_Types>;
};


/** columns and relationships of "vendors" */
export type VendorsLatchel_Vendor_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Vendor_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Vendor_Categories_Order_By>>;
  where?: InputMaybe<Latchel_Vendor_Categories_Bool_Exp>;
};


/** columns and relationships of "vendors" */
export type VendorsLatchel_Vendor_UsersArgs = {
  distinct_on?: InputMaybe<Array<Latchel_Vendor_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Latchel_Vendor_Users_Order_By>>;
  where?: InputMaybe<Latchel_Vendor_Users_Bool_Exp>;
};


/** columns and relationships of "vendors" */
export type VendorsTicket_Vendor_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Vendor_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Vendor_Assignments_Order_By>>;
  where?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
};


/** columns and relationships of "vendors" */
export type VendorsVendor_MarketsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Markets_Order_By>>;
  where?: InputMaybe<Vendor_Markets_Bool_Exp>;
};


/** columns and relationships of "vendors" */
export type VendorsVendors_Vendor_TagsArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Tags_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
};


/** columns and relationships of "vendors" */
export type VendorsVendors_Vendor_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vendors_Vendor_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendors_Vendor_Types_Order_By>>;
  where?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "vendors". All fields are combined with a logical 'AND'. */
export type Vendors_Bool_Exp = {
  _and?: InputMaybe<Array<Vendors_Bool_Exp>>;
  _not?: InputMaybe<Vendors_Bool_Exp>;
  _or?: InputMaybe<Array<Vendors_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  insurance_policy_number?: InputMaybe<String_Comparison_Exp>;
  insurance_provider?: InputMaybe<String_Comparison_Exp>;
  internal_rating?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  latchel_id?: InputMaybe<Int_Comparison_Exp>;
  latchel_vendor_categories?: InputMaybe<Latchel_Vendor_Categories_Bool_Exp>;
  latchel_vendor_users?: InputMaybe<Latchel_Vendor_Users_Bool_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  scope_of_work_description?: InputMaybe<String_Comparison_Exp>;
  ticket_vendor_assignments?: InputMaybe<Ticket_Vendor_Assignments_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor_markets?: InputMaybe<Vendor_Markets_Bool_Exp>;
  vendors_vendor_tags?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
  vendors_vendor_types?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vendors" */
export type Vendors_Inc_Input = {
  internal_rating?: InputMaybe<Scalars['Int']['input']>;
  latchel_id?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "vendors" */
export type Vendors_Mutation_Response = {
  __typename: 'vendors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendors>;
};

/** Ordering options when selecting data from "vendors". */
export type Vendors_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_expiration_date?: InputMaybe<Order_By>;
  insurance_policy_number?: InputMaybe<Order_By>;
  insurance_provider?: InputMaybe<Order_By>;
  internal_rating?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  latchel_id?: InputMaybe<Order_By>;
  latchel_vendor_categories_aggregate?: InputMaybe<Latchel_Vendor_Categories_Aggregate_Order_By>;
  latchel_vendor_users_aggregate?: InputMaybe<Latchel_Vendor_Users_Aggregate_Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  scope_of_work_description?: InputMaybe<Order_By>;
  ticket_vendor_assignments_aggregate?: InputMaybe<Ticket_Vendor_Assignments_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_markets_aggregate?: InputMaybe<Vendor_Markets_Aggregate_Order_By>;
  vendors_vendor_tags_aggregate?: InputMaybe<Vendors_Vendor_Tags_Aggregate_Order_By>;
  vendors_vendor_types_aggregate?: InputMaybe<Vendors_Vendor_Types_Aggregate_Order_By>;
};

/** primary key columns input for table: vendors */
export type Vendors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendors" */
export enum Vendors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceExpirationDate = 'insurance_expiration_date',
  /** column name */
  InsurancePolicyNumber = 'insurance_policy_number',
  /** column name */
  InsuranceProvider = 'insurance_provider',
  /** column name */
  InternalRating = 'internal_rating',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LatchelId = 'latchel_id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ScopeOfWorkDescription = 'scope_of_work_description',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "vendors" */
export type Vendors_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expiration_date?: InputMaybe<Scalars['date']['input']>;
  insurance_policy_number?: InputMaybe<Scalars['String']['input']>;
  insurance_provider?: InputMaybe<Scalars['String']['input']>;
  internal_rating?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  latchel_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  scope_of_work_description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "vendors" */
export type Vendors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expiration_date?: InputMaybe<Scalars['date']['input']>;
  insurance_policy_number?: InputMaybe<Scalars['String']['input']>;
  insurance_provider?: InputMaybe<Scalars['String']['input']>;
  internal_rating?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  latchel_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  scope_of_work_description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Vendors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vendors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendors_Set_Input>;
  where: Vendors_Bool_Exp;
};

/** columns and relationships of "vendors_vendor_tags" */
export type Vendors_Vendor_Tags = {
  __typename: 'vendors_vendor_tags';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  removed_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor_tag: Vendor_Tags;
  vendor_tag_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendors_vendor_tags" */
export type Vendors_Vendor_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendors_Vendor_Tags_Max_Order_By>;
  min?: InputMaybe<Vendors_Vendor_Tags_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendors_vendor_tags". All fields are combined with a logical 'AND'. */
export type Vendors_Vendor_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Vendors_Vendor_Tags_Bool_Exp>>;
  _not?: InputMaybe<Vendors_Vendor_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Vendors_Vendor_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  removed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_tag?: InputMaybe<Vendor_Tags_Bool_Exp>;
  vendor_tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "vendors_vendor_tags" */
export type Vendors_Vendor_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  removed_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_tag_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendors_vendor_tags" */
export type Vendors_Vendor_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  removed_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_tag_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vendors_vendor_tags". */
export type Vendors_Vendor_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  removed_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_tag?: InputMaybe<Vendor_Tags_Order_By>;
  vendor_tag_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendors_vendor_tags" */
export enum Vendors_Vendor_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RemovedAt = 'removed_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  VendorTagId = 'vendor_tag_id'
}

/** Streaming cursor of the table "vendors_vendor_tags" */
export type Vendors_Vendor_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendors_Vendor_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendors_Vendor_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  removed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "vendors_vendor_types" */
export type Vendors_Vendor_Types = {
  __typename: 'vendors_vendor_types';
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor: Vendors;
  vendor_id: Scalars['uuid']['output'];
  /** An object relationship */
  vendor_type: Vendor_Types;
  vendor_type_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "vendors_vendor_types" */
export type Vendors_Vendor_Types_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendors_Vendor_Types_Max_Order_By>;
  min?: InputMaybe<Vendors_Vendor_Types_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "vendors_vendor_types". All fields are combined with a logical 'AND'. */
export type Vendors_Vendor_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Vendors_Vendor_Types_Bool_Exp>>;
  _not?: InputMaybe<Vendors_Vendor_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Vendors_Vendor_Types_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_type?: InputMaybe<Vendor_Types_Bool_Exp>;
  vendor_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "vendors_vendor_types" */
export type Vendors_Vendor_Types_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_type_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "vendors_vendor_types" */
export type Vendors_Vendor_Types_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_type_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vendors_vendor_types". */
export type Vendors_Vendor_Types_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_type?: InputMaybe<Vendor_Types_Order_By>;
  vendor_type_id?: InputMaybe<Order_By>;
};

/** select columns of table "vendors_vendor_types" */
export enum Vendors_Vendor_Types_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  VendorTypeId = 'vendor_type_id'
}

/** Streaming cursor of the table "vendors_vendor_types" */
export type Vendors_Vendor_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendors_Vendor_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendors_Vendor_Types_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "work_orders" */
export type Work_Orders = {
  __typename: 'work_orders';
  actual_completion_date?: Maybe<Scalars['date']['output']>;
  actual_cost?: Maybe<Scalars['numeric']['output']>;
  actual_start_date?: Maybe<Scalars['date']['output']>;
  bid_price?: Maybe<Scalars['numeric']['output']>;
  bid_url?: Maybe<Scalars['String']['output']>;
  buildium_task_id?: Maybe<Scalars['String']['output']>;
  buildium_task_number?: Maybe<Scalars['String']['output']>;
  cancelation_reason?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  chargeback_amount?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_admin_id: Scalars['uuid']['output'];
  date_scheduled_with_tenant2?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  follow_up_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  internally_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  is_paid?: Maybe<Scalars['Boolean']['output']>;
  issue_category1?: Maybe<Scalars['String']['output']>;
  issue_category2?: Maybe<Scalars['String']['output']>;
  issue_category3?: Maybe<Scalars['String']['output']>;
  not_to_exceed?: Maybe<Scalars['numeric']['output']>;
  owned_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  priority: Scalars['String']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  reference_number2?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  rental?: Maybe<Rentals>;
  rental_id?: Maybe<Scalars['uuid']['output']>;
  requester_id?: Maybe<Scalars['String']['output']>;
  requester_type: Scalars['String']['output'];
  resource_id?: Maybe<Scalars['String']['output']>;
  resource_type: Scalars['String']['output'];
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by_admin_id?: Maybe<Scalars['uuid']['output']>;
  skills_needed1?: Maybe<Scalars['String']['output']>;
  skills_needed2?: Maybe<Scalars['String']['output']>;
  skills_needed3?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vendor?: Maybe<Vendors>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
  vendor_resource_id?: Maybe<Scalars['String']['output']>;
  vendor_scheduled_for_date?: Maybe<Scalars['date']['output']>;
};

/** order by aggregate values of table "work_orders" */
export type Work_Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Work_Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Work_Orders_Max_Order_By>;
  min?: InputMaybe<Work_Orders_Min_Order_By>;
  stddev?: InputMaybe<Work_Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Work_Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Work_Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Work_Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Work_Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Work_Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Work_Orders_Variance_Order_By>;
};

/** order by avg() on columns of table "work_orders" */
export type Work_Orders_Avg_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "work_orders". All fields are combined with a logical 'AND'. */
export type Work_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Work_Orders_Bool_Exp>>;
  _not?: InputMaybe<Work_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Work_Orders_Bool_Exp>>;
  actual_completion_date?: InputMaybe<Date_Comparison_Exp>;
  actual_cost?: InputMaybe<Numeric_Comparison_Exp>;
  actual_start_date?: InputMaybe<Date_Comparison_Exp>;
  bid_price?: InputMaybe<Numeric_Comparison_Exp>;
  bid_url?: InputMaybe<String_Comparison_Exp>;
  buildium_task_id?: InputMaybe<String_Comparison_Exp>;
  buildium_task_number?: InputMaybe<String_Comparison_Exp>;
  cancelation_reason?: InputMaybe<String_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  chargeback_amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  date_scheduled_with_tenant2?: InputMaybe<Date_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  follow_up_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internally_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  issue_category1?: InputMaybe<String_Comparison_Exp>;
  issue_category2?: InputMaybe<String_Comparison_Exp>;
  issue_category3?: InputMaybe<String_Comparison_Exp>;
  not_to_exceed?: InputMaybe<Numeric_Comparison_Exp>;
  owned_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference_number2?: InputMaybe<Int_Comparison_Exp>;
  rental?: InputMaybe<Rentals_Bool_Exp>;
  rental_id?: InputMaybe<Uuid_Comparison_Exp>;
  requester_id?: InputMaybe<String_Comparison_Exp>;
  requester_type?: InputMaybe<String_Comparison_Exp>;
  resource_id?: InputMaybe<String_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  skills_needed1?: InputMaybe<String_Comparison_Exp>;
  skills_needed2?: InputMaybe<String_Comparison_Exp>;
  skills_needed3?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vendor?: InputMaybe<Vendors_Bool_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_resource_id?: InputMaybe<String_Comparison_Exp>;
  vendor_scheduled_for_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "work_orders" */
export type Work_Orders_Max_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_url?: InputMaybe<Order_By>;
  buildium_task_id?: InputMaybe<Order_By>;
  buildium_task_number?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  date_scheduled_with_tenant2?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  follow_up_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internally_requested_at?: InputMaybe<Order_By>;
  issue_category1?: InputMaybe<Order_By>;
  issue_category2?: InputMaybe<Order_By>;
  issue_category3?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  owned_by_admin_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  requester_type?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  skills_needed1?: InputMaybe<Order_By>;
  skills_needed2?: InputMaybe<Order_By>;
  skills_needed3?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_resource_id?: InputMaybe<Order_By>;
  vendor_scheduled_for_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "work_orders" */
export type Work_Orders_Min_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_url?: InputMaybe<Order_By>;
  buildium_task_id?: InputMaybe<Order_By>;
  buildium_task_number?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  date_scheduled_with_tenant2?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  follow_up_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internally_requested_at?: InputMaybe<Order_By>;
  issue_category1?: InputMaybe<Order_By>;
  issue_category2?: InputMaybe<Order_By>;
  issue_category3?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  owned_by_admin_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
  rental_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  requester_type?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  skills_needed1?: InputMaybe<Order_By>;
  skills_needed2?: InputMaybe<Order_By>;
  skills_needed3?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_resource_id?: InputMaybe<Order_By>;
  vendor_scheduled_for_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "work_orders". */
export type Work_Orders_Order_By = {
  actual_completion_date?: InputMaybe<Order_By>;
  actual_cost?: InputMaybe<Order_By>;
  actual_start_date?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  bid_url?: InputMaybe<Order_By>;
  buildium_task_id?: InputMaybe<Order_By>;
  buildium_task_number?: InputMaybe<Order_By>;
  cancelation_reason?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_admin_id?: InputMaybe<Order_By>;
  date_scheduled_with_tenant2?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  follow_up_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internally_requested_at?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  issue_category1?: InputMaybe<Order_By>;
  issue_category2?: InputMaybe<Order_By>;
  issue_category3?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  owned_by_admin_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
  rental?: InputMaybe<Rentals_Order_By>;
  rental_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  requester_type?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by_admin_id?: InputMaybe<Order_By>;
  skills_needed1?: InputMaybe<Order_By>;
  skills_needed2?: InputMaybe<Order_By>;
  skills_needed3?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendors_Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_resource_id?: InputMaybe<Order_By>;
  vendor_scheduled_for_date?: InputMaybe<Order_By>;
};

/** select columns of table "work_orders" */
export enum Work_Orders_Select_Column {
  /** column name */
  ActualCompletionDate = 'actual_completion_date',
  /** column name */
  ActualCost = 'actual_cost',
  /** column name */
  ActualStartDate = 'actual_start_date',
  /** column name */
  BidPrice = 'bid_price',
  /** column name */
  BidUrl = 'bid_url',
  /** column name */
  BuildiumTaskId = 'buildium_task_id',
  /** column name */
  BuildiumTaskNumber = 'buildium_task_number',
  /** column name */
  CancelationReason = 'cancelation_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  ChargebackAmount = 'chargeback_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByAdminId = 'created_by_admin_id',
  /** column name */
  DateScheduledWithTenant2 = 'date_scheduled_with_tenant2',
  /** column name */
  Description = 'description',
  /** column name */
  FollowUpDate = 'follow_up_date',
  /** column name */
  Id = 'id',
  /** column name */
  InternallyRequestedAt = 'internally_requested_at',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IssueCategory1 = 'issue_category1',
  /** column name */
  IssueCategory2 = 'issue_category2',
  /** column name */
  IssueCategory3 = 'issue_category3',
  /** column name */
  NotToExceed = 'not_to_exceed',
  /** column name */
  OwnedByAdminId = 'owned_by_admin_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  ReferenceNumber2 = 'reference_number2',
  /** column name */
  RentalId = 'rental_id',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  RequesterType = 'requester_type',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedByAdminId = 'reviewed_by_admin_id',
  /** column name */
  SkillsNeeded1 = 'skills_needed1',
  /** column name */
  SkillsNeeded2 = 'skills_needed2',
  /** column name */
  SkillsNeeded3 = 'skills_needed3',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VendorId = 'vendor_id',
  /** column name */
  VendorResourceId = 'vendor_resource_id',
  /** column name */
  VendorScheduledForDate = 'vendor_scheduled_for_date'
}

/** order by stddev() on columns of table "work_orders" */
export type Work_Orders_Stddev_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "work_orders" */
export type Work_Orders_Stddev_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "work_orders" */
export type Work_Orders_Stddev_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "work_orders" */
export type Work_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Work_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Work_Orders_Stream_Cursor_Value_Input = {
  actual_completion_date?: InputMaybe<Scalars['date']['input']>;
  actual_cost?: InputMaybe<Scalars['numeric']['input']>;
  actual_start_date?: InputMaybe<Scalars['date']['input']>;
  bid_price?: InputMaybe<Scalars['numeric']['input']>;
  bid_url?: InputMaybe<Scalars['String']['input']>;
  buildium_task_id?: InputMaybe<Scalars['String']['input']>;
  buildium_task_number?: InputMaybe<Scalars['String']['input']>;
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  chargeback_amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  date_scheduled_with_tenant2?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  follow_up_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internally_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  issue_category1?: InputMaybe<Scalars['String']['input']>;
  issue_category2?: InputMaybe<Scalars['String']['input']>;
  issue_category3?: InputMaybe<Scalars['String']['input']>;
  not_to_exceed?: InputMaybe<Scalars['numeric']['input']>;
  owned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_number2?: InputMaybe<Scalars['Int']['input']>;
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  requester_id?: InputMaybe<Scalars['String']['input']>;
  requester_type?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  skills_needed1?: InputMaybe<Scalars['String']['input']>;
  skills_needed2?: InputMaybe<Scalars['String']['input']>;
  skills_needed3?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_resource_id?: InputMaybe<Scalars['String']['input']>;
  vendor_scheduled_for_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by sum() on columns of table "work_orders" */
export type Work_Orders_Sum_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "work_orders" */
export type Work_Orders_Var_Pop_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "work_orders" */
export type Work_Orders_Var_Samp_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "work_orders" */
export type Work_Orders_Variance_Order_By = {
  actual_cost?: InputMaybe<Order_By>;
  bid_price?: InputMaybe<Order_By>;
  chargeback_amount?: InputMaybe<Order_By>;
  not_to_exceed?: InputMaybe<Order_By>;
  reference_number2?: InputMaybe<Order_By>;
};

export type AcquisitionDetailsByPropertyIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type AcquisitionDetailsByPropertyIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, closing_date?: any | null, type?: string | null, status: string, final_purchase_price?: any | null, final_sellers_credits_amount?: any | null, mls_listing: { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } }, opportunity?: { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> } | null, final_ic_opportunity_underwrite?: { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null } | null } | null } | null };

export type DocumentResourceIdsByPropertyIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type DocumentResourceIdsByPropertyIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any }, rentals: Array<{ __typename: 'rentals', id: any, construction_projects: Array<{ __typename: 'construction_projects', id: any }> }>, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, construction_projects: Array<{ __typename: 'construction_projects', id: any }> } | null, work_orders: Array<{ __typename: 'work_orders', id: any }> } | null, dispositions_portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, portfolio_home_disposition_bids: Array<{ __typename: 'dispositions_portfolio_home_disposition_bids', id: any }> }> };

export type EntityDetailsByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type EntityDetailsByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, llc_property_transfers: Array<{ __typename: 'llc_property_transfers', id: any, completed_at?: any | null }>, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, llc?: { __typename: 'llcs', id: any, name: string, fund_llcs: Array<{ __typename: 'fund_llcs', id: any, fund: { __typename: 'funds', id: any, name: string, abbreviation?: string | null } }> } | null } | null } | null };

export type LatchelPropertyIdByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type LatchelPropertyIdByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, latchel_property_id?: number | null } | null };

export type UpdateLatchelPropertyIdByPortfolioHomeIdMutationVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
  latchelPropertyId: Scalars['Int']['input'];
}>;


export type UpdateLatchelPropertyIdByPortfolioHomeIdMutation = { __typename: 'mutation_root', update_portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, latchel_property_id?: number | null } | null };

export type ListingPhotosByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type ListingPhotosByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, opportunity?: { __typename: 'opportunities', id: any, photos: Array<{ __typename: 'mls_listing_photos', created_at: any, display_order?: number | null, id: any, is_deleted?: boolean | null, updated_at: any, url: string }> } | null } | null } | null };

export type MarketingDetailsByPropertyIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type MarketingDetailsByPropertyIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, mls_listing: { __typename: 'mls_listings', id: any, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null, url?: string | null }>, active_underwrite: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null }> } } | null, listed_rents: Array<{ __typename: 'listed_rents', id: any, listed_rent: any, base_rent: any }> } | null };

export type ListedRentFragment = { __typename: 'portfolio_homes', listed_rents: Array<{ __typename: 'listed_rents', id: any, listed_rent: any, base_rent: any }> };

export type ActiveUnderwriteFragment = { __typename: 'mls_listings', active_underwrite: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null }> };

export type ActiveRentReadyDateFragment = { __typename: 'mls_listings', rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null }> };

export type GetPortfolioHomeWithFeaturesQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type GetPortfolioHomeWithFeaturesQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, community_id?: any | null, community?: { __typename: 'communities', id: any, name: string, community_features?: { __typename: 'community_features', id: any, community_id: any, hoa_contact_name?: string | null, hoa_contact_email?: string | null, amenity_fee?: any | null, amenity_details?: string | null, pool?: boolean | null, playground?: boolean | null, landscaping?: boolean | null, security?: boolean | null, dog_park?: boolean | null, nature?: string | null, created_at: any, updated_at: any } | null } | null, portfolio_home_internal_features?: { __typename: 'portfolio_home_internal_features', id: any, portfolio_home_id: any, washer_dryer?: boolean | null, basement?: boolean | null, warranties?: string | null, appliances?: string | null, utilities_exception?: string | null, created_at: any, updated_at: any } | null, portfolio_home_external_features?: { __typename: 'portfolio_home_external_features', id: any, portfolio_home_id: any, security: string, mailbox_info?: string | null, garage?: string | null, parking?: string | null, gate?: string | null, fence?: string | null, shed?: string | null, created_at: any, updated_at: any } | null } | null };

export type ResourceIdsByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type ResourceIdsByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, opportunities: Array<{ __typename: 'opportunities', id: any, real_estate_screenings: Array<{ __typename: 'real_estate_screenings', id: any }>, bids: Array<{ __typename: 'bids', id: any }> }> }, construction_walkthroughs: Array<{ __typename: 'construction_walkthroughs', id: any }>, rentals: Array<{ __typename: 'rentals', id: any, rental_application: { __typename: 'rental_applications', id: any, move_ins: Array<{ __typename: 'move_ins', id: any }> }, evictions: Array<{ __typename: 'evictions', id: any }>, construction_projects: Array<{ __typename: 'construction_projects', id: any, construction_scopes: Array<{ __typename: 'construction_scopes', id: any, construction_estimates: Array<{ __typename: 'construction_estimates', id: any }> }> }> }>, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, real_estate_screening?: { __typename: 'real_estate_screenings', id: any } | null, construction_projects: Array<{ __typename: 'construction_projects', id: any, construction_scopes: Array<{ __typename: 'construction_scopes', id: any, construction_estimates: Array<{ __typename: 'construction_estimates', id: any }> }> }> } | null, work_orders: Array<{ __typename: 'work_orders', id: any }> } | null };

export type ConstructionIdsFragment = { __typename: 'construction_projects', id: any, construction_scopes: Array<{ __typename: 'construction_scopes', id: any, construction_estimates: Array<{ __typename: 'construction_estimates', id: any }> }> };

export type UtilityTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type UtilityTypesQuery = { __typename: 'query_root', utility_types: Array<{ __typename: 'utility_types', id: any, name: string, liability_type: { __typename: 'liability_types', id: any, deactivated_at?: any | null, is_variable: boolean } }> };

export type UtilityDetailsByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type UtilityDetailsByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, conservice_property_id?: string | null, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null };

export type LockboxCodeDisplayDataFragment = { __typename: 'lockbox_codes', id: any, code: string, created_at: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } };

export type CreateNewLockboxCodeMutationVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
  code: Scalars['String']['input'];
}>;


export type CreateNewLockboxCodeMutation = { __typename: 'mutation_root', update_lockbox_codes?: { __typename: 'lockbox_codes_mutation_response', affected_rows: number } | null, insert_lockbox_codes_one?: { __typename: 'lockbox_codes', id: any, code: string, created_at: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } } | null };

export type ConstructionByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type ConstructionByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, construction_projects: Array<{ __typename: 'construction_projects', id: any, created_at: any, type: string, status: Construction_Construction_Project_Status_Enum_Enum, substatus?: string | null, tracking_status: string, start_date?: any | null, end_date?: any | null, estimated_cost?: any | null, actual_cost?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> } | null };

export type ConstructionProjectsFragment = { __typename: 'construction_projects', id: any, created_at: any, type: string, status: Construction_Construction_Project_Status_Enum_Enum, substatus?: string | null, tracking_status: string, start_date?: any | null, end_date?: any | null, estimated_cost?: any | null, actual_cost?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null };

export type PortfolioHomeSystemWorkOrdersByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type PortfolioHomeSystemWorkOrdersByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_home_system_work_orders: Array<{ __typename: 'portfolio_home_system_work_orders', id: any, system: string, type: string, under_warranty?: boolean | null, service_date: any, warranty_end_date?: any | null, notes?: string | null, portfolio_home: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', display_line_1?: string | null, display_line_2?: string | null } } }, vendor: { __typename: 'vendors', id: any, name: string } }> };

export type PortfolioHomeSystemWorkOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioHomeSystemWorkOrdersQuery = { __typename: 'query_root', portfolio_home_system_work_orders: Array<{ __typename: 'portfolio_home_system_work_orders', id: any, system: string, type: string, under_warranty?: boolean | null, service_date: any, warranty_end_date?: any | null, notes?: string | null, portfolio_home: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', display_line_1?: string | null, display_line_2?: string | null } } }, vendor: { __typename: 'vendors', id: any, name: string } }> };

export type RentalHistoryByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type RentalHistoryByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, rentals: Array<{ __typename: 'rentals', id: any, occupancy_date: any, status: string, move_out_date?: any | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, starts_at: any, rent: any }>, primary_rental_user: Array<{ __typename: 'rental_users', id: any, role: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, primary_phone: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }>, primary_email: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }> }> } | null };

export type PortfolioHomesRentalHistoryFragment = { __typename: 'portfolio_homes', id: any, rentals: Array<{ __typename: 'rentals', id: any, occupancy_date: any, status: string, move_out_date?: any | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, starts_at: any, rent: any }>, primary_rental_user: Array<{ __typename: 'rental_users', id: any, role: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, primary_phone: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }>, primary_email: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }> }> };

export type PrimaryRentalUserFragment = { __typename: 'rentals', primary_rental_user: Array<{ __typename: 'rental_users', id: any, role: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, primary_phone: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }>, primary_email: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }> };

export type PrimaryContactDetailsFragment = { __typename: 'users', primary_phone: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }>, primary_email: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> };

export type ActiveRentalAgreementHistoriesFragment = { __typename: 'rentals', rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, starts_at: any, rent: any }> };

export type WalkthroughsByPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type WalkthroughsByPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, construction_walkthroughs: Array<{ __typename: 'construction_walkthroughs', id: any, type: string, start_at?: any | null, status: string, external_source?: string | null, external_link?: string | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, note?: { __typename: 'notes', note: string } | null }>, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, construction_projects: Array<{ __typename: 'construction_projects', id: any, construction_scopes: Array<{ __typename: 'construction_scopes', id: any, construction_walkthroughs: Array<{ __typename: 'construction_walkthroughs', id: any, type: string, start_at?: any | null, status: string, external_source?: string | null, external_link?: string | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, note?: { __typename: 'notes', note: string } | null }> }> }> } | null } | null };

export type ConstructionWalkthroughsFragment = { __typename: 'construction_walkthroughs', id: any, type: string, start_at?: any | null, status: string, external_source?: string | null, external_link?: string | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, note?: { __typename: 'notes', note: string } | null };

export type WorkOrdersFromPortfolioHomeIdQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type WorkOrdersFromPortfolioHomeIdQuery = { __typename: 'query_root', portfolio_homes_by_pk?: { __typename: 'portfolio_homes', id: any, work_orders: Array<{ __typename: 'work_orders', id: any, created_at: any, actual_completion_date?: any | null, description?: string | null, status: string, type: string, priority: string, vendor_id?: any | null, bid_price?: any | null, vendor?: { __typename: 'vendors', id: any, name: string } | null }> } | null };

export type WorkOrdersHistoryFragment = { __typename: 'work_orders', id: any, created_at: any, actual_completion_date?: any | null, description?: string | null, status: string, type: string, priority: string, vendor_id?: any | null, bid_price?: any | null, vendor?: { __typename: 'vendors', id: any, name: string } | null };

export type Homes360HeaderOpportunityPhotosFragment = { __typename: 'opportunities', id: any, photos: Array<{ __typename: 'mls_listing_photos', id: any, url: string, display_order?: number | null }> };

export type LockboxCodeFragment = { __typename: 'portfolio_homes', id: any, active_lockbox_code: Array<{ __typename: 'lockbox_codes', id: any, code: string, created_at: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> };

export type Homes360HeaderFragment = { __typename: 'homes360', id?: any | null, city?: string | null, beds?: number | null, baths_total?: number | null, display_line_1?: string | null, display_line_2?: string | null, year_built?: number | null, sqft?: number | null, occupancy_status?: string | null, construction_status?: string | null, ownership_status?: string | null, summary_status?: string | null, market?: { __typename: 'markets', id: any, display_name: string } | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, rental_program_type: Rental_Program_Types_Enum_Enum, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', final_purchase_price?: any | null, closing_date?: any | null, opportunity?: { __typename: 'opportunities', id: any, photos: Array<{ __typename: 'mls_listing_photos', id: any, url: string, display_order?: number | null }> } | null } | null, down_status_incidents: Array<{ __typename: 'down_status_incidents', id: any, type: string, stage: string, created_at: any }>, active_lockbox_code: Array<{ __typename: 'lockbox_codes', id: any, code: string, created_at: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> } | null, opportunities: Array<{ __typename: 'opportunities', id: any, real_estate_acquisitions: Array<{ __typename: 'real_estate_acquisitions', id: any, final_purchase_price?: any | null, closing_date?: any | null }>, photos: Array<{ __typename: 'mls_listing_photos', id: any, url: string, display_order?: number | null }> }> };

export type AcquisitionInfoFragmentFragment = { __typename: 'real_estate_acquisitions', id: any, closing_date?: any | null, type?: string | null, status: string, final_purchase_price?: any | null, final_sellers_credits_amount?: any | null, mls_listing: { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } }, opportunity?: { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> } | null, final_ic_opportunity_underwrite?: { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null } | null };

export type OpportunityFragmentFragment = { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> };

export type MlsListingFragmentFragment = { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } };

export type UnderwriteInfoFragment = { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null };

export type PropertyInfoFragment = { __typename: 'properties', id: any, exit_date?: any | null, exit_price?: any | null, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, closing_date?: any | null, type?: string | null, status: string, final_purchase_price?: any | null, final_sellers_credits_amount?: any | null, mls_listing: { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } }, opportunity?: { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> } | null, final_ic_opportunity_underwrite?: { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null } | null } | null };

export type PortfolioHomeInfoFragment = { __typename: 'portfolio_homes', id: any, exit_date?: any | null, exit_price?: any | null, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, closing_date?: any | null, type?: string | null, status: string, final_purchase_price?: any | null, final_sellers_credits_amount?: any | null, mls_listing: { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } }, opportunity?: { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> } | null, final_ic_opportunity_underwrite?: { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null } | null } | null };

export type HomeByIdQueryVariables = Exact<{
  homeId: Scalars['uuid']['input'];
}>;


export type HomeByIdQuery = { __typename: 'query_root', homes360: Array<{ __typename: 'homes360', id?: any | null, display_line_1?: string | null, sqft?: number | null, city?: string | null, state?: string | null, zip?: string | null, beds?: number | null, year_built?: number | null, baths_total?: number | null, most_recent_rental_move_out_date?: any | null, occupancy_status?: string | null, construction_status?: string | null, ownership_status?: string | null, summary_status?: string | null, fund_name?: string | null, entity_name?: string | null, most_recent_rental_id?: any | null, tenant_first_name?: string | null, tenant_last_name?: string | null, display_line_2?: string | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, rental_program_type: Rental_Program_Types_Enum_Enum, exit_date?: any | null, exit_price?: any | null, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', final_purchase_price?: any | null, closing_date?: any | null, id: any, type?: string | null, status: string, final_sellers_credits_amount?: any | null, opportunity?: { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, photos: Array<{ __typename: 'mls_listing_photos', id: any, url: string, display_order?: number | null }>, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> } | null, mls_listing: { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } }, final_ic_opportunity_underwrite?: { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null } | null } | null, down_status_incidents: Array<{ __typename: 'down_status_incidents', id: any, type: string, stage: string, created_at: any }>, active_lockbox_code: Array<{ __typename: 'lockbox_codes', id: any, code: string, created_at: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> } | null, market?: { __typename: 'markets', id: any, display_name: string } | null, opportunities: Array<{ __typename: 'opportunities', id: any, real_estate_acquisitions: Array<{ __typename: 'real_estate_acquisitions', id: any, final_purchase_price?: any | null, closing_date?: any | null }>, photos: Array<{ __typename: 'mls_listing_photos', id: any, url: string, display_order?: number | null }> }> }> };

export type HomesGridQueryVariables = Exact<{ [key: string]: never; }>;


export type HomesGridQuery = { __typename: 'query_root', homes_list: Array<{ __typename: 'homes360', id?: any | null, display_line_1?: string | null, sqft?: number | null, city?: string | null, state?: string | null, zip?: string | null, beds?: number | null, year_built?: number | null, baths_total?: number | null, most_recent_rental_move_out_date?: any | null, occupancy_status?: string | null, construction_status?: string | null, ownership_status?: string | null, summary_status?: string | null, fund_name?: string | null, entity_name?: string | null, most_recent_rental_id?: any | null, tenant_first_name?: string | null, tenant_last_name?: string | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, rental_program_type: Rental_Program_Types_Enum_Enum, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', id: any, closing_date?: any | null, type?: string | null, status: string, final_purchase_price?: any | null, final_sellers_credits_amount?: any | null, opportunity?: { __typename: 'opportunities', id: any, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }> } | null, mls_listing: { __typename: 'mls_listings', id: any, area?: string | null, baths_total?: number | null, beds?: number | null, city?: string | null, display_line_1?: string | null, firestore_id: any, listing_date?: any | null, list_price?: any | null, mls: string, provider?: string | null, size?: string | null, state?: string | null, year_built?: number | null, zip?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }>, opportunity_underwrites: Array<{ __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null }>, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null, type: string }>, market: { __typename: 'markets', id: any, display_name: string } }, final_ic_opportunity_underwrite?: { __typename: 'underwrites_opportunity_underwrites', id: any, target_rent?: any | null, target_cap_rate?: any | null, upfront_improvements_cost?: any | null, sellers_credits?: any | null } | null } | null, down_status_incidents: Array<{ __typename: 'down_status_incidents', id: any, type: string, stage: string, created_at: any }>, active_lockbox_code: Array<{ __typename: 'lockbox_codes', id: any, code: string, created_at: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> } | null, market?: { __typename: 'markets', id: any, display_name: string } | null }> };

export type Homes360FragmentFragment = { __typename: 'homes360', id?: any | null, display_line_1?: string | null, sqft?: number | null, city?: string | null, state?: string | null, zip?: string | null, beds?: number | null, year_built?: number | null, baths_total?: number | null, most_recent_rental_move_out_date?: any | null, occupancy_status?: string | null, construction_status?: string | null, ownership_status?: string | null, summary_status?: string | null, fund_name?: string | null, entity_name?: string | null, most_recent_rental_id?: any | null, tenant_first_name?: string | null, tenant_last_name?: string | null, market?: { __typename: 'markets', id: any, display_name: string } | null };

export type UpupLeadGroupsUserListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Lead_Groups_Bool_Exp>;
}>;


export type UpupLeadGroupsUserListQuery = { __typename: 'query_root', lead_groups: Array<{ __typename: 'lead_groups', id: any, created_at?: any | null, status: string, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, type: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_type: string, contact_info: string }> } }> }> };

export type UpupGenericNotesQueryVariables = Exact<{
  where?: InputMaybe<Notes_Bool_Exp>;
  created_at?: InputMaybe<Order_By>;
}>;


export type UpupGenericNotesQuery = { __typename: 'query_root', notes: Array<{ __typename: 'notes', id: any, category?: string | null, created_at: any, note: string, resource_type: string, resource_id: any, subject_id?: any | null, subject_type?: string | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, documents: Array<{ __typename: 'documents', id: any, external_id: string, external_source: string, friendly_name: string }> }> };

export type DeactivateSaferentRequestMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type DeactivateSaferentRequestMutation = { __typename: 'mutation_root', update_saferent_requests_by_pk?: { __typename: 'saferent_requests', id: any, deactivated_at?: any | null } | null };

export type OverrideIncomeSourceAnnualIncomeMutationVariables = Exact<{
  userIncomeSourceId: Scalars['uuid']['input'];
  annualIncome: Scalars['numeric']['input'];
  now: Scalars['timestamptz']['input'];
  adminId: Scalars['uuid']['input'];
}>;


export type OverrideIncomeSourceAnnualIncomeMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_income_sources_by_pk?: { __typename: 'applicant_income_underwrites_user_income_sources', id: any, source_annual_income: any } | null };

export type SetEmploymentVerificationStatusMutationVariables = Exact<{
  userIncomeSourceId: Scalars['uuid']['input'];
  employmentVerificationStatus: Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum;
  now: Scalars['timestamptz']['input'];
  adminId: Scalars['uuid']['input'];
}>;


export type SetEmploymentVerificationStatusMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_income_sources_employed?: { __typename: 'applicant_income_underwrites_user_income_sources_employed_mutation_response', returning: Array<{ __typename: 'applicant_income_underwrites_user_income_sources_employed', id: any, employment_verification_status: Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum }> } | null };

export type UpdateIncomeSourceContactNameMutationVariables = Exact<{
  userIncomeSourceId: Scalars['uuid']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateIncomeSourceContactNameMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_income_sources_employed?: { __typename: 'applicant_income_underwrites_user_income_sources_employed_mutation_response', affected_rows: number } | null };

export type UpdateIncomeSourceContactTitleMutationVariables = Exact<{
  userIncomeSourceId: Scalars['uuid']['input'];
  contactTitle?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateIncomeSourceContactTitleMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_income_sources_employed?: { __typename: 'applicant_income_underwrites_user_income_sources_employed_mutation_response', affected_rows: number } | null };

export type UpdateIncomeSourceContactPhoneMutationVariables = Exact<{
  userIncomeSourceId: Scalars['uuid']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateIncomeSourceContactPhoneMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_income_sources_employed?: { __typename: 'applicant_income_underwrites_user_income_sources_employed_mutation_response', affected_rows: number } | null };

export type UpdateIncomeSourceContactEmailMutationVariables = Exact<{
  userIncomeSourceId: Scalars['uuid']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateIncomeSourceContactEmailMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_income_sources_employed?: { __typename: 'applicant_income_underwrites_user_income_sources_employed_mutation_response', affected_rows: number } | null };

export type OverrideUserIncomeAmountMutationVariables = Exact<{
  userIncomeId: Scalars['uuid']['input'];
  amount: Scalars['numeric']['input'];
}>;


export type OverrideUserIncomeAmountMutation = { __typename: 'mutation_root', update_applicant_income_underwrites_user_incomes_by_pk?: { __typename: 'applicant_income_underwrites_user_incomes', id: any, annual_income: any } | null };

export type UpupRentalApplicationByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpupRentalApplicationByIdQuery = { __typename: 'query_root', rental_applications_by_pk?: { __typename: 'rental_applications', id: any, status: string, status_metadata: any, created_at: any, priority_score: number, projected_occupancy_date?: any | null, rent?: any | null, rental_program_type_applied_for: Rental_Program_Types_Enum_Enum, mls_listing: { __typename: 'mls_listings', id: any, display_line_1?: string | null, zip?: string | null, state?: string | null, city?: string | null, region?: string | null, rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null }> }, lead_group: { __typename: 'lead_groups', id: any, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, type: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, close_lead_id?: string | null } }>, agent_lead_group_owners: Array<{ __typename: 'agent_lead_group_owners', id: any, agent_type: Agent_Lead_Group_Owners_Agent_Type_Enum_Enum, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> }, application_escalations: Array<{ __typename: 'rental_application_manager_application_escalations', id: any, reason: string, created_at: any, assigned_to_admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, assigned_by_admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }>, application_snoozes: Array<{ __typename: 'rental_application_manager_application_snoozes', id: any, snoozed_until: any, snoozed_by_admin_id: any, snooze_reason: Rental_Application_Manager_Snooze_Reasons_Enum, rental_application_id: any }> } | null };

export type UpupRentalApplicationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By> | Rental_Applications_Order_By>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
}>;


export type UpupRentalApplicationsQuery = { __typename: 'query_root', rental_applications: Array<{ __typename: 'rental_applications', id: any, status: string, created_at: any, priority_score: number, projected_occupancy_date?: any | null, required_coapplicant_at?: any | null, required_cosigner_at?: any | null, rental_program_type_applied_for: Rental_Program_Types_Enum_Enum, mls_listing: { __typename: 'mls_listings', id: any, display_line_1?: string | null, region?: string | null, opportunity?: { __typename: 'opportunities', id: any, home?: { __typename: 'homes', id: any, portfolio_homes: Array<{ __typename: 'portfolio_homes', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, llc?: { __typename: 'llcs', id: any, fund_llcs: Array<{ __typename: 'fund_llcs', id: any, fund: { __typename: 'funds', id: any, abbreviation?: string | null, name: string } }> } | null } | null }> } | null } | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }> }, lead_group: { __typename: 'lead_groups', id: any, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, type: string, rental_application_submitted_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, credit_reports: Array<{ __typename: 'credit_reports', id: any, status: string, score_status?: string | null, score?: number | null }>, eviction_reports: Array<{ __typename: 'eviction_reports', id: any }>, criminal_reports: Array<{ __typename: 'criminal_reports', id: any }> } }> }, application_escalations: Array<{ __typename: 'rental_application_manager_application_escalations', id: any, reason: string, created_at: any, assigned_to_admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, assigned_by_admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }>, application_snoozes: Array<{ __typename: 'rental_application_manager_application_snoozes', id: any, snoozed_until: any, snoozed_by_admin_id: any, snooze_reason: Rental_Application_Manager_Snooze_Reasons_Enum, rental_application_id: any }> }> };

export type FindDocumentsByResourceIdsQueryVariables = Exact<{
  resourceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type FindDocumentsByResourceIdsQuery = { __typename: 'query_root', documents: Array<{ __typename: 'documents', id: any, resource_id: any, resource_type: string, created_at: any, status: string, external_source: string, external_id: string, friendly_name: string, type: string, reviewed_at?: any | null, review_notes?: string | null, uploaded_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, reviewed_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> };

export type FindNotesByResourceIdsQueryVariables = Exact<{
  resourceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type FindNotesByResourceIdsQuery = { __typename: 'query_root', notes: Array<{ __typename: 'notes', id: any, resource_id: any, resource_type: string, note: string, created_at: any, priority: Note_Priorities_Enum, category?: string | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> };

export type UpdateNotePriorityByNoteIdMutationVariables = Exact<{
  noteId: Scalars['uuid']['input'];
  priority?: InputMaybe<Note_Priorities_Enum>;
}>;


export type UpdateNotePriorityByNoteIdMutation = { __typename: 'mutation_root', update_notes_by_pk?: { __typename: 'notes', id: any, priority: Note_Priorities_Enum } | null };

export type UpupAdminsWithCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type UpupAdminsWithCapabilitiesQuery = { __typename: 'query_root', admins: Array<{ __typename: 'admins', id: any, first_name: string, last_name: string, email: string, admin_capabilities: Array<{ __typename: 'admin_capabilities', id: any, capability: { __typename: 'capabilities', id: any, name: string, type: string, description?: string | null } }> }> };

export type UpupAdminsWithCapabilitiesByCapabilityTypeQueryVariables = Exact<{
  capability_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpupAdminsWithCapabilitiesByCapabilityTypeQuery = { __typename: 'query_root', admins: Array<{ __typename: 'admins', id: any, first_name: string, last_name: string, email: string, admin_capabilities: Array<{ __typename: 'admin_capabilities', id: any, capability: { __typename: 'capabilities', id: any, name: string, type: string, description?: string | null } }> }> };

export type ApplicationBuildiumLeaseSyncSubscriptionVariables = Exact<{
  rentalApplicationId: Scalars['uuid']['input'];
}>;


export type ApplicationBuildiumLeaseSyncSubscription = { __typename: 'subscription_root', rental_applications_by_pk?: { __typename: 'rental_applications', id: any, agreements: Array<{ __typename: 'agreements', id: any, created_at: any, buildium_lease_id?: number | null, updated_at: any }> } | null };

export type UpupApplicationListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rental_Applications_Order_By> | Rental_Applications_Order_By>;
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
}>;


export type UpupApplicationListQuery = { __typename: 'query_root', rental_applications: Array<{ __typename: 'rental_applications', id: any, created_at: any, projected_occupancy_date?: any | null, status: string, agreements: Array<{ __typename: 'agreements', id: any, status: string, metadata: any }>, lead_group: { __typename: 'lead_groups', id: any, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, type: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }> }, mls_listing: { __typename: 'mls_listings', id: any, display_line_1?: string | null, region?: string | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', id: any, internal_status?: string | null }> } }> };

export type ApplicationListQueryVariables = Exact<{
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
}>;


export type ApplicationListQuery = { __typename: 'query_root', rental_applications: Array<{ __typename: 'rental_applications', id: any }> };

export type UpupApplicationUserQualQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpupApplicationUserQualQuery = { __typename: 'query_root', getUserQualificationData?: { __typename: 'UserQualificationData', status?: string | null } | null };

export type UpupApplicationMlsListingsByAddressQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpupApplicationMlsListingsByAddressQuery = { __typename: 'query_root', mls_listings: Array<{ __typename: 'mls_listings', baths_weighted?: any | null, beds?: number | null, display_line_1?: string | null, display_line_2?: string | null, firestore_id: any, id: any, list_price?: any | null, opportunity?: { __typename: 'opportunities', id: any, current_rent: Array<{ __typename: 'listed_rents', id: any, listed_rent: any, base_rent: any }> } | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }>, photos: Array<{ __typename: 'mls_listing_photos', url: string }> }> };

export type GetBackgroundCheckRequestByTypeQueryVariables = Exact<{
  reportType: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetBackgroundCheckRequestByTypeQuery = { __typename: 'query_root', background_check_requests: Array<{ __typename: 'background_check_requests', id: any, user_id: any, type: string, resource_type?: string | null, resource_id?: any | null, request_id: any, status: string, error_message?: string | null, completed_at?: any | null, created_at: any, updated_at: any, initiated_by_admin_id?: any | null, invalidated_by_admin_id?: any | null, invalidated_at?: any | null }> };

export type UpupCapabilitiesWithAdminQueryVariables = Exact<{
  where?: InputMaybe<Capabilities_Bool_Exp>;
}>;


export type UpupCapabilitiesWithAdminQuery = { __typename: 'query_root', capabilities: Array<{ __typename: 'capabilities', id: any, name: string, type: string, description?: string | null, admin_capabilities: Array<{ __typename: 'admin_capabilities', id: any, admin: { __typename: 'admins', id: any, first_name: string, last_name: string, email: string } }> }> };

export type CashoutDetailsFragment = { __typename: 'rentals', lease_end_reason?: string | null, rental_program_type: Rental_Program_Types_Enum_Enum, id: any, move_out_date?: any | null, tenant_notice_given_on_date?: any | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, starts_at: any, ends_at: any }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } } } | null, primary_rental_user: Array<{ __typename: 'rental_users', id: any, role: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, primary_phone: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }>, primary_email: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null };

export type GetRentalCashoutDetailsQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type GetRentalCashoutDetailsQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', lease_end_reason?: string | null, rental_program_type: Rental_Program_Types_Enum_Enum, id: any, move_out_date?: any | null, tenant_notice_given_on_date?: any | null, status: string, buildium_lease_id?: number | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, starts_at: any, ends_at: any }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } } } | null, primary_rental_user: Array<{ __typename: 'rental_users', id: any, role: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, primary_phone: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }>, primary_email: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', id: any, rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }>, document_agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }> }, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }>, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> } | null, unallocated_credits: Array<{ __typename: 'unallocated_credits', amount_remaining?: any | null, rental_id?: any | null, date?: any | null, id?: any | null, liability_type?: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } | null, credit?: { __typename: 'rental_credits', id: any, note: string } | null }>, unallocated_payments: Array<{ __typename: 'unallocated_payments', amount_remaining?: any | null, rental_id?: any | null, id?: any | null, date?: any | null, liability_type?: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } | null, payment?: { __typename: 'payments', id: any, note?: string | null } | null }>, unpaid_liabilities: Array<{ __typename: 'unpaid_liabilities', amount_remaining?: any | null, rental_id?: any | null, date?: any | null, id?: any | null, liability_type?: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } | null, liability?: { __typename: 'rental_liabilities', id: any, note?: string | null, cashouts_pending_liabilities: Array<{ __typename: 'cashouts_pending_liabilities', id: any, rental_liability_id?: any | null }> } | null }> };

export type GetCashoutPendingLiabilitiesLedgerAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCashoutPendingLiabilitiesLedgerAccountsQuery = { __typename: 'query_root', ledger_accounts: Array<{ __typename: 'ledger_accounts', id: any, name: string, ledger_account_categories: Array<{ __typename: 'ledger_account_categories', id: any, category: string }> }> };

export type CreateCashoutPendingLiabilityMutationVariables = Exact<{
  cashoutId: Scalars['uuid']['input'];
  liabilityTypeId: Scalars['uuid']['input'];
  ledgerAccountId: Scalars['uuid']['input'];
  amount: Scalars['numeric']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCashoutPendingLiabilityMutation = { __typename: 'mutation_root', insert_cashouts_pending_liabilities_one?: { __typename: 'cashouts_pending_liabilities', id: any, amount: any, description?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string }, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null };

export type DeleteCashoutPendingLiabilityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCashoutPendingLiabilityMutation = { __typename: 'mutation_root', delete_cashouts_pending_liabilities_by_pk?: { __typename: 'cashouts_pending_liabilities', id: any, amount: any, description?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string } } | null };

export type CashoutSidebarFragment = { __typename: 'rentals', id: any, rental_program_type: Rental_Program_Types_Enum_Enum, status: string, buildium_lease_id?: number | null, move_out_date?: any | null, tenant_notice_given_on_date?: any | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } } } | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', id: any, rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }>, document_agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }> }, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null, agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }>, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> };

export type CashoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type CashoutsQuery = { __typename: 'query_root', cashouts: Array<{ __typename: 'cashouts', id: any, created_at: any, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_at?: any | null, clawback_amount?: any | null, total_investment_amount?: any | null, wallet_fee_amount?: any | null, write_off_amount?: any | null, status: any, rental: { __typename: 'rentals', id: any, move_out_date?: any | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, display_line_1?: string | null, display_line_2?: string | null } } } | null }, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }> };

export type ArchiveUserMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  archiveReason: Scalars['String']['input'];
  archivedByAdminId: Scalars['uuid']['input'];
}>;


export type ArchiveUserMutation = { __typename: 'mutation_root', update_user_funnel_statuses?: { __typename: 'user_funnel_statuses_mutation_response', affected_rows: number } | null };

export type CustomerHeaderInfoByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CustomerHeaderInfoByUserIdQuery = { __typename: 'query_root', users: Array<{ __typename: 'users', id: any, close_lead_id?: string | null, created_at?: any | null, deleted_at?: any | null, rental_users: Array<{ __typename: 'rental_users', id: any }>, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, lead_group_id: any, rental_applications: Array<{ __typename: 'rental_applications', id: any }> }>, user_prequalification_data?: { __typename: 'user_prequalification_data', id: any } | null, user_funnel_status?: { __typename: 'user_funnel_statuses', id: any, lead_status?: string | null, archived_at?: any | null } | null }> };

export type InvalidateSuccessfulUserIdentityVerificationsMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  invalidatedByAdminId: Scalars['uuid']['input'];
}>;


export type InvalidateSuccessfulUserIdentityVerificationsMutation = { __typename: 'mutation_root', update_user_identity_verifications_many?: Array<{ __typename: 'user_identity_verifications_mutation_response', affected_rows: number } | null> | null };

export type MostRelevantUserIdentityVerificationByUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type MostRelevantUserIdentityVerificationByUserQuery = { __typename: 'query_root', most_relevant_user_identity_verification_by_user: Array<{ __typename: 'most_relevant_user_identity_verification_by_user', id?: any | null, user_id?: any | null, stripe_session_id?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null, completed_at?: any | null, invalidated_at?: any | null, failure_message?: string | null, failure_code?: string | null, verified_as_first_name?: string | null, verified_as_last_name?: string | null, invalidated_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> };

export type PersonalDetailsByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PersonalDetailsByUserIdQuery = { __typename: 'query_root', users: Array<{ __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, emails: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, is_primary_for_contact_type: boolean }>, phones: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, is_primary_for_contact_type: boolean }>, user_funnel_status?: { __typename: 'user_funnel_statuses', id: any, lead_status?: string | null, archived_at?: any | null } | null, credit_reports: Array<{ __typename: 'credit_reports', id: any, score?: number | null }> }> };

export type RentalApplicationFeesByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type RentalApplicationFeesByUserIdQuery = { __typename: 'query_root', rental_application_fees: Array<{ __typename: 'rental_application_fees', id: any, user_id: any, created_at: any, updated_at: any, expected_amount: any, amount_paid: any, payment_date?: any | null, stripe_payment_intent_id?: string | null, stripe_payment_intent_status?: string | null }> };

export type ResetUserIdentityVerificationAttemptsMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  invalidatedByAdminId: Scalars['uuid']['input'];
  oneDayAgo: Scalars['timestamptz']['input'];
}>;


export type ResetUserIdentityVerificationAttemptsMutation = { __typename: 'mutation_root', update_user_identity_verifications_many?: Array<{ __typename: 'user_identity_verifications_mutation_response', affected_rows: number } | null> | null };

export type UpupDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpupDashboardsQuery = { __typename: 'query_root', dashboards: Array<{ __typename: 'dashboards', id: any, category: string, name: string, description: string, url: string, icon?: string | null, status: string }> };

export type UpupDeleteDashboardMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpupDeleteDashboardMutation = { __typename: 'mutation_root', update_dashboards_by_pk?: { __typename: 'dashboards', id: any } | null };

export type UpupDeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['uuid']['input'];
}>;


export type UpupDeleteDocumentMutation = { __typename: 'mutation_root', delete_documents_by_pk?: { __typename: 'documents', id: any } | null };

export type UpupDocumentsByResourceQueryVariables = Exact<{
  resourceId: Scalars['uuid']['input'];
  resourceType: Scalars['String']['input'];
}>;


export type UpupDocumentsByResourceQuery = { __typename: 'query_root', documents: Array<{ __typename: 'documents', id: any, status: string, friendly_name: string, created_at: any, type: string, resource_id: any, resource_notes?: string | null, resource_type: string, uploaded_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> };

export type DocumentsByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DocumentsByUserIdQuery = { __typename: 'query_root', documents: Array<{ __typename: 'documents', id: any, friendly_name: string, status: string, created_at: any, reviewed_at?: any | null, reviewed_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> };

export type UpupDocumentRealEstateAcquisitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpupDocumentRealEstateAcquisitionsQuery = { __typename: 'query_root', real_estate_acquisitions: Array<{ __typename: 'real_estate_acquisitions', id: any, status: string, closing_date?: any | null, mls_listing: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null } }> };

export type GeneralContractorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralContractorsQuery = { __typename: 'query_root', construction_general_contractors: Array<{ __typename: 'construction_general_contractors', id: any, name: string }> };

export type MlsSellerAgentDataFragment = { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null };

export type MlsListingDataFragment = { __typename: 'mls_listings', area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, beds?: number | null, city?: string | null, co_listing_office_id?: any | null, county?: string | null, created_at: any, delivery_line?: string | null, description?: string | null, display_line_1?: string | null, display_line_2?: string | null, features_amenities?: any | null, features_appliances_and_equipment?: any | null, features_bathrooms?: any | null, features_bedrooms?: any | null, features_community?: any | null, features_cooling?: any | null, features_dining_room?: any | null, features_disclosures?: any | null, features_doors?: any | null, features_energy_saving?: any | null, features_exterior_features?: any | null, features_fees?: any | null, features_fence?: any | null, features_fireplaces?: any | null, features_foundation?: any | null, features_garage?: any | null, features_heating?: any | null, features_home_owners_association?: any | null, features_house?: any | null, features_interior?: any | null, features_interior_features?: any | null, features_kitchen?: any | null, features_laundry?: any | null, features_listing?: any | null, features_location?: any | null, features_lot?: any | null, features_miscellaneous?: any | null, features_parking?: any | null, features_pool?: any | null, features_property?: any | null, features_property_access?: any | null, features_roof?: any | null, features_schools?: any | null, features_security_system?: any | null, features_sewer?: any | null, features_spa?: any | null, features_taxes?: any | null, features_utilities?: any | null, features_water?: any | null, features_windows_and_doors?: any | null, geo_type?: string | null, id: any, firestore_id: any, is_new_construction?: boolean | null, last_updated_at?: any | null, lat?: number | null, list_price?: any | null, listing_date?: any | null, listing_office_id?: any | null, listing_type?: string | null, lng?: number | null, lotsize_acres?: number | null, lotsize_sqft?: any | null, market_id: any, mls: string, modified_at?: any | null, property_type?: string | null, provider_id?: string | null, provider?: string | null, region?: string | null, school_district?: string | null, school_elementary?: string | null, school_high?: string | null, school_middle?: string | null, short_id: string, size?: string | null, state?: string | null, status?: string | null, std_address?: any | null, street?: string | null, style?: string | null, subdivision?: string | null, system_id?: string | null, tour_url?: string | null, updated_at: any, xf_attributes?: any | null, year_built?: number | null, zip?: string | null, co_listing_agent?: { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null } | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', analyzed_images?: any | null, census_tract_county_code?: string | null, census_tract_income_level?: string | null, census_tract_median_family_income?: number | null, census_tract_percent_below_poverty_line?: number | null, census_tract_tract_code?: string | null, created_at: any, guidance_price?: any | null, id: any, internal_status?: string | null, is_census_tract_opportunity_zone?: boolean | null, is_in_customer_buy_box: boolean, is_in_real_estate_buy_box: boolean, is_persisted_in_algolia: boolean, mls_listing_id: any, neighborhood_levels?: any | null, percent_over_comp?: number | null, rating_base?: number | null, short_list_images?: any | null, tags?: any | null, updated_at: any, url?: string | null, zillow_deep_search_results?: any | null }>, opportunity?: { __typename: 'opportunities', id: any, current_rent: Array<{ __typename: 'listed_rents', id: any, listed_rent: any, base_rent: any }> } | null, listing_agent?: { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null } | null, photos: Array<{ __typename: 'mls_listing_photos', created_at: any, display_order?: number | null, id: any, is_deleted?: boolean | null, updated_at: any, url: string }> };

export type UpUpMlsListingByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpUpMlsListingByIdQuery = { __typename: 'query_root', mls_listing?: { __typename: 'mls_listings', area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, beds?: number | null, city?: string | null, co_listing_office_id?: any | null, county?: string | null, created_at: any, delivery_line?: string | null, description?: string | null, display_line_1?: string | null, display_line_2?: string | null, features_amenities?: any | null, features_appliances_and_equipment?: any | null, features_bathrooms?: any | null, features_bedrooms?: any | null, features_community?: any | null, features_cooling?: any | null, features_dining_room?: any | null, features_disclosures?: any | null, features_doors?: any | null, features_energy_saving?: any | null, features_exterior_features?: any | null, features_fees?: any | null, features_fence?: any | null, features_fireplaces?: any | null, features_foundation?: any | null, features_garage?: any | null, features_heating?: any | null, features_home_owners_association?: any | null, features_house?: any | null, features_interior?: any | null, features_interior_features?: any | null, features_kitchen?: any | null, features_laundry?: any | null, features_listing?: any | null, features_location?: any | null, features_lot?: any | null, features_miscellaneous?: any | null, features_parking?: any | null, features_pool?: any | null, features_property?: any | null, features_property_access?: any | null, features_roof?: any | null, features_schools?: any | null, features_security_system?: any | null, features_sewer?: any | null, features_spa?: any | null, features_taxes?: any | null, features_utilities?: any | null, features_water?: any | null, features_windows_and_doors?: any | null, geo_type?: string | null, id: any, firestore_id: any, is_new_construction?: boolean | null, last_updated_at?: any | null, lat?: number | null, list_price?: any | null, listing_date?: any | null, listing_office_id?: any | null, listing_type?: string | null, lng?: number | null, lotsize_acres?: number | null, lotsize_sqft?: any | null, market_id: any, mls: string, modified_at?: any | null, property_type?: string | null, provider_id?: string | null, provider?: string | null, region?: string | null, school_district?: string | null, school_elementary?: string | null, school_high?: string | null, school_middle?: string | null, short_id: string, size?: string | null, state?: string | null, status?: string | null, std_address?: any | null, street?: string | null, style?: string | null, subdivision?: string | null, system_id?: string | null, tour_url?: string | null, updated_at: any, xf_attributes?: any | null, year_built?: number | null, zip?: string | null, co_listing_agent?: { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null } | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', analyzed_images?: any | null, census_tract_county_code?: string | null, census_tract_income_level?: string | null, census_tract_median_family_income?: number | null, census_tract_percent_below_poverty_line?: number | null, census_tract_tract_code?: string | null, created_at: any, guidance_price?: any | null, id: any, internal_status?: string | null, is_census_tract_opportunity_zone?: boolean | null, is_in_customer_buy_box: boolean, is_in_real_estate_buy_box: boolean, is_persisted_in_algolia: boolean, mls_listing_id: any, neighborhood_levels?: any | null, percent_over_comp?: number | null, rating_base?: number | null, short_list_images?: any | null, tags?: any | null, updated_at: any, url?: string | null, zillow_deep_search_results?: any | null }>, opportunity?: { __typename: 'opportunities', id: any, current_rent: Array<{ __typename: 'listed_rents', id: any, listed_rent: any, base_rent: any }> } | null, listing_agent?: { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null } | null, photos: Array<{ __typename: 'mls_listing_photos', created_at: any, display_order?: number | null, id: any, is_deleted?: boolean | null, updated_at: any, url: string }> } | null };

export type UpupMlsListingsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type UpupMlsListingsByIdsQuery = { __typename: 'query_root', mls_listings: Array<{ __typename: 'mls_listings', area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, beds?: number | null, city?: string | null, co_listing_office_id?: any | null, county?: string | null, created_at: any, delivery_line?: string | null, description?: string | null, display_line_1?: string | null, display_line_2?: string | null, features_amenities?: any | null, features_appliances_and_equipment?: any | null, features_bathrooms?: any | null, features_bedrooms?: any | null, features_community?: any | null, features_cooling?: any | null, features_dining_room?: any | null, features_disclosures?: any | null, features_doors?: any | null, features_energy_saving?: any | null, features_exterior_features?: any | null, features_fees?: any | null, features_fence?: any | null, features_fireplaces?: any | null, features_foundation?: any | null, features_garage?: any | null, features_heating?: any | null, features_home_owners_association?: any | null, features_house?: any | null, features_interior?: any | null, features_interior_features?: any | null, features_kitchen?: any | null, features_laundry?: any | null, features_listing?: any | null, features_location?: any | null, features_lot?: any | null, features_miscellaneous?: any | null, features_parking?: any | null, features_pool?: any | null, features_property?: any | null, features_property_access?: any | null, features_roof?: any | null, features_schools?: any | null, features_security_system?: any | null, features_sewer?: any | null, features_spa?: any | null, features_taxes?: any | null, features_utilities?: any | null, features_water?: any | null, features_windows_and_doors?: any | null, geo_type?: string | null, id: any, firestore_id: any, is_new_construction?: boolean | null, last_updated_at?: any | null, lat?: number | null, list_price?: any | null, listing_date?: any | null, listing_office_id?: any | null, listing_type?: string | null, lng?: number | null, lotsize_acres?: number | null, lotsize_sqft?: any | null, market_id: any, mls: string, modified_at?: any | null, property_type?: string | null, provider_id?: string | null, provider?: string | null, region?: string | null, school_district?: string | null, school_elementary?: string | null, school_high?: string | null, school_middle?: string | null, short_id: string, size?: string | null, state?: string | null, status?: string | null, std_address?: any | null, street?: string | null, style?: string | null, subdivision?: string | null, system_id?: string | null, tour_url?: string | null, updated_at: any, xf_attributes?: any | null, year_built?: number | null, zip?: string | null, co_listing_agent?: { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null } | null, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', analyzed_images?: any | null, census_tract_county_code?: string | null, census_tract_income_level?: string | null, census_tract_median_family_income?: number | null, census_tract_percent_below_poverty_line?: number | null, census_tract_tract_code?: string | null, created_at: any, guidance_price?: any | null, id: any, internal_status?: string | null, is_census_tract_opportunity_zone?: boolean | null, is_in_customer_buy_box: boolean, is_in_real_estate_buy_box: boolean, is_persisted_in_algolia: boolean, mls_listing_id: any, neighborhood_levels?: any | null, percent_over_comp?: number | null, rating_base?: number | null, short_list_images?: any | null, tags?: any | null, updated_at: any, url?: string | null, zillow_deep_search_results?: any | null }>, opportunity?: { __typename: 'opportunities', id: any, current_rent: Array<{ __typename: 'listed_rents', id: any, listed_rent: any, base_rent: any }> } | null, listing_agent?: { __typename: 'seller_agents', close_lead_id?: string | null, created_at: any, do_not_contact?: boolean | null, email?: string | null, first_name: string, id: any, last_contacted_at?: any | null, last_name: string, mls: string, mls_id: string, phone?: string | null } | null, photos: Array<{ __typename: 'mls_listing_photos', created_at: any, display_order?: number | null, id: any, is_deleted?: boolean | null, updated_at: any, url: string }> }> };

export type UpupInsertAdminMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpupInsertAdminMutation = { __typename: 'mutation_root', insert_admins_one?: { __typename: 'admins', id: any, email: string, first_name: string, last_name: string } | null };

export type UpupInsertCapabilityMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpupInsertCapabilityMutation = { __typename: 'mutation_root', insert_capabilities_one?: { __typename: 'capabilities', id: any, name: string, type: string, description?: string | null } | null };

export type UpupInsertDashboardMutationVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpupInsertDashboardMutation = { __typename: 'mutation_root', insert_dashboards_one?: { __typename: 'dashboards', id: any } | null };

export type UpupInsertDocumentMutationVariables = Exact<{
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_source?: InputMaybe<Scalars['String']['input']>;
  friendly_name?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  resource_notes?: InputMaybe<Scalars['String']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploaded_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  is_publicly_viewable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpupInsertDocumentMutation = { __typename: 'mutation_root', insert_documents_one?: { __typename: 'documents', id: any } | null };

export type UpupInsertNoteMutationVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  created_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Note_Priorities_Enum>;
}>;


export type UpupInsertNoteMutation = { __typename: 'mutation_root', insert_notes_one?: { __typename: 'notes', id: any } | null };

export type CreateRecurringCreditMutationVariables = Exact<{
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  num_months?: InputMaybe<Scalars['Int']['input']>;
  total_amount?: InputMaybe<Scalars['numeric']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  liability_type_id?: InputMaybe<Scalars['uuid']['input']>;
  move_in_credit?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateRecurringCreditMutation = { __typename: 'mutation_root', insert_recurring_credits_one?: { __typename: 'recurring_credits', id: any, rental_id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type_id: any, move_in_credit: boolean, created_at: any, updated_at: any } | null };

export type UpupInsertUserDocumentRequestsMutationVariables = Exact<{
  requests: Array<User_Document_Requests_Insert_Input> | User_Document_Requests_Insert_Input;
}>;


export type UpupInsertUserDocumentRequestsMutation = { __typename: 'mutation_root', insert_user_document_requests?: { __typename: 'user_document_requests_mutation_response', returning: Array<{ __typename: 'user_document_requests', id: any }> } | null };

export type OccupancyInspectionByConstructionProjectIdQueryVariables = Exact<{
  constructionProjectId: Scalars['uuid']['input'];
}>;


export type OccupancyInspectionByConstructionProjectIdQuery = { __typename: 'query_root', construction_occupancy_inspections: Array<{ __typename: 'construction_occupancy_inspections', id: any }> };

export type BuyersInspectionByConstructionProjectIdQueryVariables = Exact<{
  constructionProjectId: Scalars['uuid']['input'];
}>;


export type BuyersInspectionByConstructionProjectIdQuery = { __typename: 'query_root', construction_projects: Array<{ __typename: 'construction_projects', portfolio_home?: { __typename: 'portfolio_homes', portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', portfolio_home_disposition_bids: Array<{ __typename: 'dispositions_portfolio_home_disposition_bids', buyers_inspections: Array<{ __typename: 'dispositions_buyers_inspections', id: any }> }> }> } | null }> };

export type LatchelVendorsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LatchelVendorsQueryQuery = { __typename: 'query_root', vendors: Array<{ __typename: 'vendors', id: any, name: string }> };

export type LeadGroupByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LeadGroupByUserIdQuery = { __typename: 'query_root', lead_group_users: Array<{ __typename: 'lead_group_users', id: any, lead_group: { __typename: 'lead_groups', id: any, status: string, created_at?: any | null } }> };

export type LeadGroupUsersByLeadGroupIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LeadGroupUsersByLeadGroupIdQuery = { __typename: 'query_root', lead_group_users: Array<{ __typename: 'lead_group_users', id: any, user_id: any, type: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, emails: Array<{ __typename: 'user_contact_details', id: any, contact_info: string }> }> };

export type UpupLeadGroupUsersWithDocsByRentalAppIdQueryVariables = Exact<{
  rentalAppId: Scalars['uuid']['input'];
}>;


export type UpupLeadGroupUsersWithDocsByRentalAppIdQuery = { __typename: 'query_root', lead_group_users: Array<{ __typename: 'lead_group_users', id: any, type: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_document_requests: Array<{ __typename: 'user_document_requests', id: any, created_at: any, created_by_admin_id?: any | null, document_id?: any | null, document_type: string, instructions?: string | null }>, documents: Array<{ __typename: 'user_documents', id?: any | null, created_at?: any | null, friendly_name?: string | null, review_notes?: string | null, status?: string | null, type?: string | null }> } }> };

export type HomeOccupancyStatusesForRentalsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeOccupancyStatusesForRentalsQuery = { __typename: 'query_root', home_occupancy_statuses: Array<{ __typename: 'home_occupancy_statuses', id: any, most_recent_rental_id?: any | null, status: Home_Occupancy_Status_Enum_Enum }> };

export type OwnedPortfolioHomesQueryVariables = Exact<{ [key: string]: never; }>;


export type OwnedPortfolioHomesQuery = { __typename: 'query_root', portfolio_homes: Array<{ __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, display_line_1?: string | null, display_line_2?: string | null, city: string, state: string, zip: string }, market?: { __typename: 'markets', id: any, display_name: string } | null } }> };

export type PortfolioHomeSystemWorkOrderSystemsQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioHomeSystemWorkOrderSystemsQuery = { __typename: 'query_root', portfolio_home_system_work_order_system_enum: Array<{ __typename: 'portfolio_home_system_work_order_system_enum', system: string }> };

export type PortfolioHomeSystemWorkOrderTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioHomeSystemWorkOrderTypesQuery = { __typename: 'query_root', portfolio_home_system_work_order_type_enum: Array<{ __typename: 'portfolio_home_system_work_order_type_enum', type: string }> };

export type PrequalificationDetailsByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PrequalificationDetailsByUserIdQuery = { __typename: 'query_root', user_prequalification_data: Array<{ __typename: 'user_prequalification_data', id: any, prequalification_status: string, is_section_eight?: boolean | null, is_ok_with_two_year_lease?: boolean | null, is_income_qualified?: boolean | null, is_credit_qualified?: boolean | null, has_cosigner?: boolean | null, has_coapplicant?: boolean | null }> };

export type UpupProcessedUtilityBillsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpupProcessedUtilityBillsQuery = { __typename: 'query_root', kafka_connector_prorated_utility_bill_line_items: Array<{ __typename: 'kafka_connector_prorated_utility_bill_line_items', buildium_csv: string, id: any, rental_liabilities: any, transformations: any, original_upload_url: string, original_upload?: string | null, created_at: any, rental_liabilities_csv: string, unknown_memos?: string | null, known_liabilities_do_not_cover_full_bill_csv?: string | null, potential_duplicates_csv?: string | null }> };

export type UpUpPropertyInformationForUtilityBillsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpUpPropertyInformationForUtilityBillsQuery = { __typename: 'query_root', llcs: Array<{ __typename: 'llcs', id: any, name: string, abbreviation?: string | null }>, llc_properties: Array<{ __typename: 'llc_properties', start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any }, property: { __typename: 'properties', id: any, rentals: Array<{ __typename: 'rentals', final_liability_date?: any | null, occupancy_date: any, user_id: any, id: any }>, real_estate_acquisition?: { __typename: 'real_estate_acquisitions', mls_listing: { __typename: 'mls_listings', display_line_1?: string | null, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, id: any } } | null } }>, funds: Array<{ __typename: 'funds', id: any, name: string, abbreviation?: string | null }>, fund_llcs: Array<{ __typename: 'fund_llcs', fund_id: any, llc_id: any }>, real_estate_acquisitions: Array<{ __typename: 'real_estate_acquisitions', canceled_at?: any | null, closing_date?: any | null, llc_id?: any | null, status: string, possession_at?: any | null, utilities_activation_date?: any | null, mls_listing: { __typename: 'mls_listings', display_line_1?: string | null, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, id: any } }> };

export type RentReadyDatesByOpportunityIdQueryVariables = Exact<{
  opportunityId: Scalars['uuid']['input'];
}>;


export type RentReadyDatesByOpportunityIdQuery = { __typename: 'query_root', rent_ready_dates: Array<{ __typename: 'rent_ready_dates', id: any, earliest_move_in_date?: any | null }> };

export type RentRollRentalDetailsQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollRentalDetailsQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, initial_option_premium: number, status: string, target_monthly_option_premium: number, rental_program_type: Rental_Program_Types_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, buildium_lease_id?: number | null, do_not_renew_reason?: string | null, do_not_renew_selected_at?: any | null, do_not_renew_notice_sent_at?: any | null, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null, daily_late_fee_amount?: any | null, utility_chargeback_override?: { __typename: 'rental_utility_chargeback_overrides', rental_id: any, mode: string, set_at: any, reason?: string | null } | null, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rahWithRenewal: Array<{ __typename: 'rental_agreement_histories', renewals: Array<{ __typename: 'renewals', id: any, status: Renewal_Status_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, offered_at?: any | null, created_at: any, kcpoa_terms?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, completed_at?: any | null, scheduled_rental_liabilities: Array<{ __typename: 'scheduled_rental_liabilities', id: any, amount: any, due_date: any, status: string, last_error?: string | null }>, selected_renewal_offer?: { __typename: 'renewal_offers', id: any, price: any, term: number, is_month_to_month: boolean } | null, admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, agreement?: { __typename: 'agreements', id: any, external_id: string, metadata: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string }>, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, external_id: string, external_source: string, resource_id: any, resource_type: string, role: string, status: string, signed_at?: any | null }> } | null }> }>, do_not_renew_selected_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, pending_evictions: Array<{ __typename: 'evictions', id: any, status: string, created_at: any }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } }, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }> } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }>, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> }, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null } | null };

export type CashoutStatusInfoFragment = { __typename: 'rentals', id: any, move_out_date?: any | null, tenant_notice_given_on_date?: any | null, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null };

export type RentRollDetailsRentalFragment = { __typename: 'rentals', id: any, initial_option_premium: number, status: string, target_monthly_option_premium: number, rental_program_type: Rental_Program_Types_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, buildium_lease_id?: number | null, do_not_renew_reason?: string | null, do_not_renew_selected_at?: any | null, do_not_renew_notice_sent_at?: any | null, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null, daily_late_fee_amount?: any | null, utility_chargeback_override?: { __typename: 'rental_utility_chargeback_overrides', rental_id: any, mode: string, set_at: any, reason?: string | null } | null, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rahWithRenewal: Array<{ __typename: 'rental_agreement_histories', renewals: Array<{ __typename: 'renewals', id: any, status: Renewal_Status_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, offered_at?: any | null, created_at: any, kcpoa_terms?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, completed_at?: any | null, scheduled_rental_liabilities: Array<{ __typename: 'scheduled_rental_liabilities', id: any, amount: any, due_date: any, status: string, last_error?: string | null }>, selected_renewal_offer?: { __typename: 'renewal_offers', id: any, price: any, term: number, is_month_to_month: boolean } | null, admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, agreement?: { __typename: 'agreements', id: any, external_id: string, metadata: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string }>, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, external_id: string, external_source: string, resource_id: any, resource_type: string, role: string, status: string, signed_at?: any | null }> } | null }> }>, do_not_renew_selected_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, pending_evictions: Array<{ __typename: 'evictions', id: any, status: string, created_at: any }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } }, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }> } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }>, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> }, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null };

export type ActiveRentalApplicationDecisionByRentalApplicationIdQueryVariables = Exact<{
  rentalApplicationId: Scalars['uuid']['input'];
}>;


export type ActiveRentalApplicationDecisionByRentalApplicationIdQuery = { __typename: 'query_root', rental_application_decisions: Array<{ __typename: 'rental_application_decisions', id: any, decided_at?: any | null, deposit_rent_multiple?: any | null, is_approved?: boolean | null, rejection_reason?: string | null, weighted_average_credit_score_at_decision?: any | null, usable_income_at_decision?: any | null, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> };

export type UserIncomeByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserIncomeByUserIdQuery = { __typename: 'query_root', user_incomes: Array<{ __typename: 'applicant_income_underwrites_user_incomes', id: any, initially_completed_at?: any | null, is_non_income_applicant: boolean, approved_at?: any | null, additional_income_requested_at?: any | null, additional_income_submitted_at?: any | null, annual_income: any, approved_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user_income_sources: Array<{ __typename: 'applicant_income_underwrites_user_income_sources', id: any, source_annual_income: any, status: string, employed?: { __typename: 'applicant_income_underwrites_user_income_sources_employed', id: any, employment_verification_status: Applicant_Income_Underwrites_User_Income_Employment_Verification_Statuses_Enum_Enum } | null, self_employed?: { __typename: 'applicant_income_underwrites_user_income_sources_self_employed', id: any, business_name: string } | null, benefits?: { __typename: 'applicant_income_underwrites_user_income_sources_benefits', id: any, benefits_type: string, pay_frequency: Applicant_Income_Underwrites_User_Income_Source_Pay_Frequencies_Enum_Enum } | null, user_income_source_documents: Array<{ __typename: 'applicant_income_underwrites_user_income_source_documents', id: any, amount?: any | null, document_id: any }> }> }> };

export type RentalApplicationInitialUnderwritingDataQueryVariables = Exact<{
  rentalApplicationId: Scalars['uuid']['input'];
}>;


export type RentalApplicationInitialUnderwritingDataQuery = { __typename: 'query_root', rental_applications_by_pk?: { __typename: 'rental_applications', id: any, preapproved_at?: any | null, lead_group: { __typename: 'lead_groups', lead_group_users: Array<{ __typename: 'lead_group_users', user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_underwriting_data: Array<{ __typename: 'user_underwriting_data', id: any, credit_score?: number | null, verified_income?: any | null }> } }> } } | null };

export type AssignLeadGroupMutationVariables = Exact<{
  adminId: Scalars['uuid']['input'];
  leadGroupId: Scalars['uuid']['input'];
  agentType: Agent_Lead_Group_Owners_Agent_Type_Enum_Enum;
}>;


export type AssignLeadGroupMutation = { __typename: 'mutation_root', update_agent_lead_group_owners?: { __typename: 'agent_lead_group_owners_mutation_response', affected_rows: number } | null, insert_agent_lead_group_owners_one?: { __typename: 'agent_lead_group_owners', id: any } | null };

export type EscalateRentalApplicationMutationVariables = Exact<{
  reason?: InputMaybe<Scalars['String']['input']>;
  assigned_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_application_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type EscalateRentalApplicationMutation = { __typename: 'mutation_root', insert_rental_application_manager_application_escalations_one?: { __typename: 'rental_application_manager_application_escalations', id: any } | null };

export type LeadGroupAssignmentsByLeadGroupIdQueryVariables = Exact<{
  leadGroupId: Scalars['uuid']['input'];
}>;


export type LeadGroupAssignmentsByLeadGroupIdQuery = { __typename: 'query_root', agent_lead_group_owners: Array<{ __typename: 'agent_lead_group_owners', id: any, agent_type: Agent_Lead_Group_Owners_Agent_Type_Enum_Enum, admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> };

export type FindRecentNoteByResourceIdQueryVariables = Exact<{
  resourceId: Scalars['uuid']['input'];
}>;


export type FindRecentNoteByResourceIdQuery = { __typename: 'query_root', notes: Array<{ __typename: 'notes', id: any, resource_id: any, resource_type: string, note: string, created_at: any, priority: Note_Priorities_Enum, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }> };

export type RaEscalationsByRaIdQueryVariables = Exact<{
  rentalApplicationId: Scalars['uuid']['input'];
}>;


export type RaEscalationsByRaIdQuery = { __typename: 'query_root', rental_application_manager_application_escalations: Array<{ __typename: 'rental_application_manager_application_escalations', escalation_status: Rental_Application_Manager_Escalation_Statuses_Enum, id: any, reason: string, rental_application_id: any, resolution_note?: string | null, resolved_at?: any | null, created_at: any, assigned_by_admin: { __typename: 'admins', first_name: string, last_name: string, id: any }, assigned_to_admin: { __typename: 'admins', first_name: string, last_name: string, id: any }, resolved_by_admin?: { __typename: 'admins', first_name: string, last_name: string, id: any } | null }> };

export type RaSnoozesByRaIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RaSnoozesByRaIdQuery = { __typename: 'query_root', rental_application_manager_application_snoozes: Array<{ __typename: 'rental_application_manager_application_snoozes', id: any, snooze_reason: Rental_Application_Manager_Snooze_Reasons_Enum, snoozed_until: any, snoozed_by_admin: { __typename: 'admins', id: any, first_name: string, last_name: string } }> };

export type RentalApplicationManagerAdminRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RentalApplicationManagerAdminRolesQuery = { __typename: 'query_root', agent_lead_group_owners_agent_type_enum: Array<{ __typename: 'agent_lead_group_owners_agent_type_enum', agent_type: string }> };

export type ResolveRentalAppEscalationMutationVariables = Exact<{
  rental_application_id: Scalars['uuid']['input'];
  resolved_by_admin_id: Scalars['uuid']['input'];
  resolution_note?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveRentalAppEscalationMutation = { __typename: 'mutation_root', update_rental_application_manager_application_escalations?: { __typename: 'rental_application_manager_application_escalations_mutation_response', returning: Array<{ __typename: 'rental_application_manager_application_escalations', id: any, rental_application_id: any, resolution_note?: string | null, resolved_at?: any | null, resolved_by_admin_id?: any | null, escalation_status: Rental_Application_Manager_Escalation_Statuses_Enum }> } | null };

export type SnoozeReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SnoozeReasonsQuery = { __typename: 'query_root', rental_application_manager_snooze_reasons: Array<{ __typename: 'rental_application_manager_snooze_reasons', snooze_reason: string }> };

export type SnoozeRentalApplicationMutationVariables = Exact<{
  rental_application_id: Scalars['uuid']['input'];
  snoozed_until: Scalars['timestamptz']['input'];
  snooze_reason: Rental_Application_Manager_Snooze_Reasons_Enum;
  snoozed_by_admin_id: Scalars['uuid']['input'];
}>;


export type SnoozeRentalApplicationMutation = { __typename: 'mutation_root', insert_rental_application_manager_application_snoozes_one?: { __typename: 'rental_application_manager_application_snoozes', id: any, rental_application_id: any } | null };

export type SoftDeleteRaSnoozeMutationVariables = Exact<{
  rentalApplicationId: Scalars['uuid']['input'];
}>;


export type SoftDeleteRaSnoozeMutation = { __typename: 'mutation_root', update_rental_application_manager_application_snoozes?: { __typename: 'rental_application_manager_application_snoozes_mutation_response', returning: Array<{ __typename: 'rental_application_manager_application_snoozes', id: any, rental_application_id: any, deleted_at?: any | null }> } | null };

export type UpupRentalApplicationsCountQueryVariables = Exact<{
  where?: InputMaybe<Rental_Applications_Bool_Exp>;
}>;


export type UpupRentalApplicationsCountQuery = { __typename: 'query_root', rental_applications_aggregate: { __typename: 'rental_applications_aggregate', aggregate?: { __typename: 'rental_applications_aggregate_fields', count: number } | null } };

export type RentRollListRentalFragment = { __typename: 'rentals', id: any, initial_option_premium: number, status: string, target_monthly_option_premium: number, rental_program_type: Rental_Program_Types_Enum_Enum, buildium_lease_id?: number | null, has_signed_utility_addendum?: string | null, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null, daily_late_fee_amount?: any | null, payments: Array<{ __typename: 'payments', amount: any, available_on?: any | null, category: string, created_at?: any | null, id: any, note?: string | null, payment_date?: any | null, payment_method?: string | null, status: string, stripe_charge_id?: string | null, stripe_payment_intent_id?: string | null, lifecycle: string, initiated_at?: any | null, refund_reason?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null }, buildium_transaction?: { __typename: 'buildium_transactions', id: any, buildium_id: number, type: string, date: any, amount: any, metadata: any } | null }>, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rental_credits: Array<{ __typename: 'rental_credits', id: any, buildium_id?: number | null, amount: any, date: any, note: string, type: string, payment_plan_offset_credits: Array<{ __typename: 'payment_plan_offset_credits', id: any }>, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, rental_liabilities: Array<{ __typename: 'rental_liabilities', amount: any, date: any, id: any, note?: string | null, buildium_id?: any | null, payment_plan_liability?: { __typename: 'payment_plan_liabilities', id: any } | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, option_premium_transfers_received: Array<{ __typename: 'option_premium_transfers', id: any, amount: any, from_rental_id: any, date: any }>, recurring_credits: Array<{ __typename: 'recurring_credits', id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type: { __typename: 'liability_types', id: any, name: string } }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } }, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }>, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }>, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> }, utility_responsibilities: Array<{ __typename: 'utility_responsibilities', id: any, created_at: any, responsible_party: string, start_date: any, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } }>, current_utility_responsibilities: Array<{ __typename: 'current_utility_responsibilities', id?: any | null, created_at?: any | null, responsible_party?: string | null, start_date?: any | null, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility?: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } | null }> };

export type MoveOutInfoFragment = { __typename: 'rentals', id: any, status: string, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null };

export type CashoutFragment = { __typename: 'rentals', id: any, move_out_date?: any | null, tenant_notice_given_on_date?: any | null, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null };

export type CashoutAdminFragment = { __typename: 'admins', id: any, first_name: string, last_name: string };

export type RentRollRentalFragment = { __typename: 'rentals', id: any, status: string, initial_option_premium: number, target_monthly_option_premium: number, rental_program_type: Rental_Program_Types_Enum_Enum, buildium_lease_id?: number | null, has_signed_utility_addendum?: string | null, do_not_renew_reason?: string | null, do_not_renew_selected_at?: any | null, do_not_renew_notice_sent_at?: any | null, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null, daily_late_fee_amount?: any | null, rental_add_ons: Array<{ __typename: 'rental_add_ons', id: any, updated_at?: any | null, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, rental_move_in_fees: Array<{ __typename: 'rental_move_in_fees', id: any, amount: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, rental_application: { __typename: 'rental_applications', id: any, lead_group: { __typename: 'lead_groups', id: any }, agreements: Array<{ __typename: 'agreements', id: any, type: string, metadata: any, documents: Array<{ __typename: 'documents', id: any, created_at: any, external_id: string, external_source: string, friendly_name: string, review_notes?: string | null, reviewed_at?: any | null, status: string, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }>, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_type: string, contact_info: string }> } | null }> }>, document_agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }>, rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> }, agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }>, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }>, payments: Array<{ __typename: 'payments', amount: any, available_on?: any | null, category: string, created_at?: any | null, id: any, note?: string | null, payment_date?: any | null, payment_method?: string | null, status: string, stripe_charge_id?: string | null, stripe_payment_intent_id?: string | null, lifecycle: string, initiated_at?: any | null, refund_reason?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null }, buildium_transaction?: { __typename: 'buildium_transactions', id: any, buildium_id: number, type: string, date: any, amount: any, metadata: any } | null }>, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rental_credits: Array<{ __typename: 'rental_credits', id: any, buildium_id?: number | null, amount: any, date: any, note: string, type: string, payment_plan_offset_credits: Array<{ __typename: 'payment_plan_offset_credits', id: any }>, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, rental_liabilities: Array<{ __typename: 'rental_liabilities', amount: any, date: any, id: any, note?: string | null, buildium_id?: any | null, payment_plan_liability?: { __typename: 'payment_plan_liabilities', id: any } | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, option_premium_transfers_received: Array<{ __typename: 'option_premium_transfers', id: any, amount: any, from_rental_id: any, date: any }>, rahWithRenewal: Array<{ __typename: 'rental_agreement_histories', renewals: Array<{ __typename: 'renewals', id: any, status: Renewal_Status_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, offered_at?: any | null, created_at: any, kcpoa_terms?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, completed_at?: any | null, scheduled_rental_liabilities: Array<{ __typename: 'scheduled_rental_liabilities', id: any, amount: any, due_date: any, status: string, last_error?: string | null }>, selected_renewal_offer?: { __typename: 'renewal_offers', id: any, price: any, term: number, is_month_to_month: boolean } | null, admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, agreement?: { __typename: 'agreements', id: any, external_id: string, metadata: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string }>, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, external_id: string, external_source: string, resource_id: any, resource_type: string, role: string, status: string, signed_at?: any | null }> } | null }> }>, do_not_renew_selected_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, pending_evictions: Array<{ __typename: 'evictions', id: any, status: string, created_at: any }>, recurring_credits: Array<{ __typename: 'recurring_credits', id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type: { __typename: 'liability_types', id: any, name: string } }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } }, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }>, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }>, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, utility_responsibilities: Array<{ __typename: 'utility_responsibilities', id: any, created_at: any, responsible_party: string, start_date: any, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } }>, current_utility_responsibilities: Array<{ __typename: 'current_utility_responsibilities', id?: any | null, created_at?: any | null, responsible_party?: string | null, start_date?: any | null, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility?: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } | null }> };

export type LlcInfoFragment = { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null };

export type RentRollRentalPropertyFragment = { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> };

export type WithPortfolioHomeUtilitiesFragment = { __typename: 'rentals', portfolio_home?: { __typename: 'portfolio_homes', id: any, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null };

export type PortfolioHomeUtilitiesFragment = { __typename: 'portfolio_homes', id: any, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> };

export type RentRollPaymentFragment = { __typename: 'payments', amount: any, available_on?: any | null, category: string, created_at?: any | null, id: any, note?: string | null, payment_date?: any | null, payment_method?: string | null, status: string, stripe_charge_id?: string | null, stripe_payment_intent_id?: string | null, lifecycle: string, initiated_at?: any | null, refund_reason?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null }, buildium_transaction?: { __typename: 'buildium_transactions', id: any, buildium_id: number, type: string, date: any, amount: any, metadata: any } | null };

export type RentRollLiabilityTypeFragment = { __typename: 'liability_types', id: any, name: string, payment_category?: string | null };

export type RentRollRentalAddOnsFragment = { __typename: 'rental_add_ons', id: any, updated_at?: any | null, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } };

export type RentRollRentalMoveInFeesFragment = { __typename: 'rental_move_in_fees', id: any, amount: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } };

export type RentRollRentalLiabilitiesFragment = { __typename: 'rental_liabilities', amount: any, date: any, id: any, note?: string | null, buildium_id?: any | null, payment_plan_liability?: { __typename: 'payment_plan_liabilities', id: any } | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } };

export type RentRollApplicationAgreementFragment = { __typename: 'agreements', id: any, type: string, metadata: any };

export type PortfolioHomeDispositionsFragment = { __typename: 'rentals', id: any, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }> } | null };

export type UpupRentalListQueryVariables = Exact<{
  onlyActive: Scalars['Boolean']['input'];
}>;


export type UpupRentalListQuery = { __typename: 'query_root', activeRentals?: Array<{ __typename: 'rentals', id: any, initial_option_premium: number, status: string, target_monthly_option_premium: number, rental_program_type: Rental_Program_Types_Enum_Enum, buildium_lease_id?: number | null, has_signed_utility_addendum?: string | null, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null, daily_late_fee_amount?: any | null, payments: Array<{ __typename: 'payments', amount: any, available_on?: any | null, category: string, created_at?: any | null, id: any, note?: string | null, payment_date?: any | null, payment_method?: string | null, status: string, stripe_charge_id?: string | null, stripe_payment_intent_id?: string | null, lifecycle: string, initiated_at?: any | null, refund_reason?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null }, buildium_transaction?: { __typename: 'buildium_transactions', id: any, buildium_id: number, type: string, date: any, amount: any, metadata: any } | null }>, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rental_credits: Array<{ __typename: 'rental_credits', id: any, buildium_id?: number | null, amount: any, date: any, note: string, type: string, payment_plan_offset_credits: Array<{ __typename: 'payment_plan_offset_credits', id: any }>, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, rental_liabilities: Array<{ __typename: 'rental_liabilities', amount: any, date: any, id: any, note?: string | null, buildium_id?: any | null, payment_plan_liability?: { __typename: 'payment_plan_liabilities', id: any } | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, option_premium_transfers_received: Array<{ __typename: 'option_premium_transfers', id: any, amount: any, from_rental_id: any, date: any }>, recurring_credits: Array<{ __typename: 'recurring_credits', id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type: { __typename: 'liability_types', id: any, name: string } }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } }, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }>, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }>, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> }, utility_responsibilities: Array<{ __typename: 'utility_responsibilities', id: any, created_at: any, responsible_party: string, start_date: any, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } }>, current_utility_responsibilities: Array<{ __typename: 'current_utility_responsibilities', id?: any | null, created_at?: any | null, responsible_party?: string | null, start_date?: any | null, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility?: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } | null }> }>, allRentals?: Array<{ __typename: 'rentals', id: any, initial_option_premium: number, status: string, target_monthly_option_premium: number, rental_program_type: Rental_Program_Types_Enum_Enum, buildium_lease_id?: number | null, has_signed_utility_addendum?: string | null, final_liability_date?: any | null, move_out_date?: any | null, lease_end_reason?: string | null, occupancy_date: any, tenant_notice_given_on_date?: any | null, daily_late_fee_amount?: any | null, payments: Array<{ __typename: 'payments', amount: any, available_on?: any | null, category: string, created_at?: any | null, id: any, note?: string | null, payment_date?: any | null, payment_method?: string | null, status: string, stripe_charge_id?: string | null, stripe_payment_intent_id?: string | null, lifecycle: string, initiated_at?: any | null, refund_reason?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null }, buildium_transaction?: { __typename: 'buildium_transactions', id: any, buildium_id: number, type: string, date: any, amount: any, metadata: any } | null }>, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rental_credits: Array<{ __typename: 'rental_credits', id: any, buildium_id?: number | null, amount: any, date: any, note: string, type: string, payment_plan_offset_credits: Array<{ __typename: 'payment_plan_offset_credits', id: any }>, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, rental_liabilities: Array<{ __typename: 'rental_liabilities', amount: any, date: any, id: any, note?: string | null, buildium_id?: any | null, payment_plan_liability?: { __typename: 'payment_plan_liabilities', id: any } | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, option_premium_transfers_received: Array<{ __typename: 'option_premium_transfers', id: any, amount: any, from_rental_id: any, date: any }>, recurring_credits: Array<{ __typename: 'recurring_credits', id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type: { __typename: 'liability_types', id: any, name: string } }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, exit_date?: any | null, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } }, portfolio_home_dispositions: Array<{ __typename: 'dispositions_portfolio_home_dispositions', id: any, sale_type?: string | null, status: string }>, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }>, cashout?: { __typename: 'cashouts', id: any, status: any, paid_out_amount: any, cashed_out_at?: any | null, utilities_finalized_at?: any | null, maintenance_chargebacks_finalized_at?: any | null, adjustments_finalized_at?: any | null, cashed_out_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, utilities_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, maintenance_chargebacks_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, adjustments_finalized_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null, current_statement?: { __typename: 'current_statements', id?: any | null, ending_balance?: any | null, ending_premium_factor?: any | null, month?: string | null, starting_balance?: any | null, starting_premium_factor?: any | null, sum_contributions?: any | null } | null, rent_roll?: { __typename: 'rent_roll', chargeback_deadline?: number | null, cashout_deadline?: number | null } | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> }, utility_responsibilities: Array<{ __typename: 'utility_responsibilities', id: any, created_at: any, responsible_party: string, start_date: any, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } }>, current_utility_responsibilities: Array<{ __typename: 'current_utility_responsibilities', id?: any | null, created_at?: any | null, responsible_party?: string | null, start_date?: any | null, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility?: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } | null }> }> };

export type RentalSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  rentalIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  tenantNameQuery: Scalars['String']['input'];
  tenantFieldQuery: Scalars['String']['input'];
  firstNameQuery: Scalars['String']['input'];
  lastNameQuery: Scalars['String']['input'];
}>;


export type RentalSearchQuery = { __typename: 'query_root', rentals: Array<{ __typename: 'rentals', id: any, occupancy_date: any, move_out_date?: any | null, portfolio_home?: { __typename: 'portfolio_homes', home: { __typename: 'homes', address: { __typename: 'addresses', display_line_1?: string | null, display_line_2?: string | null } } } | null, rental_users: Array<{ __typename: 'rental_users', user: { __typename: 'users', first_name?: string | null, last_name?: string | null } }> }> };

export type RentalsByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type RentalsByUserIdQuery = { __typename: 'query_root', rental_users: Array<{ __typename: 'rental_users', id: any, role: string, rental: { __typename: 'rentals', id: any, status: string, occupancy_date: any, move_out_date?: any | null, portfolio_home?: { __typename: 'portfolio_homes', home: { __typename: 'homes', address: { __typename: 'addresses', display_line_1?: string | null, display_line_2?: string | null, id: any }, market?: { __typename: 'markets', display_name: string, id: any } | null } } | null } }> };

export type SetRentalApplicationAutoRemindersDisabledAtMutationVariables = Exact<{
  pk_columns: Rental_Applications_Pk_Columns_Input;
  auto_reminders_disabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auto_reminders_disabled_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SetRentalApplicationAutoRemindersDisabledAtMutation = { __typename: 'mutation_root', update_rental_applications_by_pk?: { __typename: 'rental_applications', id: any, auto_reminders_disabled_at?: any | null, auto_reminders_disabled_by_admin_id?: any | null } | null };

export type SetRentalApplicationPriorityMutationVariables = Exact<{
  pk_columns: Rental_Applications_Pk_Columns_Input;
  priority_score?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetRentalApplicationPriorityMutation = { __typename: 'mutation_root', update_rental_applications_by_pk?: { __typename: 'rental_applications', id: any, priority_score: number } | null };

export type SetRentalApplicationRecievedProductPitchMutationVariables = Exact<{
  pk_columns: Rental_Applications_Pk_Columns_Input;
  did_receive_initial_product_pitch: Scalars['Boolean']['input'];
}>;


export type SetRentalApplicationRecievedProductPitchMutation = { __typename: 'mutation_root', set?: { __typename: 'rental_applications', id: any, received_initial_product_pitch_at?: any | null } | null, unset?: { __typename: 'rental_applications', id: any, received_initial_product_pitch_at?: any | null } | null };

export type SetRentalApplicationRentMutationVariables = Exact<{
  pk_columns: Rental_Applications_Pk_Columns_Input;
  rent?: InputMaybe<Scalars['numeric']['input']>;
}>;


export type SetRentalApplicationRentMutation = { __typename: 'mutation_root', update_rental_applications_by_pk?: { __typename: 'rental_applications', id: any, rent?: any | null } | null };

export type ToursByLeadGroupIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ToursByLeadGroupIdQuery = { __typename: 'query_root', tours: Array<{ __typename: 'tours', id: any, start_at: any, status: string, type?: string | null, tour_properties: Array<{ __typename: 'tour_properties', id: any, mls_listing: { __typename: 'mls_listings', id: any, display_line_1?: string | null, display_line_2?: string | null } }> }> };

export type UpupUpdateDashboardMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpupUpdateDashboardMutation = { __typename: 'mutation_root', update_dashboards_by_pk?: { __typename: 'dashboards', id: any } | null };

export type UpupUpdateDocumentMutationVariables = Exact<{
  documentId: Scalars['uuid']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  resourceNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpupUpdateDocumentMutation = { __typename: 'mutation_root', update_documents_by_pk?: { __typename: 'documents', id: any } | null };

export type UserByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserByUserIdQuery = { __typename: 'query_root', users_by_pk?: { __typename: 'users', first_name?: string | null, last_name?: string | null, id: any, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_type: string, contact_info: string }> } | null };

export type UpupUserListSubscriptionVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UpupUserListSubscription = { __typename: 'subscription_root', users: Array<{ __typename: 'users', id: any, close_lead_id?: string | null, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_type: string, contact_info: string }> }> };

export type UpUpUserTimelineByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  with_property_details: Scalars['Boolean']['input'];
  with_conversations: Scalars['Boolean']['input'];
  with_tours: Scalars['Boolean']['input'];
  with_rental_app_events: Scalars['Boolean']['input'];
  with_rental_site_leads: Scalars['Boolean']['input'];
}>;


export type UpUpUserTimelineByUserIdQuery = { __typename: 'query_root', users: Array<{ __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, lead_group: { __typename: 'lead_groups', id: any, tours?: Array<{ __typename: 'tours', id: any, status: string, type?: string | null, start_at: any, created_at: any, completed_at?: any | null, canceled_at?: any | null, lead_group_confirmed_at?: any | null, cancelation_reason?: string | null, agent?: { __typename: 'agents', id: any, first_name: string, last_name: string, status: string, email: string, phone: string } | null, tour_properties?: Array<{ __typename: 'tour_properties', id: any, mls_listing: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> } }> }>, rental_applications?: Array<{ __typename: 'rental_applications', id: any, status: string, created_at: any, completed_at?: any | null, projected_occupancy_date?: any | null, is_underwriting_approved?: boolean | null, underwritten_at?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, mls_listing?: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> }, lead_group: { __typename: 'lead_groups', id: any, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }> } }> } }>, conversations?: Array<{ __typename: 'conversations', id: any, medium: string, from?: string | null, external_source: string, direction: string, created_at: any, status: string, payload: any }>, rental_site_leads?: Array<{ __typename: 'rental_site_leads', id: any, lead_comments?: string | null, created_at: any, rental_site_listing: { __typename: 'rental_site_listings', id: any, rental_site_account: { __typename: 'rental_site_accounts', id: any, source: string }, mls_listing?: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> } } }> }> };

export type Tour_ItemsFragment = { __typename: 'tours', id: any, status: string, type?: string | null, start_at: any, created_at: any, completed_at?: any | null, canceled_at?: any | null, lead_group_confirmed_at?: any | null, cancelation_reason?: string | null, agent?: { __typename: 'agents', id: any, first_name: string, last_name: string, status: string, email: string, phone: string } | null, tour_properties?: Array<{ __typename: 'tour_properties', id: any, mls_listing: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> } }> };

export type Rental_Applications_ItemsFragment = { __typename: 'rental_applications', id: any, status: string, created_at: any, completed_at?: any | null, projected_occupancy_date?: any | null, is_underwriting_approved?: boolean | null, underwritten_at?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, mls_listing?: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> }, lead_group: { __typename: 'lead_groups', id: any, lead_group_users: Array<{ __typename: 'lead_group_users', id: any, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }> } };

export type Primary_User_NameFragment = { __typename: 'lead_groups', lead_group_users: Array<{ __typename: 'lead_group_users', id: any, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }> };

export type Mls_Listing_ItemsFragment = { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> };

export type Conversations_ItemsFragment = { __typename: 'conversations', id: any, medium: string, from?: string | null, external_source: string, direction: string, created_at: any, status: string, payload: any };

export type Rental_Site_Lead_ItemsFragment = { __typename: 'rental_site_leads', id: any, lead_comments?: string | null, created_at: any, rental_site_listing: { __typename: 'rental_site_listings', id: any, rental_site_account: { __typename: 'rental_site_accounts', id: any, source: string }, mls_listing?: { __typename: 'mls_listings', id: any, delivery_line?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, description?: string | null, size?: string | null, list_price?: any | null, property_type?: string | null, area?: string | null, baths_full?: number | null, baths_half?: number | null, baths_total?: number | null, firestore_id: any, status?: string | null, lotsize_sqft?: any | null, market: { __typename: 'markets', id: any, name: string, short_name?: string | null, display_name: string }, internal_attributes: Array<{ __typename: 'mls_listing_internal_attributes', internal_status?: string | null }> } } };

export type UpUpAddProcessedUtilityBillMutationVariables = Exact<{
  transformations?: InputMaybe<Scalars['json']['input']>;
  rental_liabilities?: InputMaybe<Scalars['json']['input']>;
  original_upload_url?: InputMaybe<Scalars['String']['input']>;
  original_upload?: InputMaybe<Scalars['String']['input']>;
  buildium_csv?: InputMaybe<Scalars['String']['input']>;
  rental_liabilities_csv?: InputMaybe<Scalars['String']['input']>;
  potential_duplicates_csv?: InputMaybe<Scalars['String']['input']>;
  known_liabilities_do_not_cover_full_bill_csv?: InputMaybe<Scalars['String']['input']>;
  unknown_memos?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpUpAddProcessedUtilityBillMutation = { __typename: 'mutation_root', insert_kafka_connector_prorated_utility_bill_line_items_one?: { __typename: 'kafka_connector_prorated_utility_bill_line_items', buildium_csv: string, id: any, rental_liabilities: any, transformations: any, original_upload_url: string, original_upload?: string | null, created_at: any, rental_liabilities_csv: string, unknown_memos?: string | null, known_liabilities_do_not_cover_full_bill_csv?: string | null, potential_duplicates_csv?: string | null } | null };

export type CreatePromiseToPayMutationVariables = Exact<{
  collectionId: Scalars['uuid']['input'];
  promiseToPayDate: Scalars['date']['input'];
  adminId: Scalars['uuid']['input'];
}>;


export type CreatePromiseToPayMutation = { __typename: 'mutation_root', insert_collection_payment_promises_one?: { __typename: 'collection_payment_promises', id: any } | null };

export type CancelPromiseToPayMutationVariables = Exact<{
  promiseId: Scalars['uuid']['input'];
  canceledAt: Scalars['timestamptz']['input'];
}>;


export type CancelPromiseToPayMutation = { __typename: 'mutation_root', update_collection_payment_promises_by_pk?: { __typename: 'collection_payment_promises', id: any } | null };

export type UpdatePromiseToPayDateMutationVariables = Exact<{
  promiseId: Scalars['uuid']['input'];
  promiseToPayDate: Scalars['date']['input'];
}>;


export type UpdatePromiseToPayDateMutation = { __typename: 'mutation_root', update_collection_payment_promises_by_pk?: { __typename: 'collection_payment_promises', id: any } | null };

export type CollectionsByMonthQueryVariables = Exact<{
  firstDayOfMonth: Scalars['date']['input'];
  lastDayOfMonth: Scalars['date']['input'];
}>;


export type CollectionsByMonthQuery = { __typename: 'query_root', collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, collection_payment_promises: Array<{ __typename: 'collection_payment_promises', id: any, promise_to_pay_date: any, created_at: any }>, note?: { __typename: 'notes', id: any, note: string } | null, rental: { __typename: 'rentals', id: any, status: string, occupancy_date: any, move_out_date?: any | null, current_balance?: { __typename: 'current_balances', id?: any | null, aggregate_balance_after?: any | null } | null, evictions: Array<{ __typename: 'evictions', id: any, status: string }>, notes: Array<{ __typename: 'notes', id: any, note: string, created_at: any, created_by_admin_id?: any | null }>, payments: Array<{ __typename: 'payments', id: any, amount: any, status: string, liability_type_id: any, liability_type: { __typename: 'liability_types', id: any, name: string } }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, display_line_1?: string | null, city: string, state: string } }, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, llc?: { __typename: 'llcs', id: any, name: string, fund_llcs: Array<{ __typename: 'fund_llcs', id: any, fund: { __typename: 'funds', id: any, name: string, abbreviation?: string | null } }> } | null } | null } | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, rent: any }>, rental_users: Array<{ __typename: 'rental_users', id: any, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }> } }> };

export type LiabilitiesRemainingForCollectionsQueryVariables = Exact<{
  firstDayOfMonth: Scalars['date']['input'];
  lastDayOfMonth: Scalars['date']['input'];
}>;


export type LiabilitiesRemainingForCollectionsQuery = { __typename: 'query_root', collections: Array<{ __typename: 'collections', id: any, liabilities_remaining: Array<{ __typename: 'collections_liabilities_remaining', liability_id?: any | null, amount_remaining?: any | null, original_amount?: any | null }> }> };

export type UpdateCollectionsLatePaymentReasonMutationVariables = Exact<{
  collectionId: Scalars['uuid']['input'];
  latePaymentReason?: InputMaybe<Collections_Late_Payment_Reason_Enum_Enum>;
}>;


export type UpdateCollectionsLatePaymentReasonMutation = { __typename: 'mutation_root', update_collections_by_pk?: { __typename: 'collections', id: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null } | null };

export type UpdateCollectionsZendeskLinkMutationVariables = Exact<{
  collectionId: Scalars['uuid']['input'];
  zendeskLink?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCollectionsZendeskLinkMutation = { __typename: 'mutation_root', update_collections_by_pk?: { __typename: 'collections', id: any, zendesk_link?: string | null } | null };

export type EvictionsQueryVariables = Exact<{ [key: string]: never; }>;


export type EvictionsQuery = { __typename: 'query_root', evictions: Array<{ __typename: 'evictions', id: any, rental_id: any, status: string, created_at: any, updated_at: any, filed_at?: any | null, file_sent_to_attorney_at?: any | null, completed_at?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, court_date?: any | null, writ_date?: any | null, set_out_date?: any | null, projected_possession_date?: any | null, consent_judgement?: boolean | null, filed_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, file_sent_to_attorney_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, completed_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, canceled_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, eviction_filing_fees: Array<{ __typename: 'eviction_filing_fees', id: any, charged_at: any, charged_by_admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, rental_liability: { __typename: 'rental_liabilities', id: any, amount: any, note?: string | null } }>, rental?: { __typename: 'rentals', id: any, notes: Array<{ __typename: 'notes', id: any, note: string, category?: string | null, created_at: any, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null }>, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, portfolio_home?: { __typename: 'portfolio_homes', home: { __typename: 'homes', address: { __typename: 'addresses', display_line_1?: string | null, display_line_2?: string | null } }, most_recent_llc_property?: { __typename: 'most_recent_llc_property', llc?: { __typename: 'llcs', fund_llcs: Array<{ __typename: 'fund_llcs', fund: { __typename: 'funds', name: string } }> } | null } | null } | null } | null }> };

export type SearchRentalsForEvictionQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchRentalsForEvictionQuery = { __typename: 'query_root', rentals: Array<{ __typename: 'rentals', id: any, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, portfolio_home?: { __typename: 'portfolio_homes', home: { __typename: 'homes', address: { __typename: 'addresses', display_line_1?: string | null, display_line_2?: string | null } } } | null }> };

export type Upup_CreateRentalAddOnMutationVariables = Exact<{
  liability_type_id: Scalars['uuid']['input'];
  rental_id: Scalars['uuid']['input'];
  start_date: Scalars['date']['input'];
  end_date?: InputMaybe<Scalars['date']['input']>;
  price: Scalars['numeric']['input'];
}>;


export type Upup_CreateRentalAddOnMutation = { __typename: 'mutation_root', insert_rental_add_ons_one?: { __typename: 'rental_add_ons', id: any, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', name: string } } | null };

export type RentRollAddOnsDataQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollAddOnsDataQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, occupancy_date: any, rental_add_ons: Array<{ __typename: 'rental_add_ons', id: any, updated_at?: any | null, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null };

export type Upup_UpdateRentalAddOnMutationVariables = Exact<{
  where: Rental_Add_Ons_Bool_Exp;
  start_date: Scalars['date']['input'];
  end_date?: InputMaybe<Scalars['date']['input']>;
  price: Scalars['numeric']['input'];
}>;


export type Upup_UpdateRentalAddOnMutation = { __typename: 'mutation_root', update_rental_add_ons?: { __typename: 'rental_add_ons_mutation_response', affected_rows: number, returning: Array<{ __typename: 'rental_add_ons', id: any, updated_at?: any | null, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', name: string } }> } | null };

export type Upup_CreateRentalAgreementHistoryMutationVariables = Exact<{
  rental_id?: InputMaybe<Scalars['uuid']['input']>;
  rent?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  starts_at?: InputMaybe<Scalars['date']['input']>;
  ends_at?: InputMaybe<Scalars['date']['input']>;
}>;


export type Upup_CreateRentalAgreementHistoryMutation = { __typename: 'mutation_root', insert_rental_agreement_histories_one?: { __typename: 'rental_agreement_histories', ends_at: any, rent: any, type?: string | null, rental_id: any, starts_at: any } | null };

export type Upup_LiabilityTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type Upup_LiabilityTypesQuery = { __typename: 'query_root', liability_types: Array<{ __typename: 'liability_types', id: any, is_variable: boolean, name: string, price?: any | null, recurring: boolean, payment_category?: string | null, utility_types: Array<{ __typename: 'utility_types', id: any }> }> };

export type Upup_EditRentalAgreementHistoryMutationVariables = Exact<{
  ends_at?: InputMaybe<Scalars['date']['input']>;
  id: Scalars['uuid']['input'];
}>;


export type Upup_EditRentalAgreementHistoryMutation = { __typename: 'mutation_root', update_rental_agreement_histories_by_pk?: { __typename: 'rental_agreement_histories', id: any, ends_at: any } | null };

export type DeleteRecurringCreditMutationVariables = Exact<{
  recurringCreditId: Scalars['uuid']['input'];
}>;


export type DeleteRecurringCreditMutation = { __typename: 'mutation_root', delete_recurring_credits_by_pk?: { __typename: 'recurring_credits', id: any } | null };

export type Upup_LedgerAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type Upup_LedgerAccountsQuery = { __typename: 'query_root', ledger_accounts: Array<{ __typename: 'ledger_accounts', id: any, name: string, rental_credit_type?: string | null }> };

export type ExistingRentalReunderwriteForRentalQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type ExistingRentalReunderwriteForRentalQuery = { __typename: 'query_root', rental_reunderwrites: Array<{ __typename: 'rental_reunderwrites', id: any, created_at: any, status: string, rental_reunderwrite_tenant_underwrites: Array<{ __typename: 'rental_reunderwrite_tenant_underwrites', id: any, tenant_underwrite_id: any, tenant_underwrite: { __typename: 'tenant_underwrites', id: any, contact_email?: string | null, submitted_at?: any | null, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, credit_reports: Array<{ __typename: 'credit_reports', id: any, score?: number | null, status: string, document_id?: any | null, created_at: any }>, criminal_reports: Array<{ __typename: 'criminal_reports', id: any, document_id?: any | null, created_at: any, matches?: any | null }>, eviction_reports: Array<{ __typename: 'eviction_reports', id: any, document_id?: any | null, created_at: any, matches?: any | null }> } | null, tenant_underwrite_documents: Array<{ __typename: 'tenant_underwrite_documents', id: any, document: { __typename: 'documents', id: any, external_id: string, friendly_name: string, type: string } }> } }> }> };

export type Upup_SetRentalDoNotRenewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  do_not_renew_reason?: InputMaybe<Scalars['String']['input']>;
  do_not_renew_selected_by_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  do_not_renew_selected_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_end_reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type Upup_SetRentalDoNotRenewMutation = { __typename: 'mutation_root', update_rentals_by_pk?: { __typename: 'rentals', id: any, do_not_renew_selected_at?: any | null, do_not_renew_selected_by_admin_id?: any | null, do_not_renew_reason?: string | null, lease_end_reason?: string | null } | null };

export type RentalForRenewalQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RentalForRenewalQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', lease_variant: Lease_Variants_Enum_Enum, rental_program_type: Rental_Program_Types_Enum_Enum, id: any, occupancy_date: any, target_monthly_option_premium: number, daily_late_fee_amount?: any | null, status: string, buildium_lease_id?: number | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, market?: { __typename: 'markets', name: string } | null, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } } } | null, payments: Array<{ __typename: 'payments', id: any, amount: any, status: string, liability_type: { __typename: 'liability_types', id: any, payment_category?: string | null } }>, rental_credits: Array<{ __typename: 'rental_credits', id: any, amount: any, liability_type: { __typename: 'liability_types', id: any, payment_category?: string | null } }>, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }>, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rental_add_ons: Array<{ __typename: 'rental_add_ons', id: any, updated_at?: any | null, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null };

export type RentRollDocumentsDataQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollDocumentsDataQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, status: string, rental_users: Array<{ __typename: 'rental_users', id: any, role: string, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }>, agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }>, rental_application: { __typename: 'rental_applications', id: any, document_agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }> }, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> } | null };

export type RentRollDocumentsPanelDocumentFragment = { __typename: 'documents', id: any, friendly_name: string, created_at: any, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null };

export type MoveInFeesFragment = { __typename: 'rentals', id: any, occupancy_date: any, status: string, rental_move_in_fees: Array<{ __typename: 'rental_move_in_fees', id: any, amount: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> };

export type AddOnsFragment = { __typename: 'rentals', id: any, occupancy_date: any, rental_add_ons: Array<{ __typename: 'rental_add_ons', id: any, updated_at?: any | null, end_date?: any | null, price: any, start_date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> };

export type WithLlcInfoFragment = { __typename: 'rentals', property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> } };

export type WithAddressInfoFragment = { __typename: 'rentals', portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } } } | null };

export type RentRollTenantFragment = { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> };

export type WithRentalAgreementInfoFragment = { __typename: 'rentals', id: any, occupancy_date: any, target_monthly_option_premium: number, daily_late_fee_amount?: any | null, rental_agreement_histories: Array<{ __typename: 'rental_agreement_histories', id: any, option_premium: any, rent: any, starts_at: any, ends_at: any, type?: string | null, renewal_months?: any | null, agreement?: { __typename: 'agreements', id: any, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null }> } | null }> };

export type AgreementSignerUserFragment = { __typename: 'agreement_signers', id: any, role: string, user?: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } | null };

export type TenantsFragment = { __typename: 'rentals', id: any, status: string, buildium_lease_id?: number | null, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }> };

export type OccupantsFragment = { __typename: 'rentals', rental_occupants: Array<{ __typename: 'rental_occupants', occupant_number?: number | null, occupant_name?: string | null, occupant_age?: string | null, occupant_relation?: string | null }>, rental_application: { __typename: 'rental_applications', rental_application_occupants: Array<{ __typename: 'rental_application_occupants', id: any, name: string, age: number, relation: string }> } };

export type RentRollDocumentFragment = { __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null };

export type RentRollDocumentsFragment = { __typename: 'rentals', id: any, status: string, agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }>, rental_application: { __typename: 'rental_applications', id: any, document_agreements: Array<{ __typename: 'agreements', id: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> }> }, documents: Array<{ __typename: 'documents', id: any, friendly_name: string, created_at: any, reviewed_at?: any | null, review_notes?: string | null, status: string, type: string, uploaded_by_admin?: { __typename: 'admins', first_name: string, last_name: string } | null, admin?: { __typename: 'admins', first_name: string, last_name: string } | null }> };

export type PendingRenewalInfoFragment = { __typename: 'rentals', do_not_renew_reason?: string | null, do_not_renew_selected_at?: any | null, do_not_renew_notice_sent_at?: any | null, rahWithRenewal: Array<{ __typename: 'rental_agreement_histories', renewals: Array<{ __typename: 'renewals', id: any, status: Renewal_Status_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, offered_at?: any | null, created_at: any, kcpoa_terms?: any | null, canceled_at?: any | null, cancelation_reason?: string | null, completed_at?: any | null, scheduled_rental_liabilities: Array<{ __typename: 'scheduled_rental_liabilities', id: any, amount: any, due_date: any, status: string, last_error?: string | null }>, selected_renewal_offer?: { __typename: 'renewal_offers', id: any, price: any, term: number, is_month_to_month: boolean } | null, admin: { __typename: 'admins', id: any, first_name: string, last_name: string }, agreement?: { __typename: 'agreements', id: any, external_id: string, metadata: any, documents: Array<{ __typename: 'documents', id: any, friendly_name: string }>, agreement_signers: Array<{ __typename: 'agreement_signers', id: any, external_id: string, external_source: string, resource_id: any, resource_type: string, role: string, status: string, signed_at?: any | null }> } | null }> }>, do_not_renew_selected_by_admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null };

export type UtilityResponsibilitiesFragment = { __typename: 'rentals', id: any, utility_responsibilities: Array<{ __typename: 'utility_responsibilities', id: any, created_at: any, responsible_party: string, start_date: any, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } }> };

export type CurrentUtilityResponsibilitiesFragment = { __typename: 'rentals', id: any, current_utility_responsibilities: Array<{ __typename: 'current_utility_responsibilities', id?: any | null, created_at?: any | null, responsible_party?: string | null, start_date?: any | null, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility?: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } | null }> };

export type RentRollPendingEvictionsFragment = { __typename: 'rentals', pending_evictions: Array<{ __typename: 'evictions', id: any, status: string, created_at: any }> };

export type CollectionsFragment = { __typename: 'rentals', collections: Array<{ __typename: 'collections', id: any, month: any, late_payment_reason?: Collections_Late_Payment_Reason_Enum_Enum | null, zendesk_link?: string | null, note?: { __typename: 'notes', id: any, note: string } | null }> };

export type RecurringCreditsFragment = { __typename: 'rentals', recurring_credits: Array<{ __typename: 'recurring_credits', id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type: { __typename: 'liability_types', id: any, name: string } }> };

export type Upup_CreateUtilityResponsibilityMutationVariables = Exact<{
  rentalId?: InputMaybe<Scalars['uuid']['input']>;
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  portfolioHomeUtilityId?: InputMaybe<Scalars['uuid']['input']>;
  responsibleParty?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
}>;


export type Upup_CreateUtilityResponsibilityMutation = { __typename: 'mutation_root', insert_utility_responsibilities_one?: { __typename: 'utility_responsibilities', id: any, created_at: any, updated_at: any, rental_id: any, portfolio_home_utility_id: any, responsible_party: string, start_date: any, created_by_admin_id?: any | null } | null };

export type RentRollLedgerDataQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollLedgerDataQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, status: string, buildium_lease_id?: number | null, occupancy_date: any, final_liability_date?: any | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, home: { __typename: 'homes', id: any, address: { __typename: 'addresses', id: any, state: string, display_line_1?: string | null, display_line_2?: string | null } } } | null, property: { __typename: 'properties', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, start_date?: any | null, end_date?: any | null, llc?: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } | null } | null, llc_properties: Array<{ __typename: 'llc_properties', id: any, start_date: any, end_date?: any | null, llc: { __typename: 'llcs', id: any, name: string, ledger_account?: { __typename: 'ledger_accounts', id: any, name: string } | null } }> }, rental_users: Array<{ __typename: 'rental_users', id: any, user_id: any, role: string, deactivated_at?: any | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_info: string, contact_type: string }> } }>, payments: Array<{ __typename: 'payments', amount: any, available_on?: any | null, category: string, created_at?: any | null, id: any, note?: string | null, payment_date?: any | null, payment_method?: string | null, status: string, stripe_charge_id?: string | null, stripe_payment_intent_id?: string | null, lifecycle: string, initiated_at?: any | null, refund_reason?: string | null, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null }, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null }, buildium_transaction?: { __typename: 'buildium_transactions', id: any, buildium_id: number, type: string, date: any, amount: any, metadata: any } | null }>, rental_liabilities: Array<{ __typename: 'rental_liabilities', resource_type?: string | null, amount: any, date: any, id: any, note?: string | null, buildium_id?: any | null, payment_plan_liability?: { __typename: 'payment_plan_liabilities', id: any } | null, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, scheduled_rental_liabilities: Array<{ __typename: 'scheduled_rental_liabilities', id: any, amount: any, due_date: any, note: string, source: string, status: string, renewal_id?: any | null, created_at: any, canceled_at?: any | null, posted_at?: any | null, last_error?: string | null, liability_type: { __typename: 'liability_types', id: any, name: string } }>, rental_credits: Array<{ __typename: 'rental_credits', id: any, buildium_id?: number | null, amount: any, date: any, note: string, type: string, payment_plan_offset_credits: Array<{ __typename: 'payment_plan_offset_credits', id: any }>, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }>, option_premium_transfers_received: Array<{ __typename: 'option_premium_transfers', id: any, amount: any, from_rental_id: any, date: any }>, cashout?: { __typename: 'cashouts', id: any, paid_out_amount: any, cashed_out_at?: any | null, adjustments_finalized_at?: any | null, cashout_adjustments: Array<{ __typename: 'cashout_adjustments', id: any, liability_type_id: any, type: string, amount: any, date: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null } | null };

export type CreateMoveInFeeMutationVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
  liabilityTypeId: Scalars['uuid']['input'];
  amount: Scalars['numeric']['input'];
}>;


export type CreateMoveInFeeMutation = { __typename: 'mutation_root', insert_rental_move_in_fees_one?: { __typename: 'rental_move_in_fees', id: any, rental_id: any, liability_type_id: any, amount: any } | null };

export type UpdateMoveInFeeAmountMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  amount: Scalars['numeric']['input'];
}>;


export type UpdateMoveInFeeAmountMutation = { __typename: 'mutation_root', update_rental_move_in_fees_by_pk?: { __typename: 'rental_move_in_fees', id: any, amount: any } | null };

export type DeactivateMoveInFeeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type DeactivateMoveInFeeMutation = { __typename: 'mutation_root', update_rental_move_in_fees_by_pk?: { __typename: 'rental_move_in_fees', id: any, deactivated_at?: any | null } | null };

export type RentRollMoveInFeesDataQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollMoveInFeesDataQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, occupancy_date: any, status: string, rental_move_in_fees: Array<{ __typename: 'rental_move_in_fees', id: any, amount: any, liability_type: { __typename: 'liability_types', id: any, name: string, payment_category?: string | null } }> } | null };

export type UtilityBillsForPropertyQueryVariables = Exact<{
  portfolioHomeId: Scalars['uuid']['input'];
}>;


export type UtilityBillsForPropertyQuery = { __typename: 'query_root', utility_bills: Array<{ __typename: 'utility_bills', id: any, amount: any, buildium_id?: number | null, buildium_bank_account_id?: number | null, service_start_date: any, service_end_date: any, bill_date: any, bill_due_date: any, vendor: string, charge_type: Utility_Bills_Charge_Type_Enum_Enum, status: string, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any }, utility_chargebacks: Array<{ __typename: 'utility_chargebacks', id: any, rental_id: any, status: Utility_Chargeback_Status_Enum_Enum, finalized_at?: any | null, finalized_amount?: any | null, rental_liability_id?: any | null }> }> };

export type RentRollRecurringCreditsDataQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollRecurringCreditsDataQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, recurring_credits: Array<{ __typename: 'recurring_credits', id: any, start_date: any, num_months: number, total_amount: any, notes: string, liability_type: { __typename: 'liability_types', id: any, name: string } }> } | null };

export type UpdateTargetMonthlyOptionPremiumMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  target_monthly_option_premium: Scalars['Int']['input'];
}>;


export type UpdateTargetMonthlyOptionPremiumMutation = { __typename: 'mutation_root', update_rentals_by_pk?: { __typename: 'rentals', id: any, target_monthly_option_premium: number } | null };

export type RentRollUtilityResponsibilitiesDataQueryVariables = Exact<{
  rentalId: Scalars['uuid']['input'];
}>;


export type RentRollUtilityResponsibilitiesDataQuery = { __typename: 'query_root', rentals_by_pk?: { __typename: 'rentals', id: any, has_signed_utility_addendum?: string | null, portfolio_home?: { __typename: 'portfolio_homes', id: any, portfolio_home_utilities: Array<{ __typename: 'portfolio_home_utilities', id: any, deactivated_at?: any | null, default_responsible_party: string, utility_type: { __typename: 'utility_types', id: any, name: string } }> } | null, current_utility_responsibilities: Array<{ __typename: 'current_utility_responsibilities', id?: any | null, created_at?: any | null, responsible_party?: string | null, start_date?: any | null, created_by_admin_id?: any | null, admin?: { __typename: 'admins', id: any, first_name: string, last_name: string } | null, portfolio_home_utility?: { __typename: 'portfolio_home_utilities', id: any, default_responsible_party: string, deactivated_at?: any | null, utility_type: { __typename: 'utility_types', id: any, name: string, liability_type_id: any, liability_type: { __typename: 'liability_types', name: string } } } | null }> } | null };

export type RentRollQueryVariables = Exact<{ [key: string]: never; }>;


export type RentRollQuery = { __typename: 'query_root', rent_roll: Array<{ __typename: 'rent_roll', id?: any | null, status?: string | null, display_line_1?: string | null, display_line_2?: string | null, city?: string | null, state?: string | null, zip?: string | null, aggregate_balance_after?: any | null, aggregate_successful_balance_after?: any | null, ends_at?: any | null, starts_at?: any | null, renewal_months?: any | null, occupancy_date?: any | null, move_out_date?: any | null, final_liability_date?: any | null, lease_end_reason?: string | null, rent?: any | null, occupancy_status?: string | null, option_premium?: any | null, target_monthly_option_premium?: number | null, chargeback_deadline?: number | null, cashout_deadline?: number | null, rental?: { __typename: 'rentals', id: any, rental_program_type: Rental_Program_Types_Enum_Enum, lease_variant: Lease_Variants_Enum_Enum, rental_users: Array<{ __typename: 'rental_users', id: any, user: { __typename: 'users', id: any, first_name?: string | null, last_name?: string | null } }>, evictions: Array<{ __typename: 'evictions', id: any, status: string, filed_at?: any | null }>, cashout?: { __typename: 'cashouts', id: any, status: any, maintenance_chargebacks_finalized_at?: any | null, final_wallet_amount?: any | null } | null, statements: Array<{ __typename: 'statements', id?: any | null, ending_balance?: any | null }>, portfolio_home?: { __typename: 'portfolio_homes', id: any, most_recent_llc_property?: { __typename: 'most_recent_llc_property', id?: any | null, llc?: { __typename: 'llcs', id: any, name: string, fund_llcs: Array<{ __typename: 'fund_llcs', id: any, fund: { __typename: 'funds', id: any, name: string } }> } | null } | null } | null } | null }> };

export type UserListQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UserListQuery = { __typename: 'query_root', users: Array<{ __typename: 'users', id: any, first_name?: string | null, last_name?: string | null, user_contact_details: Array<{ __typename: 'user_contact_details', id: any, contact_type: string, contact_info: string }> }> };

export const ListedRentFragmentDoc = gql`
    fragment ListedRent on portfolio_homes {
  listed_rents(limit: 1, order_by: {created_at: desc}) {
    id
    listed_rent
    base_rent
  }
}
    `;
export const ActiveUnderwriteFragmentDoc = gql`
    fragment ActiveUnderwrite on mls_listings {
  active_underwrite: opportunity_underwrites(
    limit: 1
    where: {is_for_sale_and_in_buy_box: {_eq: true}}
  ) {
    id
    target_rent
  }
}
    `;
export const ActiveRentReadyDateFragmentDoc = gql`
    fragment ActiveRentReadyDate on mls_listings {
  rent_ready_dates(
    limit: 1
    order_by: {created_at: desc}
    where: {is_active: {_eq: true}}
  ) {
    id
    earliest_move_in_date
  }
}
    `;
export const ConstructionIdsFragmentDoc = gql`
    fragment ConstructionIds on construction_projects {
  id
  construction_scopes {
    id
    construction_estimates {
      id
    }
  }
}
    `;
export const ConstructionProjectsFragmentDoc = gql`
    fragment ConstructionProjects on construction_projects {
  id
  created_at
  type
  status
  substatus
  tracking_status
  start_date
  end_date
  estimated_cost
  actual_cost
  admin {
    id
    first_name
    last_name
  }
}
    `;
export const ActiveRentalAgreementHistoriesFragmentDoc = gql`
    fragment ActiveRentalAgreementHistories on rentals {
  rental_agreement_histories(
    order_by: {ends_at: desc_nulls_first}
    where: {is_active: {_eq: true}}
  ) {
    id
    starts_at
    rent
  }
}
    `;
export const PrimaryContactDetailsFragmentDoc = gql`
    fragment PrimaryContactDetails on users {
  primary_phone: user_contact_details(
    limit: 1
    where: {is_primary_for_contact_type: {_eq: true}, contact_type: {_eq: "phone"}}
  ) {
    id
    contact_info
    contact_type
  }
  primary_email: user_contact_details(
    limit: 1
    where: {is_primary_for_contact_type: {_eq: true}, contact_type: {_eq: "email"}}
  ) {
    id
    contact_info
    contact_type
  }
}
    `;
export const PrimaryRentalUserFragmentDoc = gql`
    fragment PrimaryRentalUser on rentals {
  primary_rental_user: rental_users(
    where: {role: {_eq: "primary"}}
    order_by: {deactivated_at: desc_nulls_first}
  ) {
    id
    role
    user {
      id
      first_name
      last_name
      ...PrimaryContactDetails
    }
  }
}
    ${PrimaryContactDetailsFragmentDoc}`;
export const PortfolioHomesRentalHistoryFragmentDoc = gql`
    fragment PortfolioHomesRentalHistory on portfolio_homes {
  id
  rentals(order_by: {occupancy_date: desc_nulls_last}) {
    id
    occupancy_date
    status
    move_out_date
    ...ActiveRentalAgreementHistories
    ...PrimaryRentalUser
  }
}
    ${ActiveRentalAgreementHistoriesFragmentDoc}
${PrimaryRentalUserFragmentDoc}`;
export const ConstructionWalkthroughsFragmentDoc = gql`
    fragment ConstructionWalkthroughs on construction_walkthroughs {
  id
  type
  start_at
  status
  external_source
  external_link
  admin {
    id
    first_name
    last_name
  }
  note {
    note
  }
}
    `;
export const WorkOrdersHistoryFragmentDoc = gql`
    fragment WorkOrdersHistory on work_orders {
  id
  created_at
  actual_completion_date
  description
  status
  type
  priority
  vendor_id
  bid_price
  vendor {
    id
    name
  }
}
    `;
export const Homes360HeaderOpportunityPhotosFragmentDoc = gql`
    fragment Homes360HeaderOpportunityPhotos on opportunities {
  id
  photos(
    limit: 1
    order_by: {display_order: asc_nulls_last}
    where: {is_deleted: {_eq: false}}
  ) {
    id
    url
    display_order
  }
}
    `;
export const LockboxCodeDisplayDataFragmentDoc = gql`
    fragment LockboxCodeDisplayData on lockbox_codes {
  id
  code
  created_at
  admin {
    id
    first_name
    last_name
  }
}
    `;
export const LockboxCodeFragmentDoc = gql`
    fragment LockboxCode on portfolio_homes {
  id
  active_lockbox_code: lockbox_codes(
    where: {deactivated_at: {_is_null: true}}
    limit: 1
  ) {
    ...LockboxCodeDisplayData
  }
}
    ${LockboxCodeDisplayDataFragmentDoc}`;
export const Homes360HeaderFragmentDoc = gql`
    fragment Homes360Header on homes360 {
  id
  city
  beds
  baths_total
  display_line_1
  display_line_2
  year_built
  sqft
  market {
    id
    display_name
  }
  occupancy_status
  construction_status
  ownership_status
  summary_status
  portfolio_home {
    id
    rental_program_type
    real_estate_acquisition {
      final_purchase_price
      closing_date
      opportunity {
        ...Homes360HeaderOpportunityPhotos
      }
    }
    down_status_incidents(where: {stage: {_eq: "active"}}) {
      id
      type
      stage
      created_at
    }
    ...LockboxCode
  }
  opportunities {
    ...Homes360HeaderOpportunityPhotos
    real_estate_acquisitions(
      where: {status: {_neq: "canceled"}}
      limit: 1
      order_by: {created_at: desc}
    ) {
      id
      final_purchase_price
      closing_date
    }
  }
}
    ${Homes360HeaderOpportunityPhotosFragmentDoc}
${LockboxCodeFragmentDoc}`;
export const UnderwriteInfoFragmentDoc = gql`
    fragment UnderwriteInfo on underwrites_opportunity_underwrites {
  id
  target_rent
  target_cap_rate
  upfront_improvements_cost
  sellers_credits
}
    `;
export const MlsListingFragmentFragmentDoc = gql`
    fragment MlsListingFragment on mls_listings {
  id
  area
  baths_total
  beds
  city
  display_line_1
  firestore_id
  listing_date
  list_price
  mls
  provider
  size
  state
  year_built
  zip
  internal_attributes {
    id
    internal_status
  }
  opportunity_underwrites(
    order_by: {created_at: desc}
    where: {is_for_sale_and_in_buy_box: {_eq: true}}
  ) {
    ...UnderwriteInfo
  }
  rent_ready_dates(where: {is_active: {_eq: true}}) {
    id
    earliest_move_in_date
    type
  }
  market {
    id
    display_name
  }
}
    ${UnderwriteInfoFragmentDoc}`;
export const OpportunityFragmentFragmentDoc = gql`
    fragment OpportunityFragment on opportunities {
  id
  firestore_id
  listing_date
  list_price
  mls
  provider
  internal_attributes {
    id
    internal_status
  }
  opportunity_underwrites(
    order_by: {created_at: desc}
    where: {is_for_sale_and_in_buy_box: {_eq: true}}
  ) {
    ...UnderwriteInfo
  }
  rent_ready_dates(where: {is_active: {_eq: true}}) {
    id
    earliest_move_in_date
    type
  }
}
    ${UnderwriteInfoFragmentDoc}`;
export const AcquisitionInfoFragmentFragmentDoc = gql`
    fragment AcquisitionInfoFragment on real_estate_acquisitions {
  id
  closing_date
  type
  status
  final_purchase_price
  final_sellers_credits_amount
  mls_listing {
    ...MlsListingFragment
  }
  opportunity {
    ...OpportunityFragment
  }
  final_ic_opportunity_underwrite {
    ...UnderwriteInfo
  }
}
    ${MlsListingFragmentFragmentDoc}
${OpportunityFragmentFragmentDoc}
${UnderwriteInfoFragmentDoc}`;
export const PropertyInfoFragmentDoc = gql`
    fragment PropertyInfo on properties {
  id
  exit_date
  exit_price
  real_estate_acquisition {
    ...AcquisitionInfoFragment
  }
}
    ${AcquisitionInfoFragmentFragmentDoc}`;
export const PortfolioHomeInfoFragmentDoc = gql`
    fragment PortfolioHomeInfo on portfolio_homes {
  id
  exit_date
  exit_price
  real_estate_acquisition {
    ...AcquisitionInfoFragment
  }
}
    ${AcquisitionInfoFragmentFragmentDoc}`;
export const Homes360FragmentFragmentDoc = gql`
    fragment Homes360Fragment on homes360 {
  id
  display_line_1
  sqft
  city
  state
  zip
  beds
  year_built
  baths_total
  market {
    id
    display_name
  }
  most_recent_rental_move_out_date
  occupancy_status
  construction_status
  ownership_status
  summary_status
  fund_name
  entity_name
  most_recent_rental_id
  tenant_first_name
  tenant_last_name
}
    `;
export const WithAddressInfoFragmentDoc = gql`
    fragment WithAddressInfo on rentals {
  portfolio_home {
    id
    home {
      id
      address {
        id
        state
        display_line_1
        display_line_2
      }
    }
  }
}
    `;
export const CashoutAdminFragmentDoc = gql`
    fragment CashoutAdmin on admins {
  id
  first_name
  last_name
}
    `;
export const RentRollLiabilityTypeFragmentDoc = gql`
    fragment RentRollLiabilityType on liability_types {
  id
  name
  payment_category
}
    `;
export const CashoutFragmentDoc = gql`
    fragment Cashout on rentals {
  id
  move_out_date
  tenant_notice_given_on_date
  cashout {
    id
    status
    paid_out_amount
    cashed_out_at
    cashed_out_by_admin {
      ...CashoutAdmin
    }
    utilities_finalized_at
    utilities_finalized_by_admin {
      ...CashoutAdmin
    }
    maintenance_chargebacks_finalized_at
    maintenance_chargebacks_finalized_by_admin {
      ...CashoutAdmin
    }
    adjustments_finalized_at
    adjustments_finalized_by_admin {
      ...CashoutAdmin
    }
    user {
      id
      first_name
      last_name
    }
    cashout_adjustments(order_by: {type: desc}) {
      id
      liability_type_id
      liability_type {
        ...RentRollLiabilityType
      }
      type
      amount
      date
    }
  }
  current_statement {
    id
    ending_balance
    ending_premium_factor
    month
    starting_balance
    starting_premium_factor
    sum_contributions
  }
  rent_roll {
    chargeback_deadline
    cashout_deadline
  }
}
    ${CashoutAdminFragmentDoc}
${RentRollLiabilityTypeFragmentDoc}`;
export const CashoutDetailsFragmentDoc = gql`
    fragment CashoutDetails on rentals {
  lease_end_reason
  rental_program_type
  rental_agreement_histories(
    where: {is_active: {_eq: true}}
    order_by: {starts_at: asc}
  ) {
    id
    starts_at
    ends_at
  }
  ...WithAddressInfo
  ...PrimaryRentalUser
  ...Cashout
}
    ${WithAddressInfoFragmentDoc}
${PrimaryRentalUserFragmentDoc}
${CashoutFragmentDoc}`;
export const RentRollTenantFragmentDoc = gql`
    fragment RentRollTenant on users {
  id
  first_name
  last_name
  user_contact_details(where: {is_primary_for_contact_type: {_eq: true}}) {
    id
    contact_info
    contact_type
  }
}
    `;
export const TenantsFragmentDoc = gql`
    fragment Tenants on rentals {
  id
  status
  buildium_lease_id
  rental_users {
    id
    user_id
    role
    deactivated_at
    user {
      ...RentRollTenant
    }
  }
}
    ${RentRollTenantFragmentDoc}`;
export const OccupantsFragmentDoc = gql`
    fragment Occupants on rentals {
  rental_occupants {
    occupant_number
    occupant_name
    occupant_age
    occupant_relation
  }
  rental_application {
    rental_application_occupants(order_by: [{created_at: asc}, {id: asc}]) {
      id
      name
      age
      relation
    }
  }
}
    `;
export const LlcInfoFragmentDoc = gql`
    fragment LlcInfo on llcs {
  id
  name
  ledger_account {
    id
    name
  }
}
    `;
export const RentRollRentalPropertyFragmentDoc = gql`
    fragment RentRollRentalProperty on properties {
  id
  most_recent_llc_property {
    id
    start_date
    end_date
    llc {
      ...LlcInfo
    }
  }
  llc_properties(
    order_by: {start_date: desc}
    where: {llc: {abbreviation: {_is_null: false}}}
  ) {
    id
    start_date
    end_date
    llc {
      ...LlcInfo
    }
  }
}
    ${LlcInfoFragmentDoc}`;
export const WithLlcInfoFragmentDoc = gql`
    fragment WithLlcInfo on rentals {
  property {
    ...RentRollRentalProperty
  }
}
    ${RentRollRentalPropertyFragmentDoc}`;
export const RentRollDocumentFragmentDoc = gql`
    fragment RentRollDocument on documents {
  id
  friendly_name
  created_at
  reviewed_at
  uploaded_by_admin {
    first_name
    last_name
  }
  admin {
    first_name
    last_name
  }
  review_notes
  status
  type
}
    `;
export const RentRollDocumentsFragmentDoc = gql`
    fragment RentRollDocuments on rentals {
  id
  status
  agreements(where: {status: {_eq: "complete"}}, order_by: {created_at: desc}) {
    id
    documents {
      ...RentRollDocument
    }
  }
  rental_application {
    id
    document_agreements: agreements(
      where: {status: {_eq: "complete"}}
      order_by: {created_at: desc}
    ) {
      id
      documents {
        ...RentRollDocument
      }
    }
  }
  documents {
    ...RentRollDocument
  }
}
    ${RentRollDocumentFragmentDoc}`;
export const CashoutSidebarFragmentDoc = gql`
    fragment CashoutSidebar on rentals {
  id
  rental_program_type
  ...WithAddressInfo
  ...Tenants
  ...Occupants
  ...WithLlcInfo
  ...Cashout
  ...RentRollDocuments
}
    ${WithAddressInfoFragmentDoc}
${TenantsFragmentDoc}
${OccupantsFragmentDoc}
${WithLlcInfoFragmentDoc}
${CashoutFragmentDoc}
${RentRollDocumentsFragmentDoc}`;
export const MlsSellerAgentDataFragmentDoc = gql`
    fragment mlsSellerAgentData on seller_agents {
  close_lead_id
  created_at
  do_not_contact
  email
  first_name
  id
  last_contacted_at
  last_name
  mls
  mls_id
  phone
}
    `;
export const MlsListingDataFragmentDoc = gql`
    fragment mlsListingData on mls_listings {
  area
  baths_full
  baths_half
  baths_total
  beds
  city
  co_listing_agent {
    ...mlsSellerAgentData
  }
  co_listing_office_id
  county
  created_at
  delivery_line
  description
  display_line_1
  display_line_2
  features_amenities
  features_appliances_and_equipment
  features_bathrooms
  features_bedrooms
  features_community
  features_cooling
  features_dining_room
  features_disclosures
  features_doors
  features_energy_saving
  features_exterior_features
  features_fees
  features_fence
  features_fireplaces
  features_foundation
  features_garage
  features_heating
  features_home_owners_association
  features_house
  features_interior
  features_interior_features
  features_kitchen
  features_laundry
  features_listing
  features_location
  features_lot
  features_miscellaneous
  features_parking
  features_pool
  features_property
  features_property_access
  features_roof
  features_schools
  features_security_system
  features_sewer
  features_spa
  features_taxes
  features_utilities
  features_water
  features_windows_and_doors
  geo_type
  id
  firestore_id
  internal_attributes {
    analyzed_images
    census_tract_county_code
    census_tract_income_level
    census_tract_median_family_income
    census_tract_percent_below_poverty_line
    census_tract_tract_code
    created_at
    guidance_price
    id
    internal_status
    is_census_tract_opportunity_zone
    is_in_customer_buy_box
    is_in_real_estate_buy_box
    is_persisted_in_algolia
    mls_listing_id
    neighborhood_levels
    percent_over_comp
    rating_base
    short_list_images
    tags
    updated_at
    url
    zillow_deep_search_results
  }
  is_new_construction
  last_updated_at
  lat
  list_price
  opportunity {
    id
    current_rent: listed_rents(order_by: {created_at: desc}, limit: 1) {
      id
      listed_rent
      base_rent
    }
  }
  listing_agent {
    ...mlsSellerAgentData
  }
  listing_date
  listing_office_id
  listing_type
  lng
  lotsize_acres
  lotsize_sqft
  market_id
  mls
  modified_at
  photos(order_by: {display_order: asc}, where: {is_deleted: {_eq: false}}) {
    created_at
    display_order
    id
    is_deleted
    updated_at
    url
  }
  property_type
  provider_id
  provider
  region
  school_district
  school_elementary
  school_high
  school_middle
  short_id
  size
  state
  status
  std_address
  street
  style
  subdivision
  system_id
  tour_url
  updated_at
  xf_attributes
  year_built
  zip
}
    ${MlsSellerAgentDataFragmentDoc}`;
export const PendingRenewalInfoFragmentDoc = gql`
    fragment PendingRenewalInfo on rentals {
  rahWithRenewal: rental_agreement_histories {
    renewals(order_by: {created_at: desc}) {
      id
      status
      lease_variant
      offered_at
      created_at
      kcpoa_terms
      canceled_at
      cancelation_reason
      completed_at
      scheduled_rental_liabilities(order_by: {created_at: desc}) {
        id
        amount
        due_date
        status
        last_error
      }
      selected_renewal_offer {
        id
        price
        term
        is_month_to_month
      }
      admin {
        id
        first_name
        last_name
      }
      agreement {
        id
        external_id
        metadata
        documents {
          id
          friendly_name
        }
        agreement_signers {
          id
          external_id
          external_source
          resource_id
          resource_type
          role
          status
          signed_at
        }
      }
    }
  }
  do_not_renew_reason
  do_not_renew_selected_at
  do_not_renew_notice_sent_at
  do_not_renew_selected_by_admin {
    id
    first_name
    last_name
  }
}
    `;
export const RentRollPendingEvictionsFragmentDoc = gql`
    fragment RentRollPendingEvictions on rentals {
  pending_evictions: evictions(where: {status: {_nin: ["completed", "canceled"]}}) {
    id
    status
    created_at
  }
}
    `;
export const MoveOutInfoFragmentDoc = gql`
    fragment MoveOutInfo on rentals {
  id
  status
  final_liability_date
  move_out_date
  lease_end_reason
  occupancy_date
  tenant_notice_given_on_date
}
    `;
export const AgreementSignerUserFragmentDoc = gql`
    fragment AgreementSignerUser on agreement_signers {
  id
  role
  user {
    ...RentRollTenant
  }
}
    ${RentRollTenantFragmentDoc}`;
export const WithRentalAgreementInfoFragmentDoc = gql`
    fragment WithRentalAgreementInfo on rentals {
  id
  occupancy_date
  target_monthly_option_premium
  daily_late_fee_amount
  rental_agreement_histories(
    where: {is_active: {_eq: true}}
    order_by: {ends_at: desc}
  ) {
    id
    option_premium
    rent
    starts_at
    ends_at
    type
    renewal_months
    agreement {
      id
      agreement_signers(where: {resource_type: {_eq: "users"}}) {
        ...AgreementSignerUser
      }
    }
  }
}
    ${AgreementSignerUserFragmentDoc}`;
export const CollectionsFragmentDoc = gql`
    fragment Collections on rentals {
  collections {
    id
    month
    late_payment_reason
    zendesk_link
    note {
      id
      note
    }
  }
}
    `;
export const PortfolioHomeDispositionsFragmentDoc = gql`
    fragment PortfolioHomeDispositions on rentals {
  id
  portfolio_home {
    id
    exit_date
    portfolio_home_dispositions(where: {status: {_neq: "canceled"}}) {
      id
      sale_type
      status
    }
  }
}
    `;
export const CashoutStatusInfoFragmentDoc = gql`
    fragment CashoutStatusInfo on rentals {
  id
  move_out_date
  tenant_notice_given_on_date
  cashout {
    id
    status
    paid_out_amount
    cashed_out_at
    cashed_out_by_admin {
      ...CashoutAdmin
    }
    utilities_finalized_at
    utilities_finalized_by_admin {
      ...CashoutAdmin
    }
    maintenance_chargebacks_finalized_at
    maintenance_chargebacks_finalized_by_admin {
      ...CashoutAdmin
    }
    adjustments_finalized_at
    adjustments_finalized_by_admin {
      ...CashoutAdmin
    }
    user {
      id
      first_name
      last_name
    }
  }
  rent_roll {
    chargeback_deadline
    cashout_deadline
  }
}
    ${CashoutAdminFragmentDoc}`;
export const RentRollDetailsRentalFragmentDoc = gql`
    fragment RentRollDetailsRental on rentals {
  ...PendingRenewalInfo
  ...RentRollPendingEvictions
  ...WithAddressInfo
  ...MoveOutInfo
  ...WithRentalAgreementInfo
  ...Collections
  ...Tenants
  ...Occupants
  ...PortfolioHomeDispositions
  ...CashoutStatusInfo
  id
  initial_option_premium
  status
  target_monthly_option_premium
  rental_program_type
  lease_variant
  buildium_lease_id
  utility_chargeback_override {
    rental_id
    mode
    set_at
    reason
  }
  property {
    ...RentRollRentalProperty
  }
}
    ${PendingRenewalInfoFragmentDoc}
${RentRollPendingEvictionsFragmentDoc}
${WithAddressInfoFragmentDoc}
${MoveOutInfoFragmentDoc}
${WithRentalAgreementInfoFragmentDoc}
${CollectionsFragmentDoc}
${TenantsFragmentDoc}
${OccupantsFragmentDoc}
${PortfolioHomeDispositionsFragmentDoc}
${CashoutStatusInfoFragmentDoc}
${RentRollRentalPropertyFragmentDoc}`;
export const RecurringCreditsFragmentDoc = gql`
    fragment RecurringCredits on rentals {
  recurring_credits {
    id
    start_date
    num_months
    total_amount
    notes
    liability_type {
      id
      name
    }
  }
}
    `;
export const PortfolioHomeUtilitiesFragmentDoc = gql`
    fragment PortfolioHomeUtilities on portfolio_homes {
  id
  portfolio_home_utilities {
    id
    deactivated_at
    default_responsible_party
    utility_type {
      id
      name
    }
  }
}
    `;
export const WithPortfolioHomeUtilitiesFragmentDoc = gql`
    fragment WithPortfolioHomeUtilities on rentals {
  portfolio_home {
    id
    ...PortfolioHomeUtilities
  }
}
    ${PortfolioHomeUtilitiesFragmentDoc}`;
export const RentRollPaymentFragmentDoc = gql`
    fragment RentRollPayment on payments {
  amount
  available_on
  category
  created_at
  id
  liability_type {
    ...RentRollLiabilityType
  }
  note
  payment_date
  payment_method
  status
  stripe_charge_id
  stripe_payment_intent_id
  lifecycle
  initiated_at
  refund_reason
  buildium_transaction {
    id
    buildium_id
    type
    date
    amount
    metadata
  }
}
    ${RentRollLiabilityTypeFragmentDoc}`;
export const RentRollRentalLiabilitiesFragmentDoc = gql`
    fragment RentRollRentalLiabilities on rental_liabilities {
  amount
  date
  id
  note
  buildium_id
  payment_plan_liability {
    id
  }
  liability_type {
    ...RentRollLiabilityType
  }
}
    ${RentRollLiabilityTypeFragmentDoc}`;
export const UtilityResponsibilitiesFragmentDoc = gql`
    fragment UtilityResponsibilities on rentals {
  id
  utility_responsibilities {
    id
    created_at
    responsible_party
    start_date
    created_by_admin_id
    admin {
      id
      first_name
      last_name
    }
    portfolio_home_utility {
      id
      default_responsible_party
      deactivated_at
      utility_type {
        id
        name
        liability_type_id
        liability_type {
          name
        }
      }
    }
  }
}
    `;
export const CurrentUtilityResponsibilitiesFragmentDoc = gql`
    fragment CurrentUtilityResponsibilities on rentals {
  id
  current_utility_responsibilities(
    order_by: {portfolio_home_utility: {utility_type: {name: asc}}}
  ) {
    id
    created_at
    responsible_party
    start_date
    created_by_admin_id
    admin {
      id
      first_name
      last_name
    }
    portfolio_home_utility {
      id
      default_responsible_party
      deactivated_at
      utility_type {
        id
        name
        liability_type_id
        liability_type {
          name
        }
      }
    }
  }
}
    `;
export const RentRollListRentalFragmentDoc = gql`
    fragment RentRollListRental on rentals {
  id
  initial_option_premium
  status
  target_monthly_option_premium
  rental_program_type
  buildium_lease_id
  has_signed_utility_addendum
  ...RecurringCredits
  ...WithAddressInfo
  ...WithPortfolioHomeUtilities
  ...MoveOutInfo
  payments(where: {_not: {category: {_eq: "initial_payment"}}}) {
    ...RentRollPayment
  }
  property {
    ...RentRollRentalProperty
  }
  rental_credits {
    id
    buildium_id
    payment_plan_offset_credits(limit: 1) {
      id
    }
    liability_type {
      ...RentRollLiabilityType
    }
    amount
    date
    note
    type
  }
  ...WithRentalAgreementInfo
  rental_liabilities {
    ...RentRollRentalLiabilities
  }
  option_premium_transfers_received {
    id
    amount
    from_rental_id
    date
  }
  ...Collections
  ...Cashout
  ...Tenants
  ...Occupants
  ...UtilityResponsibilities
  ...CurrentUtilityResponsibilities
  ...PortfolioHomeDispositions
}
    ${RecurringCreditsFragmentDoc}
${WithAddressInfoFragmentDoc}
${WithPortfolioHomeUtilitiesFragmentDoc}
${MoveOutInfoFragmentDoc}
${RentRollPaymentFragmentDoc}
${RentRollRentalPropertyFragmentDoc}
${RentRollLiabilityTypeFragmentDoc}
${WithRentalAgreementInfoFragmentDoc}
${RentRollRentalLiabilitiesFragmentDoc}
${CollectionsFragmentDoc}
${CashoutFragmentDoc}
${TenantsFragmentDoc}
${OccupantsFragmentDoc}
${UtilityResponsibilitiesFragmentDoc}
${CurrentUtilityResponsibilitiesFragmentDoc}
${PortfolioHomeDispositionsFragmentDoc}`;
export const RentRollRentalAddOnsFragmentDoc = gql`
    fragment RentRollRentalAddOns on rental_add_ons {
  id
  updated_at
  end_date
  price
  start_date
  liability_type {
    ...RentRollLiabilityType
  }
}
    ${RentRollLiabilityTypeFragmentDoc}`;
export const RentRollRentalMoveInFeesFragmentDoc = gql`
    fragment RentRollRentalMoveInFees on rental_move_in_fees {
  id
  amount
  liability_type {
    ...RentRollLiabilityType
  }
}
    ${RentRollLiabilityTypeFragmentDoc}`;
export const RentRollApplicationAgreementFragmentDoc = gql`
    fragment RentRollApplicationAgreement on agreements {
  id
  type
  metadata
}
    `;
export const RentRollRentalFragmentDoc = gql`
    fragment RentRollRental on rentals {
  ...RentRollDocuments
  ...RentRollListRental
  ...PendingRenewalInfo
  ...RentRollPendingEvictions
  rental_add_ons {
    ...RentRollRentalAddOns
  }
  rental_move_in_fees(where: {deactivated_at: {_is_null: true}}) {
    ...RentRollRentalMoveInFees
  }
  rental_application {
    id
    lead_group {
      id
    }
    agreements(where: {status: {_eq: "complete"}}, order_by: {created_at: desc}) {
      ...RentRollApplicationAgreement
      documents {
        id
        admin {
          id
          first_name
          last_name
        }
        created_at
        external_id
        external_source
        friendly_name
        review_notes
        reviewed_at
        status
      }
      agreement_signers(where: {resource_type: {_eq: "users"}}) {
        id
        role
        user {
          id
          first_name
          last_name
          user_contact_details(where: {is_primary_for_contact_type: {_eq: true}}) {
            id
            contact_type
            contact_info
          }
        }
      }
    }
  }
}
    ${RentRollDocumentsFragmentDoc}
${RentRollListRentalFragmentDoc}
${PendingRenewalInfoFragmentDoc}
${RentRollPendingEvictionsFragmentDoc}
${RentRollRentalAddOnsFragmentDoc}
${RentRollRentalMoveInFeesFragmentDoc}
${RentRollApplicationAgreementFragmentDoc}`;
export const Mls_Listing_ItemsFragmentDoc = gql`
    fragment mls_listing_items on mls_listings {
  id
  delivery_line
  city
  state
  county
  zip
  description
  size
  list_price
  property_type
  area
  baths_full
  baths_half
  baths_total
  firestore_id
  status
  lotsize_sqft
  market {
    id
    name
    short_name
    display_name
  }
  internal_attributes {
    internal_status
  }
}
    `;
export const Tour_ItemsFragmentDoc = gql`
    fragment tour_items on tours {
  id
  status
  type
  start_at
  created_at
  completed_at
  canceled_at
  lead_group_confirmed_at
  cancelation_reason
  agent {
    id
    first_name
    last_name
    status
    email
    phone
  }
  tour_properties @include(if: $with_property_details) {
    id
    mls_listing {
      ...mls_listing_items
    }
  }
}
    ${Mls_Listing_ItemsFragmentDoc}`;
export const Primary_User_NameFragmentDoc = gql`
    fragment primary_user_name on lead_groups {
  lead_group_users(
    where: {type: {_eq: "primary"}, deactivated_at: {_is_null: true}}
  ) {
    id
    user {
      id
      first_name
      last_name
    }
  }
}
    `;
export const Rental_Applications_ItemsFragmentDoc = gql`
    fragment rental_applications_items on rental_applications {
  id
  status
  created_at
  completed_at
  projected_occupancy_date
  is_underwriting_approved
  underwritten_at
  canceled_at
  cancelation_reason
  mls_listing @include(if: $with_property_details) {
    ...mls_listing_items
  }
  lead_group {
    id
    ...primary_user_name
  }
}
    ${Mls_Listing_ItemsFragmentDoc}
${Primary_User_NameFragmentDoc}`;
export const Conversations_ItemsFragmentDoc = gql`
    fragment conversations_items on conversations {
  id
  medium
  from
  external_source
  direction
  created_at
  status
  payload
}
    `;
export const Rental_Site_Lead_ItemsFragmentDoc = gql`
    fragment rental_site_lead_items on rental_site_leads {
  id
  lead_comments
  created_at
  rental_site_listing {
    id
    rental_site_account {
      id
      source
    }
    mls_listing @include(if: $with_property_details) {
      ...mls_listing_items
    }
  }
}
    ${Mls_Listing_ItemsFragmentDoc}`;
export const RentRollDocumentsPanelDocumentFragmentDoc = gql`
    fragment RentRollDocumentsPanelDocument on documents {
  id
  friendly_name
  created_at
  type
  uploaded_by_admin {
    first_name
    last_name
  }
}
    `;
export const MoveInFeesFragmentDoc = gql`
    fragment MoveInFees on rentals {
  rental_move_in_fees {
    ...RentRollRentalMoveInFees
  }
  id
  occupancy_date
  status
}
    ${RentRollRentalMoveInFeesFragmentDoc}`;
export const AddOnsFragmentDoc = gql`
    fragment AddOns on rentals {
  rental_add_ons {
    ...RentRollRentalAddOns
  }
  id
  occupancy_date
}
    ${RentRollRentalAddOnsFragmentDoc}`;
export const AcquisitionDetailsByPropertyIdDocument = gql`
    query AcquisitionDetailsByPropertyId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    real_estate_acquisition {
      ...AcquisitionInfoFragment
    }
  }
}
    ${AcquisitionInfoFragmentFragmentDoc}`;

export function useAcquisitionDetailsByPropertyIdQuery(options: Omit<Urql.UseQueryArgs<AcquisitionDetailsByPropertyIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AcquisitionDetailsByPropertyIdQuery, AcquisitionDetailsByPropertyIdQueryVariables>({ query: AcquisitionDetailsByPropertyIdDocument, ...options });
};
export const DocumentResourceIdsByPropertyIdDocument = gql`
    query DocumentResourceIdsByPropertyId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    home {
      id
    }
    rentals {
      id
      construction_projects {
        id
      }
    }
    real_estate_acquisition {
      id
      construction_projects {
        id
      }
    }
    work_orders {
      id
    }
  }
  dispositions_portfolio_home_dispositions {
    id
    portfolio_home_disposition_bids {
      id
    }
  }
}
    `;

export function useDocumentResourceIdsByPropertyIdQuery(options: Omit<Urql.UseQueryArgs<DocumentResourceIdsByPropertyIdQueryVariables>, 'query'>) {
  return Urql.useQuery<DocumentResourceIdsByPropertyIdQuery, DocumentResourceIdsByPropertyIdQueryVariables>({ query: DocumentResourceIdsByPropertyIdDocument, ...options });
};
export const EntityDetailsByPortfolioHomeIdDocument = gql`
    query EntityDetailsByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    llc_property_transfers(
      limit: 1
      where: {completed_at: {_is_null: false}}
      order_by: {completed_at: desc}
    ) {
      id
      completed_at
    }
    most_recent_llc_property {
      id
      llc {
        id
        name
        fund_llcs(limit: 1, order_by: {start_date: desc}) {
          id
          fund {
            id
            name
            abbreviation
          }
        }
      }
    }
  }
}
    `;

export function useEntityDetailsByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<EntityDetailsByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<EntityDetailsByPortfolioHomeIdQuery, EntityDetailsByPortfolioHomeIdQueryVariables>({ query: EntityDetailsByPortfolioHomeIdDocument, ...options });
};
export const LatchelPropertyIdByPortfolioHomeIdDocument = gql`
    query LatchelPropertyIdByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    latchel_property_id
  }
}
    `;

export function useLatchelPropertyIdByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<LatchelPropertyIdByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LatchelPropertyIdByPortfolioHomeIdQuery, LatchelPropertyIdByPortfolioHomeIdQueryVariables>({ query: LatchelPropertyIdByPortfolioHomeIdDocument, ...options });
};
export const UpdateLatchelPropertyIdByPortfolioHomeIdDocument = gql`
    mutation UpdateLatchelPropertyIdByPortfolioHomeId($portfolioHomeId: uuid!, $latchelPropertyId: Int!) {
  update_portfolio_homes_by_pk(
    pk_columns: {id: $portfolioHomeId}
    _set: {latchel_property_id: $latchelPropertyId}
  ) {
    id
    latchel_property_id
  }
}
    `;

export function useUpdateLatchelPropertyIdByPortfolioHomeIdMutation() {
  return Urql.useMutation<UpdateLatchelPropertyIdByPortfolioHomeIdMutation, UpdateLatchelPropertyIdByPortfolioHomeIdMutationVariables>(UpdateLatchelPropertyIdByPortfolioHomeIdDocument);
};
export const ListingPhotosByPortfolioHomeIdDocument = gql`
    query ListingPhotosByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    real_estate_acquisition {
      id
      opportunity {
        id
        photos(
          where: {is_deleted: {_eq: false}}
          order_by: {display_order: asc_nulls_last}
        ) {
          created_at
          display_order
          id
          is_deleted
          updated_at
          url
        }
      }
    }
  }
}
    `;

export function useListingPhotosByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<ListingPhotosByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ListingPhotosByPortfolioHomeIdQuery, ListingPhotosByPortfolioHomeIdQueryVariables>({ query: ListingPhotosByPortfolioHomeIdDocument, ...options });
};
export const MarketingDetailsByPropertyIdDocument = gql`
    query MarketingDetailsByPropertyId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    ...ListedRent
    real_estate_acquisition {
      id
      mls_listing {
        id
        ...ActiveUnderwrite
        ...ActiveRentReadyDate
        internal_attributes(limit: 1, order_by: {created_at: desc}) {
          id
          internal_status
          url
        }
      }
    }
  }
}
    ${ListedRentFragmentDoc}
${ActiveUnderwriteFragmentDoc}
${ActiveRentReadyDateFragmentDoc}`;

export function useMarketingDetailsByPropertyIdQuery(options: Omit<Urql.UseQueryArgs<MarketingDetailsByPropertyIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketingDetailsByPropertyIdQuery, MarketingDetailsByPropertyIdQueryVariables>({ query: MarketingDetailsByPropertyIdDocument, ...options });
};
export const GetPortfolioHomeWithFeaturesDocument = gql`
    query GetPortfolioHomeWithFeatures($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    community_id
    community {
      id
      name
      community_features {
        id
        community_id
        hoa_contact_name
        hoa_contact_email
        amenity_fee
        amenity_details
        pool
        playground
        landscaping
        security
        dog_park
        nature
        created_at
        updated_at
      }
    }
    portfolio_home_internal_features {
      id
      portfolio_home_id
      washer_dryer
      basement
      warranties
      appliances
      utilities_exception
      created_at
      updated_at
    }
    portfolio_home_external_features {
      id
      portfolio_home_id
      security
      mailbox_info
      garage
      parking
      gate
      fence
      shed
      created_at
      updated_at
    }
  }
}
    `;

export function useGetPortfolioHomeWithFeaturesQuery(options: Omit<Urql.UseQueryArgs<GetPortfolioHomeWithFeaturesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPortfolioHomeWithFeaturesQuery, GetPortfolioHomeWithFeaturesQueryVariables>({ query: GetPortfolioHomeWithFeaturesDocument, ...options });
};
export const ResourceIdsByPortfolioHomeIdDocument = gql`
    query ResourceIdsByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    home {
      id
      opportunities {
        id
        real_estate_screenings {
          id
        }
        bids {
          id
        }
      }
    }
    construction_walkthroughs {
      id
    }
    rentals {
      id
      rental_application {
        id
        move_ins {
          id
        }
      }
      evictions {
        id
      }
      construction_projects {
        ...ConstructionIds
      }
    }
    real_estate_acquisition {
      id
      real_estate_screening {
        id
      }
      construction_projects {
        ...ConstructionIds
      }
    }
    work_orders {
      id
    }
  }
}
    ${ConstructionIdsFragmentDoc}`;

export function useResourceIdsByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<ResourceIdsByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ResourceIdsByPortfolioHomeIdQuery, ResourceIdsByPortfolioHomeIdQueryVariables>({ query: ResourceIdsByPortfolioHomeIdDocument, ...options });
};
export const UtilityTypesDocument = gql`
    query UtilityTypes {
  utility_types {
    id
    name
    liability_type {
      id
      deactivated_at
      is_variable
    }
  }
}
    `;

export function useUtilityTypesQuery(options?: Omit<Urql.UseQueryArgs<UtilityTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilityTypesQuery, UtilityTypesQueryVariables>({ query: UtilityTypesDocument, ...options });
};
export const UtilityDetailsByPortfolioHomeIdDocument = gql`
    query UtilityDetailsByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    conservice_property_id
    portfolio_home_utilities(where: {deactivated_at: {_is_null: true}}) {
      id
      default_responsible_party
      utility_type {
        id
        name
      }
    }
  }
}
    `;

export function useUtilityDetailsByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<UtilityDetailsByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilityDetailsByPortfolioHomeIdQuery, UtilityDetailsByPortfolioHomeIdQueryVariables>({ query: UtilityDetailsByPortfolioHomeIdDocument, ...options });
};
export const CreateNewLockboxCodeDocument = gql`
    mutation CreateNewLockboxCode($portfolioHomeId: uuid!, $code: String!) {
  update_lockbox_codes(
    where: {portfolio_home_id: {_eq: $portfolioHomeId}}
    _set: {deactivated_at: "now()"}
  ) {
    affected_rows
  }
  insert_lockbox_codes_one(
    object: {portfolio_home_id: $portfolioHomeId, code: $code}
  ) {
    ...LockboxCodeDisplayData
  }
}
    ${LockboxCodeDisplayDataFragmentDoc}`;

export function useCreateNewLockboxCodeMutation() {
  return Urql.useMutation<CreateNewLockboxCodeMutation, CreateNewLockboxCodeMutationVariables>(CreateNewLockboxCodeDocument);
};
export const ConstructionByPortfolioHomeIdDocument = gql`
    query ConstructionByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    construction_projects {
      ...ConstructionProjects
    }
  }
}
    ${ConstructionProjectsFragmentDoc}`;

export function useConstructionByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<ConstructionByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ConstructionByPortfolioHomeIdQuery, ConstructionByPortfolioHomeIdQueryVariables>({ query: ConstructionByPortfolioHomeIdDocument, ...options });
};
export const PortfolioHomeSystemWorkOrdersByPortfolioHomeIdDocument = gql`
    query PortfolioHomeSystemWorkOrdersByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_home_system_work_orders(
    where: {portfolio_home_id: {_eq: $portfolioHomeId}}
  ) {
    portfolio_home {
      id
      home {
        id
        address {
          display_line_1
          display_line_2
        }
      }
    }
    id
    system
    type
    under_warranty
    vendor {
      id
      name
    }
    service_date
    warranty_end_date
    notes
  }
}
    `;

export function usePortfolioHomeSystemWorkOrdersByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<PortfolioHomeSystemWorkOrdersByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<PortfolioHomeSystemWorkOrdersByPortfolioHomeIdQuery, PortfolioHomeSystemWorkOrdersByPortfolioHomeIdQueryVariables>({ query: PortfolioHomeSystemWorkOrdersByPortfolioHomeIdDocument, ...options });
};
export const PortfolioHomeSystemWorkOrdersDocument = gql`
    query PortfolioHomeSystemWorkOrders {
  portfolio_home_system_work_orders(order_by: {service_date: desc}) {
    portfolio_home {
      id
      home {
        id
        address {
          display_line_1
          display_line_2
        }
      }
    }
    id
    system
    type
    under_warranty
    vendor {
      id
      name
    }
    service_date
    warranty_end_date
    notes
  }
}
    `;

export function usePortfolioHomeSystemWorkOrdersQuery(options?: Omit<Urql.UseQueryArgs<PortfolioHomeSystemWorkOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<PortfolioHomeSystemWorkOrdersQuery, PortfolioHomeSystemWorkOrdersQueryVariables>({ query: PortfolioHomeSystemWorkOrdersDocument, ...options });
};
export const RentalHistoryByPortfolioHomeIdDocument = gql`
    query RentalHistoryByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    ...PortfolioHomesRentalHistory
  }
}
    ${PortfolioHomesRentalHistoryFragmentDoc}`;

export function useRentalHistoryByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<RentalHistoryByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalHistoryByPortfolioHomeIdQuery, RentalHistoryByPortfolioHomeIdQueryVariables>({ query: RentalHistoryByPortfolioHomeIdDocument, ...options });
};
export const WalkthroughsByPortfolioHomeIdDocument = gql`
    query WalkthroughsByPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    construction_walkthroughs {
      ...ConstructionWalkthroughs
    }
    real_estate_acquisition {
      id
      construction_projects {
        id
        construction_scopes(where: {type: {_eq: "initial_scope"}}) {
          id
          construction_walkthroughs {
            ...ConstructionWalkthroughs
          }
        }
      }
    }
  }
}
    ${ConstructionWalkthroughsFragmentDoc}`;

export function useWalkthroughsByPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<WalkthroughsByPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<WalkthroughsByPortfolioHomeIdQuery, WalkthroughsByPortfolioHomeIdQueryVariables>({ query: WalkthroughsByPortfolioHomeIdDocument, ...options });
};
export const WorkOrdersFromPortfolioHomeIdDocument = gql`
    query WorkOrdersFromPortfolioHomeId($portfolioHomeId: uuid!) {
  portfolio_homes_by_pk(id: $portfolioHomeId) {
    id
    work_orders {
      ...WorkOrdersHistory
    }
  }
}
    ${WorkOrdersHistoryFragmentDoc}`;

export function useWorkOrdersFromPortfolioHomeIdQuery(options: Omit<Urql.UseQueryArgs<WorkOrdersFromPortfolioHomeIdQueryVariables>, 'query'>) {
  return Urql.useQuery<WorkOrdersFromPortfolioHomeIdQuery, WorkOrdersFromPortfolioHomeIdQueryVariables>({ query: WorkOrdersFromPortfolioHomeIdDocument, ...options });
};
export const HomeByIdDocument = gql`
    query HomeById($homeId: uuid!) {
  homes360(
    where: {_or: [{id: {_eq: $homeId}}, {portfolio_home_id: {_eq: $homeId}}]}
  ) {
    id
    ...Homes360Fragment
    ...Homes360Header
    portfolio_home {
      ...PortfolioHomeInfo
    }
  }
}
    ${Homes360FragmentFragmentDoc}
${Homes360HeaderFragmentDoc}
${PortfolioHomeInfoFragmentDoc}`;

export function useHomeByIdQuery(options: Omit<Urql.UseQueryArgs<HomeByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HomeByIdQuery, HomeByIdQueryVariables>({ query: HomeByIdDocument, ...options });
};
export const HomesGridDocument = gql`
    query HomesGrid {
  homes_list: homes360(where: {portfolio_home: {id: {}}}) {
    ...Homes360Fragment
    portfolio_home {
      id
      rental_program_type
      real_estate_acquisition {
        ...AcquisitionInfoFragment
        opportunity {
          ...OpportunityFragment
        }
      }
      ...LockboxCode
      down_status_incidents(where: {stage: {_eq: "active"}}) {
        id
        type
        stage
        created_at
      }
    }
  }
}
    ${Homes360FragmentFragmentDoc}
${AcquisitionInfoFragmentFragmentDoc}
${OpportunityFragmentFragmentDoc}
${LockboxCodeFragmentDoc}`;

export function useHomesGridQuery(options?: Omit<Urql.UseQueryArgs<HomesGridQueryVariables>, 'query'>) {
  return Urql.useQuery<HomesGridQuery, HomesGridQueryVariables>({ query: HomesGridDocument, ...options });
};
export const UpupLeadGroupsUserListDocument = gql`
    query UpupLeadGroupsUserList($limit: Int = 10, $where: lead_groups_bool_exp = {}) {
  lead_groups(
    limit: $limit
    where: {_and: [$where, {lead_group_users: {deactivated_at: {_is_null: true}}}]}
  ) {
    id
    created_at
    status
    lead_group_users(
      limit: 10
      distinct_on: user_id
      where: {deactivated_at: {_is_null: true}}
    ) {
      id
      type
      deactivated_at
      user {
        id
        first_name
        last_name
        user_contact_details(where: {is_primary_for_contact_type: {_eq: true}}) {
          id
          contact_type
          contact_info
        }
      }
    }
  }
}
    `;

export function useUpupLeadGroupsUserListQuery(options?: Omit<Urql.UseQueryArgs<UpupLeadGroupsUserListQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupLeadGroupsUserListQuery, UpupLeadGroupsUserListQueryVariables>({ query: UpupLeadGroupsUserListDocument, ...options });
};
export const UpupGenericNotesDocument = gql`
    query UpupGenericNotes($where: notes_bool_exp = {}, $created_at: order_by = desc_nulls_last) {
  notes(where: $where, order_by: {created_at: $created_at}) {
    admin {
      id
      first_name
      last_name
    }
    documents {
      id
      external_id
      external_source
      friendly_name
    }
    id
    category
    created_at
    note
    resource_type
    resource_id
    subject_id
    subject_type
  }
}
    `;

export function useUpupGenericNotesQuery(options?: Omit<Urql.UseQueryArgs<UpupGenericNotesQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupGenericNotesQuery, UpupGenericNotesQueryVariables>({ query: UpupGenericNotesDocument, ...options });
};
export const DeactivateSaferentRequestDocument = gql`
    mutation DeactivateSaferentRequest($id: uuid!, $deactivated_at: timestamptz) {
  update_saferent_requests_by_pk(
    pk_columns: {id: $id}
    _set: {deactivated_at: $deactivated_at}
  ) {
    id
    deactivated_at
  }
}
    `;

export function useDeactivateSaferentRequestMutation() {
  return Urql.useMutation<DeactivateSaferentRequestMutation, DeactivateSaferentRequestMutationVariables>(DeactivateSaferentRequestDocument);
};
export const OverrideIncomeSourceAnnualIncomeDocument = gql`
    mutation OverrideIncomeSourceAnnualIncome($userIncomeSourceId: uuid!, $annualIncome: numeric!, $now: timestamptz!, $adminId: uuid!) {
  update_applicant_income_underwrites_user_income_sources_by_pk(
    pk_columns: {id: $userIncomeSourceId}
    _set: {source_annual_income: $annualIncome, annual_income_overridden_at: $now, annual_income_overridden_by_admin_id: $adminId}
  ) {
    id
    source_annual_income
  }
}
    `;

export function useOverrideIncomeSourceAnnualIncomeMutation() {
  return Urql.useMutation<OverrideIncomeSourceAnnualIncomeMutation, OverrideIncomeSourceAnnualIncomeMutationVariables>(OverrideIncomeSourceAnnualIncomeDocument);
};
export const SetEmploymentVerificationStatusDocument = gql`
    mutation SetEmploymentVerificationStatus($userIncomeSourceId: uuid!, $employmentVerificationStatus: applicant_income_underwrites_user_income_employment_verification_statuses_enum_enum!, $now: timestamptz!, $adminId: uuid!) {
  update_applicant_income_underwrites_user_income_sources_employed(
    where: {user_income_source_id: {_eq: $userIncomeSourceId}}
    _set: {employment_verification_status: $employmentVerificationStatus, employment_verified_at: $now, employment_verified_by_admin_id: $adminId}
  ) {
    returning {
      id
      employment_verification_status
    }
  }
}
    `;

export function useSetEmploymentVerificationStatusMutation() {
  return Urql.useMutation<SetEmploymentVerificationStatusMutation, SetEmploymentVerificationStatusMutationVariables>(SetEmploymentVerificationStatusDocument);
};
export const UpdateIncomeSourceContactNameDocument = gql`
    mutation UpdateIncomeSourceContactName($userIncomeSourceId: uuid!, $contactName: String = null) {
  update_applicant_income_underwrites_user_income_sources_employed(
    where: {user_income_source_id: {_eq: $userIncomeSourceId}}
    _set: {contact_name: $contactName}
  ) {
    affected_rows
  }
}
    `;

export function useUpdateIncomeSourceContactNameMutation() {
  return Urql.useMutation<UpdateIncomeSourceContactNameMutation, UpdateIncomeSourceContactNameMutationVariables>(UpdateIncomeSourceContactNameDocument);
};
export const UpdateIncomeSourceContactTitleDocument = gql`
    mutation UpdateIncomeSourceContactTitle($userIncomeSourceId: uuid!, $contactTitle: String = null) {
  update_applicant_income_underwrites_user_income_sources_employed(
    where: {user_income_source_id: {_eq: $userIncomeSourceId}}
    _set: {contact_title: $contactTitle}
  ) {
    affected_rows
  }
}
    `;

export function useUpdateIncomeSourceContactTitleMutation() {
  return Urql.useMutation<UpdateIncomeSourceContactTitleMutation, UpdateIncomeSourceContactTitleMutationVariables>(UpdateIncomeSourceContactTitleDocument);
};
export const UpdateIncomeSourceContactPhoneDocument = gql`
    mutation UpdateIncomeSourceContactPhone($userIncomeSourceId: uuid!, $contactPhone: String = null) {
  update_applicant_income_underwrites_user_income_sources_employed(
    where: {user_income_source_id: {_eq: $userIncomeSourceId}}
    _set: {contact_phone: $contactPhone}
  ) {
    affected_rows
  }
}
    `;

export function useUpdateIncomeSourceContactPhoneMutation() {
  return Urql.useMutation<UpdateIncomeSourceContactPhoneMutation, UpdateIncomeSourceContactPhoneMutationVariables>(UpdateIncomeSourceContactPhoneDocument);
};
export const UpdateIncomeSourceContactEmailDocument = gql`
    mutation UpdateIncomeSourceContactEmail($userIncomeSourceId: uuid!, $contactEmail: String = null) {
  update_applicant_income_underwrites_user_income_sources_employed(
    where: {user_income_source_id: {_eq: $userIncomeSourceId}}
    _set: {contact_email: $contactEmail}
  ) {
    affected_rows
  }
}
    `;

export function useUpdateIncomeSourceContactEmailMutation() {
  return Urql.useMutation<UpdateIncomeSourceContactEmailMutation, UpdateIncomeSourceContactEmailMutationVariables>(UpdateIncomeSourceContactEmailDocument);
};
export const OverrideUserIncomeAmountDocument = gql`
    mutation OverrideUserIncomeAmount($userIncomeId: uuid!, $amount: numeric!) {
  update_applicant_income_underwrites_user_incomes_by_pk(
    pk_columns: {id: $userIncomeId}
    _set: {annual_income: $amount}
  ) {
    id
    annual_income
  }
}
    `;

export function useOverrideUserIncomeAmountMutation() {
  return Urql.useMutation<OverrideUserIncomeAmountMutation, OverrideUserIncomeAmountMutationVariables>(OverrideUserIncomeAmountDocument);
};
export const UpupRentalApplicationByIdDocument = gql`
    query UpupRentalApplicationById($id: uuid!) {
  rental_applications_by_pk(id: $id) {
    id
    status
    status_metadata
    created_at
    priority_score
    projected_occupancy_date
    rent
    rental_program_type_applied_for
    mls_listing {
      id
      display_line_1
      zip
      state
      city
      region
      rent_ready_dates(where: {is_active: {_eq: true}}) {
        id
        earliest_move_in_date
      }
    }
    lead_group {
      id
      lead_group_users(
        distinct_on: user_id
        where: {deactivated_at: {_is_null: true}}
      ) {
        id
        type
        user {
          id
          first_name
          last_name
          close_lead_id
        }
      }
      agent_lead_group_owners(where: {deactivated_at: {_is_null: true}}) {
        id
        agent_type
        admin {
          id
          first_name
          last_name
        }
      }
    }
    application_escalations(
      where: {resolved_at: {_is_null: true}, canceled_at: {_is_null: true}}
    ) {
      id
      reason
      created_at
      assigned_to_admin {
        id
        first_name
        last_name
      }
      assigned_by_admin {
        id
        first_name
        last_name
      }
    }
    application_snoozes(
      where: {deleted_at: {_is_null: true}, snoozed_until: {_gt: "now()"}}
    ) {
      id
      snoozed_until
      snoozed_by_admin_id
      snooze_reason
      rental_application_id
    }
  }
}
    `;

export function useUpupRentalApplicationByIdQuery(options: Omit<Urql.UseQueryArgs<UpupRentalApplicationByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupRentalApplicationByIdQuery, UpupRentalApplicationByIdQueryVariables>({ query: UpupRentalApplicationByIdDocument, ...options });
};
export const UpupRentalApplicationsDocument = gql`
    query UpupRentalApplications($limit: Int = 10, $offset: Int = 0, $order_by: [rental_applications_order_by!] = {created_at: desc}, $where: rental_applications_bool_exp = null) {
  rental_applications(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    status
    created_at
    priority_score
    projected_occupancy_date
    required_coapplicant_at
    required_cosigner_at
    rental_program_type_applied_for
    mls_listing {
      id
      display_line_1
      region
      opportunity {
        id
        home {
          id
          portfolio_homes(limit: 1, order_by: {created_at: desc}) {
            id
            most_recent_llc_property {
              id
              llc {
                id
                fund_llcs(limit: 1, order_by: {start_date: desc}) {
                  id
                  fund {
                    id
                    abbreviation
                    name
                  }
                }
              }
            }
          }
        }
      }
      internal_attributes {
        id
        internal_status
      }
    }
    lead_group {
      id
      lead_group_users(
        distinct_on: user_id
        where: {deactivated_at: {_is_null: true}}
      ) {
        id
        type
        rental_application_submitted_at
        user {
          id
          first_name
          last_name
          credit_reports {
            id
            status
            score_status
            score
          }
          eviction_reports {
            id
          }
          criminal_reports {
            id
          }
        }
      }
    }
    application_escalations(
      where: {resolved_at: {_is_null: true}, canceled_at: {_is_null: true}}
    ) {
      id
      reason
      created_at
      assigned_to_admin {
        id
        first_name
        last_name
      }
      assigned_by_admin {
        id
        first_name
        last_name
      }
    }
    application_snoozes(
      where: {deleted_at: {_is_null: true}, snoozed_until: {_gt: "now()"}}
    ) {
      id
      snoozed_until
      snoozed_by_admin_id
      snooze_reason
      rental_application_id
    }
  }
}
    `;

export function useUpupRentalApplicationsQuery(options?: Omit<Urql.UseQueryArgs<UpupRentalApplicationsQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupRentalApplicationsQuery, UpupRentalApplicationsQueryVariables>({ query: UpupRentalApplicationsDocument, ...options });
};
export const FindDocumentsByResourceIdsDocument = gql`
    query FindDocumentsByResourceIds($resourceIds: [uuid!]!) {
  documents(where: {resource_id: {_in: $resourceIds}}) {
    id
    resource_id
    resource_type
    created_at
    status
    external_source
    external_id
    friendly_name
    type
    reviewed_at
    review_notes
    uploaded_by_admin {
      id
      first_name
      last_name
    }
    reviewed_by_admin: admin {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useFindDocumentsByResourceIdsQuery(options: Omit<Urql.UseQueryArgs<FindDocumentsByResourceIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<FindDocumentsByResourceIdsQuery, FindDocumentsByResourceIdsQueryVariables>({ query: FindDocumentsByResourceIdsDocument, ...options });
};
export const FindNotesByResourceIdsDocument = gql`
    query FindNotesByResourceIds($resourceIds: [uuid!]!) {
  notes(where: {resource_id: {_in: $resourceIds}}) {
    id
    resource_id
    resource_type
    note
    created_at
    admin {
      id
      first_name
      last_name
    }
    priority
    category
  }
}
    `;

export function useFindNotesByResourceIdsQuery(options: Omit<Urql.UseQueryArgs<FindNotesByResourceIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<FindNotesByResourceIdsQuery, FindNotesByResourceIdsQueryVariables>({ query: FindNotesByResourceIdsDocument, ...options });
};
export const UpdateNotePriorityByNoteIdDocument = gql`
    mutation UpdateNotePriorityByNoteId($noteId: uuid!, $priority: note_priorities_enum) {
  update_notes_by_pk(pk_columns: {id: $noteId}, _set: {priority: $priority}) {
    id
    priority
  }
}
    `;

export function useUpdateNotePriorityByNoteIdMutation() {
  return Urql.useMutation<UpdateNotePriorityByNoteIdMutation, UpdateNotePriorityByNoteIdMutationVariables>(UpdateNotePriorityByNoteIdDocument);
};
export const UpupAdminsWithCapabilitiesDocument = gql`
    query UpupAdminsWithCapabilities {
  admins(order_by: {email: asc}, where: {status: {_eq: "active"}}) {
    id
    first_name
    last_name
    email
    admin_capabilities {
      id
      capability {
        id
        name
        type
        description
      }
    }
  }
}
    `;

export function useUpupAdminsWithCapabilitiesQuery(options?: Omit<Urql.UseQueryArgs<UpupAdminsWithCapabilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupAdminsWithCapabilitiesQuery, UpupAdminsWithCapabilitiesQueryVariables>({ query: UpupAdminsWithCapabilitiesDocument, ...options });
};
export const UpupAdminsWithCapabilitiesByCapabilityTypeDocument = gql`
    query UpupAdminsWithCapabilitiesByCapabilityType($capability_types: [String!], $status_types: [String!] = ["active"]) {
  admins(
    order_by: {email: asc}
    where: {status: {_in: $status_types}, admin_capabilities: {capability: {type: {_in: $capability_types}}}}
  ) {
    id
    first_name
    last_name
    email
    admin_capabilities {
      id
      capability {
        id
        name
        type
        description
      }
    }
  }
}
    `;

export function useUpupAdminsWithCapabilitiesByCapabilityTypeQuery(options?: Omit<Urql.UseQueryArgs<UpupAdminsWithCapabilitiesByCapabilityTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupAdminsWithCapabilitiesByCapabilityTypeQuery, UpupAdminsWithCapabilitiesByCapabilityTypeQueryVariables>({ query: UpupAdminsWithCapabilitiesByCapabilityTypeDocument, ...options });
};
export const ApplicationBuildiumLeaseSyncDocument = gql`
    subscription ApplicationBuildiumLeaseSync($rentalApplicationId: uuid!) {
  rental_applications_by_pk(id: $rentalApplicationId) {
    id
    agreements(
      where: {status: {_neq: "canceled"}}
      order_by: {created_at: desc}
      limit: 1
    ) {
      id
      created_at
      buildium_lease_id
      updated_at
    }
  }
}
    `;

export function useApplicationBuildiumLeaseSyncSubscription<TData = ApplicationBuildiumLeaseSyncSubscription>(options: Omit<Urql.UseSubscriptionArgs<ApplicationBuildiumLeaseSyncSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<ApplicationBuildiumLeaseSyncSubscription, TData>) {
  return Urql.useSubscription<ApplicationBuildiumLeaseSyncSubscription, TData, ApplicationBuildiumLeaseSyncSubscriptionVariables>({ query: ApplicationBuildiumLeaseSyncDocument, ...options }, handler);
};
export const UpupApplicationListDocument = gql`
    query UpupApplicationList($limit: Int = 10, $offset: Int = 0, $order_by: [rental_applications_order_by!] = {created_at: desc}, $where: rental_applications_bool_exp = {}) {
  rental_applications(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    agreements(where: {status: {_neq: "canceled"}}) {
      id
      status
      metadata
    }
    created_at
    projected_occupancy_date
    lead_group {
      id
      lead_group_users(limit: 10, distinct_on: user_id) {
        id
        type
        user {
          id
          first_name
          last_name
        }
      }
    }
    mls_listing {
      id
      display_line_1
      region
      internal_attributes {
        id
        internal_status
      }
    }
    status
  }
}
    `;

export function useUpupApplicationListQuery(options?: Omit<Urql.UseQueryArgs<UpupApplicationListQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupApplicationListQuery, UpupApplicationListQueryVariables>({ query: UpupApplicationListDocument, ...options });
};
export const ApplicationListDocument = gql`
    query applicationList($where: rental_applications_bool_exp = {}) {
  rental_applications(where: $where) {
    id
  }
}
    `;

export function useApplicationListQuery(options?: Omit<Urql.UseQueryArgs<ApplicationListQueryVariables>, 'query'>) {
  return Urql.useQuery<ApplicationListQuery, ApplicationListQueryVariables>({ query: ApplicationListDocument, ...options });
};
export const UpupApplicationUserQualDocument = gql`
    query UpupApplicationUserQual($id: ID!) {
  getUserQualificationData(id: $id) {
    status
  }
}
    `;

export function useUpupApplicationUserQualQuery(options: Omit<Urql.UseQueryArgs<UpupApplicationUserQualQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupApplicationUserQualQuery, UpupApplicationUserQualQueryVariables>({ query: UpupApplicationUserQualDocument, ...options });
};
export const UpupApplicationMlsListingsByAddressDocument = gql`
    query UpupApplicationMlsListingsByAddress($address: String) {
  mls_listings(
    where: {display_line_1: {_ilike: $address}, internal_attributes: {internal_status: {_in: ["homevested", "internally_listed"]}}}
    limit: 5
  ) {
    opportunity {
      id
      current_rent: listed_rents(order_by: {created_at: desc}, limit: 1) {
        id
        listed_rent
        base_rent
      }
    }
    internal_attributes {
      internal_status
    }
    photos(
      limit: 1
      order_by: [{display_order: asc_nulls_last}, {created_at: asc}]
      where: {_or: [{is_deleted: {_eq: false}}, {is_deleted: {_is_null: true}}]}
    ) {
      url
    }
    baths_weighted
    beds
    display_line_1
    display_line_2
    firestore_id
    id
    list_price
  }
}
    `;

export function useUpupApplicationMlsListingsByAddressQuery(options?: Omit<Urql.UseQueryArgs<UpupApplicationMlsListingsByAddressQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupApplicationMlsListingsByAddressQuery, UpupApplicationMlsListingsByAddressQueryVariables>({ query: UpupApplicationMlsListingsByAddressDocument, ...options });
};
export const GetBackgroundCheckRequestByTypeDocument = gql`
    query GetBackgroundCheckRequestByType($reportType: String!, $userId: uuid!) {
  background_check_requests(
    where: {type: {_eq: $reportType}, user_id: {_eq: $userId}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    id
    user_id
    type
    resource_type
    resource_id
    request_id
    status
    error_message
    completed_at
    created_at
    updated_at
    initiated_by_admin_id
    invalidated_by_admin_id
    invalidated_at
  }
}
    `;

export function useGetBackgroundCheckRequestByTypeQuery(options: Omit<Urql.UseQueryArgs<GetBackgroundCheckRequestByTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBackgroundCheckRequestByTypeQuery, GetBackgroundCheckRequestByTypeQueryVariables>({ query: GetBackgroundCheckRequestByTypeDocument, ...options });
};
export const UpupCapabilitiesWithAdminDocument = gql`
    query UpupCapabilitiesWithAdmin($where: capabilities_bool_exp = {}) {
  capabilities(order_by: {type: asc}, where: $where) {
    id
    name
    type
    description
    admin_capabilities(
      order_by: {admin: {email: asc}}
      where: {admin: {status: {_eq: "active"}}}
    ) {
      id
      admin {
        id
        first_name
        last_name
        email
      }
    }
  }
}
    `;

export function useUpupCapabilitiesWithAdminQuery(options?: Omit<Urql.UseQueryArgs<UpupCapabilitiesWithAdminQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupCapabilitiesWithAdminQuery, UpupCapabilitiesWithAdminQueryVariables>({ query: UpupCapabilitiesWithAdminDocument, ...options });
};
export const GetRentalCashoutDetailsDocument = gql`
    query GetRentalCashoutDetails($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    ...CashoutDetails
    ...CashoutSidebar
  }
  unallocated_credits(
    where: {rental_id: {_eq: $rentalId}}
    order_by: {date: desc}
  ) {
    id: credit_id
    __typename
    amount_remaining
    rental_id
    liability_type {
      id
      name
      payment_category
    }
    credit {
      id
      note
    }
    date
  }
  unallocated_payments(
    where: {rental_id: {_eq: $rentalId}, status: {_eq: "succeeded"}, liability_type_id: {_neq: "f83c201d-e00d-4c85-b0ea-38279fb8a844"}}
    order_by: {payment_date: desc}
  ) {
    id: payment_id
    __typename
    amount_remaining
    rental_id
    liability_type {
      id
      name
      payment_category
    }
    payment {
      id
      note
    }
    date: payment_date
  }
  unpaid_liabilities(where: {rental_id: {_eq: $rentalId}}, order_by: {date: desc}) {
    id: liability_id
    __typename
    amount_remaining
    rental_id
    liability_type {
      id
      name
      payment_category
    }
    date
    liability {
      id
      cashouts_pending_liabilities {
        id
        rental_liability_id
      }
      note
    }
  }
}
    ${CashoutDetailsFragmentDoc}
${CashoutSidebarFragmentDoc}`;

export function useGetRentalCashoutDetailsQuery(options: Omit<Urql.UseQueryArgs<GetRentalCashoutDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRentalCashoutDetailsQuery, GetRentalCashoutDetailsQueryVariables>({ query: GetRentalCashoutDetailsDocument, ...options });
};
export const GetCashoutPendingLiabilitiesLedgerAccountsDocument = gql`
    query GetCashoutPendingLiabilitiesLedgerAccounts {
  ledger_accounts(
    where: {external_source: {_eq: "buildium"}, ledger_account_categories: {category: {_in: ["turn_r_m", "disposition_r_m"]}, type: {_eq: "management"}}, ledger_type: {_eq: "expense"}, parent_ledger_account_id: {_is_null: false}}
  ) {
    id
    name
    ledger_account_categories(
      where: {category: {_in: ["turn_r_m", "disposition_r_m"]}, type: {_eq: "management"}}
    ) {
      id
      category
    }
  }
}
    `;

export function useGetCashoutPendingLiabilitiesLedgerAccountsQuery(options?: Omit<Urql.UseQueryArgs<GetCashoutPendingLiabilitiesLedgerAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCashoutPendingLiabilitiesLedgerAccountsQuery, GetCashoutPendingLiabilitiesLedgerAccountsQueryVariables>({ query: GetCashoutPendingLiabilitiesLedgerAccountsDocument, ...options });
};
export const CreateCashoutPendingLiabilityDocument = gql`
    mutation CreateCashoutPendingLiability($cashoutId: uuid!, $liabilityTypeId: uuid!, $ledgerAccountId: uuid!, $amount: numeric!, $description: String) {
  insert_cashouts_pending_liabilities_one(
    object: {cashout_id: $cashoutId, liability_type_id: $liabilityTypeId, ledger_account_id: $ledgerAccountId, amount: $amount, description: $description}
  ) {
    id
    amount
    description
    liability_type {
      id
      name
    }
    ledger_account {
      id
      name
    }
  }
}
    `;

export function useCreateCashoutPendingLiabilityMutation() {
  return Urql.useMutation<CreateCashoutPendingLiabilityMutation, CreateCashoutPendingLiabilityMutationVariables>(CreateCashoutPendingLiabilityDocument);
};
export const DeleteCashoutPendingLiabilityDocument = gql`
    mutation DeleteCashoutPendingLiability($id: uuid!) {
  delete_cashouts_pending_liabilities_by_pk(id: $id) {
    id
    amount
    description
    liability_type {
      id
      name
    }
  }
}
    `;

export function useDeleteCashoutPendingLiabilityMutation() {
  return Urql.useMutation<DeleteCashoutPendingLiabilityMutation, DeleteCashoutPendingLiabilityMutationVariables>(DeleteCashoutPendingLiabilityDocument);
};
export const CashoutsDocument = gql`
    query Cashouts {
  cashouts {
    id
    rental {
      id
      portfolio_home {
        id
        home {
          id
          address {
            id
            display_line_1
            display_line_2
          }
        }
      }
      move_out_date
    }
    created_at
    maintenance_chargebacks_finalized_at
    adjustments_finalized_at
    cashed_out_at
    clawback_amount
    total_investment_amount
    wallet_fee_amount
    write_off_amount
    status
    user {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useCashoutsQuery(options?: Omit<Urql.UseQueryArgs<CashoutsQueryVariables>, 'query'>) {
  return Urql.useQuery<CashoutsQuery, CashoutsQueryVariables>({ query: CashoutsDocument, ...options });
};
export const ArchiveUserDocument = gql`
    mutation ArchiveUser($userId: uuid!, $archiveReason: String!, $archivedByAdminId: uuid!) {
  update_user_funnel_statuses(
    where: {user_id: {_eq: $userId}, archived_at: {_is_null: true}}
    _set: {archived_at: "now()", archive_reason: $archiveReason, archived_by_admin_id: $archivedByAdminId}
  ) {
    affected_rows
  }
}
    `;

export function useArchiveUserMutation() {
  return Urql.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument);
};
export const CustomerHeaderInfoByUserIdDocument = gql`
    query customerHeaderInfoByUserId($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    id
    close_lead_id
    created_at
    deleted_at
    rental_users(where: {deactivated_at: {_is_null: true}}) {
      id
    }
    lead_group_users {
      id
      lead_group_id
      rental_applications(where: {canceled_at: {_is_null: true}}) {
        id
      }
    }
    user_prequalification_data {
      id
    }
    user_funnel_status {
      id
      lead_status
      archived_at
    }
  }
}
    `;

export function useCustomerHeaderInfoByUserIdQuery(options: Omit<Urql.UseQueryArgs<CustomerHeaderInfoByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CustomerHeaderInfoByUserIdQuery, CustomerHeaderInfoByUserIdQueryVariables>({ query: CustomerHeaderInfoByUserIdDocument, ...options });
};
export const InvalidateSuccessfulUserIdentityVerificationsDocument = gql`
    mutation invalidateSuccessfulUserIdentityVerifications($userId: uuid!, $invalidatedByAdminId: uuid!) {
  update_user_identity_verifications_many(
    updates: {where: {user_id: {_eq: $userId}, invalidated_at: {_is_null: true}, status: {_eq: verified}}, _set: {invalidated_at: "now()", invalidated_by_admin_id: $invalidatedByAdminId}}
  ) {
    affected_rows
  }
}
    `;

export function useInvalidateSuccessfulUserIdentityVerificationsMutation() {
  return Urql.useMutation<InvalidateSuccessfulUserIdentityVerificationsMutation, InvalidateSuccessfulUserIdentityVerificationsMutationVariables>(InvalidateSuccessfulUserIdentityVerificationsDocument);
};
export const MostRelevantUserIdentityVerificationByUserDocument = gql`
    query MostRelevantUserIdentityVerificationByUser($userId: uuid!) {
  most_relevant_user_identity_verification_by_user(
    limit: 1
    where: {user_id: {_eq: $userId}}
  ) {
    id
    user_id
    stripe_session_id
    status
    created_at
    updated_at
    completed_at
    invalidated_at
    failure_message
    failure_code
    verified_as_first_name
    verified_as_last_name
    invalidated_by_admin {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useMostRelevantUserIdentityVerificationByUserQuery(options: Omit<Urql.UseQueryArgs<MostRelevantUserIdentityVerificationByUserQueryVariables>, 'query'>) {
  return Urql.useQuery<MostRelevantUserIdentityVerificationByUserQuery, MostRelevantUserIdentityVerificationByUserQueryVariables>({ query: MostRelevantUserIdentityVerificationByUserDocument, ...options });
};
export const PersonalDetailsByUserIdDocument = gql`
    query personalDetailsByUserId($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    id
    first_name
    last_name
    emails: user_contact_details(
      order_by: {is_primary_for_contact_type: desc}
      where: {contact_type: {_eq: "email"}}
    ) {
      id
      contact_info
      is_primary_for_contact_type
    }
    phones: user_contact_details(
      order_by: {is_primary_for_contact_type: desc}
      where: {contact_type: {_eq: "phone"}}
    ) {
      id
      contact_info
      is_primary_for_contact_type
    }
    user_funnel_status {
      id
      lead_status
      archived_at
    }
    credit_reports(
      order_by: {created_at: desc}
      where: {score_status: {_eq: "Success"}}
    ) {
      id
      score
    }
  }
}
    `;

export function usePersonalDetailsByUserIdQuery(options: Omit<Urql.UseQueryArgs<PersonalDetailsByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<PersonalDetailsByUserIdQuery, PersonalDetailsByUserIdQueryVariables>({ query: PersonalDetailsByUserIdDocument, ...options });
};
export const RentalApplicationFeesByUserIdDocument = gql`
    query RentalApplicationFeesByUserId($userId: uuid!) {
  rental_application_fees(
    where: {user_id: {_eq: $userId}}
    order_by: [{created_at: desc}, {id: desc}]
  ) {
    id
    user_id
    created_at
    updated_at
    expected_amount
    amount_paid
    payment_date
    stripe_payment_intent_id
    stripe_payment_intent_status
  }
}
    `;

export function useRentalApplicationFeesByUserIdQuery(options: Omit<Urql.UseQueryArgs<RentalApplicationFeesByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalApplicationFeesByUserIdQuery, RentalApplicationFeesByUserIdQueryVariables>({ query: RentalApplicationFeesByUserIdDocument, ...options });
};
export const ResetUserIdentityVerificationAttemptsDocument = gql`
    mutation resetUserIdentityVerificationAttempts($userId: uuid!, $invalidatedByAdminId: uuid!, $oneDayAgo: timestamptz!) {
  update_user_identity_verifications_many(
    updates: {where: {created_at: {_gte: $oneDayAgo}, user_id: {_eq: $userId}, invalidated_at: {_is_null: true}}, _set: {invalidated_at: "now()", invalidated_by_admin_id: $invalidatedByAdminId}}
  ) {
    affected_rows
  }
}
    `;

export function useResetUserIdentityVerificationAttemptsMutation() {
  return Urql.useMutation<ResetUserIdentityVerificationAttemptsMutation, ResetUserIdentityVerificationAttemptsMutationVariables>(ResetUserIdentityVerificationAttemptsDocument);
};
export const UpupDashboardsDocument = gql`
    query UpupDashboards {
  dashboards(where: {status: {_eq: "active"}}) {
    id
    category
    name
    description
    url
    icon
    status
  }
}
    `;

export function useUpupDashboardsQuery(options?: Omit<Urql.UseQueryArgs<UpupDashboardsQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupDashboardsQuery, UpupDashboardsQueryVariables>({ query: UpupDashboardsDocument, ...options });
};
export const UpupDeleteDashboardDocument = gql`
    mutation UpupDeleteDashboard($id: uuid!) {
  update_dashboards_by_pk(pk_columns: {id: $id}, _set: {status: "deleted"}) {
    id
  }
}
    `;

export function useUpupDeleteDashboardMutation() {
  return Urql.useMutation<UpupDeleteDashboardMutation, UpupDeleteDashboardMutationVariables>(UpupDeleteDashboardDocument);
};
export const UpupDeleteDocumentDocument = gql`
    mutation UpupDeleteDocument($documentId: uuid!) {
  delete_documents_by_pk(id: $documentId) {
    id
  }
}
    `;

export function useUpupDeleteDocumentMutation() {
  return Urql.useMutation<UpupDeleteDocumentMutation, UpupDeleteDocumentMutationVariables>(UpupDeleteDocumentDocument);
};
export const UpupDocumentsByResourceDocument = gql`
    query UpupDocumentsByResource($resourceId: uuid!, $resourceType: String!) {
  documents(
    where: {resource_type: {_eq: $resourceType}, resource_id: {_eq: $resourceId}}
    order_by: {created_at: desc}
  ) {
    id
    status
    friendly_name
    created_at
    type
    resource_id
    resource_notes
    resource_type
    uploaded_by_admin {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useUpupDocumentsByResourceQuery(options: Omit<Urql.UseQueryArgs<UpupDocumentsByResourceQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupDocumentsByResourceQuery, UpupDocumentsByResourceQueryVariables>({ query: UpupDocumentsByResourceDocument, ...options });
};
export const DocumentsByUserIdDocument = gql`
    query documentsByUserId($id: uuid!) {
  documents(where: {resource_id: {_eq: $id}}, order_by: {created_at: desc}) {
    id
    friendly_name
    status
    created_at
    reviewed_at
    reviewed_by_admin_id
    admin {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useDocumentsByUserIdQuery(options: Omit<Urql.UseQueryArgs<DocumentsByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<DocumentsByUserIdQuery, DocumentsByUserIdQueryVariables>({ query: DocumentsByUserIdDocument, ...options });
};
export const UpupDocumentRealEstateAcquisitionsDocument = gql`
    query UpupDocumentRealEstateAcquisitions {
  real_estate_acquisitions {
    id
    status
    closing_date
    mls_listing {
      id
      delivery_line
      city
      state
    }
  }
}
    `;

export function useUpupDocumentRealEstateAcquisitionsQuery(options?: Omit<Urql.UseQueryArgs<UpupDocumentRealEstateAcquisitionsQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupDocumentRealEstateAcquisitionsQuery, UpupDocumentRealEstateAcquisitionsQueryVariables>({ query: UpupDocumentRealEstateAcquisitionsDocument, ...options });
};
export const GeneralContractorsDocument = gql`
    query GeneralContractors {
  construction_general_contractors {
    id
    name
  }
}
    `;

export function useGeneralContractorsQuery(options?: Omit<Urql.UseQueryArgs<GeneralContractorsQueryVariables>, 'query'>) {
  return Urql.useQuery<GeneralContractorsQuery, GeneralContractorsQueryVariables>({ query: GeneralContractorsDocument, ...options });
};
export const UpUpMlsListingByIdDocument = gql`
    query UpUpMlsListingById($id: uuid!) {
  mls_listing: mls_listings_by_pk(id: $id) {
    ...mlsListingData
  }
}
    ${MlsListingDataFragmentDoc}`;

export function useUpUpMlsListingByIdQuery(options: Omit<Urql.UseQueryArgs<UpUpMlsListingByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UpUpMlsListingByIdQuery, UpUpMlsListingByIdQueryVariables>({ query: UpUpMlsListingByIdDocument, ...options });
};
export const UpupMlsListingsByIdsDocument = gql`
    query UpupMlsListingsByIds($ids: [uuid!]) {
  mls_listings(where: {id: {_in: $ids}}) {
    ...mlsListingData
  }
}
    ${MlsListingDataFragmentDoc}`;

export function useUpupMlsListingsByIdsQuery(options?: Omit<Urql.UseQueryArgs<UpupMlsListingsByIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupMlsListingsByIdsQuery, UpupMlsListingsByIdsQueryVariables>({ query: UpupMlsListingsByIdsDocument, ...options });
};
export const UpupInsertAdminDocument = gql`
    mutation UpupInsertAdmin($email: String, $firstName: String, $lastName: String) {
  insert_admins_one(
    object: {email: $email, first_name: $firstName, last_name: $lastName}
  ) {
    id
    email
    first_name
    last_name
  }
}
    `;

export function useUpupInsertAdminMutation() {
  return Urql.useMutation<UpupInsertAdminMutation, UpupInsertAdminMutationVariables>(UpupInsertAdminDocument);
};
export const UpupInsertCapabilityDocument = gql`
    mutation UpupInsertCapability($name: String, $type: String, $description: String) {
  insert_capabilities_one(
    object: {name: $name, type: $type, description: $description}
  ) {
    id
    name
    type
    description
  }
}
    `;

export function useUpupInsertCapabilityMutation() {
  return Urql.useMutation<UpupInsertCapabilityMutation, UpupInsertCapabilityMutationVariables>(UpupInsertCapabilityDocument);
};
export const UpupInsertDashboardDocument = gql`
    mutation UpupInsertDashboard($category: String, $name: String, $description: String, $url: String, $icon: String) {
  insert_dashboards_one(
    object: {category: $category, name: $name, description: $description, url: $url, icon: $icon, status: "active"}
  ) {
    id
  }
}
    `;

export function useUpupInsertDashboardMutation() {
  return Urql.useMutation<UpupInsertDashboardMutation, UpupInsertDashboardMutationVariables>(UpupInsertDashboardDocument);
};
export const UpupInsertDocumentDocument = gql`
    mutation UpupInsertDocument($external_id: String, $external_source: String, $friendly_name: String, $resource_id: uuid, $resource_type: String, $resource_notes: String, $review_notes: String, $reviewed_at: timestamptz, $reviewed_by_admin_id: uuid, $status: String, $type: String, $uploaded_by_admin_id: uuid, $is_publicly_viewable: Boolean) {
  insert_documents_one(
    object: {external_id: $external_id, external_source: $external_source, friendly_name: $friendly_name, resource_id: $resource_id, resource_type: $resource_type, review_notes: $review_notes, resource_notes: $resource_notes, reviewed_at: $reviewed_at, reviewed_by_admin_id: $reviewed_by_admin_id, status: $status, type: $type, uploaded_by_admin_id: $uploaded_by_admin_id, is_publicly_viewable: $is_publicly_viewable}
  ) {
    id
  }
}
    `;

export function useUpupInsertDocumentMutation() {
  return Urql.useMutation<UpupInsertDocumentMutation, UpupInsertDocumentMutationVariables>(UpupInsertDocumentDocument);
};
export const UpupInsertNoteDocument = gql`
    mutation UpupInsertNote($category: String, $created_by_admin_id: uuid, $note: String, $resource_id: uuid, $resource_type: String, $priority: note_priorities_enum) {
  insert_notes_one(
    object: {category: $category, created_by_admin_id: $created_by_admin_id, note: $note, resource_id: $resource_id, resource_type: $resource_type, priority: $priority}
  ) {
    id
  }
}
    `;

export function useUpupInsertNoteMutation() {
  return Urql.useMutation<UpupInsertNoteMutation, UpupInsertNoteMutationVariables>(UpupInsertNoteDocument);
};
export const CreateRecurringCreditDocument = gql`
    mutation CreateRecurringCredit($rental_id: uuid, $start_date: date, $num_months: Int, $total_amount: numeric, $notes: String, $liability_type_id: uuid, $move_in_credit: Boolean) {
  insert_recurring_credits_one(
    object: {rental_id: $rental_id, start_date: $start_date, num_months: $num_months, total_amount: $total_amount, notes: $notes, liability_type_id: $liability_type_id, move_in_credit: $move_in_credit}
  ) {
    id
    rental_id
    start_date
    num_months
    total_amount
    notes
    liability_type_id
    move_in_credit
    created_at
    updated_at
  }
}
    `;

export function useCreateRecurringCreditMutation() {
  return Urql.useMutation<CreateRecurringCreditMutation, CreateRecurringCreditMutationVariables>(CreateRecurringCreditDocument);
};
export const UpupInsertUserDocumentRequestsDocument = gql`
    mutation UpupInsertUserDocumentRequests($requests: [user_document_requests_insert_input!]!) {
  insert_user_document_requests(objects: $requests) {
    returning {
      id
    }
  }
}
    `;

export function useUpupInsertUserDocumentRequestsMutation() {
  return Urql.useMutation<UpupInsertUserDocumentRequestsMutation, UpupInsertUserDocumentRequestsMutationVariables>(UpupInsertUserDocumentRequestsDocument);
};
export const OccupancyInspectionByConstructionProjectIdDocument = gql`
    query OccupancyInspectionByConstructionProjectId($constructionProjectId: uuid!) {
  construction_occupancy_inspections(
    where: {construction_project_id: {_eq: $constructionProjectId}}
  ) {
    id
  }
}
    `;

export function useOccupancyInspectionByConstructionProjectIdQuery(options: Omit<Urql.UseQueryArgs<OccupancyInspectionByConstructionProjectIdQueryVariables>, 'query'>) {
  return Urql.useQuery<OccupancyInspectionByConstructionProjectIdQuery, OccupancyInspectionByConstructionProjectIdQueryVariables>({ query: OccupancyInspectionByConstructionProjectIdDocument, ...options });
};
export const BuyersInspectionByConstructionProjectIdDocument = gql`
    query BuyersInspectionByConstructionProjectId($constructionProjectId: uuid!) {
  construction_projects(where: {id: {_eq: $constructionProjectId}}) {
    portfolio_home {
      portfolio_home_dispositions {
        portfolio_home_disposition_bids {
          buyers_inspections {
            id
          }
        }
      }
    }
  }
}
    `;

export function useBuyersInspectionByConstructionProjectIdQuery(options: Omit<Urql.UseQueryArgs<BuyersInspectionByConstructionProjectIdQueryVariables>, 'query'>) {
  return Urql.useQuery<BuyersInspectionByConstructionProjectIdQuery, BuyersInspectionByConstructionProjectIdQueryVariables>({ query: BuyersInspectionByConstructionProjectIdDocument, ...options });
};
export const LatchelVendorsQueryDocument = gql`
    query LatchelVendorsQuery {
  vendors(where: {_and: [{is_active: {_eq: true}}, {type: {_eq: "latchel"}}]}) {
    id
    name
  }
}
    `;

export function useLatchelVendorsQueryQuery(options?: Omit<Urql.UseQueryArgs<LatchelVendorsQueryQueryVariables>, 'query'>) {
  return Urql.useQuery<LatchelVendorsQueryQuery, LatchelVendorsQueryQueryVariables>({ query: LatchelVendorsQueryDocument, ...options });
};
export const LeadGroupByUserIdDocument = gql`
    query leadGroupByUserId($id: uuid!) {
  lead_group_users(where: {user_id: {_eq: $id}, deactivated_at: {_is_null: true}}) {
    id
    lead_group {
      id
      status
      created_at
    }
  }
}
    `;

export function useLeadGroupByUserIdQuery(options: Omit<Urql.UseQueryArgs<LeadGroupByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadGroupByUserIdQuery, LeadGroupByUserIdQueryVariables>({ query: LeadGroupByUserIdDocument, ...options });
};
export const LeadGroupUsersByLeadGroupIdDocument = gql`
    query leadGroupUsersByLeadGroupId($id: uuid!) {
  lead_group_users(
    where: {lead_group_id: {_eq: $id}, deactivated_at: {_is_null: true}}
  ) {
    id
    user_id
    type
    user {
      id
      first_name
      last_name
    }
    emails: user_contact_details(
      order_by: {is_primary_for_contact_type: desc}
      where: {contact_type: {_eq: "email"}}
    ) {
      id
      contact_info
    }
  }
}
    `;

export function useLeadGroupUsersByLeadGroupIdQuery(options: Omit<Urql.UseQueryArgs<LeadGroupUsersByLeadGroupIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadGroupUsersByLeadGroupIdQuery, LeadGroupUsersByLeadGroupIdQueryVariables>({ query: LeadGroupUsersByLeadGroupIdDocument, ...options });
};
export const UpupLeadGroupUsersWithDocsByRentalAppIdDocument = gql`
    query UpupLeadGroupUsersWithDocsByRentalAppId($rentalAppId: uuid!) {
  lead_group_users(
    distinct_on: user_id
    where: {rental_applications: {id: {_eq: $rentalAppId}}}
  ) {
    id
    type
    user {
      id
      first_name
      last_name
      user_document_requests {
        id
        created_at
        created_by_admin_id
        document_id
        document_type
        instructions
      }
      documents(
        where: {type: {_nin: ["eviction_report", "credit_report", "criminal_report"]}}
      ) {
        id
        created_at
        friendly_name
        review_notes
        status
        type
      }
    }
  }
}
    `;

export function useUpupLeadGroupUsersWithDocsByRentalAppIdQuery(options: Omit<Urql.UseQueryArgs<UpupLeadGroupUsersWithDocsByRentalAppIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupLeadGroupUsersWithDocsByRentalAppIdQuery, UpupLeadGroupUsersWithDocsByRentalAppIdQueryVariables>({ query: UpupLeadGroupUsersWithDocsByRentalAppIdDocument, ...options });
};
export const HomeOccupancyStatusesForRentalsDocument = gql`
    query HomeOccupancyStatusesForRentals {
  home_occupancy_statuses(where: {left_status_at: {_is_null: true}}) {
    id
    most_recent_rental_id
    status
  }
}
    `;

export function useHomeOccupancyStatusesForRentalsQuery(options?: Omit<Urql.UseQueryArgs<HomeOccupancyStatusesForRentalsQueryVariables>, 'query'>) {
  return Urql.useQuery<HomeOccupancyStatusesForRentalsQuery, HomeOccupancyStatusesForRentalsQueryVariables>({ query: HomeOccupancyStatusesForRentalsDocument, ...options });
};
export const OwnedPortfolioHomesDocument = gql`
    query OwnedPortfolioHomes @cached(ttl: 300) {
  portfolio_homes(
    where: {home_ownership_statuses: {status: {_in: [disposing, owned]}, left_status_at: {_is_null: true}}}
  ) {
    id
    home {
      id
      address {
        id
        display_line_1
        display_line_2
        city
        state
        zip
      }
      market {
        id
        display_name
      }
    }
  }
}
    `;

export function useOwnedPortfolioHomesQuery(options?: Omit<Urql.UseQueryArgs<OwnedPortfolioHomesQueryVariables>, 'query'>) {
  return Urql.useQuery<OwnedPortfolioHomesQuery, OwnedPortfolioHomesQueryVariables>({ query: OwnedPortfolioHomesDocument, ...options });
};
export const PortfolioHomeSystemWorkOrderSystemsDocument = gql`
    query PortfolioHomeSystemWorkOrderSystems {
  portfolio_home_system_work_order_system_enum {
    system
  }
}
    `;

export function usePortfolioHomeSystemWorkOrderSystemsQuery(options?: Omit<Urql.UseQueryArgs<PortfolioHomeSystemWorkOrderSystemsQueryVariables>, 'query'>) {
  return Urql.useQuery<PortfolioHomeSystemWorkOrderSystemsQuery, PortfolioHomeSystemWorkOrderSystemsQueryVariables>({ query: PortfolioHomeSystemWorkOrderSystemsDocument, ...options });
};
export const PortfolioHomeSystemWorkOrderTypesDocument = gql`
    query PortfolioHomeSystemWorkOrderTypes {
  portfolio_home_system_work_order_type_enum {
    type
  }
}
    `;

export function usePortfolioHomeSystemWorkOrderTypesQuery(options?: Omit<Urql.UseQueryArgs<PortfolioHomeSystemWorkOrderTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<PortfolioHomeSystemWorkOrderTypesQuery, PortfolioHomeSystemWorkOrderTypesQueryVariables>({ query: PortfolioHomeSystemWorkOrderTypesDocument, ...options });
};
export const PrequalificationDetailsByUserIdDocument = gql`
    query prequalificationDetailsByUserId($id: uuid!) {
  user_prequalification_data(where: {user_id: {_eq: $id}}) {
    id
    prequalification_status
    is_section_eight
    is_ok_with_two_year_lease
    is_income_qualified
    is_credit_qualified
    has_cosigner
    has_coapplicant
  }
}
    `;

export function usePrequalificationDetailsByUserIdQuery(options: Omit<Urql.UseQueryArgs<PrequalificationDetailsByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<PrequalificationDetailsByUserIdQuery, PrequalificationDetailsByUserIdQueryVariables>({ query: PrequalificationDetailsByUserIdDocument, ...options });
};
export const UpupProcessedUtilityBillsDocument = gql`
    query UpupProcessedUtilityBills($limit: Int) {
  kafka_connector_prorated_utility_bill_line_items(
    order_by: {created_at: desc}
    limit: $limit
  ) {
    buildium_csv
    id
    rental_liabilities
    transformations
    original_upload_url
    original_upload
    created_at
    rental_liabilities_csv
    unknown_memos
    known_liabilities_do_not_cover_full_bill_csv
    potential_duplicates_csv
  }
}
    `;

export function useUpupProcessedUtilityBillsQuery(options?: Omit<Urql.UseQueryArgs<UpupProcessedUtilityBillsQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupProcessedUtilityBillsQuery, UpupProcessedUtilityBillsQueryVariables>({ query: UpupProcessedUtilityBillsDocument, ...options });
};
export const UpUpPropertyInformationForUtilityBillsDocument = gql`
    query UpUpPropertyInformationForUtilityBills @cached {
  llcs {
    id
    name
    abbreviation
  }
  llc_properties {
    llc {
      id
    }
    start_date
    end_date
    property {
      id
      rentals {
        final_liability_date
        occupancy_date
        user_id
        id
      }
      real_estate_acquisition {
        mls_listing {
          display_line_1
          street
          city
          state
          zip
          id
        }
      }
    }
  }
  funds {
    id
    name
    abbreviation
  }
  fund_llcs {
    fund_id
    llc_id
  }
  real_estate_acquisitions {
    canceled_at
    closing_date
    llc_id
    mls_listing {
      display_line_1
      street
      city
      state
      zip
      id
    }
    status
    possession_at
    utilities_activation_date
  }
}
    `;

export function useUpUpPropertyInformationForUtilityBillsQuery(options?: Omit<Urql.UseQueryArgs<UpUpPropertyInformationForUtilityBillsQueryVariables>, 'query'>) {
  return Urql.useQuery<UpUpPropertyInformationForUtilityBillsQuery, UpUpPropertyInformationForUtilityBillsQueryVariables>({ query: UpUpPropertyInformationForUtilityBillsDocument, ...options });
};
export const RentReadyDatesByOpportunityIdDocument = gql`
    query RentReadyDatesByOpportunityId($opportunityId: uuid!) {
  rent_ready_dates(
    limit: 1
    order_by: {created_at: desc}
    where: {is_active: {_eq: true}, mls_listing_id: {_eq: $opportunityId}}
  ) {
    id
    earliest_move_in_date
  }
}
    `;

export function useRentReadyDatesByOpportunityIdQuery(options: Omit<Urql.UseQueryArgs<RentReadyDatesByOpportunityIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RentReadyDatesByOpportunityIdQuery, RentReadyDatesByOpportunityIdQueryVariables>({ query: RentReadyDatesByOpportunityIdDocument, ...options });
};
export const RentRollRentalDetailsDocument = gql`
    query RentRollRentalDetails($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    ...RentRollDetailsRental
  }
}
    ${RentRollDetailsRentalFragmentDoc}`;

export function useRentRollRentalDetailsQuery(options: Omit<Urql.UseQueryArgs<RentRollRentalDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollRentalDetailsQuery, RentRollRentalDetailsQueryVariables>({ query: RentRollRentalDetailsDocument, ...options });
};
export const ActiveRentalApplicationDecisionByRentalApplicationIdDocument = gql`
    query ActiveRentalApplicationDecisionByRentalApplicationId($rentalApplicationId: uuid!) {
  rental_application_decisions(
    where: {rental_application_id: {_eq: $rentalApplicationId}, deactivated_at: {_is_null: true}}
  ) {
    id
    admin {
      id
      first_name
      last_name
    }
    decided_at
    deposit_rent_multiple
    is_approved
    rejection_reason
    weighted_average_credit_score_at_decision
    usable_income_at_decision
  }
}
    `;

export function useActiveRentalApplicationDecisionByRentalApplicationIdQuery(options: Omit<Urql.UseQueryArgs<ActiveRentalApplicationDecisionByRentalApplicationIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ActiveRentalApplicationDecisionByRentalApplicationIdQuery, ActiveRentalApplicationDecisionByRentalApplicationIdQueryVariables>({ query: ActiveRentalApplicationDecisionByRentalApplicationIdDocument, ...options });
};
export const UserIncomeByUserIdDocument = gql`
    query UserIncomeByUserId($userId: uuid!) {
  user_incomes: applicant_income_underwrites_user_incomes(
    where: {user_id: {_eq: $userId}, deactivated_at: {_is_null: true}}
  ) {
    id
    initially_completed_at
    is_non_income_applicant
    approved_at
    approved_by_admin: admin {
      id
      first_name
      last_name
    }
    additional_income_requested_at
    additional_income_submitted_at
    annual_income
    user_income_sources(
      where: {deleted_by_user_at: {_is_null: true}, invalidated_at: {_is_null: true}}
    ) {
      id
      source_annual_income
      status
      employed {
        id
        employment_verification_status
      }
      self_employed {
        id
        business_name
      }
      benefits {
        id
        benefits_type
        pay_frequency
      }
      user_income_source_documents {
        id
        amount
        document_id
      }
    }
  }
}
    `;

export function useUserIncomeByUserIdQuery(options: Omit<Urql.UseQueryArgs<UserIncomeByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UserIncomeByUserIdQuery, UserIncomeByUserIdQueryVariables>({ query: UserIncomeByUserIdDocument, ...options });
};
export const RentalApplicationInitialUnderwritingDataDocument = gql`
    query RentalApplicationInitialUnderwritingData($rentalApplicationId: uuid!) {
  rental_applications_by_pk(id: $rentalApplicationId) {
    id
    preapproved_at
    lead_group {
      lead_group_users(where: {deactivated_at: {_is_null: true}}) {
        user {
          id
          first_name
          last_name
          user_underwriting_data(
            where: {deactivated_at: {_is_null: true}}
            order_by: {created_at: desc}
          ) {
            id
            credit_score
            verified_income
          }
        }
      }
    }
  }
}
    `;

export function useRentalApplicationInitialUnderwritingDataQuery(options: Omit<Urql.UseQueryArgs<RentalApplicationInitialUnderwritingDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalApplicationInitialUnderwritingDataQuery, RentalApplicationInitialUnderwritingDataQueryVariables>({ query: RentalApplicationInitialUnderwritingDataDocument, ...options });
};
export const AssignLeadGroupDocument = gql`
    mutation AssignLeadGroup($adminId: uuid!, $leadGroupId: uuid!, $agentType: agent_lead_group_owners_agent_type_enum_enum!) {
  update_agent_lead_group_owners(
    where: {deactivated_at: {_is_null: true}, agent_type: {_eq: $agentType}, lead_group_id: {_eq: $leadGroupId}}
    _set: {deactivated_at: "now()"}
  ) {
    affected_rows
  }
  insert_agent_lead_group_owners_one(
    object: {agent_admin_id: $adminId, agent_type: $agentType, lead_group_id: $leadGroupId}
  ) {
    id
  }
}
    `;

export function useAssignLeadGroupMutation() {
  return Urql.useMutation<AssignLeadGroupMutation, AssignLeadGroupMutationVariables>(AssignLeadGroupDocument);
};
export const EscalateRentalApplicationDocument = gql`
    mutation EscalateRentalApplication($reason: String, $assigned_by_admin_id: uuid, $assigned_to_admin_id: uuid, $rental_application_id: uuid) {
  insert_rental_application_manager_application_escalations_one(
    object: {assigned_by_admin_id: $assigned_by_admin_id, assigned_to_admin_id: $assigned_to_admin_id, escalation_status: pending, reason: $reason, rental_application_id: $rental_application_id}
  ) {
    id
  }
}
    `;

export function useEscalateRentalApplicationMutation() {
  return Urql.useMutation<EscalateRentalApplicationMutation, EscalateRentalApplicationMutationVariables>(EscalateRentalApplicationDocument);
};
export const LeadGroupAssignmentsByLeadGroupIdDocument = gql`
    query LeadGroupAssignmentsByLeadGroupId($leadGroupId: uuid!) {
  agent_lead_group_owners(
    where: {lead_group_id: {_eq: $leadGroupId}, deactivated_at: {_is_null: true}}
  ) {
    id
    agent_type
    admin {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useLeadGroupAssignmentsByLeadGroupIdQuery(options: Omit<Urql.UseQueryArgs<LeadGroupAssignmentsByLeadGroupIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadGroupAssignmentsByLeadGroupIdQuery, LeadGroupAssignmentsByLeadGroupIdQueryVariables>({ query: LeadGroupAssignmentsByLeadGroupIdDocument, ...options });
};
export const FindRecentNoteByResourceIdDocument = gql`
    query FindRecentNoteByResourceId($resourceId: uuid!) {
  notes(
    where: {resource_id: {_eq: $resourceId}}
    order_by: {created_at: desc_nulls_last}
    limit: 1
  ) {
    id
    resource_id
    resource_type
    note
    created_at
    admin {
      id
      first_name
      last_name
    }
    priority
  }
}
    `;

export function useFindRecentNoteByResourceIdQuery(options: Omit<Urql.UseQueryArgs<FindRecentNoteByResourceIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FindRecentNoteByResourceIdQuery, FindRecentNoteByResourceIdQueryVariables>({ query: FindRecentNoteByResourceIdDocument, ...options });
};
export const RaEscalationsByRaIdDocument = gql`
    query RAEscalationsByRAId($rentalApplicationId: uuid!) {
  rental_application_manager_application_escalations(
    where: {rental_application_id: {_eq: $rentalApplicationId}, canceled_at: {_is_null: true}}
    order_by: {updated_at: desc_nulls_last}
  ) {
    assigned_by_admin {
      first_name
      last_name
      id
    }
    assigned_to_admin {
      first_name
      last_name
      id
    }
    escalation_status
    id
    reason
    rental_application_id
    resolution_note
    resolved_at
    created_at
    resolved_by_admin {
      first_name
      last_name
      id
    }
  }
}
    `;

export function useRaEscalationsByRaIdQuery(options: Omit<Urql.UseQueryArgs<RaEscalationsByRaIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RaEscalationsByRaIdQuery, RaEscalationsByRaIdQueryVariables>({ query: RaEscalationsByRaIdDocument, ...options });
};
export const RaSnoozesByRaIdDocument = gql`
    query RASnoozesByRAId($id: uuid!) {
  rental_application_manager_application_snoozes(
    order_by: {snoozed_until: desc_nulls_last}
    where: {rental_application_id: {_eq: $id}, deleted_at: {_is_null: true}, snoozed_until: {_gt: "now()"}}
    limit: 1
  ) {
    id
    snooze_reason
    snoozed_until
    snoozed_by_admin {
      id
      first_name
      last_name
    }
  }
}
    `;

export function useRaSnoozesByRaIdQuery(options: Omit<Urql.UseQueryArgs<RaSnoozesByRaIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RaSnoozesByRaIdQuery, RaSnoozesByRaIdQueryVariables>({ query: RaSnoozesByRaIdDocument, ...options });
};
export const RentalApplicationManagerAdminRolesDocument = gql`
    query RentalApplicationManagerAdminRoles {
  agent_lead_group_owners_agent_type_enum {
    agent_type
  }
}
    `;

export function useRentalApplicationManagerAdminRolesQuery(options?: Omit<Urql.UseQueryArgs<RentalApplicationManagerAdminRolesQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalApplicationManagerAdminRolesQuery, RentalApplicationManagerAdminRolesQueryVariables>({ query: RentalApplicationManagerAdminRolesDocument, ...options });
};
export const ResolveRentalAppEscalationDocument = gql`
    mutation ResolveRentalAppEscalation($rental_application_id: uuid!, $resolved_by_admin_id: uuid!, $resolution_note: String = "") {
  update_rental_application_manager_application_escalations(
    where: {rental_application_id: {_eq: $rental_application_id}, escalation_status: {_eq: pending}}
    _set: {resolved_at: "now()", resolution_note: $resolution_note, resolved_by_admin_id: $resolved_by_admin_id, escalation_status: resolved}
  ) {
    returning {
      id
      rental_application_id
      resolution_note
      resolved_at
      resolved_by_admin_id
      escalation_status
    }
  }
}
    `;

export function useResolveRentalAppEscalationMutation() {
  return Urql.useMutation<ResolveRentalAppEscalationMutation, ResolveRentalAppEscalationMutationVariables>(ResolveRentalAppEscalationDocument);
};
export const SnoozeReasonsDocument = gql`
    query SnoozeReasons {
  rental_application_manager_snooze_reasons {
    snooze_reason
  }
}
    `;

export function useSnoozeReasonsQuery(options?: Omit<Urql.UseQueryArgs<SnoozeReasonsQueryVariables>, 'query'>) {
  return Urql.useQuery<SnoozeReasonsQuery, SnoozeReasonsQueryVariables>({ query: SnoozeReasonsDocument, ...options });
};
export const SnoozeRentalApplicationDocument = gql`
    mutation SnoozeRentalApplication($rental_application_id: uuid!, $snoozed_until: timestamptz!, $snooze_reason: rental_application_manager_snooze_reasons_enum!, $snoozed_by_admin_id: uuid!) {
  insert_rental_application_manager_application_snoozes_one(
    object: {rental_application_id: $rental_application_id, snooze_reason: $snooze_reason, snoozed_until: $snoozed_until, snoozed_by_admin_id: $snoozed_by_admin_id}
  ) {
    id
    rental_application_id
  }
}
    `;

export function useSnoozeRentalApplicationMutation() {
  return Urql.useMutation<SnoozeRentalApplicationMutation, SnoozeRentalApplicationMutationVariables>(SnoozeRentalApplicationDocument);
};
export const SoftDeleteRaSnoozeDocument = gql`
    mutation SoftDeleteRASnooze($rentalApplicationId: uuid!) {
  update_rental_application_manager_application_snoozes(
    where: {rental_application_id: {_eq: $rentalApplicationId}, deleted_at: {_is_null: true}}
    _set: {deleted_at: "now()"}
  ) {
    returning {
      id
      rental_application_id
      deleted_at
    }
  }
}
    `;

export function useSoftDeleteRaSnoozeMutation() {
  return Urql.useMutation<SoftDeleteRaSnoozeMutation, SoftDeleteRaSnoozeMutationVariables>(SoftDeleteRaSnoozeDocument);
};
export const UpupRentalApplicationsCountDocument = gql`
    query UpupRentalApplicationsCount($where: rental_applications_bool_exp = {}) {
  rental_applications_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useUpupRentalApplicationsCountQuery(options?: Omit<Urql.UseQueryArgs<UpupRentalApplicationsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupRentalApplicationsCountQuery, UpupRentalApplicationsCountQueryVariables>({ query: UpupRentalApplicationsCountDocument, ...options });
};
export const UpupRentalListDocument = gql`
    query UpupRentalList($onlyActive: Boolean!) {
  activeRentals: rentals(
    where: {_or: [{status: {_eq: "active"}}, {status: {_eq: "pending"}}]}
  ) @include(if: $onlyActive) {
    ...RentRollListRental
  }
  allRentals: rentals @skip(if: $onlyActive) {
    ...RentRollListRental
  }
}
    ${RentRollListRentalFragmentDoc}`;

export function useUpupRentalListQuery(options: Omit<Urql.UseQueryArgs<UpupRentalListQueryVariables>, 'query'>) {
  return Urql.useQuery<UpupRentalListQuery, UpupRentalListQueryVariables>({ query: UpupRentalListDocument, ...options });
};
export const RentalSearchDocument = gql`
    query RentalSearch($query: String!, $rentalIds: [uuid!], $tenantNameQuery: String!, $tenantFieldQuery: String!, $firstNameQuery: String!, $lastNameQuery: String!) {
  rentals(
    where: {_or: [{id: {_in: $rentalIds}}, {portfolio_home: {home: {address: {display_line_1: {_ilike: $query}}}}}, {portfolio_home: {home: {address: {display_line_2: {_ilike: $query}}}}}, {rental_users: {deactivated_at: {_is_null: true}, user: {_or: [{user_searchable: {name: {_ilike: $tenantNameQuery}}}, {first_name: {_ilike: $tenantFieldQuery}}, {last_name: {_ilike: $tenantFieldQuery}}, {_and: [{first_name: {_ilike: $firstNameQuery}}, {last_name: {_ilike: $lastNameQuery}}]}]}}}]}
    order_by: {occupancy_date: desc}
    limit: 25
  ) {
    id
    occupancy_date
    move_out_date
    portfolio_home {
      home {
        address {
          display_line_1
          display_line_2
        }
      }
    }
    rental_users(where: {deactivated_at: {_is_null: true}}) {
      user {
        first_name
        last_name
      }
    }
  }
}
    `;

export function useRentalSearchQuery(options: Omit<Urql.UseQueryArgs<RentalSearchQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalSearchQuery, RentalSearchQueryVariables>({ query: RentalSearchDocument, ...options });
};
export const RentalsByUserIdDocument = gql`
    query RentalsByUserId($userId: uuid!) {
  rental_users(where: {deactivated_at: {_is_null: true}, user_id: {_eq: $userId}}) {
    id
    role
    rental {
      id
      status
      occupancy_date
      move_out_date
      portfolio_home {
        home {
          address {
            display_line_1
            display_line_2
            id
          }
          market {
            display_name
            id
          }
        }
      }
    }
  }
}
    `;

export function useRentalsByUserIdQuery(options: Omit<Urql.UseQueryArgs<RentalsByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalsByUserIdQuery, RentalsByUserIdQueryVariables>({ query: RentalsByUserIdDocument, ...options });
};
export const SetRentalApplicationAutoRemindersDisabledAtDocument = gql`
    mutation SetRentalApplicationAutoRemindersDisabledAt($pk_columns: rental_applications_pk_columns_input!, $auto_reminders_disabled_at: timestamptz, $auto_reminders_disabled_by_admin_id: uuid) {
  update_rental_applications_by_pk(
    pk_columns: $pk_columns
    _set: {auto_reminders_disabled_at: $auto_reminders_disabled_at, auto_reminders_disabled_by_admin_id: $auto_reminders_disabled_by_admin_id}
  ) {
    id
    auto_reminders_disabled_at
    auto_reminders_disabled_by_admin_id
  }
}
    `;

export function useSetRentalApplicationAutoRemindersDisabledAtMutation() {
  return Urql.useMutation<SetRentalApplicationAutoRemindersDisabledAtMutation, SetRentalApplicationAutoRemindersDisabledAtMutationVariables>(SetRentalApplicationAutoRemindersDisabledAtDocument);
};
export const SetRentalApplicationPriorityDocument = gql`
    mutation SetRentalApplicationPriority($pk_columns: rental_applications_pk_columns_input!, $priority_score: Int) {
  update_rental_applications_by_pk(
    pk_columns: $pk_columns
    _set: {priority_score: $priority_score}
  ) {
    id
    priority_score
  }
}
    `;

export function useSetRentalApplicationPriorityMutation() {
  return Urql.useMutation<SetRentalApplicationPriorityMutation, SetRentalApplicationPriorityMutationVariables>(SetRentalApplicationPriorityDocument);
};
export const SetRentalApplicationRecievedProductPitchDocument = gql`
    mutation SetRentalApplicationRecievedProductPitch($pk_columns: rental_applications_pk_columns_input!, $did_receive_initial_product_pitch: Boolean!) {
  set: update_rental_applications_by_pk(
    _set: {received_initial_product_pitch_at: "now"}
    pk_columns: $pk_columns
  ) @include(if: $did_receive_initial_product_pitch) {
    id
    received_initial_product_pitch_at
  }
  unset: update_rental_applications_by_pk(
    _set: {received_initial_product_pitch_at: null}
    pk_columns: $pk_columns
  ) @skip(if: $did_receive_initial_product_pitch) {
    id
    received_initial_product_pitch_at
  }
}
    `;

export function useSetRentalApplicationRecievedProductPitchMutation() {
  return Urql.useMutation<SetRentalApplicationRecievedProductPitchMutation, SetRentalApplicationRecievedProductPitchMutationVariables>(SetRentalApplicationRecievedProductPitchDocument);
};
export const SetRentalApplicationRentDocument = gql`
    mutation SetRentalApplicationRent($pk_columns: rental_applications_pk_columns_input!, $rent: numeric) {
  update_rental_applications_by_pk(pk_columns: $pk_columns, _set: {rent: $rent}) {
    id
    rent
  }
}
    `;

export function useSetRentalApplicationRentMutation() {
  return Urql.useMutation<SetRentalApplicationRentMutation, SetRentalApplicationRentMutationVariables>(SetRentalApplicationRentDocument);
};
export const ToursByLeadGroupIdDocument = gql`
    query toursByLeadGroupId($id: uuid!) {
  tours(where: {lead_group_id: {_eq: $id}}) {
    id
    start_at
    status
    type
    tour_properties {
      id
      mls_listing {
        id
        display_line_1
        display_line_2
      }
    }
  }
}
    `;

export function useToursByLeadGroupIdQuery(options: Omit<Urql.UseQueryArgs<ToursByLeadGroupIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ToursByLeadGroupIdQuery, ToursByLeadGroupIdQueryVariables>({ query: ToursByLeadGroupIdDocument, ...options });
};
export const UpupUpdateDashboardDocument = gql`
    mutation UpupUpdateDashboard($id: uuid!, $category: String, $name: String, $description: String, $url: String, $icon: String) {
  update_dashboards_by_pk(
    pk_columns: {id: $id}
    _set: {category: $category, name: $name, description: $description, url: $url, icon: $icon}
  ) {
    id
  }
}
    `;

export function useUpupUpdateDashboardMutation() {
  return Urql.useMutation<UpupUpdateDashboardMutation, UpupUpdateDashboardMutationVariables>(UpupUpdateDashboardDocument);
};
export const UpupUpdateDocumentDocument = gql`
    mutation UpupUpdateDocument($documentId: uuid!, $status: String, $friendlyName: String, $resourceNotes: String) {
  update_documents_by_pk(
    pk_columns: {id: $documentId}
    _set: {status: $status, friendly_name: $friendlyName, resource_notes: $resourceNotes}
  ) {
    id
  }
}
    `;

export function useUpupUpdateDocumentMutation() {
  return Urql.useMutation<UpupUpdateDocumentMutation, UpupUpdateDocumentMutationVariables>(UpupUpdateDocumentDocument);
};
export const UserByUserIdDocument = gql`
    query UserByUserId($id: uuid!) {
  users_by_pk(id: $id) {
    user_contact_details {
      id
      contact_type
      contact_info
    }
    first_name
    last_name
    id
  }
}
    `;

export function useUserByUserIdQuery(options: Omit<Urql.UseQueryArgs<UserByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UserByUserIdQuery, UserByUserIdQueryVariables>({ query: UserByUserIdDocument, ...options });
};
export const UpupUserListDocument = gql`
    subscription UpupUserList($where: users_bool_exp = {}) {
  users(limit: 10, where: $where) {
    id
    close_lead_id
    first_name
    last_name
    user_contact_details(where: {is_primary_for_contact_type: {_eq: true}}) {
      id
      contact_type
      contact_info
    }
  }
}
    `;

export function useUpupUserListSubscription<TData = UpupUserListSubscription>(options?: Omit<Urql.UseSubscriptionArgs<UpupUserListSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<UpupUserListSubscription, TData>) {
  return Urql.useSubscription<UpupUserListSubscription, TData, UpupUserListSubscriptionVariables>({ query: UpupUserListDocument, ...options }, handler);
};
export const UpUpUserTimelineByUserIdDocument = gql`
    query UpUpUserTimelineByUserID($id: uuid!, $with_property_details: Boolean!, $with_conversations: Boolean!, $with_tours: Boolean!, $with_rental_app_events: Boolean!, $with_rental_site_leads: Boolean!) {
  users(where: {id: {_eq: $id}}) {
    id
    first_name
    last_name
    lead_group_users(where: {deactivated_at: {_is_null: true}}) {
      id
      lead_group {
        id
        tours @include(if: $with_tours) {
          ...tour_items
        }
        rental_applications @include(if: $with_rental_app_events) {
          ...rental_applications_items
        }
      }
    }
    conversations @include(if: $with_conversations) {
      ...conversations_items
    }
    rental_site_leads @include(if: $with_rental_site_leads) {
      ...rental_site_lead_items
    }
  }
}
    ${Tour_ItemsFragmentDoc}
${Rental_Applications_ItemsFragmentDoc}
${Conversations_ItemsFragmentDoc}
${Rental_Site_Lead_ItemsFragmentDoc}`;

export function useUpUpUserTimelineByUserIdQuery(options: Omit<Urql.UseQueryArgs<UpUpUserTimelineByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UpUpUserTimelineByUserIdQuery, UpUpUserTimelineByUserIdQueryVariables>({ query: UpUpUserTimelineByUserIdDocument, ...options });
};
export const UpUpAddProcessedUtilityBillDocument = gql`
    mutation UpUpAddProcessedUtilityBill($transformations: json = {}, $rental_liabilities: json = {}, $original_upload_url: String = "http://", $original_upload: String = "c,s,v", $buildium_csv: String = "c,s,v", $rental_liabilities_csv: String = "c,s,v", $potential_duplicates_csv: String = "c,s,v", $known_liabilities_do_not_cover_full_bill_csv: String = "c,s,v", $unknown_memos: String = "") {
  insert_kafka_connector_prorated_utility_bill_line_items_one(
    object: {original_upload_url: $original_upload_url, original_upload: $original_upload, transformations: $transformations, buildium_csv: $buildium_csv, rental_liabilities: $rental_liabilities, rental_liabilities_csv: $rental_liabilities_csv, potential_duplicates_csv: $potential_duplicates_csv, known_liabilities_do_not_cover_full_bill_csv: $known_liabilities_do_not_cover_full_bill_csv, unknown_memos: $unknown_memos}
  ) {
    buildium_csv
    id
    rental_liabilities
    transformations
    original_upload_url
    original_upload
    created_at
    rental_liabilities_csv
    unknown_memos
    known_liabilities_do_not_cover_full_bill_csv
    potential_duplicates_csv
  }
}
    `;

export function useUpUpAddProcessedUtilityBillMutation() {
  return Urql.useMutation<UpUpAddProcessedUtilityBillMutation, UpUpAddProcessedUtilityBillMutationVariables>(UpUpAddProcessedUtilityBillDocument);
};
export const CreatePromiseToPayDocument = gql`
    mutation CreatePromiseToPay($collectionId: uuid!, $promiseToPayDate: date!, $adminId: uuid!) {
  insert_collection_payment_promises_one(
    object: {collection_id: $collectionId, promise_to_pay_date: $promiseToPayDate, created_by_admin_id: $adminId}
  ) {
    id
  }
}
    `;

export function useCreatePromiseToPayMutation() {
  return Urql.useMutation<CreatePromiseToPayMutation, CreatePromiseToPayMutationVariables>(CreatePromiseToPayDocument);
};
export const CancelPromiseToPayDocument = gql`
    mutation CancelPromiseToPay($promiseId: uuid!, $canceledAt: timestamptz!) {
  update_collection_payment_promises_by_pk(
    pk_columns: {id: $promiseId}
    _set: {canceled_at: $canceledAt}
  ) {
    id
  }
}
    `;

export function useCancelPromiseToPayMutation() {
  return Urql.useMutation<CancelPromiseToPayMutation, CancelPromiseToPayMutationVariables>(CancelPromiseToPayDocument);
};
export const UpdatePromiseToPayDateDocument = gql`
    mutation UpdatePromiseToPayDate($promiseId: uuid!, $promiseToPayDate: date!) {
  update_collection_payment_promises_by_pk(
    pk_columns: {id: $promiseId}
    _set: {promise_to_pay_date: $promiseToPayDate}
  ) {
    id
  }
}
    `;

export function useUpdatePromiseToPayDateMutation() {
  return Urql.useMutation<UpdatePromiseToPayDateMutation, UpdatePromiseToPayDateMutationVariables>(UpdatePromiseToPayDateDocument);
};
export const CollectionsByMonthDocument = gql`
    query CollectionsByMonth($firstDayOfMonth: date!, $lastDayOfMonth: date!) {
  collections(where: {month: {_gte: $firstDayOfMonth, _lte: $lastDayOfMonth}}) {
    id
    month
    late_payment_reason
    zendesk_link
    collection_payment_promises(
      limit: 1
      order_by: {created_at: desc}
      where: {canceled_at: {_is_null: true}}
    ) {
      id
      promise_to_pay_date
      created_at
    }
    note {
      id
      note
    }
    rental {
      id
      status
      occupancy_date
      move_out_date
      current_balance {
        id
        aggregate_balance_after
      }
      evictions(where: {status: {_neq: "canceled"}}) {
        id
        status
      }
      notes(order_by: {created_at: desc}, where: {is_deleted: {_eq: false}}) {
        id
        note
        created_at
        created_by_admin_id
      }
      payments(where: {status: {_eq: "processing"}}) {
        id
        amount
        status
        liability_type_id
        liability_type {
          id
          name
        }
      }
      portfolio_home {
        id
        home {
          id
          address {
            id
            display_line_1
            city
            state
          }
        }
        most_recent_llc_property {
          id
          llc {
            id
            name
            fund_llcs {
              id
              fund {
                id
                name
                abbreviation
              }
            }
          }
        }
      }
      rental_agreement_histories(
        where: {is_active: {_eq: true}, starts_at: {_lte: $firstDayOfMonth}}
      ) {
        id
        rent
      }
      rental_users(where: {deactivated_at: {_is_null: true}, role: {_eq: "primary"}}) {
        id
        user {
          id
          first_name
          last_name
        }
      }
    }
  }
}
    `;

export function useCollectionsByMonthQuery(options: Omit<Urql.UseQueryArgs<CollectionsByMonthQueryVariables>, 'query'>) {
  return Urql.useQuery<CollectionsByMonthQuery, CollectionsByMonthQueryVariables>({ query: CollectionsByMonthDocument, ...options });
};
export const LiabilitiesRemainingForCollectionsDocument = gql`
    query LiabilitiesRemainingForCollections($firstDayOfMonth: date!, $lastDayOfMonth: date!) {
  collections(where: {month: {_gte: $firstDayOfMonth, _lte: $lastDayOfMonth}}) {
    id
    liabilities_remaining {
      liability_id
      amount_remaining
      original_amount
    }
  }
}
    `;

export function useLiabilitiesRemainingForCollectionsQuery(options: Omit<Urql.UseQueryArgs<LiabilitiesRemainingForCollectionsQueryVariables>, 'query'>) {
  return Urql.useQuery<LiabilitiesRemainingForCollectionsQuery, LiabilitiesRemainingForCollectionsQueryVariables>({ query: LiabilitiesRemainingForCollectionsDocument, ...options });
};
export const UpdateCollectionsLatePaymentReasonDocument = gql`
    mutation UpdateCollectionsLatePaymentReason($collectionId: uuid!, $latePaymentReason: collections_late_payment_reason_enum_enum = null) {
  update_collections_by_pk(
    pk_columns: {id: $collectionId}
    _set: {late_payment_reason: $latePaymentReason}
  ) {
    id
    late_payment_reason
  }
}
    `;

export function useUpdateCollectionsLatePaymentReasonMutation() {
  return Urql.useMutation<UpdateCollectionsLatePaymentReasonMutation, UpdateCollectionsLatePaymentReasonMutationVariables>(UpdateCollectionsLatePaymentReasonDocument);
};
export const UpdateCollectionsZendeskLinkDocument = gql`
    mutation UpdateCollectionsZendeskLink($collectionId: uuid!, $zendeskLink: String = null) {
  update_collections_by_pk(
    pk_columns: {id: $collectionId}
    _set: {zendesk_link: $zendeskLink}
  ) {
    id
    zendesk_link
  }
}
    `;

export function useUpdateCollectionsZendeskLinkMutation() {
  return Urql.useMutation<UpdateCollectionsZendeskLinkMutation, UpdateCollectionsZendeskLinkMutationVariables>(UpdateCollectionsZendeskLinkDocument);
};
export const EvictionsDocument = gql`
    query Evictions {
  evictions(order_by: {created_at: desc}) {
    id
    rental_id
    status
    created_at
    updated_at
    filed_at
    file_sent_to_attorney_at
    completed_at
    canceled_at
    cancelation_reason
    court_date
    writ_date
    set_out_date
    projected_possession_date
    consent_judgement
    filed_by_admin {
      id
      first_name
      last_name
    }
    file_sent_to_attorney_by_admin {
      id
      first_name
      last_name
    }
    completed_by_admin {
      id
      first_name
      last_name
    }
    canceled_by_admin {
      id
      first_name
      last_name
    }
    eviction_filing_fees(order_by: {charged_at: asc}) {
      id
      charged_at
      charged_by_admin {
        id
        first_name
        last_name
      }
      rental_liability {
        id
        amount
        note
      }
    }
    rental {
      id
      notes(
        where: {is_deleted: {_eq: false}, resource_type: {_eq: "rentals"}}
        order_by: {created_at: desc}
      ) {
        id
        note
        category
        created_at
        admin {
          id
          first_name
          last_name
        }
      }
      user {
        id
        first_name
        last_name
      }
      portfolio_home {
        home {
          address {
            display_line_1
            display_line_2
          }
        }
        most_recent_llc_property {
          llc {
            fund_llcs(where: {end_date: {_is_null: true}}) {
              fund {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useEvictionsQuery(options?: Omit<Urql.UseQueryArgs<EvictionsQueryVariables>, 'query'>) {
  return Urql.useQuery<EvictionsQuery, EvictionsQueryVariables>({ query: EvictionsDocument, ...options });
};
export const SearchRentalsForEvictionDocument = gql`
    query SearchRentalsForEviction($search: String!) {
  rentals(
    where: {status: {_eq: "active"}, portfolio_home: {home: {address: {display_line_1: {_ilike: $search}}}}}
    limit: 10
    order_by: {created_at: desc}
  ) {
    id
    user {
      id
      first_name
      last_name
    }
    portfolio_home {
      home {
        address {
          display_line_1
          display_line_2
        }
      }
    }
  }
}
    `;

export function useSearchRentalsForEvictionQuery(options: Omit<Urql.UseQueryArgs<SearchRentalsForEvictionQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchRentalsForEvictionQuery, SearchRentalsForEvictionQueryVariables>({ query: SearchRentalsForEvictionDocument, ...options });
};
export const Upup_CreateRentalAddOnDocument = gql`
    mutation Upup_CreateRentalAddOn($liability_type_id: uuid!, $rental_id: uuid!, $start_date: date!, $end_date: date, $price: numeric!) {
  insert_rental_add_ons_one(
    object: {end_date: $end_date, liability_type_id: $liability_type_id, price: $price, rental_id: $rental_id, start_date: $start_date}
  ) {
    id
    end_date
    liability_type {
      name
    }
    price
    start_date
  }
}
    `;

export function useUpup_CreateRentalAddOnMutation() {
  return Urql.useMutation<Upup_CreateRentalAddOnMutation, Upup_CreateRentalAddOnMutationVariables>(Upup_CreateRentalAddOnDocument);
};
export const RentRollAddOnsDataDocument = gql`
    query RentRollAddOnsData($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    occupancy_date
    rental_add_ons {
      ...RentRollRentalAddOns
    }
  }
}
    ${RentRollRentalAddOnsFragmentDoc}`;

export function useRentRollAddOnsDataQuery(options: Omit<Urql.UseQueryArgs<RentRollAddOnsDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollAddOnsDataQuery, RentRollAddOnsDataQueryVariables>({ query: RentRollAddOnsDataDocument, ...options });
};
export const Upup_UpdateRentalAddOnDocument = gql`
    mutation Upup_UpdateRentalAddOn($where: rental_add_ons_bool_exp!, $start_date: date!, $end_date: date, $price: numeric!) {
  update_rental_add_ons(
    where: $where
    _set: {end_date: $end_date, price: $price, start_date: $start_date}
  ) {
    affected_rows
    returning {
      id
      updated_at
      end_date
      price
      start_date
      liability_type {
        name
      }
    }
  }
}
    `;

export function useUpup_UpdateRentalAddOnMutation() {
  return Urql.useMutation<Upup_UpdateRentalAddOnMutation, Upup_UpdateRentalAddOnMutationVariables>(Upup_UpdateRentalAddOnDocument);
};
export const Upup_CreateRentalAgreementHistoryDocument = gql`
    mutation Upup_CreateRentalAgreementHistory($rental_id: uuid, $rent: numeric, $type: String, $starts_at: date, $ends_at: date) {
  insert_rental_agreement_histories_one(
    object: {ends_at: $ends_at, is_active: true, option_premium: 0, rent: $rent, type: $type, rental_id: $rental_id, starts_at: $starts_at}
  ) {
    ends_at
    rent
    type
    rental_id
    starts_at
  }
}
    `;

export function useUpup_CreateRentalAgreementHistoryMutation() {
  return Urql.useMutation<Upup_CreateRentalAgreementHistoryMutation, Upup_CreateRentalAgreementHistoryMutationVariables>(Upup_CreateRentalAgreementHistoryDocument);
};
export const Upup_LiabilityTypesDocument = gql`
    query Upup_LiabilityTypes @cached {
  liability_types(where: {deactivated_at: {_is_null: true}}) {
    id
    is_variable
    name
    price
    recurring
    payment_category
    utility_types {
      id
    }
  }
}
    `;

export function useUpup_LiabilityTypesQuery(options?: Omit<Urql.UseQueryArgs<Upup_LiabilityTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<Upup_LiabilityTypesQuery, Upup_LiabilityTypesQueryVariables>({ query: Upup_LiabilityTypesDocument, ...options });
};
export const Upup_EditRentalAgreementHistoryDocument = gql`
    mutation Upup_EditRentalAgreementHistory($ends_at: date, $id: uuid!) {
  update_rental_agreement_histories_by_pk(
    pk_columns: {id: $id}
    _set: {ends_at: $ends_at}
  ) {
    id
    ends_at
  }
}
    `;

export function useUpup_EditRentalAgreementHistoryMutation() {
  return Urql.useMutation<Upup_EditRentalAgreementHistoryMutation, Upup_EditRentalAgreementHistoryMutationVariables>(Upup_EditRentalAgreementHistoryDocument);
};
export const DeleteRecurringCreditDocument = gql`
    mutation DeleteRecurringCredit($recurringCreditId: uuid!) {
  delete_recurring_credits_by_pk(id: $recurringCreditId) {
    id
  }
}
    `;

export function useDeleteRecurringCreditMutation() {
  return Urql.useMutation<DeleteRecurringCreditMutation, DeleteRecurringCreditMutationVariables>(DeleteRecurringCreditDocument);
};
export const Upup_LedgerAccountsDocument = gql`
    query Upup_LedgerAccounts {
  ledger_accounts(
    where: {is_active: {_eq: true}, external_source: {_eq: "buildium"}, parent_ledger_account_id: {_eq: "f87c5761-caca-47d5-a31f-b6298653c2c5"}}
  ) {
    id
    name
    rental_credit_type
  }
}
    `;

export function useUpup_LedgerAccountsQuery(options?: Omit<Urql.UseQueryArgs<Upup_LedgerAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<Upup_LedgerAccountsQuery, Upup_LedgerAccountsQueryVariables>({ query: Upup_LedgerAccountsDocument, ...options });
};
export const ExistingRentalReunderwriteForRentalDocument = gql`
    query ExistingRentalReunderwriteForRental($rentalId: uuid!) {
  rental_reunderwrites(
    where: {rental_id: {_eq: $rentalId}, status: {_neq: "canceled"}}
    order_by: {created_at: desc}
  ) {
    id
    created_at
    status
    rental_reunderwrite_tenant_underwrites {
      id
      tenant_underwrite_id
      tenant_underwrite {
        id
        contact_email
        submitted_at
        user {
          id
          first_name
          last_name
          credit_reports(limit: 1, order_by: {created_at: desc}) {
            id
            score
            status
            document_id
            created_at
          }
          criminal_reports(limit: 1, order_by: {created_at: desc}) {
            id
            document_id
            created_at
            matches
          }
          eviction_reports(limit: 1, order_by: {created_at: desc}) {
            id
            document_id
            created_at
            matches
          }
        }
        tenant_underwrite_documents {
          id
          document {
            id
            external_id
            friendly_name
            type
          }
        }
      }
    }
  }
}
    `;

export function useExistingRentalReunderwriteForRentalQuery(options: Omit<Urql.UseQueryArgs<ExistingRentalReunderwriteForRentalQueryVariables>, 'query'>) {
  return Urql.useQuery<ExistingRentalReunderwriteForRentalQuery, ExistingRentalReunderwriteForRentalQueryVariables>({ query: ExistingRentalReunderwriteForRentalDocument, ...options });
};
export const Upup_SetRentalDoNotRenewDocument = gql`
    mutation Upup_SetRentalDoNotRenew($id: uuid!, $do_not_renew_reason: String, $do_not_renew_selected_by_admin_id: uuid, $do_not_renew_selected_at: timestamptz, $lease_end_reason: String) {
  update_rentals_by_pk(
    pk_columns: {id: $id}
    _set: {do_not_renew_selected_at: $do_not_renew_selected_at, do_not_renew_selected_by_admin_id: $do_not_renew_selected_by_admin_id, do_not_renew_reason: $do_not_renew_reason, lease_end_reason: $lease_end_reason}
  ) {
    id
    do_not_renew_selected_at
    do_not_renew_selected_by_admin_id
    do_not_renew_reason
    lease_end_reason
  }
}
    `;

export function useUpup_SetRentalDoNotRenewMutation() {
  return Urql.useMutation<Upup_SetRentalDoNotRenewMutation, Upup_SetRentalDoNotRenewMutationVariables>(Upup_SetRentalDoNotRenewDocument);
};
export const RentalForRenewalDocument = gql`
    query RentalForRenewal($id: uuid!) {
  rentals_by_pk(id: $id) {
    ...WithRentalAgreementInfo
    ...WithAddressInfo
    ...Tenants
    ...WithLlcInfo
    ...AddOns
    lease_variant
    rental_program_type
    portfolio_home {
      home {
        market {
          name
        }
      }
    }
    payments(where: {_not: {category: {_eq: "initial_payment"}}}) {
      id
      amount
      status
      liability_type {
        id
        payment_category
      }
    }
    rental_credits {
      id
      amount
      liability_type {
        id
        payment_category
      }
    }
  }
}
    ${WithRentalAgreementInfoFragmentDoc}
${WithAddressInfoFragmentDoc}
${TenantsFragmentDoc}
${WithLlcInfoFragmentDoc}
${AddOnsFragmentDoc}`;

export function useRentalForRenewalQuery(options: Omit<Urql.UseQueryArgs<RentalForRenewalQueryVariables>, 'query'>) {
  return Urql.useQuery<RentalForRenewalQuery, RentalForRenewalQueryVariables>({ query: RentalForRenewalDocument, ...options });
};
export const RentRollDocumentsDataDocument = gql`
    query RentRollDocumentsData($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    status
    rental_users(where: {role: {_eq: "primary"}}, limit: 1) {
      id
      role
      user {
        id
        first_name
        last_name
      }
    }
    agreements(where: {status: {_eq: "complete"}}, order_by: {created_at: desc}) {
      id
      documents {
        ...RentRollDocumentsPanelDocument
      }
    }
    rental_application {
      id
      document_agreements: agreements(
        where: {status: {_eq: "complete"}}
        order_by: {created_at: desc}
      ) {
        id
        documents {
          ...RentRollDocumentsPanelDocument
        }
      }
    }
    documents {
      ...RentRollDocumentsPanelDocument
    }
  }
}
    ${RentRollDocumentsPanelDocumentFragmentDoc}`;

export function useRentRollDocumentsDataQuery(options: Omit<Urql.UseQueryArgs<RentRollDocumentsDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollDocumentsDataQuery, RentRollDocumentsDataQueryVariables>({ query: RentRollDocumentsDataDocument, ...options });
};
export const Upup_CreateUtilityResponsibilityDocument = gql`
    mutation Upup_CreateUtilityResponsibility($rentalId: uuid, $adminId: uuid, $portfolioHomeUtilityId: uuid, $responsibleParty: String, $startDate: date) {
  insert_utility_responsibilities_one(
    object: {rental_id: $rentalId, portfolio_home_utility_id: $portfolioHomeUtilityId, created_by_admin_id: $adminId, responsible_party: $responsibleParty, start_date: $startDate}
  ) {
    id
    created_at
    updated_at
    rental_id
    portfolio_home_utility_id
    responsible_party
    start_date
    created_by_admin_id
  }
}
    `;

export function useUpup_CreateUtilityResponsibilityMutation() {
  return Urql.useMutation<Upup_CreateUtilityResponsibilityMutation, Upup_CreateUtilityResponsibilityMutationVariables>(Upup_CreateUtilityResponsibilityDocument);
};
export const RentRollLedgerDataDocument = gql`
    query RentRollLedgerData($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    status
    buildium_lease_id
    occupancy_date
    final_liability_date
    portfolio_home {
      id
      home {
        id
        address {
          id
          state
          display_line_1
          display_line_2
        }
      }
    }
    property {
      ...RentRollRentalProperty
    }
    rental_users {
      id
      user_id
      role
      deactivated_at
      user {
        ...RentRollTenant
      }
    }
    payments(where: {_not: {category: {_eq: "initial_payment"}}}) {
      ...RentRollPayment
      user {
        id
        first_name
        last_name
      }
    }
    rental_liabilities {
      ...RentRollRentalLiabilities
      resource_type
    }
    scheduled_rental_liabilities(order_by: [{due_date: asc}, {created_at: asc}]) {
      id
      amount
      due_date
      note
      source
      status
      renewal_id
      created_at
      canceled_at
      posted_at
      last_error
      liability_type {
        id
        name
      }
    }
    rental_credits {
      id
      buildium_id
      payment_plan_offset_credits(limit: 1) {
        id
      }
      liability_type {
        ...RentRollLiabilityType
      }
      amount
      date
      note
      type
    }
    option_premium_transfers_received {
      id
      amount
      from_rental_id
      date
    }
    cashout {
      id
      paid_out_amount
      cashed_out_at
      adjustments_finalized_at
      cashout_adjustments(order_by: {type: desc}) {
        id
        liability_type_id
        liability_type {
          ...RentRollLiabilityType
        }
        type
        amount
        date
      }
    }
  }
}
    ${RentRollRentalPropertyFragmentDoc}
${RentRollTenantFragmentDoc}
${RentRollPaymentFragmentDoc}
${RentRollRentalLiabilitiesFragmentDoc}
${RentRollLiabilityTypeFragmentDoc}`;

export function useRentRollLedgerDataQuery(options: Omit<Urql.UseQueryArgs<RentRollLedgerDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollLedgerDataQuery, RentRollLedgerDataQueryVariables>({ query: RentRollLedgerDataDocument, ...options });
};
export const CreateMoveInFeeDocument = gql`
    mutation CreateMoveInFee($rentalId: uuid!, $liabilityTypeId: uuid!, $amount: numeric!) {
  insert_rental_move_in_fees_one(
    object: {rental_id: $rentalId, liability_type_id: $liabilityTypeId, amount: $amount}
  ) {
    id
    rental_id
    liability_type_id
    amount
  }
}
    `;

export function useCreateMoveInFeeMutation() {
  return Urql.useMutation<CreateMoveInFeeMutation, CreateMoveInFeeMutationVariables>(CreateMoveInFeeDocument);
};
export const UpdateMoveInFeeAmountDocument = gql`
    mutation UpdateMoveInFeeAmount($id: uuid!, $amount: numeric!) {
  update_rental_move_in_fees_by_pk(pk_columns: {id: $id}, _set: {amount: $amount}) {
    id
    amount
  }
}
    `;

export function useUpdateMoveInFeeAmountMutation() {
  return Urql.useMutation<UpdateMoveInFeeAmountMutation, UpdateMoveInFeeAmountMutationVariables>(UpdateMoveInFeeAmountDocument);
};
export const DeactivateMoveInFeeDocument = gql`
    mutation DeactivateMoveInFee($id: uuid!, $deactivated_at: timestamptz) {
  update_rental_move_in_fees_by_pk(
    pk_columns: {id: $id}
    _set: {deactivated_at: $deactivated_at}
  ) {
    id
    deactivated_at
  }
}
    `;

export function useDeactivateMoveInFeeMutation() {
  return Urql.useMutation<DeactivateMoveInFeeMutation, DeactivateMoveInFeeMutationVariables>(DeactivateMoveInFeeDocument);
};
export const RentRollMoveInFeesDataDocument = gql`
    query RentRollMoveInFeesData($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    occupancy_date
    status
    rental_move_in_fees(where: {deactivated_at: {_is_null: true}}) {
      ...RentRollRentalMoveInFees
    }
  }
}
    ${RentRollRentalMoveInFeesFragmentDoc}`;

export function useRentRollMoveInFeesDataQuery(options: Omit<Urql.UseQueryArgs<RentRollMoveInFeesDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollMoveInFeesDataQuery, RentRollMoveInFeesDataQueryVariables>({ query: RentRollMoveInFeesDataDocument, ...options });
};
export const UtilityBillsForPropertyDocument = gql`
    query UtilityBillsForProperty($portfolioHomeId: uuid!) {
  utility_bills(
    where: {portfolio_home_id: {_eq: $portfolioHomeId}}
    order_by: {service_end_date: desc}
  ) {
    id
    amount
    buildium_id
    buildium_bank_account_id
    service_start_date
    service_end_date
    bill_date
    bill_due_date
    vendor
    charge_type
    status
    utility_type {
      id
      name
      liability_type_id
    }
    utility_chargebacks {
      id
      rental_id
      status
      finalized_at
      finalized_amount
      rental_liability_id
    }
  }
}
    `;

export function useUtilityBillsForPropertyQuery(options: Omit<Urql.UseQueryArgs<UtilityBillsForPropertyQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilityBillsForPropertyQuery, UtilityBillsForPropertyQueryVariables>({ query: UtilityBillsForPropertyDocument, ...options });
};
export const RentRollRecurringCreditsDataDocument = gql`
    query RentRollRecurringCreditsData($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    recurring_credits {
      id
      start_date
      num_months
      total_amount
      notes
      liability_type {
        id
        name
      }
    }
  }
}
    `;

export function useRentRollRecurringCreditsDataQuery(options: Omit<Urql.UseQueryArgs<RentRollRecurringCreditsDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollRecurringCreditsDataQuery, RentRollRecurringCreditsDataQueryVariables>({ query: RentRollRecurringCreditsDataDocument, ...options });
};
export const UpdateTargetMonthlyOptionPremiumDocument = gql`
    mutation UpdateTargetMonthlyOptionPremium($id: uuid!, $target_monthly_option_premium: Int!) {
  update_rentals_by_pk(
    pk_columns: {id: $id}
    _set: {target_monthly_option_premium: $target_monthly_option_premium}
  ) {
    id
    target_monthly_option_premium
  }
}
    `;

export function useUpdateTargetMonthlyOptionPremiumMutation() {
  return Urql.useMutation<UpdateTargetMonthlyOptionPremiumMutation, UpdateTargetMonthlyOptionPremiumMutationVariables>(UpdateTargetMonthlyOptionPremiumDocument);
};
export const RentRollUtilityResponsibilitiesDataDocument = gql`
    query RentRollUtilityResponsibilitiesData($rentalId: uuid!) {
  rentals_by_pk(id: $rentalId) {
    id
    has_signed_utility_addendum
    portfolio_home {
      id
      portfolio_home_utilities {
        id
        deactivated_at
        default_responsible_party
        utility_type {
          id
          name
        }
      }
    }
    current_utility_responsibilities(
      order_by: {portfolio_home_utility: {utility_type: {name: asc}}}
    ) {
      id
      created_at
      responsible_party
      start_date
      created_by_admin_id
      admin {
        id
        first_name
        last_name
      }
      portfolio_home_utility {
        id
        default_responsible_party
        deactivated_at
        utility_type {
          id
          name
          liability_type_id
          liability_type {
            name
          }
        }
      }
    }
  }
}
    `;

export function useRentRollUtilityResponsibilitiesDataQuery(options: Omit<Urql.UseQueryArgs<RentRollUtilityResponsibilitiesDataQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollUtilityResponsibilitiesDataQuery, RentRollUtilityResponsibilitiesDataQueryVariables>({ query: RentRollUtilityResponsibilitiesDataDocument, ...options });
};
export const RentRollDocument = gql`
    query RentRoll {
  rent_roll {
    id
    status
    display_line_1
    display_line_2
    city
    state
    zip
    aggregate_balance_after
    aggregate_successful_balance_after
    ends_at
    starts_at
    renewal_months
    occupancy_date
    move_out_date
    final_liability_date
    lease_end_reason
    rent
    occupancy_status
    option_premium
    target_monthly_option_premium
    chargeback_deadline
    cashout_deadline
    rental {
      id
      rental_program_type
      lease_variant
      rental_users(
        where: {role: {_eq: "primary"}, deactivated_at: {_is_null: true}}
        limit: 1
      ) {
        id
        user {
          id
          first_name
          last_name
        }
      }
      evictions(where: {status: {_nin: ["canceled", "completed"]}}) {
        id
        status
        filed_at
      }
      cashout {
        id
        status
        maintenance_chargebacks_finalized_at
        final_wallet_amount
      }
      statements(order_by: {date: desc}, limit: 1) {
        id
        ending_balance
      }
      portfolio_home {
        id
        most_recent_llc_property {
          id
          llc {
            id
            name
            fund_llcs(where: {end_date: {_is_null: true}}) {
              id
              fund {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useRentRollQuery(options?: Omit<Urql.UseQueryArgs<RentRollQueryVariables>, 'query'>) {
  return Urql.useQuery<RentRollQuery, RentRollQueryVariables>({ query: RentRollDocument, ...options });
};
export const UserListDocument = gql`
    query UserList($where: users_bool_exp = {}) {
  users(limit: 10, where: $where) {
    id
    first_name
    last_name
    user_contact_details(where: {is_primary_for_contact_type: {_eq: true}}) {
      id
      contact_type
      contact_info
    }
  }
}
    `;

export function useUserListQuery(options?: Omit<Urql.UseQueryArgs<UserListQueryVariables>, 'query'>) {
  return Urql.useQuery<UserListQuery, UserListQueryVariables>({ query: UserListDocument, ...options });
};